/* tslint:disable */
/* eslint-disable */
/**
 * rest-express-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AIReportPayload
 */
export interface AIReportPayload {
    /**
     * 
     * @type {string}
     * @memberof AIReportPayload
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof AIReportPayload
     */
    'billNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AIReportPayload
     */
    'version': string;
    /**
     * 
     * @type {AIReportPayloadCompanyInfo}
     * @memberof AIReportPayload
     */
    'companyInfo'?: AIReportPayloadCompanyInfo;
    /**
     * 
     * @type {Array<string>}
     * @memberof AIReportPayload
     */
    'selectedSections': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AIReportPayload
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof AIReportPayload
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AIReportPayload
     */
    'selectedSession': string;
    /**
     * 
     * @type {number}
     * @memberof AIReportPayload
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AIReportPayload
     */
    'targetFolderId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AIReportPayload
     */
    'folderPath'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AIReportPayload
     */
    'masterBillId'?: string;
}
/**
 * 
 * @export
 * @interface AIReportPayloadCompanyInfo
 */
export interface AIReportPayloadCompanyInfo {
    /**
     * 
     * @type {string}
     * @memberof AIReportPayloadCompanyInfo
     */
    'FullSum'?: string;
    /**
     * 
     * @type {string}
     * @memberof AIReportPayloadCompanyInfo
     */
    'CompanyName'?: string;
}
/**
 * 
 * @export
 * @interface AIReportResponse
 */
export interface AIReportResponse {
    /**
     * 
     * @type {string}
     * @memberof AIReportResponse
     */
    'analysis': string;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: string; }}
     * @memberof AIReportResponse
     */
    'report'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof AIReportResponse
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof AIReportResponse
     */
    'fileUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AIReportResponse
     */
    'fileId'?: number | null;
}
/**
 * 
 * @export
 * @interface AIResponse
 */
export interface AIResponse {
    /**
     * 
     * @type {string}
     * @memberof AIResponse
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface AcceptInviteRequest
 */
export interface AcceptInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptInviteRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface AccountCompanyClaimUserDto
 */
export interface AccountCompanyClaimUserDto {
    /**
     * 
     * @type {number}
     * @memberof AccountCompanyClaimUserDto
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof AccountCompanyClaimUserDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof AccountCompanyClaimUserDto
     */
    'userEmail': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountCompanyClaimUserDto
     */
    'states': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AccountCompanyClaimUserDto
     */
    'isCurrentUser': boolean;
}
/**
 * 
 * @export
 * @interface AccountCompanySummaryDto
 */
export interface AccountCompanySummaryDto {
    /**
     * 
     * @type {number}
     * @memberof AccountCompanySummaryDto
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof AccountCompanySummaryDto
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof AccountCompanySummaryDto
     */
    'stateCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCompanySummaryDto
     */
    'accountFullSum': string;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: StateSpecificSummaryEntry; }}
     * @memberof AccountCompanySummaryDto
     */
    'stateSpecificSummaries'?: { [key: string]: StateSpecificSummaryEntry; };
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountCompanySummaryDto
     */
    'keywords'?: Array<string>;
    /**
     * 
     * @type {Array<KeywordWithUser>}
     * @memberof AccountCompanySummaryDto
     */
    'keywordsWithUsers'?: Array<KeywordWithUser>;
    /**
     * 
     * @type {number}
     * @memberof AccountCompanySummaryDto
     */
    'canonicalCompanyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountCompanySummaryDto
     */
    'clusterId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AccountCompanySummaryDto
     */
    'clusterName'?: string | null;
}
/**
 * 
 * @export
 * @interface AccountDto
 */
export interface AccountDto {
    /**
     * 
     * @type {number}
     * @memberof AccountDto
     */
    'accountId': number;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDto
     */
    'isAnalyst': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDto
     */
    'isLobbyist': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDto
     */
    'lobbyistPortal': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDto
     */
    'analystPortal': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDto
     */
    'clientCrm': boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    'AIStrength': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDto
     */
    'regulatory': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDto
     */
    'autoTrackEnabled': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDto
     */
    'committeeAgentEnabled': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    'companyLogo': string | null;
}
/**
 * 
 * @export
 * @interface AccountPortalResponse
 */
export interface AccountPortalResponse {
    /**
     * 
     * @type {number}
     * @memberof AccountPortalResponse
     */
    'portalId': number;
    /**
     * 
     * @type {number}
     * @memberof AccountPortalResponse
     */
    'accountId': number;
    /**
     * 
     * @type {string}
     * @memberof AccountPortalResponse
     */
    'accountName': string;
    /**
     * 
     * @type {string}
     * @memberof AccountPortalResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AccountPortalResponse
     */
    'subdomain': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountPortalResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {PortalSettings}
     * @memberof AccountPortalResponse
     */
    'portalSettings': PortalSettings | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountPortalResponse
     */
    'hasPassword': boolean;
    /**
     * 
     * @type {Array<PortalPageResponse>}
     * @memberof AccountPortalResponse
     */
    'pages': Array<PortalPageResponse>;
    /**
     * 
     * @type {string}
     * @memberof AccountPortalResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AccountPortalResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface AccountSharedTags
 */
export interface AccountSharedTags {
    /**
     * 
     * @type {AccountSharedTagsAccount}
     * @memberof AccountSharedTags
     */
    'account': AccountSharedTagsAccount;
    /**
     * 
     * @type {Array<TagInfo>}
     * @memberof AccountSharedTags
     */
    'tags': Array<TagInfo>;
}
/**
 * 
 * @export
 * @interface AccountSharedTagsAccount
 */
export interface AccountSharedTagsAccount {
    /**
     * 
     * @type {string}
     * @memberof AccountSharedTagsAccount
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AccountSharedTagsAccount
     */
    'accountId': number;
}
/**
 * 
 * @export
 * @interface AccountTrackedBillsBulkBody
 */
export interface AccountTrackedBillsBulkBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountTrackedBillsBulkBody
     */
    'billIds': Array<string>;
}
/**
 * 
 * @export
 * @interface ActivityMetricsResponse
 */
export interface ActivityMetricsResponse {
    /**
     * 
     * @type {number}
     * @memberof ActivityMetricsResponse
     */
    'dau': number;
    /**
     * 
     * @type {number}
     * @memberof ActivityMetricsResponse
     */
    'mau': number;
    /**
     * 
     * @type {Array<UserActivitySummary>}
     * @memberof ActivityMetricsResponse
     */
    'activeUsersToday': Array<UserActivitySummary>;
    /**
     * 
     * @type {Array<UserActivitySummary>}
     * @memberof ActivityMetricsResponse
     */
    'activeUsersThisMonth': Array<UserActivitySummary>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ActivityType = {
    All: 'all',
    Progress: 'progress',
    Text: 'text',
    Votes: 'votes'
} as const;

export type ActivityType = typeof ActivityType[keyof typeof ActivityType];


/**
 * 
 * @export
 * @interface AddAnalyst200Response
 */
export interface AddAnalyst200Response {
    /**
     * 
     * @type {string}
     * @memberof AddAnalyst200Response
     */
    'FullAccountRole': string;
    /**
     * 
     * @type {string}
     * @memberof AddAnalyst200Response
     */
    'AnalystRole': string;
    /**
     * 
     * @type {boolean}
     * @memberof AddAnalyst200Response
     */
    'FullAccount': boolean;
    /**
     * 
     * @type {number}
     * @memberof AddAnalyst200Response
     */
    'RelationshipId': number;
    /**
     * 
     * @type {boolean}
     * @memberof AddAnalyst200Response
     */
    'IsAnalyst': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddAnalyst200Response
     */
    'IsLobbyist': boolean;
    /**
     * 
     * @type {number}
     * @memberof AddAnalyst200Response
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof AddAnalyst200Response
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof AddAnalyst200Response
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof AddAnalyst200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof AddAnalyst200Response
     */
    'UserId': number;
}
/**
 * 
 * @export
 * @interface AddAnalystRequest
 */
export interface AddAnalystRequest {
    /**
     * 
     * @type {number}
     * @memberof AddAnalystRequest
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface AddBillWithSession200Response
 */
export interface AddBillWithSession200Response {
    /**
     * 
     * @type {string}
     * @memberof AddBillWithSession200Response
     */
    'billId': string;
    /**
     * 
     * @type {boolean}
     * @memberof AddBillWithSession200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface AddBillWithSessionBody
 */
export interface AddBillWithSessionBody {
    /**
     * 
     * @type {string}
     * @memberof AddBillWithSessionBody
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AddBillWithSessionBody
     */
    'session': string;
    /**
     * 
     * @type {string}
     * @memberof AddBillWithSessionBody
     */
    'billType': string;
    /**
     * 
     * @type {string}
     * @memberof AddBillWithSessionBody
     */
    'billNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddBillWithSessionBody
     */
    'lobbyistIds': string;
    /**
     * 
     * @type {string}
     * @memberof AddBillWithSessionBody
     */
    'accountId'?: string;
}
/**
 * 
 * @export
 * @interface AddPortalComment200Response
 */
export interface AddPortalComment200Response {
    /**
     * 
     * @type {Array<PortalViewerComment>}
     * @memberof AddPortalComment200Response
     */
    'comments': Array<PortalViewerComment>;
}
/**
 * 
 * @export
 * @interface AddPortalRelationship200Response
 */
export interface AddPortalRelationship200Response {
    /**
     * 
     * @type {Array<PortalViewerRelationship>}
     * @memberof AddPortalRelationship200Response
     */
    'relationships': Array<PortalViewerRelationship>;
}
/**
 * 
 * @export
 * @interface AddTeamMemberRequest
 */
export interface AddTeamMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof AddTeamMemberRequest
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface AdvancedSearchRequest
 */
export interface AdvancedSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'session'?: string;
    /**
     * Array of session codes for multi-session search
     * @type {Array<string>}
     * @memberof AdvancedSearchRequest
     */
    'sessions'?: Array<string>;
    /**
     * Comma separated bill types
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'types'?: string;
    /**
     * Whether to show tags column in the report
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'showTagsColumn'?: boolean;
    /**
     * Whether to render AI summary as markdown
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'renderAiSummaryMarkdown'?: boolean;
    /**
     * Date range preset (e.g., \'custom\', \'last30days\', etc.)
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'dateRangePreset'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'dateRangeType'?: AdvancedSearchRequestDateRangeTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdvancedSearchRequest
     */
    'actionCodes'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdvancedSearchRequest
     */
    'progressCodes'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'progressMatchType'?: AdvancedSearchRequestProgressMatchTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdvancedSearchRequest
     */
    'selectedTags'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'wordSearch'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'vectorSearch'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdvancedSearchRequest
     */
    'vectorMatchThreshold'?: number;
    /**
     * 
     * @type {AdvancedSearchRequestStatutoryCodes}
     * @memberof AdvancedSearchRequest
     */
    'statutoryCodes'?: AdvancedSearchRequestStatutoryCodes;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdvancedSearchRequest
     */
    'selectedAuthors'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdvancedSearchRequest
     */
    'selectedParties'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdvancedSearchRequest
     */
    'trackTypes'?: Array<AdvancedSearchRequestTrackTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'excludeLobbyistUsers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'hasVote'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'actionsToReturn'?: AdvancedSearchRequestActionsToReturnEnum;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'linkType'?: AdvancedSearchRequestLinkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'emailRecipients'?: string;
    /**
     * Master bill identifier used for fetching bill data
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'masterBillId'?: string;
    /**
     * Specific bill version identifier
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'billVersionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'saveToFile'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'reportName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'includeAiSummary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'remarksScope'?: AdvancedSearchRequestRemarksScopeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'aiSearchOnly'?: boolean;
    /**
     * Optional position filters based on tag names (e.g., Support, Oppose)
     * @type {Array<string>}
     * @memberof AdvancedSearchRequest
     */
    'positions'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'emphasizeRecent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'emphasizeWindow'?: AdvancedSearchRequestEmphasizeWindowEnum;
    /**
     * 
     * @type {AdvancedSearchSortOption}
     * @memberof AdvancedSearchRequest
     */
    'sortBy'?: AdvancedSearchSortOption;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'showProgressSteps'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'trackedOnly'?: boolean;
    /**
     * Optional priority filters (low, medium, high) - only applies to tagged bills
     * @type {Array<string>}
     * @memberof AdvancedSearchRequest
     */
    'priorities'?: Array<string>;
    /**
     * Optional impact filters (low, medium, high) - only applies to tagged bills
     * @type {Array<string>}
     * @memberof AdvancedSearchRequest
     */
    'impacts'?: Array<string>;
    /**
     * Optional CRM company identifier for report association
     * @type {number}
     * @memberof AdvancedSearchRequest
     */
    'companyId'?: number;
    /**
     * Optional CRM company name for display
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'companyName'?: string;
    /**
     * Include upcoming BillCalendar events when available
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'includeFutureBillCalendarEvents'?: boolean;
    /**
     * View mode for report generation: \'standard\' or \'tabulated\'
     * @type {string}
     * @memberof AdvancedSearchRequest
     */
    'viewMode'?: AdvancedSearchRequestViewModeEnum;
    /**
     * Optional list of masterBillIds to exclude from the report
     * @type {Array<string>}
     * @memberof AdvancedSearchRequest
     */
    'excludeMasterBillIds'?: Array<string>;
    /**
     * Whether to include the account logo at the top of the report
     * @type {boolean}
     * @memberof AdvancedSearchRequest
     */
    'includeAccountLogo'?: boolean;
}

export const AdvancedSearchRequestDateRangeTypeEnum = {
    Actions: 'actions',
    Filed: 'filed',
    Language: 'language'
} as const;

export type AdvancedSearchRequestDateRangeTypeEnum = typeof AdvancedSearchRequestDateRangeTypeEnum[keyof typeof AdvancedSearchRequestDateRangeTypeEnum];
export const AdvancedSearchRequestProgressMatchTypeEnum = {
    Has: 'has',
    Latest: 'latest'
} as const;

export type AdvancedSearchRequestProgressMatchTypeEnum = typeof AdvancedSearchRequestProgressMatchTypeEnum[keyof typeof AdvancedSearchRequestProgressMatchTypeEnum];
export const AdvancedSearchRequestTrackTypesEnum = {
    Manual: 'manual',
    AutoSorted: 'auto_sorted',
    AutoUnsorted: 'auto_unsorted'
} as const;

export type AdvancedSearchRequestTrackTypesEnum = typeof AdvancedSearchRequestTrackTypesEnum[keyof typeof AdvancedSearchRequestTrackTypesEnum];
export const AdvancedSearchRequestActionsToReturnEnum = {
    Last: 'last',
    Last3: 'last3',
    All: 'all',
    None: 'none'
} as const;

export type AdvancedSearchRequestActionsToReturnEnum = typeof AdvancedSearchRequestActionsToReturnEnum[keyof typeof AdvancedSearchRequestActionsToReturnEnum];
export const AdvancedSearchRequestLinkTypeEnum = {
    Internal: 'internal',
    External: 'external'
} as const;

export type AdvancedSearchRequestLinkTypeEnum = typeof AdvancedSearchRequestLinkTypeEnum[keyof typeof AdvancedSearchRequestLinkTypeEnum];
export const AdvancedSearchRequestRemarksScopeEnum = {
    AccountGeneral: 'accountGeneral',
    UserGeneral: 'userGeneral',
    AccountTag: 'accountTag',
    UserTag: 'userTag',
    All: 'all'
} as const;

export type AdvancedSearchRequestRemarksScopeEnum = typeof AdvancedSearchRequestRemarksScopeEnum[keyof typeof AdvancedSearchRequestRemarksScopeEnum];
export const AdvancedSearchRequestEmphasizeWindowEnum = {
    _1w: '1w',
    _2w: '2w',
    _3w: '3w',
    _1m: '1m'
} as const;

export type AdvancedSearchRequestEmphasizeWindowEnum = typeof AdvancedSearchRequestEmphasizeWindowEnum[keyof typeof AdvancedSearchRequestEmphasizeWindowEnum];
export const AdvancedSearchRequestViewModeEnum = {
    Standard: 'standard',
    Tabulated: 'tabulated'
} as const;

export type AdvancedSearchRequestViewModeEnum = typeof AdvancedSearchRequestViewModeEnum[keyof typeof AdvancedSearchRequestViewModeEnum];

/**
 * 
 * @export
 * @interface AdvancedSearchRequestStatutoryCodes
 */
export interface AdvancedSearchRequestStatutoryCodes {
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequestStatutoryCodes
     */
    'chapter': string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchRequestStatutoryCodes
     */
    'code': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AdvancedSearchSortOption = {
    Default: 'default',
    LastActionDate: 'lastActionDate',
    FiledDate: 'filedDate',
    Author: 'author',
    Party: 'party',
    Tagged: 'tagged'
} as const;

export type AdvancedSearchSortOption = typeof AdvancedSearchSortOption[keyof typeof AdvancedSearchSortOption];


/**
 * 
 * @export
 * @interface AdvocateTestimonyResponse
 */
export interface AdvocateTestimonyResponse {
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'TestimonyId': number;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'WitnessId': number;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'CommitteeId': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponse
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponse
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponse
     */
    'MasterBillId': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponse
     */
    'Position': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'BillSupportingDocumentsId': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponse
     */
    'TestimonyDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'LobbyistID': number | null;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'CompanyID': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponse
     */
    'Organization': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'HearingId': number | null;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'VideoId': number | null;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'StartTime': number | null;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponse
     */
    'EndTime': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponse
     */
    'CreatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponse
     */
    'UpdatedAt': string | null;
    /**
     * 
     * @type {AdvocateTestimonyResponseCompany}
     * @memberof AdvocateTestimonyResponse
     */
    'Company': AdvocateTestimonyResponseCompany | null;
    /**
     * 
     * @type {AdvocateTestimonyResponseCommitteeSession}
     * @memberof AdvocateTestimonyResponse
     */
    'CommitteeSession': AdvocateTestimonyResponseCommitteeSession | null;
    /**
     * 
     * @type {AdvocateTestimonyResponseMasterBill}
     * @memberof AdvocateTestimonyResponse
     */
    'MasterBill': AdvocateTestimonyResponseMasterBill | null;
    /**
     * 
     * @type {AdvocateTestimonyResponseUser}
     * @memberof AdvocateTestimonyResponse
     */
    'User': AdvocateTestimonyResponseUser | null;
    /**
     * 
     * @type {AdvocateTestimonyResponseWitness}
     * @memberof AdvocateTestimonyResponse
     */
    'Witness': AdvocateTestimonyResponseWitness | null;
    /**
     * 
     * @type {VideoInfo}
     * @memberof AdvocateTestimonyResponse
     */
    'Video': VideoInfo | null;
    /**
     * 
     * @type {AdvocateTestimonyResponseTranscript}
     * @memberof AdvocateTestimonyResponse
     */
    'Transcript': AdvocateTestimonyResponseTranscript | null;
}
/**
 * 
 * @export
 * @interface AdvocateTestimonyResponseCommitteeSession
 */
export interface AdvocateTestimonyResponseCommitteeSession {
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseCommitteeSession
     */
    'CommitteeName': string | null;
}
/**
 * 
 * @export
 * @interface AdvocateTestimonyResponseCompany
 */
export interface AdvocateTestimonyResponseCompany {
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseCompany
     */
    'CompanyName': string | null;
}
/**
 * 
 * @export
 * @interface AdvocateTestimonyResponseMasterBill
 */
export interface AdvocateTestimonyResponseMasterBill {
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponseMasterBill
     */
    'Status': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseMasterBill
     */
    'LegiscanUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseMasterBill
     */
    'Number': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseMasterBill
     */
    'Type': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseMasterBill
     */
    'StateCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseMasterBill
     */
    'Title': string | null;
}
/**
 * 
 * @export
 * @interface AdvocateTestimonyResponseTranscript
 */
export interface AdvocateTestimonyResponseTranscript {
    /**
     * 
     * @type {Array<LobbySpeakerTranscriptInner>}
     * @memberof AdvocateTestimonyResponseTranscript
     */
    'speakerTranscript': Array<LobbySpeakerTranscriptInner>;
    /**
     * 
     * @type {Array<Array<LobbyWordTranscriptInnerInner>>}
     * @memberof AdvocateTestimonyResponseTranscript
     */
    'wordTranscript': Array<Array<LobbyWordTranscriptInnerInner>>;
}
/**
 * 
 * @export
 * @interface AdvocateTestimonyResponseUser
 */
export interface AdvocateTestimonyResponseUser {
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseUser
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseUser
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseUser
     */
    'FirstName': string;
    /**
     * 
     * @type {number}
     * @memberof AdvocateTestimonyResponseUser
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface AdvocateTestimonyResponseWitness
 */
export interface AdvocateTestimonyResponseWitness {
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseWitness
     */
    'StateCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseWitness
     */
    'LastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvocateTestimonyResponseWitness
     */
    'FirstName': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AlertMethod = {
    Email: 'email',
    Phone: 'phone',
    Web: 'web',
    None: 'none'
} as const;

export type AlertMethod = typeof AlertMethod[keyof typeof AlertMethod];


/**
 * 
 * @export
 * @interface AnalystCandidate
 */
export interface AnalystCandidate {
    /**
     * 
     * @type {number}
     * @memberof AnalystCandidate
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof AnalystCandidate
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalystCandidate
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalystCandidate
     */
    'email': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnalystCandidate
     */
    'isAnalyst': boolean;
}
/**
 * 
 * @export
 * @interface AssignWitnessLobbyistRequest
 */
export interface AssignWitnessLobbyistRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignWitnessLobbyistRequest
     */
    'lobbyistId': number;
}
/**
 * 
 * @export
 * @interface AssignWitnessLobbyistResponse
 */
export interface AssignWitnessLobbyistResponse {
    /**
     * 
     * @type {number}
     * @memberof AssignWitnessLobbyistResponse
     */
    'witnessId': number;
    /**
     * 
     * @type {number}
     * @memberof AssignWitnessLobbyistResponse
     */
    'lobbyistId': number;
    /**
     * 
     * @type {number}
     * @memberof AssignWitnessLobbyistResponse
     */
    'updatedTestimonyCount': number;
}
/**
 * 
 * @export
 * @interface AuthorResponse
 */
export interface AuthorResponse {
    /**
     * 
     * @type {number}
     * @memberof AuthorResponse
     */
    'MemberId': number;
    /**
     * 
     * @type {string}
     * @memberof AuthorResponse
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorResponse
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorResponse
     */
    'Name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorResponse
     */
    'District': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorResponse
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorResponse
     */
    'Party': string;
}
/**
 * 
 * @export
 * @interface AutoTrackCompanyDto
 */
export interface AutoTrackCompanyDto {
    /**
     * 
     * @type {number}
     * @memberof AutoTrackCompanyDto
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackCompanyDto
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackCompanyDto
     */
    'stateCode'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AutoTrackCompanyDto
     */
    'keywords': Array<string>;
}
/**
 * 
 * @export
 * @interface AutoTrackMatchDto
 */
export interface AutoTrackMatchDto {
    /**
     * 
     * @type {number}
     * @memberof AutoTrackMatchDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'outcome': string;
    /**
     * 
     * @type {number}
     * @memberof AutoTrackMatchDto
     */
    'score': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AutoTrackMatchDto
     */
    'methods': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AutoTrackMatchDto
     */
    'sources': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'reasoning': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'aiAnalysis': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackMatchDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof AutoTrackMatchDto
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface AutoTrackStateDto
 */
export interface AutoTrackStateDto {
    /**
     * 
     * @type {string}
     * @memberof AutoTrackStateDto
     */
    'stateCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof AutoTrackStateDto
     */
    'isEnabled': boolean;
}
/**
 * 
 * @export
 * @interface AutoTrackStatusDto
 */
export interface AutoTrackStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof AutoTrackStatusDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AutoTrackStatusDto
     */
    'hasAutoTrack': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AutoTrackStatusDto
     */
    'committeeAgentEnabled': boolean;
}
/**
 * 
 * @export
 * @interface AutoTrackedBillDto
 */
export interface AutoTrackedBillDto {
    /**
     * 
     * @type {number}
     * @memberof AutoTrackedBillDto
     */
    'billTagId': number;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'authorName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'authorParty': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'filedDate': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AutoTrackedBillDto
     */
    'tags': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'lastAction': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'impact': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'priority': string | null;
    /**
     * 
     * @type {number}
     * @memberof AutoTrackedBillDto
     */
    'relevancy': number | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'aiSummary': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'aiAnalysis': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'reasoning': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'aiReportUrl': string | null;
    /**
     * 
     * @type {any}
     * @memberof AutoTrackedBillDto
     */
    'aiReportData': any | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoTrackedBillDto
     */
    'fileUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AutoTrackedBillDto
     */
    'fileId'?: number | null;
}
/**
 * 
 * @export
 * @interface BillActionGroupDto
 */
export interface BillActionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof BillActionGroupDto
     */
    'bill': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillActionGroupDto
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillActionGroupDto
     */
    'author': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillActionGroupDto
     */
    'masterBillId': string | null;
    /**
     * 
     * @type {Array<LiveActionDto>}
     * @memberof BillActionGroupDto
     */
    'actions': Array<LiveActionDto>;
}
/**
 * 
 * @export
 * @interface BillAgentStatsResponse
 */
export interface BillAgentStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponse
     */
    'urgentBills': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponse
     */
    'highImpactBills': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponse
     */
    'highPriorityBills': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponse
     */
    'autoTrackedToday': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponse
     */
    'aiReportsGenerated': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponse
     */
    'aiReportsToday': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponse
     */
    'totalTrackedBills': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponse
     */
    'totalMatches': number;
    /**
     * 
     * @type {BillAgentStatsResponseOutcomeBreakdown}
     * @memberof BillAgentStatsResponse
     */
    'outcomeBreakdown': BillAgentStatsResponseOutcomeBreakdown;
    /**
     * 
     * @type {CommitteeAgentStatsResponsePriorityBreakdown}
     * @memberof BillAgentStatsResponse
     */
    'priorityBreakdown': CommitteeAgentStatsResponsePriorityBreakdown;
    /**
     * 
     * @type {CommitteeAgentStatsResponsePriorityBreakdown}
     * @memberof BillAgentStatsResponse
     */
    'impactBreakdown': CommitteeAgentStatsResponsePriorityBreakdown;
}
/**
 * 
 * @export
 * @interface BillAgentStatsResponseOutcomeBreakdown
 */
export interface BillAgentStatsResponseOutcomeBreakdown {
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponseOutcomeBreakdown
     */
    'neutral': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponseOutcomeBreakdown
     */
    'monitor': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponseOutcomeBreakdown
     */
    'oppose': number;
    /**
     * 
     * @type {number}
     * @memberof BillAgentStatsResponseOutcomeBreakdown
     */
    'support': number;
}
/**
 * 
 * @export
 * @interface BillAlertDto
 */
export interface BillAlertDto {
    /**
     * 
     * @type {number}
     * @memberof BillAlertDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BillAlertDto
     */
    'billId': string;
    /**
     * 
     * @type {number}
     * @memberof BillAlertDto
     */
    'userContactId': number;
    /**
     * 
     * @type {boolean}
     * @memberof BillAlertDto
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillAlertDto
     */
    'phone': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillAlertDto
     */
    'web': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillAlertDto
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface BillAlertsBulkBody
 */
export interface BillAlertsBulkBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof BillAlertsBulkBody
     */
    'billIds': Array<string>;
}
/**
 * 
 * @export
 * @interface BillAuthor
 */
export interface BillAuthor {
    /**
     * 
     * @type {string}
     * @memberof BillAuthor
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof BillAuthor
     */
    'Party': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillAuthor
     */
    'FirstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillAuthor
     */
    'LastName': string | null;
}
/**
 * 
 * @export
 * @interface BillContentDto
 */
export interface BillContentDto {
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'LegiscanUrl': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'TextVersion': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'TextDate': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'MimeType': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'TextUrl': string;
    /**
     * 
     * @type {number}
     * @memberof BillContentDto
     */
    'VersionNumber': number;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'BillVersionId': string;
    /**
     * 
     * @type {number}
     * @memberof BillContentDto
     */
    'Id_backup': number;
    /**
     * 
     * @type {number}
     * @memberof BillContentDto
     */
    'TextType': number;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'Received': string;
    /**
     * 
     * @type {boolean}
     * @memberof BillContentDto
     */
    'Processed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillContentDto
     */
    'BigBill': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'content': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'contentType': BillContentDtoContentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BillContentDto
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillContentDto
     */
    'error'?: string;
    /**
     * 
     * @type {BillContentDtoFallbackUrls}
     * @memberof BillContentDto
     */
    'fallbackUrls'?: BillContentDtoFallbackUrls;
}

export const BillContentDtoContentTypeEnum = {
    Text: 'text',
    Html: 'html',
    Unknown: 'unknown'
} as const;

export type BillContentDtoContentTypeEnum = typeof BillContentDtoContentTypeEnum[keyof typeof BillContentDtoContentTypeEnum];

/**
 * 
 * @export
 * @interface BillContentDtoFallbackUrls
 */
export interface BillContentDtoFallbackUrls {
    /**
     * 
     * @type {string}
     * @memberof BillContentDtoFallbackUrls
     */
    'original': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillContentDtoFallbackUrls
     */
    'html'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDtoFallbackUrls
     */
    'txt': string;
    /**
     * 
     * @type {string}
     * @memberof BillContentDtoFallbackUrls
     */
    'pdf': string;
}
/**
 * 
 * @export
 * @interface BillFileItem
 */
export interface BillFileItem {
    /**
     * 
     * @type {number}
     * @memberof BillFileItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BillFileItem
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BillFileItem
     */
    'size': number;
    /**
     * 
     * @type {string}
     * @memberof BillFileItem
     */
    'modified': string;
    /**
     * 
     * @type {number}
     * @memberof BillFileItem
     */
    'companyId': number | null;
    /**
     * 
     * @type {string}
     * @memberof BillFileItem
     */
    'companyName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillFileItem
     */
    'masterBillId': string | null;
}
/**
 * 
 * @export
 * @interface BillInfo
 */
export interface BillInfo {
    /**
     * 
     * @type {string}
     * @memberof BillInfo
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof BillInfo
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof BillInfo
     */
    'assignedAt': string;
    /**
     * 
     * @type {string}
     * @memberof BillInfo
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillInfo
     */
    'stateCode': string | null;
    /**
     * 
     * @type {number}
     * @memberof BillInfo
     */
    'status': number | null;
}
/**
 * 
 * @export
 * @interface BillListAuthor
 */
export interface BillListAuthor {
    /**
     * 
     * @type {number}
     * @memberof BillListAuthor
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BillListAuthor
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillListAuthor
     */
    'party': string | null;
}
/**
 * 
 * @export
 * @interface BillListItemDto
 */
export interface BillListItemDto {
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'snippet': string | null;
    /**
     * 
     * @type {number}
     * @memberof BillListItemDto
     */
    'aiScore'?: number | null;
    /**
     * 
     * @type {Array<BillListAuthor>}
     * @memberof BillListItemDto
     */
    'authors'?: Array<BillListAuthor>;
    /**
     * 
     * @type {boolean}
     * @memberof BillListItemDto
     */
    'shouldHighlight'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'highlightColor'?: BillListItemDtoHighlightColorEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillListItemDto
     */
    'hasText'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof BillListItemDto
     */
    'Status': number;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'Body': string;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'CurrentBody': string;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'LastAction': string;
    /**
     * 
     * @type {string}
     * @memberof BillListItemDto
     */
    'LastActionDate': string;
    /**
     * 
     * @type {Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillHistoryInner>}
     * @memberof BillListItemDto
     */
    'BillHistory': Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillHistoryInner>;
    /**
     * 
     * @type {Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner>}
     * @memberof BillListItemDto
     */
    'BillSubjects': Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner>;
    /**
     * 
     * @type {Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillVersionsInner>}
     * @memberof BillListItemDto
     */
    'BillVersions': Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillVersionsInner>;
    /**
     * 
     * @type {ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor}
     * @memberof BillListItemDto
     */
    'Author': ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor;
    /**
     * 
     * @type {Array<GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner>}
     * @memberof BillListItemDto
     */
    'Progresses': Array<GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner>;
    /**
     * 
     * @type {Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner>}
     * @memberof BillListItemDto
     */
    'Sponsors': Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner>;
}

export const BillListItemDtoHighlightColorEnum = {
    Green: 'green',
    Red: 'red'
} as const;

export type BillListItemDtoHighlightColorEnum = typeof BillListItemDtoHighlightColorEnum[keyof typeof BillListItemDtoHighlightColorEnum];

/**
 * 
 * @export
 * @interface BillPositionDto
 */
export interface BillPositionDto {
    /**
     * 
     * @type {number}
     * @memberof BillPositionDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BillPositionDto
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof BillPositionDto
     */
    'position': string;
    /**
     * 
     * @type {number}
     * @memberof BillPositionDto
     */
    'tagId': number | null;
    /**
     * 
     * @type {string}
     * @memberof BillPositionDto
     */
    'tagName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPositionDto
     */
    'tagColor': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPositionDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BillPositionDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface BillPositionRecord
 */
export interface BillPositionRecord {
    /**
     * 
     * @type {number}
     * @memberof BillPositionRecord
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof BillPositionRecord
     */
    'BillId': string;
    /**
     * 
     * @type {string}
     * @memberof BillPositionRecord
     */
    'Position': string;
    /**
     * 
     * @type {number}
     * @memberof BillPositionRecord
     */
    'TagId': number | null;
    /**
     * 
     * @type {string}
     * @memberof BillPositionRecord
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof BillPositionRecord
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {BillPositionRecordTag}
     * @memberof BillPositionRecord
     */
    'Tag'?: BillPositionRecordTag | null;
    /**
     * 
     * @type {number}
     * @memberof BillPositionRecord
     */
    'UserId': number;
}
/**
 * 
 * @export
 * @interface BillPositionRecordTag
 */
export interface BillPositionRecordTag {
    /**
     * 
     * @type {string}
     * @memberof BillPositionRecordTag
     */
    'Color': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPositionRecordTag
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof BillPositionRecordTag
     */
    'TagId': number;
}
/**
 * 
 * @export
 * @interface BillQuestionRequest
 */
export interface BillQuestionRequest {
    /**
     * The master bill identifier (STATE-SESSION-TYPE-NUMBER)
     * @type {string}
     * @memberof BillQuestionRequest
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof BillQuestionRequest
     */
    'question': string;
}
/**
 * 
 * @export
 * @interface BillRecord
 */
export interface BillRecord {
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'Title': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'Body': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'CurrentBody': string | null;
    /**
     * 
     * @type {number}
     * @memberof BillRecord
     */
    'Status': number | null;
    /**
     * 
     * @type {string}
     * @memberof BillRecord
     */
    'LastAction': string | null;
    /**
     * 
     * @type {BillAuthor}
     * @memberof BillRecord
     */
    'Author': BillAuthor | null;
    /**
     * 
     * @type {Array<BillRecordAuthorsInner>}
     * @memberof BillRecord
     */
    'Authors'?: Array<BillRecordAuthorsInner>;
    /**
     * 
     * @type {Array<BillPositionRecord>}
     * @memberof BillRecord
     */
    'BillPositions': Array<BillPositionRecord>;
    /**
     * 
     * @type {Array<BillTagRecord>}
     * @memberof BillRecord
     */
    'UserBillTags'?: Array<BillTagRecord>;
    /**
     * 
     * @type {GetBillPriorityImpact200Response}
     * @memberof BillRecord
     */
    'PriorityImpact'?: GetBillPriorityImpact200Response;
}
/**
 * 
 * @export
 * @interface BillRecordAuthorsInner
 */
export interface BillRecordAuthorsInner {
    /**
     * 
     * @type {string}
     * @memberof BillRecordAuthorsInner
     */
    'Party': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillRecordAuthorsInner
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof BillRecordAuthorsInner
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface BillSupportingDocumentDto
 */
export interface BillSupportingDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof BillSupportingDocumentDto
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof BillSupportingDocumentDto
     */
    'UrlFile': string;
    /**
     * 
     * @type {string}
     * @memberof BillSupportingDocumentDto
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof BillSupportingDocumentDto
     */
    'CreatedDate': string;
    /**
     * 
     * @type {string}
     * @memberof BillSupportingDocumentDto
     */
    'User': string;
    /**
     * 
     * @type {string}
     * @memberof BillSupportingDocumentDto
     */
    'FileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillSupportingDocumentDto
     */
    'DownloadUrl': string;
}
/**
 * 
 * @export
 * @interface BillTagRecord
 */
export interface BillTagRecord {
    /**
     * 
     * @type {number}
     * @memberof BillTagRecord
     */
    'TagId': number;
    /**
     * 
     * @type {BillPositionRecordTag}
     * @memberof BillTagRecord
     */
    'Tag': BillPositionRecordTag | null;
}
/**
 * 
 * @export
 * @interface BulkCreateTags200Response
 */
export interface BulkCreateTags200Response {
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTags200Response
     */
    'count': number;
    /**
     * 
     * @type {Array<CreateTag200Response>}
     * @memberof BulkCreateTags200Response
     */
    'tags': Array<CreateTag200Response>;
}
/**
 * 
 * @export
 * @interface BulkCreateTagsRequest
 */
export interface BulkCreateTagsRequest {
    /**
     * 
     * @type {Array<CreateTagBody>}
     * @memberof BulkCreateTagsRequest
     */
    'tags': Array<CreateTagBody>;
}
/**
 * 
 * @export
 * @interface BulkDeleteTags200Response
 */
export interface BulkDeleteTags200Response {
    /**
     * 
     * @type {number}
     * @memberof BulkDeleteTags200Response
     */
    'deletedCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDeleteTags200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface BulkDeleteTagsRequest
 */
export interface BulkDeleteTagsRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkDeleteTagsRequest
     */
    'tagIds': Array<number>;
}
/**
 * 
 * @export
 * @interface BulkImportResult
 */
export interface BulkImportResult {
    /**
     * 
     * @type {number}
     * @memberof BulkImportResult
     */
    'createdCount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkImportResult
     */
    'reactivatedCount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkImportResult
     */
    'skippedCount': number;
    /**
     * 
     * @type {Array<BulkImportResultImportedCompaniesInner>}
     * @memberof BulkImportResult
     */
    'importedCompanies': Array<BulkImportResultImportedCompaniesInner>;
}
/**
 * 
 * @export
 * @interface BulkImportResultImportedCompaniesInner
 */
export interface BulkImportResultImportedCompaniesInner {
    /**
     * 
     * @type {string}
     * @memberof BulkImportResultImportedCompaniesInner
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkImportResultImportedCompaniesInner
     */
    'companyName': string;
    /**
     * 
     * @type {number}
     * @memberof BulkImportResultImportedCompaniesInner
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface BulkSaveAccountCompanySummaryBody
 */
export interface BulkSaveAccountCompanySummaryBody {
    /**
     * 
     * @type {Array<BulkSaveAccountCompanySummaryBodyCompaniesInner>}
     * @memberof BulkSaveAccountCompanySummaryBody
     */
    'companies': Array<BulkSaveAccountCompanySummaryBodyCompaniesInner>;
}
/**
 * 
 * @export
 * @interface BulkSaveAccountCompanySummaryBodyCompaniesInner
 */
export interface BulkSaveAccountCompanySummaryBodyCompaniesInner {
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: StateSpecificSummaryEntry; }}
     * @memberof BulkSaveAccountCompanySummaryBodyCompaniesInner
     */
    'stateSpecificSummaries'?: { [key: string]: StateSpecificSummaryEntry; };
    /**
     * 
     * @type {string}
     * @memberof BulkSaveAccountCompanySummaryBodyCompaniesInner
     */
    'accountFullSum': string;
    /**
     * 
     * @type {number}
     * @memberof BulkSaveAccountCompanySummaryBodyCompaniesInner
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface BulkSaveResult
 */
export interface BulkSaveResult {
    /**
     * 
     * @type {boolean}
     * @memberof BulkSaveResult
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof BulkSaveResult
     */
    'savedCount': number;
    /**
     * 
     * @type {Array<AccountCompanySummaryDto>}
     * @memberof BulkSaveResult
     */
    'companies': Array<AccountCompanySummaryDto>;
}
/**
 * 
 * @export
 * @interface CacheWarmResult
 */
export interface CacheWarmResult {
    /**
     * 
     * @type {boolean}
     * @memberof CacheWarmResult
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof CacheWarmResult
     */
    'totalBills': number;
    /**
     * 
     * @type {number}
     * @memberof CacheWarmResult
     */
    'successCount': number;
    /**
     * 
     * @type {number}
     * @memberof CacheWarmResult
     */
    'failureCount': number;
    /**
     * 
     * @type {string}
     * @memberof CacheWarmResult
     */
    'duration': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CacheWarmResult
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CachedAccountTag
 */
export interface CachedAccountTag {
    /**
     * 
     * @type {number}
     * @memberof CachedAccountTag
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof CachedAccountTag
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof CachedAccountTag
     */
    'CreatedByUserId': number | null;
    /**
     * 
     * @type {string}
     * @memberof CachedAccountTag
     */
    'CreatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof CachedAccountTag
     */
    'Color': string | null;
    /**
     * 
     * @type {number}
     * @memberof CachedAccountTag
     */
    'AccountId': number | null;
    /**
     * 
     * @type {string}
     * @memberof CachedAccountTag
     */
    'Companies': string | null;
    /**
     * 
     * @type {string}
     * @memberof CachedAccountTag
     */
    'SecondaryCompanies': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CachedAccountTag
     */
    'Archived': boolean;
    /**
     * 
     * @type {string}
     * @memberof CachedAccountTag
     */
    'Context': string | null;
}
/**
 * 
 * @export
 * @interface CalendarBillInfo
 */
export interface CalendarBillInfo {
    /**
     * 
     * @type {string}
     * @memberof CalendarBillInfo
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarBillInfo
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarBillInfo
     */
    'author': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarBillInfo
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarBillInfo
     */
    'number': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarBillInfo
     */
    'trackedClients'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarBillInfo
     */
    'trackingUsers'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CalendarBillInfo
     */
    'trackerCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarBillInfo
     */
    'isCurrentUserTracking'?: boolean;
}
/**
 * 
 * @export
 * @interface CalendarEventDto
 */
export interface CalendarEventDto {
    /**
     * 
     * @type {number}
     * @memberof CalendarEventDto
     */
    'EventId': number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventDto
     */
    'EventTypeId': number;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'Description': string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'StartDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'EndDateTime': string | null;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventDto
     */
    'MemberId': number | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'MemberSessionCode': string | null;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventDto
     */
    'CommitteeId': number | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'MasterBillId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventDto
     */
    'UserId': number | null;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventDto
     */
    'AccountId': number | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDto
     */
    'DetailUrl'?: string | null;
    /**
     * 
     * @type {CalendarEventDtoEventType}
     * @memberof CalendarEventDto
     */
    'EventType': CalendarEventDtoEventType;
    /**
     * 
     * @type {CalendarEventDtoMasterBill}
     * @memberof CalendarEventDto
     */
    'MasterBill'?: CalendarEventDtoMasterBill | null;
    /**
     * 
     * @type {CalendarEventDtoMemberSession}
     * @memberof CalendarEventDto
     */
    'MemberSession'?: CalendarEventDtoMemberSession | null;
}
/**
 * 
 * @export
 * @interface CalendarEventDtoEventType
 */
export interface CalendarEventDtoEventType {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDtoEventType
     */
    'TypeName': string;
}
/**
 * 
 * @export
 * @interface CalendarEventDtoMasterBill
 */
export interface CalendarEventDtoMasterBill {
    /**
     * 
     * @type {CalendarEventDtoMasterBillAuthor}
     * @memberof CalendarEventDtoMasterBill
     */
    'Author'?: CalendarEventDtoMasterBillAuthor | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDtoMasterBill
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDtoMasterBill
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDtoMasterBill
     */
    'Title': string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDtoMasterBill
     */
    'MasterBillId': string;
}
/**
 * 
 * @export
 * @interface CalendarEventDtoMasterBillAuthor
 */
export interface CalendarEventDtoMasterBillAuthor {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDtoMasterBillAuthor
     */
    'Name': string | null;
}
/**
 * 
 * @export
 * @interface CalendarEventDtoMemberSession
 */
export interface CalendarEventDtoMemberSession {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDtoMemberSession
     */
    'Name': string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDtoMemberSession
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventDtoMemberSession
     */
    'MemberId': number;
}
/**
 * Explicit type definition for authenticated user to avoid TSOA issues with Prisma\'s GetPayload
 * @export
 * @interface CallingUser
 */
export interface CallingUser {
    /**
     * 
     * @type {number}
     * @memberof CallingUser
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof CallingUser
     */
    'Username': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUser
     */
    'Email': string;
    /**
     * 
     * @type {CallingUserPasswordHash}
     * @memberof CallingUser
     */
    'PasswordHash': CallingUserPasswordHash;
    /**
     * 
     * @type {CallingUserPasswordHash}
     * @memberof CallingUser
     */
    'PasswordSalt': CallingUserPasswordHash;
    /**
     * 
     * @type {number}
     * @memberof CallingUser
     */
    'RoleId': number;
    /**
     * 
     * @type {string}
     * @memberof CallingUser
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUser
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUser
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUser
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUser
     */
    'LastLogin': string | null;
    /**
     * 
     * @type {string}
     * @memberof CallingUser
     */
    'Status': string | null;
    /**
     * 
     * @type {number}
     * @memberof CallingUser
     */
    'AccountId': number;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUser
     */
    'IsLobbyist': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUser
     */
    'IsAnalyst': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CallingUser
     */
    'LobbyistId': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUser
     */
    'CanViewTrackedActivityReport': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUser
     */
    'CanViewAutoTrackedBills': boolean | null;
    /**
     * 
     * @type {CallingUserRole}
     * @memberof CallingUser
     */
    'Role': CallingUserRole;
    /**
     * 
     * @type {Array<CallingUserAccountUserRelationshipsInner>}
     * @memberof CallingUser
     */
    'AccountUserRelationships': Array<CallingUserAccountUserRelationshipsInner>;
}
/**
 * 
 * @export
 * @interface CallingUserAccountUserRelationshipsInner
 */
export interface CallingUserAccountUserRelationshipsInner {
    /**
     * 
     * @type {CallingUserAccountUserRelationshipsInnerAccounts}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'Accounts': CallingUserAccountUserRelationshipsInnerAccounts;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'FullAccountRole': string | null;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'AnalystRole': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'FullAccount': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'IsLobbyist': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'IsAnalyst': boolean;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'Status': string;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'AccountId': number;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInner
     */
    'RelationshipId': number;
}
/**
 * 
 * @export
 * @interface CallingUserAccountUserRelationshipsInnerAccounts
 */
export interface CallingUserAccountUserRelationshipsInnerAccounts {
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'PortalPassword': string | null;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'PortalSettings': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'PortalEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'Subdomain': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'Regulatory': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'VideoOptInDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'Live': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'VideoOnly': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'AutoTrackEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'AutoTrack': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'AnalystPortal': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'LobbyistPortal': boolean;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'FirmId': number | null;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'CompanyId': number | null;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'SeatsUsed': number | null;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'TotalSeats': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'NewAccount': boolean;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'Status': string;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'PlanId': number;
    /**
     * 
     * @type {string}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof CallingUserAccountUserRelationshipsInnerAccounts
     */
    'AccountId': number;
}
/**
 * 
 * @export
 * @interface CallingUserPasswordHash
 */
export interface CallingUserPasswordHash {
}
/**
 * 
 * @export
 * @interface CallingUserRole
 */
export interface CallingUserRole {
    /**
     * 
     * @type {string}
     * @memberof CallingUserRole
     */
    'Description': string | null;
    /**
     * 
     * @type {string}
     * @memberof CallingUserRole
     */
    'RoleName': string;
    /**
     * 
     * @type {number}
     * @memberof CallingUserRole
     */
    'RoleId': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Chamber = {
    H: 'H',
    S: 'S'
} as const;

export type Chamber = typeof Chamber[keyof typeof Chamber];


/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ChatRequest
 */
export interface ChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatRequest
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CheckAvailableAgendas200Response
 */
export interface CheckAvailableAgendas200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CheckAvailableAgendas200Response
     */
    'hasSenate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckAvailableAgendas200Response
     */
    'hasHouse': boolean;
}
/**
 * 
 * @export
 * @interface CheckUsernameAvailability200Response
 */
export interface CheckUsernameAvailability200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CheckUsernameAvailability200Response
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @interface ClearSessionsCache200Response
 */
export interface ClearSessionsCache200Response {
    /**
     * 
     * @type {string}
     * @memberof ClearSessionsCache200Response
     */
    'stateCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClearSessionsCache200Response
     */
    'userId': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClearSessionsCache200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface ClearUserSessionsCache200Response
 */
export interface ClearUserSessionsCache200Response {
    /**
     * 
     * @type {string}
     * @memberof ClearUserSessionsCache200Response
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ClearUserSessionsCache200Response
     */
    'userId': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClearUserSessionsCache200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface ClientDashboardResponse
 */
export interface ClientDashboardResponse {
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponse
     */
    'CompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'ContractualName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'BeneficialName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyAddress1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyAddress2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyFullAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyZip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'CompanyWebsite'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponse
     */
    'MasterCompanyID'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientDashboardResponse
     */
    'ManualCreation': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponse
     */
    'ExpectedInterest': number | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponse
     */
    'Outreach': number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'StateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'UpdatedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponse
     */
    'StateCompanyID': number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'ShortSum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponse
     */
    'FullSum'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientDashboardResponse
     */
    'DoNotContact': boolean;
    /**
     * 
     * @type {Array<ClientDashboardResponseClientContactsInner>}
     * @memberof ClientDashboardResponse
     */
    'ClientContacts': Array<ClientDashboardResponseClientContactsInner>;
    /**
     * 
     * @type {Array<ClientDashboardResponseClientInteractionsInner>}
     * @memberof ClientDashboardResponse
     */
    'ClientInteractions': Array<ClientDashboardResponseClientInteractionsInner>;
    /**
     * 
     * @type {Array<ClientDashboardResponseUserBillTagsInner>}
     * @memberof ClientDashboardResponse
     */
    'UserBillTags': Array<ClientDashboardResponseUserBillTagsInner>;
}
/**
 * 
 * @export
 * @interface ClientDashboardResponseClientContactsInner
 */
export interface ClientDashboardResponseClientContactsInner {
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'CreatedByUserId': number | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'LastContactDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'Notes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'IsPrimary': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'Zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'State'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'City'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'Address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'Department'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'Title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'Mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'Phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'Email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'LastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'FirstName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseClientContactsInner
     */
    'ContactId': number;
}
/**
 * 
 * @export
 * @interface ClientDashboardResponseClientInteractionsInner
 */
export interface ClientDashboardResponseClientInteractionsInner {
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'CreatedByUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'NextFollowUpDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'InteractionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'Description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'Subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'InteractionType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'ContactId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseClientInteractionsInner
     */
    'InteractionId': number;
}
/**
 * 
 * @export
 * @interface ClientDashboardResponseUserBillTagsInner
 */
export interface ClientDashboardResponseUserBillTagsInner {
    /**
     * 
     * @type {ClientDashboardResponseUserBillTagsInnerTag}
     * @memberof ClientDashboardResponseUserBillTagsInner
     */
    'Tag': ClientDashboardResponseUserBillTagsInnerTag;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseUserBillTagsInner
     */
    'TagId': number;
}
/**
 * 
 * @export
 * @interface ClientDashboardResponseUserBillTagsInnerTag
 */
export interface ClientDashboardResponseUserBillTagsInnerTag {
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseUserBillTagsInnerTag
     */
    'Color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDashboardResponseUserBillTagsInnerTag
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof ClientDashboardResponseUserBillTagsInnerTag
     */
    'TagId': number;
}
/**
 * 
 * @export
 * @interface ClipMetadataRequest
 */
export interface ClipMetadataRequest {
    /**
     * 
     * @type {number}
     * @memberof ClipMetadataRequest
     */
    'startTime': number;
    /**
     * 
     * @type {number}
     * @memberof ClipMetadataRequest
     */
    'endTime': number;
    /**
     * 
     * @type {string}
     * @memberof ClipMetadataRequest
     */
    'startPosition'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClipMetadataRequest
     */
    'endPosition'?: string;
}
/**
 * 
 * @export
 * @interface ClipMetadataResponse
 */
export interface ClipMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof ClipMetadataResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ClipMetadataResponse
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface ClipSegment
 */
export interface ClipSegment {
    /**
     * 
     * @type {string}
     * @memberof ClipSegment
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ClipSegment
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof ClipSegment
     */
    'startTime': number;
    /**
     * 
     * @type {number}
     * @memberof ClipSegment
     */
    'endTime': number;
    /**
     * 
     * @type {number}
     * @memberof ClipSegment
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof ClipSegment
     */
    'relevance': string;
}
/**
 * 
 * @export
 * @interface ClusterMemberDto
 */
export interface ClusterMemberDto {
    /**
     * 
     * @type {number}
     * @memberof ClusterMemberDto
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof ClusterMemberDto
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof ClusterMemberDto
     */
    'stateCode'?: string | null;
}
/**
 * 
 * @export
 * @interface ClusterResponse
 */
export interface ClusterResponse {
    /**
     * 
     * @type {number}
     * @memberof ClusterResponse
     */
    'masterCompanyId': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClusterResponse
     */
    'clusteredCompanyIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ClusterResponse
     */
    'clusterSummary': string;
    /**
     * 
     * @type {Array<ClusterMemberDto>}
     * @memberof ClusterResponse
     */
    'members': Array<ClusterMemberDto>;
}
/**
 * 
 * @export
 * @interface CoSponsor
 */
export interface CoSponsor {
    /**
     * 
     * @type {string}
     * @memberof CoSponsor
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof CoSponsor
     */
    'sharedBills': number;
    /**
     * 
     * @type {string}
     * @memberof CoSponsor
     */
    'chamber': string | null;
    /**
     * 
     * @type {string}
     * @memberof CoSponsor
     */
    'party': string | null;
    /**
     * 
     * @type {string}
     * @memberof CoSponsor
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof CoSponsor
     */
    'memberId': number;
}
/**
 * 
 * @export
 * @interface CommitteeAgentStateDto
 */
export interface CommitteeAgentStateDto {
    /**
     * 
     * @type {string}
     * @memberof CommitteeAgentStateDto
     */
    'stateCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommitteeAgentStateDto
     */
    'isEnabled': boolean;
}
/**
 * 
 * @export
 * @interface CommitteeAgentStatsResponse
 */
export interface CommitteeAgentStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'upcomingHearings': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'upcomingHearingsHighPriority': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'videoClipsGenerated': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'videoClipsToday': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'keywordClipsFound': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'keywordClipsToday': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'hearingsProcessed': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'hearingsProcessedToday': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'totalAnalyzedHearings': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'totalAnalyses': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'totalClips': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'aiSummariesCount': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'highPriorityCount': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'highImpactCount': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponse
     */
    'mediumImpactCount': number;
    /**
     * 
     * @type {CommitteeAgentStatsResponsePriorityBreakdown}
     * @memberof CommitteeAgentStatsResponse
     */
    'priorityBreakdown': CommitteeAgentStatsResponsePriorityBreakdown;
    /**
     * 
     * @type {CommitteeAgentStatsResponsePriorityBreakdown}
     * @memberof CommitteeAgentStatsResponse
     */
    'impactBreakdown': CommitteeAgentStatsResponsePriorityBreakdown;
}
/**
 * 
 * @export
 * @interface CommitteeAgentStatsResponsePriorityBreakdown
 */
export interface CommitteeAgentStatsResponsePriorityBreakdown {
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponsePriorityBreakdown
     */
    'low': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponsePriorityBreakdown
     */
    'medium': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAgentStatsResponsePriorityBreakdown
     */
    'high': number;
}
/**
 * 
 * @export
 * @interface CommitteeAlertDto
 */
export interface CommitteeAlertDto {
    /**
     * 
     * @type {number}
     * @memberof CommitteeAlertDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAlertDto
     */
    'committeeId': number;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAlertDto
     */
    'committeeName': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAlertDto
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAlertDto
     */
    'chamber'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAlertDto
     */
    'userContactId': number;
    /**
     * 
     * @type {boolean}
     * @memberof CommitteeAlertDto
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommitteeAlertDto
     */
    'phone': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommitteeAlertDto
     */
    'web': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommitteeAlertDto
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface CommitteeAnalysisResponse
 */
export interface CommitteeAnalysisResponse {
    /**
     * 
     * @type {number}
     * @memberof CommitteeAnalysisResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAnalysisResponse
     */
    'videoId': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAnalysisResponse
     */
    'committeeId': number;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAnalysisResponse
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'sessionCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommitteeAnalysisResponse
     */
    'isRelevant': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'impact': string | null;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'priority': string | null;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'blobStorageUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'shortSummary': string | null;
    /**
     * 
     * @type {Array<NotableTimestamp>}
     * @memberof CommitteeAnalysisResponse
     */
    'notableTimestamps': Array<NotableTimestamp>;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeAnalysisResponse
     */
    'summaryFileUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof CommitteeAnalysisResponse
     */
    'summaryFileId': number | null;
}
/**
 * 
 * @export
 * @interface CommitteeMemberInfo
 */
export interface CommitteeMemberInfo {
    /**
     * 
     * @type {string}
     * @memberof CommitteeMemberInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeMemberInfo
     */
    'position'?: string | null;
}
/**
 * 
 * @export
 * @interface CommitteeSession
 */
export interface CommitteeSession {
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'chamber': CommitteeSessionChamberEnum;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'status': CommitteeSessionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'type': CommitteeSessionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'committeeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'link'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'transcriptUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'originalSrc'?: string;
    /**
     * 
     * @type {PortalViewerRelationshipContactReferenceId}
     * @memberof CommitteeSession
     */
    'duration'?: PortalViewerRelationshipContactReferenceId;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'sessionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'summaryUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'stateCode'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitteeSession
     */
    'snippet'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CommitteeSession
     */
    'thumbnailUrl'?: string;
}

export const CommitteeSessionChamberEnum = {
    House: 'House',
    Senate: 'Senate'
} as const;

export type CommitteeSessionChamberEnum = typeof CommitteeSessionChamberEnum[keyof typeof CommitteeSessionChamberEnum];
export const CommitteeSessionStatusEnum = {
    Live: 'live',
    Ended: 'ended',
    Scheduled: 'scheduled'
} as const;

export type CommitteeSessionStatusEnum = typeof CommitteeSessionStatusEnum[keyof typeof CommitteeSessionStatusEnum];
export const CommitteeSessionTypeEnum = {
    Session: 'session',
    Floor: 'floor',
    Committee: 'committee'
} as const;

export type CommitteeSessionTypeEnum = typeof CommitteeSessionTypeEnum[keyof typeof CommitteeSessionTypeEnum];

/**
 * 
 * @export
 * @interface CompanyAnalyticsResponse
 */
export interface CompanyAnalyticsResponse {
    /**
     * 
     * @type {CompanyAnalyticsResponseTotals}
     * @memberof CompanyAnalyticsResponse
     */
    'totals': CompanyAnalyticsResponseTotals;
    /**
     * 
     * @type {Array<CompanyTopRecord>}
     * @memberof CompanyAnalyticsResponse
     */
    'topByLobbyists': Array<CompanyTopRecord>;
    /**
     * 
     * @type {Array<CompanyTopRecord>}
     * @memberof CompanyAnalyticsResponse
     */
    'topBySpend': Array<CompanyTopRecord>;
    /**
     * 
     * @type {Array<CompanyTopRecord>}
     * @memberof CompanyAnalyticsResponse
     */
    'topByTestimony': Array<CompanyTopRecord>;
    /**
     * 
     * @type {Array<CompanyTopRecord>}
     * @memberof CompanyAnalyticsResponse
     */
    'topByContributions': Array<CompanyTopRecord>;
}
/**
 * 
 * @export
 * @interface CompanyAnalyticsResponseTotals
 */
export interface CompanyAnalyticsResponseTotals {
    /**
     * 
     * @type {number}
     * @memberof CompanyAnalyticsResponseTotals
     */
    'totalContributionAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyAnalyticsResponseTotals
     */
    'contributions': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyAnalyticsResponseTotals
     */
    'testimonies': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyAnalyticsResponseTotals
     */
    'engagements': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyAnalyticsResponseTotals
     */
    'totalLobbyingSpendHigh': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyAnalyticsResponseTotals
     */
    'totalLobbyingSpendLow': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyAnalyticsResponseTotals
     */
    'companies': number;
}
/**
 * 
 * @export
 * @interface CompanyClipResponse
 */
export interface CompanyClipResponse {
    /**
     * 
     * @type {number}
     * @memberof CompanyClipResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyClipResponse
     */
    'companyName': string;
    /**
     * 
     * @type {Array<ClipSegment>}
     * @memberof CompanyClipResponse
     */
    'clips': Array<ClipSegment>;
}
/**
 * 
 * @export
 * @interface CompanyKeywords
 */
export interface CompanyKeywords {
    /**
     * 
     * @type {string}
     * @memberof CompanyKeywords
     */
    'companyId': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyKeywords
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyKeywords
     */
    'stateCode'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyKeywords
     */
    'keywords': Array<string>;
}
/**
 * 
 * @export
 * @interface CompanyMatch
 */
export interface CompanyMatch {
    /**
     * 
     * @type {number}
     * @memberof CompanyMatch
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyMatch
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyMatch
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMatch
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMatch
     */
    'address'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CompanyPosition = {
    Yes: 'yes',
    No: 'no',
    Neutral: 'neutral',
    Undecided: 'undecided'
} as const;

export type CompanyPosition = typeof CompanyPosition[keyof typeof CompanyPosition];


/**
 * 
 * @export
 * @interface CompanySummaryResponse
 */
export interface CompanySummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof CompanySummaryResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CompanySummaryResponse
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof CompanySummaryResponse
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof CompanySummaryResponse
     */
    'blobUrl': string;
}
/**
 * 
 * @export
 * @interface CompanyTickSheetEntryDto
 */
export interface CompanyTickSheetEntryDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyTickSheetEntryDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTickSheetEntryDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTickSheetEntryDto
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTickSheetEntryDto
     */
    'note': string;
    /**
     * 
     * @type {CompanyPosition}
     * @memberof CompanyTickSheetEntryDto
     */
    'position': CompanyPosition;
    /**
     * 
     * @type {string}
     * @memberof CompanyTickSheetEntryDto
     */
    'companyName': string;
    /**
     * 
     * @type {number}
     * @memberof CompanyTickSheetEntryDto
     */
    'companyId': number;
}


/**
 * 
 * @export
 * @interface CompanyTickSheetEntryInput
 */
export interface CompanyTickSheetEntryInput {
    /**
     * 
     * @type {string}
     * @memberof CompanyTickSheetEntryInput
     */
    'note'?: string;
    /**
     * 
     * @type {CompanyPosition}
     * @memberof CompanyTickSheetEntryInput
     */
    'position': CompanyPosition;
    /**
     * 
     * @type {string}
     * @memberof CompanyTickSheetEntryInput
     */
    'companyName': string;
    /**
     * 
     * @type {number}
     * @memberof CompanyTickSheetEntryInput
     */
    'companyId': number;
}


/**
 * 
 * @export
 * @interface CompanyTopRecord
 */
export interface CompanyTopRecord {
    /**
     * 
     * @type {number}
     * @memberof CompanyTopRecord
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyTopRecord
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyTopRecord
     */
    'totalLobbyingSpendLow'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyTopRecord
     */
    'totalLobbyingSpendHigh'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyTopRecord
     */
    'contributionsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyTopRecord
     */
    'testimoniesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyTopRecord
     */
    'lobbyistsTotal'?: number;
}
/**
 * 
 * @export
 * @interface CompleteRegistrationRequestModel
 */
export interface CompleteRegistrationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof CompleteRegistrationRequestModel
     */
    'sessionId': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteRegistrationRequestModel
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteRegistrationRequestModel
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteRegistrationRequestModel
     */
    'organization': string;
}
/**
 * 
 * @export
 * @interface CompleteSetupRequest
 */
export interface CompleteSetupRequest {
    /**
     * The description of the entity
     * @type {string}
     * @memberof CompleteSetupRequest
     */
    'description': string;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CompleteSetupRequest
     */
    'keywordsByCompany': { [key: string]: Array<string>; };
    /**
     * The tags related to the entity
     * @type {Array<string>}
     * @memberof CompleteSetupRequest
     */
    'tags': Array<string>;
    /**
     * The selected company ID (optional)
     * @type {number}
     * @memberof CompleteSetupRequest
     */
    'companyId'?: number;
    /**
     * The selected firm ID (optional)
     * @type {number}
     * @memberof CompleteSetupRequest
     */
    'firmId'?: number;
    /**
     * The selected lobbyist ID (optional)
     * @type {number}
     * @memberof CompleteSetupRequest
     */
    'lobbyistId'?: number;
}
/**
 * 
 * @export
 * @interface ConcatenatedRegulation
 */
export interface ConcatenatedRegulation {
    /**
     * 
     * @type {number}
     * @memberof ConcatenatedRegulation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ConcatenatedRegulation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ConcatenatedRegulation
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ConcatenatedRegulation
     */
    'fullText': string;
}
/**
 * 
 * @export
 * @interface ConnectGmailRequest
 */
export interface ConnectGmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectGmailRequest
     */
    'authorizationCode': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectGmailRequest
     */
    'redirectUri'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectGmailRequest
     */
    'state': string;
}
/**
 * 
 * @export
 * @interface ConnectSlackIntegrationRequest
 */
export interface ConnectSlackIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof ConnectSlackIntegrationRequest
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConnectSlackIntegrationRequest
     */
    'workspaceName': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectSlackIntegrationRequest
     */
    'webhookUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectSlackIntegrationRequest
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectSlackIntegrationRequest
     */
    'channelName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectSlackIntegrationRequest
     */
    'channelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectSlackIntegrationRequest
     */
    'teamId'?: string;
}
/**
 * 
 * @export
 * @interface ConsolidateTags200Response
 */
export interface ConsolidateTags200Response {
    /**
     * 
     * @type {string}
     * @memberof ConsolidateTags200Response
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConsolidateTags200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface ConsolidateTagsRequest
 */
export interface ConsolidateTagsRequest {
    /**
     * 
     * @type {number}
     * @memberof ConsolidateTagsRequest
     */
    'targetTagId': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConsolidateTagsRequest
     */
    'sourceTagIds': Array<number>;
}
/**
 * 
 * @export
 * @interface ContactInfoDto
 */
export interface ContactInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'officeAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'campaignWebsite': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'website': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'facebook': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'instagram': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'twitter': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'linkedIn': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'professionalBackground': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'firstElected': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'contactNotes': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'contactSources': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoDto
     */
    'contactLastUpdated': string | null;
}
/**
 * 
 * @export
 * @interface ContactPayload
 */
export interface ContactPayload {
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'Department'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'Email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'Phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'Mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'Address'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'City'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'State'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'Zip'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContactPayload
     */
    'IsPrimary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'Notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPayload
     */
    'LastContactDate'?: string;
}
/**
 * 
 * @export
 * @interface ContextQueryRequest
 */
export interface ContextQueryRequest {
    /**
     * 
     * @type {string}
     * @memberof ContextQueryRequest
     */
    'query': string;
}
/**
 * 
 * @export
 * @interface ContributionDto
 */
export interface ContributionDto {
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'MemberId': number;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'LobbyistId': number;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'State': string;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'CompanyId': number;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'FirmId': number;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'Year': number;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributionId': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'FormTypeCode': string;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'FilerId': number;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'FilerName': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributionDate': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorPersonTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorOrganization': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorLastName': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorSuffixCode': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorCity': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorState': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorCounty': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorCountry': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorEmployer': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorOccupation': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'ContributorDescription': string;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'CandidateId': number;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'HashKey': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'LoadDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'SourceFileName': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'RecipientFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'RecipientLastName': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'FilerType': string;
    /**
     * 
     * @type {string}
     * @memberof ContributionDto
     */
    'Contributor': string;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'ContributionAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'LoanAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof ContributionDto
     */
    'AggregateAmount': number | null;
}
/**
 * 
 * @export
 * @interface CreateBillPositionBody
 */
export interface CreateBillPositionBody {
    /**
     * 
     * @type {string}
     * @memberof CreateBillPositionBody
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBillPositionBody
     */
    'position': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBillPositionBody
     */
    'tagId'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateBillRemark200Response
 */
export interface CreateBillRemark200Response {
    /**
     * 
     * @type {GetBillTestimony200ResponseInnerWitness}
     * @memberof CreateBillRemark200Response
     */
    'User': GetBillTestimony200ResponseInnerWitness;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemark200Response
     */
    'RelatedId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBillRemark200Response
     */
    'Type': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateBillRemark200Response
     */
    'Tags': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof CreateBillRemark200Response
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemark200Response
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemark200Response
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBillRemark200Response
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemark200Response
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemark200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBillRemark200Response
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateBillRemark200Response
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemark200Response
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface CreateBillRemarkBody
 */
export interface CreateBillRemarkBody {
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemarkBody
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemarkBody
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemarkBody
     */
    'sessionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBillRemarkBody
     */
    'stateCode'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateBillRemarkBody
     */
    'tags'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CreateClusterBody
 */
export interface CreateClusterBody {
    /**
     * 
     * @type {number}
     * @memberof CreateClusterBody
     */
    'masterCompanyId': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateClusterBody
     */
    'companyIds': Array<number>;
}
/**
 * Create company request payload
 * @export
 * @interface CreateCompanyRequest
 */
export interface CreateCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequest
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequest
     */
    'stateCode': string;
}
/**
 * 
 * @export
 * @interface CreateFeatureRequest200Response
 */
export interface CreateFeatureRequest200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'UpdatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'EstimatedEffort': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'BusinessValue': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'Category': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'DateLastUpdated': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'DateSubmitted': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'SubmitterOrganization': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'SubmitterEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'SubmitterName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'ProposedSolution': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'CurrentIssue': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFeatureRequest200Response
     */
    'IsActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'Notes': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'AssignedTo': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'CreatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'Priority': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequest200Response
     */
    'Status': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFeatureRequest200Response
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface CreateFeatureRequestBody
 */
export interface CreateFeatureRequestBody {
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'currentIssue'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'proposedSolution'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'priority'?: CreateFeatureRequestBodyPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'businessValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'estimatedEffort'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeatureRequestBody
     */
    'submitterOrganization'?: string;
}

export const CreateFeatureRequestBodyPriorityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type CreateFeatureRequestBodyPriorityEnum = typeof CreateFeatureRequestBodyPriorityEnum[keyof typeof CreateFeatureRequestBodyPriorityEnum];

/**
 * 
 * @export
 * @interface CreateFirm200Response
 */
export interface CreateFirm200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmPhone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmZip': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmState': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmCity': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmStreet2': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmStreet1': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'FirmName': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFirm200Response
     */
    'FirmID': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFirm200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFirm200Response
     */
    'LobbyistCount': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFirm200Response
     */
    'StateFirmID': number;
}
/**
 * 
 * @export
 * @interface CreateFirmRequest
 */
export interface CreateFirmRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFirmRequest
     */
    'firmName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirmRequest
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFirmRequest
     */
    'firmPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFirmRequest
     */
    'firmEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFirmRequest
     */
    'firmWebsite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFirmRequest
     */
    'firmCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFirmRequest
     */
    'firmState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFirmRequest
     */
    'firmZip'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateFolderBody
 */
export interface CreateFolderBody {
    /**
     * 
     * @type {string}
     * @memberof CreateFolderBody
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFolderBody
     */
    'parentFolderId': number | null;
}
/**
 * 
 * @export
 * @interface CreateGmailCalendarEvent200Response
 */
export interface CreateGmailCalendarEvent200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateGmailCalendarEvent200Response
     */
    'link'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGmailCalendarEvent200Response
     */
    'eventId': string;
}
/**
 * 
 * @export
 * @interface CreateInvitation200Response
 */
export interface CreateInvitation200Response {
    /**
     * A typed array of 8-bit unsigned integer values. The contents are initialized to 0. If the requested number of bytes could not be allocated an exception is raised.
     * @type {object}
     * @memberof CreateInvitation200Response
     */
    'TempPasswordHash': object;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'InviteType': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'RespondedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'ExpirationDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'Message': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'InviteeStateCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'InviteeLastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'InviteeFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'Token': string;
    /**
     * 
     * @type {number}
     * @memberof CreateInvitation200Response
     */
    'InviteeUserId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'InviteeEmail': string;
    /**
     * 
     * @type {number}
     * @memberof CreateInvitation200Response
     */
    'InvitationId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'FullAccountRole': string;
    /**
     * 
     * @type {number}
     * @memberof CreateInvitation200Response
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitation200Response
     */
    'CreatedAt': string;
}
/**
 * 
 * @export
 * @interface CreateIssueBody
 */
export interface CreateIssueBody {
    /**
     * 
     * @type {string}
     * @memberof CreateIssueBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueBody
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueBody
     */
    'route'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueBody
     */
    'issueType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueBody
     */
    'priority'?: CreateIssueBodyPriorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateIssueBody
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueBody
     */
    'tags'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueBody
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueBody
     */
    'screenshotUrl'?: string;
}

export const CreateIssueBodyPriorityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type CreateIssueBodyPriorityEnum = typeof CreateIssueBodyPriorityEnum[keyof typeof CreateIssueBodyPriorityEnum];

/**
 * 
 * @export
 * @interface CreateLobbyist200Response
 */
export interface CreateLobbyist200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CreateLobbyist200Response
     */
    'DoNotContact': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateLobbyist200Response
     */
    'Outreach': number;
    /**
     * 
     * @type {number}
     * @memberof CreateLobbyist200Response
     */
    'FirmID': number;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistStatus': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistBusiness': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistRegisteredBranches': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistPhone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistZip': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistState': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistCity': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistFullAddress': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistFullName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistLastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistMiddleName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistTitle': string;
    /**
     * 
     * @type {number}
     * @memberof CreateLobbyist200Response
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLobbyist200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof CreateLobbyist200Response
     */
    'StateLobbyistID': number;
}
/**
 * 
 * @export
 * @interface CreateMemberListRequest
 */
export interface CreateMemberListRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMemberListRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemberListRequest
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemberListRequest
     */
    'sessionCode': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateMemberListRequest
     */
    'memberIds': Array<number>;
}
/**
 * 
 * @export
 * @interface CreatePortalRequest
 */
export interface CreatePortalRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePortalRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePortalRequest
     */
    'subdomain'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePortalRequest
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {PortalSettings}
     * @memberof CreatePortalRequest
     */
    'portalSettings'?: PortalSettings;
    /**
     * 
     * @type {string}
     * @memberof CreatePortalRequest
     */
    'portalPassword'?: string | null;
    /**
     * 
     * @type {Array<PortalPageInput>}
     * @memberof CreatePortalRequest
     */
    'pages'?: Array<PortalPageInput>;
}
/**
 * 
 * @export
 * @interface CreateProspect200Response
 */
export interface CreateProspect200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'DiscountCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'NextFollowUpDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'LastContactDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Country': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'AnnualRevenue': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Industry': string;
    /**
     * 
     * @type {number}
     * @memberof CreateProspect200Response
     */
    'CompanySize': number;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Department': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'JobTitle': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'ReferredBy': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'PreferredContactMethod': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'LinkedinProfile': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Website': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'PhoneSecondary': string;
    /**
     * 
     * @type {number}
     * @memberof CreateProspect200Response
     */
    'LeadScore': number;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'ZipCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Street': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'HowHeard': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Timezone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Source': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Tags': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Notes': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'AssignedTo': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Priority': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Organization': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'State': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof CreateProspect200Response
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'City': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProspect200Response
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface CreateTag200Response
 */
export interface CreateTag200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateTag200Response
     */
    'SecondaryCompanies': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTag200Response
     */
    'Context': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTag200Response
     */
    'Archived': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateTag200Response
     */
    'CreatedByUserId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTag200Response
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTag200Response
     */
    'Companies': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTag200Response
     */
    'Company': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateTag200Response
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTag200Response
     */
    'Color': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTag200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTag200Response
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface CreateTagBody
 */
export interface CreateTagBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTagBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTagBody
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTagBody
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTagBody
     */
    'userLevel'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateTagBody
     */
    'companies'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateTagBody
     */
    'secondaryCompanies'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CreateTaskDto
 */
export interface CreateTaskDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskDto
     */
    'billId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskDto
     */
    'assignedUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskDto
     */
    'assignedTeamId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskDto
     */
    'priority'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskDto
     */
    'dueDate'?: string;
}
/**
 * 
 * @export
 * @interface CreateTaskNoteDto
 */
export interface CreateTaskNoteDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskNoteDto
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskNoteDto
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface CreateTeam200Response
 */
export interface CreateTeam200Response {
    /**
     * 
     * @type {number}
     * @memberof CreateTeam200Response
     */
    'ManagerId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTeam200Response
     */
    'ParentId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTeam200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTeam200Response
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTeam200Response
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface CreateTeamRequest
 */
export interface CreateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTeamRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTeamRequest
     */
    'parentId'?: number;
}
/**
 * 
 * @export
 * @interface CreateUserFolder200Response
 */
export interface CreateUserFolder200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateUserFolder200Response
     */
    'Color': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserFolder200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserFolder200Response
     */
    'ParentFolderId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateUserFolder200Response
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateUserFolder200Response
     */
    'FolderId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateUserFolder200Response
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface CreatedClipResponse
 */
export interface CreatedClipResponse {
    /**
     * 
     * @type {string}
     * @memberof CreatedClipResponse
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof CreatedClipResponse
     */
    'VideoId': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatedClipResponse
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedClipResponse
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedClipResponse
     */
    'Description': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatedClipResponse
     */
    'StartTime': number;
    /**
     * 
     * @type {number}
     * @memberof CreatedClipResponse
     */
    'EndTime': number;
    /**
     * 
     * @type {string}
     * @memberof CreatedClipResponse
     */
    'StartPosition': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatedClipResponse
     */
    'EndPosition': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedClipResponse
     */
    'IncludeTranscript': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreatedClipResponse
     */
    'LiveId': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatedClipResponse
     */
    'UserId': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatedClipResponse
     */
    'Keyword': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatedClipResponse
     */
    'fileId': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatedClipResponse
     */
    'fileUrl': string | null;
}
/**
 * 
 * @export
 * @interface CustomerPortalSessionResponseModel
 */
export interface CustomerPortalSessionResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerPortalSessionResponseModel
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface DailyAgendaDto
 */
export interface DailyAgendaDto {
    /**
     * 
     * @type {number}
     * @memberof DailyAgendaDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DailyAgendaDto
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof DailyAgendaDto
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof DailyAgendaDto
     */
    'agendaDate': string;
    /**
     * 
     * @type {string}
     * @memberof DailyAgendaDto
     */
    'blobPath': string;
    /**
     * 
     * @type {string}
     * @memberof DailyAgendaDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface DashboardBill
 */
export interface DashboardBill {
    /**
     * 
     * @type {string}
     * @memberof DashboardBill
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardBill
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardBill
     */
    'assignedAt': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardBill
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardBill
     */
    'stateCode': string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardBill
     */
    'status': number | null;
    /**
     * 
     * @type {Array<DashboardBillPosition>}
     * @memberof DashboardBill
     */
    'positions': Array<DashboardBillPosition>;
}
/**
 * 
 * @export
 * @interface DashboardBillPosition
 */
export interface DashboardBillPosition {
    /**
     * 
     * @type {number}
     * @memberof DashboardBillPosition
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DashboardBillPosition
     */
    'position': string;
    /**
     * 
     * @type {number}
     * @memberof DashboardBillPosition
     */
    'tagId': number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardBillPosition
     */
    'tagName': string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardBillPosition
     */
    'tagColor': string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardBillPosition
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardBillPosition
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof DashboardBillPosition
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface DashboardData
 */
export interface DashboardData {
    /**
     * 
     * @type {Array<DashboardUser>}
     * @memberof DashboardData
     */
    'users': Array<DashboardUser>;
}
/**
 * 
 * @export
 * @interface DashboardStatsResponse
 */
export interface DashboardStatsResponse {
    /**
     * 
     * @type {StatItem}
     * @memberof DashboardStatsResponse
     */
    'trackedBills': StatItem;
    /**
     * 
     * @type {StatItem}
     * @memberof DashboardStatsResponse
     */
    'newActions': StatItem;
    /**
     * 
     * @type {StatItem}
     * @memberof DashboardStatsResponse
     */
    'savedSearches': StatItem;
    /**
     * 
     * @type {DashboardStatsResponseTrackedBreakdown}
     * @memberof DashboardStatsResponse
     */
    'trackedBreakdown'?: DashboardStatsResponseTrackedBreakdown;
}
/**
 * 
 * @export
 * @interface DashboardStatsResponseTrackedBreakdown
 */
export interface DashboardStatsResponseTrackedBreakdown {
    /**
     * 
     * @type {number}
     * @memberof DashboardStatsResponseTrackedBreakdown
     */
    'autoUnsorted': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardStatsResponseTrackedBreakdown
     */
    'totalTracked': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardStatsResponseTrackedBreakdown
     */
    'manualOrSorted': number;
}
/**
 * 
 * @export
 * @interface DashboardTag
 */
export interface DashboardTag {
    /**
     * 
     * @type {DashboardTagTag}
     * @memberof DashboardTag
     */
    'tag': DashboardTagTag;
    /**
     * 
     * @type {Array<DashboardBill>}
     * @memberof DashboardTag
     */
    'bills': Array<DashboardBill>;
}
/**
 * 
 * @export
 * @interface DashboardTagTag
 */
export interface DashboardTagTag {
    /**
     * 
     * @type {string}
     * @memberof DashboardTagTag
     */
    'Color': string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardTagTag
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof DashboardTagTag
     */
    'TagId': number;
}
/**
 * 
 * @export
 * @interface DashboardUser
 */
export interface DashboardUser {
    /**
     * 
     * @type {DashboardUserUser}
     * @memberof DashboardUser
     */
    'user': DashboardUserUser;
    /**
     * 
     * @type {Array<DashboardTag>}
     * @memberof DashboardUser
     */
    'tags': Array<DashboardTag>;
}
/**
 * 
 * @export
 * @interface DashboardUserUser
 */
export interface DashboardUserUser {
    /**
     * 
     * @type {string}
     * @memberof DashboardUserUser
     */
    'stateCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardUserUser
     */
    'isLobbyist': boolean;
    /**
     * 
     * @type {string}
     * @memberof DashboardUserUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardUserUser
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof DashboardUserUser
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface DeleteAllAutoTrackedBills200Response
 */
export interface DeleteAllAutoTrackedBills200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteAllAutoTrackedBills200Response
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof DeleteAllAutoTrackedBills200Response
     */
    'priorityImpactDeleted': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteAllAutoTrackedBills200Response
     */
    'reasoningDeleted': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteAllAutoTrackedBills200Response
     */
    'deletedCount': number;
}
/**
 * 
 * @export
 * @interface DeleteUserKeywordBody
 */
export interface DeleteUserKeywordBody {
    /**
     * 
     * @type {number}
     * @memberof DeleteUserKeywordBody
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteUserKeywordBody
     */
    'companyId': string;
    /**
     * 
     * @type {string}
     * @memberof DeleteUserKeywordBody
     */
    'keyword': string;
}
/**
 * 
 * @export
 * @interface DismissNewUserModal200Response
 */
export interface DismissNewUserModal200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DismissNewUserModal200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface DocumentMetadata
 */
export interface DocumentMetadata {
    /**
     * 
     * @type {number}
     * @memberof DocumentMetadata
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentMetadata
     */
    'remarkId': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentMetadata
     */
    'fileName': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentMetadata
     */
    'fileSize': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentMetadata
     */
    'fileType': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentMetadata
     */
    'azureBlobPath': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentMetadata
     */
    'uploadedByUserId': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentMetadata
     */
    'createdAt': string;
    /**
     * 
     * @type {DocumentMetadataUploadedBy}
     * @memberof DocumentMetadata
     */
    'uploadedBy': DocumentMetadataUploadedBy;
}
/**
 * 
 * @export
 * @interface DocumentMetadataUploadedBy
 */
export interface DocumentMetadataUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof DocumentMetadataUploadedBy
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentMetadataUploadedBy
     */
    'firstName': string;
}
/**
 * 
 * @export
 * @interface ElasticSearchResult
 */
export interface ElasticSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'masterBillId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'videoId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'snippet': string;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'sessionCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'lastAction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElasticSearchResult
     */
    'date'?: string | null;
}
/**
 * 
 * @export
 * @interface EmailAiReportRequest
 */
export interface EmailAiReportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailAiReportRequest
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmailAiReportRequest
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailAiReportRequest
     */
    'pdfBase64': string;
    /**
     * 
     * @type {string}
     * @memberof EmailAiReportRequest
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailAiReportRequest
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface EmailRequest
 */
export interface EmailRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailRequest
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof EmailRequest
     */
    'subject': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailRequest
     */
    'text': Array<string>;
}
/**
 * 
 * @export
 * @interface EnsureFolderPath200Response
 */
export interface EnsureFolderPath200Response {
    /**
     * 
     * @type {number}
     * @memberof EnsureFolderPath200Response
     */
    'folderId': number;
}
/**
 * 
 * @export
 * @interface EnsureFolderPathBody
 */
export interface EnsureFolderPathBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof EnsureFolderPathBody
     */
    'path': Array<string>;
}
/**
 * 
 * @export
 * @interface EntitySummaryRequest
 */
export interface EntitySummaryRequest {
    /**
     * The name of the entity (company, lobbyist, or associate)
     * @type {string}
     * @memberof EntitySummaryRequest
     */
    'name': string;
    /**
     * The type of entity
     * @type {string}
     * @memberof EntitySummaryRequest
     */
    'type': EntitySummaryRequestTypeEnum;
}

export const EntitySummaryRequestTypeEnum = {
    Company: 'company',
    Lobbyist: 'lobbyist',
    Associate: 'associate'
} as const;

export type EntitySummaryRequestTypeEnum = typeof EntitySummaryRequestTypeEnum[keyof typeof EntitySummaryRequestTypeEnum];

/**
 * 
 * @export
 * @interface EntitySummaryResponse
 */
export interface EntitySummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof EntitySummaryResponse
     */
    'summary': string;
}
/**
 * 
 * @export
 * @interface EventTypeDto
 */
export interface EventTypeDto {
    /**
     * 
     * @type {number}
     * @memberof EventTypeDto
     */
    'TypeId': number;
    /**
     * 
     * @type {string}
     * @memberof EventTypeDto
     */
    'TypeName': string;
}
/**
 * 
 * @export
 * @interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
 */
export interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType {
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'snippet': string;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'aiScore'?: number;
    /**
     * 
     * @type {Array<BillListAuthor>}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'authors'?: Array<BillListAuthor>;
    /**
     * 
     * @type {boolean}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'shouldHighlight'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'highlightColor'?: ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeHighlightColorEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'hasText'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'Status': number;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'Body': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'CurrentBody': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'LastAction': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'LastActionDate': string;
    /**
     * 
     * @type {Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillHistoryInner>}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'BillHistory': Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillHistoryInner>;
    /**
     * 
     * @type {Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner>}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'BillSubjects': Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner>;
    /**
     * 
     * @type {Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillVersionsInner>}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'BillVersions': Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillVersionsInner>;
    /**
     * 
     * @type {ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'Author': ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor;
    /**
     * 
     * @type {Array<GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner>}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'Progresses': Array<GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner>;
    /**
     * 
     * @type {Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner>}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsType
     */
    'Sponsors': Array<ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner>;
}

export const ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeHighlightColorEnum = {
    Green: 'green',
    Red: 'red'
} as const;

export type ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeHighlightColorEnum = typeof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeHighlightColorEnum[keyof typeof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeHighlightColorEnum];

/**
 * 
 * @export
 * @interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor
 */
export interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor {
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeAuthor
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillHistoryInner
 */
export interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillHistoryInner
     */
    'ActionDate': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillHistoryInner
     */
    'Description': string;
}
/**
 * 
 * @export
 * @interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner
 */
export interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner {
    /**
     * 
     * @type {GetSubjects200ResponseInner}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner
     */
    'Subject': GetSubjects200ResponseInner;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner
     */
    'SubjectCode': number;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillSubjectsInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillVersionsInner
 */
export interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillVersionsInner {
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeBillVersionsInner
     */
    'BillVersionId': string;
}
/**
 * 
 * @export
 * @interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner
 */
export interface ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner {
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner
     */
    'SponsorOrder': number;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner
     */
    'SponsorType': number;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadBillListSelectArgsTypeSponsorsInner
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
 */
export interface ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue {
    /**
     * 
     * @type {ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'Author': ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'Status': number;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'Number': string;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'AuthorId': number;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'FiledDate': string;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'LegiscanBillId': number;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'LegiscanUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'StateUrl': string;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'Completed': number;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'StatusDate': string;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'StateId': number;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'BodyId': number;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'CurrentBodyId': number;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'Body': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'CurrentBody': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'LastAction': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrue
     */
    'LastActionDate': string;
}
/**
 * 
 * @export
 * @interface ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor
 */
export interface ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor {
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface ExternalAIReportRequest
 */
export interface ExternalAIReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ExternalAIReportRequest
     */
    'accountId': number;
    /**
     * 
     * @type {number}
     * @memberof ExternalAIReportRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalAIReportRequest
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof ExternalAIReportRequest
     */
    'billVersionId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExternalAIReportRequest
     */
    'selectedSections': Array<string>;
}
/**
 * 
 * @export
 * @interface ExtraCalendarEventDto
 */
export interface ExtraCalendarEventDto {
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'status': ExtraCalendarEventDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'eventType': string;
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'state': string;
    /**
     * 
     * @type {number}
     * @memberof ExtraCalendarEventDto
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExtraCalendarEventDto
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExtraCalendarEventDto
     */
    'committeeId'?: number;
    /**
     * 
     * @type {Array<CalendarBillInfo>}
     * @memberof ExtraCalendarEventDto
     */
    'bills'?: Array<CalendarBillInfo>;
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtraCalendarEventDto
     */
    'eventTime'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtraCalendarEventDto
     */
    'trackingUsers'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ExtraCalendarEventDto
     */
    'trackerCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExtraCalendarEventDto
     */
    'isCurrentUserTracking'?: boolean;
    /**
     * 
     * @type {Array<CommitteeMemberInfo>}
     * @memberof ExtraCalendarEventDto
     */
    'committeeMembers'?: Array<CommitteeMemberInfo>;
}

export const ExtraCalendarEventDtoStatusEnum = {
    Passed: 'Passed',
    New: 'New',
    Hearing: 'Hearing',
    Amended: 'Amended',
    Failed: 'Failed'
} as const;

export type ExtraCalendarEventDtoStatusEnum = typeof ExtraCalendarEventDtoStatusEnum[keyof typeof ExtraCalendarEventDtoStatusEnum];

/**
 * 
 * @export
 * @interface FileItem
 */
export interface FileItem {
    /**
     * 
     * @type {number}
     * @memberof FileItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'type': FileItemTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileItem
     */
    'size': number | null;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'modified': string;
    /**
     * 
     * @type {number}
     * @memberof FileItem
     */
    'companyId': number | null;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'companyName': string | null;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'masterBillId': string | null;
    /**
     * 
     * @type {number}
     * @memberof FileItem
     */
    'videoId': number | null;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'videoMetadata': string | null;
    /**
     * 
     * @type {string}
     * @memberof FileItem
     */
    'color': string | null;
    /**
     * 
     * @type {FileItemBill}
     * @memberof FileItem
     */
    'bill': FileItemBill | null;
    /**
     * 
     * @type {FileItemVideo}
     * @memberof FileItem
     */
    'video': FileItemVideo | null;
}

export const FileItemTypeEnum = {
    File: 'file',
    Folder: 'folder'
} as const;

export type FileItemTypeEnum = typeof FileItemTypeEnum[keyof typeof FileItemTypeEnum];

/**
 * 
 * @export
 * @interface FileItemBill
 */
export interface FileItemBill {
    /**
     * 
     * @type {string}
     * @memberof FileItemBill
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof FileItemBill
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof FileItemBill
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof FileItemBill
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof FileItemBill
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof FileItemBill
     */
    'masterBillId': string;
}
/**
 * 
 * @export
 * @interface FileItemVideo
 */
export interface FileItemVideo {
    /**
     * 
     * @type {string}
     * @memberof FileItemVideo
     */
    'stateCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof FileItemVideo
     */
    'date': string | null;
    /**
     * 
     * @type {string}
     * @memberof FileItemVideo
     */
    'committee': string | null;
    /**
     * 
     * @type {number}
     * @memberof FileItemVideo
     */
    'videoId': number;
}
/**
 * 
 * @export
 * @interface FirmAnalyticsResponse
 */
export interface FirmAnalyticsResponse {
    /**
     * 
     * @type {FirmAnalyticsResponseTotals}
     * @memberof FirmAnalyticsResponse
     */
    'totals': FirmAnalyticsResponseTotals;
    /**
     * 
     * @type {Array<FirmTopRecord>}
     * @memberof FirmAnalyticsResponse
     */
    'topByContributions': Array<FirmTopRecord>;
    /**
     * 
     * @type {Array<FirmTopRecord>}
     * @memberof FirmAnalyticsResponse
     */
    'topByLobbyists': Array<FirmTopRecord>;
    /**
     * 
     * @type {Array<FirmTopRecord>}
     * @memberof FirmAnalyticsResponse
     */
    'topByClients': Array<FirmTopRecord>;
}
/**
 * 
 * @export
 * @interface FirmAnalyticsResponseTotals
 */
export interface FirmAnalyticsResponseTotals {
    /**
     * 
     * @type {number}
     * @memberof FirmAnalyticsResponseTotals
     */
    'totalContributionAmount': number;
    /**
     * 
     * @type {number}
     * @memberof FirmAnalyticsResponseTotals
     */
    'contributions': number;
    /**
     * 
     * @type {number}
     * @memberof FirmAnalyticsResponseTotals
     */
    'firms': number;
}
/**
 * 
 * @export
 * @interface FirmTopRecord
 */
export interface FirmTopRecord {
    /**
     * 
     * @type {number}
     * @memberof FirmTopRecord
     */
    'firmId': number;
    /**
     * 
     * @type {string}
     * @memberof FirmTopRecord
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof FirmTopRecord
     */
    'totalContributions'?: number;
    /**
     * 
     * @type {number}
     * @memberof FirmTopRecord
     */
    'lobbyistsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof FirmTopRecord
     */
    'clientsTotal'?: number;
}
/**
 * 
 * @export
 * @interface FixCompanySummary200Response
 */
export interface FixCompanySummary200Response {
    /**
     * 
     * @type {string}
     * @memberof FixCompanySummary200Response
     */
    'newSummary'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FixCompanySummary200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface ForgotPassword200Response
 */
export interface ForgotPassword200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ForgotPassword200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface ForgotPasswordRequest
 */
export interface ForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    'usernameOrEmail': string;
}
/**
 * 
 * @export
 * @interface ForwardBillToLobbyistRequest
 */
export interface ForwardBillToLobbyistRequest {
    /**
     * 
     * @type {string}
     * @memberof ForwardBillToLobbyistRequest
     */
    'billId': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ForwardBillToLobbyistRequest
     */
    'lobbyistUserIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ForwardBillToLobbyistRequest
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ForwardClipToPortalRequest
 */
export interface ForwardClipToPortalRequest {
    /**
     * 
     * @type {string}
     * @memberof ForwardClipToPortalRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ForwardClipToPortalRequest
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ForwardClipToPortalRequest
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface GenerateCompanySummaryRequest
 */
export interface GenerateCompanySummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof GenerateCompanySummaryRequest
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface GenerateKeywordsRequest
 */
export interface GenerateKeywordsRequest {
    /**
     * The description or summary of the entity
     * @type {string}
     * @memberof GenerateKeywordsRequest
     */
    'description'?: string;
    /**
     * Optional array of companies to process in parallel
     * @type {Array<KeywordGenerationCompanyInput>}
     * @memberof GenerateKeywordsRequest
     */
    'companies'?: Array<KeywordGenerationCompanyInput>;
}
/**
 * 
 * @export
 * @interface GenerateKeywordsResponse
 */
export interface GenerateKeywordsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GenerateKeywordsResponse
     */
    'keywords': Array<string>;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: Array<string>; }}
     * @memberof GenerateKeywordsResponse
     */
    'keywordsByCompany'?: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface GenerateSegmentSummaryRequest
 */
export interface GenerateSegmentSummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof GenerateSegmentSummaryRequest
     */
    'startTime': number;
    /**
     * 
     * @type {number}
     * @memberof GenerateSegmentSummaryRequest
     */
    'endTime': number;
    /**
     * 
     * @type {number}
     * @memberof GenerateSegmentSummaryRequest
     */
    'companyId'?: number | null;
}
/**
 * 
 * @export
 * @interface GenerateSubjectsRequest
 */
export interface GenerateSubjectsRequest {
    /**
     * The description or summary of the entity
     * @type {string}
     * @memberof GenerateSubjectsRequest
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface GenerateSubjectsResponse
 */
export interface GenerateSubjectsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GenerateSubjectsResponse
     */
    'subjects': Array<string>;
}
/**
 * 
 * @export
 * @interface GenerateTagContext200Response
 */
export interface GenerateTagContext200Response {
    /**
     * 
     * @type {string}
     * @memberof GenerateTagContext200Response
     */
    'context': string;
}
/**
 * 
 * @export
 * @interface GenerateTagsForCompany200Response
 */
export interface GenerateTagsForCompany200Response {
    /**
     * 
     * @type {Array<GenerateTagsForCompany200ResponseSuggestedTagsInner>}
     * @memberof GenerateTagsForCompany200Response
     */
    'suggestedTags': Array<GenerateTagsForCompany200ResponseSuggestedTagsInner>;
}
/**
 * 
 * @export
 * @interface GenerateTagsForCompany200ResponseSuggestedTagsInner
 */
export interface GenerateTagsForCompany200ResponseSuggestedTagsInner {
    /**
     * 
     * @type {string}
     * @memberof GenerateTagsForCompany200ResponseSuggestedTagsInner
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof GenerateTagsForCompany200ResponseSuggestedTagsInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GenerateTagsForCompany200ResponseSuggestedTagsInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GenerateTagsForCompanyRequest
 */
export interface GenerateTagsForCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateTagsForCompanyRequest
     */
    'companySummary': string;
    /**
     * 
     * @type {string}
     * @memberof GenerateTagsForCompanyRequest
     */
    'companyName': string;
    /**
     * 
     * @type {number}
     * @memberof GenerateTagsForCompanyRequest
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface GenerateTagsRequest
 */
export interface GenerateTagsRequest {
    /**
     * The keywords related to the entity
     * @type {string}
     * @memberof GenerateTagsRequest
     */
    'keywords': string;
    /**
     * The description of the company
     * @type {string}
     * @memberof GenerateTagsRequest
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface GenerateTagsResponse
 */
export interface GenerateTagsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GenerateTagsResponse
     */
    'tags': Array<string>;
}
/**
 * 
 * @export
 * @interface GenerateTrackedActivityReportsBatch200Response
 */
export interface GenerateTrackedActivityReportsBatch200Response {
    /**
     * 
     * @type {number}
     * @memberof GenerateTrackedActivityReportsBatch200Response
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof GenerateTrackedActivityReportsBatch200Response
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof GenerateTrackedActivityReportsBatch200Response
     */
    'processed': number;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateTrackedActivityReportsBatch200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface GetAccount200Response
 */
export interface GetAccount200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'ClientCrm': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'CompanyLogo': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'UseHistoricalTraining': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'StripeCurrentPeriodEnd': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'StripeSubscriptionStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'StripeSubscriptionId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'StripeCustomerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'AIStrength': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'CommitteeAgentEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'AutoTrackAvailable': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'PortalPassword': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'PortalSettings': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'PortalEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'Subdomain': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'Regulatory': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'VideoOptInDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'Live': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'VideoOnly': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'AutoTrackEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'AutoTrack': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'AnalystPortal': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'LobbyistPortal': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAccount200Response
     */
    'FirmId': number;
    /**
     * 
     * @type {number}
     * @memberof GetAccount200Response
     */
    'CompanyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetAccount200Response
     */
    'SeatsUsed': number;
    /**
     * 
     * @type {number}
     * @memberof GetAccount200Response
     */
    'TotalSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    'NewAccount': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAccount200Response
     */
    'PlanId': number;
    /**
     * 
     * @type {number}
     * @memberof GetAccount200Response
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccount200Response
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200Response
 */
export interface GetAccountLobbyist200Response {
    /**
     * 
     * @type {Array<GetAccountLobbyist200ResponseContributionsInner>}
     * @memberof GetAccountLobbyist200Response
     */
    'contributions': Array<GetAccountLobbyist200ResponseContributionsInner>;
    /**
     * 
     * @type {GetAccountLobbyist200ResponseLobbyistDetails}
     * @memberof GetAccountLobbyist200Response
     */
    'lobbyistDetails': GetAccountLobbyist200ResponseLobbyistDetails;
    /**
     * 
     * @type {Array<GetAccountLobbyist200ResponseContactRelationshipsInner>}
     * @memberof GetAccountLobbyist200Response
     */
    'contactRelationships': Array<GetAccountLobbyist200ResponseContactRelationshipsInner>;
    /**
     * 
     * @type {Array<GetAccountLobbyist200ResponseTestimoniesInner>}
     * @memberof GetAccountLobbyist200Response
     */
    'testimonies': Array<GetAccountLobbyist200ResponseTestimoniesInner>;
    /**
     * 
     * @type {Array<GetAccountLobbyist200ResponseTagsInner>}
     * @memberof GetAccountLobbyist200Response
     */
    'tags': Array<GetAccountLobbyist200ResponseTagsInner>;
    /**
     * 
     * @type {GetAccountLobbyist200ResponseUser}
     * @memberof GetAccountLobbyist200Response
     */
    'user': GetAccountLobbyist200ResponseUser;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseContactRelationshipsInner
 */
export interface GetAccountLobbyist200ResponseContactRelationshipsInner {
    /**
     * 
     * @type {GetAccountLobbyist200ResponseContributionsInnerLegislator}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'legislator': GetAccountLobbyist200ResponseContributionsInnerLegislator;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'notes': string;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'strength': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'relationshipType': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'sessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'memberId': number;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseContactRelationshipsInner
     */
    'contactRelationshipId': number;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseContributionsInner
 */
export interface GetAccountLobbyist200ResponseContributionsInner {
    /**
     * 
     * @type {GetAccountLobbyist200ResponseContributionsInnerLegislator}
     * @memberof GetAccountLobbyist200ResponseContributionsInner
     */
    'legislator'?: GetAccountLobbyist200ResponseContributionsInnerLegislator;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseContributionsInner
     */
    'memberId': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInner
     */
    'recipient': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInner
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInner
     */
    'amount': string;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseContributionsInner
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseContributionsInnerLegislator
 */
export interface GetAccountLobbyist200ResponseContributionsInnerLegislator {
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInnerLegislator
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInnerLegislator
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInnerLegislator
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInnerLegislator
     */
    'party': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInnerLegislator
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseContributionsInnerLegislator
     */
    'firstName': string;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseLobbyistDetails
 */
export interface GetAccountLobbyist200ResponseLobbyistDetails {
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistBusiness': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistState': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistFullName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistMiddleName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistTitle': string;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseLobbyistDetails
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseTagsInner
 */
export interface GetAccountLobbyist200ResponseTagsInner {
    /**
     * 
     * @type {Array<GetAccountLobbyist200ResponseTagsInnerBillsInner>}
     * @memberof GetAccountLobbyist200ResponseTagsInner
     */
    'bills': Array<GetAccountLobbyist200ResponseTagsInnerBillsInner>;
    /**
     * 
     * @type {GetAccountLobbyist200ResponseTagsInnerTag}
     * @memberof GetAccountLobbyist200ResponseTagsInner
     */
    'tag': GetAccountLobbyist200ResponseTagsInnerTag;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseTagsInnerBillsInner
 */
export interface GetAccountLobbyist200ResponseTagsInnerBillsInner {
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseTagsInnerBillsInner
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTagsInnerBillsInner
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTagsInnerBillsInner
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTagsInnerBillsInner
     */
    'assignedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTagsInnerBillsInner
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTagsInnerBillsInner
     */
    'billId': string;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseTagsInnerTag
 */
export interface GetAccountLobbyist200ResponseTagsInnerTag {
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseTagsInnerTag
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTagsInnerTag
     */
    'Color': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTagsInnerTag
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseTestimoniesInner
 */
export interface GetAccountLobbyist200ResponseTestimoniesInner {
    /**
     * 
     * @type {GetAccountLobbyist200ResponseTestimoniesInnerCommittee}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInner
     */
    'committee': GetAccountLobbyist200ResponseTestimoniesInnerCommittee;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInner
     */
    'organization': string;
    /**
     * 
     * @type {GetAccountLobbyist200ResponseTestimoniesInnerBill}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInner
     */
    'bill': GetAccountLobbyist200ResponseTestimoniesInnerBill;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInner
     */
    'position': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInner
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInner
     */
    'testimonyId': number;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseTestimoniesInnerBill
 */
export interface GetAccountLobbyist200ResponseTestimoniesInnerBill {
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInnerBill
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInnerBill
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseTestimoniesInnerCommittee
 */
export interface GetAccountLobbyist200ResponseTestimoniesInnerCommittee {
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseTestimoniesInnerCommittee
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyist200ResponseUser
 */
export interface GetAccountLobbyist200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyist200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyist200ResponseUser
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetAccountLobbyistUsers200ResponseInner
 */
export interface GetAccountLobbyistUsers200ResponseInner {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAccountLobbyistUsers200ResponseInner
     */
    'stateCodes': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyistUsers200ResponseInner
     */
    'lobbyistId': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyistUsers200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountLobbyistUsers200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetAccountLobbyistUsers200ResponseInner
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface GetAccountUsers200Response
 */
export interface GetAccountUsers200Response {
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof GetAccountUsers200Response
     */
    'pagination': GetStaff200ResponsePagination;
    /**
     * 
     * @type {Array<GetAccountUsers200ResponseDataInner>}
     * @memberof GetAccountUsers200Response
     */
    'data': Array<GetAccountUsers200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetAccountUsers200ResponseDataInner
 */
export interface GetAccountUsers200ResponseDataInner {
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'CanViewAutoTrackedBills': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'CanViewTrackedActivityReport': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'LastLogin': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'Username': string;
    /**
     * 
     * @type {number}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'Email': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'IsLobbyist': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'AnalystRole': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'IsAnalyst': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'FullAccountRole': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'FullAccount': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'AccountId': number;
    /**
     * 
     * @type {number}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'RelationshipId': number;
    /**
     * 
     * @type {string}
     * @memberof GetAccountUsers200ResponseDataInner
     */
    'Status': string;
}
/**
 * 
 * @export
 * @interface GetActivityCount200Response
 */
export interface GetActivityCount200Response {
    /**
     * 
     * @type {ActivityType}
     * @memberof GetActivityCount200Response
     */
    'activityType': ActivityType;
    /**
     * 
     * @type {number}
     * @memberof GetActivityCount200Response
     */
    'count': number;
}


/**
 * 
 * @export
 * @interface GetActivityHistory200ResponseInner
 */
export interface GetActivityHistory200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetActivityHistory200ResponseInner
     */
    'dau': number;
    /**
     * 
     * @type {string}
     * @memberof GetActivityHistory200ResponseInner
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface GetAdvancedSearch200Response
 */
export interface GetAdvancedSearch200Response {
    /**
     * 
     * @type {string}
     * @memberof GetAdvancedSearch200Response
     */
    'fileUrl': string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetAdvancedSearch200Response
     */
    'data': Array<any>;
}
/**
 * 
 * @export
 * @interface GetAnalystMetrics200ResponseInner
 */
export interface GetAnalystMetrics200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'averageCompletionTime': number;
    /**
     * 
     * @type {number}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'overdueTasks': number;
    /**
     * 
     * @type {number}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'onHoldCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'inProgressCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'completedCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'assignedCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'firstName': string;
    /**
     * 
     * @type {number}
     * @memberof GetAnalystMetrics200ResponseInner
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface GetAnalysts200ResponseInner
 */
export interface GetAnalysts200ResponseInner {
    /**
     * 
     * @type {Array<GetUser200ResponseUserStatesInner>}
     * @memberof GetAnalysts200ResponseInner
     */
    'UserStates': Array<GetUser200ResponseUserStatesInner>;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysts200ResponseInner
     */
    'Username': string;
    /**
     * 
     * @type {number}
     * @memberof GetAnalysts200ResponseInner
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysts200ResponseInner
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysts200ResponseInner
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysts200ResponseInner
     */
    'Email': string;
}
/**
 * 
 * @export
 * @interface GetAutoTrackAvailability200Response
 */
export interface GetAutoTrackAvailability200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetAutoTrackAvailability200Response
     */
    'hasAutoTrack': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAutoTrackAvailability200Response
     */
    'hasTag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAutoTrackAvailability200Response
     */
    'hasCompanyKeywords': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAutoTrackAvailability200Response
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @interface GetBatchSessionsRequest
 */
export interface GetBatchSessionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBatchSessionsRequest
     */
    'stateCodes': Array<string>;
}
/**
 * 
 * @export
 * @interface GetBill200Response
 */
export interface GetBill200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBill200Response
     */
    'committee': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBill200Response
     */
    'lastAction': string | null;
    /**
     * 
     * @type {GetBill200ResponseBill}
     * @memberof GetBill200Response
     */
    'bill': GetBill200ResponseBill;
}
/**
 * 
 * @export
 * @interface GetBill200ResponseBill
 */
export interface GetBill200ResponseBill {
    /**
     * 
     * @type {ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor}
     * @memberof GetBill200ResponseBill
     */
    'Author': ExpandPrismaMasterBillsGetPayloadInclude58Author58Select58MemberIdTrueNameTrueFirstNameTrueLastNameTruePartyTrueAuthor;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBill
     */
    'Status': number;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'Number': string;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBill
     */
    'AuthorId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'FiledDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBill
     */
    'LegiscanBillId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'LegiscanUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'StateUrl': string;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBill
     */
    'Completed': number;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'StatusDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBill
     */
    'StateId': number;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBill
     */
    'BodyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBill
     */
    'CurrentBodyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'Body': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'CurrentBody': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'LastAction': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'LastActionDate': string;
    /**
     * 
     * @type {Array<GetBill200ResponseBillAllOfCosponsorsInner>}
     * @memberof GetBill200ResponseBill
     */
    'cosponsors': Array<GetBill200ResponseBillAllOfCosponsorsInner>;
    /**
     * 
     * @type {Array<GetBill200ResponseBillAllOfAuthorsInner>}
     * @memberof GetBill200ResponseBill
     */
    'authors': Array<GetBill200ResponseBillAllOfAuthorsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBill
     */
    'aiSummary'?: string;
}
/**
 * 
 * @export
 * @interface GetBill200ResponseBillAllOfAuthorsInner
 */
export interface GetBill200ResponseBillAllOfAuthorsInner {
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBillAllOfAuthorsInner
     */
    'party': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBillAllOfAuthorsInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBillAllOfAuthorsInner
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetBill200ResponseBillAllOfCosponsorsInner
 */
export interface GetBill200ResponseBillAllOfCosponsorsInner {
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBillAllOfCosponsorsInner
     */
    'party': string;
    /**
     * 
     * @type {string}
     * @memberof GetBill200ResponseBillAllOfCosponsorsInner
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetBill200ResponseBillAllOfCosponsorsInner
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetBillAiSummary200Response
 */
export interface GetBillAiSummary200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBillAiSummary200Response
     */
    'summary': string;
}
/**
 * 
 * @export
 * @interface GetBillComments200Response
 */
export interface GetBillComments200Response {
    /**
     * 
     * @type {Array<GetBillComments200ResponseCommentsInner>}
     * @memberof GetBillComments200Response
     */
    'comments': Array<GetBillComments200ResponseCommentsInner>;
}
/**
 * 
 * @export
 * @interface GetBillComments200ResponseCommentsInner
 */
export interface GetBillComments200ResponseCommentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetBillComments200ResponseCommentsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillComments200ResponseCommentsInner
     */
    'User': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillComments200ResponseCommentsInner
     */
    'Comment': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillComments200ResponseCommentsInner
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface GetBillCompanions200Response
 */
export interface GetBillCompanions200Response {
    /**
     * 
     * @type {Array<GetBillCompanions200ResponseEnablingInner>}
     * @memberof GetBillCompanions200Response
     */
    'enabling': Array<GetBillCompanions200ResponseEnablingInner>;
    /**
     * 
     * @type {Array<GetBillCompanions200ResponseEnablingInner>}
     * @memberof GetBillCompanions200Response
     */
    'similar': Array<GetBillCompanions200ResponseEnablingInner>;
    /**
     * 
     * @type {Array<GetBillCompanions200ResponseEnablingInner>}
     * @memberof GetBillCompanions200Response
     */
    'identical': Array<GetBillCompanions200ResponseEnablingInner>;
}
/**
 * 
 * @export
 * @interface GetBillCompanions200ResponseEnablingInner
 */
export interface GetBillCompanions200ResponseEnablingInner {
    /**
     * 
     * @type {GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills}
     * @memberof GetBillCompanions200ResponseEnablingInner
     */
    'MasterBills_BillCompanions_CompanionToMasterBills': GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills;
    /**
     * 
     * @type {string}
     * @memberof GetBillCompanions200ResponseEnablingInner
     */
    'Companion': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillCompanions200ResponseEnablingInner
     */
    'PrimaryBill': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillCompanions200ResponseEnablingInner
     */
    'Type': string;
}
/**
 * 
 * @export
 * @interface GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills
 */
export interface GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills {
    /**
     * 
     * @type {string}
     * @memberof GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills
     */
    'CurrentBody': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillCompanions200ResponseEnablingInnerMasterBillsBillCompanionsCompanionToMasterBills
     */
    'MasterBillId': string;
}
/**
 * 
 * @export
 * @interface GetBillComparisonAi200Response
 */
export interface GetBillComparisonAi200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBillComparisonAi200Response
     */
    'aiResponse': string;
}
/**
 * 
 * @export
 * @interface GetBillComparisonRequest
 */
export interface GetBillComparisonRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBillComparisonRequest
     */
    'billIds': Array<string>;
}
/**
 * 
 * @export
 * @interface GetBillComparisonResponse
 */
export interface GetBillComparisonResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBillComparisonResponse
     */
    'comparisonId': string;
    /**
     * 
     * @type {GetBillComparisonResponseJsonData}
     * @memberof GetBillComparisonResponse
     */
    'jsonData': GetBillComparisonResponseJsonData;
    /**
     * 
     * @type {number}
     * @memberof GetBillComparisonResponse
     */
    'totalTokenCount': number;
}
/**
 * 
 * @export
 * @interface GetBillComparisonResponseJsonData
 */
export interface GetBillComparisonResponseJsonData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBillComparisonResponseJsonData
     */
    'originalText': Array<string>;
    /**
     * 
     * @type {Array<GetBillComparisonResponseJsonDataUnmatchedToInner>}
     * @memberof GetBillComparisonResponseJsonData
     */
    'unmatchedTo': Array<GetBillComparisonResponseJsonDataUnmatchedToInner>;
    /**
     * 
     * @type {Array<GetBillComparisonResponseJsonDataUnmatchedToInner>}
     * @memberof GetBillComparisonResponseJsonData
     */
    'unmatchedFrom': Array<GetBillComparisonResponseJsonDataUnmatchedToInner>;
    /**
     * 
     * @type {Array<GetBillComparisonResponseJsonDataSectionsInner>}
     * @memberof GetBillComparisonResponseJsonData
     */
    'sections': Array<GetBillComparisonResponseJsonDataSectionsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetBillComparisonResponseJsonData
     */
    'aiResponse': string;
}
/**
 * 
 * @export
 * @interface GetBillComparisonResponseJsonDataSectionsInner
 */
export interface GetBillComparisonResponseJsonDataSectionsInner {
    /**
     * 
     * @type {number}
     * @memberof GetBillComparisonResponseJsonDataSectionsInner
     */
    'score': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillComparisonResponseJsonDataSectionsInner
     */
    'toIndex': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillComparisonResponseJsonDataSectionsInner
     */
    'fromIndex': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBillComparisonResponseJsonDataSectionsInner
     */
    'diff': Array<string>;
}
/**
 * 
 * @export
 * @interface GetBillComparisonResponseJsonDataUnmatchedToInner
 */
export interface GetBillComparisonResponseJsonDataUnmatchedToInner {
    /**
     * 
     * @type {number}
     * @memberof GetBillComparisonResponseJsonDataUnmatchedToInner
     */
    'index': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillComparisonResponseJsonDataUnmatchedToInner
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface GetBillDownloadUrl200Response
 */
export interface GetBillDownloadUrl200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBillDownloadUrl200Response
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillDownloadUrl200Response
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface GetBillHistory200Response
 */
export interface GetBillHistory200Response {
    /**
     * 
     * @type {Array<SyntheticHistoryItemDto>}
     * @memberof GetBillHistory200Response
     */
    'syntheticHistory': Array<SyntheticHistoryItemDto>;
    /**
     * 
     * @type {Array<GetBillHistory200ResponseBillHistoryInner>}
     * @memberof GetBillHistory200Response
     */
    'billHistory': Array<GetBillHistory200ResponseBillHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetBillHistory200ResponseBillHistoryInner
 */
export interface GetBillHistory200ResponseBillHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'StateSession': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'ActionEntryDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'Importance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'Percentage': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'ActionDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'ActionCode': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillHistory200ResponseBillHistoryInner
     */
    'chamber': string;
}
/**
 * 
 * @export
 * @interface GetBillPriorityImpact200Response
 */
export interface GetBillPriorityImpact200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBillPriorityImpact200Response
     */
    'impact': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBillPriorityImpact200Response
     */
    'priority': string | null;
}
/**
 * 
 * @export
 * @interface GetBillRemarks200ResponseInner
 */
export interface GetBillRemarks200ResponseInner {
    /**
     * 
     * @type {Array<GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner>}
     * @memberof GetBillRemarks200ResponseInner
     */
    'RemarkDocuments': Array<GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner>;
    /**
     * 
     * @type {GetBillTestimony200ResponseInnerWitness}
     * @memberof GetBillRemarks200ResponseInner
     */
    'User': GetBillTestimony200ResponseInnerWitness;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInner
     */
    'RelatedId': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillRemarks200ResponseInner
     */
    'Type': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetBillRemarks200ResponseInner
     */
    'Tags': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof GetBillRemarks200ResponseInner
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInner
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillRemarks200ResponseInner
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillRemarks200ResponseInner
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillRemarks200ResponseInner
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner
 */
export interface GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner {
    /**
     * 
     * @type {number}
     * @memberof GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner
     */
    'UploadedByUserId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner
     */
    'FileType': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner
     */
    'FileName': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner
     */
    'FileSize': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillRemarks200ResponseInnerAllOfRemarkDocumentsInner
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface GetBillSimilarAi200Response
 */
export interface GetBillSimilarAi200Response {
    /**
     * 
     * @type {Array<RelatedBillDto>}
     * @memberof GetBillSimilarAi200Response
     */
    'bills': Array<RelatedBillDto>;
}
/**
 * 
 * @export
 * @interface GetBillStatutes200Response
 */
export interface GetBillStatutes200Response {
    /**
     * 
     * @type {Array<GetBillStatutes200ResponseAllInner>}
     * @memberof GetBillStatutes200Response
     */
    'all': Array<GetBillStatutes200ResponseAllInner>;
    /**
     * 
     * @type {Array<GetBillStatutes200ResponseAllInner>}
     * @memberof GetBillStatutes200Response
     */
    'repealed': Array<GetBillStatutes200ResponseAllInner>;
    /**
     * 
     * @type {Array<GetBillStatutes200ResponseAllInner>}
     * @memberof GetBillStatutes200Response
     */
    'new': Array<GetBillStatutes200ResponseAllInner>;
    /**
     * 
     * @type {Array<GetBillStatutes200ResponseAllInner>}
     * @memberof GetBillStatutes200Response
     */
    'modified': Array<GetBillStatutes200ResponseAllInner>;
}
/**
 * 
 * @export
 * @interface GetBillStatutes200ResponseAllInner
 */
export interface GetBillStatutes200ResponseAllInner {
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'StatutoryAct': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'StatutoryReference': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'StatutoryCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'Version': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'BillVersionId': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'Number': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillStatutes200ResponseAllInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetBillSubjects200ResponseInner
 */
export interface GetBillSubjects200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetBillSubjects200ResponseInner
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillSubjects200ResponseInner
     */
    'Code': number;
}
/**
 * 
 * @export
 * @interface GetBillSupportingDocuments200Response
 */
export interface GetBillSupportingDocuments200Response {
    /**
     * 
     * @type {Array<BillSupportingDocumentDto>}
     * @memberof GetBillSupportingDocuments200Response
     */
    'documents': Array<BillSupportingDocumentDto>;
}
/**
 * 
 * @export
 * @interface GetBillTags200ResponseInner
 */
export interface GetBillTags200ResponseInner {
    /**
     * 
     * @type {CreateTag200Response}
     * @memberof GetBillTags200ResponseInner
     */
    'Tag': CreateTag200Response;
    /**
     * 
     * @type {boolean}
     * @memberof GetBillTags200ResponseInner
     */
    'Active': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBillTags200ResponseInner
     */
    'RejectedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTags200ResponseInner
     */
    'RejectedReasoning': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBillTags200ResponseInner
     */
    'Rejected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBillTags200ResponseInner
     */
    'Sorted': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetBillTags200ResponseInner
     */
    'Relevancy': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetBillTags200ResponseInner
     */
    'AutoTracked': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBillTags200ResponseInner
     */
    'Impact': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTags200ResponseInner
     */
    'AssignedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillTags200ResponseInner
     */
    'BillTagId': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillTags200ResponseInner
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillTags200ResponseInner
     */
    'BillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTags200ResponseInner
     */
    'Priority': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTags200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillTags200ResponseInner
     */
    'AccountId': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillTags200ResponseInner
     */
    'UserId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillTags200ResponseInner
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillTags200ResponseInner
     */
    'Position': number;
}
/**
 * 
 * @export
 * @interface GetBillTestimony200ResponseInner
 */
export interface GetBillTestimony200ResponseInner {
    /**
     * 
     * @type {GetBillTestimony200ResponseInnerWitness}
     * @memberof GetBillTestimony200ResponseInner
     */
    'Witness': GetBillTestimony200ResponseInnerWitness;
    /**
     * 
     * @type {GetBillTestimony200ResponseInnerLobbyist}
     * @memberof GetBillTestimony200ResponseInner
     */
    'Lobbyist': GetBillTestimony200ResponseInnerLobbyist;
    /**
     * 
     * @type {GetBillTestimony200ResponseInnerCompany}
     * @memberof GetBillTestimony200ResponseInner
     */
    'Company': GetBillTestimony200ResponseInnerCompany;
    /**
     * 
     * @type {GetCompanyTestimony200ResponseInnerCommitteeSession}
     * @memberof GetBillTestimony200ResponseInner
     */
    'CommitteeSession': GetCompanyTestimony200ResponseInnerCommitteeSession;
    /**
     * 
     * @type {number}
     * @memberof GetBillTestimony200ResponseInner
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'EndTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'StartTime': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillTestimony200ResponseInner
     */
    'HearingId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'Organization': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillTestimony200ResponseInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillTestimony200ResponseInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'TestimonyDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillTestimony200ResponseInner
     */
    'BillSupportingDocumentsId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillTestimony200ResponseInner
     */
    'WitnessId': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillTestimony200ResponseInner
     */
    'TestimonyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillTestimony200ResponseInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInner
     */
    'Position': string;
}
/**
 * 
 * @export
 * @interface GetBillTestimony200ResponseInnerCompany
 */
export interface GetBillTestimony200ResponseInnerCompany {
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInnerCompany
     */
    'CompanyName': string;
}
/**
 * 
 * @export
 * @interface GetBillTestimony200ResponseInnerLobbyist
 */
export interface GetBillTestimony200ResponseInnerLobbyist {
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInnerLobbyist
     */
    'LobbyistLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInnerLobbyist
     */
    'LobbyistFirstName': string;
}
/**
 * 
 * @export
 * @interface GetBillTestimony200ResponseInnerWitness
 */
export interface GetBillTestimony200ResponseInnerWitness {
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInnerWitness
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillTestimony200ResponseInnerWitness
     */
    'FirstName': string;
}
/**
 * 
 * @export
 * @interface GetBillText200Response
 */
export interface GetBillText200Response {
    /**
     * 
     * @type {number}
     * @memberof GetBillText200Response
     */
    'TextType': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillText200Response
     */
    'BillVersionId': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillText200Response
     */
    'VersionNumber': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillText200Response
     */
    'TextUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillText200Response
     */
    'TextDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillText200Response
     */
    'TextVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillText200Response
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface GetBillVersions200ResponseInner
 */
export interface GetBillVersions200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetBillVersions200ResponseInner
     */
    'TextType': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillVersions200ResponseInner
     */
    'BillVersionId': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillVersions200ResponseInner
     */
    'VersionNumber': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillVersions200ResponseInner
     */
    'TextUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillVersions200ResponseInner
     */
    'MimeType': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillVersions200ResponseInner
     */
    'TextDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillVersions200ResponseInner
     */
    'TextVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillVersions200ResponseInner
     */
    'Description': string;
}
/**
 * 
 * @export
 * @interface GetBillVotes200ResponseInner
 */
export interface GetBillVotes200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetBillVotes200ResponseInner
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillVotes200ResponseInner
     */
    'vacant': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillVotes200ResponseInner
     */
    'notVoting': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillVotes200ResponseInner
     */
    'abstains': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillVotes200ResponseInner
     */
    'nays': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillVotes200ResponseInner
     */
    'yeas': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillVotes200ResponseInner
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillVotes200ResponseInner
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillVotes200ResponseInner
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillVotes200ResponseInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillVotes200ResponseInner
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillVotes200ResponseInner
     */
    'voteId': number;
}
/**
 * 
 * @export
 * @interface GetBillsWithHistory200ResponseInner
 */
export interface GetBillsWithHistory200ResponseInner {
    /**
     * 
     * @type {Array<GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner>}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'BillHistory': Array<GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner>;
    /**
     * 
     * @type {Array<GetBillTags200ResponseInner>}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'UserBillTags': Array<GetBillTags200ResponseInner>;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'LastActionDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'LastAction': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'CurrentBody': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'Body': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'CurrentBodyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'BodyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'StateId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'StatusDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'Completed': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'StateUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'LegiscanUrl': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'LegiscanBillId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'FiledDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'AuthorId': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'Status': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
 */
export interface GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'StateSession': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'ActionEntryDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'Importance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'Percentage': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'ActionDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'ActionCode': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBillsWithHistory200ResponseInnerAllOfBillHistoryInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetCampaignFinance200Response
 */
export interface GetCampaignFinance200Response {
    /**
     * 
     * @type {GetLobbyists200ResponsePagination}
     * @memberof GetCampaignFinance200Response
     */
    'pagination': GetLobbyists200ResponsePagination;
    /**
     * 
     * @type {Array<ContributionDto>}
     * @memberof GetCampaignFinance200Response
     */
    'data': Array<ContributionDto>;
}
/**
 * 
 * @export
 * @interface GetCampaignFinanceFilers200ResponseInner
 */
export interface GetCampaignFinanceFilers200ResponseInner {
    /**
     * 
     * @type {GetCampaignFinanceFilers200ResponseInnerCount}
     * @memberof GetCampaignFinanceFilers200ResponseInner
     */
    '_count': GetCampaignFinanceFilers200ResponseInnerCount;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignFinanceFilers200ResponseInner
     */
    'FilerName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCampaignFinanceFilers200ResponseInner
     */
    'FilerId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCampaignFinanceFilers200ResponseInner
     */
    'State': string;
    /**
     * 
     * @type {GetCampaignFinanceFilers200ResponseInnerSum}
     * @memberof GetCampaignFinanceFilers200ResponseInner
     */
    '_sum': GetCampaignFinanceFilers200ResponseInnerSum;
}
/**
 * 
 * @export
 * @interface GetCampaignFinanceFilers200ResponseInnerCount
 */
export interface GetCampaignFinanceFilers200ResponseInnerCount {
    /**
     * 
     * @type {number}
     * @memberof GetCampaignFinanceFilers200ResponseInnerCount
     */
    'ContributionId': number;
}
/**
 * 
 * @export
 * @interface GetCampaignFinanceFilers200ResponseInnerSum
 */
export interface GetCampaignFinanceFilers200ResponseInnerSum {
    /**
     * 
     * @type {number}
     * @memberof GetCampaignFinanceFilers200ResponseInnerSum
     */
    'ContributionAmount': number;
}
/**
 * 
 * @export
 * @interface GetChatHistory200Response
 */
export interface GetChatHistory200Response {
    /**
     * 
     * @type {Array<GetChatHistory200ResponseMessagesInner>}
     * @memberof GetChatHistory200Response
     */
    'messages': Array<GetChatHistory200ResponseMessagesInner>;
}
/**
 * 
 * @export
 * @interface GetChatHistory200ResponseMessagesInner
 */
export interface GetChatHistory200ResponseMessagesInner {
    /**
     * 
     * @type {string}
     * @memberof GetChatHistory200ResponseMessagesInner
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof GetChatHistory200ResponseMessagesInner
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface GetClientBills200ResponseInner
 */
export interface GetClientBills200ResponseInner {
    /**
     * 
     * @type {GetAccountLobbyist200ResponseTagsInnerTag}
     * @memberof GetClientBills200ResponseInner
     */
    'Tag': GetAccountLobbyist200ResponseTagsInnerTag;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientBills200ResponseInner
     */
    'Sorted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientBills200ResponseInner
     */
    'AutoTracked': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInner
     */
    'AssignedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientBills200ResponseInner
     */
    'BillTagId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientBills200ResponseInner
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInner
     */
    'BillId': string;
    /**
     * 
     * @type {GetClientBills200ResponseInnerMasterBill}
     * @memberof GetClientBills200ResponseInner
     */
    'MasterBill': GetClientBills200ResponseInnerMasterBill;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientBills200ResponseInner
     */
    'UserId': number;
}
/**
 * 
 * @export
 * @interface GetClientBills200ResponseInnerMasterBill
 */
export interface GetClientBills200ResponseInnerMasterBill {
    /**
     * 
     * @type {GetClientBills200ResponseInnerMasterBillAuthor}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'Author': GetClientBills200ResponseInnerMasterBillAuthor;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'LastAction': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'StatusDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBill
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetClientBills200ResponseInnerMasterBillAuthor
 */
export interface GetClientBills200ResponseInnerMasterBillAuthor {
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBillAuthor
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBillAuthor
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientBills200ResponseInnerMasterBillAuthor
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientBills200ResponseInnerMasterBillAuthor
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface GetClientCommitteeActivity200Response
 */
export interface GetClientCommitteeActivity200Response {
    /**
     * 
     * @type {Array<GetClientDetails200ResponseCommitteeVideoSummariesInner>}
     * @memberof GetClientCommitteeActivity200Response
     */
    'summaries': Array<GetClientDetails200ResponseCommitteeVideoSummariesInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseCommitteeVideoClipsInner>}
     * @memberof GetClientCommitteeActivity200Response
     */
    'clips': Array<GetClientDetails200ResponseCommitteeVideoClipsInner>;
    /**
     * 
     * @type {Array<GetClientCommitteeActivity200ResponseTestimonyInner>}
     * @memberof GetClientCommitteeActivity200Response
     */
    'testimony': Array<GetClientCommitteeActivity200ResponseTestimonyInner>;
}
/**
 * 
 * @export
 * @interface GetClientCommitteeActivity200ResponseTestimonyInner
 */
export interface GetClientCommitteeActivity200ResponseTestimonyInner {
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'TestimonyYear': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'EndTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'StartTime': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'HearingId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'Organization': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'TestimonyDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'BillSupportingDocumentsId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'WitnessId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'TestimonyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'Position': string;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerWitness}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'Witness': GetClientDetails200ResponseCommitteeTestimoniesInnerWitness;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'CommitteeSession': GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'MasterBill': GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerCompany}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'Company': GetClientDetails200ResponseCommitteeTestimoniesInnerCompany;
    /**
     * 
     * @type {CreateLobbyist200Response}
     * @memberof GetClientCommitteeActivity200ResponseTestimonyInner
     */
    'Lobbyist': CreateLobbyist200Response;
}
/**
 * 
 * @export
 * @interface GetClientContributions200ResponseInner
 */
export interface GetClientContributions200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'Contributor': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'FilerType': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'RecipientLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'RecipientFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'SourceFileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'LoadDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'HashKey': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientContributions200ResponseInner
     */
    'CandidateId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'AggregateAmount': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'LoanAmount': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorDescription': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorOccupation': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorEmployer': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorCountry': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorCounty': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorState': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorSuffixCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorOrganization': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributorPersonTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributionAmount': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributionDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'FilerName': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientContributions200ResponseInner
     */
    'FilerId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'FormTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'ContributionId': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientContributions200ResponseInner
     */
    'Year': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientContributions200ResponseInner
     */
    'FirmId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientContributions200ResponseInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientContributions200ResponseInner
     */
    'State': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientContributions200ResponseInner
     */
    'LobbyistId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientContributions200ResponseInner
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface GetClientDetails200Response
 */
export interface GetClientDetails200Response {
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200Response
     */
    'ExpectedInterest': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200Response
     */
    'ManualCreation': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200Response
     */
    'MasterCompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyState': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyFullAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'BeneficialName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'ContractualName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200Response
     */
    'Outreach': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200Response
     */
    'CompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {GetClientDetails200ResponseClientTrackingPreferences}
     * @memberof GetClientDetails200Response
     */
    'ClientTrackingPreferences': GetClientDetails200ResponseClientTrackingPreferences;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseClientContactsInner>}
     * @memberof GetClientDetails200Response
     */
    'ClientContacts': Array<GetClientDetails200ResponseClientContactsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseFirmEngagementsInner>}
     * @memberof GetClientDetails200Response
     */
    'FirmEngagements': Array<GetClientDetails200ResponseFirmEngagementsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseLobbyEngagementsInner>}
     * @memberof GetClientDetails200Response
     */
    'LobbyEngagements': Array<GetClientDetails200ResponseLobbyEngagementsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseCommitteeVideoClipsInner>}
     * @memberof GetClientDetails200Response
     */
    'CommitteeVideoClips': Array<GetClientDetails200ResponseCommitteeVideoClipsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseCommitteeVideoSummariesInner>}
     * @memberof GetClientDetails200Response
     */
    'CommitteeVideoSummaries': Array<GetClientDetails200ResponseCommitteeVideoSummariesInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseUserStorageFilesInner>}
     * @memberof GetClientDetails200Response
     */
    'UserStorageFiles': Array<GetClientDetails200ResponseUserStorageFilesInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseClientInteractionsInner>}
     * @memberof GetClientDetails200Response
     */
    'ClientInteractions': Array<GetClientDetails200ResponseClientInteractionsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseRecentReportsInner>}
     * @memberof GetClientDetails200Response
     */
    'RecentReports': Array<GetClientDetails200ResponseRecentReportsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponsePortalsInner>}
     * @memberof GetClientDetails200Response
     */
    'Portals': Array<GetClientDetails200ResponsePortalsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'LogoUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200Response
     */
    'DoNotContact': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'FullSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200Response
     */
    'ShortSum': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200Response
     */
    'StateCompanyID': number;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseCommitteeTestimoniesInner>}
     * @memberof GetClientDetails200Response
     */
    'CommitteeTestimonies': Array<GetClientDetails200ResponseCommitteeTestimoniesInner>;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseClientContactsInner
 */
export interface GetClientDetails200ResponseClientContactsInner {
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'Zip': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'Address': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'Mobile': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'IsPrimary': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'ContactId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'LastContactDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'Department': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'CreatedByUserId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'Notes': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'State': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'City': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientContactsInner
     */
    'Phone': string;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseClientInteractionsInner
 */
export interface GetClientDetails200ResponseClientInteractionsInner {
    /**
     * 
     * @type {GetClientDetails200ResponseClientContactsInner}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'Contact': GetClientDetails200ResponseClientContactsInner;
    /**
     * 
     * @type {GetClientDetails200ResponseClientInteractionsInnerAllOfUser}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'User': GetClientDetails200ResponseClientInteractionsInnerAllOfUser;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'Subject': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'InteractionType': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'InteractionId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'InteractionDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'ContactId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'NextFollowUpDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientInteractionsInner
     */
    'UserId': number;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseClientInteractionsInnerAllOfUser
 */
export interface GetClientDetails200ResponseClientInteractionsInnerAllOfUser {
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'NewUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'CanViewAutoTrackedBills': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'CanViewTrackedActivityReport': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'LobbyistId': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'IsAnalyst': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'IsLobbyist': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'LastLogin': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'UpdatedAt': string;
    /**
     * A typed array of 8-bit unsigned integer values. The contents are initialized to 0. If the requested number of bytes could not be allocated an exception is raised.
     * @type {object}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'PasswordSalt': object;
    /**
     * A typed array of 8-bit unsigned integer values. The contents are initialized to 0. If the requested number of bytes could not be allocated an exception is raised.
     * @type {object}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'PasswordHash': object;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'Username': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'FirstName': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'RoleId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientInteractionsInnerAllOfUser
     */
    'Email': string;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseClientTrackingPreferences
 */
export interface GetClientDetails200ResponseClientTrackingPreferences {
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'UpdatedByUserId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'CustomSettings': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'AlertFrequency': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'EmailAlerts': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'TrackBills': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'TrackContributions': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'TrackTestimony': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'TrackCommittees': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'PreferenceId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'CompanyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseClientTrackingPreferences
     */
    'UpdatedAt': string;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseCommitteeTestimoniesInner
 */
export interface GetClientDetails200ResponseCommitteeTestimoniesInner {
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'TestimonyYear': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'EndTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'StartTime': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'HearingId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'Organization': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'TestimonyDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'BillSupportingDocumentsId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'WitnessId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'TestimonyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'Position': string;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerWitness}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'Witness': GetClientDetails200ResponseCommitteeTestimoniesInnerWitness;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'CommitteeSession': GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'MasterBill': GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill;
    /**
     * 
     * @type {CreateLobbyist200Response}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'Lobbyist': CreateLobbyist200Response;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerCompany}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInner
     */
    'Company': GetClientDetails200ResponseCommitteeTestimoniesInnerCompany;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
 */
export interface GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession {
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
     */
    'LegiscanCommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
     */
    'Staff': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
     */
    'CommitteeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
     */
    'Room': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
 */
export interface GetClientDetails200ResponseCommitteeTestimoniesInnerCompany {
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'ExpectedInterest': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'ManualCreation': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'MasterCompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'FullSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'ShortSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyState': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyFullAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'BeneficialName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'ContractualName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'DoNotContact': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'Outreach': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'CompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerCompany
     */
    'StateCompanyID': number;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
 */
export interface GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill {
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'LastActionDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'LastAction': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'CurrentBody': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'Body': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'CurrentBodyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'BodyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'StateId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'StatusDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'Completed': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'StateUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'LegiscanUrl': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'LegiscanBillId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'FiledDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'AuthorId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'Status': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
 */
export interface GetClientDetails200ResponseCommitteeTestimoniesInnerWitness {
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
     */
    'WitnessId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
     */
    'LobbyistId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
     */
    'MiddleName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeTestimoniesInnerWitness
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseCommitteeVideoClipsInner
 */
export interface GetClientDetails200ResponseCommitteeVideoClipsInner {
    /**
     * 
     * @type {GetClip200ResponseClipDetailsAllOfVideo}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'Video': GetClip200ResponseClipDetailsAllOfVideo;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'SegmentCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'DurationSeconds': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'Timestamps': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'BlobStorageUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'Archived': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'Title': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'VideoId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoClipsInner
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseCommitteeVideoSummariesInner
 */
export interface GetClientDetails200ResponseCommitteeVideoSummariesInner {
    /**
     * 
     * @type {GetClip200ResponseClipDetailsAllOfVideo}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'Video': GetClip200ResponseClipDetailsAllOfVideo;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'SummaryBlobUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'Timestamps': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'Archived': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'Title': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'VideoId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseCommitteeVideoSummariesInner
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseFirmEngagementsInner
 */
export interface GetClientDetails200ResponseFirmEngagementsInner {
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'ReportingPeriodEnd': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'ReportingPeriodStart': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'PaymentMethod': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'CompensationRange': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'CompensationAmount': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'ClientCategory': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'IsNonprofit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'IsCorporation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'IsGovernment': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'EngagementType': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'ClientID': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'FirmEngagementID': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'Year': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'BeginDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'IsActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'EndDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'FirmID': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'IsLobbyist': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseFirmEngagementsInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseLobbyEngagementsInner
 */
export interface GetClientDetails200ResponseLobbyEngagementsInner {
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'EmployerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'Employer': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'LobbyEngagementType': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'RegPeriodEnd': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'RegPeriodStart': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'LobbyEngagementStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'AssociatedFilings': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'CoLobbyists': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'RepresentationIfNoWhoPays': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'RepresenationPaidByRepresenation': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'RepresentationPaymentCategory': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'SalaryHigh': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'SalaryLow': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'Exact': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'Amount': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'Method': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'Year': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'StopDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'BeginDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'ReportingInterval': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'LobbyingEngagementID': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseLobbyEngagementsInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponsePortalsInner
 */
export interface GetClientDetails200ResponsePortalsInner {
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponsePortalsInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponsePortalsInner
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponsePortalsInner
     */
    'hasPassword': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponsePortalsInner
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponsePortalsInner
     */
    'subdomain': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponsePortalsInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponsePortalsInner
     */
    'portalId': number;
    /**
     * 
     * @type {PortalSettings}
     * @memberof GetClientDetails200ResponsePortalsInner
     */
    'portalSettings': PortalSettings;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseRecentReportsInner
 */
export interface GetClientDetails200ResponseRecentReportsInner {
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'ModifiedDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'CreatedDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'LastAccessedDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'DownloadCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'ReportParameters': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'FilePath': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'IsStarred': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'GeneratedDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'ReportId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'ReportType': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'ReportName': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'ExpirationDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'CreatedBy': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'StateCode': string;
    /**
     * 
     * @type {GetTeams200ResponseInnerManager}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'User': GetTeams200ResponseInnerManager;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseRecentReportsInner
     */
    'FileSize': number;
}
/**
 * 
 * @export
 * @interface GetClientDetails200ResponseUserStorageFilesInner
 */
export interface GetClientDetails200ResponseUserStorageFilesInner {
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'VideoMetadata': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'Size': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'BlobPath': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'FileId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'FolderId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClientDetails200ResponseUserStorageFilesInner
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface GetClip200Response
 */
export interface GetClip200Response {
    /**
     * 
     * @type {ITranscript}
     * @memberof GetClip200Response
     */
    'transcript': ITranscript;
    /**
     * 
     * @type {GetClip200ResponseClipDetails}
     * @memberof GetClip200Response
     */
    'clipDetails': GetClip200ResponseClipDetails;
}
/**
 * 
 * @export
 * @interface GetClip200ResponseClipDetails
 */
export interface GetClip200ResponseClipDetails {
    /**
     * 
     * @type {GetClip200ResponseClipDetailsAllOfLiveTranscript}
     * @memberof GetClip200ResponseClipDetails
     */
    'LiveTranscript': GetClip200ResponseClipDetailsAllOfLiveTranscript;
    /**
     * 
     * @type {GetClip200ResponseClipDetailsAllOfVideo}
     * @memberof GetClip200ResponseClipDetails
     */
    'Video': GetClip200ResponseClipDetailsAllOfVideo;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetails
     */
    'Keyword': string;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetails
     */
    'LiveId': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetClip200ResponseClipDetails
     */
    'IncludeTranscript': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetails
     */
    'EndPosition': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetails
     */
    'StartPosition': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetails
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetails
     */
    'Description': string;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetails
     */
    'VideoId': number;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetails
     */
    'EndTime': number;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetails
     */
    'StartTime': number;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetails
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetails
     */
    'UserId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetails
     */
    'Id': string;
}
/**
 * 
 * @export
 * @interface GetClip200ResponseClipDetailsAllOfLiveTranscript
 */
export interface GetClip200ResponseClipDetailsAllOfLiveTranscript {
    /**
     * 
     * @type {boolean}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'IsChamberSession': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'IsResumed': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'CommitteeCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'IsOnLive': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'Legislature': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'StreamUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'ThumbnailUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'Title': string;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'StartTime': string;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfLiveTranscript
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetClip200ResponseClipDetailsAllOfVideo
 */
export interface GetClip200ResponseClipDetailsAllOfVideo {
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'ThumbnailUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'TranscriptUrlBackup': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'IsNormalized': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'TranscriptWitnessesProcessed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'IsFromLive': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'NonTimeStampSummaryUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'SummaryUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'IsStreaming': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'Duration': number;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'OriginalSrc': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'TranscriptUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'Link': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'Committee': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'Date': string;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetClip200ResponseClipDetailsAllOfVideo
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetCommittee200Response
 */
export interface GetCommittee200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCommittee200Response
     */
    'LegiscanCommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200Response
     */
    'Staff': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200Response
     */
    'CommitteeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200Response
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCommittee200Response
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200Response
     */
    'Room': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200Response
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {any}
     * @memberof GetCommittee200Response
     */
    'CommitteeBills': any;
    /**
     * 
     * @type {Array<GetCommittee200ResponseCommitteeHearingsInner>}
     * @memberof GetCommittee200Response
     */
    'CommitteeHearings': Array<GetCommittee200ResponseCommitteeHearingsInner>;
    /**
     * 
     * @type {any}
     * @memberof GetCommittee200Response
     */
    'CommitteeMembers': any;
}
/**
 * 
 * @export
 * @interface GetCommittee200ResponseCommitteeHearingsInner
 */
export interface GetCommittee200ResponseCommitteeHearingsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'VideoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'WitnessUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'MinutesUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'AgendaUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'AgendaText': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'IsUpdated': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'HearingStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'FileDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'HearingDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'CommitteeCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'VideoId': number;
    /**
     * 
     * @type {number}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'HearingId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittee200ResponseCommitteeHearingsInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetCommitteeAgentRecentActivity200ResponseInner
 */
export interface GetCommitteeAgentRecentActivity200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeAgentRecentActivity200ResponseInner
     */
    'analysisId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeAgentRecentActivity200ResponseInner
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeAgentRecentActivity200ResponseInner
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeAgentRecentActivity200ResponseInner
     */
    'type': GetCommitteeAgentRecentActivity200ResponseInnerTypeEnum;
}

export const GetCommitteeAgentRecentActivity200ResponseInnerTypeEnum = {
    HearingProcessed: 'hearing-processed',
    ClipsGenerated: 'clips-generated',
    HearingFlagged: 'hearing-flagged',
    AnalysisComplete: 'analysis-complete'
} as const;

export type GetCommitteeAgentRecentActivity200ResponseInnerTypeEnum = typeof GetCommitteeAgentRecentActivity200ResponseInnerTypeEnum[keyof typeof GetCommitteeAgentRecentActivity200ResponseInnerTypeEnum];

/**
 * 
 * @export
 * @interface GetCommitteeAnalysis200Response
 */
export interface GetCommitteeAnalysis200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetCommitteeAnalysis200Response
     */
    'hasMore': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeAnalysis200Response
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeAnalysis200Response
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeAnalysis200Response
     */
    'total': number;
    /**
     * 
     * @type {Array<CommitteeAnalysisResponse>}
     * @memberof GetCommitteeAnalysis200Response
     */
    'items': Array<CommitteeAnalysisResponse>;
}
/**
 * 
 * @export
 * @interface GetCommitteeClips200ResponseInner
 */
export interface GetCommitteeClips200ResponseInner {
    /**
     * 
     * @type {Array<GetCommitteeClips200ResponseInnerClipsInner>}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'clips': Array<GetCommitteeClips200ResponseInnerClipsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'durationSeconds': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'segmentCount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'companyName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'videoUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'videoId': number;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeClips200ResponseInner
     */
    'clipSetId': number;
}
/**
 * 
 * @export
 * @interface GetCommitteeClips200ResponseInnerClipsInner
 */
export interface GetCommitteeClips200ResponseInnerClipsInner {
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeClips200ResponseInnerClipsInner
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeClips200ResponseInnerClipsInner
     */
    'relevance': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeClips200ResponseInnerClipsInner
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeClips200ResponseInnerClipsInner
     */
    'endTime': number;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeClips200ResponseInnerClipsInner
     */
    'startTime': number;
}
/**
 * 
 * @export
 * @interface GetCommitteeSummaries200ResponseInner
 */
export interface GetCommitteeSummaries200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeSummaries200ResponseInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeSummaries200ResponseInner
     */
    'summaryBlobUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeSummaries200ResponseInner
     */
    'companyName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeSummaries200ResponseInner
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeSummaries200ResponseInner
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeSummaries200ResponseInner
     */
    'stateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeSummaries200ResponseInner
     */
    'videoId': number;
    /**
     * 
     * @type {number}
     * @memberof GetCommitteeSummaries200ResponseInner
     */
    'summaryId': number;
}
/**
 * 
 * @export
 * @interface GetCommitteeVideo200Response
 */
export interface GetCommitteeVideo200Response {
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof GetCommitteeVideo200Response
     */
    'pagination': GetStaff200ResponsePagination;
    /**
     * 
     * @type {Array<GetCommitteeVideo200ResponseDataInner>}
     * @memberof GetCommitteeVideo200Response
     */
    'data': Array<GetCommitteeVideo200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetCommitteeVideo200ResponseDataInner
 */
export interface GetCommitteeVideo200ResponseDataInner {
    /**
     * 
     * @type {Array<CommitteeSession>}
     * @memberof GetCommitteeVideo200ResponseDataInner
     */
    'sessions': Array<CommitteeSession>;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeVideo200ResponseDataInner
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface GetCommitteeVideoByIdResponse
 */
export interface GetCommitteeVideoByIdResponse {
    /**
     * 
     * @type {GetCommitteeVideoByIdResponseVideoDetails}
     * @memberof GetCommitteeVideoByIdResponse
     */
    'videoDetails': GetCommitteeVideoByIdResponseVideoDetails;
    /**
     * 
     * @type {ITranscript}
     * @memberof GetCommitteeVideoByIdResponse
     */
    'transcript': ITranscript;
    /**
     * 
     * @type {Array<ISummaryInner>}
     * @memberof GetCommitteeVideoByIdResponse
     */
    'summary': Array<ISummaryInner>;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeVideoByIdResponse
     */
    'nonTimestampSummary': string | null;
    /**
     * 
     * @type {Array<BillActionGroupDto>}
     * @memberof GetCommitteeVideoByIdResponse
     */
    'billActions': Array<BillActionGroupDto>;
    /**
     * 
     * @type {Array<WitnessDto>}
     * @memberof GetCommitteeVideoByIdResponse
     */
    'witnesses': Array<WitnessDto>;
    /**
     * 
     * @type {Array<GetCommitteeVideoByIdResponseSuggestedQuestionsInner>}
     * @memberof GetCommitteeVideoByIdResponse
     */
    'suggested_questions': Array<GetCommitteeVideoByIdResponseSuggestedQuestionsInner>;
}
/**
 * 
 * @export
 * @interface GetCommitteeVideoByIdResponseSuggestedQuestionsInner
 */
export interface GetCommitteeVideoByIdResponseSuggestedQuestionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeVideoByIdResponseSuggestedQuestionsInner
     */
    'question': string;
}
/**
 * 
 * @export
 * @interface GetCommitteeVideoByIdResponseVideoDetails
 */
export interface GetCommitteeVideoByIdResponseVideoDetails {
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeVideoByIdResponseVideoDetails
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeVideoByIdResponseVideoDetails
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeVideoByIdResponseVideoDetails
     */
    'url': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeVideoByIdResponseVideoDetails
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommitteeVideoByIdResponseVideoDetails
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCommittees200ResponseInner
 */
export interface GetCommittees200ResponseInner {
    /**
     * 
     * @type {Array<GetCommittees200ResponseInnerCommitteeMembersInner>}
     * @memberof GetCommittees200ResponseInner
     */
    'CommitteeMembers': Array<GetCommittees200ResponseInnerCommitteeMembersInner>;
    /**
     * 
     * @type {number}
     * @memberof GetCommittees200ResponseInner
     */
    'LegiscanCommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommittees200ResponseInner
     */
    'Staff': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittees200ResponseInner
     */
    'CommitteeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittees200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {GetCommittees200ResponseInnerCount}
     * @memberof GetCommittees200ResponseInner
     */
    '_count': GetCommittees200ResponseInnerCount;
    /**
     * 
     * @type {number}
     * @memberof GetCommittees200ResponseInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommittees200ResponseInner
     */
    'Room': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittees200ResponseInner
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommittees200ResponseInner
     */
    'StateCode': string;
    /**
     * 
     * @type {any}
     * @memberof GetCommittees200ResponseInner
     */
    'CommitteeHearings': any;
    /**
     * 
     * @type {any}
     * @memberof GetCommittees200ResponseInner
     */
    'upcomingMeeting': any;
}
/**
 * 
 * @export
 * @interface GetCommittees200ResponseInnerCommitteeMembersInner
 */
export interface GetCommittees200ResponseInnerCommitteeMembersInner {
    /**
     * 
     * @type {string}
     * @memberof GetCommittees200ResponseInnerCommitteeMembersInner
     */
    'MemberPosition': string;
    /**
     * 
     * @type {GetCommittees200ResponseInnerCommitteeMembersInnerMemberSession}
     * @memberof GetCommittees200ResponseInnerCommitteeMembersInner
     */
    'MemberSession': GetCommittees200ResponseInnerCommitteeMembersInnerMemberSession;
}
/**
 * 
 * @export
 * @interface GetCommittees200ResponseInnerCommitteeMembersInnerMemberSession
 */
export interface GetCommittees200ResponseInnerCommitteeMembersInnerMemberSession {
    /**
     * 
     * @type {boolean}
     * @memberof GetCommittees200ResponseInnerCommitteeMembersInnerMemberSession
     */
    'IsCommittee': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCommittees200ResponseInnerCommitteeMembersInnerMemberSession
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface GetCommittees200ResponseInnerCount
 */
export interface GetCommittees200ResponseInnerCount {
    /**
     * 
     * @type {number}
     * @memberof GetCommittees200ResponseInnerCount
     */
    'CommitteeMembers': number;
    /**
     * 
     * @type {number}
     * @memberof GetCommittees200ResponseInnerCount
     */
    'CommitteeHearings': number;
    /**
     * 
     * @type {number}
     * @memberof GetCommittees200ResponseInnerCount
     */
    'CommitteeBills': number;
}
/**
 * 
 * @export
 * @interface GetCompanies200Response
 */
export interface GetCompanies200Response {
    /**
     * 
     * @type {GetCompanies200ResponsePagination}
     * @memberof GetCompanies200Response
     */
    'pagination': GetCompanies200ResponsePagination;
    /**
     * 
     * @type {Array<GetCompanies200ResponseDataInner>}
     * @memberof GetCompanies200Response
     */
    'data': Array<GetCompanies200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetCompanies200ResponseDataInner
 */
export interface GetCompanies200ResponseDataInner {
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponseDataInner
     */
    'MasterCompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'FullSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'ShortSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyState': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'BeneficialName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'ContractualName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponseDataInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseDataInner
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponseDataInner
     */
    'StateCount': number;
    /**
     * 
     * @type {GetCompanies200ResponseDataInnerCount}
     * @memberof GetCompanies200ResponseDataInner
     */
    '_count': GetCompanies200ResponseDataInnerCount;
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponseDataInner
     */
    'LobbyistCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponseDataInner
     */
    'StateCompanyID': number;
}
/**
 * 
 * @export
 * @interface GetCompanies200ResponseDataInnerCount
 */
export interface GetCompanies200ResponseDataInnerCount {
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponseDataInnerCount
     */
    'LobbyEngagements': number;
}
/**
 * 
 * @export
 * @interface GetCompanies200ResponsePagination
 */
export interface GetCompanies200ResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponsePagination
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponsePagination
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponsePagination
     */
    'pages': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanies200ResponsePagination
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface GetCompaniesOfInterest200Response
 */
export interface GetCompaniesOfInterest200Response {
    /**
     * 
     * @type {Array<GetCompaniesOfInterest200ResponseCompaniesInner>}
     * @memberof GetCompaniesOfInterest200Response
     */
    'companies': Array<GetCompaniesOfInterest200ResponseCompaniesInner>;
}
/**
 * 
 * @export
 * @interface GetCompaniesOfInterest200ResponseCompaniesInner
 */
export interface GetCompaniesOfInterest200ResponseCompaniesInner {
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'FullSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'ShortSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyState': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'BeneficialName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'ContractualName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'StateCode': string;
    /**
     * 
     * @type {GetCompanies200ResponseDataInnerCount}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    '_count': GetCompanies200ResponseDataInnerCount;
    /**
     * 
     * @type {number}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'LobbyistCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompaniesOfInterest200ResponseCompaniesInner
     */
    'StateCompanyID': number;
}
/**
 * 
 * @export
 * @interface GetCompaniesWithKeywords200Response
 */
export interface GetCompaniesWithKeywords200Response {
    /**
     * 
     * @type {Array<GetCompaniesWithKeywords200ResponseCompaniesInner>}
     * @memberof GetCompaniesWithKeywords200Response
     */
    'companies': Array<GetCompaniesWithKeywords200ResponseCompaniesInner>;
}
/**
 * 
 * @export
 * @interface GetCompaniesWithKeywords200ResponseCompaniesInner
 */
export interface GetCompaniesWithKeywords200ResponseCompaniesInner {
    /**
     * 
     * @type {number}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'MasterCompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'FullSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'ShortSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyState': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'BeneficialName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'ContractualName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'StateCode': string;
    /**
     * 
     * @type {GetCompanies200ResponseDataInnerCount}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    '_count': GetCompanies200ResponseDataInnerCount;
    /**
     * 
     * @type {number}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'LobbyistCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompaniesWithKeywords200ResponseCompaniesInner
     */
    'StateCompanyID': number;
}
/**
 * 
 * @export
 * @interface GetCompany200Response
 */
export interface GetCompany200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'FullSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'ShortSum': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyState': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'BeneficialName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'ContractualName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompany200Response
     */
    'CompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {Array<GetCompany200ResponseLobbyEngagementsInner>}
     * @memberof GetCompany200Response
     */
    'LobbyEngagements': Array<GetCompany200ResponseLobbyEngagementsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetCompany200Response
     */
    'StateCompanyID': number;
}
/**
 * 
 * @export
 * @interface GetCompany200ResponseLobbyEngagementsInner
 */
export interface GetCompany200ResponseLobbyEngagementsInner {
    /**
     * 
     * @type {GetCompany200ResponseLobbyEngagementsInnerLobbyist}
     * @memberof GetCompany200ResponseLobbyEngagementsInner
     */
    'Lobbyist': GetCompany200ResponseLobbyEngagementsInnerLobbyist;
}
/**
 * 
 * @export
 * @interface GetCompany200ResponseLobbyEngagementsInnerLobbyist
 */
export interface GetCompany200ResponseLobbyEngagementsInnerLobbyist {
    /**
     * 
     * @type {string}
     * @memberof GetCompany200ResponseLobbyEngagementsInnerLobbyist
     */
    'LobbyistBusiness': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200ResponseLobbyEngagementsInnerLobbyist
     */
    'LobbyistFullName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200ResponseLobbyEngagementsInnerLobbyist
     */
    'LobbyistLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompany200ResponseLobbyEngagementsInnerLobbyist
     */
    'LobbyistFirstName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompany200ResponseLobbyEngagementsInnerLobbyist
     */
    'LobbyistID': number;
}
/**
 * 
 * @export
 * @interface GetCompanyBillsOfInterest200Response
 */
export interface GetCompanyBillsOfInterest200Response {
    /**
     * 
     * @type {Array<GetCompanyBillsOfInterest200ResponseBillsInner>}
     * @memberof GetCompanyBillsOfInterest200Response
     */
    'bills': Array<GetCompanyBillsOfInterest200ResponseBillsInner>;
}
/**
 * 
 * @export
 * @interface GetCompanyBillsOfInterest200ResponseBillsInner
 */
export interface GetCompanyBillsOfInterest200ResponseBillsInner {
    /**
     * 
     * @type {number}
     * @memberof GetCompanyBillsOfInterest200ResponseBillsInner
     */
    'matchRate': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyBillsOfInterest200ResponseBillsInner
     */
    'lastAction': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyBillsOfInterest200ResponseBillsInner
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyBillsOfInterest200ResponseBillsInner
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyBillsOfInterest200ResponseBillsInner
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyBillsOfInterest200ResponseBillsInner
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyBillsOfInterest200ResponseBillsInner
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyBillsOfInterest200ResponseBillsInner
     */
    'billId': string;
}
/**
 * 
 * @export
 * @interface GetCompanyContributions200ResponseInner
 */
export interface GetCompanyContributions200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'ContributorFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'ContributorLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'ContributionDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'FilerName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'FilerId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'FormTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'ContributionId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'State': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyContributions200ResponseInner
     */
    'ContributionAmount': number;
}
/**
 * 
 * @export
 * @interface GetCompanyFirmEngagements200ResponseInner
 */
export interface GetCompanyFirmEngagements200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'PaymentMethod': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'CompensationRange': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'EngagementType': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'FirmEngagementID': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'Year': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'BeginDate': string;
    /**
     * 
     * @type {GetCompanyFirmEngagements200ResponseInnerFirm}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'Firm': GetCompanyFirmEngagements200ResponseInnerFirm;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'EndDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'FirmID': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyFirmEngagements200ResponseInner
     */
    'CompensationAmount': number;
}
/**
 * 
 * @export
 * @interface GetCompanyFirmEngagements200ResponseInnerFirm
 */
export interface GetCompanyFirmEngagements200ResponseInnerFirm {
    /**
     * 
     * @type {string}
     * @memberof GetCompanyFirmEngagements200ResponseInnerFirm
     */
    'FirmName': string;
}
/**
 * 
 * @export
 * @interface GetCompanyStates200ResponseInner
 */
export interface GetCompanyStates200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetCompanyStates200ResponseInner
     */
    'stateCompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyStates200ResponseInner
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyStates200ResponseInner
     */
    'companyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyStates200ResponseInner
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface GetCompanyTestimony200ResponseInner
 */
export interface GetCompanyTestimony200ResponseInner {
    /**
     * 
     * @type {GetCompanyTestimony200ResponseInnerCommitteeSession}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'CommitteeSession': GetCompanyTestimony200ResponseInnerCommitteeSession;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'EndTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'StartTime': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'HearingId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'Organization': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'TestimonyDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'BillSupportingDocumentsId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'WitnessId': number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'TestimonyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInner
     */
    'Position': string;
}
/**
 * 
 * @export
 * @interface GetCompanyTestimony200ResponseInnerCommitteeSession
 */
export interface GetCompanyTestimony200ResponseInnerCommitteeSession {
    /**
     * 
     * @type {string}
     * @memberof GetCompanyTestimony200ResponseInnerCommitteeSession
     */
    'CommitteeName': string;
}
/**
 * 
 * @export
 * @interface GetConcatenatedRegsResponse
 */
export interface GetConcatenatedRegsResponse {
    /**
     * 
     * @type {ParentLevelInfo}
     * @memberof GetConcatenatedRegsResponse
     */
    'parentInfo': ParentLevelInfo;
    /**
     * 
     * @type {Array<ConcatenatedRegulation>}
     * @memberof GetConcatenatedRegsResponse
     */
    'regulations': Array<ConcatenatedRegulation>;
    /**
     * 
     * @type {number}
     * @memberof GetConcatenatedRegsResponse
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface GetFirm200Response
 */
export interface GetFirm200Response {
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmState': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmStreet2': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmStreet1': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'FirmName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFirm200Response
     */
    'FirmID': number;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {Array<GetFirm200ResponseLobbyistsInner>}
     * @memberof GetFirm200Response
     */
    'Lobbyists': Array<GetFirm200ResponseLobbyistsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetFirm200Response
     */
    'StateFirmID': number;
}
/**
 * 
 * @export
 * @interface GetFirm200ResponseLobbyistsInner
 */
export interface GetFirm200ResponseLobbyistsInner {
    /**
     * 
     * @type {string}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'LobbyistBusiness': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'LobbyistWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'LobbyistEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'LobbyistPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'LobbyistFullName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'LobbyistLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'LobbyistFirstName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetFirm200ResponseLobbyistsInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetFirmEngagements200ResponseInner
 */
export interface GetFirmEngagements200ResponseInner {
    /**
     * 
     * @type {GetBillTestimony200ResponseInnerCompany}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'Client': GetBillTestimony200ResponseInnerCompany;
    /**
     * 
     * @type {string}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'PaymentMethod': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'CompensationRange': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'EngagementType': string;
    /**
     * 
     * @type {number}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'ClientID': number;
    /**
     * 
     * @type {number}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'FirmEngagementID': number;
    /**
     * 
     * @type {number}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'Year': number;
    /**
     * 
     * @type {string}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'BeginDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'EndDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetFirmEngagements200ResponseInner
     */
    'CompensationAmount': number;
}
/**
 * 
 * @export
 * @interface GetFirms200Response
 */
export interface GetFirms200Response {
    /**
     * 
     * @type {GetLobbyists200ResponsePagination}
     * @memberof GetFirms200Response
     */
    'pagination': GetLobbyists200ResponsePagination;
    /**
     * 
     * @type {Array<GetFirms200ResponseDataInner>}
     * @memberof GetFirms200Response
     */
    'data': Array<GetFirms200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetFirms200ResponseDataInner
 */
export interface GetFirms200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmState': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmStreet2': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmStreet1': string;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFirms200ResponseDataInner
     */
    'FirmID': number;
    /**
     * 
     * @type {string}
     * @memberof GetFirms200ResponseDataInner
     */
    'StateCode': string;
    /**
     * 
     * @type {any}
     * @memberof GetFirms200ResponseDataInner
     */
    'LobbyistCount': any;
    /**
     * 
     * @type {number}
     * @memberof GetFirms200ResponseDataInner
     */
    'StateFirmID': number;
}
/**
 * 
 * @export
 * @interface GetFolderTree200ResponseInner
 */
export interface GetFolderTree200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFolderTree200ResponseInner
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof GetFolderTree200ResponseInner
     */
    'color': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFolderTree200ResponseInner
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFolderTree200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetFolderTree200ResponseInner
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetGmailOAuthUrl200Response
 */
export interface GetGmailOAuthUrl200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetGmailOAuthUrl200Response
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetGmailOAuthUrl200Response
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface GetIssues200ResponseInner
 */
export interface GetIssues200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'ScreenshotUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'UserAgent': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetIssues200ResponseInner
     */
    'IsPublic': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'ResolvedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'IssueType': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'Route': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'Tags': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'AssignedTo': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'CreatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'Priority': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssues200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetIssues200ResponseInner
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface GetKeywordClips200ResponseInner
 */
export interface GetKeywordClips200ResponseInner {
    /**
     * 
     * @type {boolean}
     * @memberof GetKeywordClips200ResponseInner
     */
    'isLive': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetKeywordClips200ResponseInner
     */
    'liveId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeywordClips200ResponseInner
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetKeywordClips200ResponseInner
     */
    'endTime': number;
    /**
     * 
     * @type {number}
     * @memberof GetKeywordClips200ResponseInner
     */
    'startTime': number;
    /**
     * 
     * @type {string}
     * @memberof GetKeywordClips200ResponseInner
     */
    'keyword': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeywordClips200ResponseInner
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeywordClips200ResponseInner
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GetKeywordClips200ResponseInner
     */
    'sessionCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeywordClips200ResponseInner
     */
    'stateCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeywordClips200ResponseInner
     */
    'videoUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetKeywordClips200ResponseInner
     */
    'videoId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeywordClips200ResponseInner
     */
    'clipId': string;
}
/**
 * 
 * @export
 * @interface GetLatestMatch200Response
 */
export interface GetLatestMatch200Response {
    /**
     * 
     * @type {string}
     * @memberof GetLatestMatch200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetLatestMatch200Response
     */
    'impact': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLatestMatch200Response
     */
    'priority': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLatestMatch200Response
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GetLatestMatch200Response
     */
    'billNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetLatestMatch200Response
     */
    'masterBillId': string;
}
/**
 * 
 * @export
 * @interface GetLobbyEngagements200ResponseInner
 */
export interface GetLobbyEngagements200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'LobbyEngagementType': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'LobbyEngagementStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'Method': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'Year': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'StopDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'BeginDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'ReportingInterval': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'LobbyingEngagementID': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'StateCode': string;
    /**
     * 
     * @type {GetRecentReports200ResponseInnerCompany}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'Company': GetRecentReports200ResponseInnerCompany;
    /**
     * 
     * @type {GetLobbyEngagements200ResponseInnerLobbyist}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'Lobbyist': GetLobbyEngagements200ResponseInnerLobbyist;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'SalaryHigh': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'SalaryLow': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyEngagements200ResponseInner
     */
    'Exact': number;
}
/**
 * 
 * @export
 * @interface GetLobbyEngagements200ResponseInnerLobbyist
 */
export interface GetLobbyEngagements200ResponseInnerLobbyist {
    /**
     * 
     * @type {number}
     * @memberof GetLobbyEngagements200ResponseInnerLobbyist
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInnerLobbyist
     */
    'LobbyistLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInnerLobbyist
     */
    'LobbyistFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInnerLobbyist
     */
    'LobbyistState': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInnerLobbyist
     */
    'LobbyistEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInnerLobbyist
     */
    'LobbyistBusiness': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyEngagements200ResponseInnerLobbyist
     */
    'LobbyistFullName': string;
}
/**
 * 
 * @export
 * @interface GetLobbyist200Response
 */
export interface GetLobbyist200Response {
    /**
     * 
     * @type {number}
     * @memberof GetLobbyist200Response
     */
    'FirmID': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistBusiness': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistRegisteredBranches': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistState': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistFullName': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistMiddleName': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'LobbyistTitle': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyist200Response
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyist200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {any}
     * @memberof GetLobbyist200Response
     */
    'Firm': any;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyist200Response
     */
    'StateLobbyistID': number;
}
/**
 * 
 * @export
 * @interface GetLobbyistClients200ResponseInner
 */
export interface GetLobbyistClients200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistClients200ResponseInner
     */
    'CompanyName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistClients200ResponseInner
     */
    'CompanyID': number;
}
/**
 * 
 * @export
 * @interface GetLobbyistTestimony200ResponseInner
 */
export interface GetLobbyistTestimony200ResponseInner {
    /**
     * 
     * @type {GetBillTestimony200ResponseInnerCompany}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'Company': GetBillTestimony200ResponseInnerCompany;
    /**
     * 
     * @type {GetCompanyTestimony200ResponseInnerCommitteeSession}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'CommitteeSession': GetCompanyTestimony200ResponseInnerCommitteeSession;
    /**
     * 
     * @type {GetLobbyistTestimony200ResponseInnerMasterBill}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'MasterBill': GetLobbyistTestimony200ResponseInnerMasterBill;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'EndTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'StartTime': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'HearingId': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'Organization': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'TestimonyDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'BillSupportingDocumentsId': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'WitnessId': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'TestimonyId': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInner
     */
    'Position': string;
}
/**
 * 
 * @export
 * @interface GetLobbyistTestimony200ResponseInnerMasterBill
 */
export interface GetLobbyistTestimony200ResponseInnerMasterBill {
    /**
     * 
     * @type {Array<GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner>}
     * @memberof GetLobbyistTestimony200ResponseInnerMasterBill
     */
    'Progresses': Array<GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner>;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInnerMasterBill
     */
    'Status': number;
}
/**
 * 
 * @export
 * @interface GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner
 */
export interface GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner {
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner
     */
    'Event': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistTestimony200ResponseInnerMasterBillProgressesInner
     */
    'Date': string;
}
/**
 * 
 * @export
 * @interface GetLobbyists200Response
 */
export interface GetLobbyists200Response {
    /**
     * 
     * @type {GetLobbyists200ResponsePagination}
     * @memberof GetLobbyists200Response
     */
    'pagination': GetLobbyists200ResponsePagination;
    /**
     * 
     * @type {any}
     * @memberof GetLobbyists200Response
     */
    'data': any;
}
/**
 * 
 * @export
 * @interface GetLobbyists200ResponsePagination
 */
export interface GetLobbyists200ResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof GetLobbyists200ResponsePagination
     */
    'pages': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyists200ResponsePagination
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyists200ResponsePagination
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyists200ResponsePagination
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface GetLobbyistsByState200ResponseInner
 */
export interface GetLobbyistsByState200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'trackedBills': number;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'lastLogin': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'firm': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'lobbyistId': number;
    /**
     * 
     * @type {number}
     * @memberof GetLobbyistsByState200ResponseInner
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetMemberById200Response
 */
export interface GetMemberById200Response {
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Nickname': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Suffix': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'MiddleName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Role': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'DateAssumedOffice': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'City': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Mail2': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Mail1': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Desk': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Phone': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Room': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'District': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Race': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Code': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberById200Response
     */
    'MemberId': number;
    /**
     * 
     * @type {Array<CoSponsor>}
     * @memberof GetMemberById200Response
     */
    'coSponsors': Array<CoSponsor>;
    /**
     * 
     * @type {SessionRankings}
     * @memberof GetMemberById200Response
     */
    'sessionRankings': SessionRankings;
    /**
     * 
     * @type {Array<GetMemberById200ResponseStaffInner>}
     * @memberof GetMemberById200Response
     */
    'staff': Array<GetMemberById200ResponseStaffInner>;
    /**
     * 
     * @type {Array<SponsorRecord>}
     * @memberof GetMemberById200Response
     */
    'sponsored': Array<SponsorRecord>;
    /**
     * 
     * @type {Array<SimpleBill>}
     * @memberof GetMemberById200Response
     */
    'passedBills': Array<SimpleBill>;
    /**
     * 
     * @type {Array<SimpleBill>}
     * @memberof GetMemberById200Response
     */
    'authoredBills': Array<SimpleBill>;
    /**
     * 
     * @type {GetMemberById200ResponseBio}
     * @memberof GetMemberById200Response
     */
    'bio': GetMemberById200ResponseBio;
    /**
     * 
     * @type {Array<GetMemberById200ResponseContactsInner>}
     * @memberof GetMemberById200Response
     */
    'contacts': Array<GetMemberById200ResponseContactsInner>;
    /**
     * 
     * @type {GetMemberById200ResponseContactsInner}
     * @memberof GetMemberById200Response
     */
    'contact': GetMemberById200ResponseContactsInner;
    /**
     * 
     * @type {Array<GetMemberById200ResponseCommitteeMembersInner>}
     * @memberof GetMemberById200Response
     */
    'CommitteeMembers': Array<GetMemberById200ResponseCommitteeMembersInner>;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'imageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200Response
     */
    'ImageMimeType': string;
}
/**
 * 
 * @export
 * @interface GetMemberById200ResponseBio
 */
export interface GetMemberById200ResponseBio {
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Biography': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Treasurer': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'SpouseOccupation': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Spouse': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'PublicOfficesHeld': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'PlaceofBirth': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Occupation': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Military': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'MembershipActivities': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'HomeTelephone': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Hobbies': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'HigherEducation': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'HighSchool': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'FilingInformation': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Degrees': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'DateofBirth': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'ChurchAffiliation': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'BusinessTelephone': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Business': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Children': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'District': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseBio
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberById200ResponseBio
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface GetMemberById200ResponseCommitteeMembersInner
 */
export interface GetMemberById200ResponseCommitteeMembersInner {
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseCommitteeMembersInner
     */
    'Room': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseCommitteeMembersInner
     */
    'CommitteeName': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberById200ResponseCommitteeMembersInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseCommitteeMembersInner
     */
    'MemberPosition': string;
}
/**
 * 
 * @export
 * @interface GetMemberById200ResponseContactsInner
 */
export interface GetMemberById200ResponseContactsInner {
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'ContactLastUpdated': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'ContactSources': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'ContactNotes': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'FirstElected': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'ProfessionalBackground': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'Facebook': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'Instagram': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'Twitter': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'CampaignWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'OfficeAddress': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'ContactId': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'Website': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'CreatedDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'LinkedIn': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'Phone': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberById200ResponseContactsInner
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface GetMemberById200ResponseStaffInner
 */
export interface GetMemberById200ResponseStaffInner {
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'Session': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'StaffId': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'State': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'Phone': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberById200ResponseStaffInner
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface GetMemberCoSponsors200ResponseInner
 */
export interface GetMemberCoSponsors200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetMemberCoSponsors200ResponseInner
     */
    'imageUrl': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberCoSponsors200ResponseInner
     */
    'sharedBills': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberCoSponsors200ResponseInner
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberCoSponsors200ResponseInner
     */
    'party': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberCoSponsors200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberCoSponsors200ResponseInner
     */
    'memberId': number;
}
/**
 * 
 * @export
 * @interface GetMemberDemographics200Response
 */
export interface GetMemberDemographics200Response {
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'RenterOccupiedPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'RenterOccupiedCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'OwnerOccupiedPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'OwnerOccupiedCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'TotalHousingUnits': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'MedianRent': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'MedianHomeValue': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'PovertyRate': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'PovertyStatusTotal': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'BelowPovertyLevelCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'ProductionTransportationPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'ProductionTransportationCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'NaturalResourcesConstructionPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'NaturalResourcesConstructionCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'SalesOfficePercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'SalesOfficeCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'ServiceOccupationPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'ServiceOccupationCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'ManagementBusinessSciencePercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'ManagementBusinessScienceCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'NotInLaborForcePercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'NotInLaborForceCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'UnemployedPercentageOfLaborForce': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'UnemployedPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'UnemployedCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'EmployedPercentageOfLaborForce': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'EmployedPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'EmployedCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'InLaborForcePercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'InLaborForceCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'Total16Plus': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'BachelorOrHigherPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'BachelorOrHigherCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'DoctoratePercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'DoctorateCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'ProfessionalDegreePercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'ProfessionalDegreeCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'MastersPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'MastersCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'BachelorsPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'BachelorsCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'AssociatesPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'AssociatesCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'HighSchoolGradPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'HighSchoolGradCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'Total25Plus': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'Over100kPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'Over100kCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'Under10kPercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'Under10kCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'PerCapitaIncome': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'MedianHouseholdIncome': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'HispanicLatinoPercentage': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'TwoOrMoreRacesPercentage': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'OtherRacePercentage': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'PacificIslanderPercentage': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'AsianPercentage': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'AmericanIndianPercentage': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'BlackPercentage': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'WhitePercentage': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'HispanicLatinoCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'TwoOrMoreRacesCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'OtherRaceCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'PacificIslanderCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'AsianCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'AmericanIndianCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'BlackCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'WhiteCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'MedianAge': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'TotalPopulation': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'DataYear': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'StateFIPS': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'DistrictNumber': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'DistrictName': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberDemographics200Response
     */
    'DistrictID': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'CreatedDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberDemographics200Response
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetMemberFilters200Response
 */
export interface GetMemberFilters200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMemberFilters200Response
     */
    'parties': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMemberFilters200Response
     */
    'chambers': Array<string>;
}
/**
 * 
 * @export
 * @interface GetMemberLeaderboards200Response
 */
export interface GetMemberLeaderboards200Response {
    /**
     * 
     * @type {GetMemberLeaderboards200ResponseLeaderboards}
     * @memberof GetMemberLeaderboards200Response
     */
    'leaderboards': GetMemberLeaderboards200ResponseLeaderboards;
    /**
     * 
     * @type {string}
     * @memberof GetMemberLeaderboards200Response
     */
    'sessionCode': string;
}
/**
 * 
 * @export
 * @interface GetMemberLeaderboards200ResponseLeaderboards
 */
export interface GetMemberLeaderboards200ResponseLeaderboards {
    /**
     * 
     * @type {Array<GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner>}
     * @memberof GetMemberLeaderboards200ResponseLeaderboards
     */
    'prevailingSide': Array<GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner>;
    /**
     * 
     * @type {Array<GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner>}
     * @memberof GetMemberLeaderboards200ResponseLeaderboards
     */
    'votesTaken': Array<GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner>;
    /**
     * 
     * @type {Array<GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner>}
     * @memberof GetMemberLeaderboards200ResponseLeaderboards
     */
    'billsPassed': Array<GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner>;
    /**
     * 
     * @type {Array<GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner>}
     * @memberof GetMemberLeaderboards200ResponseLeaderboards
     */
    'billsFiled': Array<GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner>;
}
/**
 * 
 * @export
 * @interface GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner
 */
export interface GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner {
    /**
     * 
     * @type {number}
     * @memberof GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner
     */
    'rank': number;
    /**
     * 
     * @type {number}
     * @memberof GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner
     */
    'party': string;
    /**
     * 
     * @type {string}
     * @memberof GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetMemberLeaderboards200ResponseLeaderboardsPrevailingSideInner
     */
    'memberId': number;
}
/**
 * 
 * @export
 * @interface GetMembers200Response
 */
export interface GetMembers200Response {
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof GetMembers200Response
     */
    'pagination': GetStaff200ResponsePagination;
    /**
     * 
     * @type {Array<GetMembers200ResponseDataInner>}
     * @memberof GetMembers200Response
     */
    'data': Array<GetMembers200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetMembers200ResponseDataInner
 */
export interface GetMembers200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMembers200ResponseDataInner
     */
    'IsCommittee': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Nickname': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Suffix': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'MiddleName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Role': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'DateAssumedOffice': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'City': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Mail2': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Mail1': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Desk': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Room': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'District': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Race': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Code': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetMembers200ResponseDataInner
     */
    'MemberId': number;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'imageUrl': string;
    /**
     * 
     * @type {any}
     * @memberof GetMembers200ResponseDataInner
     */
    'ImageMimeType': any;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Phone': string;
    /**
     * 
     * @type {string}
     * @memberof GetMembers200ResponseDataInner
     */
    'Email': string;
}
/**
 * 
 * @export
 * @interface GetNotifications200ResponseInner
 */
export interface GetNotifications200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetNotifications200ResponseInner
     */
    'TrackListId': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetNotifications200ResponseInner
     */
    'IsRead': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetNotifications200ResponseInner
     */
    'Link': string;
    /**
     * 
     * @type {string}
     * @memberof GetNotifications200ResponseInner
     */
    'Message': string;
    /**
     * 
     * @type {string}
     * @memberof GetNotifications200ResponseInner
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof GetNotifications200ResponseInner
     */
    'BillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetNotifications200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetNotifications200ResponseInner
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof GetNotifications200ResponseInner
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface GetPendingFullAccountInvitations200ResponseInner
 */
export interface GetPendingFullAccountInvitations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPendingFullAccountInvitations200ResponseInner
     */
    'ExpirationDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingFullAccountInvitations200ResponseInner
     */
    'InviteeLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingFullAccountInvitations200ResponseInner
     */
    'InviteeFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingFullAccountInvitations200ResponseInner
     */
    'InviteeEmail': string;
    /**
     * 
     * @type {number}
     * @memberof GetPendingFullAccountInvitations200ResponseInner
     */
    'InvitationId': number;
    /**
     * 
     * @type {string}
     * @memberof GetPendingFullAccountInvitations200ResponseInner
     */
    'FullAccountRole': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingFullAccountInvitations200ResponseInner
     */
    'CreatedAt': string;
}
/**
 * 
 * @export
 * @interface GetPendingInvitations200ResponseInner
 */
export interface GetPendingInvitations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPendingInvitations200ResponseInner
     */
    'ExpirationDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingInvitations200ResponseInner
     */
    'InviteeStateCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingInvitations200ResponseInner
     */
    'InviteeLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingInvitations200ResponseInner
     */
    'InviteeFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingInvitations200ResponseInner
     */
    'InviteeEmail': string;
    /**
     * 
     * @type {number}
     * @memberof GetPendingInvitations200ResponseInner
     */
    'InvitationId': number;
    /**
     * 
     * @type {string}
     * @memberof GetPendingInvitations200ResponseInner
     */
    'CreatedAt': string;
}
/**
 * 
 * @export
 * @interface GetPlans200ResponseInner
 */
export interface GetPlans200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPlans200ResponseInner
     */
    'PlanDescription': string;
    /**
     * 
     * @type {string}
     * @memberof GetPlans200ResponseInner
     */
    'PlanName': string;
    /**
     * 
     * @type {number}
     * @memberof GetPlans200ResponseInner
     */
    'PlanId': number;
}
/**
 * 
 * @export
 * @interface GetPortalTrackingTags200Response
 */
export interface GetPortalTrackingTags200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPortalTrackingTags200Response
     */
    'tags': Array<string>;
}
/**
 * 
 * @export
 * @interface GetRecentActivity200ResponseInner
 */
export interface GetRecentActivity200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRecentActivity200ResponseInner
     */
    'billId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentActivity200ResponseInner
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentActivity200ResponseInner
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentActivity200ResponseInner
     */
    'type': GetRecentActivity200ResponseInnerTypeEnum;
}

export const GetRecentActivity200ResponseInnerTypeEnum = {
    AutoTrack: 'auto-track',
    AiReport: 'ai-report',
    PriorityFlag: 'priority-flag',
    Opportunity: 'opportunity'
} as const;

export type GetRecentActivity200ResponseInnerTypeEnum = typeof GetRecentActivity200ResponseInnerTypeEnum[keyof typeof GetRecentActivity200ResponseInnerTypeEnum];

/**
 * 
 * @export
 * @interface GetRecentReports200ResponseInner
 */
export interface GetRecentReports200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'ModifiedDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'CreatedDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'LastAccessedDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetRecentReports200ResponseInner
     */
    'DownloadCount': number;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'ReportParameters': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'FilePath': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetRecentReports200ResponseInner
     */
    'IsStarred': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'GeneratedDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetRecentReports200ResponseInner
     */
    'ReportId': number;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'ReportType': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'ReportName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'ExpirationDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetRecentReports200ResponseInner
     */
    'CompanyId': number;
    /**
     * 
     * @type {number}
     * @memberof GetRecentReports200ResponseInner
     */
    'CreatedBy': number;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'StateCode': string;
    /**
     * 
     * @type {GetRecentReports200ResponseInnerCompany}
     * @memberof GetRecentReports200ResponseInner
     */
    'Company': GetRecentReports200ResponseInnerCompany;
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInner
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetRecentReports200ResponseInner
     */
    'FileSize': number;
}
/**
 * 
 * @export
 * @interface GetRecentReports200ResponseInnerCompany
 */
export interface GetRecentReports200ResponseInnerCompany {
    /**
     * 
     * @type {string}
     * @memberof GetRecentReports200ResponseInnerCompany
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof GetRecentReports200ResponseInnerCompany
     */
    'CompanyID': number;
}
/**
 * 
 * @export
 * @interface GetRelatedBillsByStatute200ResponseInner
 */
export interface GetRelatedBillsByStatute200ResponseInner {
    /**
     * 
     * @type {Array<GetRelatedBillsByStatute200ResponseInnerStatutesInner>}
     * @memberof GetRelatedBillsByStatute200ResponseInner
     */
    'statutes': Array<GetRelatedBillsByStatute200ResponseInnerStatutesInner>;
    /**
     * 
     * @type {GetRelatedBillsByStatute200ResponseInnerBill}
     * @memberof GetRelatedBillsByStatute200ResponseInner
     */
    'bill': GetRelatedBillsByStatute200ResponseInnerBill;
}
/**
 * 
 * @export
 * @interface GetRelatedBillsByStatute200ResponseInnerBill
 */
export interface GetRelatedBillsByStatute200ResponseInnerBill {
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerBill
     */
    'committee': string;
    /**
     * 
     * @type {number}
     * @memberof GetRelatedBillsByStatute200ResponseInnerBill
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerBill
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof GetRelatedBillsByStatute200ResponseInnerBill
     */
    'number': number;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerBill
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerBill
     */
    'session': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerBill
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerBill
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface GetRelatedBillsByStatute200ResponseInnerStatutesInner
 */
export interface GetRelatedBillsByStatute200ResponseInnerStatutesInner {
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerStatutesInner
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerStatutesInner
     */
    'act': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerStatutesInner
     */
    'reference': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedBillsByStatute200ResponseInnerStatutesInner
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface GetReportSettings200ResponseInner
 */
export interface GetReportSettings200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetReportSettings200ResponseInner
     */
    'SettingsJson': string;
    /**
     * 
     * @type {string}
     * @memberof GetReportSettings200ResponseInner
     */
    'ReportType': string;
    /**
     * 
     * @type {string}
     * @memberof GetReportSettings200ResponseInner
     */
    'ReportName': string;
    /**
     * 
     * @type {number}
     * @memberof GetReportSettings200ResponseInner
     */
    'ReportSettingId': number;
    /**
     * 
     * @type {number}
     * @memberof GetReportSettings200ResponseInner
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetReportSettings200ResponseInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetReportSettings200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetReportSettings200ResponseInner
     */
    'UserId': number;
}
/**
 * 
 * @export
 * @interface GetSavedTickSheets200ResponseInner
 */
export interface GetSavedTickSheets200ResponseInner {
    /**
     * 
     * @type {Array<TickSheetClientAssignment>}
     * @memberof GetSavedTickSheets200ResponseInner
     */
    'clients': Array<TickSheetClientAssignment>;
    /**
     * 
     * @type {string}
     * @memberof GetSavedTickSheets200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetSavedTickSheets200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetSavedTickSheets200ResponseInner
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetScheduleTimezones200Response
 */
export interface GetScheduleTimezones200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetScheduleTimezones200Response
     */
    'is50StateAccount': boolean;
    /**
     * 
     * @type {any}
     * @memberof GetScheduleTimezones200Response
     */
    'defaultTimezone': any;
    /**
     * 
     * @type {Array<GetScheduleTimezones200ResponseTimezonesInner>}
     * @memberof GetScheduleTimezones200Response
     */
    'timezones': Array<GetScheduleTimezones200ResponseTimezonesInner>;
}
/**
 * 
 * @export
 * @interface GetScheduleTimezones200ResponseTimezonesInner
 */
export interface GetScheduleTimezones200ResponseTimezonesInner {
    /**
     * 
     * @type {string}
     * @memberof GetScheduleTimezones200ResponseTimezonesInner
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduleTimezones200ResponseTimezonesInner
     */
    'timezone': string;
}
/**
 * 
 * @export
 * @interface GetScheduledReports200ResponseInner
 */
export interface GetScheduledReports200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'Timezone': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'NextRun': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'LastRun': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetScheduledReports200ResponseInner
     */
    'Enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'CronExpression': string;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInner
     */
    'DayOfMonth': number;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'DaysOfWeek': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'ScheduleTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'ScheduleType': string;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInner
     */
    'ScheduledReportId': number;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInner
     */
    'ReportSettingId': number;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInner
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInner
     */
    'UserId': number;
    /**
     * 
     * @type {GetScheduledReports200ResponseInnerUserReportSetting}
     * @memberof GetScheduledReports200ResponseInner
     */
    'UserReportSetting': GetScheduledReports200ResponseInnerUserReportSetting;
}
/**
 * 
 * @export
 * @interface GetScheduledReports200ResponseInnerUserReportSetting
 */
export interface GetScheduledReports200ResponseInnerUserReportSetting {
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'SettingsJson': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'ReportType': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'ReportName': string;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'ReportSettingId': number;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'AccountId': number;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'UserId': number;
    /**
     * 
     * @type {GetScheduledReports200ResponseInnerUserReportSettingSettings}
     * @memberof GetScheduledReports200ResponseInnerUserReportSetting
     */
    'Settings': GetScheduledReports200ResponseInnerUserReportSettingSettings;
}
/**
 * 
 * @export
 * @interface GetScheduledReports200ResponseInnerUserReportSettingSettings
 */
export interface GetScheduledReports200ResponseInnerUserReportSettingSettings {
    /**
     * 
     * @type {Array<GetScheduledReports200ResponseInnerUserReportSettingSettingsSelectedTagsInner>}
     * @memberof GetScheduledReports200ResponseInnerUserReportSettingSettings
     */
    'selectedTags': Array<GetScheduledReports200ResponseInnerUserReportSettingSettingsSelectedTagsInner>;
}
/**
 * 
 * @export
 * @interface GetScheduledReports200ResponseInnerUserReportSettingSettingsSelectedTagsInner
 */
export interface GetScheduledReports200ResponseInnerUserReportSettingSettingsSelectedTagsInner {
    /**
     * 
     * @type {any}
     * @memberof GetScheduledReports200ResponseInnerUserReportSettingSettingsSelectedTagsInner
     */
    'Name': any;
    /**
     * 
     * @type {number}
     * @memberof GetScheduledReports200ResponseInnerUserReportSettingSettingsSelectedTagsInner
     */
    'TagId': number;
}
/**
 * 
 * @export
 * @interface GetSectionTags200ResponseInner
 */
export interface GetSectionTags200ResponseInner {
    /**
     * 
     * @type {CreateTag200Response}
     * @memberof GetSectionTags200ResponseInner
     */
    'Tag': CreateTag200Response;
    /**
     * 
     * @type {string}
     * @memberof GetSectionTags200ResponseInner
     */
    'SectionId': string;
    /**
     * 
     * @type {number}
     * @memberof GetSectionTags200ResponseInner
     */
    'SectionTagId': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetSectionTags200ResponseInner
     */
    'Sorted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSectionTags200ResponseInner
     */
    'AutoTracked': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSectionTags200ResponseInner
     */
    'AssignedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetSectionTags200ResponseInner
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof GetSectionTags200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetSectionTags200ResponseInner
     */
    'UserId': number;
}
/**
 * 
 * @export
 * @interface GetStaff200Response
 */
export interface GetStaff200Response {
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof GetStaff200Response
     */
    'pagination': GetStaff200ResponsePagination;
    /**
     * 
     * @type {Array<GetStaff200ResponseDataInner>}
     * @memberof GetStaff200Response
     */
    'data': Array<GetStaff200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetStaff200ResponseDataInner
 */
export interface GetStaff200ResponseDataInner {
    /**
     * 
     * @type {GetStaff200ResponseDataInnerMember}
     * @memberof GetStaff200ResponseDataInner
     */
    'Member': GetStaff200ResponseDataInnerMember;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInner
     */
    'Session': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInner
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInner
     */
    'Phone': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInner
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInner
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInner
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInner
     */
    'State': string;
    /**
     * 
     * @type {number}
     * @memberof GetStaff200ResponseDataInner
     */
    'MemberId': number;
    /**
     * 
     * @type {number}
     * @memberof GetStaff200ResponseDataInner
     */
    'StaffId': number;
}
/**
 * 
 * @export
 * @interface GetStaff200ResponseDataInnerMember
 */
export interface GetStaff200ResponseDataInnerMember {
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInnerMember
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInnerMember
     */
    'District': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInnerMember
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetStaff200ResponseDataInnerMember
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof GetStaff200ResponseDataInnerMember
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface GetStaff200ResponsePagination
 */
export interface GetStaff200ResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof GetStaff200ResponsePagination
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof GetStaff200ResponsePagination
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetStaff200ResponsePagination
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof GetStaff200ResponsePagination
     */
    'page': number;
}
/**
 * 
 * @export
 * @interface GetStateCodes200ResponseInner
 */
export interface GetStateCodes200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetStateCodes200ResponseInner
     */
    'SessionName': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateCodes200ResponseInner
     */
    'SessionTitle': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateCodes200ResponseInner
     */
    'SessionTag': string;
    /**
     * 
     * @type {number}
     * @memberof GetStateCodes200ResponseInner
     */
    'Special': number;
    /**
     * 
     * @type {number}
     * @memberof GetStateCodes200ResponseInner
     */
    'Prior': number;
    /**
     * 
     * @type {number}
     * @memberof GetStateCodes200ResponseInner
     */
    'SineDie': number;
    /**
     * 
     * @type {number}
     * @memberof GetStateCodes200ResponseInner
     */
    'Prefile': number;
    /**
     * 
     * @type {number}
     * @memberof GetStateCodes200ResponseInner
     */
    'YearEnd': number;
    /**
     * 
     * @type {number}
     * @memberof GetStateCodes200ResponseInner
     */
    'YearStart': number;
    /**
     * 
     * @type {number}
     * @memberof GetStateCodes200ResponseInner
     */
    'SessionId': number;
    /**
     * 
     * @type {string}
     * @memberof GetStateCodes200ResponseInner
     */
    'EndDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateCodes200ResponseInner
     */
    'StartDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateCodes200ResponseInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateCodes200ResponseInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetStateMembers200Response
 */
export interface GetStateMembers200Response {
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof GetStateMembers200Response
     */
    'pagination': GetStaff200ResponsePagination;
    /**
     * 
     * @type {Array<GetStateMembers200ResponseDataInner>}
     * @memberof GetStateMembers200Response
     */
    'data': Array<GetStateMembers200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetStateMembers200ResponseDataInner
 */
export interface GetStateMembers200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'imageUrl': string;
    /**
     * 
     * @type {any}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'ImageMimeType': any;
    /**
     * 
     * @type {boolean}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'IsCommittee': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'Role': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'Suffix': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'Phone': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'District': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'StateCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetStateMembers200ResponseDataInner
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface GetStatuteBlobUrl200Response
 */
export interface GetStatuteBlobUrl200Response {
    /**
     * 
     * @type {string}
     * @memberof GetStatuteBlobUrl200Response
     */
    'blobUrl': string | null;
}
/**
 * 
 * @export
 * @interface GetStatuteCompaniesOfInterest200Response
 */
export interface GetStatuteCompaniesOfInterest200Response {
    /**
     * 
     * @type {Array<CompanyMatch>}
     * @memberof GetStatuteCompaniesOfInterest200Response
     */
    'companies': Array<CompanyMatch>;
}
/**
 * 
 * @export
 * @interface GetSubjects200ResponseInner
 */
export interface GetSubjects200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetSubjects200ResponseInner
     */
    'Code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSubjects200ResponseInner
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface GetTagCompanyAssignmentStatus200Response
 */
export interface GetTagCompanyAssignmentStatus200Response {
    /**
     * 
     * @type {number}
     * @memberof GetTagCompanyAssignmentStatus200Response
     */
    'companyCount': number;
    /**
     * 
     * @type {Array<GetTagCompanyAssignmentStatus200ResponseTagsNeedingCompaniesInner>}
     * @memberof GetTagCompanyAssignmentStatus200Response
     */
    'tagsNeedingCompanies': Array<GetTagCompanyAssignmentStatus200ResponseTagsNeedingCompaniesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetTagCompanyAssignmentStatus200Response
     */
    'hasMultipleCompanies': boolean;
}
/**
 * 
 * @export
 * @interface GetTagCompanyAssignmentStatus200ResponseTagsNeedingCompaniesInner
 */
export interface GetTagCompanyAssignmentStatus200ResponseTagsNeedingCompaniesInner {
    /**
     * 
     * @type {string}
     * @memberof GetTagCompanyAssignmentStatus200ResponseTagsNeedingCompaniesInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetTagCompanyAssignmentStatus200ResponseTagsNeedingCompaniesInner
     */
    'tagId': number;
}
/**
 * 
 * @export
 * @interface GetTeam200Response
 */
export interface GetTeam200Response {
    /**
     * 
     * @type {Array<GetTeam200ResponseTasksInner>}
     * @memberof GetTeam200Response
     */
    'Tasks': Array<GetTeam200ResponseTasksInner>;
    /**
     * 
     * @type {GetTeam200ResponseManager}
     * @memberof GetTeam200Response
     */
    'Manager': GetTeam200ResponseManager;
    /**
     * 
     * @type {Array<GetTeam200ResponseTeamMembersInner>}
     * @memberof GetTeam200Response
     */
    'TeamMembers': Array<GetTeam200ResponseTeamMembersInner>;
    /**
     * 
     * @type {number}
     * @memberof GetTeam200Response
     */
    'ManagerId': number;
    /**
     * 
     * @type {number}
     * @memberof GetTeam200Response
     */
    'ParentId': number;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeam200Response
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200Response
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface GetTeam200ResponseManager
 */
export interface GetTeam200ResponseManager {
    /**
     * 
     * @type {Array<GetTeam200ResponseManagerAccountUserRelationshipsInner>}
     * @memberof GetTeam200ResponseManager
     */
    'AccountUserRelationships': Array<GetTeam200ResponseManagerAccountUserRelationshipsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetTeam200ResponseManager
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseManager
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseManager
     */
    'FirstName': string;
    /**
     * 
     * @type {GetTeam200ResponseManagerRole}
     * @memberof GetTeam200ResponseManager
     */
    'Role': GetTeam200ResponseManagerRole;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseManager
     */
    'Email': string;
}
/**
 * 
 * @export
 * @interface GetTeam200ResponseManagerAccountUserRelationshipsInner
 */
export interface GetTeam200ResponseManagerAccountUserRelationshipsInner {
    /**
     * 
     * @type {number}
     * @memberof GetTeam200ResponseManagerAccountUserRelationshipsInner
     */
    'AccountId': number;
}
/**
 * 
 * @export
 * @interface GetTeam200ResponseManagerRole
 */
export interface GetTeam200ResponseManagerRole {
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseManagerRole
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseManagerRole
     */
    'RoleName': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeam200ResponseManagerRole
     */
    'RoleId': number;
}
/**
 * 
 * @export
 * @interface GetTeam200ResponseTasksInner
 */
export interface GetTeam200ResponseTasksInner {
    /**
     * 
     * @type {GetTeams200ResponseInnerManager}
     * @memberof GetTeam200ResponseTasksInner
     */
    'AssignedTo': GetTeams200ResponseInnerManager;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTasksInner
     */
    'BillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTasksInner
     */
    'CompletedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTasksInner
     */
    'DueDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTasksInner
     */
    'Priority': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTasksInner
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTasksInner
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTasksInner
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTasksInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeam200ResponseTasksInner
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface GetTeam200ResponseTeamMembersInner
 */
export interface GetTeam200ResponseTeamMembersInner {
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTeamMembersInner
     */
    'JoinedAt': string;
    /**
     * 
     * @type {GetTeam200ResponseTeamMembersInnerUser}
     * @memberof GetTeam200ResponseTeamMembersInner
     */
    'User': GetTeam200ResponseTeamMembersInnerUser;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTeamMembersInner
     */
    'Role': string;
}
/**
 * 
 * @export
 * @interface GetTeam200ResponseTeamMembersInnerUser
 */
export interface GetTeam200ResponseTeamMembersInnerUser {
    /**
     * 
     * @type {Array<GetTeam200ResponseManagerAccountUserRelationshipsInner>}
     * @memberof GetTeam200ResponseTeamMembersInnerUser
     */
    'AccountUserRelationships': Array<GetTeam200ResponseManagerAccountUserRelationshipsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTeamMembersInnerUser
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTeamMembersInnerUser
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeam200ResponseTeamMembersInnerUser
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTeamMembersInnerUser
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTeamMembersInnerUser
     */
    'FirstName': string;
    /**
     * 
     * @type {GetTeam200ResponseManagerRole}
     * @memberof GetTeam200ResponseTeamMembersInnerUser
     */
    'Role': GetTeam200ResponseManagerRole;
    /**
     * 
     * @type {string}
     * @memberof GetTeam200ResponseTeamMembersInnerUser
     */
    'Email': string;
}
/**
 * 
 * @export
 * @interface GetTeams200ResponseInner
 */
export interface GetTeams200ResponseInner {
    /**
     * 
     * @type {GetTeams200ResponseInnerManager}
     * @memberof GetTeams200ResponseInner
     */
    'Manager': GetTeams200ResponseInnerManager;
    /**
     * 
     * @type {Array<GetTeams200ResponseInnerTeamMembersInner>}
     * @memberof GetTeams200ResponseInner
     */
    'TeamMembers': Array<GetTeams200ResponseInnerTeamMembersInner>;
    /**
     * 
     * @type {number}
     * @memberof GetTeams200ResponseInner
     */
    'ManagerId': number;
    /**
     * 
     * @type {number}
     * @memberof GetTeams200ResponseInner
     */
    'ParentId': number;
    /**
     * 
     * @type {string}
     * @memberof GetTeams200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeams200ResponseInner
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetTeams200ResponseInner
     */
    'Name': string;
}
/**
 * 
 * @export
 * @interface GetTeams200ResponseInnerManager
 */
export interface GetTeams200ResponseInnerManager {
    /**
     * 
     * @type {number}
     * @memberof GetTeams200ResponseInnerManager
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetTeams200ResponseInnerManager
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeams200ResponseInnerManager
     */
    'FirstName': string;
}
/**
 * 
 * @export
 * @interface GetTeams200ResponseInnerTeamMembersInner
 */
export interface GetTeams200ResponseInnerTeamMembersInner {
    /**
     * 
     * @type {GetTeams200ResponseInnerManager}
     * @memberof GetTeams200ResponseInnerTeamMembersInner
     */
    'User': GetTeams200ResponseInnerManager;
}
/**
 * 
 * @export
 * @interface GetTrackList200Response
 */
export interface GetTrackList200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTrackList200Response
     */
    'blobPath': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrackList200Response
     */
    'uploadedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetTrackList200Response
     */
    'failedBills': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrackList200Response
     */
    'successfulBills': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrackList200Response
     */
    'totalBills': number;
    /**
     * 
     * @type {string}
     * @memberof GetTrackList200Response
     */
    'session': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrackList200Response
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrackList200Response
     */
    'originalFilename': string;
    /**
     * 
     * @type {number}
     * @memberof GetTrackList200Response
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetTrackedBillProgress200ResponseInner
 */
export interface GetTrackedBillProgress200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetTrackedBillProgress200ResponseInner
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrackedBillProgress200ResponseInner
     */
    'event': number;
}
/**
 * 
 * @export
 * @interface GetTrackedLiveActions200Response
 */
export interface GetTrackedLiveActions200Response {
    /**
     * 
     * @type {GetTrackedLiveActions200ResponsePagination}
     * @memberof GetTrackedLiveActions200Response
     */
    'pagination': GetTrackedLiveActions200ResponsePagination;
    /**
     * 
     * @type {Array<LiveActionDto>}
     * @memberof GetTrackedLiveActions200Response
     */
    'data': Array<LiveActionDto>;
}
/**
 * 
 * @export
 * @interface GetTrackedLiveActions200ResponsePagination
 */
export interface GetTrackedLiveActions200ResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof GetTrackedLiveActions200ResponsePagination
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrackedLiveActions200ResponsePagination
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrackedLiveActions200ResponsePagination
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrackedLiveActions200ResponsePagination
     */
    'currentPage': number;
}
/**
 * 
 * @export
 * @interface GetTrackedLiveActionsCount200Response
 */
export interface GetTrackedLiveActionsCount200Response {
    /**
     * 
     * @type {number}
     * @memberof GetTrackedLiveActionsCount200Response
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface GetUpcomingHearings200ResponseInner
 */
export interface GetUpcomingHearings200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'VideoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'MinutesUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'AgendaUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'AgendaText': string;
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'HearingDateTime': string;
    /**
     * 
     * @type {GetUpcomingHearings200ResponseInnerCommitteeSession}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'CommitteeSession': GetUpcomingHearings200ResponseInnerCommitteeSession;
    /**
     * 
     * @type {number}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'HearingId': number;
    /**
     * 
     * @type {number}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInner
     */
    'Chamber': string;
}
/**
 * 
 * @export
 * @interface GetUpcomingHearings200ResponseInnerCommitteeSession
 */
export interface GetUpcomingHearings200ResponseInnerCommitteeSession {
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInnerCommitteeSession
     */
    'CommitteeName': string;
    /**
     * 
     * @type {number}
     * @memberof GetUpcomingHearings200ResponseInnerCommitteeSession
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInnerCommitteeSession
     */
    'Room': string;
    /**
     * 
     * @type {string}
     * @memberof GetUpcomingHearings200ResponseInnerCommitteeSession
     */
    'Chamber': string;
}
/**
 * 
 * @export
 * @interface GetUser200Response
 */
export interface GetUser200Response {
    /**
     * 
     * @type {Array<GetUser200ResponseUserStatesInner>}
     * @memberof GetUser200Response
     */
    'UserStates': Array<GetUser200ResponseUserStatesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetUser200Response
     */
    'NewUser': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUser200Response
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof GetUser200Response
     */
    'Username': string;
    /**
     * 
     * @type {string}
     * @memberof GetUser200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetUser200Response
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetUser200Response
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetUser200Response
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetUser200Response
     */
    'Email': string;
}
/**
 * 
 * @export
 * @interface GetUser200ResponseUserStatesInner
 */
export interface GetUser200ResponseUserStatesInner {
    /**
     * 
     * @type {string}
     * @memberof GetUser200ResponseUserStatesInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface GetUsers200ResponseInner
 */
export interface GetUsers200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'Username': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetUsers200ResponseInner
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'Email': string;
}
/**
 * 
 * @export
 * @interface GetVoteDetails200ResponseInner
 */
export interface GetVoteDetails200ResponseInner {
    /**
     * 
     * @type {GetVoteDetails200ResponseInnerMember}
     * @memberof GetVoteDetails200ResponseInner
     */
    'Member': GetVoteDetails200ResponseInnerMember;
    /**
     * 
     * @type {string}
     * @memberof GetVoteDetails200ResponseInner
     */
    'Position': string;
    /**
     * 
     * @type {number}
     * @memberof GetVoteDetails200ResponseInner
     */
    'MemberId': number;
    /**
     * 
     * @type {number}
     * @memberof GetVoteDetails200ResponseInner
     */
    'VoteId': number;
    /**
     * 
     * @type {number}
     * @memberof GetVoteDetails200ResponseInner
     */
    'VoteDetailId': number;
}
/**
 * 
 * @export
 * @interface GetVoteDetails200ResponseInnerMember
 */
export interface GetVoteDetails200ResponseInnerMember {
    /**
     * 
     * @type {string}
     * @memberof GetVoteDetails200ResponseInnerMember
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetVoteDetails200ResponseInnerMember
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetVoteDetails200ResponseInnerMember
     */
    'Party': string;
    /**
     * 
     * @type {string}
     * @memberof GetVoteDetails200ResponseInnerMember
     */
    'Chamber': string;
    /**
     * 
     * @type {string}
     * @memberof GetVoteDetails200ResponseInnerMember
     */
    'District': string;
    /**
     * 
     * @type {string}
     * @memberof GetVoteDetails200ResponseInnerMember
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof GetVoteDetails200ResponseInnerMember
     */
    'MemberId': number;
}
/**
 * 
 * @export
 * @interface GetVoteReport200Response
 */
export interface GetVoteReport200Response {
    /**
     * 
     * @type {string}
     * @memberof GetVoteReport200Response
     */
    'fileUrl': string | null;
    /**
     * 
     * @type {VoteReportSummary}
     * @memberof GetVoteReport200Response
     */
    'summary': VoteReportSummary;
    /**
     * 
     * @type {Array<VoteReportEntry>}
     * @memberof GetVoteReport200Response
     */
    'votes': Array<VoteReportEntry>;
}
/**
 * 
 * @export
 * @interface GmailCalendarRequestBody
 */
export interface GmailCalendarRequestBody {
    /**
     * 
     * @type {number}
     * @memberof GmailCalendarRequestBody
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GmailCalendarRequestBody
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof GmailCalendarRequestBody
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GmailCalendarRequestBody
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof GmailCalendarRequestBody
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof GmailCalendarRequestBody
     */
    'timeZone'?: string;
    /**
     * 
     * @type {string}
     * @memberof GmailCalendarRequestBody
     */
    'location'?: string;
}
/**
 * 
 * @export
 * @interface GmailIntegrationStatusResponse
 */
export interface GmailIntegrationStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GmailIntegrationStatusResponse
     */
    'connected': boolean;
    /**
     * 
     * @type {string}
     * @memberof GmailIntegrationStatusResponse
     */
    'emailAddress': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GmailIntegrationStatusResponse
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GmailIntegrationStatusResponse
     */
    'canSendEmail': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GmailIntegrationStatusResponse
     */
    'canManageCalendar': boolean;
    /**
     * 
     * @type {string}
     * @memberof GmailIntegrationStatusResponse
     */
    'updatedAt': string | null;
}
/**
 * 
 * @export
 * @interface GmailSendRequestBody
 */
export interface GmailSendRequestBody {
    /**
     * 
     * @type {number}
     * @memberof GmailSendRequestBody
     */
    'accountId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GmailSendRequestBody
     */
    'to': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GmailSendRequestBody
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof GmailSendRequestBody
     */
    'body': string;
}
/**
 * 
 * @export
 * @interface GuestTrackedActivityField
 */
export interface GuestTrackedActivityField {
    /**
     * 
     * @type {string}
     * @memberof GuestTrackedActivityField
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GuestTrackedActivityField
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface GuestTrackedActivityResponse
 */
export interface GuestTrackedActivityResponse {
    /**
     * 
     * @type {string}
     * @memberof GuestTrackedActivityResponse
     */
    'generatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuestTrackedActivityResponse
     */
    'fileUrl': string | null;
    /**
     * 
     * @type {Array<TrackingKeywordMatch>}
     * @memberof GuestTrackedActivityResponse
     */
    'keywordMatches': Array<TrackingKeywordMatch>;
    /**
     * 
     * @type {Array<GuestTrackedActivityField>}
     * @memberof GuestTrackedActivityResponse
     */
    'fields': Array<GuestTrackedActivityField>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof GuestTrackedActivityResponse
     */
    'records': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuestTrackedActivityResponse
     */
    'appliedStates': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuestTrackedActivityResponse
     */
    'appliedTags': Array<string>;
}
/**
 * 
 * @export
 * @interface ISummaryInner
 */
export interface ISummaryInner {
    /**
     * 
     * @type {number}
     * @memberof ISummaryInner
     */
    'endTime': number;
    /**
     * 
     * @type {number}
     * @memberof ISummaryInner
     */
    'startTime': number;
    /**
     * 
     * @type {string}
     * @memberof ISummaryInner
     */
    'summary': string;
}
/**
 * 
 * @export
 * @interface ITranscript
 */
export interface ITranscript {
    /**
     * 
     * @type {Array<LobbySpeakerTranscriptInner>}
     * @memberof ITranscript
     */
    'speakerTranscript': Array<LobbySpeakerTranscriptInner>;
    /**
     * 
     * @type {Array<Array<LobbyWordTranscriptInnerInner>>}
     * @memberof ITranscript
     */
    'wordTranscript': Array<Array<LobbyWordTranscriptInnerInner>>;
}
/**
 * 
 * @export
 * @interface ImportReportContactsRequest
 */
export interface ImportReportContactsRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportReportContactsRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ImportReportContactsRequest
     */
    'clientCompanyId'?: number;
    /**
     * 
     * @type {Array<ReportContactDto>}
     * @memberof ImportReportContactsRequest
     */
    'contacts': Array<ReportContactDto>;
}
/**
 * 
 * @export
 * @interface InsertUser
 */
export interface InsertUser {
    /**
     * 
     * @type {Array<string>}
     * @memberof InsertUser
     */
    'stateCodes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InsertUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof InsertUser
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof InsertUser
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof InsertUser
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof InsertUser
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof InsertUser
     */
    'accountName': string;
}
/**
 * 
 * @export
 * @interface InteractionPayload
 */
export interface InteractionPayload {
    /**
     * 
     * @type {number}
     * @memberof InteractionPayload
     */
    'ContactId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InteractionPayload
     */
    'InteractionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof InteractionPayload
     */
    'Subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof InteractionPayload
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InteractionPayload
     */
    'InteractionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InteractionPayload
     */
    'NextFollowUpDate'?: string;
}
/**
 * 
 * @export
 * @interface InviteUserRequest
 */
export interface InviteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'inviteeEmail': string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'inviteeFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'inviteeLastName': string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'inviteeStateCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'role'?: InviteUserRequestRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    'expirationDate'?: string;
}

export const InviteUserRequestRoleEnum = {
    Admin: 'Admin',
    Read: 'Read',
    Write: 'Write'
} as const;

export type InviteUserRequestRoleEnum = typeof InviteUserRequestRoleEnum[keyof typeof InviteUserRequestRoleEnum];

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    'amountPaid': number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    'amountDue': number;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'invoicePdf': string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'hostedInvoiceUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface IsSessionActive200Response
 */
export interface IsSessionActive200Response {
    /**
     * 
     * @type {boolean}
     * @memberof IsSessionActive200Response
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface KeywordDebugResult
 */
export interface KeywordDebugResult {
    /**
     * 
     * @type {KeywordDebugResultSummary}
     * @memberof KeywordDebugResult
     */
    'summary': KeywordDebugResultSummary;
    /**
     * 
     * @type {Array<KeywordDebugResultCompaniesInner>}
     * @memberof KeywordDebugResult
     */
    'companies': Array<KeywordDebugResultCompaniesInner>;
    /**
     * 
     * @type {Array<KeywordDebugResultBillVersionsInner>}
     * @memberof KeywordDebugResult
     */
    'billVersions': Array<KeywordDebugResultBillVersionsInner>;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: Array<string>; }}
     * @memberof KeywordDebugResult
     */
    'rawKeywordsByCompany': { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface KeywordDebugResultBillVersionsInner
 */
export interface KeywordDebugResultBillVersionsInner {
    /**
     * 
     * @type {Array<KeywordDebugResultBillVersionsInnerMatchedCompaniesInner>}
     * @memberof KeywordDebugResultBillVersionsInner
     */
    'matchedCompanies': Array<KeywordDebugResultBillVersionsInnerMatchedCompaniesInner>;
    /**
     * 
     * @type {string}
     * @memberof KeywordDebugResultBillVersionsInner
     */
    'latestVersionDate': string;
    /**
     * 
     * @type {string}
     * @memberof KeywordDebugResultBillVersionsInner
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof KeywordDebugResultBillVersionsInner
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof KeywordDebugResultBillVersionsInner
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof KeywordDebugResultBillVersionsInner
     */
    'billCode': string;
    /**
     * 
     * @type {string}
     * @memberof KeywordDebugResultBillVersionsInner
     */
    'masterBillId': string;
}
/**
 * 
 * @export
 * @interface KeywordDebugResultBillVersionsInnerMatchedCompaniesInner
 */
export interface KeywordDebugResultBillVersionsInnerMatchedCompaniesInner {
    /**
     * 
     * @type {Array<string>}
     * @memberof KeywordDebugResultBillVersionsInnerMatchedCompaniesInner
     */
    'matchedKeywords': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof KeywordDebugResultBillVersionsInnerMatchedCompaniesInner
     */
    'companyName': string;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultBillVersionsInnerMatchedCompaniesInner
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface KeywordDebugResultCompaniesInner
 */
export interface KeywordDebugResultCompaniesInner {
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultCompaniesInner
     */
    'matchedBills': number;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultCompaniesInner
     */
    'elasticHits': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof KeywordDebugResultCompaniesInner
     */
    'keywords': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof KeywordDebugResultCompaniesInner
     */
    'companyName': string;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultCompaniesInner
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface KeywordDebugResultSummary
 */
export interface KeywordDebugResultSummary {
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultSummary
     */
    'finalMatches': number;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultSummary
     */
    'elasticSearchHits': number;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultSummary
     */
    'billsWithNewVersions': number;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultSummary
     */
    'daysToSearch': number;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultSummary
     */
    'companiesWithKeywords': number;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultSummary
     */
    'totalKeywords': number;
    /**
     * 
     * @type {number}
     * @memberof KeywordDebugResultSummary
     */
    'accountId': number;
}
/**
 * 
 * @export
 * @interface KeywordGenerationCompanyInput
 */
export interface KeywordGenerationCompanyInput {
    /**
     * 
     * @type {number}
     * @memberof KeywordGenerationCompanyInput
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof KeywordGenerationCompanyInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof KeywordGenerationCompanyInput
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof KeywordGenerationCompanyInput
     */
    'masterCompanyId'?: number;
}
/**
 * 
 * @export
 * @interface KeywordGenerationStatusResponse
 */
export interface KeywordGenerationStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof KeywordGenerationStatusResponse
     */
    'isGenerating': boolean;
    /**
     * 
     * @type {number}
     * @memberof KeywordGenerationStatusResponse
     */
    'expiresInSeconds': number | null;
    /**
     * 
     * @type {string}
     * @memberof KeywordGenerationStatusResponse
     */
    'startedAt'?: string;
}
/**
 * 
 * @export
 * @interface KeywordWithUser
 */
export interface KeywordWithUser {
    /**
     * 
     * @type {string}
     * @memberof KeywordWithUser
     */
    'keyword': string;
    /**
     * 
     * @type {number}
     * @memberof KeywordWithUser
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof KeywordWithUser
     */
    'userName': string;
}
/**
 * 
 * @export
 * @interface LegislatorCommittee
 */
export interface LegislatorCommittee {
    /**
     * 
     * @type {number}
     * @memberof LegislatorCommittee
     */
    'committeeId': number;
    /**
     * 
     * @type {string}
     * @memberof LegislatorCommittee
     */
    'committeeName': string | null;
    /**
     * 
     * @type {string}
     * @memberof LegislatorCommittee
     */
    'memberPosition': LegislatorCommitteeMemberPositionEnum;
}

export const LegislatorCommitteeMemberPositionEnum = {
    Chair: 'Chair',
    ViceChair: 'Vice Chair'
} as const;

export type LegislatorCommitteeMemberPositionEnum = typeof LegislatorCommitteeMemberPositionEnum[keyof typeof LegislatorCommitteeMemberPositionEnum];

/**
 * 
 * @export
 * @interface LegislatorWithCount
 */
export interface LegislatorWithCount {
    /**
     * 
     * @type {number}
     * @memberof LegislatorWithCount
     */
    'memberId': number;
    /**
     * 
     * @type {string}
     * @memberof LegislatorWithCount
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof LegislatorWithCount
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof LegislatorWithCount
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof LegislatorWithCount
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof LegislatorWithCount
     */
    'party': string;
    /**
     * 
     * @type {string}
     * @memberof LegislatorWithCount
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof LegislatorWithCount
     */
    'role': string | null;
    /**
     * 
     * @type {number}
     * @memberof LegislatorWithCount
     */
    'connectionCount': number;
    /**
     * 
     * @type {Array<LegislatorCommittee>}
     * @memberof LegislatorWithCount
     */
    'committees': Array<LegislatorCommittee>;
}
/**
 * 
 * @export
 * @interface LiveActionDto
 */
export interface LiveActionDto {
    /**
     * 
     * @type {number}
     * @memberof LiveActionDto
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDto
     */
    'LiveId': number | null;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDto
     */
    'VideoId': number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'Chamber': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'Bill': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'Committee': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'Action': string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDto
     */
    'Ayes': number | null;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDto
     */
    'Nays': number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'Room': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'MeetingTime': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'MeetingDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'State': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'ContextSentence': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'Outcome': string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDto
     */
    'StartTime': number;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDto
     */
    'EndTime': number;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'Timestamp': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'BillTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDto
     */
    'BillAuthor'?: string | null;
    /**
     * 
     * @type {LiveActionDtoVideo}
     * @memberof LiveActionDto
     */
    'Video'?: LiveActionDtoVideo | null;
}
/**
 * 
 * @export
 * @interface LiveActionDtoVideo
 */
export interface LiveActionDtoVideo {
    /**
     * 
     * @type {boolean}
     * @memberof LiveActionDtoVideo
     */
    'IsFromLive': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'StateCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'NonTimeStampSummaryUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'SummaryUrl': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LiveActionDtoVideo
     */
    'IsStreaming': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDtoVideo
     */
    'CommitteeId': number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDtoVideo
     */
    'Duration': number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'OriginalSrc': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'TranscriptUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'Link': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'Committee': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'Chamber': string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveActionDtoVideo
     */
    'Date': string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveActionDtoVideo
     */
    'VideoId': number;
}
/**
 * 
 * @export
 * @interface LobbySpeakerTranscriptInner
 */
export interface LobbySpeakerTranscriptInner {
    /**
     * 
     * @type {number}
     * @memberof LobbySpeakerTranscriptInner
     */
    'endTime': number;
    /**
     * 
     * @type {number}
     * @memberof LobbySpeakerTranscriptInner
     */
    'startTime': number;
    /**
     * 
     * @type {string}
     * @memberof LobbySpeakerTranscriptInner
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof LobbySpeakerTranscriptInner
     */
    'speaker'?: string;
}
/**
 * 
 * @export
 * @interface LobbyWordTranscriptInnerInner
 */
export interface LobbyWordTranscriptInnerInner {
    /**
     * 
     * @type {number}
     * @memberof LobbyWordTranscriptInnerInner
     */
    'endTime': number;
    /**
     * 
     * @type {number}
     * @memberof LobbyWordTranscriptInnerInner
     */
    'startTime': number;
    /**
     * 
     * @type {string}
     * @memberof LobbyWordTranscriptInnerInner
     */
    'word': string;
}
/**
 * 
 * @export
 * @interface LobbyistAlertDto
 */
export interface LobbyistAlertDto {
    /**
     * 
     * @type {number}
     * @memberof LobbyistAlertDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof LobbyistAlertDto
     */
    'lobbyistId': string;
    /**
     * 
     * @type {string}
     * @memberof LobbyistAlertDto
     */
    'lobbyistName': string;
    /**
     * 
     * @type {string}
     * @memberof LobbyistAlertDto
     */
    'lobbyistFirm'?: string;
    /**
     * 
     * @type {string}
     * @memberof LobbyistAlertDto
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof LobbyistAlertDto
     */
    'registrationNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof LobbyistAlertDto
     */
    'userContactId': number;
    /**
     * 
     * @type {boolean}
     * @memberof LobbyistAlertDto
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LobbyistAlertDto
     */
    'phone': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LobbyistAlertDto
     */
    'web': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LobbyistAlertDto
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface LobbyistAnalyticsResponse
 */
export interface LobbyistAnalyticsResponse {
    /**
     * 
     * @type {LobbyistAnalyticsResponseTotals}
     * @memberof LobbyistAnalyticsResponse
     */
    'totals': LobbyistAnalyticsResponseTotals;
    /**
     * 
     * @type {Array<LobbyistTopRecord>}
     * @memberof LobbyistAnalyticsResponse
     */
    'topByClients': Array<LobbyistTopRecord>;
    /**
     * 
     * @type {Array<LobbyistTopRecord>}
     * @memberof LobbyistAnalyticsResponse
     */
    'topByCompensation': Array<LobbyistTopRecord>;
    /**
     * 
     * @type {Array<LobbyistTopRecord>}
     * @memberof LobbyistAnalyticsResponse
     */
    'topByTestimony': Array<LobbyistTopRecord>;
    /**
     * 
     * @type {Array<LobbyistTopRecord>}
     * @memberof LobbyistAnalyticsResponse
     */
    'topByContributions': Array<LobbyistTopRecord>;
}
/**
 * 
 * @export
 * @interface LobbyistAnalyticsResponseTotals
 */
export interface LobbyistAnalyticsResponseTotals {
    /**
     * 
     * @type {number}
     * @memberof LobbyistAnalyticsResponseTotals
     */
    'totalContributionAmount': number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistAnalyticsResponseTotals
     */
    'contributions': number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistAnalyticsResponseTotals
     */
    'testimonies': number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistAnalyticsResponseTotals
     */
    'engagements': number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistAnalyticsResponseTotals
     */
    'totalCompensationHigh': number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistAnalyticsResponseTotals
     */
    'totalCompensationLow': number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistAnalyticsResponseTotals
     */
    'lobbyists': number;
}
/**
 * 
 * @export
 * @interface LobbyistCreateRequest
 */
export interface LobbyistCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof LobbyistCreateRequest
     */
    'StateLobbyistID'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistMiddleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistAddress1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistAddress2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistZip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistWebsite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistRegisteredBranches'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistBusiness'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'LobbyistStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LobbyistCreateRequest
     */
    'StateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LobbyistCreateRequest
     */
    'FirmID'?: number | null;
}
/**
 * 
 * @export
 * @interface LobbyistTopRecord
 */
export interface LobbyistTopRecord {
    /**
     * 
     * @type {number}
     * @memberof LobbyistTopRecord
     */
    'lobbyistId': number;
    /**
     * 
     * @type {string}
     * @memberof LobbyistTopRecord
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof LobbyistTopRecord
     */
    'totalCompensationLow'?: number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistTopRecord
     */
    'totalCompensationHigh'?: number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistTopRecord
     */
    'contributionsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistTopRecord
     */
    'testimoniesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof LobbyistTopRecord
     */
    'clientsTotal'?: number;
}
/**
 * 
 * @export
 * @interface LogInteraction200Response
 */
export interface LogInteraction200Response {
    /**
     * 
     * @type {string}
     * @memberof LogInteraction200Response
     */
    'Subject': string;
    /**
     * 
     * @type {string}
     * @memberof LogInteraction200Response
     */
    'InteractionType': string;
    /**
     * 
     * @type {number}
     * @memberof LogInteraction200Response
     */
    'InteractionId': number;
    /**
     * 
     * @type {string}
     * @memberof LogInteraction200Response
     */
    'InteractionDate': string;
    /**
     * 
     * @type {number}
     * @memberof LogInteraction200Response
     */
    'ContactId': number;
    /**
     * 
     * @type {string}
     * @memberof LogInteraction200Response
     */
    'NextFollowUpDate': string;
    /**
     * 
     * @type {number}
     * @memberof LogInteraction200Response
     */
    'CompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof LogInteraction200Response
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof LogInteraction200Response
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof LogInteraction200Response
     */
    'UserId': number;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface MarkAsReadRequest
 */
export interface MarkAsReadRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof MarkAsReadRequest
     */
    'notificationIds': Array<number>;
}
/**
 * 
 * @export
 * @interface MasterBillSummary
 */
export interface MasterBillSummary {
    /**
     * 
     * @type {string}
     * @memberof MasterBillSummary
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof MasterBillSummary
     */
    'BillTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterBillSummary
     */
    'StateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterBillSummary
     */
    'SessionCode'?: string | null;
}
/**
 * 
 * @export
 * @interface MemberImagesBulkBody
 */
export interface MemberImagesBulkBody {
    /**
     * 
     * @type {Array<number>}
     * @memberof MemberImagesBulkBody
     */
    'memberIds': Array<number>;
}
/**
 * 
 * @export
 * @interface MemberListDto
 */
export interface MemberListDto {
    /**
     * 
     * @type {number}
     * @memberof MemberListDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MemberListDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MemberListDto
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof MemberListDto
     */
    'sessionCode': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof MemberListDto
     */
    'memberIds': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof MemberListDto
     */
    'memberCount': number;
    /**
     * 
     * @type {number}
     * @memberof MemberListDto
     */
    'accountId': number;
    /**
     * 
     * @type {number}
     * @memberof MemberListDto
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof MemberListDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MemberListDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface MemberRelationship
 */
export interface MemberRelationship {
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'contactRelationshipId': string;
    /**
     * 
     * @type {number}
     * @memberof MemberRelationship
     */
    'memberId': number;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'relationshipType': string | null;
    /**
     * 
     * @type {number}
     * @memberof MemberRelationship
     */
    'strength': number | null;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'notes': string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'startDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'endDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'createdAt': string;
    /**
     * 
     * @type {MemberRelationshipLobbyist}
     * @memberof MemberRelationship
     */
    'lobbyist': MemberRelationshipLobbyist;
    /**
     * 
     * @type {number}
     * @memberof MemberRelationship
     */
    'contributionAmount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'contributionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationship
     */
    'clientName'?: string | null;
}
/**
 * 
 * @export
 * @interface MemberRelationshipLobbyist
 */
export interface MemberRelationshipLobbyist {
    /**
     * 
     * @type {number}
     * @memberof MemberRelationshipLobbyist
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationshipLobbyist
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationshipLobbyist
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationshipLobbyist
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MemberRelationshipLobbyist
     */
    'firm'?: string | null;
}
/**
 * 
 * @export
 * @interface MemberTickSheetEntryDto
 */
export interface MemberTickSheetEntryDto {
    /**
     * 
     * @type {number}
     * @memberof MemberTickSheetEntryDto
     */
    'memberId': number;
    /**
     * 
     * @type {Position}
     * @memberof MemberTickSheetEntryDto
     */
    'position': Position;
    /**
     * 
     * @type {string}
     * @memberof MemberTickSheetEntryDto
     */
    'note': string;
    /**
     * 
     * @type {Chamber}
     * @memberof MemberTickSheetEntryDto
     */
    'chamber': Chamber;
    /**
     * 
     * @type {string}
     * @memberof MemberTickSheetEntryDto
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof MemberTickSheetEntryDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MemberTickSheetEntryDto
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface MemberTickSheetEntryInput
 */
export interface MemberTickSheetEntryInput {
    /**
     * 
     * @type {number}
     * @memberof MemberTickSheetEntryInput
     */
    'memberId': number;
    /**
     * 
     * @type {Position}
     * @memberof MemberTickSheetEntryInput
     */
    'position': Position;
    /**
     * 
     * @type {string}
     * @memberof MemberTickSheetEntryInput
     */
    'note'?: string;
}


/**
 * 
 * @export
 * @interface MissingLiveReportBody
 */
export interface MissingLiveReportBody {
    /**
     * 
     * @type {string}
     * @memberof MissingLiveReportBody
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof MissingLiveReportBody
     */
    'committee': string;
}
/**
 * 
 * @export
 * @interface MissingParamsRequest
 */
export interface MissingParamsRequest {
    /**
     * The name of the function the user attempted to call
     * @type {string}
     * @memberof MissingParamsRequest
     */
    'functionName': string;
    /**
     * Parameters that were provided by the user
     * @type {Array<string>}
     * @memberof MissingParamsRequest
     */
    'providedParams'?: Array<string>;
    /**
     * Parameters still required to complete the function call
     * @type {Array<string>}
     * @memberof MissingParamsRequest
     */
    'missingParams': Array<string>;
}
/**
 * 
 * @export
 * @interface MoveFileRequest
 */
export interface MoveFileRequest {
    /**
     * 
     * @type {number}
     * @memberof MoveFileRequest
     */
    'folderId': number | null;
}
/**
 * 
 * @export
 * @interface NewAnalystRequest
 */
export interface NewAnalystRequest {
    /**
     * 
     * @type {string}
     * @memberof NewAnalystRequest
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof NewAnalystRequest
     */
    'analystName': string;
}
/**
 * 
 * @export
 * @interface NewsArticle
 */
export interface NewsArticle {
    /**
     * 
     * @type {string}
     * @memberof NewsArticle
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NewsArticle
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof NewsArticle
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsArticle
     */
    'uri'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsArticle
     */
    'dateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsArticle
     */
    'source'?: string;
}
/**
 * 
 * @export
 * @interface NodeJSReadableStream
 */
export interface NodeJSReadableStream {
    /**
     * 
     * @type {boolean}
     * @memberof NodeJSReadableStream
     */
    'readable': boolean;
}
/**
 * 
 * @export
 * @interface NotableTimestamp
 */
export interface NotableTimestamp {
    /**
     * 
     * @type {number}
     * @memberof NotableTimestamp
     */
    'startTime': number;
    /**
     * 
     * @type {number}
     * @memberof NotableTimestamp
     */
    'endTime': number;
    /**
     * 
     * @type {string}
     * @memberof NotableTimestamp
     */
    'speaker': string;
    /**
     * 
     * @type {string}
     * @memberof NotableTimestamp
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof NotableTimestamp
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface PaginatedAutoTrackMatches
 */
export interface PaginatedAutoTrackMatches {
    /**
     * 
     * @type {Array<AutoTrackMatchDto>}
     * @memberof PaginatedAutoTrackMatches
     */
    'data': Array<AutoTrackMatchDto>;
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof PaginatedAutoTrackMatches
     */
    'pagination': GetStaff200ResponsePagination;
}
/**
 * 
 * @export
 * @interface PaginatedAutoTrackedBills
 */
export interface PaginatedAutoTrackedBills {
    /**
     * 
     * @type {Array<AutoTrackedBillDto>}
     * @memberof PaginatedAutoTrackedBills
     */
    'data': Array<AutoTrackedBillDto>;
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof PaginatedAutoTrackedBills
     */
    'pagination': GetStaff200ResponsePagination;
}
/**
 * 
 * @export
 * @interface PaginatedBills
 */
export interface PaginatedBills {
    /**
     * 
     * @type {Array<BillRecord>}
     * @memberof PaginatedBills
     */
    'data': Array<BillRecord>;
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof PaginatedBills
     */
    'pagination': GetStaff200ResponsePagination;
}
/**
 * 
 * @export
 * @interface PaginatedDataElasticSearchResult
 */
export interface PaginatedDataElasticSearchResult {
    /**
     * 
     * @type {GetLobbyists200ResponsePagination}
     * @memberof PaginatedDataElasticSearchResult
     */
    'pagination': GetLobbyists200ResponsePagination;
    /**
     * 
     * @type {Array<ElasticSearchResult>}
     * @memberof PaginatedDataElasticSearchResult
     */
    'data': Array<ElasticSearchResult>;
}
/**
 * 
 * @export
 * @interface PaginatedDataFileItem
 */
export interface PaginatedDataFileItem {
    /**
     * 
     * @type {GetLobbyists200ResponsePagination}
     * @memberof PaginatedDataFileItem
     */
    'pagination': GetLobbyists200ResponsePagination;
    /**
     * 
     * @type {Array<FileItem>}
     * @memberof PaginatedDataFileItem
     */
    'data': Array<FileItem>;
}
/**
 * 
 * @export
 * @interface PaginatedDataGetBillsDto
 */
export interface PaginatedDataGetBillsDto {
    /**
     * 
     * @type {GetLobbyists200ResponsePagination}
     * @memberof PaginatedDataGetBillsDto
     */
    'pagination': GetLobbyists200ResponsePagination;
    /**
     * 
     * @type {Array<BillListItemDto>}
     * @memberof PaginatedDataGetBillsDto
     */
    'data': Array<BillListItemDto>;
}
/**
 * 
 * @export
 * @interface PaginatedTrackedBillActivity
 */
export interface PaginatedTrackedBillActivity {
    /**
     * 
     * @type {Array<TrackedBillActivityDto>}
     * @memberof PaginatedTrackedBillActivity
     */
    'data': Array<TrackedBillActivityDto>;
    /**
     * 
     * @type {GetStaff200ResponsePagination}
     * @memberof PaginatedTrackedBillActivity
     */
    'pagination': GetStaff200ResponsePagination;
    /**
     * 
     * @type {RecordActivityTypeNumber}
     * @memberof PaginatedTrackedBillActivity
     */
    'counts'?: RecordActivityTypeNumber;
}
/**
 * 
 * @export
 * @interface ParentLevelInfo
 */
export interface ParentLevelInfo {
    /**
     * 
     * @type {string}
     * @memberof ParentLevelInfo
     */
    'parentLevelType': string | null;
    /**
     * 
     * @type {string}
     * @memberof ParentLevelInfo
     */
    'parentLevelName': string | null;
    /**
     * 
     * @type {number}
     * @memberof ParentLevelInfo
     */
    'currentLevel': number;
}
/**
 * 
 * @export
 * @interface ParsedBill
 */
export interface ParsedBill {
    /**
     * 
     * @type {string}
     * @memberof ParsedBill
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof ParsedBill
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof ParsedBill
     */
    'stateCode': string;
}
/**
 * Make all properties in T optional
 * @export
 * @interface PartialCreateIssueBody
 */
export interface PartialCreateIssueBody {
    /**
     * 
     * @type {string}
     * @memberof PartialCreateIssueBody
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialCreateIssueBody
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialCreateIssueBody
     */
    'route'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialCreateIssueBody
     */
    'issueType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialCreateIssueBody
     */
    'priority'?: PartialCreateIssueBodyPriorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PartialCreateIssueBody
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialCreateIssueBody
     */
    'tags'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialCreateIssueBody
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialCreateIssueBody
     */
    'screenshotUrl'?: string;
}

export const PartialCreateIssueBodyPriorityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type PartialCreateIssueBodyPriorityEnum = typeof PartialCreateIssueBodyPriorityEnum[keyof typeof PartialCreateIssueBodyPriorityEnum];

/**
 * Make all properties in T optional
 * @export
 * @interface PartialRecordRegHierarchyFieldString
 */
export interface PartialRecordRegHierarchyFieldString {
    /**
     * 
     * @type {string}
     * @memberof PartialRecordRegHierarchyFieldString
     */
    'level1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordRegHierarchyFieldString
     */
    'level2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordRegHierarchyFieldString
     */
    'level3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordRegHierarchyFieldString
     */
    'level4'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordRegHierarchyFieldString
     */
    'level5'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordRegHierarchyFieldString
     */
    'level6'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordRegHierarchyFieldString
     */
    'level7'?: string;
}
/**
 * 
 * @export
 * @interface PaymentHistory
 */
export interface PaymentHistory {
    /**
     * 
     * @type {Array<Invoice>}
     * @memberof PaymentHistory
     */
    'invoices': Array<Invoice>;
}
/**
 * 
 * @export
 * @interface PeelClusterBody
 */
export interface PeelClusterBody {
    /**
     * 
     * @type {Array<number>}
     * @memberof PeelClusterBody
     */
    'companyIds': Array<number>;
}
/**
 * 
 * @export
 * @interface PendingRegistrationResponseModel
 */
export interface PendingRegistrationResponseModel {
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'sessionId': string;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'organization': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PendingRegistrationResponseModel
     */
    'states': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'planId': string;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'expiresAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof PendingRegistrationResponseModel
     */
    'completed': boolean;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponseModel
     */
    'csrfToken'?: string;
}
/**
 * 
 * @export
 * @interface PopulateAdvancedFiltersResponse
 */
export interface PopulateAdvancedFiltersResponse {
    /**
     * 
     * @type {Array<StatutoryCodeResponse>}
     * @memberof PopulateAdvancedFiltersResponse
     */
    'statutoryCodes': Array<StatutoryCodeResponse>;
    /**
     * 
     * @type {Array<AuthorResponse>}
     * @memberof PopulateAdvancedFiltersResponse
     */
    'authors': Array<AuthorResponse>;
    /**
     * 
     * @type {Array<UserTagResponse>}
     * @memberof PopulateAdvancedFiltersResponse
     */
    'userTags': Array<UserTagResponse>;
    /**
     * 
     * @type {Array<UserTagResponse>}
     * @memberof PopulateAdvancedFiltersResponse
     */
    'accountTags': Array<UserTagResponse>;
}
/**
 * 
 * @export
 * @interface PortalAuthRequest
 */
export interface PortalAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof PortalAuthRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface PortalAuthResponse
 */
export interface PortalAuthResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PortalAuthResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof PortalAuthResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface PortalBillDetailsResponse
 */
export interface PortalBillDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponse
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponse
     */
    'billType': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponse
     */
    'billNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponse
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponse
     */
    'aiSummary': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponse
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponse
     */
    'sessionCode': string;
    /**
     * 
     * @type {Array<PortalBillDetailsResponseAuthorsInner>}
     * @memberof PortalBillDetailsResponse
     */
    'authors': Array<PortalBillDetailsResponseAuthorsInner>;
    /**
     * 
     * @type {Array<PortalBillDetailsResponseHistoryInner>}
     * @memberof PortalBillDetailsResponse
     */
    'history': Array<PortalBillDetailsResponseHistoryInner>;
}
/**
 * 
 * @export
 * @interface PortalBillDetailsResponseAuthorsInner
 */
export interface PortalBillDetailsResponseAuthorsInner {
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponseAuthorsInner
     */
    'party': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponseAuthorsInner
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponseAuthorsInner
     */
    'firstName': string;
}
/**
 * 
 * @export
 * @interface PortalBillDetailsResponseHistoryInner
 */
export interface PortalBillDetailsResponseHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponseHistoryInner
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponseHistoryInner
     */
    'actionCode': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponseHistoryInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof PortalBillDetailsResponseHistoryInner
     */
    'actionDate': string;
}
/**
 * 
 * @export
 * @interface PortalBillHistoryResponse
 */
export interface PortalBillHistoryResponse {
    /**
     * 
     * @type {Array<PortalBillDetailsResponseHistoryInner>}
     * @memberof PortalBillHistoryResponse
     */
    'history': Array<PortalBillDetailsResponseHistoryInner>;
}
/**
 * 
 * @export
 * @interface PortalCommentRequest
 */
export interface PortalCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof PortalCommentRequest
     */
    'scope': PortalCommentRequestScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortalCommentRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof PortalCommentRequest
     */
    'masterBillId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalCommentRequest
     */
    'authorName'?: string;
}

export const PortalCommentRequestScopeEnum = {
    Report: 'report',
    Bill: 'bill'
} as const;

export type PortalCommentRequestScopeEnum = typeof PortalCommentRequestScopeEnum[keyof typeof PortalCommentRequestScopeEnum];

/**
 * 
 * @export
 * @interface PortalInfoResponse
 */
export interface PortalInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof PortalInfoResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof PortalInfoResponse
     */
    'portalName': string;
    /**
     * 
     * @type {number}
     * @memberof PortalInfoResponse
     */
    'accountId': number;
    /**
     * 
     * @type {string}
     * @memberof PortalInfoResponse
     */
    'accountName': string;
    /**
     * 
     * @type {string}
     * @memberof PortalInfoResponse
     */
    'subdomain': string;
    /**
     * 
     * @type {PortalSettings}
     * @memberof PortalInfoResponse
     */
    'portalSettings': PortalSettings | null;
    /**
     * 
     * @type {Array<PortalPageResponse>}
     * @memberof PortalInfoResponse
     */
    'pages': Array<PortalPageResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof PortalInfoResponse
     */
    'requiresPassword': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalInfoResponse
     */
    'authenticated': boolean;
}
/**
 * 
 * @export
 * @interface PortalPageInput
 */
export interface PortalPageInput {
    /**
     * 
     * @type {number}
     * @memberof PortalPageInput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortalPageInput
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PortalPageInput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PortalPageInput
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof PortalPageInput
     */
    'pageType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PortalPageInput
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface PortalPageResponse
 */
export interface PortalPageResponse {
    /**
     * 
     * @type {number}
     * @memberof PortalPageResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PortalPageResponse
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PortalPageResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PortalPageResponse
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof PortalPageResponse
     */
    'pageType': string | null;
    /**
     * 
     * @type {number}
     * @memberof PortalPageResponse
     */
    'sortOrder': number;
}
/**
 * 
 * @export
 * @interface PortalRelationshipMemberInput
 */
export interface PortalRelationshipMemberInput {
    /**
     * 
     * @type {number}
     * @memberof PortalRelationshipMemberInput
     */
    'memberId': number;
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipMemberInput
     */
    'memberName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipMemberInput
     */
    'relationshipType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipMemberInput
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipMemberInput
     */
    'stateCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipMemberInput
     */
    'sessionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipMemberInput
     */
    'chamber'?: string;
}
/**
 * 
 * @export
 * @interface PortalRelationshipRequest
 */
export interface PortalRelationshipRequest {
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipRequest
     */
    'contactName': string;
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipRequest
     */
    'contactEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalRelationshipRequest
     */
    'organization'?: string;
    /**
     * 
     * @type {RelationshipContactType}
     * @memberof PortalRelationshipRequest
     */
    'contactType'?: RelationshipContactType;
    /**
     * 
     * @type {PortalViewerRelationshipContactReferenceId}
     * @memberof PortalRelationshipRequest
     */
    'contactReferenceId'?: PortalViewerRelationshipContactReferenceId;
    /**
     * 
     * @type {Array<PortalRelationshipMemberInput>}
     * @memberof PortalRelationshipRequest
     */
    'relationships': Array<PortalRelationshipMemberInput>;
}


/**
 * 
 * @export
 * @interface PortalSession
 */
export interface PortalSession {
    /**
     * 
     * @type {string}
     * @memberof PortalSession
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface PortalSettings
 */
export interface PortalSettings {
    /**
     * 
     * @type {string}
     * @memberof PortalSettings
     */
    'logoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettings
     */
    'brandColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettings
     */
    'accentColor'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortalSettings
     */
    'enabledPages'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PortalSettings
     */
    'welcomeMessage'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortalSettings
     */
    'allowedTags'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PortalSettings
     */
    'clientCompanyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortalSettings
     */
    'clientCompanyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PortalSettings
     */
    'reportSettingId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortalSettings
     */
    'reportSettingName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'autoShareCommitteeSummaries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'autoShareCommitteeClips'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PortalSettings
     */
    'autoShareClientCompanyIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'shareCompanyTickSheets'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'allowPortalTickSheetEdits'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'showRelationshipModule'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'showClipModule'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'showSummaryModule'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'showFeedbackModule'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalSettings
     */
    'persistFeedbackVisibility'?: boolean;
    /**
     * 
     * @type {Array<PortalSettingsCommitteeSummariesInner>}
     * @memberof PortalSettings
     */
    'committeeSummaries'?: Array<PortalSettingsCommitteeSummariesInner>;
    /**
     * 
     * @type {Array<PortalSettingsForwardedClipsInner>}
     * @memberof PortalSettings
     */
    'forwardedClips'?: Array<PortalSettingsForwardedClipsInner>;
    /**
     * 
     * @type {Array<PortalSettingsForwardedEventsInner>}
     * @memberof PortalSettings
     */
    'forwardedEvents'?: Array<PortalSettingsForwardedEventsInner>;
    /**
     * 
     * @type {Array<PortalSettingsViewerCommentsInner>}
     * @memberof PortalSettings
     */
    'viewerComments'?: Array<PortalSettingsViewerCommentsInner>;
    /**
     * 
     * @type {Array<PortalViewerRelationship>}
     * @memberof PortalSettings
     */
    'viewerRelationships'?: Array<PortalViewerRelationship>;
    /**
     * 
     * @type {Array<PortalTickSheetSummary>}
     * @memberof PortalSettings
     */
    'sharedTickSheets'?: Array<PortalTickSheetSummary>;
    /**
     * 
     * @type {PortalSettingsCompanyInfo}
     * @memberof PortalSettings
     */
    'companyInfo'?: PortalSettingsCompanyInfo;
    /**
     * 
     * @type {string}
     * @memberof PortalSettings
     */
    'contactEmail'?: string;
}
/**
 * 
 * @export
 * @interface PortalSettingsCommitteeSummariesInner
 */
export interface PortalSettingsCommitteeSummariesInner {
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'videoId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'videoDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'committeeTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'companyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCommitteeSummariesInner
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PortalSettingsCompanyInfo
 */
export interface PortalSettingsCompanyInfo {
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCompanyInfo
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCompanyInfo
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsCompanyInfo
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PortalSettingsForwardedClipsInner
 */
export interface PortalSettingsForwardedClipsInner {
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'sharedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'videoId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'videoDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'committeeTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedClipsInner
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PortalSettingsForwardedEventsInner
 */
export interface PortalSettingsForwardedEventsInner {
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedEventsInner
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedEventsInner
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedEventsInner
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedEventsInner
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedEventsInner
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsForwardedEventsInner
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PortalSettingsViewerCommentsInner
 */
export interface PortalSettingsViewerCommentsInner {
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsViewerCommentsInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsViewerCommentsInner
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsViewerCommentsInner
     */
    'authorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsViewerCommentsInner
     */
    'masterBillId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsViewerCommentsInner
     */
    'scope': PortalSettingsViewerCommentsInnerScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortalSettingsViewerCommentsInner
     */
    'id': string;
}

export const PortalSettingsViewerCommentsInnerScopeEnum = {
    Report: 'report',
    Bill: 'bill'
} as const;

export type PortalSettingsViewerCommentsInnerScopeEnum = typeof PortalSettingsViewerCommentsInnerScopeEnum[keyof typeof PortalSettingsViewerCommentsInnerScopeEnum];

/**
 * 
 * @export
 * @interface PortalTickSheetClient
 */
export interface PortalTickSheetClient {
    /**
     * 
     * @type {number}
     * @memberof PortalTickSheetClient
     */
    'clientCompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetClient
     */
    'clientCompanyName'?: string;
}
/**
 * 
 * @export
 * @interface PortalTickSheetDetailResponse
 */
export interface PortalTickSheetDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof PortalTickSheetDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<PortalTickSheetEntryPayload>}
     * @memberof PortalTickSheetDetailResponse
     */
    'entries': Array<PortalTickSheetEntryPayload>;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'billNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'billType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'stateCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'sessionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetDetailResponse
     */
    'billTitle'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortalTickSheetDetailResponse
     */
    'allowPortalTickSheetEdits'?: boolean;
}
/**
 * 
 * @export
 * @interface PortalTickSheetEntryPayload
 */
export interface PortalTickSheetEntryPayload {
    /**
     * 
     * @type {number}
     * @memberof PortalTickSheetEntryPayload
     */
    'memberId': number;
    /**
     * 
     * @type {TickSheetPosition}
     * @memberof PortalTickSheetEntryPayload
     */
    'position': TickSheetPosition;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetEntryPayload
     */
    'note': string;
    /**
     * 
     * @type {PortalTickSheetMember}
     * @memberof PortalTickSheetEntryPayload
     */
    'member'?: PortalTickSheetMember;
}


/**
 * 
 * @export
 * @interface PortalTickSheetMember
 */
export interface PortalTickSheetMember {
    /**
     * 
     * @type {number}
     * @memberof PortalTickSheetMember
     */
    'memberId': number;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetMember
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetMember
     */
    'district'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetMember
     */
    'party'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetMember
     */
    'chamber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetMember
     */
    'imageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface PortalTickSheetSummary
 */
export interface PortalTickSheetSummary {
    /**
     * 
     * @type {number}
     * @memberof PortalTickSheetSummary
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'chamber': string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<PortalTickSheetClient>}
     * @memberof PortalTickSheetSummary
     */
    'clients': Array<PortalTickSheetClient>;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'billNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'billType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'stateCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'sessionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetSummary
     */
    'billTitle'?: string;
}
/**
 * 
 * @export
 * @interface PortalTickSheetUpdateEntry
 */
export interface PortalTickSheetUpdateEntry {
    /**
     * 
     * @type {number}
     * @memberof PortalTickSheetUpdateEntry
     */
    'memberId': number;
    /**
     * 
     * @type {TickSheetPosition}
     * @memberof PortalTickSheetUpdateEntry
     */
    'position'?: TickSheetPosition;
    /**
     * 
     * @type {string}
     * @memberof PortalTickSheetUpdateEntry
     */
    'note'?: string;
}


/**
 * 
 * @export
 * @interface PortalTickSheetUpdateRequest
 */
export interface PortalTickSheetUpdateRequest {
    /**
     * 
     * @type {Array<PortalTickSheetUpdateEntry>}
     * @memberof PortalTickSheetUpdateRequest
     */
    'entries': Array<PortalTickSheetUpdateEntry>;
}
/**
 * 
 * @export
 * @interface PortalTrackedActivityField
 */
export interface PortalTrackedActivityField {
    /**
     * 
     * @type {string}
     * @memberof PortalTrackedActivityField
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof PortalTrackedActivityField
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface PortalTrackedActivityResponse
 */
export interface PortalTrackedActivityResponse {
    /**
     * 
     * @type {string}
     * @memberof PortalTrackedActivityResponse
     */
    'generatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalTrackedActivityResponse
     */
    'fileUrl': string | null;
    /**
     * 
     * @type {Array<TrackingKeywordMatch>}
     * @memberof PortalTrackedActivityResponse
     */
    'keywordMatches': Array<TrackingKeywordMatch>;
    /**
     * 
     * @type {Array<PortalTrackedActivityField>}
     * @memberof PortalTrackedActivityResponse
     */
    'fields': Array<PortalTrackedActivityField>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof PortalTrackedActivityResponse
     */
    'records': Array<{ [key: string]: any; }>;
}
/**
 * 
 * @export
 * @interface PortalViewerComment
 */
export interface PortalViewerComment {
    /**
     * 
     * @type {string}
     * @memberof PortalViewerComment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerComment
     */
    'scope': PortalViewerCommentScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerComment
     */
    'masterBillId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerComment
     */
    'authorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerComment
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerComment
     */
    'createdAt': string;
}

export const PortalViewerCommentScopeEnum = {
    Report: 'report',
    Bill: 'bill'
} as const;

export type PortalViewerCommentScopeEnum = typeof PortalViewerCommentScopeEnum[keyof typeof PortalViewerCommentScopeEnum];

/**
 * 
 * @export
 * @interface PortalViewerRelationship
 */
export interface PortalViewerRelationship {
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationship
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationship
     */
    'contactName': string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationship
     */
    'contactEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationship
     */
    'organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationship
     */
    'createdAt': string;
    /**
     * 
     * @type {RelationshipContactType}
     * @memberof PortalViewerRelationship
     */
    'contactType'?: RelationshipContactType;
    /**
     * 
     * @type {PortalViewerRelationshipContactReferenceId}
     * @memberof PortalViewerRelationship
     */
    'contactReferenceId'?: PortalViewerRelationshipContactReferenceId;
    /**
     * 
     * @type {Array<PortalViewerRelationshipEntry>}
     * @memberof PortalViewerRelationship
     */
    'relationships': Array<PortalViewerRelationshipEntry>;
}


/**
 * 
 * @export
 * @interface PortalViewerRelationshipContactReferenceId
 */
export interface PortalViewerRelationshipContactReferenceId {
}
/**
 * 
 * @export
 * @interface PortalViewerRelationshipEntry
 */
export interface PortalViewerRelationshipEntry {
    /**
     * 
     * @type {number}
     * @memberof PortalViewerRelationshipEntry
     */
    'memberId': number;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationshipEntry
     */
    'memberName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationshipEntry
     */
    'relationshipType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationshipEntry
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationshipEntry
     */
    'stateCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationshipEntry
     */
    'sessionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalViewerRelationshipEntry
     */
    'chamber'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Position = {
    Yes: 'yes',
    No: 'no',
    Neutral: 'neutral',
    Undecided: 'undecided'
} as const;

export type Position = typeof Position[keyof typeof Position];


/**
 * 
 * @export
 * @interface PriorityBillResponse
 */
export interface PriorityBillResponse {
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'billNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'billType': string;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'priority': string | null;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'impact': string | null;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'reasoning': string | null;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'aiAnalysis': string | null;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'aiReportUrl': string | null;
    /**
     * 
     * @type {any}
     * @memberof PriorityBillResponse
     */
    'aiReportData': any | null;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'outcome': string | null;
    /**
     * 
     * @type {number}
     * @memberof PriorityBillResponse
     */
    'score': number | null;
    /**
     * 
     * @type {string}
     * @memberof PriorityBillResponse
     */
    'createdAt': string;
}
/**
 * Batch Payload for updateMany & deleteMany & createMany
 * @export
 * @interface PrismaBatchPayload
 */
export interface PrismaBatchPayload {
    /**
     * 
     * @type {number}
     * @memberof PrismaBatchPayload
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PromotionCheckoutRequestModel
 */
export interface PromotionCheckoutRequestModel {
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'organization': string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'planId': PromotionCheckoutRequestModelPlanIdEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromotionCheckoutRequestModel
     */
    'states': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PromotionCheckoutRequestModel
     */
    'additionalUsers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PromotionCheckoutRequestModel
     */
    'tosAccepted': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'utmCampaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutRequestModel
     */
    'utmSource'?: string;
}

export const PromotionCheckoutRequestModelPlanIdEnum = {
    Discounted: 'discounted',
    FreeFirstYear: 'free-first-year',
    Escalating: 'escalating',
    _50State: '50-state',
    DcOnly: 'dc-only',
    UsPlus50: 'us-plus-50'
} as const;

export type PromotionCheckoutRequestModelPlanIdEnum = typeof PromotionCheckoutRequestModelPlanIdEnum[keyof typeof PromotionCheckoutRequestModelPlanIdEnum];

/**
 * 
 * @export
 * @interface PromotionCheckoutSessionResponseModel
 */
export interface PromotionCheckoutSessionResponseModel {
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutSessionResponseModel
     */
    'sessionId': string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutSessionResponseModel
     */
    'sessionUrl': string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutSessionResponseModel
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof PromotionCheckoutSessionResponseModel
     */
    'amountDueCents': number;
    /**
     * 
     * @type {number}
     * @memberof PromotionCheckoutSessionResponseModel
     */
    'renewalAmountCents'?: number;
    /**
     * 
     * @type {PromotionCheckoutSummaryModel}
     * @memberof PromotionCheckoutSessionResponseModel
     */
    'summary': PromotionCheckoutSummaryModel;
}
/**
 * 
 * @export
 * @interface PromotionCheckoutSummaryModel
 */
export interface PromotionCheckoutSummaryModel {
    /**
     * 
     * @type {string}
     * @memberof PromotionCheckoutSummaryModel
     */
    'planId': PromotionCheckoutSummaryModelPlanIdEnum;
    /**
     * 
     * @type {number}
     * @memberof PromotionCheckoutSummaryModel
     */
    'basePlanCents': number;
    /**
     * 
     * @type {number}
     * @memberof PromotionCheckoutSummaryModel
     */
    'additionalStateCents': number;
    /**
     * 
     * @type {number}
     * @memberof PromotionCheckoutSummaryModel
     */
    'additionalStateCount': number;
    /**
     * 
     * @type {number}
     * @memberof PromotionCheckoutSummaryModel
     */
    'totalStateCount': number;
}

export const PromotionCheckoutSummaryModelPlanIdEnum = {
    Discounted: 'discounted',
    FreeFirstYear: 'free-first-year',
    Escalating: 'escalating',
    _50State: '50-state',
    DcOnly: 'dc-only',
    UsPlus50: 'us-plus-50'
} as const;

export type PromotionCheckoutSummaryModelPlanIdEnum = typeof PromotionCheckoutSummaryModelPlanIdEnum[keyof typeof PromotionCheckoutSummaryModelPlanIdEnum];

/**
 * 
 * @export
 * @interface ProspectCreateRequest
 */
export interface ProspectCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'HowHeard'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Street'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'City'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'State'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'ZipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProspectCreateRequest
     */
    'LeadScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Priority'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'PhoneSecondary'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Website'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'LinkedinProfile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'PreferredContactMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'ReferredBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'JobTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Department'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProspectCreateRequest
     */
    'CompanySize'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Industry'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProspectCreateRequest
     */
    'AnnualRevenue'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'LastContactDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'NextFollowUpDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'Tags'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'AssignedTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProspectCreateRequest
     */
    'DiscountCode'?: string;
}
/**
 * 
 * @export
 * @interface PurchaseSeatsRequest
 */
export interface PurchaseSeatsRequest {
    /**
     * 
     * @type {number}
     * @memberof PurchaseSeatsRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface PurchaseSeatsResponse
 */
export interface PurchaseSeatsResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseSeatsResponse
     */
    'totalSeats': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSeatsResponse
     */
    'invoiceUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSeatsResponse
     */
    'invoiceStatus': string | null;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSeatsResponse
     */
    'amountDueCents': number | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSeatsResponse
     */
    'currency': string | null;
}
/**
 * 
 * @export
 * @interface QueueKeywordGenerationRequest
 */
export interface QueueKeywordGenerationRequest {
    /**
     * 
     * @type {Array<KeywordGenerationCompanyInput>}
     * @memberof QueueKeywordGenerationRequest
     */
    'companies': Array<KeywordGenerationCompanyInput>;
}
/**
 * 
 * @export
 * @interface QueueKeywordGenerationResponse
 */
export interface QueueKeywordGenerationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QueueKeywordGenerationResponse
     */
    'queued': boolean;
}
/**
 * 
 * @export
 * @interface RecentAnalysisResponse
 */
export interface RecentAnalysisResponse {
    /**
     * 
     * @type {number}
     * @memberof RecentAnalysisResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof RecentAnalysisResponse
     */
    'videoId': number;
    /**
     * 
     * @type {number}
     * @memberof RecentAnalysisResponse
     */
    'committeeId': number;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponse
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponse
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponse
     */
    'priority': string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponse
     */
    'impact': string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponse
     */
    'shortSummary': string | null;
    /**
     * 
     * @type {number}
     * @memberof RecentAnalysisResponse
     */
    'clipsCount': number;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponse
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponse
     */
    'blobStorageUrl': string | null;
    /**
     * 
     * @type {Array<RecentAnalysisResponseVideoClipsInner>}
     * @memberof RecentAnalysisResponse
     */
    'videoClips': Array<RecentAnalysisResponseVideoClipsInner>;
    /**
     * 
     * @type {Array<RecentAnalysisResponseSummariesInner>}
     * @memberof RecentAnalysisResponse
     */
    'summaries': Array<RecentAnalysisResponseSummariesInner>;
}
/**
 * 
 * @export
 * @interface RecentAnalysisResponseSummariesInner
 */
export interface RecentAnalysisResponseSummariesInner {
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponseSummariesInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponseSummariesInner
     */
    'summaryBlobUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponseSummariesInner
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponseSummariesInner
     */
    'companyName': string | null;
    /**
     * 
     * @type {number}
     * @memberof RecentAnalysisResponseSummariesInner
     */
    'summaryId': number;
}
/**
 * 
 * @export
 * @interface RecentAnalysisResponseVideoClipsInner
 */
export interface RecentAnalysisResponseVideoClipsInner {
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponseVideoClipsInner
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof RecentAnalysisResponseVideoClipsInner
     */
    'durationSeconds': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecentAnalysisResponseVideoClipsInner
     */
    'segmentCount': number | null;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponseVideoClipsInner
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentAnalysisResponseVideoClipsInner
     */
    'companyName': string | null;
    /**
     * 
     * @type {number}
     * @memberof RecentAnalysisResponseVideoClipsInner
     */
    'clipSetId': number;
}
/**
 * Construct a type with a set of properties K of type T
 * @export
 * @interface RecordActivityTypeNumber
 */
export interface RecordActivityTypeNumber {
    /**
     * 
     * @type {number}
     * @memberof RecordActivityTypeNumber
     */
    'all': number;
    /**
     * 
     * @type {number}
     * @memberof RecordActivityTypeNumber
     */
    'progress': number;
    /**
     * 
     * @type {number}
     * @memberof RecordActivityTypeNumber
     */
    'text': number;
    /**
     * 
     * @type {number}
     * @memberof RecordActivityTypeNumber
     */
    'votes': number;
}
/**
 * 
 * @export
 * @interface RecordStringArrayIdStringNameStringIsDefault63BooleanValueInner
 */
export interface RecordStringArrayIdStringNameStringIsDefault63BooleanValueInner {
    /**
     * 
     * @type {boolean}
     * @memberof RecordStringArrayIdStringNameStringIsDefault63BooleanValueInner
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecordStringArrayIdStringNameStringIsDefault63BooleanValueInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RecordStringArrayIdStringNameStringIsDefault63BooleanValueInner
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface RecordStringCountNumberTrackedByAccountBooleanTrackedByLobbyistBooleanValue
 */
export interface RecordStringCountNumberTrackedByAccountBooleanTrackedByLobbyistBooleanValue {
    /**
     * 
     * @type {boolean}
     * @memberof RecordStringCountNumberTrackedByAccountBooleanTrackedByLobbyistBooleanValue
     */
    'trackedByLobbyist': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecordStringCountNumberTrackedByAccountBooleanTrackedByLobbyistBooleanValue
     */
    'trackedByAccount': boolean;
    /**
     * 
     * @type {number}
     * @memberof RecordStringCountNumberTrackedByAccountBooleanTrackedByLobbyistBooleanValue
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ReferralInviteRequest
 */
export interface ReferralInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof ReferralInviteRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface RefreshDashboardCache200Response
 */
export interface RefreshDashboardCache200Response {
    /**
     * 
     * @type {string}
     * @memberof RefreshDashboardCache200Response
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof RefreshDashboardCache200Response
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RegHierarchyField = {
    Level1: 'level1',
    Level2: 'level2',
    Level3: 'level3',
    Level4: 'level4',
    Level5: 'level5',
    Level6: 'level6',
    Level7: 'level7'
} as const;

export type RegHierarchyField = typeof RegHierarchyField[keyof typeof RegHierarchyField];


/**
 * 
 * @export
 * @interface RegHierarchyItem
 */
export interface RegHierarchyItem {
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyItem
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof RegHierarchyItem
     */
    'count': number;
    /**
     * 
     * @type {boolean}
     * @memberof RegHierarchyItem
     */
    'hasChildren': boolean;
}
/**
 * 
 * @export
 * @interface RegHierarchyItemsResponse
 */
export interface RegHierarchyItemsResponse {
    /**
     * 
     * @type {Array<RegHierarchyItem>}
     * @memberof RegHierarchyItemsResponse
     */
    'items': Array<RegHierarchyItem>;
    /**
     * 
     * @type {SearchRemarks200ResponsePagination}
     * @memberof RegHierarchyItemsResponse
     */
    'pagination': SearchRemarks200ResponsePagination;
    /**
     * 
     * @type {RegHierarchyField}
     * @memberof RegHierarchyItemsResponse
     */
    'nextLevel': RegHierarchyField | null;
}


/**
 * 
 * @export
 * @interface RegHierarchyLevel
 */
export interface RegHierarchyLevel {
    /**
     * 
     * @type {RegHierarchyField}
     * @memberof RegHierarchyLevel
     */
    'field': RegHierarchyField;
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyLevel
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof RegHierarchyLevel
     */
    'distinctCount': number;
    /**
     * 
     * @type {number}
     * @memberof RegHierarchyLevel
     */
    'completeness': number;
}


/**
 * 
 * @export
 * @interface RegHierarchyRegsResponse
 */
export interface RegHierarchyRegsResponse {
    /**
     * 
     * @type {Array<RegHierarchyRegulation>}
     * @memberof RegHierarchyRegsResponse
     */
    'regs': Array<RegHierarchyRegulation>;
    /**
     * 
     * @type {SearchRemarks200ResponsePagination}
     * @memberof RegHierarchyRegsResponse
     */
    'pagination': SearchRemarks200ResponsePagination;
}
/**
 * 
 * @export
 * @interface RegHierarchyRegulation
 */
export interface RegHierarchyRegulation {
    /**
     * 
     * @type {number}
     * @memberof RegHierarchyRegulation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyRegulation
     */
    'indexName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyRegulation
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyRegulation
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyRegulation
     */
    'blobLocation'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyRegulation
     */
    'snippet'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyRegulation
     */
    'state'?: string;
    /**
     * 
     * @type {PartialRecordRegHierarchyFieldString}
     * @memberof RegHierarchyRegulation
     */
    'levelPath': PartialRecordRegHierarchyFieldString;
}
/**
 * 
 * @export
 * @interface RegHierarchyStateCount
 */
export interface RegHierarchyStateCount {
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyStateCount
     */
    'state': string;
    /**
     * 
     * @type {number}
     * @memberof RegHierarchyStateCount
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface RegHierarchyStructure
 */
export interface RegHierarchyStructure {
    /**
     * 
     * @type {string}
     * @memberof RegHierarchyStructure
     */
    'state': string;
    /**
     * 
     * @type {Array<RegHierarchyLevel>}
     * @memberof RegHierarchyStructure
     */
    'levels': Array<RegHierarchyLevel>;
}
/**
 * 
 * @export
 * @interface RegSearchResult
 */
export interface RegSearchResult {
    /**
     * 
     * @type {number}
     * @memberof RegSearchResult
     */
    'wordScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof RegSearchResult
     */
    'vectorScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegSearchResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RegSearchResult
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegSearchResult
     */
    'snippet'?: string;
}
/**
 * 
 * @export
 * @interface RegulationQuestionRequest
 */
export interface RegulationQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof RegulationQuestionRequest
     */
    'regulationId': string;
    /**
     * 
     * @type {string}
     * @memberof RegulationQuestionRequest
     */
    'question': string;
}
/**
 * 
 * @export
 * @interface RejectAutoTrackedBillBody
 */
export interface RejectAutoTrackedBillBody {
    /**
     * 
     * @type {string}
     * @memberof RejectAutoTrackedBillBody
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof RejectAutoTrackedBillBody
     */
    'reasoning'?: string;
    /**
     * 
     * @type {number}
     * @memberof RejectAutoTrackedBillBody
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface RelatedBillDto
 */
export interface RelatedBillDto {
    /**
     * 
     * @type {string}
     * @memberof RelatedBillDto
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedBillDto
     */
    'Type': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedBillDto
     */
    'Number': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedBillDto
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedBillDto
     */
    'CurrentBody': string | null;
    /**
     * 
     * @type {number}
     * @memberof RelatedBillDto
     */
    'score'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RelationshipContactType = {
    AccountUser: 'accountUser',
    Advocate: 'advocate',
    Other: 'other'
} as const;

export type RelationshipContactType = typeof RelationshipContactType[keyof typeof RelationshipContactType];


/**
 * 
 * @export
 * @interface RemoveTrackedBillBody
 */
export interface RemoveTrackedBillBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveTrackedBillBody
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof RemoveTrackedBillBody
     */
    'lobbyistIds': string;
    /**
     * 
     * @type {string}
     * @memberof RemoveTrackedBillBody
     */
    'accountId'?: string;
}
/**
 * 
 * @export
 * @interface RenameFileRequest
 */
export interface RenameFileRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameFileRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ReportContactDto
 */
export interface ReportContactDto {
    /**
     * 
     * @type {string}
     * @memberof ReportContactDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportContactDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportContactDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportContactDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportContactDto
     */
    'organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportContactDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportContactDto
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportContactDto
     */
    'clientCompanyId'?: number | null;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: string; }}
     * @memberof ReportContactDto
     */
    'customFields'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface ReportContactListDto
 */
export interface ReportContactListDto {
    /**
     * 
     * @type {number}
     * @memberof ReportContactListDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ReportContactListDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ReportContactListDto
     */
    'contactCount': number;
    /**
     * 
     * @type {number}
     * @memberof ReportContactListDto
     */
    'clientCompanyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportContactListDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ReportContactListDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ReportContactListWithContactsDto
 */
export interface ReportContactListWithContactsDto {
    /**
     * 
     * @type {number}
     * @memberof ReportContactListWithContactsDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ReportContactListWithContactsDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ReportContactListWithContactsDto
     */
    'contactCount': number;
    /**
     * 
     * @type {number}
     * @memberof ReportContactListWithContactsDto
     */
    'clientCompanyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportContactListWithContactsDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ReportContactListWithContactsDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<ReportContactDto>}
     * @memberof ReportContactListWithContactsDto
     */
    'contacts': Array<ReportContactDto>;
}
/**
 * 
 * @export
 * @interface ReportStatItem
 */
export interface ReportStatItem {
    /**
     * 
     * @type {number}
     * @memberof ReportStatItem
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ReportStatItem
     */
    'changePercent': number;
}
/**
 * 
 * @export
 * @interface ReportWrongCompanySummaryResponse
 */
export interface ReportWrongCompanySummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportWrongCompanySummaryResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof ReportWrongCompanySummaryResponse
     */
    'processing': boolean;
}
/**
 * 
 * @export
 * @interface ReportsStatsResponse
 */
export interface ReportsStatsResponse {
    /**
     * 
     * @type {ReportStatItem}
     * @memberof ReportsStatsResponse
     */
    'savedReports': ReportStatItem;
    /**
     * 
     * @type {ReportStatItem}
     * @memberof ReportsStatsResponse
     */
    'scheduledReports': ReportStatItem;
    /**
     * 
     * @type {ReportStatItem}
     * @memberof ReportsStatsResponse
     */
    'generatedReports': ReportStatItem;
    /**
     * 
     * @type {ReportStatItem}
     * @memberof ReportsStatsResponse
     */
    'reportDownloads': ReportStatItem;
}
/**
 * 
 * @export
 * @interface SaveAccountCompanyClaimsBody
 */
export interface SaveAccountCompanyClaimsBody {
    /**
     * 
     * @type {number}
     * @memberof SaveAccountCompanyClaimsBody
     */
    'companyId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveAccountCompanyClaimsBody
     */
    'stateCodes': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SaveAccountCompanyClaimsBody
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface SaveAccountCompanySummaryBody
 */
export interface SaveAccountCompanySummaryBody {
    /**
     * 
     * @type {number}
     * @memberof SaveAccountCompanySummaryBody
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof SaveAccountCompanySummaryBody
     */
    'accountFullSum': string;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: StateSpecificSummaryEntry; }}
     * @memberof SaveAccountCompanySummaryBody
     */
    'stateSpecificSummaries'?: { [key: string]: StateSpecificSummaryEntry; };
}
/**
 * 
 * @export
 * @interface SaveAutoTrackCompaniesBody
 */
export interface SaveAutoTrackCompaniesBody {
    /**
     * 
     * @type {Array<SaveAutoTrackCompaniesBodyCompaniesInner>}
     * @memberof SaveAutoTrackCompaniesBody
     */
    'companies': Array<SaveAutoTrackCompaniesBodyCompaniesInner>;
}
/**
 * 
 * @export
 * @interface SaveAutoTrackCompaniesBodyCompaniesInner
 */
export interface SaveAutoTrackCompaniesBodyCompaniesInner {
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveAutoTrackCompaniesBodyCompaniesInner
     */
    'keywords': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SaveAutoTrackCompaniesBodyCompaniesInner
     */
    'companyId': number;
}
/**
 * 
 * @export
 * @interface SaveAutoTrackStatesBody
 */
export interface SaveAutoTrackStatesBody {
    /**
     * 
     * @type {Array<AutoTrackStateDto>}
     * @memberof SaveAutoTrackStatesBody
     */
    'states': Array<AutoTrackStateDto>;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAutoTrackStatesBody
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAutoTrackStatesBody
     */
    'committeeAgentEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface SaveBillAlertBody
 */
export interface SaveBillAlertBody {
    /**
     * 
     * @type {string}
     * @memberof SaveBillAlertBody
     */
    'billId': string;
    /**
     * 
     * @type {number}
     * @memberof SaveBillAlertBody
     */
    'userContactId': number;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBillAlertBody
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBillAlertBody
     */
    'phone': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBillAlertBody
     */
    'web': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBillAlertBody
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface SaveBillTagsBody
 */
export interface SaveBillTagsBody {
    /**
     * 
     * @type {string}
     * @memberof SaveBillTagsBody
     */
    'billId': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveBillTagsBody
     */
    'tagIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SaveBillTagsBody
     */
    'sessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof SaveBillTagsBody
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface SaveCommitteeAgentStatesBody
 */
export interface SaveCommitteeAgentStatesBody {
    /**
     * 
     * @type {Array<CommitteeAgentStateDto>}
     * @memberof SaveCommitteeAgentStatesBody
     */
    'states': Array<CommitteeAgentStateDto>;
}
/**
 * 
 * @export
 * @interface SaveCommitteeAlertBody
 */
export interface SaveCommitteeAlertBody {
    /**
     * 
     * @type {number}
     * @memberof SaveCommitteeAlertBody
     */
    'committeeId': number;
    /**
     * 
     * @type {string}
     * @memberof SaveCommitteeAlertBody
     */
    'committeeName': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCommitteeAlertBody
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCommitteeAlertBody
     */
    'chamber'?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveCommitteeAlertBody
     */
    'userContactId': number;
    /**
     * 
     * @type {boolean}
     * @memberof SaveCommitteeAlertBody
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveCommitteeAlertBody
     */
    'phone': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveCommitteeAlertBody
     */
    'web': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveCommitteeAlertBody
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface SaveCompanyTickSheetBody
 */
export interface SaveCompanyTickSheetBody {
    /**
     * 
     * @type {Array<CompanyTickSheetEntryInput>}
     * @memberof SaveCompanyTickSheetBody
     */
    'entries': Array<CompanyTickSheetEntryInput>;
    /**
     * 
     * @type {string}
     * @memberof SaveCompanyTickSheetBody
     */
    'name': string;
    /**
     * 
     * @type {Array<TickSheetClientAssignment>}
     * @memberof SaveCompanyTickSheetBody
     */
    'clients'?: Array<TickSheetClientAssignment>;
}
/**
 * 
 * @export
 * @interface SaveLobbyistAlertBody
 */
export interface SaveLobbyistAlertBody {
    /**
     * 
     * @type {string}
     * @memberof SaveLobbyistAlertBody
     */
    'lobbyistId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveLobbyistAlertBody
     */
    'lobbyistName': string;
    /**
     * 
     * @type {string}
     * @memberof SaveLobbyistAlertBody
     */
    'lobbyistFirm'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveLobbyistAlertBody
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof SaveLobbyistAlertBody
     */
    'registrationNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveLobbyistAlertBody
     */
    'userContactId': number;
    /**
     * 
     * @type {boolean}
     * @memberof SaveLobbyistAlertBody
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveLobbyistAlertBody
     */
    'phone': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveLobbyistAlertBody
     */
    'web': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveLobbyistAlertBody
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface SaveMemberTickSheetBody
 */
export interface SaveMemberTickSheetBody {
    /**
     * 
     * @type {Chamber}
     * @memberof SaveMemberTickSheetBody
     */
    'chamber': Chamber;
    /**
     * 
     * @type {Array<MemberTickSheetEntryInput>}
     * @memberof SaveMemberTickSheetBody
     */
    'entries': Array<MemberTickSheetEntryInput>;
    /**
     * 
     * @type {string}
     * @memberof SaveMemberTickSheetBody
     */
    'name': string;
    /**
     * 
     * @type {Array<TickSheetClientAssignment>}
     * @memberof SaveMemberTickSheetBody
     */
    'clients'?: Array<TickSheetClientAssignment>;
}


/**
 * 
 * @export
 * @interface SaveReportSettingRequest
 */
export interface SaveReportSettingRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveReportSettingRequest
     */
    'reportName': string;
    /**
     * 
     * @type {string}
     * @memberof SaveReportSettingRequest
     */
    'reportType': string;
    /**
     * 
     * @type {string}
     * @memberof SaveReportSettingRequest
     */
    'settingsJson': string;
}
/**
 * 
 * @export
 * @interface SaveSectionTagsBody
 */
export interface SaveSectionTagsBody {
    /**
     * 
     * @type {string}
     * @memberof SaveSectionTagsBody
     */
    'sectionId': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveSectionTagsBody
     */
    'tagIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SaveSectionTagsBody
     */
    'sessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof SaveSectionTagsBody
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface SaveUserSettingsBody
 */
export interface SaveUserSettingsBody {
    /**
     * 
     * @type {Array<CompanyKeywords>}
     * @memberof SaveUserSettingsBody
     */
    'billKeywords': Array<CompanyKeywords>;
    /**
     * 
     * @type {Array<VideoKeywordEntry>}
     * @memberof SaveUserSettingsBody
     */
    'videoKeywords': Array<VideoKeywordEntry>;
    /**
     * 
     * @type {string}
     * @memberof SaveUserSettingsBody
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveUserSettingsBody
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveUserSettingsBody
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface SavedClipSet
 */
export interface SavedClipSet {
    /**
     * 
     * @type {number}
     * @memberof SavedClipSet
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SavedClipSet
     */
    'videoId': number;
    /**
     * 
     * @type {number}
     * @memberof SavedClipSet
     */
    'companyId': number | null;
    /**
     * 
     * @type {string}
     * @memberof SavedClipSet
     */
    'companyName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SavedClipSet
     */
    'title': string | null;
    /**
     * 
     * @type {number}
     * @memberof SavedClipSet
     */
    'segmentCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof SavedClipSet
     */
    'durationSeconds': number | null;
    /**
     * 
     * @type {string}
     * @memberof SavedClipSet
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<ClipSegment>}
     * @memberof SavedClipSet
     */
    'clips': Array<ClipSegment>;
}
/**
 * 
 * @export
 * @interface ScheduleReport200Response
 */
export interface ScheduleReport200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleReport200Response
     */
    'isDuplicate': boolean;
    /**
     * 
     * @type {number}
     * @memberof ScheduleReport200Response
     */
    'scheduleId': number;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleReport200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface ScheduleReportRequest
 */
export interface ScheduleReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ScheduleReportRequest
     */
    'reportSettingId': number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReportRequest
     */
    'scheduleType': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReportRequest
     */
    'scheduleTime': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReportRequest
     */
    'daysOfWeek'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduleReportRequest
     */
    'dayOfMonth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReportRequest
     */
    'cronExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleReportRequest
     */
    'timezone'?: string;
}
/**
 * 
 * @export
 * @interface SearchCompaniesForInvite200ResponseInner
 */
export interface SearchCompaniesForInvite200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof SearchCompaniesForInvite200ResponseInner
     */
    'LobbyistCount': number;
    /**
     * 
     * @type {string}
     * @memberof SearchCompaniesForInvite200ResponseInner
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof SearchCompaniesForInvite200ResponseInner
     */
    'MasterCompanyID': number;
}
/**
 * 
 * @export
 * @interface SearchRemarks200Response
 */
export interface SearchRemarks200Response {
    /**
     * 
     * @type {SearchRemarks200ResponsePagination}
     * @memberof SearchRemarks200Response
     */
    'pagination': SearchRemarks200ResponsePagination;
    /**
     * 
     * @type {Array<GetBillRemarks200ResponseInner>}
     * @memberof SearchRemarks200Response
     */
    'data': Array<GetBillRemarks200ResponseInner>;
}
/**
 * 
 * @export
 * @interface SearchRemarks200ResponsePagination
 */
export interface SearchRemarks200ResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof SearchRemarks200ResponsePagination
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SearchRemarks200ResponsePagination
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof SearchRemarks200ResponsePagination
     */
    'page': number;
}
/**
 * 
 * @export
 * @interface SeatInfo
 */
export interface SeatInfo {
    /**
     * 
     * @type {number}
     * @memberof SeatInfo
     */
    'totalSeats': number;
    /**
     * 
     * @type {number}
     * @memberof SeatInfo
     */
    'seatsUsed': number;
    /**
     * 
     * @type {number}
     * @memberof SeatInfo
     */
    'pendingInvites': number;
}
/**
 * 
 * @export
 * @interface SegmentSummaryResponse
 */
export interface SegmentSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof SegmentSummaryResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SegmentSummaryResponse
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof SegmentSummaryResponse
     */
    'companyName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SegmentSummaryResponse
     */
    'blobUrl': string;
    /**
     * 
     * @type {number}
     * @memberof SegmentSummaryResponse
     */
    'startTime': number;
    /**
     * 
     * @type {number}
     * @memberof SegmentSummaryResponse
     */
    'endTime': number;
}
/**
 * 
 * @export
 * @interface SendEmail500Response
 */
export interface SendEmail500Response {
    /**
     * 
     * @type {string}
     * @memberof SendEmail500Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface SendGmailTestMessage200Response
 */
export interface SendGmailTestMessage200Response {
    /**
     * 
     * @type {string}
     * @memberof SendGmailTestMessage200Response
     */
    'detail': string;
    /**
     * 
     * @type {boolean}
     * @memberof SendGmailTestMessage200Response
     */
    'delivered': boolean;
}
/**
 * 
 * @export
 * @interface SendGmailTestMessageRequest
 */
export interface SendGmailTestMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SendGmailTestMessageRequest
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof SendGmailTestMessageRequest
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface SendTaskReminder200Response
 */
export interface SendTaskReminder200Response {
    /**
     * 
     * @type {string}
     * @memberof SendTaskReminder200Response
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface SendTaskReminderRequest
 */
export interface SendTaskReminderRequest {
    /**
     * 
     * @type {string}
     * @memberof SendTaskReminderRequest
     */
    'via'?: SendTaskReminderRequestViaEnum;
}

export const SendTaskReminderRequestViaEnum = {
    Email: 'email',
    Sms: 'sms',
    Both: 'both'
} as const;

export type SendTaskReminderRequestViaEnum = typeof SendTaskReminderRequestViaEnum[keyof typeof SendTaskReminderRequestViaEnum];

/**
 * 
 * @export
 * @interface SessionData
 */
export interface SessionData {
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof SessionData
     */
    'isDefault': boolean;
}
/**
 * 
 * @export
 * @interface SessionRankings
 */
export interface SessionRankings {
    /**
     * 
     * @type {SessionRankingsPrevailingSide}
     * @memberof SessionRankings
     */
    'prevailingSide': SessionRankingsPrevailingSide;
    /**
     * 
     * @type {SessionRankingsVotesTaken}
     * @memberof SessionRankings
     */
    'votesTaken': SessionRankingsVotesTaken;
    /**
     * 
     * @type {SessionRankingsVotesTaken}
     * @memberof SessionRankings
     */
    'billsPassed': SessionRankingsVotesTaken;
    /**
     * 
     * @type {SessionRankingsVotesTaken}
     * @memberof SessionRankings
     */
    'billsFiled': SessionRankingsVotesTaken;
}
/**
 * 
 * @export
 * @interface SessionRankingsPrevailingSide
 */
export interface SessionRankingsPrevailingSide {
    /**
     * 
     * @type {number}
     * @memberof SessionRankingsPrevailingSide
     */
    'percentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SessionRankingsPrevailingSide
     */
    'outOf': number;
    /**
     * 
     * @type {number}
     * @memberof SessionRankingsPrevailingSide
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SessionRankingsPrevailingSide
     */
    'rank': number;
}
/**
 * 
 * @export
 * @interface SessionRankingsVotesTaken
 */
export interface SessionRankingsVotesTaken {
    /**
     * 
     * @type {number}
     * @memberof SessionRankingsVotesTaken
     */
    'outOf': number;
    /**
     * 
     * @type {number}
     * @memberof SessionRankingsVotesTaken
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SessionRankingsVotesTaken
     */
    'rank': number;
}
/**
 * 
 * @export
 * @interface ShareTagBody
 */
export interface ShareTagBody {
    /**
     * 
     * @type {number}
     * @memberof ShareTagBody
     */
    'tagId': number;
    /**
     * 
     * @type {number}
     * @memberof ShareTagBody
     */
    'accountId': number;
}
/**
 * 
 * @export
 * @interface SimpleBill
 */
export interface SimpleBill {
    /**
     * 
     * @type {string}
     * @memberof SimpleBill
     */
    'committee'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBill
     */
    'LastAction': string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBill
     */
    'StatusDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof SimpleBill
     */
    'Status': number | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBill
     */
    'Number': string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBill
     */
    'Type': string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBill
     */
    'Title': string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBill
     */
    'MasterBillId': string;
}
/**
 * 
 * @export
 * @interface SlackIntegrationStatusResponse
 */
export interface SlackIntegrationStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SlackIntegrationStatusResponse
     */
    'connected': boolean;
    /**
     * 
     * @type {string}
     * @memberof SlackIntegrationStatusResponse
     */
    'workspaceName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SlackIntegrationStatusResponse
     */
    'channelName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SlackIntegrationStatusResponse
     */
    'updatedAt': string | null;
}
/**
 * 
 * @export
 * @interface SlackTestRequest
 */
export interface SlackTestRequest {
    /**
     * 
     * @type {number}
     * @memberof SlackTestRequest
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SlackTestRequest
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface SlackTestResponse
 */
export interface SlackTestResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SlackTestResponse
     */
    'delivered': boolean;
    /**
     * 
     * @type {string}
     * @memberof SlackTestResponse
     */
    'detail': string;
}
/**
 * 
 * @export
 * @interface SponsorRecord
 */
export interface SponsorRecord {
    /**
     * 
     * @type {number}
     * @memberof SponsorRecord
     */
    'SponsorOrder': number;
    /**
     * 
     * @type {string}
     * @memberof SponsorRecord
     */
    'Session': string | null;
    /**
     * 
     * @type {number}
     * @memberof SponsorRecord
     */
    'SponsorType': number;
    /**
     * 
     * @type {string}
     * @memberof SponsorRecord
     */
    'State': string | null;
    /**
     * 
     * @type {number}
     * @memberof SponsorRecord
     */
    'MemberId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SponsorRecord
     */
    'SponsorId': number;
    /**
     * 
     * @type {string}
     * @memberof SponsorRecord
     */
    'MasterBillId': string;
}
/**
 * 
 * @export
 * @interface StakeholderContactInput
 */
export interface StakeholderContactInput {
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactInput
     */
    'organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactInput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactInput
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactInput
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactInput
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof StakeholderContactInput
     */
    'accountId'?: number;
}
/**
 * 
 * @export
 * @interface StakeholderContactResponse
 */
export interface StakeholderContactResponse {
    /**
     * 
     * @type {number}
     * @memberof StakeholderContactResponse
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderContactResponse
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderContactResponse
     */
    'AccountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactResponse
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactResponse
     */
    'Organization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactResponse
     */
    'Title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactResponse
     */
    'Email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactResponse
     */
    'Phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactResponse
     */
    'Notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactResponse
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactResponse
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {Array<StakeholderMeetingSummary>}
     * @memberof StakeholderContactResponse
     */
    'Meetings': Array<StakeholderMeetingSummary>;
}
/**
 * 
 * @export
 * @interface StakeholderContactSummary
 */
export interface StakeholderContactSummary {
    /**
     * 
     * @type {number}
     * @memberof StakeholderContactSummary
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderContactSummary
     */
    'UserId': number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderContactSummary
     */
    'AccountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactSummary
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactSummary
     */
    'Organization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactSummary
     */
    'Title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactSummary
     */
    'Email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactSummary
     */
    'Phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactSummary
     */
    'Notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactSummary
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderContactSummary
     */
    'UpdatedAt': string;
}
/**
 * 
 * @export
 * @interface StakeholderMeetingInput
 */
export interface StakeholderMeetingInput {
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingInput
     */
    'stakeholderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingInput
     */
    'stakeholderName': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingInput
     */
    'meetingDate': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingInput
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingInput
     */
    'meetingType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingInput
     */
    'discussionNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingInput
     */
    'outcomes'?: string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingInput
     */
    'followUpActions'?: string;
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingInput
     */
    'accountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingInput
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingInput
     */
    'masterBillId'?: string;
}
/**
 * 
 * @export
 * @interface StakeholderMeetingResponse
 */
export interface StakeholderMeetingResponse {
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingResponse
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingResponse
     */
    'StakeholderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'StakeholderName': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'MeetingDate': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'Location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'MeetingType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'DiscussionNotes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'Outcomes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'FollowUpActions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingResponse
     */
    'AccountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingResponse
     */
    'CompanyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'CompanyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'MasterBillId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingResponse
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {StakeholderContactSummary}
     * @memberof StakeholderMeetingResponse
     */
    'Stakeholder'?: StakeholderContactSummary;
    /**
     * 
     * @type {MasterBillSummary}
     * @memberof StakeholderMeetingResponse
     */
    'MasterBill'?: MasterBillSummary;
}
/**
 * 
 * @export
 * @interface StakeholderMeetingSummary
 */
export interface StakeholderMeetingSummary {
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingSummary
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingSummary
     */
    'StakeholderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'StakeholderName': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'MeetingDate': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'Location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'MeetingType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'DiscussionNotes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'Outcomes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'FollowUpActions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingSummary
     */
    'AccountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StakeholderMeetingSummary
     */
    'CompanyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'CompanyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'MasterBillId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof StakeholderMeetingSummary
     */
    'UpdatedAt': string;
}
/**
 * 
 * @export
 * @interface StatItem
 */
export interface StatItem {
    /**
     * 
     * @type {number}
     * @memberof StatItem
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof StatItem
     */
    'changePercent': number;
}
/**
 * 
 * @export
 * @interface StateSpecificSummaryEntry
 */
export interface StateSpecificSummaryEntry {
    /**
     * 
     * @type {string}
     * @memberof StateSpecificSummaryEntry
     */
    'background'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateSpecificSummaryEntry
     */
    'interests'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateSpecificSummaryEntry
     */
    'oppositions'?: string;
}
/**
 * 
 * @export
 * @interface StatuteDetails
 */
export interface StatuteDetails {
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'full_text': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'statute_id': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'article': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'chapter': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'section': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'section_name': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'full_section_id': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'indexed_at': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteDetails
     */
    'last_updated_date'?: string | null;
    /**
     * 
     * @type {StatuteDetailsWordCount}
     * @memberof StatuteDetails
     */
    'word_count'?: StatuteDetailsWordCount | null;
    /**
     * 
     * @type {StatuteDetailsWordCount}
     * @memberof StatuteDetails
     */
    'char_count'?: StatuteDetailsWordCount | null;
}
/**
 * 
 * @export
 * @interface StatuteDetailsWordCount
 */
export interface StatuteDetailsWordCount {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StatuteHierarchyField = {
    Code: 'code',
    Title: 'title',
    Subtitle: 'subtitle',
    Article: 'article',
    Chapter: 'chapter',
    Subchapter: 'subchapter',
    Section: 'section',
    Subsection: 'subsection'
} as const;

export type StatuteHierarchyField = typeof StatuteHierarchyField[keyof typeof StatuteHierarchyField];


/**
 * 
 * @export
 * @interface StatuteHierarchyItem
 */
export interface StatuteHierarchyItem {
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyItem
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof StatuteHierarchyItem
     */
    'count': number;
    /**
     * 
     * @type {boolean}
     * @memberof StatuteHierarchyItem
     */
    'hasChildren': boolean;
}
/**
 * 
 * @export
 * @interface StatuteHierarchyItemsResponse
 */
export interface StatuteHierarchyItemsResponse {
    /**
     * 
     * @type {Array<StatuteHierarchyItem>}
     * @memberof StatuteHierarchyItemsResponse
     */
    'items': Array<StatuteHierarchyItem>;
    /**
     * 
     * @type {SearchRemarks200ResponsePagination}
     * @memberof StatuteHierarchyItemsResponse
     */
    'pagination': SearchRemarks200ResponsePagination;
    /**
     * 
     * @type {StatuteHierarchyField}
     * @memberof StatuteHierarchyItemsResponse
     */
    'nextLevel': StatuteHierarchyField | null;
}


/**
 * 
 * @export
 * @interface StatuteHierarchyLevel
 */
export interface StatuteHierarchyLevel {
    /**
     * 
     * @type {StatuteHierarchyField}
     * @memberof StatuteHierarchyLevel
     */
    'field': StatuteHierarchyField;
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyLevel
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof StatuteHierarchyLevel
     */
    'distinctCount': number;
    /**
     * 
     * @type {number}
     * @memberof StatuteHierarchyLevel
     */
    'completeness': number;
}


/**
 * 
 * @export
 * @interface StatuteHierarchyStateCount
 */
export interface StatuteHierarchyStateCount {
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStateCount
     */
    'state': string;
    /**
     * 
     * @type {number}
     * @memberof StatuteHierarchyStateCount
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface StatuteHierarchyStatute
 */
export interface StatuteHierarchyStatute {
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStatute
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStatute
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStatute
     */
    'section'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStatute
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStatute
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStatute
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStatute
     */
    'snippet'?: string;
}
/**
 * 
 * @export
 * @interface StatuteHierarchyStatutesResponse
 */
export interface StatuteHierarchyStatutesResponse {
    /**
     * 
     * @type {Array<StatuteHierarchyStatute>}
     * @memberof StatuteHierarchyStatutesResponse
     */
    'statutes': Array<StatuteHierarchyStatute>;
    /**
     * 
     * @type {SearchRemarks200ResponsePagination}
     * @memberof StatuteHierarchyStatutesResponse
     */
    'pagination': SearchRemarks200ResponsePagination;
}
/**
 * 
 * @export
 * @interface StatuteHierarchyStructure
 */
export interface StatuteHierarchyStructure {
    /**
     * 
     * @type {string}
     * @memberof StatuteHierarchyStructure
     */
    'state': string;
    /**
     * 
     * @type {Array<StatuteHierarchyLevel>}
     * @memberof StatuteHierarchyStructure
     */
    'levels': Array<StatuteHierarchyLevel>;
}
/**
 * 
 * @export
 * @interface StatuteQuestionRequest
 */
export interface StatuteQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof StatuteQuestionRequest
     */
    'statuteId': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteQuestionRequest
     */
    'question': string;
}
/**
 * 
 * @export
 * @interface StatuteSearchResult
 */
export interface StatuteSearchResult {
    /**
     * 
     * @type {number}
     * @memberof StatuteSearchResult
     */
    'wordScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatuteSearchResult
     */
    'vectorScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof StatuteSearchResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StatuteSearchResult
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatuteSearchResult
     */
    'snippet'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatuteSearchResult
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatuteSearchResult
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface StatutoryCodeResponse
 */
export interface StatutoryCodeResponse {
    /**
     * 
     * @type {number}
     * @memberof StatutoryCodeResponse
     */
    'StatutoryCodeID': number;
    /**
     * 
     * @type {string}
     * @memberof StatutoryCodeResponse
     */
    'Code': string;
    /**
     * 
     * @type {string}
     * @memberof StatutoryCodeResponse
     */
    'Description': string;
    /**
     * 
     * @type {string}
     * @memberof StatutoryCodeResponse
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface StreamCommitteeClip200Response
 */
export interface StreamCommitteeClip200Response {
    /**
     * 
     * @type {string}
     * @memberof StreamCommitteeClip200Response
     */
    'videoDate': string;
    /**
     * 
     * @type {string}
     * @memberof StreamCommitteeClip200Response
     */
    'committee': string;
    /**
     * 
     * @type {Array<any>}
     * @memberof StreamCommitteeClip200Response
     */
    'timestamps': Array<any>;
    /**
     * 
     * @type {string}
     * @memberof StreamCommitteeClip200Response
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof StreamCommitteeClip200Response
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface SubscribeNewsletterRequest
 */
export interface SubscribeNewsletterRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscribeNewsletterRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SubscriptionDetails
 */
export interface SubscriptionDetails {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetails
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetails
     */
    'currentPeriodEnd': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetails
     */
    'currentPeriodStart': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionDetails
     */
    'cancelAtPeriodEnd': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetails
     */
    'canceledAt': string | null;
    /**
     * 
     * @type {SubscriptionDetailsPlan}
     * @memberof SubscriptionDetails
     */
    'plan'?: SubscriptionDetailsPlan;
}
/**
 * 
 * @export
 * @interface SubscriptionDetailsPlan
 */
export interface SubscriptionDetailsPlan {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailsPlan
     */
    'interval': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailsPlan
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDetailsPlan
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface SummaryPayload
 */
export interface SummaryPayload {
    /**
     * 
     * @type {string}
     * @memberof SummaryPayload
     */
    'ShortSum'?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryPayload
     */
    'FullSum'?: string;
}
/**
 * Synthetic history item when no detailed history exists.
 * @export
 * @interface SyntheticHistoryItemDto
 */
export interface SyntheticHistoryItemDto {
    /**
     * 
     * @type {string}
     * @memberof SyntheticHistoryItemDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof SyntheticHistoryItemDto
     */
    'action': string | null;
    /**
     * 
     * @type {string}
     * @memberof SyntheticHistoryItemDto
     */
    'chamber': string | null;
}
/**
 * 
 * @export
 * @interface TagInfo
 */
export interface TagInfo {
    /**
     * 
     * @type {DashboardTagTag}
     * @memberof TagInfo
     */
    'tag': DashboardTagTag;
    /**
     * 
     * @type {Array<BillInfo>}
     * @memberof TagInfo
     */
    'bills': Array<BillInfo>;
}
/**
 * 
 * @export
 * @interface Tags
 */
export interface Tags {
    /**
     * 
     * @type {number}
     * @memberof Tags
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof Tags
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof Tags
     */
    'CreatedByUserId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Tags
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Tags
     */
    'Color': string | null;
}
/**
 * 
 * @export
 * @interface TaskBillContentDto
 */
export interface TaskBillContentDto {
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDto
     */
    'BillVersionId': string;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDto
     */
    'TextVersion': string;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDto
     */
    'TextDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskBillContentDto
     */
    'VersionNumber': number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDto
     */
    'TextUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskBillContentDto
     */
    'TextType': number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDto
     */
    'MimeType': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDto
     */
    'content': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDto
     */
    'contentType': TaskBillContentDtoContentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TaskBillContentDto
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDto
     */
    'error'?: string;
    /**
     * 
     * @type {TaskBillContentDtoFallbackUrls}
     * @memberof TaskBillContentDto
     */
    'fallbackUrls'?: TaskBillContentDtoFallbackUrls;
}

export const TaskBillContentDtoContentTypeEnum = {
    Text: 'text',
    Unknown: 'unknown'
} as const;

export type TaskBillContentDtoContentTypeEnum = typeof TaskBillContentDtoContentTypeEnum[keyof typeof TaskBillContentDtoContentTypeEnum];

/**
 * 
 * @export
 * @interface TaskBillContentDtoFallbackUrls
 */
export interface TaskBillContentDtoFallbackUrls {
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDtoFallbackUrls
     */
    'original': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDtoFallbackUrls
     */
    'txt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskBillContentDtoFallbackUrls
     */
    'pdf': string;
}
/**
 * 
 * @export
 * @interface TaskFileDto
 */
export interface TaskFileDto {
    /**
     * 
     * @type {number}
     * @memberof TaskFileDto
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof TaskFileDto
     */
    'TaskId': number;
    /**
     * 
     * @type {string}
     * @memberof TaskFileDto
     */
    'FileName': string;
    /**
     * 
     * @type {number}
     * @memberof TaskFileDto
     */
    'FileSize': number;
    /**
     * 
     * @type {string}
     * @memberof TaskFileDto
     */
    'FileType': string;
    /**
     * 
     * @type {string}
     * @memberof TaskFileDto
     */
    'FilePath': string;
    /**
     * 
     * @type {string}
     * @memberof TaskFileDto
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskFileDto
     */
    'Username'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskFileDto
     */
    'UserId'?: number;
}
/**
 * 
 * @export
 * @interface TaskItemDto
 */
export interface TaskItemDto {
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'priority': string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'dueDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'billId': string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    'assignedUserId': number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'assignedUserName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    'assignedTeamId': number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'assignedTeamName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    'assignedToEmail': string;
}
/**
 * 
 * @export
 * @interface TaskListItemDto
 */
export interface TaskListItemDto {
    /**
     * 
     * @type {number}
     * @memberof TaskListItemDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'priority': string;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'dueDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'billId': string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskListItemDto
     */
    'assignedUserId': number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'assignedUserName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskListItemDto
     */
    'assignedTeamId': number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskListItemDto
     */
    'assignedTeamName'?: string;
}
/**
 * 
 * @export
 * @interface TaskMetricsDto
 */
export interface TaskMetricsDto {
    /**
     * 
     * @type {number}
     * @memberof TaskMetricsDto
     */
    'averageCompletionTime': number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskMetricsDto
     */
    'overdueTasks': number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskMetricsDto
     */
    'onHoldCount': number;
    /**
     * 
     * @type {number}
     * @memberof TaskMetricsDto
     */
    'inProgressCount': number;
    /**
     * 
     * @type {number}
     * @memberof TaskMetricsDto
     */
    'completedCount': number;
    /**
     * 
     * @type {number}
     * @memberof TaskMetricsDto
     */
    'assignedCount': number;
    /**
     * 
     * @type {number}
     * @memberof TaskMetricsDto
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface TaskNoteDto
 */
export interface TaskNoteDto {
    /**
     * 
     * @type {number}
     * @memberof TaskNoteDto
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof TaskNoteDto
     */
    'TaskId': number;
    /**
     * 
     * @type {string}
     * @memberof TaskNoteDto
     */
    'Content': string;
    /**
     * 
     * @type {string}
     * @memberof TaskNoteDto
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskNoteDto
     */
    'Username'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskNoteDto
     */
    'UserId'?: number;
}
/**
 * 
 * @export
 * @interface TestConnection200Response
 */
export interface TestConnection200Response {
    /**
     * 
     * @type {string}
     * @memberof TestConnection200Response
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof TestConnection200Response
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface TickSheetClientAssignment
 */
export interface TickSheetClientAssignment {
    /**
     * 
     * @type {number}
     * @memberof TickSheetClientAssignment
     */
    'clientCompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof TickSheetClientAssignment
     */
    'clientCompanyName'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TickSheetPosition = {
    Yes: 'yes',
    No: 'no',
    Neutral: 'neutral',
    Undecided: 'undecided'
} as const;

export type TickSheetPosition = typeof TickSheetPosition[keyof typeof TickSheetPosition];


/**
 * 
 * @export
 * @interface ToggleArchiveTagRequest
 */
export interface ToggleArchiveTagRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleArchiveTagRequest
     */
    'archived': boolean;
}
/**
 * 
 * @export
 * @interface TrackDownloadRequest
 */
export interface TrackDownloadRequest {
    /**
     * 
     * @type {string}
     * @memberof TrackDownloadRequest
     */
    'reportType': string;
    /**
     * 
     * @type {string}
     * @memberof TrackDownloadRequest
     */
    'reportName'?: string;
}
/**
 * 
 * @export
 * @interface TrackListUploadResponse
 */
export interface TrackListUploadResponse {
    /**
     * 
     * @type {Array<ParsedBill>}
     * @memberof TrackListUploadResponse
     */
    'successfulBills': Array<ParsedBill>;
    /**
     * 
     * @type {Array<TrackListUploadResponseNonExistentBillsInner>}
     * @memberof TrackListUploadResponse
     */
    'nonExistentBills': Array<TrackListUploadResponseNonExistentBillsInner>;
    /**
     * 
     * @type {TrackListUploadResponseSummary}
     * @memberof TrackListUploadResponse
     */
    'summary': TrackListUploadResponseSummary;
}
/**
 * 
 * @export
 * @interface TrackListUploadResponseNonExistentBillsInner
 */
export interface TrackListUploadResponseNonExistentBillsInner {
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackListUploadResponseNonExistentBillsInner
     */
    'foundInSessions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrackListUploadResponseNonExistentBillsInner
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof TrackListUploadResponseNonExistentBillsInner
     */
    'originalBillNumber': string;
    /**
     * 
     * @type {string}
     * @memberof TrackListUploadResponseNonExistentBillsInner
     */
    'billId': string;
}
/**
 * 
 * @export
 * @interface TrackListUploadResponseSummary
 */
export interface TrackListUploadResponseSummary {
    /**
     * 
     * @type {number}
     * @memberof TrackListUploadResponseSummary
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof TrackListUploadResponseSummary
     */
    'successful': number;
    /**
     * 
     * @type {number}
     * @memberof TrackListUploadResponseSummary
     */
    'totalProcessed': number;
}
/**
 * 
 * @export
 * @interface TrackWitnessRequest
 */
export interface TrackWitnessRequest {
    /**
     * 
     * @type {number}
     * @memberof TrackWitnessRequest
     */
    'witnessId': number;
}
/**
 * 
 * @export
 * @interface TrackedActivityAvailableFieldDto
 */
export interface TrackedActivityAvailableFieldDto {
    /**
     * 
     * @type {string}
     * @memberof TrackedActivityAvailableFieldDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof TrackedActivityAvailableFieldDto
     */
    'defaultLabel': string;
}
/**
 * 
 * @export
 * @interface TrackedActivityConfigResponse
 */
export interface TrackedActivityConfigResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TrackedActivityConfigResponse
     */
    'canViewReport': boolean;
    /**
     * 
     * @type {Array<TrackedActivityFieldConfigDto>}
     * @memberof TrackedActivityConfigResponse
     */
    'fields': Array<TrackedActivityFieldConfigDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackedActivityConfigResponse
     */
    'states': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackedActivityConfigResponse
     */
    'tags': Array<string>;
    /**
     * 
     * @type {Array<TrackedActivityAvailableFieldDto>}
     * @memberof TrackedActivityConfigResponse
     */
    'availableFields': Array<TrackedActivityAvailableFieldDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackedActivityConfigResponse
     */
    'availableStates': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackedActivityConfigResponse
     */
    'availableTags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrackedActivityConfigResponse
     */
    'cachedGeneratedAt': string | null;
}
/**
 * 
 * @export
 * @interface TrackedActivityEmailSettingsResponse
 */
export interface TrackedActivityEmailSettingsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackedActivityEmailSettingsResponse
     */
    'emails': Array<string>;
}
/**
 * 
 * @export
 * @interface TrackedActivityFieldConfigDto
 */
export interface TrackedActivityFieldConfigDto {
    /**
     * 
     * @type {string}
     * @memberof TrackedActivityFieldConfigDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof TrackedActivityFieldConfigDto
     */
    'label': string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackedActivityFieldConfigDto
     */
    'displayOrder': number;
}
/**
 * 
 * @export
 * @interface TrackedBillActivityDto
 */
export interface TrackedBillActivityDto {
    /**
     * 
     * @type {number}
     * @memberof TrackedBillActivityDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDto
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDto
     */
    'billNumber': string;
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDto
     */
    'billTitle': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDto
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDto
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDto
     */
    'actionDate': string;
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDto
     */
    'actionDescription': string;
    /**
     * 
     * @type {number}
     * @memberof TrackedBillActivityDto
     */
    'actionCode': number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDto
     */
    'chamber': string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackedBillActivityDto
     */
    'importance': number | null;
    /**
     * 
     * @type {Array<TrackedBillActivityDtoTagsInner>}
     * @memberof TrackedBillActivityDto
     */
    'tags': Array<TrackedBillActivityDtoTagsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackedBillActivityDto
     */
    'trackedBy': Array<string>;
}
/**
 * 
 * @export
 * @interface TrackedBillActivityDtoTagsInner
 */
export interface TrackedBillActivityDtoTagsInner {
    /**
     * 
     * @type {string}
     * @memberof TrackedBillActivityDtoTagsInner
     */
    'tagName': string;
    /**
     * 
     * @type {number}
     * @memberof TrackedBillActivityDtoTagsInner
     */
    'tagId': number;
}
/**
 * 
 * @export
 * @interface TrackedWitnessResponse
 */
export interface TrackedWitnessResponse {
    /**
     * 
     * @type {number}
     * @memberof TrackedWitnessResponse
     */
    'witnessId': number;
    /**
     * 
     * @type {string}
     * @memberof TrackedWitnessResponse
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackedWitnessResponse
     */
    'middleName': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackedWitnessResponse
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackedWitnessResponse
     */
    'stateCode': string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackedWitnessResponse
     */
    'lobbyistId': number | null;
    /**
     * 
     * @type {WitnessTrackingSource}
     * @memberof TrackedWitnessResponse
     */
    'source': WitnessTrackingSource;
    /**
     * 
     * @type {string}
     * @memberof TrackedWitnessResponse
     */
    'trackedAt': string | null;
}


/**
 * 
 * @export
 * @interface TrackingActivityReportResponse
 */
export interface TrackingActivityReportResponse {
    /**
     * 
     * @type {Array<any>}
     * @memberof TrackingActivityReportResponse
     */
    'data': Array<any>;
    /**
     * 
     * @type {string}
     * @memberof TrackingActivityReportResponse
     */
    'fileUrl': string | null;
    /**
     * 
     * @type {Array<TrackingKeywordMatch>}
     * @memberof TrackingActivityReportResponse
     */
    'keywordMatches': Array<TrackingKeywordMatch>;
}
/**
 * 
 * @export
 * @interface TrackingKeywordMatch
 */
export interface TrackingKeywordMatch {
    /**
     * 
     * @type {number}
     * @memberof TrackingKeywordMatch
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'billType': string;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'billNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'billTitle': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'stateUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'lastAction': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'statusDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'latestVersionDate': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackingKeywordMatch
     */
    'matchedKeywords': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'snippet': string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingKeywordMatch
     */
    'viewedAt': string | null;
}
/**
 * 
 * @export
 * @interface TrackingPreferencesPayload
 */
export interface TrackingPreferencesPayload {
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPreferencesPayload
     */
    'TrackCommittees'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPreferencesPayload
     */
    'TrackTestimony'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPreferencesPayload
     */
    'TrackContributions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPreferencesPayload
     */
    'TrackBills'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingPreferencesPayload
     */
    'EmailAlerts'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrackingPreferencesPayload
     */
    'AlertFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingPreferencesPayload
     */
    'CustomSettings'?: string;
}
/**
 * 
 * @export
 * @interface UpcomingHearingResponse
 */
export interface UpcomingHearingResponse {
    /**
     * 
     * @type {number}
     * @memberof UpcomingHearingResponse
     */
    'calendarId': number;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'masterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'billNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'billType': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'stateCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'sessionCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'eventDate': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'eventTime': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'location': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'billPriority': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'billImpact': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'billTitle': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'committeeName': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'authorName': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'autotrackReasoning': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponse
     */
    'aiSummary': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingHearingResponse
     */
    'trackedClients'?: Array<string>;
    /**
     * 
     * @type {UpcomingHearingResponseCommitteeAnalysis}
     * @memberof UpcomingHearingResponse
     */
    'committeeAnalysis'?: UpcomingHearingResponseCommitteeAnalysis;
}
/**
 * 
 * @export
 * @interface UpcomingHearingResponseCommitteeAnalysis
 */
export interface UpcomingHearingResponseCommitteeAnalysis {
    /**
     * 
     * @type {number}
     * @memberof UpcomingHearingResponseCommitteeAnalysis
     */
    'clipsCount': number;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponseCommitteeAnalysis
     */
    'shortSummary': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponseCommitteeAnalysis
     */
    'impact': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpcomingHearingResponseCommitteeAnalysis
     */
    'priority': string | null;
    /**
     * 
     * @type {number}
     * @memberof UpcomingHearingResponseCommitteeAnalysis
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface UpdateAIStrength200Response
 */
export interface UpdateAIStrength200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateAIStrength200Response
     */
    'aiStrength': string;
}
/**
 * 
 * @export
 * @interface UpdateAIStrengthRequest
 */
export interface UpdateAIStrengthRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAIStrengthRequest
     */
    'aiStrength': UpdateAIStrengthRequestAiStrengthEnum | null;
}

export const UpdateAIStrengthRequestAiStrengthEnum = {
    High: 'High',
    Medium: 'Medium',
    Low: 'Low'
} as const;

export type UpdateAIStrengthRequestAiStrengthEnum = typeof UpdateAIStrengthRequestAiStrengthEnum[keyof typeof UpdateAIStrengthRequestAiStrengthEnum];

/**
 * 
 * @export
 * @interface UpdateAccountEntityRequest
 */
export interface UpdateAccountEntityRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountEntityRequest
     */
    'lobbyistId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountEntityRequest
     */
    'firmId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountEntityRequest
     */
    'companyId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateBillPriorityImpactRequest
 */
export interface UpdateBillPriorityImpactRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBillPriorityImpactRequest
     */
    'impact'?: UpdateBillPriorityImpactRequestImpactEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBillPriorityImpactRequest
     */
    'priority'?: UpdateBillPriorityImpactRequestPriorityEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBillPriorityImpactRequest
     */
    'masterBillId': string;
}

export const UpdateBillPriorityImpactRequestImpactEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type UpdateBillPriorityImpactRequestImpactEnum = typeof UpdateBillPriorityImpactRequestImpactEnum[keyof typeof UpdateBillPriorityImpactRequestImpactEnum];
export const UpdateBillPriorityImpactRequestPriorityEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type UpdateBillPriorityImpactRequestPriorityEnum = typeof UpdateBillPriorityImpactRequestPriorityEnum[keyof typeof UpdateBillPriorityImpactRequestPriorityEnum];

/**
 * 
 * @export
 * @interface UpdateBillRemarkBody
 */
export interface UpdateBillRemarkBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBillRemarkBody
     */
    'description': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateBillRemarkBody
     */
    'tags'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBillRemarkBody
     */
    'convertToPersonal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBillRemarkBody
     */
    'convertToAccount'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateClipArchivedRequest
 */
export interface UpdateClipArchivedRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClipArchivedRequest
     */
    'archived': boolean;
}
/**
 * 
 * @export
 * @interface UpdateCommitteeAgentEnabledRequest
 */
export interface UpdateCommitteeAgentEnabledRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCommitteeAgentEnabledRequest
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface UpdateCompanyStatus200Response
 */
export interface UpdateCompanyStatus200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyStatus200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyStatus200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface UpdateCompanyStatusRequest
 */
export interface UpdateCompanyStatusRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyStatusRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface UpdateCompanySummary200Response
 */
export interface UpdateCompanySummary200Response {
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200Response
     */
    'ExpectedInterest': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanySummary200Response
     */
    'ManualCreation': boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200Response
     */
    'MasterCompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyWebsite': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyEmail': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyPhone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyZip': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyState': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyCity': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyFullAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'BeneficialName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'ContractualName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyName': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200Response
     */
    'Outreach': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200Response
     */
    'CompanyID': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'StateCode': string;
    /**
     * 
     * @type {GetClientDetails200ResponseClientTrackingPreferences}
     * @memberof UpdateCompanySummary200Response
     */
    'ClientTrackingPreferences': GetClientDetails200ResponseClientTrackingPreferences;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseClientContactsInner>}
     * @memberof UpdateCompanySummary200Response
     */
    'ClientContacts': Array<GetClientDetails200ResponseClientContactsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseFirmEngagementsInner>}
     * @memberof UpdateCompanySummary200Response
     */
    'FirmEngagements': Array<GetClientDetails200ResponseFirmEngagementsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseLobbyEngagementsInner>}
     * @memberof UpdateCompanySummary200Response
     */
    'LobbyEngagements': Array<GetClientDetails200ResponseLobbyEngagementsInner>;
    /**
     * 
     * @type {Array<UpdateCompanySummary200ResponseCommitteeTestimoniesInner>}
     * @memberof UpdateCompanySummary200Response
     */
    'CommitteeTestimonies': Array<UpdateCompanySummary200ResponseCommitteeTestimoniesInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseCommitteeVideoClipsInner>}
     * @memberof UpdateCompanySummary200Response
     */
    'CommitteeVideoClips': Array<GetClientDetails200ResponseCommitteeVideoClipsInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseCommitteeVideoSummariesInner>}
     * @memberof UpdateCompanySummary200Response
     */
    'CommitteeVideoSummaries': Array<GetClientDetails200ResponseCommitteeVideoSummariesInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseUserStorageFilesInner>}
     * @memberof UpdateCompanySummary200Response
     */
    'UserStorageFiles': Array<GetClientDetails200ResponseUserStorageFilesInner>;
    /**
     * 
     * @type {Array<GetClientDetails200ResponseClientInteractionsInner>}
     * @memberof UpdateCompanySummary200Response
     */
    'ClientInteractions': Array<GetClientDetails200ResponseClientInteractionsInner>;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200Response
     */
    'StateCompanyID': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanySummary200Response
     */
    'DoNotContact': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'FullSum': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200Response
     */
    'ShortSum': string;
}
/**
 * 
 * @export
 * @interface UpdateCompanySummary200ResponseCommitteeTestimoniesInner
 */
export interface UpdateCompanySummary200ResponseCommitteeTestimoniesInner {
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'CommitteeSession': GetClientDetails200ResponseCommitteeTestimoniesInnerCommitteeSession;
    /**
     * 
     * @type {GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'MasterBill': GetClientDetails200ResponseCommitteeTestimoniesInnerMasterBill;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'TestimonyYear': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'EndTime': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'StartTime': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'HearingId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'Organization': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'CompanyID': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'LobbyistID': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'TestimonyDate': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'BillSupportingDocumentsId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'MasterBillId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'WitnessId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'TestimonyId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'CreatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'CommitteeId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'StateCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanySummary200ResponseCommitteeTestimoniesInner
     */
    'Position': string;
}
/**
 * 
 * @export
 * @interface UpdateFolderColorSettingRequest
 */
export interface UpdateFolderColorSettingRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFolderColorSettingRequest
     */
    'color'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateIssueRequest
 */
export interface UpdateIssueRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'route'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'issueType'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'priority'?: UpdateIssueRequestPriorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateIssueRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'tags'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'screenshotUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'assignedTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueRequest
     */
    'status'?: UpdateIssueRequestStatusEnum;
}

export const UpdateIssueRequestPriorityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type UpdateIssueRequestPriorityEnum = typeof UpdateIssueRequestPriorityEnum[keyof typeof UpdateIssueRequestPriorityEnum];
export const UpdateIssueRequestStatusEnum = {
    Open: 'Open',
    InProgress: 'In Progress',
    Resolved: 'Resolved',
    Closed: 'Closed'
} as const;

export type UpdateIssueRequestStatusEnum = typeof UpdateIssueRequestStatusEnum[keyof typeof UpdateIssueRequestStatusEnum];

/**
 * 
 * @export
 * @interface UpdateKeywordMatchViewed200Response
 */
export interface UpdateKeywordMatchViewed200Response {
    /**
     * 
     * @type {Array<TrackingKeywordMatch>}
     * @memberof UpdateKeywordMatchViewed200Response
     */
    'keywordMatches': Array<TrackingKeywordMatch>;
}
/**
 * 
 * @export
 * @interface UpdateKeywordMatchViewedRequest
 */
export interface UpdateKeywordMatchViewedRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateKeywordMatchViewedRequest
     */
    'billIds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateKeywordMatchViewedRequest
     */
    'viewed': boolean;
}
/**
 * 
 * @export
 * @interface UpdateKeywordsRequest
 */
export interface UpdateKeywordsRequest {
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: Array<string>; }}
     * @memberof UpdateKeywordsRequest
     */
    'keywordsByCompany': { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface UpdateMemberListRequest
 */
export interface UpdateMemberListRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMemberListRequest
     */
    'replace'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateMemberListRequest
     */
    'memberIds': Array<number>;
}
/**
 * 
 * @export
 * @interface UpdateMetadataRequest
 */
export interface UpdateMetadataRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMetadataRequest
     */
    'masterBillId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMetadataRequest
     */
    'companyId'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdatePortalRequest
 */
export interface UpdatePortalRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePortalRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePortalRequest
     */
    'subdomain'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePortalRequest
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {PortalSettings}
     * @memberof UpdatePortalRequest
     */
    'portalSettings'?: PortalSettings;
    /**
     * 
     * @type {string}
     * @memberof UpdatePortalRequest
     */
    'portalPassword'?: string | null;
    /**
     * 
     * @type {Array<PortalPageInput>}
     * @memberof UpdatePortalRequest
     */
    'pages'?: Array<PortalPageInput>;
}
/**
 * 
 * @export
 * @interface UpdatePriorityImpactRequest
 */
export interface UpdatePriorityImpactRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePriorityImpactRequest
     */
    'impact'?: UpdatePriorityImpactRequestImpactEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePriorityImpactRequest
     */
    'priority'?: UpdatePriorityImpactRequestPriorityEnum | null;
}

export const UpdatePriorityImpactRequestImpactEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type UpdatePriorityImpactRequestImpactEnum = typeof UpdatePriorityImpactRequestImpactEnum[keyof typeof UpdatePriorityImpactRequestImpactEnum];
export const UpdatePriorityImpactRequestPriorityEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type UpdatePriorityImpactRequestPriorityEnum = typeof UpdatePriorityImpactRequestPriorityEnum[keyof typeof UpdatePriorityImpactRequestPriorityEnum];

/**
 * 
 * @export
 * @interface UpdateReportSettingRequest
 */
export interface UpdateReportSettingRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateReportSettingRequest
     */
    'reportSettingId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportSettingRequest
     */
    'reportName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportSettingRequest
     */
    'settingsJson': string;
}
/**
 * 
 * @export
 * @interface UpdateSeatsRequest
 */
export interface UpdateSeatsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateSeatsRequest
     */
    'totalSeats': number;
}
/**
 * 
 * @export
 * @interface UpdateTagRequest
 */
export interface UpdateTagRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateTagRequest
     */
    'secondaryCompanies'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateTagRequest
     */
    'companies'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof UpdateTagRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTagRequest
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTagRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateTaskDto
 */
export interface UpdateTaskDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskDto
     */
    'priority'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskDto
     */
    'dueDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskDto
     */
    'assignedUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskDto
     */
    'assignedTeamId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateTeam200Response
 */
export interface UpdateTeam200Response {
    /**
     * 
     * @type {number}
     * @memberof UpdateTeam200Response
     */
    'parentId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeam200Response
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTeam200Response
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface UpdateTeamRequest
 */
export interface UpdateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTeamRequest
     */
    'parentId'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateTrackedActivityConfigBody
 */
export interface UpdateTrackedActivityConfigBody {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrackedActivityConfigBody
     */
    'canViewReport': boolean;
    /**
     * 
     * @type {Array<UpdateTrackedActivityFieldDto>}
     * @memberof UpdateTrackedActivityConfigBody
     */
    'fields': Array<UpdateTrackedActivityFieldDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTrackedActivityConfigBody
     */
    'states': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTrackedActivityConfigBody
     */
    'tags': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateTrackedActivityEmailSettingsBody
 */
export interface UpdateTrackedActivityEmailSettingsBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTrackedActivityEmailSettingsBody
     */
    'emails': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateTrackedActivityFieldDto
 */
export interface UpdateTrackedActivityFieldDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackedActivityFieldDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackedActivityFieldDto
     */
    'label'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrackedActivityFieldDto
     */
    'displayOrder': number;
}
/**
 * 
 * @export
 * @interface UpdateUserAutoTrackAccess200Response
 */
export interface UpdateUserAutoTrackAccess200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserAutoTrackAccess200Response
     */
    'states': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAutoTrackAccess200Response
     */
    'canViewAutoTrackedBills': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAutoTrackAccess200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface UpdateUserAutoTrackAccessRequest
 */
export interface UpdateUserAutoTrackAccessRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserAutoTrackAccessRequest
     */
    'stateCodes': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAutoTrackAccessRequest
     */
    'canViewAutoTrackedBills': boolean;
}
/**
 * 
 * @export
 * @interface UpdateUserContactEmailRequest
 */
export interface UpdateUserContactEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserContactEmailRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UpdateUserRoleRequest
 */
export interface UpdateUserRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRoleRequest
     */
    'role': UpdateUserRoleRequestRoleEnum;
}

export const UpdateUserRoleRequestRoleEnum = {
    Admin: 'Admin',
    Read: 'Read',
    Write: 'Write'
} as const;

export type UpdateUserRoleRequestRoleEnum = typeof UpdateUserRoleRequestRoleEnum[keyof typeof UpdateUserRoleRequestRoleEnum];

/**
 * 
 * @export
 * @interface UpdateUserStatusRequest
 */
export interface UpdateUserStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserStatusRequest
     */
    'status': UpdateUserStatusRequestStatusEnum;
}

export const UpdateUserStatusRequestStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type UpdateUserStatusRequestStatusEnum = typeof UpdateUserStatusRequestStatusEnum[keyof typeof UpdateUserStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface UpdateUsernameRequest
 */
export interface UpdateUsernameRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUsernameRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface UploadDocuments200Response
 */
export interface UploadDocuments200Response {
    /**
     * 
     * @type {number}
     * @memberof UploadDocuments200Response
     */
    'filesUploaded': number;
    /**
     * 
     * @type {boolean}
     * @memberof UploadDocuments200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface UploadLogoFromUrl200Response
 */
export interface UploadLogoFromUrl200Response {
    /**
     * 
     * @type {string}
     * @memberof UploadLogoFromUrl200Response
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface UploadLogoFromUrlRequest
 */
export interface UploadLogoFromUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadLogoFromUrlRequest
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'Username': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'Email': string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'RoleId': number | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'UpdatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'CanViewAutoTrackedBills': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'LastLogin': string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'Status': string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'LobbyistId': number | null;
    /**
     * 
     * @type {Array<UserAccountUserRelationshipsInner>}
     * @memberof User
     */
    'AccountUserRelationships': Array<UserAccountUserRelationshipsInner>;
    /**
     * 
     * @type {CallingUserRole}
     * @memberof User
     */
    'Role'?: CallingUserRole;
    /**
     * 
     * @type {Array<Tags>}
     * @memberof User
     */
    'UserTags': Array<Tags>;
    /**
     * 
     * @type {Array<UserBillTags>}
     * @memberof User
     */
    'UserBillTags': Array<UserBillTags>;
    /**
     * 
     * @type {Array<UserSectionTags>}
     * @memberof User
     */
    'UserSectionTags': Array<UserSectionTags>;
    /**
     * 
     * @type {Array<GetUser200ResponseUserStatesInner>}
     * @memberof User
     */
    'UserStates': Array<GetUser200ResponseUserStatesInner>;
    /**
     * 
     * @type {Array<UserUserStateSubscriptionsInner>}
     * @memberof User
     */
    'UserStateSubscriptions': Array<UserUserStateSubscriptionsInner>;
}
/**
 * 
 * @export
 * @interface UserAccountUserRelationshipsInner
 */
export interface UserAccountUserRelationshipsInner {
    /**
     * 
     * @type {UserAccountUserRelationshipsInnerAccounts}
     * @memberof UserAccountUserRelationshipsInner
     */
    'Accounts': UserAccountUserRelationshipsInnerAccounts;
    /**
     * 
     * @type {string}
     * @memberof UserAccountUserRelationshipsInner
     */
    'Status': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountUserRelationshipsInner
     */
    'AnalystRole': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAccountUserRelationshipsInner
     */
    'FullAccountRole': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountUserRelationshipsInner
     */
    'FullAccount': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountUserRelationshipsInner
     */
    'IsLobbyist': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountUserRelationshipsInner
     */
    'IsAnalyst': boolean;
    /**
     * 
     * @type {number}
     * @memberof UserAccountUserRelationshipsInner
     */
    'RelationshipId': number;
    /**
     * 
     * @type {number}
     * @memberof UserAccountUserRelationshipsInner
     */
    'AccountId': number;
}
/**
 * 
 * @export
 * @interface UserAccountUserRelationshipsInnerAccounts
 */
export interface UserAccountUserRelationshipsInnerAccounts {
    /**
     * 
     * @type {string}
     * @memberof UserAccountUserRelationshipsInnerAccounts
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof UserAccountUserRelationshipsInnerAccounts
     */
    'AccountId': number;
}
/**
 * 
 * @export
 * @interface UserActivitySummary
 */
export interface UserActivitySummary {
    /**
     * 
     * @type {number}
     * @memberof UserActivitySummary
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof UserActivitySummary
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof UserActivitySummary
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserActivitySummary
     */
    'lastActivityAt': string;
    /**
     * 
     * @type {number}
     * @memberof UserActivitySummary
     */
    'requestCount': number;
}
/**
 * 
 * @export
 * @interface UserBillTags
 */
export interface UserBillTags {
    /**
     * 
     * @type {number}
     * @memberof UserBillTags
     */
    'BillTagId': number;
    /**
     * 
     * @type {string}
     * @memberof UserBillTags
     */
    'BillId': string;
    /**
     * 
     * @type {number}
     * @memberof UserBillTags
     */
    'TagId': number;
    /**
     * 
     * @type {number}
     * @memberof UserBillTags
     */
    'UserId': number;
    /**
     * 
     * @type {string}
     * @memberof UserBillTags
     */
    'SessionCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserBillTags
     */
    'Sorted': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserBillTags
     */
    'AutoTracked': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserBillTags
     */
    'AssignedAt': string;
    /**
     * 
     * @type {Tags}
     * @memberof UserBillTags
     */
    'Tag': Tags;
}
/**
 * 
 * @export
 * @interface UserContactDto
 */
export interface UserContactDto {
    /**
     * 
     * @type {number}
     * @memberof UserContactDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserContactDto
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactDto
     */
    'email': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserContactDto
     */
    'isPrimary': boolean;
}
/**
 * 
 * @export
 * @interface UserSectionTags
 */
export interface UserSectionTags {
    /**
     * 
     * @type {number}
     * @memberof UserSectionTags
     */
    'SectionTagId': number;
    /**
     * 
     * @type {string}
     * @memberof UserSectionTags
     */
    'SectionId': string;
    /**
     * 
     * @type {number}
     * @memberof UserSectionTags
     */
    'TagId': number;
    /**
     * 
     * @type {number}
     * @memberof UserSectionTags
     */
    'UserId': number;
    /**
     * 
     * @type {string}
     * @memberof UserSectionTags
     */
    'SessionCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSectionTags
     */
    'Sorted': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSectionTags
     */
    'AutoTracked': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserSectionTags
     */
    'AssignedAt': string;
    /**
     * 
     * @type {Tags}
     * @memberof UserSectionTags
     */
    'Tag': Tags;
}
/**
 * 
 * @export
 * @interface UserSettingsDto
 */
export interface UserSettingsDto {
    /**
     * 
     * @type {Array<CompanyKeywords>}
     * @memberof UserSettingsDto
     */
    'billKeywords': Array<CompanyKeywords>;
    /**
     * 
     * @type {Array<VideoKeywordEntry>}
     * @memberof UserSettingsDto
     */
    'videoKeywords': Array<VideoKeywordEntry>;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsDto
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsDto
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsDto
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface UserTagResponse
 */
export interface UserTagResponse {
    /**
     * 
     * @type {number}
     * @memberof UserTagResponse
     */
    'TagId': number;
    /**
     * 
     * @type {string}
     * @memberof UserTagResponse
     */
    'Name': string;
    /**
     * 
     * @type {number}
     * @memberof UserTagResponse
     */
    'CreatedByUserId': number | null;
    /**
     * 
     * @type {string}
     * @memberof UserTagResponse
     */
    'CreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserTagResponse
     */
    'Color': string | null;
}
/**
 * 
 * @export
 * @interface UserUserStateSubscriptionsInner
 */
export interface UserUserStateSubscriptionsInner {
    /**
     * 
     * @type {string}
     * @memberof UserUserStateSubscriptionsInner
     */
    'Status': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserStateSubscriptionsInner
     */
    'StateCode': string;
}
/**
 * 
 * @export
 * @interface UsernameAvailabilityResponseModel
 */
export interface UsernameAvailabilityResponseModel {
    /**
     * 
     * @type {boolean}
     * @memberof UsernameAvailabilityResponseModel
     */
    'available': boolean;
}
/**
 * Response for validation check
 * @export
 * @interface ValidateCompanySummaryResponse
 */
export interface ValidateCompanySummaryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateCompanySummaryResponse
     */
    'isCorrectCompany': boolean;
    /**
     * 
     * @type {number}
     * @memberof ValidateCompanySummaryResponse
     */
    'confidence': number;
    /**
     * 
     * @type {string}
     * @memberof ValidateCompanySummaryResponse
     */
    'reasoning'?: string;
}
/**
 * 
 * @export
 * @interface VideoInfo
 */
export interface VideoInfo {
    /**
     * 
     * @type {number}
     * @memberof VideoInfo
     */
    'VideoId': number;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'Date': string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'Chamber': string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'Committee': string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'Link': string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'TranscriptUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'OriginalSrc': string | null;
    /**
     * 
     * @type {number}
     * @memberof VideoInfo
     */
    'Duration': number | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'SessionCode': string;
    /**
     * 
     * @type {number}
     * @memberof VideoInfo
     */
    'CommitteeId': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VideoInfo
     */
    'IsStreaming': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'SummaryUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'NonTimeStampSummaryUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof VideoInfo
     */
    'StateCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VideoInfo
     */
    'IsFromLive': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VideoInfo
     */
    'TranscriptWitnessesProcessed': boolean | null;
}
/**
 * 
 * @export
 * @interface VideoKeywordEntry
 */
export interface VideoKeywordEntry {
    /**
     * 
     * @type {string}
     * @memberof VideoKeywordEntry
     */
    'keyword': string;
    /**
     * 
     * @type {string}
     * @memberof VideoKeywordEntry
     */
    'context': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VideoKeywordEntry
     */
    'companyIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof VideoKeywordEntry
     */
    'companyNames'?: Array<string>;
    /**
     * 
     * @type {AlertMethod}
     * @memberof VideoKeywordEntry
     */
    'alertMethod'?: AlertMethod;
}


/**
 * 
 * @export
 * @interface VideoQuestionRequest
 */
export interface VideoQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof VideoQuestionRequest
     */
    'question': string;
    /**
     * 
     * @type {number}
     * @memberof VideoQuestionRequest
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface VideoSegment
 */
export interface VideoSegment {
    /**
     * 
     * @type {boolean}
     * @memberof VideoSegment
     */
    'IncludeTranscript': boolean;
    /**
     * 
     * @type {string}
     * @memberof VideoSegment
     */
    'Title': string;
    /**
     * 
     * @type {string}
     * @memberof VideoSegment
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof VideoSegment
     */
    'VideoId': number;
    /**
     * 
     * @type {number}
     * @memberof VideoSegment
     */
    'StartTime': number;
    /**
     * 
     * @type {number}
     * @memberof VideoSegment
     */
    'EndTime': number;
    /**
     * 
     * @type {string}
     * @memberof VideoSegment
     */
    'StartPosition': string;
    /**
     * 
     * @type {string}
     * @memberof VideoSegment
     */
    'EndPosition': string;
    /**
     * 
     * @type {number}
     * @memberof VideoSegment
     */
    'TargetFolderId'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ViewScope = {
    User: 'user',
    Account: 'account'
} as const;

export type ViewScope = typeof ViewScope[keyof typeof ViewScope];


/**
 * 
 * @export
 * @interface VoteReportCrossPartyActivity
 */
export interface VoteReportCrossPartyActivity {
    /**
     * 
     * @type {string}
     * @memberof VoteReportCrossPartyActivity
     */
    'prevailingParty': string | null;
    /**
     * 
     * @type {Array<VoteReportCrossPartyEntry>}
     * @memberof VoteReportCrossPartyActivity
     */
    'prevailingPartyDissenters': Array<VoteReportCrossPartyEntry>;
    /**
     * 
     * @type {string}
     * @memberof VoteReportCrossPartyActivity
     */
    'nonPrevailingParty': string | null;
    /**
     * 
     * @type {Array<VoteReportCrossPartyEntry>}
     * @memberof VoteReportCrossPartyActivity
     */
    'nonPrevailingPartyDissenters': Array<VoteReportCrossPartyEntry>;
}
/**
 * 
 * @export
 * @interface VoteReportCrossPartyEntry
 */
export interface VoteReportCrossPartyEntry {
    /**
     * 
     * @type {number}
     * @memberof VoteReportCrossPartyEntry
     */
    'memberId': number;
    /**
     * 
     * @type {string}
     * @memberof VoteReportCrossPartyEntry
     */
    'memberName': string;
    /**
     * 
     * @type {string}
     * @memberof VoteReportCrossPartyEntry
     */
    'party': string;
    /**
     * 
     * @type {string}
     * @memberof VoteReportCrossPartyEntry
     */
    'chamber': string | null;
    /**
     * 
     * @type {string}
     * @memberof VoteReportCrossPartyEntry
     */
    'position': string;
}
/**
 * 
 * @export
 * @interface VoteReportEntry
 */
export interface VoteReportEntry {
    /**
     * 
     * @type {number}
     * @memberof VoteReportEntry
     */
    'voteId': number;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'billCode': string;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'billTitle': string | null;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'masterBillId': string | null;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'voteDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'chamber': string | null;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'voteType': VoteReportEntryVoteTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'result': string;
    /**
     * 
     * @type {number}
     * @memberof VoteReportEntry
     */
    'yes': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportEntry
     */
    'no': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportEntry
     */
    'absent': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportEntry
     */
    'notVoting': number;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'prevailingSide': VoteReportEntryPrevailingSideEnum;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'prevailingParty': string | null;
    /**
     * 
     * @type {Array<VoteReportCrossPartyEntry>}
     * @memberof VoteReportEntry
     */
    'crossPartyVotes': Array<VoteReportCrossPartyEntry>;
    /**
     * 
     * @type {VoteReportCrossPartyActivity}
     * @memberof VoteReportEntry
     */
    'crossPartyActivity': VoteReportCrossPartyActivity;
    /**
     * 
     * @type {Array<VoteReportMemberBreakdown>}
     * @memberof VoteReportEntry
     */
    'memberBreakdown': Array<VoteReportMemberBreakdown>;
    /**
     * 
     * @type {string}
     * @memberof VoteReportEntry
     */
    'committeeName': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VoteReportEntry
     */
    'keywordMatches': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof VoteReportEntry
     */
    'lowMargin': boolean;
}

export const VoteReportEntryVoteTypeEnum = {
    Floor: 'floor',
    Committee: 'committee'
} as const;

export type VoteReportEntryVoteTypeEnum = typeof VoteReportEntryVoteTypeEnum[keyof typeof VoteReportEntryVoteTypeEnum];
export const VoteReportEntryPrevailingSideEnum = {
    Yes: 'yes',
    No: 'no'
} as const;

export type VoteReportEntryPrevailingSideEnum = typeof VoteReportEntryPrevailingSideEnum[keyof typeof VoteReportEntryPrevailingSideEnum];

/**
 * 
 * @export
 * @interface VoteReportMemberBreakdown
 */
export interface VoteReportMemberBreakdown {
    /**
     * 
     * @type {string}
     * @memberof VoteReportMemberBreakdown
     */
    'party': string;
    /**
     * 
     * @type {number}
     * @memberof VoteReportMemberBreakdown
     */
    'yes': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportMemberBreakdown
     */
    'no': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportMemberBreakdown
     */
    'other': number;
}
/**
 * 
 * @export
 * @interface VoteReportRequest
 */
export interface VoteReportRequest {
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'session': string;
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'billCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'keyword'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VoteReportRequest
     */
    'chambers'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof VoteReportRequest
     */
    'parties'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'voteType'?: VoteReportRequestVoteTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof VoteReportRequest
     */
    'maxPrevailingVotes'?: number;
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'committeeQuery'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VoteReportRequest
     */
    'onlyCrossParty'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VoteReportRequest
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'reportName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'emailRecipients'?: string;
    /**
     * 
     * @type {number}
     * @memberof VoteReportRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VoteReportRequest
     */
    'companyName'?: string;
}

export const VoteReportRequestVoteTypeEnum = {
    All: 'all',
    Floor: 'floor',
    Committee: 'committee'
} as const;

export type VoteReportRequestVoteTypeEnum = typeof VoteReportRequestVoteTypeEnum[keyof typeof VoteReportRequestVoteTypeEnum];

/**
 * 
 * @export
 * @interface VoteReportSummary
 */
export interface VoteReportSummary {
    /**
     * 
     * @type {number}
     * @memberof VoteReportSummary
     */
    'totalVotes': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportSummary
     */
    'floorVotes': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportSummary
     */
    'committeeVotes': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportSummary
     */
    'crossPartyInstances': number;
    /**
     * 
     * @type {number}
     * @memberof VoteReportSummary
     */
    'lowMarginVotes': number;
}
/**
 * 
 * @export
 * @interface WarmBillCache200Response
 */
export interface WarmBillCache200Response {
    /**
     * 
     * @type {string}
     * @memberof WarmBillCache200Response
     */
    'duration': string;
    /**
     * 
     * @type {number}
     * @memberof WarmBillCache200Response
     */
    'listCachesFailed': number;
    /**
     * 
     * @type {number}
     * @memberof WarmBillCache200Response
     */
    'listCachesProcessed': number;
    /**
     * 
     * @type {number}
     * @memberof WarmBillCache200Response
     */
    'billsFailed': number;
    /**
     * 
     * @type {number}
     * @memberof WarmBillCache200Response
     */
    'billsProcessed': number;
    /**
     * 
     * @type {string}
     * @memberof WarmBillCache200Response
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof WarmBillCache200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface WebhookResponse
 */
export interface WebhookResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WebhookResponse
     */
    'received': boolean;
}
/**
 * 
 * @export
 * @interface WitnessDto
 */
export interface WitnessDto {
    /**
     * 
     * @type {number}
     * @memberof WitnessDto
     */
    'witnessId': number;
    /**
     * 
     * @type {string}
     * @memberof WitnessDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WitnessDto
     */
    'organization': string | null;
    /**
     * 
     * @type {number}
     * @memberof WitnessDto
     */
    'companyId': number | null;
    /**
     * 
     * @type {number}
     * @memberof WitnessDto
     */
    'lobbyistId': number | null;
    /**
     * 
     * @type {Array<WitnessTimestampDto>}
     * @memberof WitnessDto
     */
    'timestamps': Array<WitnessTimestampDto>;
    /**
     * 
     * @type {Array<WitnessDtoBillsInner>}
     * @memberof WitnessDto
     */
    'bills': Array<WitnessDtoBillsInner>;
}
/**
 * 
 * @export
 * @interface WitnessDtoBillsInner
 */
export interface WitnessDtoBillsInner {
    /**
     * 
     * @type {string}
     * @memberof WitnessDtoBillsInner
     */
    'position': string | null;
    /**
     * 
     * @type {string}
     * @memberof WitnessDtoBillsInner
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof WitnessDtoBillsInner
     */
    'billNumber': string;
    /**
     * 
     * @type {string}
     * @memberof WitnessDtoBillsInner
     */
    'masterBillId': string;
}
/**
 * 
 * @export
 * @interface WitnessSearchResult
 */
export interface WitnessSearchResult {
    /**
     * 
     * @type {number}
     * @memberof WitnessSearchResult
     */
    'witnessId': number;
    /**
     * 
     * @type {string}
     * @memberof WitnessSearchResult
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof WitnessSearchResult
     */
    'middleName': string | null;
    /**
     * 
     * @type {string}
     * @memberof WitnessSearchResult
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof WitnessSearchResult
     */
    'stateCode': string | null;
    /**
     * 
     * @type {number}
     * @memberof WitnessSearchResult
     */
    'lobbyistId': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WitnessSearchResult
     */
    'isTracked': boolean;
}
/**
 * 
 * @export
 * @interface WitnessTimestampDto
 */
export interface WitnessTimestampDto {
    /**
     * 
     * @type {string}
     * @memberof WitnessTimestampDto
     */
    'startTime': string | null;
    /**
     * 
     * @type {string}
     * @memberof WitnessTimestampDto
     */
    'endTime': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WitnessTrackingSource = {
    Lobbyist: 'lobbyist',
    Manual: 'manual'
} as const;

export type WitnessTrackingSource = typeof WitnessTrackingSource[keyof typeof WitnessTrackingSource];



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AcceptInviteRequest} acceptInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation: async (acceptInviteRequest: AcceptInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptInviteRequest' is not null or undefined
            assertParamExists('acceptInvitation', 'acceptInviteRequest', acceptInviteRequest)
            const localVarPath = `/api/invitations/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitationGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('acceptInvitationGet', 'token', token)
            const localVarPath = `/api/invitations/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddAnalystRequest} addAnalystRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAnalyst: async (addAnalystRequest: AddAnalystRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addAnalystRequest' is not null or undefined
            assertParamExists('addAnalyst', 'addAnalystRequest', addAnalystRequest)
            const localVarPath = `/api/analysts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAnalystRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddBillWithSessionBody} addBillWithSessionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBillWithSession: async (addBillWithSessionBody: AddBillWithSessionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addBillWithSessionBody' is not null or undefined
            assertParamExists('addBillWithSession', 'addBillWithSessionBody', addBillWithSessionBody)
            const localVarPath = `/api/track-lists/add-bill-with-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addBillWithSessionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateTaskNoteDto} createTaskNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTaskNote: async (id: number, createTaskNoteDto: CreateTaskNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTaskNote', 'id', id)
            // verify required parameter 'createTaskNoteDto' is not null or undefined
            assertParamExists('addTaskNote', 'createTaskNoteDto', createTaskNoteDto)
            const localVarPath = `/api/tasks/{id}/notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AddTeamMemberRequest} addTeamMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamMember: async (id: number, addTeamMemberRequest: AddTeamMemberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTeamMember', 'id', id)
            // verify required parameter 'addTeamMemberRequest' is not null or undefined
            assertParamExists('addTeamMember', 'addTeamMemberRequest', addTeamMemberRequest)
            const localVarPath = `/api/teams/{id}/members`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTeamMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrackWitnessRequest} trackWitnessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrackedWitness: async (trackWitnessRequest: TrackWitnessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackWitnessRequest' is not null or undefined
            assertParamExists('addTrackedWitness', 'trackWitnessRequest', trackWitnessRequest)
            const localVarPath = `/api/advocate-management/testimonies/tracked-witnesses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackWitnessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAutoTrackedBill: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('approveAutoTrackedBill', 'billId', billId)
            const localVarPath = `/api/autotracked-bills/{billId}/approve`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Answer questions about a bill using its text content with conversation history
         * @param {BillQuestionRequest} billQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askBillQuestion: async (billQuestionRequest: BillQuestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billQuestionRequest' is not null or undefined
            assertParamExists('askBillQuestion', 'billQuestionRequest', billQuestionRequest)
            const localVarPath = `/api/ai/bill-question`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billQuestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegulationQuestionRequest} regulationQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askRegQuestion: async (regulationQuestionRequest: RegulationQuestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regulationQuestionRequest' is not null or undefined
            assertParamExists('askRegQuestion', 'regulationQuestionRequest', regulationQuestionRequest)
            const localVarPath = `/api/ai/reg-chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(regulationQuestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StatuteQuestionRequest} statuteQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askStatuteQuestion: async (statuteQuestionRequest: StatuteQuestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statuteQuestionRequest' is not null or undefined
            assertParamExists('askStatuteQuestion', 'statuteQuestionRequest', statuteQuestionRequest)
            const localVarPath = `/api/ai/statute-chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statuteQuestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} witnessId 
         * @param {AssignWitnessLobbyistRequest} assignWitnessLobbyistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLobbyist: async (witnessId: number, assignWitnessLobbyistRequest: AssignWitnessLobbyistRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'witnessId' is not null or undefined
            assertParamExists('assignLobbyist', 'witnessId', witnessId)
            // verify required parameter 'assignWitnessLobbyistRequest' is not null or undefined
            assertParamExists('assignLobbyist', 'assignWitnessLobbyistRequest', assignWitnessLobbyistRequest)
            const localVarPath = `/api/witnesses/{witnessId}/assign-lobbyist`
                .replace(`{${"witnessId"}}`, encodeURIComponent(String(witnessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignWitnessLobbyistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkCreateTagsRequest} bulkCreateTagsRequest 
         * @param {boolean} [bypassAccessCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateTags: async (bulkCreateTagsRequest: BulkCreateTagsRequest, bypassAccessCheck?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreateTagsRequest' is not null or undefined
            assertParamExists('bulkCreateTags', 'bulkCreateTagsRequest', bulkCreateTagsRequest)
            const localVarPath = `/api/tags/bulk-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (bypassAccessCheck !== undefined) {
                localVarQueryParameter['bypassAccessCheck'] = bypassAccessCheck;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateTagsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkDeleteTagsRequest} bulkDeleteTagsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteTags: async (bulkDeleteTagsRequest: BulkDeleteTagsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDeleteTagsRequest' is not null or undefined
            assertParamExists('bulkDeleteTags', 'bulkDeleteTagsRequest', bulkDeleteTagsRequest)
            const localVarPath = `/api/tags/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteTagsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkImportClients: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client-crm/bulk-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSaveAccountCompanySummaryBody} bulkSaveAccountCompanySummaryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveAccountCompanySummaries: async (bulkSaveAccountCompanySummaryBody: BulkSaveAccountCompanySummaryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkSaveAccountCompanySummaryBody' is not null or undefined
            assertParamExists('bulkSaveAccountCompanySummaries', 'bulkSaveAccountCompanySummaryBody', bulkSaveAccountCompanySummaryBody)
            const localVarPath = `/api/account-company-summary/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSaveAccountCompanySummaryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel the setup process for an account
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelSetup: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/initSetup/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel subscription at the end of the current billing period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the current user\'s password
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordRequest: ChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/api/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check which chambers have agendas available for a given state
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAvailableAgendas: async (state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('checkAvailableAgendas', 'state', state)
            const localVarPath = `/api/daily-agenda/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('checkUsername', 'username', username)
            const localVarPath = `/api/promo-registration/check-username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if a username is available
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUsernameAvailability: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('checkUsernameAvailability', 'username', username)
            const localVarPath = `/api/auth/check-username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clear a specific bill from cache
         * @param {string} xApiKey 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearBillCache: async (xApiKey: string, billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xApiKey' is not null or undefined
            assertParamExists('clearBillCache', 'xApiKey', xApiKey)
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('clearBillCache', 'billId', billId)
            const localVarPath = `/api/admin/cache/clear/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clear sessions cache for a specific user and state
         * @param {string} xApiKey 
         * @param {number} userId 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSessionsCache: async (xApiKey: string, userId: number, stateCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xApiKey' is not null or undefined
            assertParamExists('clearSessionsCache', 'xApiKey', xApiKey)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('clearSessionsCache', 'userId', userId)
            const localVarPath = `/api/admin/cache/sessions/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }


    
            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clear sessions cache for a specific user
         * @param {string} xApiKey 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearUserSessionsCache: async (xApiKey: string, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xApiKey' is not null or undefined
            assertParamExists('clearUserSessionsCache', 'xApiKey', xApiKey)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('clearUserSessionsCache', 'userId', userId)
            const localVarPath = `/api/admin/cache/sessions/clear-user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteRegistrationRequestModel} completeRegistrationRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRegistration: async (completeRegistrationRequestModel: CompleteRegistrationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeRegistrationRequestModel' is not null or undefined
            assertParamExists('completeRegistration', 'completeRegistrationRequestModel', completeRegistrationRequestModel)
            const localVarPath = `/api/promo-registration/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeRegistrationRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete the setup process for an account with the provided information
         * @param {CompleteSetupRequest} completeSetupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeSetup: async (completeSetupRequest: CompleteSetupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeSetupRequest' is not null or undefined
            assertParamExists('completeSetup', 'completeSetupRequest', completeSetupRequest)
            const localVarPath = `/api/initSetup/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSetupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConnectGmailRequest} connectGmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGmailIntegration: async (connectGmailRequest: ConnectGmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectGmailRequest' is not null or undefined
            assertParamExists('connectGmailIntegration', 'connectGmailRequest', connectGmailRequest)
            const localVarPath = `/api/integrations/gmail/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectGmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConnectSlackIntegrationRequest} connectSlackIntegrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectSlackIntegration: async (connectSlackIntegrationRequest: ConnectSlackIntegrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectSlackIntegrationRequest' is not null or undefined
            assertParamExists('connectSlackIntegration', 'connectSlackIntegrationRequest', connectSlackIntegrationRequest)
            const localVarPath = `/api/integrations/slack/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectSlackIntegrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConsolidateTagsRequest} consolidateTagsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consolidateTags: async (consolidateTagsRequest: ConsolidateTagsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consolidateTagsRequest' is not null or undefined
            assertParamExists('consolidateTags', 'consolidateTagsRequest', consolidateTagsRequest)
            const localVarPath = `/api/tags/consolidate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consolidateTagsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBillRemarkBody} createBillRemarkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountBillRemark: async (createBillRemarkBody: CreateBillRemarkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBillRemarkBody' is not null or undefined
            assertParamExists('createAccountBillRemark', 'createBillRemarkBody', createBillRemarkBody)
            const localVarPath = `/api/remarks/bill/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBillRemarkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBillRemarkBody} createBillRemarkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillRemark: async (createBillRemarkBody: CreateBillRemarkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBillRemarkBody' is not null or undefined
            assertParamExists('createBillRemark', 'createBillRemarkBody', createBillRemarkBody)
            const localVarPath = `/api/remarks/bill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBillRemarkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateClusterBody} createClusterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCluster: async (createClusterBody: CreateClusterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createClusterBody' is not null or undefined
            assertParamExists('createCluster', 'createClusterBody', createClusterBody)
            const localVarPath = `/api/company-clusters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClusterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new company and generate a Full summary via Perplexity. Ensures MasterCompanyID is set to CompanyID.
         * @param {CreateCompanyRequest} createCompanyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: async (createCompanyRequest: CreateCompanyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompanyRequest' is not null or undefined
            assertParamExists('createCompany', 'createCompanyRequest', createCompanyRequest)
            const localVarPath = `/api/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {ContactPayload} contactPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (companyId: number, contactPayload: ContactPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('createContact', 'companyId', companyId)
            // verify required parameter 'contactPayload' is not null or undefined
            assertParamExists('createContact', 'contactPayload', contactPayload)
            const localVarPath = `/api/client-crm/clients/{companyId}/contacts`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFeatureRequestBody} createFeatureRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeatureRequest: async (createFeatureRequestBody: CreateFeatureRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFeatureRequestBody' is not null or undefined
            assertParamExists('createFeatureRequest', 'createFeatureRequestBody', createFeatureRequestBody)
            const localVarPath = `/api/feature-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeatureRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFirmRequest} createFirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirm: async (createFirmRequest: CreateFirmRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFirmRequest' is not null or undefined
            assertParamExists('createFirm', 'createFirmRequest', createFirmRequest)
            const localVarPath = `/api/firms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GmailCalendarRequestBody} gmailCalendarRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGmailCalendarEvent: async (gmailCalendarRequestBody: GmailCalendarRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gmailCalendarRequestBody' is not null or undefined
            assertParamExists('createGmailCalendarEvent', 'gmailCalendarRequestBody', gmailCalendarRequestBody)
            const localVarPath = `/api/integrations/gmail/calendar-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gmailCalendarRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InviteUserRequest} inviteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation: async (inviteUserRequest: InviteUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteUserRequest' is not null or undefined
            assertParamExists('createInvitation', 'inviteUserRequest', inviteUserRequest)
            const localVarPath = `/api/advocate-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateIssueBody} createIssueBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssue: async (createIssueBody: CreateIssueBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIssueBody' is not null or undefined
            assertParamExists('createIssue', 'createIssueBody', createIssueBody)
            const localVarPath = `/api/issues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIssueBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LobbyistCreateRequest} lobbyistCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLobbyist: async (lobbyistCreateRequest: LobbyistCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lobbyistCreateRequest' is not null or undefined
            assertParamExists('createLobbyist', 'lobbyistCreateRequest', lobbyistCreateRequest)
            const localVarPath = `/api/lobbyists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lobbyistCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMemberListRequest} createMemberListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemberList: async (createMemberListRequest: CreateMemberListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMemberListRequest' is not null or undefined
            assertParamExists('createMemberList', 'createMemberListRequest', createMemberListRequest)
            const localVarPath = `/api/member-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMemberListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBillPositionBody} createBillPositionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateBillPosition: async (createBillPositionBody: CreateBillPositionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBillPositionBody' is not null or undefined
            assertParamExists('createOrUpdateBillPosition', 'createBillPositionBody', createBillPositionBody)
            const localVarPath = `/api/bill-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBillPositionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBillRemarkBody} createBillRemarkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonalBillRemark: async (createBillRemarkBody: CreateBillRemarkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBillRemarkBody' is not null or undefined
            assertParamExists('createPersonalBillRemark', 'createBillRemarkBody', createBillRemarkBody)
            const localVarPath = `/api/remarks/bill/personal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBillRemarkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe Customer Portal session for managing billing This allows customers to update payment methods, view invoices, etc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortalSession: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/portal-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe Customer Portal session for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortalSession_1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/billing/portal-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProspectCreateRequest} prospectCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProspect: async (prospectCreateRequest: ProspectCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prospectCreateRequest' is not null or undefined
            assertParamExists('createProspect', 'prospectCreateRequest', prospectCreateRequest)
            const localVarPath = `/api/prospects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prospectCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PromotionCheckoutRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession: async (body: PromotionCheckoutRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createSession', 'body', body)
            const localVarPath = `/api/promo-checkout/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StakeholderContactInput} stakeholderContactInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStakeholderContact: async (stakeholderContactInput: StakeholderContactInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stakeholderContactInput' is not null or undefined
            assertParamExists('createStakeholderContact', 'stakeholderContactInput', stakeholderContactInput)
            const localVarPath = `/api/stakeholder-meetings/stakeholders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stakeholderContactInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StakeholderMeetingInput} stakeholderMeetingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStakeholderMeeting: async (stakeholderMeetingInput: StakeholderMeetingInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stakeholderMeetingInput' is not null or undefined
            assertParamExists('createStakeholderMeeting', 'stakeholderMeetingInput', stakeholderMeetingInput)
            const localVarPath = `/api/stakeholder-meetings/meetings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stakeholderMeetingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTagBody} createTagBody 
         * @param {boolean} [bypassAccessCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: async (createTagBody: CreateTagBody, bypassAccessCheck?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTagBody' is not null or undefined
            assertParamExists('createTag', 'createTagBody', createTagBody)
            const localVarPath = `/api/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (bypassAccessCheck !== undefined) {
                localVarQueryParameter['bypassAccessCheck'] = bypassAccessCheck;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTagBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTaskDto} createTaskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: async (createTaskDto: CreateTaskDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTaskDto' is not null or undefined
            assertParamExists('createTask', 'createTaskDto', createTaskDto)
            const localVarPath = `/api/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTeamRequest} createTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: async (createTeamRequest: CreateTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTeamRequest' is not null or undefined
            assertParamExists('createTeam', 'createTeamRequest', createTeamRequest)
            const localVarPath = `/api/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTeamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFolderBody} createFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserFolder: async (createFolderBody: CreateFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFolderBody' is not null or undefined
            assertParamExists('createUserFolder', 'createFolderBody', createFolderBody)
            const localVarPath = `/api/user-storage/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create video clip  Creates a clip record with timestamps only. The video segment is generated on-demand when viewed or downloaded, just like the share endpoint and committee agent.
         * @param {VideoSegment} videoSegment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoClip: async (videoSegment: VideoSegment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoSegment' is not null or undefined
            assertParamExists('createVideoClip', 'videoSegment', videoSegment)
            const localVarPath = `/api/committee-videos/create-clip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoSegment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountCompanySummary: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('deleteAccountCompanySummary', 'companyId', companyId)
            const localVarPath = `/api/account-company-summary/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllAutoTrackedBills: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/autotracked-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} billTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAutoTrackedBill: async (billTagId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billTagId' is not null or undefined
            assertParamExists('deleteAutoTrackedBill', 'billTagId', billTagId)
            const localVarPath = `/api/autotracked-bills/{billTagId}`
                .replace(`{${"billTagId"}}`, encodeURIComponent(String(billTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillPosition: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBillPosition', 'id', id)
            const localVarPath = `/api/bill-positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a document
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteDocument', 'documentId', documentId)
            const localVarPath = `/api/remarks/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (fileId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteFile', 'fileId', fileId)
            const localVarPath = `/api/user-storage/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder: async (folderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteFolder', 'folderId', folderId)
            const localVarPath = `/api/user-storage/folders/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMemberList: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMemberList', 'id', id)
            const localVarPath = `/api/member-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} remarkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRemark: async (remarkId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'remarkId' is not null or undefined
            assertParamExists('deleteRemark', 'remarkId', remarkId)
            const localVarPath = `/api/remarks/{remarkId}`
                .replace(`{${"remarkId"}}`, encodeURIComponent(String(remarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} scheduledReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduledReport: async (scheduledReportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduledReportId' is not null or undefined
            assertParamExists('deleteScheduledReport', 'scheduledReportId', scheduledReportId)
            const localVarPath = `/api/report/schedule/{scheduledReportId}`
                .replace(`{${"scheduledReportId"}}`, encodeURIComponent(String(scheduledReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: async (tagId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('deleteTag', 'tagId', tagId)
            const localVarPath = `/api/tags/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteUserKeywordBody} deleteUserKeywordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserKeyword: async (deleteUserKeywordBody: DeleteUserKeywordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteUserKeywordBody' is not null or undefined
            assertParamExists('deleteUserKeyword', 'deleteUserKeywordBody', deleteUserKeywordBody)
            const localVarPath = `/api/user-settings/keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteUserKeywordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectGmailIntegration: async (accountId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/integrations/gmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSlackIntegration: async (accountId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/integrations/slack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dismiss the new user welcome modal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissNewUserModal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-settings/dismiss-new-user-modal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Proxy endpoint for downloading agenda content Streams the file directly from Azure to the client without exposing SAS tokens
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAgenda: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadAgenda', 'id', id)
            const localVarPath = `/api/daily-agenda/download/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Proxy endpoint for downloading bill documents Streams the file directly from Azure to the client without exposing SAS tokens  IMPORTANT: This route MUST be defined before generic routes that might capture it.
         * @param {string} id 
         * @param {string} billVersionId 
         * @param {DownloadBillDocumentFormatEnum} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBillDocument: async (id: string, billVersionId: string, format?: DownloadBillDocumentFormatEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadBillDocument', 'id', id)
            // verify required parameter 'billVersionId' is not null or undefined
            assertParamExists('downloadBillDocument', 'billVersionId', billVersionId)
            const localVarPath = `/api/bills/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billVersionId !== undefined) {
                localVarQueryParameter['billVersionId'] = billVersionId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a Video Clip as MP4.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadClip: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('downloadClip', 'uuid', uuid)
            const localVarPath = `/api/committee-videos/clip/{uuid}/download`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a document
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument: async (documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('downloadDocument', 'documentId', documentId)
            const localVarPath = `/api/remarks/documents/{documentId}/download`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile: async (fileId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadFile', 'fileId', fileId)
            const localVarPath = `/api/user-storage/files/{fileId}/download`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Proxy endpoint for downloading files by path Replaces direct SAS URL access for security compliance
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileByPath: async (path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('downloadFileByPath', 'path', path)
            const localVarPath = `/api/user-storage/files/download-proxy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download recent live actions as CSV
         * @param {Array<string>} [stateCodes] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLiveActions: async (stateCodes?: Array<string>, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/live-actions/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCodes) {
                localVarQueryParameter['stateCodes'] = stateCodes;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Proxy endpoint for downloading supporting documents Streams the file directly from Azure to the client without exposing SAS tokens  IMPORTANT: This route MUST be defined before generic routes that might capture it.
         * @param {string} id 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSupportingDocument: async (id: string, documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadSupportingDocument', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('downloadSupportingDocument', 'documentId', documentId)
            const localVarPath = `/api/bills/{id}/supporting-documents/{documentId}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailAiReportRequest} emailAiReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailAiReport: async (emailAiReportRequest: EmailAiReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailAiReportRequest' is not null or undefined
            assertParamExists('emailAiReport', 'emailAiReportRequest', emailAiReportRequest)
            const localVarPath = `/api/ai-reports/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailAiReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnsureFolderPathBody} ensureFolderPathBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ensureFolderPath: async (ensureFolderPathBody: EnsureFolderPathBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ensureFolderPathBody' is not null or undefined
            assertParamExists('ensureFolderPath', 'ensureFolderPathBody', ensureFolderPathBody)
            const localVarPath = `/api/user-storage/folders/ensure-path`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ensureFolderPathBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Proxy endpoint to fetch AI report from Azure storage (bypasses CORS)
         * @param {string} url The full URL to the AI report JSON file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAIReport: async (url: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'url' is not null or undefined
            assertParamExists('fetchAIReport', 'url', url)
            const localVarPath = `/api/ai-reports/fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the most recent daily agenda for a specific state and chamber
         * @param {string} state 
         * @param {string} chamber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDailyAgenda: async (state: string, chamber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('fetchDailyAgenda', 'state', state)
            // verify required parameter 'chamber' is not null or undefined
            assertParamExists('fetchDailyAgenda', 'chamber', chamber)
            const localVarPath = `/api/daily-agenda/fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (chamber !== undefined) {
                localVarQueryParameter['chamber'] = chamber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fix an incorrect company summary by regenerating it
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixCompanySummary: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('fixCompanySummary', 'companyId', companyId)
            const localVarPath = `/api/company-summary-fix/{companyId}/fix`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a password reset
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (forgotPasswordRequest: ForgotPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordRequest' is not null or undefined
            assertParamExists('forgotPassword', 'forgotPasswordRequest', forgotPasswordRequest)
            const localVarPath = `/api/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Forward a bill to one or more lobbyists in the account
         * @param {ForwardBillToLobbyistRequest} forwardBillToLobbyistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardBillToLobbyists: async (forwardBillToLobbyistRequest: ForwardBillToLobbyistRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forwardBillToLobbyistRequest' is not null or undefined
            assertParamExists('forwardBillToLobbyists', 'forwardBillToLobbyistRequest', forwardBillToLobbyistRequest)
            const localVarPath = `/api/bills/forward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forwardBillToLobbyistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContextQueryRequest} contextQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gatherContext: async (contextQueryRequest: ContextQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contextQueryRequest' is not null or undefined
            assertParamExists('gatherContext', 'contextQueryRequest', contextQueryRequest)
            const localVarPath = `/api/ai/gather-context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contextQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AIReportPayload} aIReportPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAIReport: async (aIReportPayload: AIReportPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aIReportPayload' is not null or undefined
            assertParamExists('generateAIReport', 'aIReportPayload', aIReportPayload)
            const localVarPath = `/api/ai-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIReportPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a suggested title and description for a clip.
         * @param {number} videoId 
         * @param {ClipMetadataRequest} clipMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClipMetadata: async (videoId: number, clipMetadataRequest: ClipMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            assertParamExists('generateClipMetadata', 'videoId', videoId)
            // verify required parameter 'clipMetadataRequest' is not null or undefined
            assertParamExists('generateClipMetadata', 'clipMetadataRequest', clipMetadataRequest)
            const localVarPath = `/api/committee-videos/{videoId}/generate-clip-metadata`
                .replace(`{${"videoId"}}`, encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clipMetadataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a video clip of segments relevant to a company
         * @param {number} videoId 
         * @param {GenerateCompanySummaryRequest} generateCompanySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompanyClip: async (videoId: number, generateCompanySummaryRequest: GenerateCompanySummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            assertParamExists('generateCompanyClip', 'videoId', videoId)
            // verify required parameter 'generateCompanySummaryRequest' is not null or undefined
            assertParamExists('generateCompanyClip', 'generateCompanySummaryRequest', generateCompanySummaryRequest)
            const localVarPath = `/api/committee-videos/{videoId}/generate-company-clip`
                .replace(`{${"videoId"}}`, encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCompanySummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a company-specific summary of a committee video
         * @param {number} videoId 
         * @param {GenerateCompanySummaryRequest} generateCompanySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompanySummary: async (videoId: number, generateCompanySummaryRequest: GenerateCompanySummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            assertParamExists('generateCompanySummary', 'videoId', videoId)
            // verify required parameter 'generateCompanySummaryRequest' is not null or undefined
            assertParamExists('generateCompanySummary', 'generateCompanySummaryRequest', generateCompanySummaryRequest)
            const localVarPath = `/api/committee-videos/{videoId}/generate-company-summary`
                .replace(`{${"videoId"}}`, encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCompanySummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate AI report using API key authentication (for external clients)
         * @param {string} xApiKey API key for authentication (pass in x-api-key header)
         * @param {ExternalAIReportRequest} externalAIReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExternalAIReport: async (xApiKey: string, externalAIReportRequest: ExternalAIReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xApiKey' is not null or undefined
            assertParamExists('generateExternalAIReport', 'xApiKey', xApiKey)
            // verify required parameter 'externalAIReportRequest' is not null or undefined
            assertParamExists('generateExternalAIReport', 'externalAIReportRequest', externalAIReportRequest)
            const localVarPath = `/api/ai-reports/external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalAIReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate relevant keywords based on the entity description Can process single entity or multiple companies in parallel
         * @param {GenerateKeywordsRequest} generateKeywordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateKeywords: async (generateKeywordsRequest: GenerateKeywordsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateKeywordsRequest' is not null or undefined
            assertParamExists('generateKeywords', 'generateKeywordsRequest', generateKeywordsRequest)
            const localVarPath = `/api/initSetup/keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateKeywordsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} videoId 
         * @param {GenerateSegmentSummaryRequest} generateSegmentSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSegmentSummary: async (videoId: number, generateSegmentSummaryRequest: GenerateSegmentSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            assertParamExists('generateSegmentSummary', 'videoId', videoId)
            // verify required parameter 'generateSegmentSummaryRequest' is not null or undefined
            assertParamExists('generateSegmentSummary', 'generateSegmentSummaryRequest', generateSegmentSummaryRequest)
            const localVarPath = `/api/committee-videos/{videoId}/generate-segment-summary`
                .replace(`{${"videoId"}}`, encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateSegmentSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate relevant subjects based on the entity description
         * @param {GenerateSubjectsRequest} generateSubjectsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSubjects: async (generateSubjectsRequest: GenerateSubjectsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateSubjectsRequest' is not null or undefined
            assertParamExists('generateSubjects', 'generateSubjectsRequest', generateSubjectsRequest)
            const localVarPath = `/api/initSetup/subjects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateSubjectsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTagContext: async (tagId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('generateTagContext', 'tagId', tagId)
            const localVarPath = `/api/tags/{tagId}/generate-context`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate relevant tags based on provided keywords
         * @param {GenerateTagsRequest} generateTagsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTags: async (generateTagsRequest: GenerateTagsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateTagsRequest' is not null or undefined
            assertParamExists('generateTags', 'generateTagsRequest', generateTagsRequest)
            const localVarPath = `/api/initSetup/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateTagsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateTagsForCompanyRequest} generateTagsForCompanyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTagsForCompany: async (generateTagsForCompanyRequest: GenerateTagsForCompanyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateTagsForCompanyRequest' is not null or undefined
            assertParamExists('generateTagsForCompany', 'generateTagsForCompanyRequest', generateTagsForCompanyRequest)
            const localVarPath = `/api/tags/generate-for-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateTagsForCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTrackedActivityReportsBatch: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report/tracked-activity/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountBillRemarks: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getAccountBillRemarks', 'billId', billId)
            const localVarPath = `/api/remarks/bill/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCompanyClaims: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getAccountCompanyClaims', 'companyId', companyId)
            const localVarPath = `/api/account-company-claims/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCompanySummaries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account-company-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCompanySummary: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getAccountCompanySummary', 'companyId', companyId)
            const localVarPath = `/api/account-company-summary/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [state] 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLobbyist: async (id: number, state?: string, accountId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccountLobbyist', 'id', id)
            const localVarPath = `/api/advocate-management/lobbyists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all lobbyist users in the current account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLobbyistUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lobbyists/account/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [states] 
         * @param {string} [sessionKeys] 
         * @param {boolean} [activeOnly] 
         * @param {string} [tagIds] 
         * @param {GetAccountTrackedBillsTagLogicEnum} [tagLogic] 
         * @param {string} [trackTypes] 
         * @param {string} [progressStatuses] 
         * @param {boolean} [alertsOnly] 
         * @param {boolean} [excludeLobbyistUsers] 
         * @param {boolean} [lobbyistUsersOnly] 
         * @param {boolean} [jointTracked] 
         * @param {string} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTrackedBills: async (page?: number, pageSize?: number, search?: string, states?: string, sessionKeys?: string, activeOnly?: boolean, tagIds?: string, tagLogic?: GetAccountTrackedBillsTagLogicEnum, trackTypes?: string, progressStatuses?: string, alertsOnly?: boolean, excludeLobbyistUsers?: boolean, lobbyistUsersOnly?: boolean, jointTracked?: boolean, userIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tags/tracked-bills/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }

            if (sessionKeys !== undefined) {
                localVarQueryParameter['sessionKeys'] = sessionKeys;
            }

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }

            if (tagIds !== undefined) {
                localVarQueryParameter['tagIds'] = tagIds;
            }

            if (tagLogic !== undefined) {
                localVarQueryParameter['tagLogic'] = tagLogic;
            }

            if (trackTypes !== undefined) {
                localVarQueryParameter['trackTypes'] = trackTypes;
            }

            if (progressStatuses !== undefined) {
                localVarQueryParameter['progressStatuses'] = progressStatuses;
            }

            if (alertsOnly !== undefined) {
                localVarQueryParameter['alertsOnly'] = alertsOnly;
            }

            if (excludeLobbyistUsers !== undefined) {
                localVarQueryParameter['excludeLobbyistUsers'] = excludeLobbyistUsers;
            }

            if (lobbyistUsersOnly !== undefined) {
                localVarQueryParameter['lobbyistUsersOnly'] = lobbyistUsersOnly;
            }

            if (jointTracked !== undefined) {
                localVarQueryParameter['jointTracked'] = jointTracked;
            }

            if (userIds !== undefined) {
                localVarQueryParameter['userIds'] = userIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountTrackedBillsBulkBody} accountTrackedBillsBulkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTrackedBillsBulk: async (accountTrackedBillsBulkBody: AccountTrackedBillsBulkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountTrackedBillsBulkBody' is not null or undefined
            assertParamExists('getAccountTrackedBillsBulk', 'accountTrackedBillsBulkBody', accountTrackedBillsBulkBody)
            const localVarPath = `/api/tags/tracked-bills/account/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountTrackedBillsBulkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountUsers: async (page?: number, pageSize?: number, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get counts for a specific activity type
         * @param {GetActivityCountScopeEnum} [scope] Either \&#39;user\&#39; (only user\&#39;s tracked bills) or \&#39;account\&#39; (all users in account)
         * @param {number} [days] Number of days to look back (default 30)
         * @param {ActivityType} [activityType] The activity type to get count for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityCount: async (scope?: GetActivityCountScopeEnum, days?: number, activityType?: ActivityType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tracked-bill-activity/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (activityType !== undefined) {
                localVarQueryParameter['activityType'] = activityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get historical DAU/MAU data for a date range
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityHistory: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getActivityHistory', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getActivityHistory', 'endDate', endDate)
            const localVarPath = `/api/analytics/activity-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Daily Active Users (DAU) and Monthly Active Users (MAU) metrics
         * @param {string} [date] Optional date in YYYY-MM-DD format. Defaults to today.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityMetrics: async (date?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/activity-metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdvancedSearchRequest} advancedSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvancedSearch: async (advancedSearchRequest: AdvancedSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advancedSearchRequest' is not null or undefined
            assertParamExists('getAdvancedSearch', 'advancedSearchRequest', advancedSearchRequest)
            const localVarPath = `/api/report/advanced-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(advancedSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvocateTestimony: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/testimonies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvocateTestimonyById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdvocateTestimonyById', 'id', id)
            const localVarPath = `/api/advocate-management/testimonies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAnalystMetrics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analysts/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalystCandidates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analysts/candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalystMetrics: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAnalystMetrics', 'id', id)
            const localVarPath = `/api/analysts/{id}/metrics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analysts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackAvailability: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/autotracked-bills/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackCompanies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auto-track-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} masterBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackMatch: async (masterBillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterBillId' is not null or undefined
            assertParamExists('getAutoTrackMatch', 'masterBillId', masterBillId)
            const localVarPath = `/api/autotracked-bills/matches/{masterBillId}`
                .replace(`{${"masterBillId"}}`, encodeURIComponent(String(masterBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAutoTrackMatchesOutcomeEnum} [outcome] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {number} [minScore] 
         * @param {number} [maxScore] 
         * @param {string} [rejectedStart] 
         * @param {string} [rejectedEnd] 
         * @param {GetAutoTrackMatchesPriorityEnum} [priority] 
         * @param {GetAutoTrackMatchesImpactEnum} [impact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackMatches: async (outcome?: GetAutoTrackMatchesOutcomeEnum, page?: number, pageSize?: number, search?: string, minScore?: number, maxScore?: number, rejectedStart?: string, rejectedEnd?: string, priority?: GetAutoTrackMatchesPriorityEnum, impact?: GetAutoTrackMatchesImpactEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/autotracked-bills/matches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (outcome !== undefined) {
                localVarQueryParameter['outcome'] = outcome;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (minScore !== undefined) {
                localVarQueryParameter['minScore'] = minScore;
            }

            if (maxScore !== undefined) {
                localVarQueryParameter['maxScore'] = maxScore;
            }

            if (rejectedStart !== undefined) {
                localVarQueryParameter['rejectedStart'] = (rejectedStart as any instanceof Date) ?
                    (rejectedStart as any).toISOString() :
                    rejectedStart;
            }

            if (rejectedEnd !== undefined) {
                localVarQueryParameter['rejectedEnd'] = (rejectedEnd as any instanceof Date) ?
                    (rejectedEnd as any).toISOString() :
                    rejectedEnd;
            }

            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }

            if (impact !== undefined) {
                localVarQueryParameter['impact'] = impact;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackStates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auto-track-states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auto-track-states/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {ViewScope} [viewScope] 
         * @param {number} [targetFolderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackedBill: async (billId: string, viewScope?: ViewScope, targetFolderId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getAutoTrackedBill', 'billId', billId)
            const localVarPath = `/api/autotracked-bills/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (targetFolderId !== undefined) {
                localVarQueryParameter['targetFolderId'] = targetFolderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [sorted] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {ViewScope} [viewScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackedBills: async (sorted?: number, page?: number, pageSize?: number, viewScope?: ViewScope, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/autotracked-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (sorted !== undefined) {
                localVarQueryParameter['sorted'] = sorted;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sessions for multiple states in a single request
         * @param {GetBatchSessionsRequest} getBatchSessionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchSessions: async (getBatchSessionsRequest: GetBatchSessionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getBatchSessionsRequest' is not null or undefined
            assertParamExists('getBatchSessions', 'getBatchSessionsRequest', getBatchSessionsRequest)
            const localVarPath = `/api/sessions/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBatchSessionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [includeAiSummary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill: async (id: string, includeAiSummary?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBill', 'id', id)
            const localVarPath = `/api/bills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (includeAiSummary !== undefined) {
                localVarQueryParameter['includeAiSummary'] = includeAiSummary;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Bill Agent statistics for the current account
         * @param {number} [accountId] 
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillAgentStats: async (accountId?: number, viewScope?: ViewScope, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bill-agent/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillAiSummary: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillAiSummary', 'id', id)
            const localVarPath = `/api/bills/{id}/ai-summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [billId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillAlerts: async (billId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bill-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BillAlertsBulkBody} billAlertsBulkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillAlertsBulk: async (billAlertsBulkBody: BillAlertsBulkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billAlertsBulkBody' is not null or undefined
            assertParamExists('getBillAlertsBulk', 'billAlertsBulkBody', billAlertsBulkBody)
            const localVarPath = `/api/bill-alerts/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billAlertsBulkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get committee calendar entries for the selected date range. When trackedOnly is true, results are limited to bills tracked by the account.
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [trackedOnly] 
         * @param {Array<string>} [stateCodes] 
         * @param {Array<number>} [clientCompanyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillCalendar: async (startDate?: string, endDate?: string, trackedOnly?: boolean, stateCodes?: Array<string>, clientCompanyIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calendar-events/bill-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (trackedOnly !== undefined) {
                localVarQueryParameter['trackedOnly'] = trackedOnly;
            }

            if (stateCodes) {
                localVarQueryParameter['stateCodes'] = stateCodes;
            }

            if (clientCompanyIds) {
                localVarQueryParameter['clientCompanyIds'] = clientCompanyIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get bill chat history for the current session and specific bill
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillChatHistory: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getBillChatHistory', 'billId', billId)
            const localVarPath = `/api/ai/bill-chat/history/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillComments: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillComments', 'id', id)
            const localVarPath = `/api/bills/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillCompaniesOfInterest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillCompaniesOfInterest', 'id', id)
            const localVarPath = `/api/bills/{id}/companies-of-interest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillCompanions: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillCompanions', 'id', id)
            const localVarPath = `/api/bills/{id}/companions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetBillComparisonRequest} getBillComparisonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillComparison: async (getBillComparisonRequest: GetBillComparisonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getBillComparisonRequest' is not null or undefined
            assertParamExists('getBillComparison', 'getBillComparisonRequest', getBillComparisonRequest)
            const localVarPath = `/api/bills/comparison`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBillComparisonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillComparisonAi: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillComparisonAi', 'id', id)
            const localVarPath = `/api/bills/comparison-ai/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [billVersionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillContent: async (id: string, billVersionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillContent', 'id', id)
            const localVarPath = `/api/bills/{id}/content`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billVersionId !== undefined) {
                localVarQueryParameter['billVersionId'] = billVersionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get download URL for bill content - UPDATED TO BE A PROXY ENDPOINT Now returns the actual file stream instead of a SAS URL
         * @param {string} id 
         * @param {string} billVersionId 
         * @param {GetBillDownloadUrlFormatEnum} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDownloadUrl: async (id: string, billVersionId: string, format?: GetBillDownloadUrlFormatEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillDownloadUrl', 'id', id)
            // verify required parameter 'billVersionId' is not null or undefined
            assertParamExists('getBillDownloadUrl', 'billVersionId', billVersionId)
            const localVarPath = `/api/bills/{id}/download-url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billVersionId !== undefined) {
                localVarQueryParameter['billVersionId'] = billVersionId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillHistory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillHistory', 'id', id)
            const localVarPath = `/api/bills/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillNotes: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getBillNotes', 'billId', billId)
            const localVarPath = `/api/tasks/bill-notes/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} masterBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillPriorityImpact: async (masterBillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterBillId' is not null or undefined
            assertParamExists('getBillPriorityImpact', 'masterBillId', masterBillId)
            const localVarPath = `/api/committee-agent/bill-priority-impact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (masterBillId !== undefined) {
                localVarQueryParameter['masterBillId'] = masterBillId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillRemarks: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getBillRemarks', 'billId', billId)
            const localVarPath = `/api/remarks/bill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdvancedSearchRequest} advancedSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillReport: async (advancedSearchRequest: AdvancedSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advancedSearchRequest' is not null or undefined
            assertParamExists('getBillReport', 'advancedSearchRequest', advancedSearchRequest)
            const localVarPath = `/api/report/bill-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(advancedSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillSimilarAi: async (id: string, state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillSimilarAi', 'id', id)
            const localVarPath = `/api/bills/{id}/similar-ai`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillStatutes: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillStatutes', 'id', id)
            const localVarPath = `/api/bills/{id}/statutes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillSubjects: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillSubjects', 'id', id)
            const localVarPath = `/api/bills/{id}/subjects`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillSupportingDocuments: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillSupportingDocuments', 'id', id)
            const localVarPath = `/api/bills/{id}/supporting-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillTags: async (billId: string, sessionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getBillTags', 'billId', billId)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getBillTags', 'sessionCode', sessionCode)
            const localVarPath = `/api/tags/bills/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get testimony for a specific bill
         * @param {string} masterBillId The ID of the bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillTestimony: async (masterBillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterBillId' is not null or undefined
            assertParamExists('getBillTestimony', 'masterBillId', masterBillId)
            const localVarPath = `/api/testimony/bill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (masterBillId !== undefined) {
                localVarQueryParameter['masterBillId'] = masterBillId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [billVersionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillText: async (id: string, billVersionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillText', 'id', id)
            const localVarPath = `/api/bills/{id}/text`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billVersionId !== undefined) {
                localVarQueryParameter['billVersionId'] = billVersionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillVersions: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillVersions', 'id', id)
            const localVarPath = `/api/bills/{id}/versions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillVotes: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillVotes', 'id', id)
            const localVarPath = `/api/bills/{id}/votes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {Array<string>} [sessionCodes] Array of session codes for multi-session search
         * @param {Array<number>} [subjects] 
         * @param {string} [searchTerm] 
         * @param {Array<string>} [types] 
         * @param {string} [authorName] 
         * @param {string} [statuteSection] 
         * @param {string} [statuteCode] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<string>} [parties] 
         * @param {string} [textSearch] 
         * @param {number} [rerankCompanyId] 
         * @param {boolean} [rerankProgress] 
         * @param {boolean} [onlyCommitteeChairFiled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBills: async (page?: number, pageSize?: number, stateCode?: string, sessionCode?: string, sessionCodes?: Array<string>, subjects?: Array<number>, searchTerm?: string, types?: Array<string>, authorName?: string, statuteSection?: string, statuteCode?: string, dateFrom?: string, dateTo?: string, parties?: Array<string>, textSearch?: string, rerankCompanyId?: number, rerankProgress?: boolean, onlyCommitteeChairFiled?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (sessionCodes) {
                localVarQueryParameter['sessionCodes'] = sessionCodes;
            }

            if (subjects) {
                localVarQueryParameter['subjects'] = subjects;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (authorName !== undefined) {
                localVarQueryParameter['authorName'] = authorName;
            }

            if (statuteSection !== undefined) {
                localVarQueryParameter['statuteSection'] = statuteSection;
            }

            if (statuteCode !== undefined) {
                localVarQueryParameter['statuteCode'] = statuteCode;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }

            if (parties) {
                localVarQueryParameter['parties'] = parties;
            }

            if (textSearch !== undefined) {
                localVarQueryParameter['textSearch'] = textSearch;
            }

            if (rerankCompanyId !== undefined) {
                localVarQueryParameter['rerankCompanyId'] = rerankCompanyId;
            }

            if (rerankProgress !== undefined) {
                localVarQueryParameter['rerankProgress'] = rerankProgress;
            }

            if (onlyCommitteeChairFiled !== undefined) {
                localVarQueryParameter['onlyCommitteeChairFiled'] = onlyCommitteeChairFiled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} onlyWithHistory 
         * @param {boolean} onlyTrackedTags 
         * @param {Array<string>} [types] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [historyDateFrom] 
         * @param {string} [historyDateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillsWithHistory: async (onlyWithHistory: boolean, onlyTrackedTags: boolean, types?: Array<string>, limit?: number, page?: number, historyDateFrom?: string, historyDateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onlyWithHistory' is not null or undefined
            assertParamExists('getBillsWithHistory', 'onlyWithHistory', onlyWithHistory)
            // verify required parameter 'onlyTrackedTags' is not null or undefined
            assertParamExists('getBillsWithHistory', 'onlyTrackedTags', onlyTrackedTags)
            const localVarPath = `/api/bills/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (onlyWithHistory !== undefined) {
                localVarQueryParameter['onlyWithHistory'] = onlyWithHistory;
            }

            if (onlyTrackedTags !== undefined) {
                localVarQueryParameter['onlyTrackedTags'] = onlyTrackedTags;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (historyDateFrom !== undefined) {
                localVarQueryParameter['historyDateFrom'] = (historyDateFrom as any instanceof Date) ?
                    (historyDateFrom as any).toISOString() :
                    historyDateFrom;
            }

            if (historyDateTo !== undefined) {
                localVarQueryParameter['historyDateTo'] = (historyDateTo as any instanceof Date) ?
                    (historyDateTo as any).toISOString() :
                    historyDateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cache statistics
         * @param {string} xApiKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCacheStats: async (xApiKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xApiKey' is not null or undefined
            assertParamExists('getCacheStats', 'xApiKey', xApiKey)
            const localVarPath = `/api/admin/cache/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [stateCodes] 
         * @param {string} [sessionCode] 
         * @param {Array<number>} [eventTypeIds] 
         * @param {boolean} [includeUserEvents] 
         * @param {boolean} [includeAccountEvents] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEvents: async (stateCodes?: Array<string>, sessionCode?: string, eventTypeIds?: Array<number>, includeUserEvents?: boolean, includeAccountEvents?: boolean, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calendar-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCodes) {
                localVarQueryParameter['stateCodes'] = stateCodes;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (eventTypeIds) {
                localVarQueryParameter['eventTypeIds'] = eventTypeIds;
            }

            if (includeUserEvents !== undefined) {
                localVarQueryParameter['includeUserEvents'] = includeUserEvents;
            }

            if (includeAccountEvents !== undefined) {
                localVarQueryParameter['includeAccountEvents'] = includeAccountEvents;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get campaign finance data with various filters
         * @param {string} stateCode The state code for the state to filter by.
         * @param {number} page Page number for pagination
         * @param {number} limit Number of records per page
         * @param {string} [search] General search term across multiple fields
         * @param {string} [filerName] Filter by filer name
         * @param {string} [contributorOrganization] Filter by contributor organization
         * @param {string} [contributorFirstName] Filter by contributor first name
         * @param {string} [contributorLastName] Filter by contributor last name
         * @param {string} [contributorState] Filter by contributor state
         * @param {number} [year] Filter by minimum year
         * @param {number} [minAmount] Filter by minimum contribution amount
         * @param {number} [maxAmount] Filter by maximum contribution amount
         * @param {boolean} [isLobbyist] 
         * @param {boolean} [isMember] Filter by contributions made to members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignFinance: async (stateCode: string, page: number, limit: number, search?: string, filerName?: string, contributorOrganization?: string, contributorFirstName?: string, contributorLastName?: string, contributorState?: string, year?: number, minAmount?: number, maxAmount?: number, isLobbyist?: boolean, isMember?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getCampaignFinance', 'stateCode', stateCode)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCampaignFinance', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCampaignFinance', 'limit', limit)
            const localVarPath = `/api/finance/campaign-finance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filerName !== undefined) {
                localVarQueryParameter['filerName'] = filerName;
            }

            if (contributorOrganization !== undefined) {
                localVarQueryParameter['contributorOrganization'] = contributorOrganization;
            }

            if (contributorFirstName !== undefined) {
                localVarQueryParameter['contributorFirstName'] = contributorFirstName;
            }

            if (contributorLastName !== undefined) {
                localVarQueryParameter['contributorLastName'] = contributorLastName;
            }

            if (contributorState !== undefined) {
                localVarQueryParameter['contributorState'] = contributorState;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (minAmount !== undefined) {
                localVarQueryParameter['minAmount'] = minAmount;
            }

            if (maxAmount !== undefined) {
                localVarQueryParameter['maxAmount'] = maxAmount;
            }

            if (isLobbyist !== undefined) {
                localVarQueryParameter['isLobbyist'] = isLobbyist;
            }

            if (isMember !== undefined) {
                localVarQueryParameter['isMember'] = isMember;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get campaign finance filers
         * @param {string} [search] Search term for filer name
         * @param {string} [state] Filter by state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignFinanceFilers: async (search?: string, state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/finance/campaign-finance/filers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get chat history for the current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ai/chat/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {string} [sessionCode] 
         * @param {boolean} [includeInactiveSessions] 
         * @param {boolean} [includeAutoUnsorted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBills: async (companyId: number, sessionCode?: string, includeInactiveSessions?: boolean, includeAutoUnsorted?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getClientBills', 'companyId', companyId)
            const localVarPath = `/api/client-crm/clients/{companyId}/bills`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (includeInactiveSessions !== undefined) {
                localVarQueryParameter['includeInactiveSessions'] = includeInactiveSessions;
            }

            if (includeAutoUnsorted !== undefined) {
                localVarQueryParameter['includeAutoUnsorted'] = includeAutoUnsorted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientCommitteeActivity: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getClientCommitteeActivity', 'companyId', companyId)
            const localVarPath = `/api/client-crm/clients/{companyId}/committee-activity`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientContributions: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getClientContributions', 'companyId', companyId)
            const localVarPath = `/api/client-crm/clients/{companyId}/contributions`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientDashboard: async (includeInactive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/client-crm/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientDetails: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getClientDetails', 'companyId', companyId)
            const localVarPath = `/api/client-crm/clients/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Video Clip.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClip: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getClip', 'uuid', uuid)
            const localVarPath = `/api/committee-videos/clip/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} masterCompanyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCluster: async (masterCompanyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterCompanyId' is not null or undefined
            assertParamExists('getCluster', 'masterCompanyId', masterCompanyId)
            const localVarPath = `/api/company-clusters/{masterCompanyId}`
                .replace(`{${"masterCompanyId"}}`, encodeURIComponent(String(masterCompanyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [stateCodes] 
         * @param {string} [sessionCode] 
         * @param {Array<number>} [eventTypeIds] 
         * @param {boolean} [includeUserEvents] 
         * @param {boolean} [includeAccountEvents] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCombinedCalendarEvents: async (stateCodes?: Array<string>, sessionCode?: string, eventTypeIds?: Array<number>, includeUserEvents?: boolean, includeAccountEvents?: boolean, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calendar-events/extra`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCodes) {
                localVarQueryParameter['stateCodes'] = stateCodes;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (eventTypeIds) {
                localVarQueryParameter['eventTypeIds'] = eventTypeIds;
            }

            if (includeUserEvents !== undefined) {
                localVarQueryParameter['includeUserEvents'] = includeUserEvents;
            }

            if (includeAccountEvents !== undefined) {
                localVarQueryParameter['includeAccountEvents'] = includeAccountEvents;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full detail for one committee session by its ID
         * @param {number} id 
         * @param {string} sessionCode 
         * @param {string} [sections] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommittee: async (id: number, sessionCode: string, sections?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCommittee', 'id', id)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getCommittee', 'sessionCode', sessionCode)
            const localVarPath = `/api/committees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (sections !== undefined) {
                localVarQueryParameter['sections'] = sections;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recent activity for Committee Agent
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAgentRecentActivity: async (viewScope?: ViewScope, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-agent/recent-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAgentStates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-agent-states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Committee Agent statistics for the current account
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAgentStats: async (viewScope?: ViewScope, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-agent/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [committeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAlerts: async (committeeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (committeeId !== undefined) {
                localVarQueryParameter['committeeId'] = committeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get committee analysis for the current account
         * @param {GetCommitteeAnalysisMinPriorityEnum} [minPriority] 
         * @param {GetCommitteeAnalysisMinImpactEnum} [minImpact] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAnalysis: async (minPriority?: GetCommitteeAnalysisMinPriorityEnum, minImpact?: GetCommitteeAnalysisMinImpactEnum, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (minPriority !== undefined) {
                localVarQueryParameter['minPriority'] = minPriority;
            }

            if (minImpact !== undefined) {
                localVarQueryParameter['minImpact'] = minImpact;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single committee analysis by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAnalysisById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCommitteeAnalysisById', 'id', id)
            const localVarPath = `/api/committee-analysis/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all clips from CommitteeVideoClips table
         * @param {ViewScope} [viewScope] 
         * @param {number} [limit] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeClips: async (viewScope?: ViewScope, limit?: number, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-agent/clips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all summaries from CommitteeVideoSummaries table
         * @param {ViewScope} [viewScope] 
         * @param {number} [limit] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeSummaries: async (viewScope?: ViewScope, limit?: number, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-agent/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of CommitteeVideo, optionally filtered by state and with text search support.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {string} [chamber] 
         * @param {string} [committee] 
         * @param {number} [year] 
         * @param {number} [month] 
         * @param {string} [searchTerm] 
         * @param {string} [textSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeVideo: async (page?: number, pageSize?: number, stateCode?: string, sessionCode?: string, chamber?: string, committee?: string, year?: number, month?: number, searchTerm?: string, textSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-videos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (chamber !== undefined) {
                localVarQueryParameter['chamber'] = chamber;
            }

            if (committee !== undefined) {
                localVarQueryParameter['committee'] = committee;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (textSearch !== undefined) {
                localVarQueryParameter['textSearch'] = textSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get full detail for one committee video by its ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeVideoById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCommitteeVideoById', 'id', id)
            const localVarPath = `/api/committee-videos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of all committee sessions in a given state + session
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {string} [searchTerm] 
         * @param {boolean} [includeNonSession] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommittees: async (stateCode: string, sessionCode: string, searchTerm?: string, includeNonSession?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getCommittees', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getCommittees', 'sessionCode', sessionCode)
            const localVarPath = `/api/committees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (includeNonSession !== undefined) {
                localVarQueryParameter['includeNonSession'] = includeNonSession;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of companies with pagination, searching, and sorting.
         * @param {string} [state] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {boolean} [aiSearch] 
         * @param {string} [sortBy] 
         * @param {GetCompaniesSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies: async (state?: string, page?: number, limit?: number, search?: string, aiSearch?: boolean, sortBy?: string, sortOrder?: GetCompaniesSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (aiSearch !== undefined) {
                localVarQueryParameter['aiSearch'] = aiSearch;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get companies of interest based on user\'s tracked bills and recent bills. Uses bill embeddings from Pinecone to find relevant companies.
         * @param {string} [stateCode] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesOfInterest: async (stateCode?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/companies/of-interest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get companies that the user has configured keywords for. Returns only companies that appear as keys in the user\'s BillKeywords config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesWithKeywords: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/companies/with-keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single company by its CompanyID.
         * @param {number} id numeric ID of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompany', 'id', id)
            const localVarPath = `/api/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAnalytics: async (stateCode: string, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getCompanyAnalytics', 'stateCode', stateCode)
            const localVarPath = `/api/lobby-analytics/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBillsOfInterest: async (id: number, stateCode?: string, sessionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyBillsOfInterest', 'id', id)
            const localVarPath = `/api/companies/{id}/bills-of-interest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get contributions for a specific company
         * @param {number} companyId The ID of the company
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyContributions: async (companyId: number, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyContributions', 'companyId', companyId)
            const localVarPath = `/api/finance/company-contributions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get firm engagements for a given company.
         * @param {number} id 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyFirmEngagements: async (id: number, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyFirmEngagements', 'id', id)
            const localVarPath = `/api/companies/{id}/firm-engagements`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all state variants for a company, grouped by MasterCompanyID. Returns a list of company ids and their state codes so the UI can switch states.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyStates: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyStates', 'id', id)
            const localVarPath = `/api/companies/{id}/states`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get testimony for a specific company
         * @param {number} companyId The ID of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyTestimony: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyTestimony', 'companyId', companyId)
            const localVarPath = `/api/testimony/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyTickSheet: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getCompanyTickSheet', 'billId', billId)
            const localVarPath = `/api/company-tick-sheets/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get concatenated regulations for an entire parent level
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConcatenatedParentLevel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getConcatenatedParentLevel', 'id', id)
            const localVarPath = `/api/regs/id/{id}/concatenated-parent`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all documents for a remark
         * @param {number} remarkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (remarkId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'remarkId' is not null or undefined
            assertParamExists('getDocuments', 'remarkId', remarkId)
            const localVarPath = `/api/remarks/{remarkId}/documents`
                .replace(`{${"remarkId"}}`, encodeURIComponent(String(remarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calendar-events/event-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalTrackingCounts: async (billIds: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billIds' is not null or undefined
            assertParamExists('getExternalTrackingCounts', 'billIds', billIds)
            const localVarPath = `/api/advocate-management/bills/tracking-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billIds !== undefined) {
                localVarQueryParameter['billIds'] = billIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} masterBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesByBill: async (masterBillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterBillId' is not null or undefined
            assertParamExists('getFilesByBill', 'masterBillId', masterBillId)
            const localVarPath = `/api/user-storage/files/by-bill/{masterBillId}`
                .replace(`{${"masterBillId"}}`, encodeURIComponent(String(masterBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single firm by its FirmID with all associated lobbyists.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirm: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFirm', 'id', id)
            const localVarPath = `/api/firms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmAnalytics: async (stateCode: string, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getFirmAnalytics', 'stateCode', stateCode)
            const localVarPath = `/api/lobby-analytics/firms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get firm engagements for a given firm.
         * @param {number} id 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmEngagements: async (id: number, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFirmEngagements', 'id', id)
            const localVarPath = `/api/firms/{id}/engagements`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of firms with pagination, searching, and sorting.
         * @param {string} [stateCode] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetFirmsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirms: async (stateCode?: string, page?: number, limit?: number, search?: string, sortBy?: string, sortOrder?: GetFirmsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/firms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderTree: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-storage/folders/tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGmailIntegration: async (accountId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/integrations/gmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {string} [redirectUri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGmailOAuthUrl: async (accountId?: number, redirectUri?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/integrations/gmail/oauth-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = redirectUri;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getIsAccountNew: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/initSetup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssue: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIssue', 'id', id)
            const localVarPath = `/api/issues/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [status] 
         * @param {string} [issueType] 
         * @param {string} [priority] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssues: async (status?: string, issueType?: string, priority?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/issues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (issueType !== undefined) {
                localVarQueryParameter['issueType'] = issueType;
            }

            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get keyword clips for the current account (all users in the account)
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeywordClips: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-agent/keyword-clips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeywordGenerationStatus: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getKeywordGenerationStatus', 'companyId', companyId)
            const localVarPath = `/api/initSetup/keyword-status/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/news/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestBillContent: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getLatestBillContent', 'billId', billId)
            const localVarPath = `/api/tasks/bill-content/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get latest bill match from AutoTrackReasoning
         * @param {number} [accountId] 
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestMatch: async (accountId?: number, viewScope?: ViewScope, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bill-agent/latest-match`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegislators: async (stateCode: string, sessionCode: string, accountId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getLegislators', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getLegislators', 'sessionCode', sessionCode)
            const localVarPath = `/api/relationships/legislators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recent live actions filtered by state
         * @param {Array<string>} [stateCodes] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveActions: async (stateCodes?: Array<string>, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/live-actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCodes) {
                localVarQueryParameter['stateCodes'] = stateCodes;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch by exactly one of lobbyistId, companyId, masterCompanyId, or companySearch.
         * @param {number} [lobbyistId] 
         * @param {number} [companyId] 
         * @param {number} [masterCompanyId] 
         * @param {number} [year] 
         * @param {string} [companySearch] 
         * @param {string} [stateCode] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyEngagements: async (lobbyistId?: number, companyId?: number, masterCompanyId?: number, year?: number, companySearch?: string, stateCode?: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lobbyists/engagements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lobbyistId !== undefined) {
                localVarQueryParameter['lobbyistId'] = lobbyistId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (masterCompanyId !== undefined) {
                localVarQueryParameter['masterCompanyId'] = masterCompanyId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (companySearch !== undefined) {
                localVarQueryParameter['companySearch'] = companySearch;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyist: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLobbyist', 'id', id)
            const localVarPath = `/api/lobbyists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lobbyistId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistAlerts: async (lobbyistId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lobbyist-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (lobbyistId !== undefined) {
                localVarQueryParameter['lobbyistId'] = lobbyistId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistAnalytics: async (stateCode: string, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getLobbyistAnalytics', 'stateCode', stateCode)
            const localVarPath = `/api/lobby-analytics/lobbyists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistClients: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLobbyistClients', 'id', id)
            const localVarPath = `/api/lobbyists/{id}/clients`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Contributions filtered by lobbyist and/or company.
         * @param {number} [lobbyistId] 
         * @param {number} [companyId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistContributions: async (lobbyistId?: number, companyId?: number, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lobbyists/contributions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lobbyistId !== undefined) {
                localVarQueryParameter['lobbyistId'] = lobbyistId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [lobbyistId] 
         * @param {number} [companyId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistTestimony: async (lobbyistId?: number, companyId?: number, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lobbyists/testimony`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lobbyistId !== undefined) {
                localVarQueryParameter['lobbyistId'] = lobbyistId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetLobbyistsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyists: async (stateCode?: string, page?: number, limit?: number, search?: string, sortBy?: string, sortOrder?: GetLobbyistsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lobbyists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistsByState: async (stateCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/states/lobbyists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed information for a single member
         * @param {number} id 
         * @param {string} sessionCode 
         * @param {boolean} [includeAuthoredBills] 
         * @param {boolean} [includePassedBills] 
         * @param {boolean} [includeSponsoredBills] 
         * @param {boolean} [includeCoSponsors] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberById: async (id: number, sessionCode: string, includeAuthoredBills?: boolean, includePassedBills?: boolean, includeSponsoredBills?: boolean, includeCoSponsors?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMemberById', 'id', id)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getMemberById', 'sessionCode', sessionCode)
            const localVarPath = `/api/members/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (includeAuthoredBills !== undefined) {
                localVarQueryParameter['includeAuthoredBills'] = includeAuthoredBills;
            }

            if (includePassedBills !== undefined) {
                localVarQueryParameter['includePassedBills'] = includePassedBills;
            }

            if (includeSponsoredBills !== undefined) {
                localVarQueryParameter['includeSponsoredBills'] = includeSponsoredBills;
            }

            if (includeCoSponsors !== undefined) {
                localVarQueryParameter['includeCoSponsors'] = includeCoSponsors;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get co-sponsors for a member
         * @param {number} id 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberCoSponsors: async (id: number, sessionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMemberCoSponsors', 'id', id)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getMemberCoSponsors', 'sessionCode', sessionCode)
            const localVarPath = `/api/members/{id}/co-sponsors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get contact information for multiple members in batch This is a lightweight endpoint that only fetches contact data without expensive stats calculations
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {string} [chamber] 
         * @param {string} [memberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberContactsBatch: async (stateCode: string, sessionCode: string, chamber?: string, memberIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getMemberContactsBatch', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getMemberContactsBatch', 'sessionCode', sessionCode)
            const localVarPath = `/api/members/contacts/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (chamber !== undefined) {
                localVarQueryParameter['chamber'] = chamber;
            }

            if (memberIds !== undefined) {
                localVarQueryParameter['memberIds'] = memberIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get district demographics for a member
         * @param {number} id 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberDemographics: async (id: number, sessionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMemberDemographics', 'id', id)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getMemberDemographics', 'sessionCode', sessionCode)
            const localVarPath = `/api/members/{id}/demographics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get available filter options (chambers and parties) for a state/session
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberFilters: async (stateCode: string, sessionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getMemberFilters', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getMemberFilters', 'sessionCode', sessionCode)
            const localVarPath = `/api/members/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single member image
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberImage: async (memberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getMemberImage', 'memberId', memberId)
            const localVarPath = `/api/member-images/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Proxy endpoint for member images - provides access without exposing SAS URLs Member images are public, so no authentication required  IMPORTANT: This route MUST be defined before the generic getMemberById (\'{id}\') route. Otherwise, Express will match \'/api/members/123/image\' as getMemberById with id=\'123/image\'.
         * @param {number} id Member ID
         * @param {string} [ext] File extension (default: jpg)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberImage_2: async (id: number, ext?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMemberImage_2', 'id', id)
            const localVarPath = `/api/members/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ext !== undefined) {
                localVarQueryParameter['ext'] = ext;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get multiple member images in bulk
         * @param {MemberImagesBulkBody} memberImagesBulkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberImagesBulk: async (memberImagesBulkBody: MemberImagesBulkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberImagesBulkBody' is not null or undefined
            assertParamExists('getMemberImagesBulk', 'memberImagesBulkBody', memberImagesBulkBody)
            const localVarPath = `/api/member-images/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberImagesBulkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get member statistics leaderboards for a state Shows stats from the last completed regular session
         * @param {string} stateCode 
         * @param {string} [currentSessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberLeaderboards: async (stateCode: string, currentSessionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getMemberLeaderboards', 'stateCode', stateCode)
            const localVarPath = `/api/members/leaderboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (currentSessionCode !== undefined) {
                localVarQueryParameter['currentSessionCode'] = currentSessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberList: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMemberList', 'id', id)
            const localVarPath = `/api/member-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberLists: async (stateCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/member-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberPublicContributions: async (memberId: number, stateCode?: string, sessionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getMemberPublicContributions', 'memberId', memberId)
            const localVarPath = `/api/relationships/{memberId}/public-contributions`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {number} [accountId] 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberRelationships: async (memberId: number, accountId?: number, stateCode?: string, sessionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getMemberRelationships', 'memberId', memberId)
            const localVarPath = `/api/relationships/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {Chamber} [chamber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberTickSheet: async (billId: string, chamber?: Chamber, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getMemberTickSheet', 'billId', billId)
            const localVarPath = `/api/member-tick-sheets/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (chamber !== undefined) {
                localVarQueryParameter['chamber'] = chamber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all members for a given state and session
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [pageSize] Number of items per page
         * @param {string} [searchTerm] 
         * @param {string} [chamber] 
         * @param {string} [party] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers: async (stateCode: string, sessionCode: string, page?: number, pageSize?: number, searchTerm?: string, chamber?: string, party?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getMembers', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getMembers', 'sessionCode', sessionCode)
            const localVarPath = `/api/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (chamber !== undefined) {
                localVarQueryParameter['chamber'] = chamber;
            }

            if (party !== undefined) {
                localVarQueryParameter['party'] = party;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payment history (invoices) for the authenticated user\'s account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentHistory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/payment-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingFullAccountInvitations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/invitations/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingInvitations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingRegistration: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getPendingRegistration', 'sessionId', sessionId)
            const localVarPath = `/api/promo-registration/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalBillRemarks: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getPersonalBillRemarks', 'billId', billId)
            const localVarPath = `/api/remarks/bill/personal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlans: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} state 
         * @param {string} session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulateAdvancedFilters: async (state: string, session: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getPopulateAdvancedFilters', 'state', state)
            // verify required parameter 'session' is not null or undefined
            assertParamExists('getPopulateAdvancedFilters', 'session', session)
            const localVarPath = `/api/report/populate-advanced-filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (session !== undefined) {
                localVarQueryParameter['session'] = session;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get priority bills for the current account
         * @param {number} [accountId] 
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriorityBills: async (accountId?: number, viewScope?: ViewScope, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bill-agent/priority-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recent activity for Bill Agent
         * @param {number} [accountId] 
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentActivity: async (accountId?: number, viewScope?: ViewScope, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bill-agent/recent-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recent committee analysis
         * @param {ViewScope} [viewScope] 
         * @param {number} [limit] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentAnalysis: async (viewScope?: ViewScope, limit?: number, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-agent/recent-analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recent committee analysis (for dashboard widget)
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentCommitteeAnalysis: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-analysis/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentReports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get regulation details by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegById', 'id', id)
            const localVarPath = `/api/regs/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get companies related to a specific regulation
         * @param {string} id 
         * @param {string} stateCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegCompaniesOfInterest: async (id: string, stateCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegCompaniesOfInterest', 'id', id)
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getRegCompaniesOfInterest', 'stateCode', stateCode)
            const localVarPath = `/api/regs/id/{id}/companies-of-interest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get items for a specific hierarchy level
         * @param {string} state 
         * @param {RegHierarchyField} level 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [level1] 
         * @param {string} [level2] 
         * @param {string} [level3] 
         * @param {string} [level4] 
         * @param {string} [level5] 
         * @param {string} [level6] 
         * @param {string} [level7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegHierarchyItems: async (state: string, level: RegHierarchyField, page?: number, pageSize?: number, level1?: string, level2?: string, level3?: string, level4?: string, level5?: string, level6?: string, level7?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getRegHierarchyItems', 'state', state)
            // verify required parameter 'level' is not null or undefined
            assertParamExists('getRegHierarchyItems', 'level', level)
            const localVarPath = `/api/regs/hierarchy/{state}/items`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (level1 !== undefined) {
                localVarQueryParameter['level1'] = level1;
            }

            if (level2 !== undefined) {
                localVarQueryParameter['level2'] = level2;
            }

            if (level3 !== undefined) {
                localVarQueryParameter['level3'] = level3;
            }

            if (level4 !== undefined) {
                localVarQueryParameter['level4'] = level4;
            }

            if (level5 !== undefined) {
                localVarQueryParameter['level5'] = level5;
            }

            if (level6 !== undefined) {
                localVarQueryParameter['level6'] = level6;
            }

            if (level7 !== undefined) {
                localVarQueryParameter['level7'] = level7;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get regulations for the selected hierarchy path
         * @param {string} state 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [level1] 
         * @param {string} [level2] 
         * @param {string} [level3] 
         * @param {string} [level4] 
         * @param {string} [level5] 
         * @param {string} [level6] 
         * @param {string} [level7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegHierarchyRegs: async (state: string, page?: number, pageSize?: number, level1?: string, level2?: string, level3?: string, level4?: string, level5?: string, level6?: string, level7?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getRegHierarchyRegs', 'state', state)
            const localVarPath = `/api/regs/hierarchy/{state}/regs`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (level1 !== undefined) {
                localVarQueryParameter['level1'] = level1;
            }

            if (level2 !== undefined) {
                localVarQueryParameter['level2'] = level2;
            }

            if (level3 !== undefined) {
                localVarQueryParameter['level3'] = level3;
            }

            if (level4 !== undefined) {
                localVarQueryParameter['level4'] = level4;
            }

            if (level5 !== undefined) {
                localVarQueryParameter['level5'] = level5;
            }

            if (level6 !== undefined) {
                localVarQueryParameter['level6'] = level6;
            }

            if (level7 !== undefined) {
                localVarQueryParameter['level7'] = level7;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get hierarchy overview for all states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegHierarchyStateCounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/regs/hierarchy/state-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get hierarchy structure for a specific state
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegHierarchyStructure: async (state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getRegHierarchyStructure', 'state', state)
            const localVarPath = `/api/regs/hierarchy/{state}/structure`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get bills related to a specific statute
         * @param {string} statutoryCode The statutory code
         * @param {string} reference The statutory reference
         * @param {string} stateCode The state code
         * @param {string} sessionCode The session code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedBillsByStatute: async (statutoryCode: string, reference: string, stateCode: string, sessionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statutoryCode' is not null or undefined
            assertParamExists('getRelatedBillsByStatute', 'statutoryCode', statutoryCode)
            // verify required parameter 'reference' is not null or undefined
            assertParamExists('getRelatedBillsByStatute', 'reference', reference)
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getRelatedBillsByStatute', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getRelatedBillsByStatute', 'sessionCode', sessionCode)
            const localVarPath = `/api/statutes/{statutoryCode}/{reference}`
                .replace(`{${"statutoryCode"}}`, encodeURIComponent(String(statutoryCode)))
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportContactList: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportContactList', 'id', id)
            const localVarPath = `/api/report-contacts/lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportContactLists: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report-contacts/lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {Chamber} [chamber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedTickSheets: async (billId: string, chamber?: Chamber, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getSavedTickSheets', 'billId', billId)
            const localVarPath = `/api/member-tick-sheets/{billId}/saved`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (chamber !== undefined) {
                localVarQueryParameter['chamber'] = chamber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedTickSheets_3: async (billId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getSavedTickSheets_3', 'billId', billId)
            const localVarPath = `/api/company-tick-sheets/{billId}/saved`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleTimezones: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report/schedule/timezones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledReports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/seats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectionTags: async (sectionId: string, sessionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('getSectionTags', 'sectionId', sectionId)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getSectionTags', 'sessionCode', sessionCode)
            const localVarPath = `/api/tags/sections/{sectionId}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessions: async (stateCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedTags: async (state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/guest/shared-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackIntegration: async (accountId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/integrations/slack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get staff for a given state and session
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {number} [memberId] Optional filter for a specific member ID
         * @param {string} [position] Optional filter for staff position/title
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [pageSize] Number of items per page
         * @param {string} [searchTerm] Optional search across first/last name, title, email, phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff: async (stateCode: string, sessionCode: string, memberId?: number, position?: string, page?: number, pageSize?: number, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getStaff', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getStaff', 'sessionCode', sessionCode)
            const localVarPath = `/api/staff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStakeholderContacts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stakeholder-meetings/stakeholders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [stakeholderId] 
         * @param {number} [accountId] 
         * @param {string} [masterBillId] 
         * @param {number} [companyId] 
         * @param {string} [meetingType] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStakeholderMeetings: async (stakeholderId?: number, accountId?: number, masterBillId?: string, companyId?: number, meetingType?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stakeholder-meetings/meetings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stakeholderId !== undefined) {
                localVarQueryParameter['stakeholderId'] = stakeholderId;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (masterBillId !== undefined) {
                localVarQueryParameter['masterBillId'] = masterBillId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (meetingType !== undefined) {
                localVarQueryParameter['meetingType'] = meetingType;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of State Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-videos/stateCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all members for a given state
         * @param {string} stateCode 
         * @param {string} [searchTerm] 
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [pageSize] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateMembers: async (stateCode: string, searchTerm?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getStateMembers', 'stateCode', stateCode)
            const localVarPath = `/api/members/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetStatsScopeEnum} [scope] 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats: async (scope?: GetStatsScopeEnum, stateCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the blob URL for a statute
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteBlobUrl: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStatuteBlobUrl', 'id', id)
            const localVarPath = `/api/statutes/id/{id}/blob-url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statute details by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStatuteById', 'id', id)
            const localVarPath = `/api/statutes/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get companies related to a specific statute
         * @param {string} id 
         * @param {string} stateCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteCompaniesOfInterest: async (id: string, stateCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStatuteCompaniesOfInterest', 'id', id)
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getStatuteCompaniesOfInterest', 'stateCode', stateCode)
            const localVarPath = `/api/statutes/id/{id}/companies-of-interest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get items for a specific hierarchy level
         * @param {string} state 
         * @param {StatuteHierarchyField} level 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [code] 
         * @param {string} [title] 
         * @param {string} [subtitle] 
         * @param {string} [article] 
         * @param {string} [chapter] 
         * @param {string} [subchapter] 
         * @param {string} [section] 
         * @param {string} [subsection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteHierarchyItems: async (state: string, level: StatuteHierarchyField, page?: number, pageSize?: number, code?: string, title?: string, subtitle?: string, article?: string, chapter?: string, subchapter?: string, section?: string, subsection?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getStatuteHierarchyItems', 'state', state)
            // verify required parameter 'level' is not null or undefined
            assertParamExists('getStatuteHierarchyItems', 'level', level)
            const localVarPath = `/api/statutes/hierarchy/{state}/items`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (subtitle !== undefined) {
                localVarQueryParameter['subtitle'] = subtitle;
            }

            if (article !== undefined) {
                localVarQueryParameter['article'] = article;
            }

            if (chapter !== undefined) {
                localVarQueryParameter['chapter'] = chapter;
            }

            if (subchapter !== undefined) {
                localVarQueryParameter['subchapter'] = subchapter;
            }

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (subsection !== undefined) {
                localVarQueryParameter['subsection'] = subsection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get hierarchy overview for all states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteHierarchyStateCounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/statutes/hierarchy/state-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statutes for the selected hierarchy path
         * @param {string} state 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [code] 
         * @param {string} [title] 
         * @param {string} [subtitle] 
         * @param {string} [article] 
         * @param {string} [chapter] 
         * @param {string} [subchapter] 
         * @param {string} [section] 
         * @param {string} [subsection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteHierarchyStatutes: async (state: string, page?: number, pageSize?: number, code?: string, title?: string, subtitle?: string, article?: string, chapter?: string, subchapter?: string, section?: string, subsection?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getStatuteHierarchyStatutes', 'state', state)
            const localVarPath = `/api/statutes/hierarchy/{state}/statutes`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (subtitle !== undefined) {
                localVarQueryParameter['subtitle'] = subtitle;
            }

            if (article !== undefined) {
                localVarQueryParameter['article'] = article;
            }

            if (chapter !== undefined) {
                localVarQueryParameter['chapter'] = chapter;
            }

            if (subchapter !== undefined) {
                localVarQueryParameter['subchapter'] = subchapter;
            }

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (subsection !== undefined) {
                localVarQueryParameter['subsection'] = subsection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get hierarchy structure for a specific state
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteHierarchyStructure: async (state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getStatuteHierarchyStructure', 'state', state)
            const localVarPath = `/api/statutes/hierarchy/{state}/structure`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjects: async (stateCode: string, sessionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getSubjects', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('getSubjects', 'sessionCode', sessionCode)
            const localVarPath = `/api/subjects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current subscription details for the authenticated user\'s account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagCompanyAssignmentStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tags/company-assignment-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTask', 'id', id)
            const localVarPath = `/api/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFiles: async (taskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTaskFiles', 'taskId', taskId)
            const localVarPath = `/api/tasks/files/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskNotes: async (taskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTaskNotes', 'taskId', taskId)
            const localVarPath = `/api/tasks/notes/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {number} [teamId] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks: async (userId?: number, teamId?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeam', 'id', id)
            const localVarPath = `/api/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {number} tickSheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTickSheetById: async (billId: string, tickSheetId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getTickSheetById', 'billId', billId)
            // verify required parameter 'tickSheetId' is not null or undefined
            assertParamExists('getTickSheetById', 'tickSheetId', tickSheetId)
            const localVarPath = `/api/member-tick-sheets/{billId}/saved/{tickSheetId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)))
                .replace(`{${"tickSheetId"}}`, encodeURIComponent(String(tickSheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {number} tickSheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTickSheetById_4: async (billId: string, tickSheetId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getTickSheetById_4', 'billId', billId)
            // verify required parameter 'tickSheetId' is not null or undefined
            assertParamExists('getTickSheetById_4', 'tickSheetId', tickSheetId)
            const localVarPath = `/api/company-tick-sheets/{billId}/saved/{tickSheetId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)))
                .replace(`{${"tickSheetId"}}`, encodeURIComponent(String(tickSheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} trackListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackList: async (trackListId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackListId' is not null or undefined
            assertParamExists('getTrackList', 'trackListId', trackListId)
            const localVarPath = `/api/track-lists/{trackListId}`
                .replace(`{${"trackListId"}}`, encodeURIComponent(String(trackListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedActivityEmails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report/tracking-activity/emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedActivityReport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/guest/tracked-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recent bill history for all bills tracked by the user or account
         * @param {GetTrackedBillActivityScopeEnum} [scope] Either \&#39;user\&#39; (only user\&#39;s tracked bills) or \&#39;account\&#39; (all users in account)
         * @param {number} [days] Number of days to look back (default 30)
         * @param {number} [page] Page number
         * @param {number} [pageSize] Items per page
         * @param {ActivityType} [activityType] Filter activity by category (all, progress, text, votes)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedBillActivity: async (scope?: GetTrackedBillActivityScopeEnum, days?: number, page?: number, pageSize?: number, activityType?: ActivityType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tracked-bill-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (activityType !== undefined) {
                localVarQueryParameter['activityType'] = activityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetTrackedBillProgressScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedBillProgress: async (scope?: GetTrackedBillProgressScopeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/tracked-progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [states] 
         * @param {string} [sessionKeys] 
         * @param {boolean} [activeOnly] 
         * @param {string} [tagIds] 
         * @param {GetTrackedBillsTagLogicEnum} [tagLogic] 
         * @param {string} [trackTypes] 
         * @param {string} [progressStatuses] 
         * @param {boolean} [alertsOnly] 
         * @param {boolean} [excludeLobbyistUsers] 
         * @param {ViewScope} [viewScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedBills: async (page?: number, pageSize?: number, search?: string, states?: string, sessionKeys?: string, activeOnly?: boolean, tagIds?: string, tagLogic?: GetTrackedBillsTagLogicEnum, trackTypes?: string, progressStatuses?: string, alertsOnly?: boolean, excludeLobbyistUsers?: boolean, viewScope?: ViewScope, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tags/tracked-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }

            if (sessionKeys !== undefined) {
                localVarQueryParameter['sessionKeys'] = sessionKeys;
            }

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }

            if (tagIds !== undefined) {
                localVarQueryParameter['tagIds'] = tagIds;
            }

            if (tagLogic !== undefined) {
                localVarQueryParameter['tagLogic'] = tagLogic;
            }

            if (trackTypes !== undefined) {
                localVarQueryParameter['trackTypes'] = trackTypes;
            }

            if (progressStatuses !== undefined) {
                localVarQueryParameter['progressStatuses'] = progressStatuses;
            }

            if (alertsOnly !== undefined) {
                localVarQueryParameter['alertsOnly'] = alertsOnly;
            }

            if (excludeLobbyistUsers !== undefined) {
                localVarQueryParameter['excludeLobbyistUsers'] = excludeLobbyistUsers;
            }

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get live actions for tracked bills
         * @param {GetTrackedLiveActionsScopeEnum} [scope] 
         * @param {number} [days] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedLiveActions: async (scope?: GetTrackedLiveActionsScopeEnum, days?: number, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/live-actions/tracked`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of live actions for tracked bills
         * @param {GetTrackedLiveActionsCountScopeEnum} [scope] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedLiveActionsCount: async (scope?: GetTrackedLiveActionsCountScopeEnum, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/live-actions/tracked/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedWitnesses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/testimonies/tracked-witnesses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdvancedSearchRequest} advancedSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingActivityReport: async (advancedSearchRequest: AdvancedSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advancedSearchRequest' is not null or undefined
            assertParamExists('getTrackingActivityReport', 'advancedSearchRequest', advancedSearchRequest)
            const localVarPath = `/api/report/tracking-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(advancedSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get upcoming committee hearings for a given state
         * @param {string} stateCode 
         * @param {string} [sessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingHearings: async (stateCode: string, sessionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getUpcomingHearings', 'stateCode', stateCode)
            const localVarPath = `/api/committees/hearings/upcoming`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get upcoming hearings with tracked bills
         * @param {ViewScope} [viewScope] 
         * @param {number} [limit] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingHearings_5: async (viewScope?: ViewScope, limit?: number, sortedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/committee-agent/upcoming-hearings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (viewScope !== undefined) {
                localVarQueryParameter['viewScope'] = viewScope;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortedOnly !== undefined) {
                localVarQueryParameter['sortedOnly'] = sortedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUser', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAutoTrackStates: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserAutoTrackStates', 'userId', userId)
            const localVarPath = `/api/accounts/users/{userId}/auto-track-states`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContacts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [folderId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFiles: async (folderId?: number, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-storage/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTaskMetrics: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserTaskMetrics', 'userId', userId)
            const localVarPath = `/api/tasks/user-metrics/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrackedActivity: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserTrackedActivity', 'userId', userId)
            const localVarPath = `/api/accounts/users/{userId}/tracked-activity`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get calendar events for bills tracked by the current user
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrackedBillCalendar: async (startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calendar-events/tracked-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [roleName] 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (roleName?: string, stateCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (roleName !== undefined) {
                localVarQueryParameter['roleName'] = roleName;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [lobbyistId] 
         * @param {number} [companyId] 
         * @param {GetValidYearsTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidYears: async (lobbyistId?: number, companyId?: number, type?: GetValidYearsTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lobbyists/valid-years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lobbyistId !== undefined) {
                localVarQueryParameter['lobbyistId'] = lobbyistId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all saved clip sets for a video
         * @param {number} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoClips: async (videoId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            assertParamExists('getVideoClips', 'videoId', videoId)
            const localVarPath = `/api/committee-videos/{videoId}/clips`
                .replace(`{${"videoId"}}`, encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all saved summaries for a video
         * @param {number} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoSummaries: async (videoId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            assertParamExists('getVideoSummaries', 'videoId', videoId)
            const localVarPath = `/api/committee-videos/{videoId}/summaries`
                .replace(`{${"videoId"}}`, encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed voting records (including member info) for a specific vote.
         * @param {number} voteId The ID of the vote to fetch details for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoteDetails: async (voteId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voteId' is not null or undefined
            assertParamExists('getVoteDetails', 'voteId', voteId)
            const localVarPath = `/api/votes/{voteId}/details`
                .replace(`{${"voteId"}}`, encodeURIComponent(String(voteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VoteReportRequest} voteReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoteReport: async (voteReportRequest: VoteReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voteReportRequest' is not null or undefined
            assertParamExists('getVoteReport', 'voteReportRequest', voteReportRequest)
            const localVarPath = `/api/report/vote-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voteReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportReportContactsRequest} importReportContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importReportContacts: async (importReportContactsRequest: ImportReportContactsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importReportContactsRequest' is not null or undefined
            assertParamExists('importReportContacts', 'importReportContactsRequest', importReportContactsRequest)
            const localVarPath = `/api/report-contacts/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importReportContactsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InviteUserRequest} inviteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAnalyst: async (inviteUserRequest: InviteUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteUserRequest' is not null or undefined
            assertParamExists('inviteAnalyst', 'inviteUserRequest', inviteUserRequest)
            const localVarPath = `/api/analysts/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InviteUserRequest} inviteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteFullAccount: async (inviteUserRequest: InviteUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteUserRequest' is not null or undefined
            assertParamExists('inviteFullAccount', 'inviteUserRequest', inviteUserRequest)
            const localVarPath = `/api/accounts/invite-full`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if a session is currently active (SineDie = 0)
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSessionActive: async (stateCode: string, sessionCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('isSessionActive', 'stateCode', stateCode)
            // verify required parameter 'sessionCode' is not null or undefined
            assertParamExists('isSessionActive', 'sessionCode', sessionCode)
            const localVarPath = `/api/sessions/is-active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [billId] 
         * @param {number} [tagId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillPositions: async (billId?: string, tagId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bill-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }

            if (tagId !== undefined) {
                localVarQueryParameter['tagId'] = tagId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {InteractionPayload} interactionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logInteraction: async (companyId: number, interactionPayload: InteractionPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('logInteraction', 'companyId', companyId)
            // verify required parameter 'interactionPayload' is not null or undefined
            assertParamExists('logInteraction', 'interactionPayload', interactionPayload)
            const localVarPath = `/api/client-crm/clients/{companyId}/interactions`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interactionPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Login a user
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logout the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkAsReadRequest} markAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead: async (markAsReadRequest: MarkAsReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markAsReadRequest' is not null or undefined
            assertParamExists('markAsRead', 'markAsReadRequest', markAsReadRequest)
            const localVarPath = `/api/notifications/mark-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markAsReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {MoveFileRequest} moveFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveFile: async (fileId: number, moveFileRequest: MoveFileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('moveFile', 'fileId', fileId)
            // verify required parameter 'moveFileRequest' is not null or undefined
            assertParamExists('moveFile', 'moveFileRequest', moveFileRequest)
            const localVarPath = `/api/user-storage/files/{fileId}/move`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} masterCompanyId 
         * @param {PeelClusterBody} peelClusterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peelCompanies: async (masterCompanyId: number, peelClusterBody: PeelClusterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterCompanyId' is not null or undefined
            assertParamExists('peelCompanies', 'masterCompanyId', masterCompanyId)
            // verify required parameter 'peelClusterBody' is not null or undefined
            assertParamExists('peelCompanies', 'peelClusterBody', peelClusterBody)
            const localVarPath = `/api/company-clusters/{masterCompanyId}/peel`
                .replace(`{${"masterCompanyId"}}`, encodeURIComponent(String(masterCompanyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(peelClusterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PurchaseSeatsRequest} purchaseSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseSeats: async (purchaseSeatsRequest: PurchaseSeatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseSeatsRequest' is not null or undefined
            assertParamExists('purchaseSeats', 'purchaseSeatsRequest', purchaseSeatsRequest)
            const localVarPath = `/api/accounts/seats/purchase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseSeatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query the AI assistant for bill analysis
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryAiChat: async (chatRequest: ChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('queryAiChat', 'chatRequest', chatRequest)
            const localVarPath = `/api/ai/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query the AI assistant for video transcript analysis
         * @param {VideoQuestionRequest} videoQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryVideoChat: async (videoQuestionRequest: VideoQuestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoQuestionRequest' is not null or undefined
            assertParamExists('queryVideoChat', 'videoQuestionRequest', videoQuestionRequest)
            const localVarPath = `/api/ai/video-chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoQuestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Queue background keyword generation for one or more companies
         * @param {QueueKeywordGenerationRequest} queueKeywordGenerationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueKeywordGeneration: async (queueKeywordGenerationRequest: QueueKeywordGenerationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueKeywordGenerationRequest' is not null or undefined
            assertParamExists('queueKeywordGeneration', 'queueKeywordGenerationRequest', queueKeywordGenerationRequest)
            const localVarPath = `/api/initSetup/queue-keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueKeywordGenerationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reactivate a canceled subscription (before period end)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/reactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCalendarCache: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/refresh-calendar-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshDashboardCache: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/refresh-dashboard-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshExistingCache: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/refresh-existing-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshMainDashboardCache: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/refresh-main-dashboard-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshUserDashboardCache: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/refresh-user-dashboard-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a new user
         * @param {InsertUser} insertUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (insertUser: InsertUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'insertUser' is not null or undefined
            assertParamExists('register', 'insertUser', insertUser)
            const localVarPath = `/api/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insertUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RejectAutoTrackedBillBody} rejectAutoTrackedBillBody 
         * @param {boolean} [bypassAccessCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAutoTrackedBill: async (rejectAutoTrackedBillBody: RejectAutoTrackedBillBody, bypassAccessCheck?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rejectAutoTrackedBillBody' is not null or undefined
            assertParamExists('rejectAutoTrackedBill', 'rejectAutoTrackedBillBody', rejectAutoTrackedBillBody)
            const localVarPath = `/api/tags/bills/reject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (bypassAccessCheck !== undefined) {
                localVarQueryParameter['bypassAccessCheck'] = bypassAccessCheck;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectAutoTrackedBillBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTeamMember: async (id: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeTeamMember', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeTeamMember', 'userId', userId)
            const localVarPath = `/api/teams/{id}/members/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveTrackedBillBody} removeTrackedBillBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTrackedBill: async (removeTrackedBillBody: RemoveTrackedBillBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removeTrackedBillBody' is not null or undefined
            assertParamExists('removeTrackedBill', 'removeTrackedBillBody', removeTrackedBillBody)
            const localVarPath = `/api/track-lists/remove-bill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeTrackedBillBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} witnessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTrackedWitness: async (witnessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'witnessId' is not null or undefined
            assertParamExists('removeTrackedWitness', 'witnessId', witnessId)
            const localVarPath = `/api/advocate-management/testimonies/tracked-witnesses/{witnessId}`
                .replace(`{${"witnessId"}}`, encodeURIComponent(String(witnessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {RenameFileRequest} renameFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFile: async (fileId: number, renameFileRequest: RenameFileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('renameFile', 'fileId', fileId)
            // verify required parameter 'renameFileRequest' is not null or undefined
            assertParamExists('renameFile', 'renameFileRequest', renameFileRequest)
            const localVarPath = `/api/user-storage/files/{fileId}/name`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {RenameFileRequest} renameFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFolder: async (folderId: number, renameFileRequest: RenameFileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('renameFolder', 'folderId', folderId)
            // verify required parameter 'renameFileRequest' is not null or undefined
            assertParamExists('renameFolder', 'renameFileRequest', renameFileRequest)
            const localVarPath = `/api/user-storage/folders/{folderId}/name`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report missing live stream
         * @param {MissingLiveReportBody} missingLiveReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportMissingLive: async (missingLiveReportBody: MissingLiveReportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'missingLiveReportBody' is not null or undefined
            assertParamExists('reportMissingLive', 'missingLiveReportBody', missingLiveReportBody)
            const localVarPath = `/api/committee-videos/missing-live-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(missingLiveReportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate and automatically regenerate a summary when it does not match the company. This endpoint returns immediately and processes the validation/regeneration in the background.
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportWrongCompanySummary: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('reportWrongCompanySummary', 'companyId', companyId)
            const localVarPath = `/api/company-summary-fix/{companyId}/report`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MissingParamsRequest} missingParamsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMissingParams: async (missingParamsRequest: MissingParamsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'missingParamsRequest' is not null or undefined
            assertParamExists('requestMissingParams', 'missingParamsRequest', missingParamsRequest)
            const localVarPath = `/api/ai/request-missing-params`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(missingParamsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation: async (invitationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('revokeInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/accounts/invitations/{invitationId}/revoke`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} scheduledReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runScheduledReport: async (scheduledReportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduledReportId' is not null or undefined
            assertParamExists('runScheduledReport', 'scheduledReportId', scheduledReportId)
            const localVarPath = `/api/report/run-scheduled/{scheduledReportId}`
                .replace(`{${"scheduledReportId"}}`, encodeURIComponent(String(scheduledReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveAccountCompanyClaimsBody} saveAccountCompanyClaimsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountCompanyClaims: async (saveAccountCompanyClaimsBody: SaveAccountCompanyClaimsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveAccountCompanyClaimsBody' is not null or undefined
            assertParamExists('saveAccountCompanyClaims', 'saveAccountCompanyClaimsBody', saveAccountCompanyClaimsBody)
            const localVarPath = `/api/account-company-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAccountCompanyClaimsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveAccountCompanySummaryBody} saveAccountCompanySummaryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountCompanySummary: async (saveAccountCompanySummaryBody: SaveAccountCompanySummaryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveAccountCompanySummaryBody' is not null or undefined
            assertParamExists('saveAccountCompanySummary', 'saveAccountCompanySummaryBody', saveAccountCompanySummaryBody)
            const localVarPath = `/api/account-company-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAccountCompanySummaryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveAutoTrackCompaniesBody} saveAutoTrackCompaniesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAutoTrackCompanies: async (saveAutoTrackCompaniesBody: SaveAutoTrackCompaniesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveAutoTrackCompaniesBody' is not null or undefined
            assertParamExists('saveAutoTrackCompanies', 'saveAutoTrackCompaniesBody', saveAutoTrackCompaniesBody)
            const localVarPath = `/api/auto-track-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAutoTrackCompaniesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveAutoTrackStatesBody} saveAutoTrackStatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAutoTrackStates: async (saveAutoTrackStatesBody: SaveAutoTrackStatesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveAutoTrackStatesBody' is not null or undefined
            assertParamExists('saveAutoTrackStates', 'saveAutoTrackStatesBody', saveAutoTrackStatesBody)
            const localVarPath = `/api/auto-track-states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAutoTrackStatesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveBillAlertBody} saveBillAlertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillAlert: async (saveBillAlertBody: SaveBillAlertBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveBillAlertBody' is not null or undefined
            assertParamExists('saveBillAlert', 'saveBillAlertBody', saveBillAlertBody)
            const localVarPath = `/api/bill-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveBillAlertBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveBillTagsBody} saveBillTagsBody 
         * @param {boolean} [bypassAccessCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillTags: async (saveBillTagsBody: SaveBillTagsBody, bypassAccessCheck?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveBillTagsBody' is not null or undefined
            assertParamExists('saveBillTags', 'saveBillTagsBody', saveBillTagsBody)
            const localVarPath = `/api/tags/bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (bypassAccessCheck !== undefined) {
                localVarQueryParameter['bypassAccessCheck'] = bypassAccessCheck;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveBillTagsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveCommitteeAgentStatesBody} saveCommitteeAgentStatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCommitteeAgentStates: async (saveCommitteeAgentStatesBody: SaveCommitteeAgentStatesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveCommitteeAgentStatesBody' is not null or undefined
            assertParamExists('saveCommitteeAgentStates', 'saveCommitteeAgentStatesBody', saveCommitteeAgentStatesBody)
            const localVarPath = `/api/committee-agent-states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCommitteeAgentStatesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveCommitteeAlertBody} saveCommitteeAlertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCommitteeAlert: async (saveCommitteeAlertBody: SaveCommitteeAlertBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveCommitteeAlertBody' is not null or undefined
            assertParamExists('saveCommitteeAlert', 'saveCommitteeAlertBody', saveCommitteeAlertBody)
            const localVarPath = `/api/committee-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCommitteeAlertBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {SaveCompanyTickSheetBody} saveCompanyTickSheetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyTickSheet: async (billId: string, saveCompanyTickSheetBody: SaveCompanyTickSheetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('saveCompanyTickSheet', 'billId', billId)
            // verify required parameter 'saveCompanyTickSheetBody' is not null or undefined
            assertParamExists('saveCompanyTickSheet', 'saveCompanyTickSheetBody', saveCompanyTickSheetBody)
            const localVarPath = `/api/company-tick-sheets/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCompanyTickSheetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveLobbyistAlertBody} saveLobbyistAlertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLobbyistAlert: async (saveLobbyistAlertBody: SaveLobbyistAlertBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveLobbyistAlertBody' is not null or undefined
            assertParamExists('saveLobbyistAlert', 'saveLobbyistAlertBody', saveLobbyistAlertBody)
            const localVarPath = `/api/lobbyist-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveLobbyistAlertBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} billId 
         * @param {SaveMemberTickSheetBody} saveMemberTickSheetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMemberTickSheet: async (billId: string, saveMemberTickSheetBody: SaveMemberTickSheetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('saveMemberTickSheet', 'billId', billId)
            // verify required parameter 'saveMemberTickSheetBody' is not null or undefined
            assertParamExists('saveMemberTickSheet', 'saveMemberTickSheetBody', saveMemberTickSheetBody)
            const localVarPath = `/api/member-tick-sheets/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveMemberTickSheetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveReportSettingRequest} saveReportSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReportSetting: async (saveReportSettingRequest: SaveReportSettingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveReportSettingRequest' is not null or undefined
            assertParamExists('saveReportSetting', 'saveReportSettingRequest', saveReportSettingRequest)
            const localVarPath = `/api/report/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveReportSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveSectionTagsBody} saveSectionTagsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSectionTags: async (saveSectionTagsBody: SaveSectionTagsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveSectionTagsBody' is not null or undefined
            assertParamExists('saveSectionTags', 'saveSectionTagsBody', saveSectionTagsBody)
            const localVarPath = `/api/tags/sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveSectionTagsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveUserSettingsBody} saveUserSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserSettings: async (saveUserSettingsBody: SaveUserSettingsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveUserSettingsBody' is not null or undefined
            assertParamExists('saveUserSettings', 'saveUserSettingsBody', saveUserSettingsBody)
            const localVarPath = `/api/user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveUserSettingsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ScheduleReportRequest} scheduleReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleReport: async (scheduleReportRequest: ScheduleReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleReportRequest' is not null or undefined
            assertParamExists('scheduleReport', 'scheduleReportRequest', scheduleReportRequest)
            const localVarPath = `/api/report/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search the bills index using ElasticSearch
         * @param {string} term 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<string>} [stateCodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (term: string, page?: number, limit?: number, stateCodes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'term' is not null or undefined
            assertParamExists('search', 'term', term)
            const localVarPath = `/api/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (stateCodes) {
                localVarQueryParameter['stateCodes'] = stateCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for companies by name, returns one representative company per MasterCompanyID with lobbyist count. Used for the invite page searchbar.
         * @param {string} search 
         * @param {string} [stateCode] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompaniesForInvite: async (search: string, stateCode?: string, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('searchCompaniesForInvite', 'search', search)
            const localVarPath = `/api/lobbyists/companies/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search regulations via word or AI search
         * @param {string} [query] 
         * @param {SearchRegsSearchModeEnum} [searchMode] 
         * @param {string} [wordQuery] 
         * @param {string} [aiQuery] 
         * @param {string} [state] 
         * @param {string} [code] 
         * @param {string} [title] 
         * @param {string} [chapter] 
         * @param {string} [section] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {string} [article] 
         * @param {string} [subtitle] 
         * @param {string} [subchapter] 
         * @param {string} [subsection] 
         * @param {string} [rule] 
         * @param {string} [part] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRegs: async (query?: string, searchMode?: SearchRegsSearchModeEnum, wordQuery?: string, aiQuery?: string, state?: string, code?: string, title?: string, chapter?: string, section?: string, name?: string, fileName?: string, article?: string, subtitle?: string, subchapter?: string, subsection?: string, rule?: string, part?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/regs/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (searchMode !== undefined) {
                localVarQueryParameter['searchMode'] = searchMode;
            }

            if (wordQuery !== undefined) {
                localVarQueryParameter['wordQuery'] = wordQuery;
            }

            if (aiQuery !== undefined) {
                localVarQueryParameter['aiQuery'] = aiQuery;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (chapter !== undefined) {
                localVarQueryParameter['chapter'] = chapter;
            }

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (article !== undefined) {
                localVarQueryParameter['article'] = article;
            }

            if (subtitle !== undefined) {
                localVarQueryParameter['subtitle'] = subtitle;
            }

            if (subchapter !== undefined) {
                localVarQueryParameter['subchapter'] = subchapter;
            }

            if (subsection !== undefined) {
                localVarQueryParameter['subsection'] = subsection;
            }

            if (rule !== undefined) {
                localVarQueryParameter['rule'] = rule;
            }

            if (part !== undefined) {
                localVarQueryParameter['part'] = part;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {string} [q] 
         * @param {string} [tags] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRemarks: async (stateCode?: string, sessionCode?: string, q?: string, tags?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/remarks/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (sessionCode !== undefined) {
                localVarQueryParameter['sessionCode'] = sessionCode;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search statutes via word or AI search
         * @param {string} [query] 
         * @param {SearchStatutesSearchModeEnum} [searchMode] 
         * @param {string} [wordQuery] 
         * @param {string} [aiQuery] 
         * @param {string} [state] 
         * @param {string} [code] 
         * @param {string} [title] 
         * @param {string} [chapter] 
         * @param {string} [section] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {string} [article] 
         * @param {string} [subtitle] 
         * @param {string} [subchapter] 
         * @param {string} [subsection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStatutes: async (query?: string, searchMode?: SearchStatutesSearchModeEnum, wordQuery?: string, aiQuery?: string, state?: string, code?: string, title?: string, chapter?: string, section?: string, name?: string, fileName?: string, article?: string, subtitle?: string, subchapter?: string, subsection?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/statutes/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (searchMode !== undefined) {
                localVarQueryParameter['searchMode'] = searchMode;
            }

            if (wordQuery !== undefined) {
                localVarQueryParameter['wordQuery'] = wordQuery;
            }

            if (aiQuery !== undefined) {
                localVarQueryParameter['aiQuery'] = aiQuery;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (chapter !== undefined) {
                localVarQueryParameter['chapter'] = chapter;
            }

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (article !== undefined) {
                localVarQueryParameter['article'] = article;
            }

            if (subtitle !== undefined) {
                localVarQueryParameter['subtitle'] = subtitle;
            }

            if (subchapter !== undefined) {
                localVarQueryParameter['subchapter'] = subchapter;
            }

            if (subsection !== undefined) {
                localVarQueryParameter['subsection'] = subsection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search committee videos by transcript text
         * @param {string} term 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<string>} [stateCodes] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVideos: async (term: string, page?: number, limit?: number, stateCodes?: Array<string>, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'term' is not null or undefined
            assertParamExists('searchVideos', 'term', term)
            const localVarPath = `/api/committee-videos/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (stateCodes) {
                localVarQueryParameter['stateCodes'] = stateCodes;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWitnessDirectory: async (query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/advocate-management/testimonies/witnesses/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GmailSendRequestBody} gmailSendRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAccountGmail: async (gmailSendRequestBody: GmailSendRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gmailSendRequestBody' is not null or undefined
            assertParamExists('sendAccountGmail', 'gmailSendRequestBody', gmailSendRequestBody)
            const localVarPath = `/api/integrations/gmail/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gmailSendRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailRequest} emailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail: async (emailRequest: EmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailRequest' is not null or undefined
            assertParamExists('sendEmail', 'emailRequest', emailRequest)
            const localVarPath = `/api/email/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendGmailTestMessageRequest} sendGmailTestMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendGmailTestMessage: async (sendGmailTestMessageRequest: SendGmailTestMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendGmailTestMessageRequest' is not null or undefined
            assertParamExists('sendGmailTestMessage', 'sendGmailTestMessageRequest', sendGmailTestMessageRequest)
            const localVarPath = `/api/integrations/gmail/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendGmailTestMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReferralInviteRequest} referralInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvite: async (referralInviteRequest: ReferralInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referralInviteRequest' is not null or undefined
            assertParamExists('sendInvite', 'referralInviteRequest', referralInviteRequest)
            const localVarPath = `/api/referrals/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referralInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewAnalystRequest} newAnalystRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewAnalyst: async (newAnalystRequest: NewAnalystRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newAnalystRequest' is not null or undefined
            assertParamExists('sendNewAnalyst', 'newAnalystRequest', newAnalystRequest)
            const localVarPath = `/api/email/new-analyst`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newAnalystRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SlackTestRequest} slackTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSlackTestMessage: async (slackTestRequest: SlackTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slackTestRequest' is not null or undefined
            assertParamExists('sendSlackTestMessage', 'slackTestRequest', slackTestRequest)
            const localVarPath = `/api/integrations/slack/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(slackTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SendTaskReminderRequest} sendTaskReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTaskReminder: async (id: number, sendTaskReminderRequest: SendTaskReminderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendTaskReminder', 'id', id)
            // verify required parameter 'sendTaskReminderRequest' is not null or undefined
            assertParamExists('sendTaskReminder', 'sendTaskReminderRequest', sendTaskReminderRequest)
            const localVarPath = `/api/tasks/{id}/remind`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTaskReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShareTagBody} shareTagBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareTag: async (shareTagBody: ShareTagBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareTagBody' is not null or undefined
            assertParamExists('shareTag', 'shareTagBody', shareTagBody)
            const localVarPath = `/api/tags/share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shareTagBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} masterCompanyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitCluster: async (masterCompanyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterCompanyId' is not null or undefined
            assertParamExists('splitCluster', 'masterCompanyId', masterCompanyId)
            const localVarPath = `/api/company-clusters/{masterCompanyId}/split`
                .replace(`{${"masterCompanyId"}}`, encodeURIComponent(String(masterCompanyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAutoTrack: async (type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('startAutoTrack', 'type', type)
            const localVarPath = `/api/autotracked-bills/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubscribeNewsletterRequest} subscribeNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeNewsletter: async (subscribeNewsletterRequest: SubscribeNewsletterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeNewsletterRequest' is not null or undefined
            assertParamExists('subscribeNewsletter', 'subscribeNewsletterRequest', subscribeNewsletterRequest)
            const localVarPath = `/api/newsletter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeNewsletterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a summary about an entity (company, lobbyist, or associate) based on their name
         * @param {EntitySummaryRequest} entitySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeText: async (entitySummaryRequest: EntitySummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entitySummaryRequest' is not null or undefined
            assertParamExists('summarizeText', 'entitySummaryRequest', entitySummaryRequest)
            const localVarPath = `/api/initSetup/summarize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entitySummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test Elasticsearch connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testConnection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/search/test-connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testKeywordMatching: async (days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/keyword-debug/test-matching`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} tagId 
         * @param {ToggleArchiveTagRequest} toggleArchiveTagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleArchiveTag: async (tagId: number, toggleArchiveTagRequest: ToggleArchiveTagRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('toggleArchiveTag', 'tagId', tagId)
            // verify required parameter 'toggleArchiveTagRequest' is not null or undefined
            assertParamExists('toggleArchiveTag', 'toggleArchiveTagRequest', toggleArchiveTagRequest)
            const localVarPath = `/api/tags/{tagId}/archive`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleArchiveTagRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Track report download
         * @param {TrackDownloadRequest} trackDownloadRequest Download tracking parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackReportDownload: async (trackDownloadRequest: TrackDownloadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackDownloadRequest' is not null or undefined
            assertParamExists('trackReportDownload', 'trackDownloadRequest', trackDownloadRequest)
            const localVarPath = `/api/report/track-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackDownloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAIStrengthRequest} updateAIStrengthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAIStrength: async (updateAIStrengthRequest: UpdateAIStrengthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAIStrengthRequest' is not null or undefined
            assertParamExists('updateAIStrength', 'updateAIStrengthRequest', updateAIStrengthRequest)
            const localVarPath = `/api/accounts/ai-strength`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAIStrengthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update account with selected entity immediately
         * @param {UpdateAccountEntityRequest} updateAccountEntityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountEntity: async (updateAccountEntityRequest: UpdateAccountEntityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAccountEntityRequest' is not null or undefined
            assertParamExists('updateAccountEntity', 'updateAccountEntityRequest', updateAccountEntityRequest)
            const localVarPath = `/api/initSetup/update-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountEntityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Priority and/or Impact for a bill in AutoTrackReasoning
         * @param {UpdateBillPriorityImpactRequest} updateBillPriorityImpactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillPriorityImpact: async (updateBillPriorityImpactRequest: UpdateBillPriorityImpactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateBillPriorityImpactRequest' is not null or undefined
            assertParamExists('updateBillPriorityImpact', 'updateBillPriorityImpactRequest', updateBillPriorityImpactRequest)
            const localVarPath = `/api/committee-agent/update-bill-priority-impact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBillPriorityImpactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientTags: async (companyId: number, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateClientTags', 'companyId', companyId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateClientTags', 'requestBody', requestBody)
            const localVarPath = `/api/client-crm/clients/{companyId}/tags`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the archived status for a saved clip set
         * @param {number} clipSetId 
         * @param {UpdateClipArchivedRequest} updateClipArchivedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClipArchived: async (clipSetId: number, updateClipArchivedRequest: UpdateClipArchivedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clipSetId' is not null or undefined
            assertParamExists('updateClipArchived', 'clipSetId', clipSetId)
            // verify required parameter 'updateClipArchivedRequest' is not null or undefined
            assertParamExists('updateClipArchived', 'updateClipArchivedRequest', updateClipArchivedRequest)
            const localVarPath = `/api/committee-videos/clips/{clipSetId}`
                .replace(`{${"clipSetId"}}`, encodeURIComponent(String(clipSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClipArchivedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCommitteeAgentEnabledRequest} updateCommitteeAgentEnabledRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommitteeAgentEnabled: async (updateCommitteeAgentEnabledRequest: UpdateCommitteeAgentEnabledRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCommitteeAgentEnabledRequest' is not null or undefined
            assertParamExists('updateCommitteeAgentEnabled', 'updateCommitteeAgentEnabledRequest', updateCommitteeAgentEnabledRequest)
            const localVarPath = `/api/accounts/committee-agent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommitteeAgentEnabledRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {UpdateCompanyStatusRequest} updateCompanyStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyStatus: async (companyId: number, updateCompanyStatusRequest: UpdateCompanyStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateCompanyStatus', 'companyId', companyId)
            // verify required parameter 'updateCompanyStatusRequest' is not null or undefined
            assertParamExists('updateCompanyStatus', 'updateCompanyStatusRequest', updateCompanyStatusRequest)
            const localVarPath = `/api/client-crm/clients/{companyId}/status`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {SummaryPayload} summaryPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanySummary: async (companyId: number, summaryPayload: SummaryPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateCompanySummary', 'companyId', companyId)
            // verify required parameter 'summaryPayload' is not null or undefined
            assertParamExists('updateCompanySummary', 'summaryPayload', summaryPayload)
            const localVarPath = `/api/client-crm/clients/{companyId}/summary`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(summaryPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {number} contactId 
         * @param {ContactPayload} contactPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (companyId: number, contactId: number, contactPayload: ContactPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateContact', 'companyId', companyId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('updateContact', 'contactId', contactId)
            // verify required parameter 'contactPayload' is not null or undefined
            assertParamExists('updateContact', 'contactPayload', contactPayload)
            const localVarPath = `/api/client-crm/clients/{companyId}/contacts/{contactId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {UpdateFolderColorSettingRequest} updateFolderColorSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolderColorSetting: async (folderId: number, updateFolderColorSettingRequest: UpdateFolderColorSettingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('updateFolderColorSetting', 'folderId', folderId)
            // verify required parameter 'updateFolderColorSettingRequest' is not null or undefined
            assertParamExists('updateFolderColorSetting', 'updateFolderColorSettingRequest', updateFolderColorSettingRequest)
            const localVarPath = `/api/user-storage/folders/{folderId}/color`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFolderColorSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateIssueRequest} updateIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssue: async (id: number, updateIssueRequest: UpdateIssueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIssue', 'id', id)
            // verify required parameter 'updateIssueRequest' is not null or undefined
            assertParamExists('updateIssue', 'updateIssueRequest', updateIssueRequest)
            const localVarPath = `/api/issues/{id}/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIssueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateKeywordMatchViewedRequest} updateKeywordMatchViewedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeywordMatchViewed: async (updateKeywordMatchViewedRequest: UpdateKeywordMatchViewedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateKeywordMatchViewedRequest' is not null or undefined
            assertParamExists('updateKeywordMatchViewed', 'updateKeywordMatchViewedRequest', updateKeywordMatchViewedRequest)
            const localVarPath = `/api/guest/tracked-activity/keyword-matches/viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKeywordMatchViewedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update keywords for an account after initial setup This allows keywords to be generated asynchronously and saved later
         * @param {UpdateKeywordsRequest} updateKeywordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeywords: async (updateKeywordsRequest: UpdateKeywordsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateKeywordsRequest' is not null or undefined
            assertParamExists('updateKeywords', 'updateKeywordsRequest', updateKeywordsRequest)
            const localVarPath = `/api/initSetup/update-keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKeywordsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMemberListRequest} updateMemberListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberList: async (id: number, updateMemberListRequest: UpdateMemberListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMemberList', 'id', id)
            // verify required parameter 'updateMemberListRequest' is not null or undefined
            assertParamExists('updateMemberList', 'updateMemberListRequest', updateMemberListRequest)
            const localVarPath = `/api/member-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {UpdateMetadataRequest} updateMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata: async (fileId: number, updateMetadataRequest: UpdateMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('updateMetadata', 'fileId', fileId)
            // verify required parameter 'updateMetadataRequest' is not null or undefined
            assertParamExists('updateMetadata', 'updateMetadataRequest', updateMetadataRequest)
            const localVarPath = `/api/user-storage/files/{fileId}/metadata`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMetadataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the priority and/or impact for a committee analysis record
         * @param {number} id 
         * @param {UpdatePriorityImpactRequest} updatePriorityImpactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriorityImpact: async (id: number, updatePriorityImpactRequest: UpdatePriorityImpactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePriorityImpact', 'id', id)
            // verify required parameter 'updatePriorityImpactRequest' is not null or undefined
            assertParamExists('updatePriorityImpact', 'updatePriorityImpactRequest', updatePriorityImpactRequest)
            const localVarPath = `/api/committee-analysis/{id}/priority-impact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePriorityImpactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} remarkId 
         * @param {UpdateBillRemarkBody} updateBillRemarkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRemark: async (remarkId: number, updateBillRemarkBody: UpdateBillRemarkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'remarkId' is not null or undefined
            assertParamExists('updateRemark', 'remarkId', remarkId)
            // verify required parameter 'updateBillRemarkBody' is not null or undefined
            assertParamExists('updateRemark', 'updateBillRemarkBody', updateBillRemarkBody)
            const localVarPath = `/api/remarks/{remarkId}`
                .replace(`{${"remarkId"}}`, encodeURIComponent(String(remarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBillRemarkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReportSettingRequest} updateReportSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportSetting: async (updateReportSettingRequest: UpdateReportSettingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateReportSettingRequest' is not null or undefined
            assertParamExists('updateReportSetting', 'updateReportSettingRequest', updateReportSettingRequest)
            const localVarPath = `/api/report/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSeatsRequest} updateSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeats: async (updateSeatsRequest: UpdateSeatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSeatsRequest' is not null or undefined
            assertParamExists('updateSeats', 'updateSeatsRequest', updateSeatsRequest)
            const localVarPath = `/api/accounts/seats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSeatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} stakeholderId 
         * @param {StakeholderContactInput} stakeholderContactInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStakeholderContact: async (stakeholderId: number, stakeholderContactInput: StakeholderContactInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stakeholderId' is not null or undefined
            assertParamExists('updateStakeholderContact', 'stakeholderId', stakeholderId)
            // verify required parameter 'stakeholderContactInput' is not null or undefined
            assertParamExists('updateStakeholderContact', 'stakeholderContactInput', stakeholderContactInput)
            const localVarPath = `/api/stakeholder-meetings/stakeholders/{stakeholderId}`
                .replace(`{${"stakeholderId"}}`, encodeURIComponent(String(stakeholderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stakeholderContactInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meetingId 
         * @param {StakeholderMeetingInput} stakeholderMeetingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStakeholderMeeting: async (meetingId: number, stakeholderMeetingInput: StakeholderMeetingInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('updateStakeholderMeeting', 'meetingId', meetingId)
            // verify required parameter 'stakeholderMeetingInput' is not null or undefined
            assertParamExists('updateStakeholderMeeting', 'stakeholderMeetingInput', stakeholderMeetingInput)
            const localVarPath = `/api/stakeholder-meetings/meetings/{meetingId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stakeholderMeetingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} tagId 
         * @param {UpdateTagRequest} updateTagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag: async (tagId: number, updateTagRequest: UpdateTagRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('updateTag', 'tagId', tagId)
            // verify required parameter 'updateTagRequest' is not null or undefined
            assertParamExists('updateTag', 'updateTagRequest', updateTagRequest)
            const localVarPath = `/api/tags/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTagRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTaskDto} updateTaskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask: async (id: number, updateTaskDto: UpdateTaskDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTask', 'id', id)
            // verify required parameter 'updateTaskDto' is not null or undefined
            assertParamExists('updateTask', 'updateTaskDto', updateTaskDto)
            const localVarPath = `/api/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTeamRequest} updateTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: async (id: number, updateTeamRequest: UpdateTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTeam', 'id', id)
            // verify required parameter 'updateTeamRequest' is not null or undefined
            assertParamExists('updateTeam', 'updateTeamRequest', updateTeamRequest)
            const localVarPath = `/api/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateTrackedActivityEmailSettingsBody} updateTrackedActivityEmailSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackedActivityEmails: async (updateTrackedActivityEmailSettingsBody: UpdateTrackedActivityEmailSettingsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateTrackedActivityEmailSettingsBody' is not null or undefined
            assertParamExists('updateTrackedActivityEmails', 'updateTrackedActivityEmailSettingsBody', updateTrackedActivityEmailSettingsBody)
            const localVarPath = `/api/report/tracking-activity/emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrackedActivityEmailSettingsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {TrackingPreferencesPayload} trackingPreferencesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackingPreferences: async (companyId: number, trackingPreferencesPayload: TrackingPreferencesPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateTrackingPreferences', 'companyId', companyId)
            // verify required parameter 'trackingPreferencesPayload' is not null or undefined
            assertParamExists('updateTrackingPreferences', 'trackingPreferencesPayload', trackingPreferencesPayload)
            const localVarPath = `/api/client-crm/clients/{companyId}/tracking-preferences`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingPreferencesPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {UpdateUserAutoTrackAccessRequest} updateUserAutoTrackAccessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAutoTrackAccess: async (userId: number, updateUserAutoTrackAccessRequest: UpdateUserAutoTrackAccessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserAutoTrackAccess', 'userId', userId)
            // verify required parameter 'updateUserAutoTrackAccessRequest' is not null or undefined
            assertParamExists('updateUserAutoTrackAccess', 'updateUserAutoTrackAccessRequest', updateUserAutoTrackAccessRequest)
            const localVarPath = `/api/accounts/users/{userId}/auto-track-access`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserAutoTrackAccessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the user\'s primary contact email. This is used when setting a lobbyist email.
         * @param {UpdateUserContactEmailRequest} updateUserContactEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserContactEmail: async (updateUserContactEmailRequest: UpdateUserContactEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserContactEmailRequest' is not null or undefined
            assertParamExists('updateUserContactEmail', 'updateUserContactEmailRequest', updateUserContactEmailRequest)
            const localVarPath = `/api/user-contacts/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserContactEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {UpdateUserRoleRequest} updateUserRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRole: async (userId: number, updateUserRoleRequest: UpdateUserRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserRole', 'userId', userId)
            // verify required parameter 'updateUserRoleRequest' is not null or undefined
            assertParamExists('updateUserRole', 'updateUserRoleRequest', updateUserRoleRequest)
            const localVarPath = `/api/accounts/users/{userId}/role`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {UpdateUserStatusRequest} updateUserStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus: async (userId: number, updateUserStatusRequest: UpdateUserStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserStatus', 'userId', userId)
            // verify required parameter 'updateUserStatusRequest' is not null or undefined
            assertParamExists('updateUserStatus', 'updateUserStatusRequest', updateUserStatusRequest)
            const localVarPath = `/api/accounts/users/{userId}/status`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {UpdateTrackedActivityConfigBody} updateTrackedActivityConfigBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTrackedActivity: async (userId: number, updateTrackedActivityConfigBody: UpdateTrackedActivityConfigBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserTrackedActivity', 'userId', userId)
            // verify required parameter 'updateTrackedActivityConfigBody' is not null or undefined
            assertParamExists('updateUserTrackedActivity', 'updateTrackedActivityConfigBody', updateTrackedActivityConfigBody)
            const localVarPath = `/api/accounts/users/{userId}/tracked-activity`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrackedActivityConfigBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the current user\'s username
         * @param {UpdateUsernameRequest} updateUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsername: async (updateUsernameRequest: UpdateUsernameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUsernameRequest' is not null or undefined
            assertParamExists('updateUsername', 'updateUsernameRequest', updateUsernameRequest)
            const localVarPath = `/api/auth/update-username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAccountLogo: async (files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadAccountLogo', 'files', files)
            const localVarPath = `/api/accounts/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication session required

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a document attachment to a remark
         * @param {number} remarkId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument: async (remarkId: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'remarkId' is not null or undefined
            assertParamExists('uploadDocument', 'remarkId', remarkId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadDocument', 'file', file)
            const localVarPath = `/api/remarks/{remarkId}/documents`
                .replace(`{${"remarkId"}}`, encodeURIComponent(String(remarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication session required


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocuments: async (companyId: number, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('uploadDocuments', 'companyId', companyId)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadDocuments', 'files', files)
            const localVarPath = `/api/client-crm/clients/{companyId}/documents`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication session required

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<File>} files 
         * @param {string} [folderId] 
         * @param {string} [companyId] 
         * @param {string} [masterBillId] 
         * @param {string} [purpose] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFiles: async (files: Array<File>, folderId?: string, companyId?: string, masterBillId?: string, purpose?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadFiles', 'files', files)
            const localVarPath = `/api/user-storage/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication session required

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (folderId !== undefined) { 
                localVarFormParams.append('folderId', folderId as any);
            }
    
            if (companyId !== undefined) { 
                localVarFormParams.append('companyId', companyId as any);
            }
    
            if (masterBillId !== undefined) { 
                localVarFormParams.append('masterBillId', masterBillId as any);
            }
    
            if (purpose !== undefined) { 
                localVarFormParams.append('purpose', purpose as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} companyId 
         * @param {UploadLogoFromUrlRequest} uploadLogoFromUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogoFromUrl: async (companyId: number, uploadLogoFromUrlRequest: UploadLogoFromUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('uploadLogoFromUrl', 'companyId', companyId)
            // verify required parameter 'uploadLogoFromUrlRequest' is not null or undefined
            assertParamExists('uploadLogoFromUrl', 'uploadLogoFromUrlRequest', uploadLogoFromUrlRequest)
            const localVarPath = `/api/client-crm/clients/{companyId}/logo/from-url`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadLogoFromUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTaskFile: async (id: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadTaskFile', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadTaskFile', 'file', file)
            const localVarPath = `/api/tasks/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication session required


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {string} state 
         * @param {string} session 
         * @param {string} lobbyistIds 
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTrackList: async (file: File, state: string, session: string, lobbyistIds: string, accountId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadTrackList', 'file', file)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('uploadTrackList', 'state', state)
            // verify required parameter 'session' is not null or undefined
            assertParamExists('uploadTrackList', 'session', session)
            // verify required parameter 'lobbyistIds' is not null or undefined
            assertParamExists('uploadTrackList', 'lobbyistIds', lobbyistIds)
            const localVarPath = `/api/track-lists/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication session required


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (state !== undefined) { 
                localVarFormParams.append('state', state as any);
            }
    
            if (session !== undefined) { 
                localVarFormParams.append('session', session as any);
            }
    
            if (lobbyistIds !== undefined) { 
                localVarFormParams.append('lobbyistIds', lobbyistIds as any);
            }
    
            if (accountId !== undefined) { 
                localVarFormParams.append('accountId', accountId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate if a company summary matches the company name using GPT
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCompanySummary: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('validateCompanySummary', 'companyId', companyId)
            const localVarPath = `/api/company-summary-fix/{companyId}/validate`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Warm the cache for recently active bills This endpoint is designed to be called by a cron job (e.g., at 3 AM daily) Protected by API key authentication
         * @param {number} [days] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmBillCache: async (days?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bills/warm-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Warm the cache for bills with recent activity
         * @param {string} xApiKey 
         * @param {number} [days] Number of days to look back for recent activity (default: 7)
         * @param {number} [limit] Maximum number of bills to cache (optional, for safety)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmBillCache_6: async (xApiKey: string, days?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xApiKey' is not null or undefined
            assertParamExists('warmBillCache_6', 'xApiKey', xApiKey)
            const localVarPath = `/api/admin/cache/warm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AcceptInviteRequest} acceptInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitation(acceptInviteRequest: AcceptInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitation(acceptInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.acceptInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitationGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitationGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.acceptInvitationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddAnalystRequest} addAnalystRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAnalyst(addAnalystRequest: AddAnalystRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddAnalyst200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAnalyst(addAnalystRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addAnalyst']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddBillWithSessionBody} addBillWithSessionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBillWithSession(addBillWithSessionBody: AddBillWithSessionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddBillWithSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBillWithSession(addBillWithSessionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addBillWithSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {CreateTaskNoteDto} createTaskNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTaskNote(id: number, createTaskNoteDto: CreateTaskNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTaskNote(id, createTaskNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addTaskNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {AddTeamMemberRequest} addTeamMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTeamMember(id: number, addTeamMemberRequest: AddTeamMemberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTeamMember(id, addTeamMemberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TrackWitnessRequest} trackWitnessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTrackedWitness(trackWitnessRequest: TrackWitnessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTrackedWitness(trackWitnessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addTrackedWitness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAutoTrackedBill(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAutoTrackedBill(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.approveAutoTrackedBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Answer questions about a bill using its text content with conversation history
         * @param {BillQuestionRequest} billQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askBillQuestion(billQuestionRequest: BillQuestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askBillQuestion(billQuestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.askBillQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegulationQuestionRequest} regulationQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askRegQuestion(regulationQuestionRequest: RegulationQuestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askRegQuestion(regulationQuestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.askRegQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StatuteQuestionRequest} statuteQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askStatuteQuestion(statuteQuestionRequest: StatuteQuestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askStatuteQuestion(statuteQuestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.askStatuteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} witnessId 
         * @param {AssignWitnessLobbyistRequest} assignWitnessLobbyistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignLobbyist(witnessId: number, assignWitnessLobbyistRequest: AssignWitnessLobbyistRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignWitnessLobbyistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignLobbyist(witnessId, assignWitnessLobbyistRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignLobbyist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkCreateTagsRequest} bulkCreateTagsRequest 
         * @param {boolean} [bypassAccessCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreateTags(bulkCreateTagsRequest: BulkCreateTagsRequest, bypassAccessCheck?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreateTags(bulkCreateTagsRequest, bypassAccessCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.bulkCreateTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkDeleteTagsRequest} bulkDeleteTagsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteTags(bulkDeleteTagsRequest: BulkDeleteTagsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteTags(bulkDeleteTagsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.bulkDeleteTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkImportClients(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkImportResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkImportClients(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.bulkImportClients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkSaveAccountCompanySummaryBody} bulkSaveAccountCompanySummaryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkSaveAccountCompanySummaries(bulkSaveAccountCompanySummaryBody: BulkSaveAccountCompanySummaryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSaveResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkSaveAccountCompanySummaries(bulkSaveAccountCompanySummaryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.bulkSaveAccountCompanySummaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel the setup process for an account
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancelSetup(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSetup(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cancelSetup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel subscription at the end of the current billing period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsolidateTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the current user\'s password
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check which chambers have agendas available for a given state
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAvailableAgendas(state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAvailableAgendas200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAvailableAgendas(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkAvailableAgendas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsernameAvailabilityResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if a username is available
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUsernameAvailability(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckUsernameAvailability200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUsernameAvailability(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkUsernameAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clear a specific bill from cache
         * @param {string} xApiKey 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearBillCache(xApiKey: string, billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddBillWithSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearBillCache(xApiKey, billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.clearBillCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clear sessions cache for a specific user and state
         * @param {string} xApiKey 
         * @param {number} userId 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearSessionsCache(xApiKey: string, userId: number, stateCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClearSessionsCache200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearSessionsCache(xApiKey, userId, stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.clearSessionsCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clear sessions cache for a specific user
         * @param {string} xApiKey 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearUserSessionsCache(xApiKey: string, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClearUserSessionsCache200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearUserSessionsCache(xApiKey, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.clearUserSessionsCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompleteRegistrationRequestModel} completeRegistrationRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeRegistration(completeRegistrationRequestModel: CompleteRegistrationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallingUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeRegistration(completeRegistrationRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.completeRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Complete the setup process for an account with the provided information
         * @param {CompleteSetupRequest} completeSetupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeSetup(completeSetupRequest: CompleteSetupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeSetup(completeSetupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.completeSetup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConnectGmailRequest} connectGmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectGmailIntegration(connectGmailRequest: ConnectGmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmailIntegrationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectGmailIntegration(connectGmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.connectGmailIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConnectSlackIntegrationRequest} connectSlackIntegrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectSlackIntegration(connectSlackIntegrationRequest: ConnectSlackIntegrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlackIntegrationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectSlackIntegration(connectSlackIntegrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.connectSlackIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConsolidateTagsRequest} consolidateTagsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consolidateTags(consolidateTagsRequest: ConsolidateTagsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsolidateTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consolidateTags(consolidateTagsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.consolidateTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBillRemarkBody} createBillRemarkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccountBillRemark(createBillRemarkBody: CreateBillRemarkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBillRemark200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccountBillRemark(createBillRemarkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createAccountBillRemark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBillRemarkBody} createBillRemarkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBillRemark(createBillRemarkBody: CreateBillRemarkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBillRemark200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBillRemark(createBillRemarkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createBillRemark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateClusterBody} createClusterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCluster(createClusterBody: CreateClusterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCluster(createClusterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new company and generate a Full summary via Perplexity. Ensures MasterCompanyID is set to CompanyID.
         * @param {CreateCompanyRequest} createCompanyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompany(createCompanyRequest: CreateCompanyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompanies200ResponseDataInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompany(createCompanyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {ContactPayload} contactPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(companyId: number, contactPayload: ContactPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientDetails200ResponseClientContactsInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(companyId, contactPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFeatureRequestBody} createFeatureRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFeatureRequest(createFeatureRequestBody: CreateFeatureRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFeatureRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFeatureRequest(createFeatureRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createFeatureRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFirmRequest} createFirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFirm(createFirmRequest: CreateFirmRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFirm200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFirm(createFirmRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createFirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GmailCalendarRequestBody} gmailCalendarRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGmailCalendarEvent(gmailCalendarRequestBody: GmailCalendarRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateGmailCalendarEvent200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGmailCalendarEvent(gmailCalendarRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createGmailCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InviteUserRequest} inviteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitation(inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInvitation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitation(inviteUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateIssueBody} createIssueBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIssue(createIssueBody: CreateIssueBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssues200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIssue(createIssueBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LobbyistCreateRequest} lobbyistCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLobbyist(lobbyistCreateRequest: LobbyistCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLobbyist200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLobbyist(lobbyistCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createLobbyist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateMemberListRequest} createMemberListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMemberList(createMemberListRequest: CreateMemberListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMemberList(createMemberListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createMemberList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBillPositionBody} createBillPositionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateBillPosition(createBillPositionBody: CreateBillPositionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateBillPosition(createBillPositionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createOrUpdateBillPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBillRemarkBody} createBillRemarkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPersonalBillRemark(createBillRemarkBody: CreateBillRemarkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBillRemark200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPersonalBillRemark(createBillRemarkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createPersonalBillRemark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Stripe Customer Portal session for managing billing This allows customers to update payment methods, view invoices, etc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPortalSession(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPortalSession(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createPortalSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Stripe Customer Portal session for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPortalSession_1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPortalSessionResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPortalSession_1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createPortalSession_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProspectCreateRequest} prospectCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProspect(prospectCreateRequest: ProspectCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProspect200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProspect(prospectCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createProspect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PromotionCheckoutRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSession(body: PromotionCheckoutRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromotionCheckoutSessionResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSession(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StakeholderContactInput} stakeholderContactInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStakeholderContact(stakeholderContactInput: StakeholderContactInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StakeholderContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStakeholderContact(stakeholderContactInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createStakeholderContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StakeholderMeetingInput} stakeholderMeetingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStakeholderMeeting(stakeholderMeetingInput: StakeholderMeetingInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StakeholderMeetingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStakeholderMeeting(stakeholderMeetingInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createStakeholderMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTagBody} createTagBody 
         * @param {boolean} [bypassAccessCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTag(createTagBody: CreateTagBody, bypassAccessCheck?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTag200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTag(createTagBody, bypassAccessCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTaskDto} createTaskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTask(createTaskDto: CreateTaskDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskListItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTask(createTaskDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTeamRequest} createTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeam(createTeamRequest: CreateTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTeam200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeam(createTeamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFolderBody} createFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserFolder(createFolderBody: CreateFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserFolder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserFolder(createFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createUserFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create video clip  Creates a clip record with timestamps only. The video segment is generated on-demand when viewed or downloaded, just like the share endpoint and committee agent.
         * @param {VideoSegment} videoSegment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVideoClip(videoSegment: VideoSegment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedClipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVideoClip(videoSegment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createVideoClip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccountCompanySummary(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccountCompanySummary(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteAccountCompanySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllAutoTrackedBills(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteAllAutoTrackedBills200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllAutoTrackedBills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteAllAutoTrackedBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} billTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAutoTrackedBill(billTagId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAutoTrackedBill(billTagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteAutoTrackedBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBillPosition(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForgotPassword200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBillPosition(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteBillPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a document
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(fileId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolder(folderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMemberList(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsolidateTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMemberList(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteMemberList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} remarkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRemark(remarkId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRemark(remarkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteRemark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} scheduledReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScheduledReport(scheduledReportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScheduledReport(scheduledReportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteScheduledReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTag(tagId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTag(tagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteUserKeywordBody} deleteUserKeywordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserKeyword(deleteUserKeywordBody: DeleteUserKeywordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserKeyword(deleteUserKeywordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteUserKeyword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectGmailIntegration(accountId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmailIntegrationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectGmailIntegration(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.disconnectGmailIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectSlackIntegration(accountId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlackIntegrationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectSlackIntegration(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.disconnectSlackIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dismiss the new user welcome modal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissNewUserModal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissNewUserModal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.dismissNewUserModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Proxy endpoint for downloading agenda content Streams the file directly from Azure to the client without exposing SAS tokens
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAgenda(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAgenda(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadAgenda']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Proxy endpoint for downloading bill documents Streams the file directly from Azure to the client without exposing SAS tokens  IMPORTANT: This route MUST be defined before generic routes that might capture it.
         * @param {string} id 
         * @param {string} billVersionId 
         * @param {DownloadBillDocumentFormatEnum} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBillDocument(id: string, billVersionId: string, format?: DownloadBillDocumentFormatEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBillDocument(id, billVersionId, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadBillDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a Video Clip as MP4.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadClip(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadClip(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadClip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a document
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocument(documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocument(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFile(fileId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFile(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Proxy endpoint for downloading files by path Replaces direct SAS URL access for security compliance
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileByPath(path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileByPath(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadFileByPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download recent live actions as CSV
         * @param {Array<string>} [stateCodes] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadLiveActions(stateCodes?: Array<string>, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadLiveActions(stateCodes, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadLiveActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Proxy endpoint for downloading supporting documents Streams the file directly from Azure to the client without exposing SAS tokens  IMPORTANT: This route MUST be defined before generic routes that might capture it.
         * @param {string} id 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSupportingDocument(id: string, documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSupportingDocument(id, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadSupportingDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmailAiReportRequest} emailAiReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailAiReport(emailAiReportRequest: EmailAiReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendTaskReminder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailAiReport(emailAiReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.emailAiReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnsureFolderPathBody} ensureFolderPathBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ensureFolderPath(ensureFolderPathBody: EnsureFolderPathBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnsureFolderPath200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ensureFolderPath(ensureFolderPathBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ensureFolderPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Proxy endpoint to fetch AI report from Azure storage (bypasses CORS)
         * @param {string} url The full URL to the AI report JSON file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAIReport(url: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAIReport(url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.fetchAIReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the most recent daily agenda for a specific state and chamber
         * @param {string} state 
         * @param {string} chamber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchDailyAgenda(state: string, chamber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyAgendaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchDailyAgenda(state, chamber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.fetchDailyAgenda']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fix an incorrect company summary by regenerating it
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fixCompanySummary(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FixCompanySummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fixCompanySummary(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.fixCompanySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request a password reset
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(forgotPasswordRequest: ForgotPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForgotPassword200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(forgotPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Forward a bill to one or more lobbyists in the account
         * @param {ForwardBillToLobbyistRequest} forwardBillToLobbyistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forwardBillToLobbyists(forwardBillToLobbyistRequest: ForwardBillToLobbyistRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsolidateTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forwardBillToLobbyists(forwardBillToLobbyistRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.forwardBillToLobbyists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ContextQueryRequest} contextQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gatherContext(contextQueryRequest: ContextQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gatherContext(contextQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.gatherContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AIReportPayload} aIReportPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAIReport(aIReportPayload: AIReportPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAIReport(aIReportPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateAIReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a suggested title and description for a clip.
         * @param {number} videoId 
         * @param {ClipMetadataRequest} clipMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateClipMetadata(videoId: number, clipMetadataRequest: ClipMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClipMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateClipMetadata(videoId, clipMetadataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateClipMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a video clip of segments relevant to a company
         * @param {number} videoId 
         * @param {GenerateCompanySummaryRequest} generateCompanySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCompanyClip(videoId: number, generateCompanySummaryRequest: GenerateCompanySummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyClipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCompanyClip(videoId, generateCompanySummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateCompanyClip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a company-specific summary of a committee video
         * @param {number} videoId 
         * @param {GenerateCompanySummaryRequest} generateCompanySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCompanySummary(videoId: number, generateCompanySummaryRequest: GenerateCompanySummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanySummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCompanySummary(videoId, generateCompanySummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateCompanySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate AI report using API key authentication (for external clients)
         * @param {string} xApiKey API key for authentication (pass in x-api-key header)
         * @param {ExternalAIReportRequest} externalAIReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateExternalAIReport(xApiKey: string, externalAIReportRequest: ExternalAIReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateExternalAIReport(xApiKey, externalAIReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateExternalAIReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate relevant keywords based on the entity description Can process single entity or multiple companies in parallel
         * @param {GenerateKeywordsRequest} generateKeywordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateKeywords(generateKeywordsRequest: GenerateKeywordsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeywordsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateKeywords(generateKeywordsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} videoId 
         * @param {GenerateSegmentSummaryRequest} generateSegmentSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSegmentSummary(videoId: number, generateSegmentSummaryRequest: GenerateSegmentSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SegmentSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSegmentSummary(videoId, generateSegmentSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateSegmentSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate relevant subjects based on the entity description
         * @param {GenerateSubjectsRequest} generateSubjectsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSubjects(generateSubjectsRequest: GenerateSubjectsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateSubjectsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSubjects(generateSubjectsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateSubjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTagContext(tagId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateTagContext200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTagContext(tagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateTagContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate relevant tags based on provided keywords
         * @param {GenerateTagsRequest} generateTagsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTags(generateTagsRequest: GenerateTagsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateTagsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTags(generateTagsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateTagsForCompanyRequest} generateTagsForCompanyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTagsForCompany(generateTagsForCompanyRequest: GenerateTagsForCompanyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateTagsForCompany200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTagsForCompany(generateTagsForCompanyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateTagsForCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTrackedActivityReportsBatch(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateTrackedActivityReportsBatch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTrackedActivityReportsBatch(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateTrackedActivityReportsBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountBillRemarks(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillRemarks200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountBillRemarks(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountBillRemarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountCompanyClaims(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountCompanyClaimUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountCompanyClaims(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountCompanyClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountCompanySummaries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountCompanySummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountCompanySummaries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountCompanySummaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountCompanySummary(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountCompanySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountCompanySummary(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountCompanySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [state] 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountLobbyist(id: number, state?: string, accountId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountLobbyist200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountLobbyist(id, state, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountLobbyist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all lobbyist users in the current account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountLobbyistUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAccountLobbyistUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountLobbyistUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountLobbyistUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [states] 
         * @param {string} [sessionKeys] 
         * @param {boolean} [activeOnly] 
         * @param {string} [tagIds] 
         * @param {GetAccountTrackedBillsTagLogicEnum} [tagLogic] 
         * @param {string} [trackTypes] 
         * @param {string} [progressStatuses] 
         * @param {boolean} [alertsOnly] 
         * @param {boolean} [excludeLobbyistUsers] 
         * @param {boolean} [lobbyistUsersOnly] 
         * @param {boolean} [jointTracked] 
         * @param {string} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountTrackedBills(page?: number, pageSize?: number, search?: string, states?: string, sessionKeys?: string, activeOnly?: boolean, tagIds?: string, tagLogic?: GetAccountTrackedBillsTagLogicEnum, trackTypes?: string, progressStatuses?: string, alertsOnly?: boolean, excludeLobbyistUsers?: boolean, lobbyistUsersOnly?: boolean, jointTracked?: boolean, userIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBills>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountTrackedBills(page, pageSize, search, states, sessionKeys, activeOnly, tagIds, tagLogic, trackTypes, progressStatuses, alertsOnly, excludeLobbyistUsers, lobbyistUsersOnly, jointTracked, userIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountTrackedBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AccountTrackedBillsBulkBody} accountTrackedBillsBulkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountTrackedBillsBulk(accountTrackedBillsBulkBody: AccountTrackedBillsBulkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountTrackedBillsBulk(accountTrackedBillsBulkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountTrackedBillsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountUsers(page?: number, pageSize?: number, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountUsers(page, pageSize, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAccountUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get counts for a specific activity type
         * @param {GetActivityCountScopeEnum} [scope] Either \&#39;user\&#39; (only user\&#39;s tracked bills) or \&#39;account\&#39; (all users in account)
         * @param {number} [days] Number of days to look back (default 30)
         * @param {ActivityType} [activityType] The activity type to get count for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityCount(scope?: GetActivityCountScopeEnum, days?: number, activityType?: ActivityType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivityCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityCount(scope, days, activityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getActivityCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get historical DAU/MAU data for a date range
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityHistory(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetActivityHistory200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityHistory(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getActivityHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Daily Active Users (DAU) and Monthly Active Users (MAU) metrics
         * @param {string} [date] Optional date in YYYY-MM-DD format. Defaults to today.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityMetrics(date?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityMetrics(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getActivityMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdvancedSearchRequest} advancedSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvancedSearch(advancedSearchRequest: AdvancedSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdvancedSearch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvancedSearch(advancedSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAdvancedSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvocateTestimony(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdvocateTestimonyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvocateTestimony(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAdvocateTestimony']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvocateTestimonyById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvocateTestimonyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvocateTestimonyById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAdvocateTestimonyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAnalystMetrics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskMetricsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAnalystMetrics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllAnalystMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalystCandidates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalystCandidate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalystCandidates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAnalystCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalystMetrics(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAnalystMetrics200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalystMetrics(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAnalystMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalysts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAnalysts200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalysts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAnalysts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoTrackAvailability(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAutoTrackAvailability200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoTrackAvailability(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoTrackAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoTrackCompanies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AutoTrackCompanyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoTrackCompanies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoTrackCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} masterBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoTrackMatch(masterBillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoTrackMatchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoTrackMatch(masterBillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoTrackMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAutoTrackMatchesOutcomeEnum} [outcome] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {number} [minScore] 
         * @param {number} [maxScore] 
         * @param {string} [rejectedStart] 
         * @param {string} [rejectedEnd] 
         * @param {GetAutoTrackMatchesPriorityEnum} [priority] 
         * @param {GetAutoTrackMatchesImpactEnum} [impact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoTrackMatches(outcome?: GetAutoTrackMatchesOutcomeEnum, page?: number, pageSize?: number, search?: string, minScore?: number, maxScore?: number, rejectedStart?: string, rejectedEnd?: string, priority?: GetAutoTrackMatchesPriorityEnum, impact?: GetAutoTrackMatchesImpactEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAutoTrackMatches>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoTrackMatches(outcome, page, pageSize, search, minScore, maxScore, rejectedStart, rejectedEnd, priority, impact, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoTrackMatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoTrackStates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AutoTrackStateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoTrackStates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoTrackStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoTrackStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoTrackStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoTrackStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoTrackStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {ViewScope} [viewScope] 
         * @param {number} [targetFolderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoTrackedBill(billId: string, viewScope?: ViewScope, targetFolderId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoTrackedBillDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoTrackedBill(billId, viewScope, targetFolderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoTrackedBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [sorted] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {ViewScope} [viewScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoTrackedBills(sorted?: number, page?: number, pageSize?: number, viewScope?: ViewScope, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAutoTrackedBills>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoTrackedBills(sorted, page, pageSize, viewScope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoTrackedBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get sessions for multiple states in a single request
         * @param {GetBatchSessionsRequest} getBatchSessionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchSessions(getBatchSessionsRequest: GetBatchSessionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<RecordStringArrayIdStringNameStringIsDefault63BooleanValueInner>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchSessions(getBatchSessionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBatchSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [includeAiSummary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBill(id: string, includeAiSummary?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBill200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBill(id, includeAiSummary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Bill Agent statistics for the current account
         * @param {number} [accountId] 
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillAgentStats(accountId?: number, viewScope?: ViewScope, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillAgentStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillAgentStats(accountId, viewScope, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillAgentStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillAiSummary(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillAiSummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillAiSummary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillAiSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [billId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillAlerts(billId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillAlertDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillAlerts(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BillAlertsBulkBody} billAlertsBulkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillAlertsBulk(billAlertsBulkBody: BillAlertsBulkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<BillAlertDto>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillAlertsBulk(billAlertsBulkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillAlertsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get committee calendar entries for the selected date range. When trackedOnly is true, results are limited to bills tracked by the account.
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [trackedOnly] 
         * @param {Array<string>} [stateCodes] 
         * @param {Array<number>} [clientCompanyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillCalendar(startDate?: string, endDate?: string, trackedOnly?: boolean, stateCodes?: Array<string>, clientCompanyIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExtraCalendarEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillCalendar(startDate, endDate, trackedOnly, stateCodes, clientCompanyIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get bill chat history for the current session and specific bill
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillChatHistory(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillChatHistory(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillChatHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillComments(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillComments200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillComments(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillCompaniesOfInterest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatuteCompaniesOfInterest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillCompaniesOfInterest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillCompaniesOfInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillCompanions(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillCompanions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillCompanions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillCompanions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetBillComparisonRequest} getBillComparisonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillComparison(getBillComparisonRequest: GetBillComparisonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillComparisonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillComparison(getBillComparisonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillComparisonAi(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillComparisonAi200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillComparisonAi(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillComparisonAi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [billVersionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillContent(id: string, billVersionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillContent(id, billVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get download URL for bill content - UPDATED TO BE A PROXY ENDPOINT Now returns the actual file stream instead of a SAS URL
         * @param {string} id 
         * @param {string} billVersionId 
         * @param {GetBillDownloadUrlFormatEnum} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillDownloadUrl(id: string, billVersionId: string, format?: GetBillDownloadUrlFormatEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillDownloadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillDownloadUrl(id, billVersionId, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillHistory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillHistory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillNotes(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillNotes(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} masterBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillPriorityImpact(masterBillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillPriorityImpact200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillPriorityImpact(masterBillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillPriorityImpact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillRemarks(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillRemarks200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillRemarks(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillRemarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdvancedSearchRequest} advancedSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillReport(advancedSearchRequest: AdvancedSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdvancedSearch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillReport(advancedSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillSimilarAi(id: string, state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillSimilarAi200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillSimilarAi(id, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillSimilarAi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillStatutes(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillStatutes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillStatutes(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillStatutes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillSubjects(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillSubjects200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillSubjects(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillSubjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillSupportingDocuments(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillSupportingDocuments200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillSupportingDocuments(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillSupportingDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillTags(billId: string, sessionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillTags200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillTags(billId, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get testimony for a specific bill
         * @param {string} masterBillId The ID of the bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillTestimony(masterBillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillTestimony200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillTestimony(masterBillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillTestimony']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [billVersionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillText(id: string, billVersionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBillText200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillText(id, billVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillVersions(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillVersions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillVersions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillVotes(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillVotes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillVotes(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillVotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {Array<string>} [sessionCodes] Array of session codes for multi-session search
         * @param {Array<number>} [subjects] 
         * @param {string} [searchTerm] 
         * @param {Array<string>} [types] 
         * @param {string} [authorName] 
         * @param {string} [statuteSection] 
         * @param {string} [statuteCode] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<string>} [parties] 
         * @param {string} [textSearch] 
         * @param {number} [rerankCompanyId] 
         * @param {boolean} [rerankProgress] 
         * @param {boolean} [onlyCommitteeChairFiled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBills(page?: number, pageSize?: number, stateCode?: string, sessionCode?: string, sessionCodes?: Array<string>, subjects?: Array<number>, searchTerm?: string, types?: Array<string>, authorName?: string, statuteSection?: string, statuteCode?: string, dateFrom?: string, dateTo?: string, parties?: Array<string>, textSearch?: string, rerankCompanyId?: number, rerankProgress?: boolean, onlyCommitteeChairFiled?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDataGetBillsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBills(page, pageSize, stateCode, sessionCode, sessionCodes, subjects, searchTerm, types, authorName, statuteSection, statuteCode, dateFrom, dateTo, parties, textSearch, rerankCompanyId, rerankProgress, onlyCommitteeChairFiled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} onlyWithHistory 
         * @param {boolean} onlyTrackedTags 
         * @param {Array<string>} [types] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [historyDateFrom] 
         * @param {string} [historyDateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillsWithHistory(onlyWithHistory: boolean, onlyTrackedTags: boolean, types?: Array<string>, limit?: number, page?: number, historyDateFrom?: string, historyDateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillsWithHistory200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillsWithHistory(onlyWithHistory, onlyTrackedTags, types, limit, page, historyDateFrom, historyDateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBillsWithHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get cache statistics
         * @param {string} xApiKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCacheStats(xApiKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendTaskReminder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCacheStats(xApiKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCacheStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [stateCodes] 
         * @param {string} [sessionCode] 
         * @param {Array<number>} [eventTypeIds] 
         * @param {boolean} [includeUserEvents] 
         * @param {boolean} [includeAccountEvents] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarEvents(stateCodes?: Array<string>, sessionCode?: string, eventTypeIds?: Array<number>, includeUserEvents?: boolean, includeAccountEvents?: boolean, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarEvents(stateCodes, sessionCode, eventTypeIds, includeUserEvents, includeAccountEvents, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get campaign finance data with various filters
         * @param {string} stateCode The state code for the state to filter by.
         * @param {number} page Page number for pagination
         * @param {number} limit Number of records per page
         * @param {string} [search] General search term across multiple fields
         * @param {string} [filerName] Filter by filer name
         * @param {string} [contributorOrganization] Filter by contributor organization
         * @param {string} [contributorFirstName] Filter by contributor first name
         * @param {string} [contributorLastName] Filter by contributor last name
         * @param {string} [contributorState] Filter by contributor state
         * @param {number} [year] Filter by minimum year
         * @param {number} [minAmount] Filter by minimum contribution amount
         * @param {number} [maxAmount] Filter by maximum contribution amount
         * @param {boolean} [isLobbyist] 
         * @param {boolean} [isMember] Filter by contributions made to members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignFinance(stateCode: string, page: number, limit: number, search?: string, filerName?: string, contributorOrganization?: string, contributorFirstName?: string, contributorLastName?: string, contributorState?: string, year?: number, minAmount?: number, maxAmount?: number, isLobbyist?: boolean, isMember?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCampaignFinance200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignFinance(stateCode, page, limit, search, filerName, contributorOrganization, contributorFirstName, contributorLastName, contributorState, year, minAmount, maxAmount, isLobbyist, isMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCampaignFinance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get campaign finance filers
         * @param {string} [search] Search term for filer name
         * @param {string} [state] Filter by state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignFinanceFilers(search?: string, state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCampaignFinanceFilers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignFinanceFilers(search, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCampaignFinanceFilers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get chat history for the current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatHistory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatHistory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getChatHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {string} [sessionCode] 
         * @param {boolean} [includeInactiveSessions] 
         * @param {boolean} [includeAutoUnsorted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientBills(companyId: number, sessionCode?: string, includeInactiveSessions?: boolean, includeAutoUnsorted?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetClientBills200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientBills(companyId, sessionCode, includeInactiveSessions, includeAutoUnsorted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getClientBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientCommitteeActivity(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientCommitteeActivity200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientCommitteeActivity(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getClientCommitteeActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientContributions(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetClientContributions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientContributions(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getClientContributions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientDashboard(includeInactive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientDashboardResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientDashboard(includeInactive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getClientDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientDetails(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientDetails200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientDetails(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getClientDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Video Clip.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClip(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClip200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClip(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getClip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} masterCompanyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCluster(masterCompanyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCluster(masterCompanyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [stateCodes] 
         * @param {string} [sessionCode] 
         * @param {Array<number>} [eventTypeIds] 
         * @param {boolean} [includeUserEvents] 
         * @param {boolean} [includeAccountEvents] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCombinedCalendarEvents(stateCodes?: Array<string>, sessionCode?: string, eventTypeIds?: Array<number>, includeUserEvents?: boolean, includeAccountEvents?: boolean, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExtraCalendarEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCombinedCalendarEvents(stateCodes, sessionCode, eventTypeIds, includeUserEvents, includeAccountEvents, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCombinedCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full detail for one committee session by its ID
         * @param {number} id 
         * @param {string} sessionCode 
         * @param {string} [sections] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommittee(id: number, sessionCode: string, sections?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommittee200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommittee(id, sessionCode, sections, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommittee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get recent activity for Committee Agent
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeAgentRecentActivity(viewScope?: ViewScope, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCommitteeAgentRecentActivity200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeAgentRecentActivity(viewScope, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeAgentRecentActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeAgentStates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitteeAgentStateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeAgentStates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeAgentStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Committee Agent statistics for the current account
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeAgentStats(viewScope?: ViewScope, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeAgentStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeAgentStats(viewScope, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeAgentStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [committeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeAlerts(committeeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitteeAlertDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeAlerts(committeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get committee analysis for the current account
         * @param {GetCommitteeAnalysisMinPriorityEnum} [minPriority] 
         * @param {GetCommitteeAnalysisMinImpactEnum} [minImpact] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeAnalysis(minPriority?: GetCommitteeAnalysisMinPriorityEnum, minImpact?: GetCommitteeAnalysisMinImpactEnum, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommitteeAnalysis200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeAnalysis(minPriority, minImpact, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single committee analysis by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeAnalysisById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeAnalysisById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeAnalysisById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all clips from CommitteeVideoClips table
         * @param {ViewScope} [viewScope] 
         * @param {number} [limit] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeClips(viewScope?: ViewScope, limit?: number, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCommitteeClips200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeClips(viewScope, limit, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeClips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all summaries from CommitteeVideoSummaries table
         * @param {ViewScope} [viewScope] 
         * @param {number} [limit] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeSummaries(viewScope?: ViewScope, limit?: number, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCommitteeSummaries200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeSummaries(viewScope, limit, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeSummaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of CommitteeVideo, optionally filtered by state and with text search support.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {string} [chamber] 
         * @param {string} [committee] 
         * @param {number} [year] 
         * @param {number} [month] 
         * @param {string} [searchTerm] 
         * @param {string} [textSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeVideo(page?: number, pageSize?: number, stateCode?: string, sessionCode?: string, chamber?: string, committee?: string, year?: number, month?: number, searchTerm?: string, textSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommitteeVideo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeVideo(page, pageSize, stateCode, sessionCode, chamber, committee, year, month, searchTerm, textSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get full detail for one committee video by its ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitteeVideoById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommitteeVideoByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitteeVideoById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommitteeVideoById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of all committee sessions in a given state + session
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {string} [searchTerm] 
         * @param {boolean} [includeNonSession] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommittees(stateCode: string, sessionCode: string, searchTerm?: string, includeNonSession?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCommittees200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommittees(stateCode, sessionCode, searchTerm, includeNonSession, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCommittees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of companies with pagination, searching, and sorting.
         * @param {string} [state] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {boolean} [aiSearch] 
         * @param {string} [sortBy] 
         * @param {GetCompaniesSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanies(state?: string, page?: number, limit?: number, search?: string, aiSearch?: boolean, sortBy?: string, sortOrder?: GetCompaniesSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompanies200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanies(state, page, limit, search, aiSearch, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get companies of interest based on user\'s tracked bills and recent bills. Uses bill embeddings from Pinecone to find relevant companies.
         * @param {string} [stateCode] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompaniesOfInterest(stateCode?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompaniesOfInterest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompaniesOfInterest(stateCode, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompaniesOfInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get companies that the user has configured keywords for. Returns only companies that appear as keys in the user\'s BillKeywords config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompaniesWithKeywords(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompaniesWithKeywords200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompaniesWithKeywords(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompaniesWithKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single company by its CompanyID.
         * @param {number} id numeric ID of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompany(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompany200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAnalytics(stateCode: string, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAnalytics(stateCode, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanyAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyBillsOfInterest(id: number, stateCode?: string, sessionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompanyBillsOfInterest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyBillsOfInterest(id, stateCode, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanyBillsOfInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get contributions for a specific company
         * @param {number} companyId The ID of the company
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyContributions(companyId: number, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCompanyContributions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyContributions(companyId, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanyContributions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get firm engagements for a given company.
         * @param {number} id 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyFirmEngagements(id: number, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCompanyFirmEngagements200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyFirmEngagements(id, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanyFirmEngagements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all state variants for a company, grouped by MasterCompanyID. Returns a list of company ids and their state codes so the UI can switch states.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyStates(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCompanyStates200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyStates(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanyStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get testimony for a specific company
         * @param {number} companyId The ID of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyTestimony(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCompanyTestimony200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyTestimony(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanyTestimony']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyTickSheet(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyTickSheetEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyTickSheet(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCompanyTickSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get concatenated regulations for an entire parent level
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConcatenatedParentLevel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConcatenatedRegsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConcatenatedParentLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConcatenatedParentLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboard(state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all documents for a remark
         * @param {number} remarkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(remarkId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentMetadata>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(remarkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEventTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalTrackingCounts(billIds: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: RecordStringCountNumberTrackedByAccountBooleanTrackedByLobbyistBooleanValue; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalTrackingCounts(billIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getExternalTrackingCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} masterBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilesByBill(masterBillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillFileItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilesByBill(masterBillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFilesByBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single firm by its FirmID with all associated lobbyists.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirm(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFirm200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirm(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmAnalytics(stateCode: string, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirmAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirmAnalytics(stateCode, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFirmAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get firm engagements for a given firm.
         * @param {number} id 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmEngagements(id: number, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFirmEngagements200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirmEngagements(id, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFirmEngagements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of firms with pagination, searching, and sorting.
         * @param {string} [stateCode] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetFirmsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirms(stateCode?: string, page?: number, limit?: number, search?: string, sortBy?: string, sortOrder?: GetFirmsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFirms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirms(stateCode, page, limit, search, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFirms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolderTree(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFolderTree200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolderTree(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFolderTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGmailIntegration(accountId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmailIntegrationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGmailIntegration(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getGmailIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {string} [redirectUri] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGmailOAuthUrl(accountId?: number, redirectUri?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGmailOAuthUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGmailOAuthUrl(accountId, redirectUri, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getGmailOAuthUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getIsAccountNew(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIsAccountNew(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getIsAccountNew']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssue(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssues200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssue(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [status] 
         * @param {string} [issueType] 
         * @param {string} [priority] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssues(status?: string, issueType?: string, priority?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetIssues200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssues(status, issueType, priority, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getIssues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get keyword clips for the current account (all users in the account)
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKeywordClips(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetKeywordClips200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKeywordClips(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getKeywordClips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKeywordGenerationStatus(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeywordGenerationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKeywordGenerationStatus(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getKeywordGenerationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsArticle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLatest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestBillContent(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskBillContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestBillContent(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLatestBillContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get latest bill match from AutoTrackReasoning
         * @param {number} [accountId] 
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestMatch(accountId?: number, viewScope?: ViewScope, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestMatch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestMatch(accountId, viewScope, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLatestMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegislators(stateCode: string, sessionCode: string, accountId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LegislatorWithCount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegislators(stateCode, sessionCode, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLegislators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get recent live actions filtered by state
         * @param {Array<string>} [stateCodes] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLiveActions(stateCodes?: Array<string>, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiveActionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLiveActions(stateCodes, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLiveActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch by exactly one of lobbyistId, companyId, masterCompanyId, or companySearch.
         * @param {number} [lobbyistId] 
         * @param {number} [companyId] 
         * @param {number} [masterCompanyId] 
         * @param {number} [year] 
         * @param {string} [companySearch] 
         * @param {string} [stateCode] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyEngagements(lobbyistId?: number, companyId?: number, masterCompanyId?: number, year?: number, companySearch?: string, stateCode?: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetLobbyEngagements200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyEngagements(lobbyistId, companyId, masterCompanyId, year, companySearch, stateCode, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyEngagements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyist(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLobbyist200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyist(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [lobbyistId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyistAlerts(lobbyistId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LobbyistAlertDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyistAlerts(lobbyistId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyistAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyistAnalytics(stateCode: string, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LobbyistAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyistAnalytics(stateCode, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyistAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyistClients(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetLobbyistClients200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyistClients(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyistClients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Contributions filtered by lobbyist and/or company.
         * @param {number} [lobbyistId] 
         * @param {number} [companyId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyistContributions(lobbyistId?: number, companyId?: number, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContributionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyistContributions(lobbyistId, companyId, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyistContributions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [lobbyistId] 
         * @param {number} [companyId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyistTestimony(lobbyistId?: number, companyId?: number, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetLobbyistTestimony200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyistTestimony(lobbyistId, companyId, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyistTestimony']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetLobbyistsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyists(stateCode?: string, page?: number, limit?: number, search?: string, sortBy?: string, sortOrder?: GetLobbyistsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLobbyists200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyists(stateCode, page, limit, search, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLobbyistsByState(stateCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetLobbyistsByState200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLobbyistsByState(stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLobbyistsByState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed information for a single member
         * @param {number} id 
         * @param {string} sessionCode 
         * @param {boolean} [includeAuthoredBills] 
         * @param {boolean} [includePassedBills] 
         * @param {boolean} [includeSponsoredBills] 
         * @param {boolean} [includeCoSponsors] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberById(id: number, sessionCode: string, includeAuthoredBills?: boolean, includePassedBills?: boolean, includeSponsoredBills?: boolean, includeCoSponsors?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMemberById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberById(id, sessionCode, includeAuthoredBills, includePassedBills, includeSponsoredBills, includeCoSponsors, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get co-sponsors for a member
         * @param {number} id 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberCoSponsors(id: number, sessionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMemberCoSponsors200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberCoSponsors(id, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberCoSponsors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get contact information for multiple members in batch This is a lightweight endpoint that only fetches contact data without expensive stats calculations
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {string} [chamber] 
         * @param {string} [memberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberContactsBatch(stateCode: string, sessionCode: string, chamber?: string, memberIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: ContactInfoDto; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberContactsBatch(stateCode, sessionCode, chamber, memberIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberContactsBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get district demographics for a member
         * @param {number} id 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberDemographics(id: number, sessionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMemberDemographics200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberDemographics(id, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberDemographics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get available filter options (chambers and parties) for a state/session
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberFilters(stateCode: string, sessionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMemberFilters200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberFilters(stateCode, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single member image
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberImage(memberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberImage(memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Proxy endpoint for member images - provides access without exposing SAS URLs Member images are public, so no authentication required  IMPORTANT: This route MUST be defined before the generic getMemberById (\'{id}\') route. Otherwise, Express will match \'/api/members/123/image\' as getMemberById with id=\'123/image\'.
         * @param {number} id Member ID
         * @param {string} [ext] File extension (default: jpg)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberImage_2(id: number, ext?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeJSReadableStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberImage_2(id, ext, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberImage_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get multiple member images in bulk
         * @param {MemberImagesBulkBody} memberImagesBulkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberImagesBulk(memberImagesBulkBody: MemberImagesBulkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberImagesBulk(memberImagesBulkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberImagesBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get member statistics leaderboards for a state Shows stats from the last completed regular session
         * @param {string} stateCode 
         * @param {string} [currentSessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberLeaderboards(stateCode: string, currentSessionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMemberLeaderboards200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberLeaderboards(stateCode, currentSessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberLeaderboards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberList(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberList(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberLists(stateCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberLists(stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberLists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberPublicContributions(memberId: number, stateCode?: string, sessionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberRelationship>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberPublicContributions(memberId, stateCode, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberPublicContributions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {number} [accountId] 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberRelationships(memberId: number, accountId?: number, stateCode?: string, sessionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberRelationship>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberRelationships(memberId, accountId, stateCode, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberRelationships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {Chamber} [chamber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberTickSheet(billId: string, chamber?: Chamber, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberTickSheetEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberTickSheet(billId, chamber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMemberTickSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all members for a given state and session
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [pageSize] Number of items per page
         * @param {string} [searchTerm] 
         * @param {string} [chamber] 
         * @param {string} [party] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembers(stateCode: string, sessionCode: string, page?: number, pageSize?: number, searchTerm?: string, chamber?: string, party?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMembers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembers(stateCode, sessionCode, page, pageSize, searchTerm, chamber, party, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMyAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetNotifications200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get payment history (invoices) for the authenticated user\'s account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentHistory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentHistory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPaymentHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingFullAccountInvitations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPendingFullAccountInvitations200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingFullAccountInvitations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPendingFullAccountInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingInvitations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPendingInvitations200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingInvitations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPendingInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingRegistration(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingRegistrationResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingRegistration(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPendingRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonalBillRemarks(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBillRemarks200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonalBillRemarks(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPersonalBillRemarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlans(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPlans200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlans(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} state 
         * @param {string} session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopulateAdvancedFilters(state: string, session: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopulateAdvancedFiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopulateAdvancedFilters(state, session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPopulateAdvancedFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get priority bills for the current account
         * @param {number} [accountId] 
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriorityBills(accountId?: number, viewScope?: ViewScope, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PriorityBillResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriorityBills(accountId, viewScope, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPriorityBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get recent activity for Bill Agent
         * @param {number} [accountId] 
         * @param {ViewScope} [viewScope] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentActivity(accountId?: number, viewScope?: ViewScope, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRecentActivity200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentActivity(accountId, viewScope, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRecentActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get recent committee analysis
         * @param {ViewScope} [viewScope] 
         * @param {number} [limit] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentAnalysis(viewScope?: ViewScope, limit?: number, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecentAnalysisResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentAnalysis(viewScope, limit, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRecentAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get recent committee analysis (for dashboard widget)
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentCommitteeAnalysis(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitteeAnalysisResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentCommitteeAnalysis(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRecentCommitteeAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentReports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRecentReports200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentReports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRecentReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get regulation details by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRegById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get companies related to a specific regulation
         * @param {string} id 
         * @param {string} stateCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegCompaniesOfInterest(id: string, stateCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatuteCompaniesOfInterest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegCompaniesOfInterest(id, stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRegCompaniesOfInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get items for a specific hierarchy level
         * @param {string} state 
         * @param {RegHierarchyField} level 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [level1] 
         * @param {string} [level2] 
         * @param {string} [level3] 
         * @param {string} [level4] 
         * @param {string} [level5] 
         * @param {string} [level6] 
         * @param {string} [level7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegHierarchyItems(state: string, level: RegHierarchyField, page?: number, pageSize?: number, level1?: string, level2?: string, level3?: string, level4?: string, level5?: string, level6?: string, level7?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegHierarchyItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegHierarchyItems(state, level, page, pageSize, level1, level2, level3, level4, level5, level6, level7, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRegHierarchyItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get regulations for the selected hierarchy path
         * @param {string} state 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [level1] 
         * @param {string} [level2] 
         * @param {string} [level3] 
         * @param {string} [level4] 
         * @param {string} [level5] 
         * @param {string} [level6] 
         * @param {string} [level7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegHierarchyRegs(state: string, page?: number, pageSize?: number, level1?: string, level2?: string, level3?: string, level4?: string, level5?: string, level6?: string, level7?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegHierarchyRegsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegHierarchyRegs(state, page, pageSize, level1, level2, level3, level4, level5, level6, level7, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRegHierarchyRegs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get hierarchy overview for all states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegHierarchyStateCounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegHierarchyStateCount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegHierarchyStateCounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRegHierarchyStateCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get hierarchy structure for a specific state
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegHierarchyStructure(state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegHierarchyStructure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegHierarchyStructure(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRegHierarchyStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get bills related to a specific statute
         * @param {string} statutoryCode The statutory code
         * @param {string} reference The statutory reference
         * @param {string} stateCode The state code
         * @param {string} sessionCode The session code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedBillsByStatute(statutoryCode: string, reference: string, stateCode: string, sessionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRelatedBillsByStatute200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedBillsByStatute(statutoryCode, reference, stateCode, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRelatedBillsByStatute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportContactList(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportContactListWithContactsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportContactList(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getReportContactList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportContactLists(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportContactListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportContactLists(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getReportContactLists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetReportSettings200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getReportSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportsStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getReportStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {Chamber} [chamber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSavedTickSheets(billId: string, chamber?: Chamber, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSavedTickSheets200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSavedTickSheets(billId, chamber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSavedTickSheets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSavedTickSheets_3(billId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSavedTickSheets200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSavedTickSheets_3(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSavedTickSheets_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleTimezones(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetScheduleTimezones200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleTimezones(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getScheduleTimezones']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduledReports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetScheduledReports200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledReports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getScheduledReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSeats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSeats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSeats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionId 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSectionTags(sectionId: string, sessionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSectionTags200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSectionTags(sectionId, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSectionTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessions(stateCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessions(stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharedTags(state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountSharedTags>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharedTags(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSharedTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackIntegration(accountId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlackIntegrationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackIntegration(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSlackIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get staff for a given state and session
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {number} [memberId] Optional filter for a specific member ID
         * @param {string} [position] Optional filter for staff position/title
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [pageSize] Number of items per page
         * @param {string} [searchTerm] Optional search across first/last name, title, email, phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaff(stateCode: string, sessionCode: string, memberId?: number, position?: string, page?: number, pageSize?: number, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStaff200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaff(stateCode, sessionCode, memberId, position, page, pageSize, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStakeholderContacts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StakeholderContactResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStakeholderContacts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStakeholderContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [stakeholderId] 
         * @param {number} [accountId] 
         * @param {string} [masterBillId] 
         * @param {number} [companyId] 
         * @param {string} [meetingType] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStakeholderMeetings(stakeholderId?: number, accountId?: number, masterBillId?: string, companyId?: number, meetingType?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StakeholderMeetingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStakeholderMeetings(stakeholderId, accountId, masterBillId, companyId, meetingType, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStakeholderMeetings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of State Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStateCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetStateCodes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStateCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStateCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all members for a given state
         * @param {string} stateCode 
         * @param {string} [searchTerm] 
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [pageSize] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStateMembers(stateCode: string, searchTerm?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStateMembers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStateMembers(stateCode, searchTerm, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStateMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetStatsScopeEnum} [scope] 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStats(scope?: GetStatsScopeEnum, stateCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStats(scope, stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the blob URL for a statute
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuteBlobUrl(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatuteBlobUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuteBlobUrl(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStatuteBlobUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get statute details by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuteById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatuteDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuteById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStatuteById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get companies related to a specific statute
         * @param {string} id 
         * @param {string} stateCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuteCompaniesOfInterest(id: string, stateCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatuteCompaniesOfInterest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuteCompaniesOfInterest(id, stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStatuteCompaniesOfInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get items for a specific hierarchy level
         * @param {string} state 
         * @param {StatuteHierarchyField} level 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [code] 
         * @param {string} [title] 
         * @param {string} [subtitle] 
         * @param {string} [article] 
         * @param {string} [chapter] 
         * @param {string} [subchapter] 
         * @param {string} [section] 
         * @param {string} [subsection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuteHierarchyItems(state: string, level: StatuteHierarchyField, page?: number, pageSize?: number, code?: string, title?: string, subtitle?: string, article?: string, chapter?: string, subchapter?: string, section?: string, subsection?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatuteHierarchyItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuteHierarchyItems(state, level, page, pageSize, code, title, subtitle, article, chapter, subchapter, section, subsection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStatuteHierarchyItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get hierarchy overview for all states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuteHierarchyStateCounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatuteHierarchyStateCount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuteHierarchyStateCounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStatuteHierarchyStateCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get statutes for the selected hierarchy path
         * @param {string} state 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [code] 
         * @param {string} [title] 
         * @param {string} [subtitle] 
         * @param {string} [article] 
         * @param {string} [chapter] 
         * @param {string} [subchapter] 
         * @param {string} [section] 
         * @param {string} [subsection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuteHierarchyStatutes(state: string, page?: number, pageSize?: number, code?: string, title?: string, subtitle?: string, article?: string, chapter?: string, subchapter?: string, section?: string, subsection?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatuteHierarchyStatutesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuteHierarchyStatutes(state, page, pageSize, code, title, subtitle, article, chapter, subchapter, section, subsection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStatuteHierarchyStatutes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get hierarchy structure for a specific state
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuteHierarchyStructure(state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatuteHierarchyStructure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuteHierarchyStructure(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStatuteHierarchyStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubjects(stateCode: string, sessionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSubjects200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubjects(stateCode, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSubjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get current subscription details for the authenticated user\'s account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSubscriptionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagCompanyAssignmentStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTagCompanyAssignmentStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagCompanyAssignmentStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTagCompanyAssignmentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CachedAccountTag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTask(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTask(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskFiles(taskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskFileDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskFiles(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTaskFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskNotes(taskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskNotes(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTaskNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {number} [teamId] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTasks(userId?: number, teamId?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskListItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTasks(userId, teamId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeam(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeam200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeam(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeams(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTeams200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeams(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {number} tickSheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTickSheetById(billId: string, tickSheetId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberTickSheetEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTickSheetById(billId, tickSheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTickSheetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {number} tickSheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTickSheetById_4(billId: string, tickSheetId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyTickSheetEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTickSheetById_4(billId, tickSheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTickSheetById_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} trackListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackList(trackListId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrackList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackList(trackListId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackedActivityEmails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackedActivityEmailSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackedActivityEmails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackedActivityEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackedActivityReport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestTrackedActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackedActivityReport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackedActivityReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get recent bill history for all bills tracked by the user or account
         * @param {GetTrackedBillActivityScopeEnum} [scope] Either \&#39;user\&#39; (only user\&#39;s tracked bills) or \&#39;account\&#39; (all users in account)
         * @param {number} [days] Number of days to look back (default 30)
         * @param {number} [page] Page number
         * @param {number} [pageSize] Items per page
         * @param {ActivityType} [activityType] Filter activity by category (all, progress, text, votes)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackedBillActivity(scope?: GetTrackedBillActivityScopeEnum, days?: number, page?: number, pageSize?: number, activityType?: ActivityType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTrackedBillActivity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackedBillActivity(scope, days, page, pageSize, activityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackedBillActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetTrackedBillProgressScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackedBillProgress(scope?: GetTrackedBillProgressScopeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTrackedBillProgress200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackedBillProgress(scope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackedBillProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [states] 
         * @param {string} [sessionKeys] 
         * @param {boolean} [activeOnly] 
         * @param {string} [tagIds] 
         * @param {GetTrackedBillsTagLogicEnum} [tagLogic] 
         * @param {string} [trackTypes] 
         * @param {string} [progressStatuses] 
         * @param {boolean} [alertsOnly] 
         * @param {boolean} [excludeLobbyistUsers] 
         * @param {ViewScope} [viewScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackedBills(page?: number, pageSize?: number, search?: string, states?: string, sessionKeys?: string, activeOnly?: boolean, tagIds?: string, tagLogic?: GetTrackedBillsTagLogicEnum, trackTypes?: string, progressStatuses?: string, alertsOnly?: boolean, excludeLobbyistUsers?: boolean, viewScope?: ViewScope, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBills>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackedBills(page, pageSize, search, states, sessionKeys, activeOnly, tagIds, tagLogic, trackTypes, progressStatuses, alertsOnly, excludeLobbyistUsers, viewScope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackedBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get live actions for tracked bills
         * @param {GetTrackedLiveActionsScopeEnum} [scope] 
         * @param {number} [days] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackedLiveActions(scope?: GetTrackedLiveActionsScopeEnum, days?: number, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrackedLiveActions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackedLiveActions(scope, days, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackedLiveActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get count of live actions for tracked bills
         * @param {GetTrackedLiveActionsCountScopeEnum} [scope] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackedLiveActionsCount(scope?: GetTrackedLiveActionsCountScopeEnum, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrackedLiveActionsCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackedLiveActionsCount(scope, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackedLiveActionsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackedWitnesses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackedWitnessResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackedWitnesses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackedWitnesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdvancedSearchRequest} advancedSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackingActivityReport(advancedSearchRequest: AdvancedSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingActivityReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackingActivityReport(advancedSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTrackingActivityReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get upcoming committee hearings for a given state
         * @param {string} stateCode 
         * @param {string} [sessionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpcomingHearings(stateCode: string, sessionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUpcomingHearings200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpcomingHearings(stateCode, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUpcomingHearings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get upcoming hearings with tracked bills
         * @param {ViewScope} [viewScope] 
         * @param {number} [limit] 
         * @param {boolean} [sortedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpcomingHearings_5(viewScope?: ViewScope, limit?: number, sortedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UpcomingHearingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpcomingHearings_5(viewScope, limit, sortedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUpcomingHearings_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAutoTrackStates(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUser200ResponseUserStatesInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAutoTrackStates(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserAutoTrackStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserContacts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserContactDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserContacts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [folderId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserFiles(folderId?: number, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDataFileItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserFiles(folderId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTaskMetrics(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskMetricsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTaskMetrics(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserTaskMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTrackedActivity(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackedActivityConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTrackedActivity(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserTrackedActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get calendar events for bills tracked by the current user
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTrackedBillCalendar(startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExtraCalendarEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTrackedBillCalendar(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserTrackedBillCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [roleName] 
         * @param {string} [stateCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(roleName?: string, stateCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(roleName, stateCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [lobbyistId] 
         * @param {number} [companyId] 
         * @param {GetValidYearsTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidYears(lobbyistId?: number, companyId?: number, type?: GetValidYearsTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidYears(lobbyistId, companyId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getValidYears']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all saved clip sets for a video
         * @param {number} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVideoClips(videoId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SavedClipSet>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVideoClips(videoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getVideoClips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all saved summaries for a video
         * @param {number} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVideoSummaries(videoId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanySummaryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVideoSummaries(videoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getVideoSummaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed voting records (including member info) for a specific vote.
         * @param {number} voteId The ID of the vote to fetch details for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoteDetails(voteId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVoteDetails200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoteDetails(voteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getVoteDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VoteReportRequest} voteReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoteReport(voteReportRequest: VoteReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVoteReport200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoteReport(voteReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getVoteReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportReportContactsRequest} importReportContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importReportContacts(importReportContactsRequest: ImportReportContactsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportContactListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importReportContacts(importReportContactsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importReportContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InviteUserRequest} inviteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteAnalyst(inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInvitation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteAnalyst(inviteUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inviteAnalyst']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InviteUserRequest} inviteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteFullAccount(inviteUserRequest: InviteUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInvitation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteFullAccount(inviteUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inviteFullAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if a session is currently active (SineDie = 0)
         * @param {string} stateCode 
         * @param {string} sessionCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isSessionActive(stateCode: string, sessionCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsSessionActive200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isSessionActive(stateCode, sessionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.isSessionActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [billId] 
         * @param {number} [tagId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBillPositions(billId?: string, tagId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillPositionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBillPositions(billId, tagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listBillPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {InteractionPayload} interactionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logInteraction(companyId: number, interactionPayload: InteractionPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogInteraction200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logInteraction(companyId, interactionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.logInteraction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Login a user
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Logout the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkAsReadRequest} markAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsRead(markAsReadRequest: MarkAsReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrismaBatchPayload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsRead(markAsReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.markAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {MoveFileRequest} moveFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveFile(fileId: number, moveFileRequest: MoveFileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveFile(fileId, moveFileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.moveFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} masterCompanyId 
         * @param {PeelClusterBody} peelClusterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async peelCompanies(masterCompanyId: number, peelClusterBody: PeelClusterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.peelCompanies(masterCompanyId, peelClusterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.peelCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PurchaseSeatsRequest} purchaseSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchaseSeats(purchaseSeatsRequest: PurchaseSeatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSeatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseSeats(purchaseSeatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.purchaseSeats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query the AI assistant for bill analysis
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryAiChat(chatRequest: ChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryAiChat(chatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.queryAiChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query the AI assistant for video transcript analysis
         * @param {VideoQuestionRequest} videoQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryVideoChat(videoQuestionRequest: VideoQuestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryVideoChat(videoQuestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.queryVideoChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Queue background keyword generation for one or more companies
         * @param {QueueKeywordGenerationRequest} queueKeywordGenerationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queueKeywordGeneration(queueKeywordGenerationRequest: QueueKeywordGenerationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueKeywordGenerationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queueKeywordGeneration(queueKeywordGenerationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.queueKeywordGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reactivate a canceled subscription (before period end)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsolidateTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reactivateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshCalendarCache(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshCalendarCache(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.refreshCalendarCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshDashboardCache(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshDashboardCache200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshDashboardCache(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.refreshDashboardCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshExistingCache(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshDashboardCache200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshExistingCache(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.refreshExistingCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshMainDashboardCache(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshDashboardCache200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshMainDashboardCache(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.refreshMainDashboardCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshUserDashboardCache(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshUserDashboardCache(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.refreshUserDashboardCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register a new user
         * @param {InsertUser} insertUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(insertUser: InsertUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(insertUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RejectAutoTrackedBillBody} rejectAutoTrackedBillBody 
         * @param {boolean} [bypassAccessCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectAutoTrackedBill(rejectAutoTrackedBillBody: RejectAutoTrackedBillBody, bypassAccessCheck?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectAutoTrackedBill(rejectAutoTrackedBillBody, bypassAccessCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rejectAutoTrackedBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTeamMember(id: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTeamMember(id, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.removeTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RemoveTrackedBillBody} removeTrackedBillBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTrackedBill(removeTrackedBillBody: RemoveTrackedBillBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTrackedBill(removeTrackedBillBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.removeTrackedBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} witnessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTrackedWitness(witnessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTrackedWitness(witnessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.removeTrackedWitness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {RenameFileRequest} renameFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameFile(fileId: number, renameFileRequest: RenameFileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameFile(fileId, renameFileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.renameFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {RenameFileRequest} renameFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameFolder(folderId: number, renameFileRequest: RenameFileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameFolder(folderId, renameFileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.renameFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report missing live stream
         * @param {MissingLiveReportBody} missingLiveReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportMissingLive(missingLiveReportBody: MissingLiveReportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportMissingLive(missingLiveReportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reportMissingLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate and automatically regenerate a summary when it does not match the company. This endpoint returns immediately and processes the validation/regeneration in the background.
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportWrongCompanySummary(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportWrongCompanySummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportWrongCompanySummary(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reportWrongCompanySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MissingParamsRequest} missingParamsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestMissingParams(missingParamsRequest: MissingParamsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestMissingParams(missingParamsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.requestMissingParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInvitation(invitationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInvitation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInvitation(invitationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.revokeInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} scheduledReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runScheduledReport(scheduledReportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runScheduledReport(scheduledReportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.runScheduledReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveAccountCompanyClaimsBody} saveAccountCompanyClaimsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAccountCompanyClaims(saveAccountCompanyClaimsBody: SaveAccountCompanyClaimsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountCompanyClaimUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAccountCompanyClaims(saveAccountCompanyClaimsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveAccountCompanyClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveAccountCompanySummaryBody} saveAccountCompanySummaryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAccountCompanySummary(saveAccountCompanySummaryBody: SaveAccountCompanySummaryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountCompanySummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAccountCompanySummary(saveAccountCompanySummaryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveAccountCompanySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveAutoTrackCompaniesBody} saveAutoTrackCompaniesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAutoTrackCompanies(saveAutoTrackCompaniesBody: SaveAutoTrackCompaniesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AutoTrackCompanyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAutoTrackCompanies(saveAutoTrackCompaniesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveAutoTrackCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveAutoTrackStatesBody} saveAutoTrackStatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAutoTrackStates(saveAutoTrackStatesBody: SaveAutoTrackStatesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AutoTrackStateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAutoTrackStates(saveAutoTrackStatesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveAutoTrackStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveBillAlertBody} saveBillAlertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBillAlert(saveBillAlertBody: SaveBillAlertBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillAlertDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBillAlert(saveBillAlertBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveBillAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveBillTagsBody} saveBillTagsBody 
         * @param {boolean} [bypassAccessCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBillTags(saveBillTagsBody: SaveBillTagsBody, bypassAccessCheck?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBillTags(saveBillTagsBody, bypassAccessCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveBillTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveCommitteeAgentStatesBody} saveCommitteeAgentStatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCommitteeAgentStates(saveCommitteeAgentStatesBody: SaveCommitteeAgentStatesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitteeAgentStateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCommitteeAgentStates(saveCommitteeAgentStatesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveCommitteeAgentStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveCommitteeAlertBody} saveCommitteeAlertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCommitteeAlert(saveCommitteeAlertBody: SaveCommitteeAlertBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeAlertDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCommitteeAlert(saveCommitteeAlertBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveCommitteeAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {SaveCompanyTickSheetBody} saveCompanyTickSheetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCompanyTickSheet(billId: string, saveCompanyTickSheetBody: SaveCompanyTickSheetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyTickSheetEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCompanyTickSheet(billId, saveCompanyTickSheetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveCompanyTickSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveLobbyistAlertBody} saveLobbyistAlertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLobbyistAlert(saveLobbyistAlertBody: SaveLobbyistAlertBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LobbyistAlertDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLobbyistAlert(saveLobbyistAlertBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveLobbyistAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} billId 
         * @param {SaveMemberTickSheetBody} saveMemberTickSheetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveMemberTickSheet(billId: string, saveMemberTickSheetBody: SaveMemberTickSheetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberTickSheetEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveMemberTickSheet(billId, saveMemberTickSheetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveMemberTickSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveReportSettingRequest} saveReportSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveReportSetting(saveReportSettingRequest: SaveReportSettingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveReportSetting(saveReportSettingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveReportSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveSectionTagsBody} saveSectionTagsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSectionTags(saveSectionTagsBody: SaveSectionTagsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSectionTags(saveSectionTagsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveSectionTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveUserSettingsBody} saveUserSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUserSettings(saveUserSettingsBody: SaveUserSettingsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUserSettings(saveUserSettingsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ScheduleReportRequest} scheduleReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleReport(scheduleReportRequest: ScheduleReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleReport200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleReport(scheduleReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.scheduleReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search the bills index using ElasticSearch
         * @param {string} term 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<string>} [stateCodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(term: string, page?: number, limit?: number, stateCodes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDataElasticSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(term, page, limit, stateCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for companies by name, returns one representative company per MasterCompanyID with lobbyist count. Used for the invite page searchbar.
         * @param {string} search 
         * @param {string} [stateCode] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCompaniesForInvite(search: string, stateCode?: string, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchCompaniesForInvite200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCompaniesForInvite(search, stateCode, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchCompaniesForInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search regulations via word or AI search
         * @param {string} [query] 
         * @param {SearchRegsSearchModeEnum} [searchMode] 
         * @param {string} [wordQuery] 
         * @param {string} [aiQuery] 
         * @param {string} [state] 
         * @param {string} [code] 
         * @param {string} [title] 
         * @param {string} [chapter] 
         * @param {string} [section] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {string} [article] 
         * @param {string} [subtitle] 
         * @param {string} [subchapter] 
         * @param {string} [subsection] 
         * @param {string} [rule] 
         * @param {string} [part] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchRegs(query?: string, searchMode?: SearchRegsSearchModeEnum, wordQuery?: string, aiQuery?: string, state?: string, code?: string, title?: string, chapter?: string, section?: string, name?: string, fileName?: string, article?: string, subtitle?: string, subchapter?: string, subsection?: string, rule?: string, part?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegSearchResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchRegs(query, searchMode, wordQuery, aiQuery, state, code, title, chapter, section, name, fileName, article, subtitle, subchapter, subsection, rule, part, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchRegs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [stateCode] 
         * @param {string} [sessionCode] 
         * @param {string} [q] 
         * @param {string} [tags] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchRemarks(stateCode?: string, sessionCode?: string, q?: string, tags?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRemarks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchRemarks(stateCode, sessionCode, q, tags, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchRemarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search statutes via word or AI search
         * @param {string} [query] 
         * @param {SearchStatutesSearchModeEnum} [searchMode] 
         * @param {string} [wordQuery] 
         * @param {string} [aiQuery] 
         * @param {string} [state] 
         * @param {string} [code] 
         * @param {string} [title] 
         * @param {string} [chapter] 
         * @param {string} [section] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {string} [article] 
         * @param {string} [subtitle] 
         * @param {string} [subchapter] 
         * @param {string} [subsection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchStatutes(query?: string, searchMode?: SearchStatutesSearchModeEnum, wordQuery?: string, aiQuery?: string, state?: string, code?: string, title?: string, chapter?: string, section?: string, name?: string, fileName?: string, article?: string, subtitle?: string, subchapter?: string, subsection?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatuteSearchResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchStatutes(query, searchMode, wordQuery, aiQuery, state, code, title, chapter, section, name, fileName, article, subtitle, subchapter, subsection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchStatutes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search committee videos by transcript text
         * @param {string} term 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<string>} [stateCodes] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchVideos(term: string, page?: number, limit?: number, stateCodes?: Array<string>, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDataElasticSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchVideos(term, page, limit, stateCodes, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchVideos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchWitnessDirectory(query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WitnessSearchResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchWitnessDirectory(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchWitnessDirectory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GmailSendRequestBody} gmailSendRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAccountGmail(gmailSendRequestBody: GmailSendRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendGmailTestMessage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAccountGmail(gmailSendRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendAccountGmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmailRequest} emailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmail(emailRequest: EmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendTaskReminder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmail(emailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendGmailTestMessageRequest} sendGmailTestMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendGmailTestMessage(sendGmailTestMessageRequest: SendGmailTestMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendGmailTestMessage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendGmailTestMessage(sendGmailTestMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendGmailTestMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReferralInviteRequest} referralInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInvite(referralInviteRequest: ReferralInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInvite(referralInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NewAnalystRequest} newAnalystRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNewAnalyst(newAnalystRequest: NewAnalystRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendTaskReminder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNewAnalyst(newAnalystRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendNewAnalyst']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SlackTestRequest} slackTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSlackTestMessage(slackTestRequest: SlackTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlackTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSlackTestMessage(slackTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendSlackTestMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {SendTaskReminderRequest} sendTaskReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTaskReminder(id: number, sendTaskReminderRequest: SendTaskReminderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendTaskReminder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTaskReminder(id, sendTaskReminderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendTaskReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ShareTagBody} shareTagBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareTag(shareTagBody: ShareTagBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareTag(shareTagBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.shareTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} masterCompanyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitCluster(masterCompanyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.splitCluster(masterCompanyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.splitCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAutoTrack(type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsolidateTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAutoTrack(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.startAutoTrack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SubscribeNewsletterRequest} subscribeNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeNewsletter(subscribeNewsletterRequest: SubscribeNewsletterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeNewsletter(subscribeNewsletterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.subscribeNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a summary about an entity (company, lobbyist, or associate) based on their name
         * @param {EntitySummaryRequest} entitySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summarizeText(entitySummaryRequest: EntitySummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntitySummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summarizeText(entitySummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.summarizeText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test Elasticsearch connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testConnection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestConnection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testConnection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.testConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testKeywordMatching(days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeywordDebugResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testKeywordMatching(days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.testKeywordMatching']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} tagId 
         * @param {ToggleArchiveTagRequest} toggleArchiveTagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleArchiveTag(tagId: number, toggleArchiveTagRequest: ToggleArchiveTagRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTag200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleArchiveTag(tagId, toggleArchiveTagRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleArchiveTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Track report download
         * @param {TrackDownloadRequest} trackDownloadRequest Download tracking parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackReportDownload(trackDownloadRequest: TrackDownloadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackReportDownload(trackDownloadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.trackReportDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAIStrengthRequest} updateAIStrengthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAIStrength(updateAIStrengthRequest: UpdateAIStrengthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAIStrength200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAIStrength(updateAIStrengthRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAIStrength']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update account with selected entity immediately
         * @param {UpdateAccountEntityRequest} updateAccountEntityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountEntity(updateAccountEntityRequest: UpdateAccountEntityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountEntity(updateAccountEntityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAccountEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Priority and/or Impact for a bill in AutoTrackReasoning
         * @param {UpdateBillPriorityImpactRequest} updateBillPriorityImpactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBillPriorityImpact(updateBillPriorityImpactRequest: UpdateBillPriorityImpactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsolidateTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBillPriorityImpact(updateBillPriorityImpactRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateBillPriorityImpact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientTags(companyId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientTags(companyId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateClientTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the archived status for a saved clip set
         * @param {number} clipSetId 
         * @param {UpdateClipArchivedRequest} updateClipArchivedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClipArchived(clipSetId: number, updateClipArchivedRequest: UpdateClipArchivedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForgotPassword200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClipArchived(clipSetId, updateClipArchivedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateClipArchived']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCommitteeAgentEnabledRequest} updateCommitteeAgentEnabledRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommitteeAgentEnabled(updateCommitteeAgentEnabledRequest: UpdateCommitteeAgentEnabledRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCommitteeAgentEnabledRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommitteeAgentEnabled(updateCommitteeAgentEnabledRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCommitteeAgentEnabled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {UpdateCompanyStatusRequest} updateCompanyStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyStatus(companyId: number, updateCompanyStatusRequest: UpdateCompanyStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCompanyStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyStatus(companyId, updateCompanyStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCompanyStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {SummaryPayload} summaryPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanySummary(companyId: number, summaryPayload: SummaryPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCompanySummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanySummary(companyId, summaryPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCompanySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {number} contactId 
         * @param {ContactPayload} contactPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(companyId: number, contactId: number, contactPayload: ContactPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientDetails200ResponseClientContactsInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(companyId, contactId, contactPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {UpdateFolderColorSettingRequest} updateFolderColorSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFolderColorSetting(folderId: number, updateFolderColorSettingRequest: UpdateFolderColorSettingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFolderColorSetting(folderId, updateFolderColorSettingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFolderColorSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateIssueRequest} updateIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIssue(id: number, updateIssueRequest: UpdateIssueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssues200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIssue(id, updateIssueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateKeywordMatchViewedRequest} updateKeywordMatchViewedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKeywordMatchViewed(updateKeywordMatchViewedRequest: UpdateKeywordMatchViewedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateKeywordMatchViewed200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKeywordMatchViewed(updateKeywordMatchViewedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateKeywordMatchViewed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update keywords for an account after initial setup This allows keywords to be generated asynchronously and saved later
         * @param {UpdateKeywordsRequest} updateKeywordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKeywords(updateKeywordsRequest: UpdateKeywordsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKeywords(updateKeywordsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMemberListRequest} updateMemberListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberList(id: number, updateMemberListRequest: UpdateMemberListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberList(id, updateMemberListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateMemberList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {UpdateMetadataRequest} updateMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMetadata(fileId: number, updateMetadataRequest: UpdateMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMetadata(fileId, updateMetadataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the priority and/or impact for a committee analysis record
         * @param {number} id 
         * @param {UpdatePriorityImpactRequest} updatePriorityImpactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriorityImpact(id: number, updatePriorityImpactRequest: UpdatePriorityImpactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriorityImpact(id, updatePriorityImpactRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePriorityImpact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} remarkId 
         * @param {UpdateBillRemarkBody} updateBillRemarkBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRemark(remarkId: number, updateBillRemarkBody: UpdateBillRemarkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBillRemark200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRemark(remarkId, updateBillRemarkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateRemark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateReportSettingRequest} updateReportSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportSetting(updateReportSettingRequest: UpdateReportSettingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportSetting(updateReportSettingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateReportSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateSeatsRequest} updateSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSeats(updateSeatsRequest: UpdateSeatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSeatsRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSeats(updateSeatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateSeats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} stakeholderId 
         * @param {StakeholderContactInput} stakeholderContactInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStakeholderContact(stakeholderId: number, stakeholderContactInput: StakeholderContactInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StakeholderContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStakeholderContact(stakeholderId, stakeholderContactInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateStakeholderContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meetingId 
         * @param {StakeholderMeetingInput} stakeholderMeetingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStakeholderMeeting(meetingId: number, stakeholderMeetingInput: StakeholderMeetingInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StakeholderMeetingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStakeholderMeeting(meetingId, stakeholderMeetingInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateStakeholderMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} tagId 
         * @param {UpdateTagRequest} updateTagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTag(tagId: number, updateTagRequest: UpdateTagRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTag200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTag(tagId, updateTagRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTaskDto} updateTaskDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTask(id: number, updateTaskDto: UpdateTaskDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTask(id, updateTaskDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTeamRequest} updateTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeam(id: number, updateTeamRequest: UpdateTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTeam200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeam(id, updateTeamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateTrackedActivityEmailSettingsBody} updateTrackedActivityEmailSettingsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrackedActivityEmails(updateTrackedActivityEmailSettingsBody: UpdateTrackedActivityEmailSettingsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackedActivityEmailSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrackedActivityEmails(updateTrackedActivityEmailSettingsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTrackedActivityEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {TrackingPreferencesPayload} trackingPreferencesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrackingPreferences(companyId: number, trackingPreferencesPayload: TrackingPreferencesPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientDetails200ResponseClientTrackingPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrackingPreferences(companyId, trackingPreferencesPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTrackingPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {UpdateUserAutoTrackAccessRequest} updateUserAutoTrackAccessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAutoTrackAccess(userId: number, updateUserAutoTrackAccessRequest: UpdateUserAutoTrackAccessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserAutoTrackAccess200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAutoTrackAccess(userId, updateUserAutoTrackAccessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserAutoTrackAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the user\'s primary contact email. This is used when setting a lobbyist email.
         * @param {UpdateUserContactEmailRequest} updateUserContactEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserContactEmail(updateUserContactEmailRequest: UpdateUserContactEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContactDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserContactEmail(updateUserContactEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserContactEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {UpdateUserRoleRequest} updateUserRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRole(userId: number, updateUserRoleRequest: UpdateUserRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddAnalyst200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRole(userId, updateUserRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {UpdateUserStatusRequest} updateUserStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserStatus(userId: number, updateUserStatusRequest: UpdateUserStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddAnalyst200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserStatus(userId, updateUserStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {UpdateTrackedActivityConfigBody} updateTrackedActivityConfigBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserTrackedActivity(userId: number, updateTrackedActivityConfigBody: UpdateTrackedActivityConfigBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackedActivityConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserTrackedActivity(userId, updateTrackedActivityConfigBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserTrackedActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the current user\'s username
         * @param {UpdateUsernameRequest} updateUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUsername(updateUsernameRequest: UpdateUsernameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUsernameRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUsername(updateUsernameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAccountLogo(files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLogoFromUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAccountLogo(files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadAccountLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a document attachment to a remark
         * @param {number} remarkId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocument(remarkId: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocument(remarkId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocuments(companyId: number, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDocuments200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocuments(companyId, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<File>} files 
         * @param {string} [folderId] 
         * @param {string} [companyId] 
         * @param {string} [masterBillId] 
         * @param {string} [purpose] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFiles(files: Array<File>, folderId?: string, companyId?: string, masterBillId?: string, purpose?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFiles(files, folderId, companyId, masterBillId, purpose, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} companyId 
         * @param {UploadLogoFromUrlRequest} uploadLogoFromUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLogoFromUrl(companyId: number, uploadLogoFromUrlRequest: UploadLogoFromUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLogoFromUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLogoFromUrl(companyId, uploadLogoFromUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadLogoFromUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTaskFile(id: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTaskFile(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadTaskFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {string} state 
         * @param {string} session 
         * @param {string} lobbyistIds 
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTrackList(file: File, state: string, session: string, lobbyistIds: string, accountId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackListUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTrackList(file, state, session, lobbyistIds, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadTrackList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate if a company summary matches the company name using GPT
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCompanySummary(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateCompanySummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCompanySummary(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.validateCompanySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Warm the cache for recently active bills This endpoint is designed to be called by a cron job (e.g., at 3 AM daily) Protected by API key authentication
         * @param {number} [days] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warmBillCache(days?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarmBillCache200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warmBillCache(days, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.warmBillCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Warm the cache for bills with recent activity
         * @param {string} xApiKey 
         * @param {number} [days] Number of days to look back for recent activity (default: 7)
         * @param {number} [limit] Maximum number of bills to cache (optional, for safety)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warmBillCache_6(xApiKey: string, days?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CacheWarmResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warmBillCache_6(xApiKey, days, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.warmBillCache_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {DefaultApiAcceptInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(requestParameters: DefaultApiAcceptInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.acceptInvitation(requestParameters.acceptInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAcceptInvitationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitationGet(requestParameters: DefaultApiAcceptInvitationGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.acceptInvitationGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAddAnalystRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAnalyst(requestParameters: DefaultApiAddAnalystRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddAnalyst200Response> {
            return localVarFp.addAnalyst(requestParameters.addAnalystRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAddBillWithSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBillWithSession(requestParameters: DefaultApiAddBillWithSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddBillWithSession200Response> {
            return localVarFp.addBillWithSession(requestParameters.addBillWithSessionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAddTaskNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTaskNote(requestParameters: DefaultApiAddTaskNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskNoteDto> {
            return localVarFp.addTaskNote(requestParameters.id, requestParameters.createTaskNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAddTeamMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamMember(requestParameters: DefaultApiAddTeamMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.addTeamMember(requestParameters.id, requestParameters.addTeamMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAddTrackedWitnessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrackedWitness(requestParameters: DefaultApiAddTrackedWitnessRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.addTrackedWitness(requestParameters.trackWitnessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiApproveAutoTrackedBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAutoTrackedBill(requestParameters: DefaultApiApproveAutoTrackedBillRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.approveAutoTrackedBill(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * Answer questions about a bill using its text content with conversation history
         * @param {DefaultApiAskBillQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askBillQuestion(requestParameters: DefaultApiAskBillQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIResponse> {
            return localVarFp.askBillQuestion(requestParameters.billQuestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAskRegQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askRegQuestion(requestParameters: DefaultApiAskRegQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIResponse> {
            return localVarFp.askRegQuestion(requestParameters.regulationQuestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAskStatuteQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askStatuteQuestion(requestParameters: DefaultApiAskStatuteQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIResponse> {
            return localVarFp.askStatuteQuestion(requestParameters.statuteQuestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssignLobbyistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLobbyist(requestParameters: DefaultApiAssignLobbyistRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignWitnessLobbyistResponse> {
            return localVarFp.assignLobbyist(requestParameters.witnessId, requestParameters.assignWitnessLobbyistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiBulkCreateTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateTags(requestParameters: DefaultApiBulkCreateTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkCreateTags200Response> {
            return localVarFp.bulkCreateTags(requestParameters.bulkCreateTagsRequest, requestParameters.bypassAccessCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiBulkDeleteTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteTags(requestParameters: DefaultApiBulkDeleteTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDeleteTags200Response> {
            return localVarFp.bulkDeleteTags(requestParameters.bulkDeleteTagsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkImportClients(options?: RawAxiosRequestConfig): AxiosPromise<BulkImportResult> {
            return localVarFp.bulkImportClients(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiBulkSaveAccountCompanySummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveAccountCompanySummaries(requestParameters: DefaultApiBulkSaveAccountCompanySummariesRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkSaveResult> {
            return localVarFp.bulkSaveAccountCompanySummaries(requestParameters.bulkSaveAccountCompanySummaryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel the setup process for an account
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelSetup(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelSetup(options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel subscription at the end of the current billing period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(options?: RawAxiosRequestConfig): AxiosPromise<ConsolidateTags200Response> {
            return localVarFp.cancelSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * Change the current user\'s password
         * @param {DefaultApiChangePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(requestParameters: DefaultApiChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changePassword(requestParameters.changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check which chambers have agendas available for a given state
         * @param {DefaultApiCheckAvailableAgendasRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAvailableAgendas(requestParameters: DefaultApiCheckAvailableAgendasRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckAvailableAgendas200Response> {
            return localVarFp.checkAvailableAgendas(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCheckUsernameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUsername(requestParameters: DefaultApiCheckUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<UsernameAvailabilityResponseModel> {
            return localVarFp.checkUsername(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if a username is available
         * @param {DefaultApiCheckUsernameAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUsernameAvailability(requestParameters: DefaultApiCheckUsernameAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckUsernameAvailability200Response> {
            return localVarFp.checkUsernameAvailability(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Clear a specific bill from cache
         * @param {DefaultApiClearBillCacheRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearBillCache(requestParameters: DefaultApiClearBillCacheRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddBillWithSession200Response> {
            return localVarFp.clearBillCache(requestParameters.xApiKey, requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * Clear sessions cache for a specific user and state
         * @param {DefaultApiClearSessionsCacheRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearSessionsCache(requestParameters: DefaultApiClearSessionsCacheRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClearSessionsCache200Response> {
            return localVarFp.clearSessionsCache(requestParameters.xApiKey, requestParameters.userId, requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Clear sessions cache for a specific user
         * @param {DefaultApiClearUserSessionsCacheRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearUserSessionsCache(requestParameters: DefaultApiClearUserSessionsCacheRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClearUserSessionsCache200Response> {
            return localVarFp.clearUserSessionsCache(requestParameters.xApiKey, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCompleteRegistrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRegistration(requestParameters: DefaultApiCompleteRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallingUser> {
            return localVarFp.completeRegistration(requestParameters.completeRegistrationRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete the setup process for an account with the provided information
         * @param {DefaultApiCompleteSetupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeSetup(requestParameters: DefaultApiCompleteSetupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.completeSetup(requestParameters.completeSetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiConnectGmailIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectGmailIntegration(requestParameters: DefaultApiConnectGmailIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GmailIntegrationStatusResponse> {
            return localVarFp.connectGmailIntegration(requestParameters.connectGmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiConnectSlackIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectSlackIntegration(requestParameters: DefaultApiConnectSlackIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SlackIntegrationStatusResponse> {
            return localVarFp.connectSlackIntegration(requestParameters.connectSlackIntegrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiConsolidateTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consolidateTags(requestParameters: DefaultApiConsolidateTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsolidateTags200Response> {
            return localVarFp.consolidateTags(requestParameters.consolidateTagsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateAccountBillRemarkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountBillRemark(requestParameters: DefaultApiCreateAccountBillRemarkRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBillRemark200Response> {
            return localVarFp.createAccountBillRemark(requestParameters.createBillRemarkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateBillRemarkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillRemark(requestParameters: DefaultApiCreateBillRemarkRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBillRemark200Response> {
            return localVarFp.createBillRemark(requestParameters.createBillRemarkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCluster(requestParameters: DefaultApiCreateClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClusterResponse> {
            return localVarFp.createCluster(requestParameters.createClusterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new company and generate a Full summary via Perplexity. Ensures MasterCompanyID is set to CompanyID.
         * @param {DefaultApiCreateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(requestParameters: DefaultApiCreateCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCompanies200ResponseDataInner> {
            return localVarFp.createCompany(requestParameters.createCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(requestParameters: DefaultApiCreateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClientDetails200ResponseClientContactsInner> {
            return localVarFp.createContact(requestParameters.companyId, requestParameters.contactPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateFeatureRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeatureRequest(requestParameters: DefaultApiCreateFeatureRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFeatureRequest200Response> {
            return localVarFp.createFeatureRequest(requestParameters.createFeatureRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateFirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirm(requestParameters: DefaultApiCreateFirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFirm200Response> {
            return localVarFp.createFirm(requestParameters.createFirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateGmailCalendarEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGmailCalendarEvent(requestParameters: DefaultApiCreateGmailCalendarEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateGmailCalendarEvent200Response> {
            return localVarFp.createGmailCalendarEvent(requestParameters.gmailCalendarRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(requestParameters: DefaultApiCreateInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInvitation200Response> {
            return localVarFp.createInvitation(requestParameters.inviteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateIssueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssue(requestParameters: DefaultApiCreateIssueRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetIssues200ResponseInner> {
            return localVarFp.createIssue(requestParameters.createIssueBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateLobbyistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLobbyist(requestParameters: DefaultApiCreateLobbyistRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLobbyist200Response> {
            return localVarFp.createLobbyist(requestParameters.lobbyistCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateMemberListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemberList(requestParameters: DefaultApiCreateMemberListRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemberListDto> {
            return localVarFp.createMemberList(requestParameters.createMemberListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateOrUpdateBillPositionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateBillPosition(requestParameters: DefaultApiCreateOrUpdateBillPositionRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillPositionDto> {
            return localVarFp.createOrUpdateBillPosition(requestParameters.createBillPositionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreatePersonalBillRemarkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonalBillRemark(requestParameters: DefaultApiCreatePersonalBillRemarkRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBillRemark200Response> {
            return localVarFp.createPersonalBillRemark(requestParameters.createBillRemarkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe Customer Portal session for managing billing This allows customers to update payment methods, view invoices, etc.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortalSession(options?: RawAxiosRequestConfig): AxiosPromise<PortalSession> {
            return localVarFp.createPortalSession(options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe Customer Portal session for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortalSession_1(options?: RawAxiosRequestConfig): AxiosPromise<CustomerPortalSessionResponseModel> {
            return localVarFp.createPortalSession_1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateProspectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProspect(requestParameters: DefaultApiCreateProspectRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateProspect200Response> {
            return localVarFp.createProspect(requestParameters.prospectCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession(requestParameters: DefaultApiCreateSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromotionCheckoutSessionResponseModel> {
            return localVarFp.createSession(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateStakeholderContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStakeholderContact(requestParameters: DefaultApiCreateStakeholderContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<StakeholderContactResponse> {
            return localVarFp.createStakeholderContact(requestParameters.stakeholderContactInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateStakeholderMeetingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStakeholderMeeting(requestParameters: DefaultApiCreateStakeholderMeetingRequest, options?: RawAxiosRequestConfig): AxiosPromise<StakeholderMeetingResponse> {
            return localVarFp.createStakeholderMeeting(requestParameters.stakeholderMeetingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(requestParameters: DefaultApiCreateTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTag200Response> {
            return localVarFp.createTag(requestParameters.createTagBody, requestParameters.bypassAccessCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(requestParameters: DefaultApiCreateTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskListItemDto> {
            return localVarFp.createTask(requestParameters.createTaskDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam(requestParameters: DefaultApiCreateTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTeam200Response> {
            return localVarFp.createTeam(requestParameters.createTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCreateUserFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserFolder(requestParameters: DefaultApiCreateUserFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserFolder200Response> {
            return localVarFp.createUserFolder(requestParameters.createFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Create video clip  Creates a clip record with timestamps only. The video segment is generated on-demand when viewed or downloaded, just like the share endpoint and committee agent.
         * @param {DefaultApiCreateVideoClipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoClip(requestParameters: DefaultApiCreateVideoClipRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatedClipResponse> {
            return localVarFp.createVideoClip(requestParameters.videoSegment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteAccountCompanySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountCompanySummary(requestParameters: DefaultApiDeleteAccountCompanySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.deleteAccountCompanySummary(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllAutoTrackedBills(options?: RawAxiosRequestConfig): AxiosPromise<DeleteAllAutoTrackedBills200Response> {
            return localVarFp.deleteAllAutoTrackedBills(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteAutoTrackedBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAutoTrackedBill(requestParameters: DefaultApiDeleteAutoTrackedBillRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.deleteAutoTrackedBill(requestParameters.billTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteBillPositionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillPosition(requestParameters: DefaultApiDeleteBillPositionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForgotPassword200Response> {
            return localVarFp.deleteBillPosition(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a document
         * @param {DefaultApiDeleteDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(requestParameters: DefaultApiDeleteDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.deleteDocument(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(requestParameters: DefaultApiDeleteFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFile(requestParameters.fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(requestParameters: DefaultApiDeleteFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFolder(requestParameters.folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteMemberListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMemberList(requestParameters: DefaultApiDeleteMemberListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsolidateTags200Response> {
            return localVarFp.deleteMemberList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteRemarkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRemark(requestParameters: DefaultApiDeleteRemarkRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.deleteRemark(requestParameters.remarkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteScheduledReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduledReport(requestParameters: DefaultApiDeleteScheduledReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.deleteScheduledReport(requestParameters.scheduledReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(requestParameters: DefaultApiDeleteTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.deleteTag(requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDeleteUserKeywordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserKeyword(requestParameters: DefaultApiDeleteUserKeywordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUserKeyword(requestParameters.deleteUserKeywordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDisconnectGmailIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectGmailIntegration(requestParameters: DefaultApiDisconnectGmailIntegrationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GmailIntegrationStatusResponse> {
            return localVarFp.disconnectGmailIntegration(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDisconnectSlackIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSlackIntegration(requestParameters: DefaultApiDisconnectSlackIntegrationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SlackIntegrationStatusResponse> {
            return localVarFp.disconnectSlackIntegration(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Dismiss the new user welcome modal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissNewUserModal(options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.dismissNewUserModal(options).then((request) => request(axios, basePath));
        },
        /**
         * Proxy endpoint for downloading agenda content Streams the file directly from Azure to the client without exposing SAS tokens
         * @param {DefaultApiDownloadAgendaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAgenda(requestParameters: DefaultApiDownloadAgendaRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.downloadAgenda(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Proxy endpoint for downloading bill documents Streams the file directly from Azure to the client without exposing SAS tokens  IMPORTANT: This route MUST be defined before generic routes that might capture it.
         * @param {DefaultApiDownloadBillDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBillDocument(requestParameters: DefaultApiDownloadBillDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.downloadBillDocument(requestParameters.id, requestParameters.billVersionId, requestParameters.format, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a Video Clip as MP4.
         * @param {DefaultApiDownloadClipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadClip(requestParameters: DefaultApiDownloadClipRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.downloadClip(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a document
         * @param {DefaultApiDownloadDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument(requestParameters: DefaultApiDownloadDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.downloadDocument(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiDownloadFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile(requestParameters: DefaultApiDownloadFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.downloadFile(requestParameters.fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Proxy endpoint for downloading files by path Replaces direct SAS URL access for security compliance
         * @param {DefaultApiDownloadFileByPathRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileByPath(requestParameters: DefaultApiDownloadFileByPathRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.downloadFileByPath(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * Download recent live actions as CSV
         * @param {DefaultApiDownloadLiveActionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLiveActions(requestParameters: DefaultApiDownloadLiveActionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadLiveActions(requestParameters.stateCodes, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Proxy endpoint for downloading supporting documents Streams the file directly from Azure to the client without exposing SAS tokens  IMPORTANT: This route MUST be defined before generic routes that might capture it.
         * @param {DefaultApiDownloadSupportingDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSupportingDocument(requestParameters: DefaultApiDownloadSupportingDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.downloadSupportingDocument(requestParameters.id, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiEmailAiReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailAiReport(requestParameters: DefaultApiEmailAiReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendTaskReminder200Response> {
            return localVarFp.emailAiReport(requestParameters.emailAiReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiEnsureFolderPathRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ensureFolderPath(requestParameters: DefaultApiEnsureFolderPathRequest, options?: RawAxiosRequestConfig): AxiosPromise<EnsureFolderPath200Response> {
            return localVarFp.ensureFolderPath(requestParameters.ensureFolderPathBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Proxy endpoint to fetch AI report from Azure storage (bypasses CORS)
         * @param {DefaultApiFetchAIReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAIReport(requestParameters: DefaultApiFetchAIReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.fetchAIReport(requestParameters.url, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the most recent daily agenda for a specific state and chamber
         * @param {DefaultApiFetchDailyAgendaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDailyAgenda(requestParameters: DefaultApiFetchDailyAgendaRequest, options?: RawAxiosRequestConfig): AxiosPromise<DailyAgendaDto> {
            return localVarFp.fetchDailyAgenda(requestParameters.state, requestParameters.chamber, options).then((request) => request(axios, basePath));
        },
        /**
         * Fix an incorrect company summary by regenerating it
         * @param {DefaultApiFixCompanySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixCompanySummary(requestParameters: DefaultApiFixCompanySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<FixCompanySummary200Response> {
            return localVarFp.fixCompanySummary(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a password reset
         * @param {DefaultApiForgotPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(requestParameters: DefaultApiForgotPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForgotPassword200Response> {
            return localVarFp.forgotPassword(requestParameters.forgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Forward a bill to one or more lobbyists in the account
         * @param {DefaultApiForwardBillToLobbyistsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardBillToLobbyists(requestParameters: DefaultApiForwardBillToLobbyistsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsolidateTags200Response> {
            return localVarFp.forwardBillToLobbyists(requestParameters.forwardBillToLobbyistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGatherContextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gatherContext(requestParameters: DefaultApiGatherContextRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.gatherContext(requestParameters.contextQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGenerateAIReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAIReport(requestParameters: DefaultApiGenerateAIReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIReportResponse> {
            return localVarFp.generateAIReport(requestParameters.aIReportPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a suggested title and description for a clip.
         * @param {DefaultApiGenerateClipMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClipMetadata(requestParameters: DefaultApiGenerateClipMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClipMetadataResponse> {
            return localVarFp.generateClipMetadata(requestParameters.videoId, requestParameters.clipMetadataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a video clip of segments relevant to a company
         * @param {DefaultApiGenerateCompanyClipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompanyClip(requestParameters: DefaultApiGenerateCompanyClipRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyClipResponse> {
            return localVarFp.generateCompanyClip(requestParameters.videoId, requestParameters.generateCompanySummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a company-specific summary of a committee video
         * @param {DefaultApiGenerateCompanySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCompanySummary(requestParameters: DefaultApiGenerateCompanySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanySummaryResponse> {
            return localVarFp.generateCompanySummary(requestParameters.videoId, requestParameters.generateCompanySummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate AI report using API key authentication (for external clients)
         * @param {DefaultApiGenerateExternalAIReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExternalAIReport(requestParameters: DefaultApiGenerateExternalAIReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIReportResponse> {
            return localVarFp.generateExternalAIReport(requestParameters.xApiKey, requestParameters.externalAIReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate relevant keywords based on the entity description Can process single entity or multiple companies in parallel
         * @param {DefaultApiGenerateKeywordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateKeywords(requestParameters: DefaultApiGenerateKeywordsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateKeywordsResponse> {
            return localVarFp.generateKeywords(requestParameters.generateKeywordsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGenerateSegmentSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSegmentSummary(requestParameters: DefaultApiGenerateSegmentSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<SegmentSummaryResponse> {
            return localVarFp.generateSegmentSummary(requestParameters.videoId, requestParameters.generateSegmentSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate relevant subjects based on the entity description
         * @param {DefaultApiGenerateSubjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSubjects(requestParameters: DefaultApiGenerateSubjectsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateSubjectsResponse> {
            return localVarFp.generateSubjects(requestParameters.generateSubjectsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGenerateTagContextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTagContext(requestParameters: DefaultApiGenerateTagContextRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateTagContext200Response> {
            return localVarFp.generateTagContext(requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate relevant tags based on provided keywords
         * @param {DefaultApiGenerateTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTags(requestParameters: DefaultApiGenerateTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateTagsResponse> {
            return localVarFp.generateTags(requestParameters.generateTagsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGenerateTagsForCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTagsForCompany(requestParameters: DefaultApiGenerateTagsForCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateTagsForCompany200Response> {
            return localVarFp.generateTagsForCompany(requestParameters.generateTagsForCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTrackedActivityReportsBatch(options?: RawAxiosRequestConfig): AxiosPromise<GenerateTrackedActivityReportsBatch200Response> {
            return localVarFp.generateTrackedActivityReportsBatch(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(options?: RawAxiosRequestConfig): AxiosPromise<GetAccount200Response> {
            return localVarFp.getAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAccountBillRemarksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountBillRemarks(requestParameters: DefaultApiGetAccountBillRemarksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillRemarks200ResponseInner>> {
            return localVarFp.getAccountBillRemarks(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAccountCompanyClaimsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCompanyClaims(requestParameters: DefaultApiGetAccountCompanyClaimsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountCompanyClaimUserDto>> {
            return localVarFp.getAccountCompanyClaims(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCompanySummaries(options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountCompanySummaryDto>> {
            return localVarFp.getAccountCompanySummaries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAccountCompanySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountCompanySummary(requestParameters: DefaultApiGetAccountCompanySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountCompanySummaryDto> {
            return localVarFp.getAccountCompanySummary(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAccountLobbyistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLobbyist(requestParameters: DefaultApiGetAccountLobbyistRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAccountLobbyist200Response> {
            return localVarFp.getAccountLobbyist(requestParameters.id, requestParameters.state, requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all lobbyist users in the current account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLobbyistUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAccountLobbyistUsers200ResponseInner>> {
            return localVarFp.getAccountLobbyistUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAccountTrackedBillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTrackedBills(requestParameters: DefaultApiGetAccountTrackedBillsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedBills> {
            return localVarFp.getAccountTrackedBills(requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.states, requestParameters.sessionKeys, requestParameters.activeOnly, requestParameters.tagIds, requestParameters.tagLogic, requestParameters.trackTypes, requestParameters.progressStatuses, requestParameters.alertsOnly, requestParameters.excludeLobbyistUsers, requestParameters.lobbyistUsersOnly, requestParameters.jointTracked, requestParameters.userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAccountTrackedBillsBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTrackedBillsBulk(requestParameters: DefaultApiGetAccountTrackedBillsBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.getAccountTrackedBillsBulk(requestParameters.accountTrackedBillsBulkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAccountUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountUsers(requestParameters: DefaultApiGetAccountUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAccountUsers200Response> {
            return localVarFp.getAccountUsers(requestParameters.page, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * Get counts for a specific activity type
         * @param {DefaultApiGetActivityCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityCount(requestParameters: DefaultApiGetActivityCountRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetActivityCount200Response> {
            return localVarFp.getActivityCount(requestParameters.scope, requestParameters.days, requestParameters.activityType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get historical DAU/MAU data for a date range
         * @param {DefaultApiGetActivityHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityHistory(requestParameters: DefaultApiGetActivityHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetActivityHistory200ResponseInner>> {
            return localVarFp.getActivityHistory(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Daily Active Users (DAU) and Monthly Active Users (MAU) metrics
         * @param {DefaultApiGetActivityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityMetrics(requestParameters: DefaultApiGetActivityMetricsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ActivityMetricsResponse> {
            return localVarFp.getActivityMetrics(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAdvancedSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvancedSearch(requestParameters: DefaultApiGetAdvancedSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAdvancedSearch200Response> {
            return localVarFp.getAdvancedSearch(requestParameters.advancedSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvocateTestimony(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdvocateTestimonyResponse>> {
            return localVarFp.getAdvocateTestimony(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAdvocateTestimonyByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvocateTestimonyById(requestParameters: DefaultApiGetAdvocateTestimonyByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdvocateTestimonyResponse> {
            return localVarFp.getAdvocateTestimonyById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAnalystMetrics(options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskMetricsDto>> {
            return localVarFp.getAllAnalystMetrics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalystCandidates(options?: RawAxiosRequestConfig): AxiosPromise<Array<AnalystCandidate>> {
            return localVarFp.getAnalystCandidates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAnalystMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalystMetrics(requestParameters: DefaultApiGetAnalystMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAnalystMetrics200ResponseInner>> {
            return localVarFp.getAnalystMetrics(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysts(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAnalysts200ResponseInner>> {
            return localVarFp.getAnalysts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackAvailability(options?: RawAxiosRequestConfig): AxiosPromise<GetAutoTrackAvailability200Response> {
            return localVarFp.getAutoTrackAvailability(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackCompanies(options?: RawAxiosRequestConfig): AxiosPromise<Array<AutoTrackCompanyDto>> {
            return localVarFp.getAutoTrackCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAutoTrackMatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackMatch(requestParameters: DefaultApiGetAutoTrackMatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutoTrackMatchDto> {
            return localVarFp.getAutoTrackMatch(requestParameters.masterBillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAutoTrackMatchesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackMatches(requestParameters: DefaultApiGetAutoTrackMatchesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAutoTrackMatches> {
            return localVarFp.getAutoTrackMatches(requestParameters.outcome, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.minScore, requestParameters.maxScore, requestParameters.rejectedStart, requestParameters.rejectedEnd, requestParameters.priority, requestParameters.impact, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackStates(options?: RawAxiosRequestConfig): AxiosPromise<Array<AutoTrackStateDto>> {
            return localVarFp.getAutoTrackStates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackStatus(options?: RawAxiosRequestConfig): AxiosPromise<AutoTrackStatusDto> {
            return localVarFp.getAutoTrackStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAutoTrackedBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackedBill(requestParameters: DefaultApiGetAutoTrackedBillRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutoTrackedBillDto> {
            return localVarFp.getAutoTrackedBill(requestParameters.billId, requestParameters.viewScope, requestParameters.targetFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetAutoTrackedBillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoTrackedBills(requestParameters: DefaultApiGetAutoTrackedBillsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAutoTrackedBills> {
            return localVarFp.getAutoTrackedBills(requestParameters.sorted, requestParameters.page, requestParameters.pageSize, requestParameters.viewScope, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sessions for multiple states in a single request
         * @param {DefaultApiGetBatchSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchSessions(requestParameters: DefaultApiGetBatchSessionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<RecordStringArrayIdStringNameStringIsDefault63BooleanValueInner>; }> {
            return localVarFp.getBatchSessions(requestParameters.getBatchSessionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill(requestParameters: DefaultApiGetBillRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBill200Response> {
            return localVarFp.getBill(requestParameters.id, requestParameters.includeAiSummary, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Bill Agent statistics for the current account
         * @param {DefaultApiGetBillAgentStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillAgentStats(requestParameters: DefaultApiGetBillAgentStatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BillAgentStatsResponse> {
            return localVarFp.getBillAgentStats(requestParameters.accountId, requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillAiSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillAiSummary(requestParameters: DefaultApiGetBillAiSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillAiSummary200Response> {
            return localVarFp.getBillAiSummary(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillAlertsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillAlerts(requestParameters: DefaultApiGetBillAlertsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<BillAlertDto>> {
            return localVarFp.getBillAlerts(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillAlertsBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillAlertsBulk(requestParameters: DefaultApiGetBillAlertsBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<BillAlertDto>; }> {
            return localVarFp.getBillAlertsBulk(requestParameters.billAlertsBulkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get committee calendar entries for the selected date range. When trackedOnly is true, results are limited to bills tracked by the account.
         * @param {DefaultApiGetBillCalendarRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillCalendar(requestParameters: DefaultApiGetBillCalendarRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExtraCalendarEventDto>> {
            return localVarFp.getBillCalendar(requestParameters.startDate, requestParameters.endDate, requestParameters.trackedOnly, requestParameters.stateCodes, requestParameters.clientCompanyIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Get bill chat history for the current session and specific bill
         * @param {DefaultApiGetBillChatHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillChatHistory(requestParameters: DefaultApiGetBillChatHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatHistory200Response> {
            return localVarFp.getBillChatHistory(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillComments(requestParameters: DefaultApiGetBillCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillComments200Response> {
            return localVarFp.getBillComments(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillCompaniesOfInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillCompaniesOfInterest(requestParameters: DefaultApiGetBillCompaniesOfInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStatuteCompaniesOfInterest200Response> {
            return localVarFp.getBillCompaniesOfInterest(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillCompanionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillCompanions(requestParameters: DefaultApiGetBillCompanionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillCompanions200Response> {
            return localVarFp.getBillCompanions(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillComparisonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillComparison(requestParameters: DefaultApiGetBillComparisonRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillComparisonResponse> {
            return localVarFp.getBillComparison(requestParameters.getBillComparisonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillComparisonAiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillComparisonAi(requestParameters: DefaultApiGetBillComparisonAiRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillComparisonAi200Response> {
            return localVarFp.getBillComparisonAi(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillContent(requestParameters: DefaultApiGetBillContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillContentDto> {
            return localVarFp.getBillContent(requestParameters.id, requestParameters.billVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get download URL for bill content - UPDATED TO BE A PROXY ENDPOINT Now returns the actual file stream instead of a SAS URL
         * @param {DefaultApiGetBillDownloadUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDownloadUrl(requestParameters: DefaultApiGetBillDownloadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillDownloadUrl200Response> {
            return localVarFp.getBillDownloadUrl(requestParameters.id, requestParameters.billVersionId, requestParameters.format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillHistory(requestParameters: DefaultApiGetBillHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillHistory200Response> {
            return localVarFp.getBillHistory(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillNotes(requestParameters: DefaultApiGetBillNotesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskNoteDto>> {
            return localVarFp.getBillNotes(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillPriorityImpactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillPriorityImpact(requestParameters: DefaultApiGetBillPriorityImpactRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillPriorityImpact200Response> {
            return localVarFp.getBillPriorityImpact(requestParameters.masterBillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillRemarksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillRemarks(requestParameters: DefaultApiGetBillRemarksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillRemarks200ResponseInner>> {
            return localVarFp.getBillRemarks(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillReport(requestParameters: DefaultApiGetBillReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAdvancedSearch200Response> {
            return localVarFp.getBillReport(requestParameters.advancedSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillSimilarAiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillSimilarAi(requestParameters: DefaultApiGetBillSimilarAiRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillSimilarAi200Response> {
            return localVarFp.getBillSimilarAi(requestParameters.id, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillStatutesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillStatutes(requestParameters: DefaultApiGetBillStatutesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillStatutes200Response> {
            return localVarFp.getBillStatutes(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillSubjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillSubjects(requestParameters: DefaultApiGetBillSubjectsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillSubjects200ResponseInner>> {
            return localVarFp.getBillSubjects(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillSupportingDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillSupportingDocuments(requestParameters: DefaultApiGetBillSupportingDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillSupportingDocuments200Response> {
            return localVarFp.getBillSupportingDocuments(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillTags(requestParameters: DefaultApiGetBillTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillTags200ResponseInner>> {
            return localVarFp.getBillTags(requestParameters.billId, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get testimony for a specific bill
         * @param {DefaultApiGetBillTestimonyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillTestimony(requestParameters: DefaultApiGetBillTestimonyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillTestimony200ResponseInner>> {
            return localVarFp.getBillTestimony(requestParameters.masterBillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillTextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillText(requestParameters: DefaultApiGetBillTextRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBillText200Response> {
            return localVarFp.getBillText(requestParameters.id, requestParameters.billVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillVersionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillVersions(requestParameters: DefaultApiGetBillVersionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillVersions200ResponseInner>> {
            return localVarFp.getBillVersions(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillVotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillVotes(requestParameters: DefaultApiGetBillVotesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillVotes200ResponseInner>> {
            return localVarFp.getBillVotes(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBills(requestParameters: DefaultApiGetBillsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDataGetBillsDto> {
            return localVarFp.getBills(requestParameters.page, requestParameters.pageSize, requestParameters.stateCode, requestParameters.sessionCode, requestParameters.sessionCodes, requestParameters.subjects, requestParameters.searchTerm, requestParameters.types, requestParameters.authorName, requestParameters.statuteSection, requestParameters.statuteCode, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.parties, requestParameters.textSearch, requestParameters.rerankCompanyId, requestParameters.rerankProgress, requestParameters.onlyCommitteeChairFiled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetBillsWithHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillsWithHistory(requestParameters: DefaultApiGetBillsWithHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillsWithHistory200ResponseInner>> {
            return localVarFp.getBillsWithHistory(requestParameters.onlyWithHistory, requestParameters.onlyTrackedTags, requestParameters.types, requestParameters.limit, requestParameters.page, requestParameters.historyDateFrom, requestParameters.historyDateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cache statistics
         * @param {DefaultApiGetCacheStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCacheStats(requestParameters: DefaultApiGetCacheStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendTaskReminder200Response> {
            return localVarFp.getCacheStats(requestParameters.xApiKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetCalendarEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEvents(requestParameters: DefaultApiGetCalendarEventsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventDto>> {
            return localVarFp.getCalendarEvents(requestParameters.stateCodes, requestParameters.sessionCode, requestParameters.eventTypeIds, requestParameters.includeUserEvents, requestParameters.includeAccountEvents, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get campaign finance data with various filters
         * @param {DefaultApiGetCampaignFinanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignFinance(requestParameters: DefaultApiGetCampaignFinanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCampaignFinance200Response> {
            return localVarFp.getCampaignFinance(requestParameters.stateCode, requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.filerName, requestParameters.contributorOrganization, requestParameters.contributorFirstName, requestParameters.contributorLastName, requestParameters.contributorState, requestParameters.year, requestParameters.minAmount, requestParameters.maxAmount, requestParameters.isLobbyist, requestParameters.isMember, options).then((request) => request(axios, basePath));
        },
        /**
         * Get campaign finance filers
         * @param {DefaultApiGetCampaignFinanceFilersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignFinanceFilers(requestParameters: DefaultApiGetCampaignFinanceFilersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCampaignFinanceFilers200ResponseInner>> {
            return localVarFp.getCampaignFinanceFilers(requestParameters.search, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * Get chat history for the current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistory(options?: RawAxiosRequestConfig): AxiosPromise<GetChatHistory200Response> {
            return localVarFp.getChatHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetClientBillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBills(requestParameters: DefaultApiGetClientBillsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetClientBills200ResponseInner>> {
            return localVarFp.getClientBills(requestParameters.companyId, requestParameters.sessionCode, requestParameters.includeInactiveSessions, requestParameters.includeAutoUnsorted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetClientCommitteeActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientCommitteeActivity(requestParameters: DefaultApiGetClientCommitteeActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClientCommitteeActivity200Response> {
            return localVarFp.getClientCommitteeActivity(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetClientContributionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientContributions(requestParameters: DefaultApiGetClientContributionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetClientContributions200ResponseInner>> {
            return localVarFp.getClientContributions(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetClientDashboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientDashboard(requestParameters: DefaultApiGetClientDashboardRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientDashboardResponse>> {
            return localVarFp.getClientDashboard(requestParameters.includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetClientDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientDetails(requestParameters: DefaultApiGetClientDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClientDetails200Response> {
            return localVarFp.getClientDetails(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Video Clip.
         * @param {DefaultApiGetClipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClip(requestParameters: DefaultApiGetClipRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClip200Response> {
            return localVarFp.getClip(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCluster(requestParameters: DefaultApiGetClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClusterResponse> {
            return localVarFp.getCluster(requestParameters.masterCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetCombinedCalendarEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCombinedCalendarEvents(requestParameters: DefaultApiGetCombinedCalendarEventsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExtraCalendarEventDto>> {
            return localVarFp.getCombinedCalendarEvents(requestParameters.stateCodes, requestParameters.sessionCode, requestParameters.eventTypeIds, requestParameters.includeUserEvents, requestParameters.includeAccountEvents, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full detail for one committee session by its ID
         * @param {DefaultApiGetCommitteeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommittee(requestParameters: DefaultApiGetCommitteeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCommittee200Response> {
            return localVarFp.getCommittee(requestParameters.id, requestParameters.sessionCode, requestParameters.sections, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recent activity for Committee Agent
         * @param {DefaultApiGetCommitteeAgentRecentActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAgentRecentActivity(requestParameters: DefaultApiGetCommitteeAgentRecentActivityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCommitteeAgentRecentActivity200ResponseInner>> {
            return localVarFp.getCommitteeAgentRecentActivity(requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAgentStates(options?: RawAxiosRequestConfig): AxiosPromise<Array<CommitteeAgentStateDto>> {
            return localVarFp.getCommitteeAgentStates(options).then((request) => request(axios, basePath));
        },
        /**
         * Get Committee Agent statistics for the current account
         * @param {DefaultApiGetCommitteeAgentStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAgentStats(requestParameters: DefaultApiGetCommitteeAgentStatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CommitteeAgentStatsResponse> {
            return localVarFp.getCommitteeAgentStats(requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetCommitteeAlertsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAlerts(requestParameters: DefaultApiGetCommitteeAlertsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommitteeAlertDto>> {
            return localVarFp.getCommitteeAlerts(requestParameters.committeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get committee analysis for the current account
         * @param {DefaultApiGetCommitteeAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAnalysis(requestParameters: DefaultApiGetCommitteeAnalysisRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCommitteeAnalysis200Response> {
            return localVarFp.getCommitteeAnalysis(requestParameters.minPriority, requestParameters.minImpact, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single committee analysis by ID
         * @param {DefaultApiGetCommitteeAnalysisByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeAnalysisById(requestParameters: DefaultApiGetCommitteeAnalysisByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommitteeAnalysisResponse> {
            return localVarFp.getCommitteeAnalysisById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all clips from CommitteeVideoClips table
         * @param {DefaultApiGetCommitteeClipsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeClips(requestParameters: DefaultApiGetCommitteeClipsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCommitteeClips200ResponseInner>> {
            return localVarFp.getCommitteeClips(requestParameters.viewScope, requestParameters.limit, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all summaries from CommitteeVideoSummaries table
         * @param {DefaultApiGetCommitteeSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeSummaries(requestParameters: DefaultApiGetCommitteeSummariesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCommitteeSummaries200ResponseInner>> {
            return localVarFp.getCommitteeSummaries(requestParameters.viewScope, requestParameters.limit, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of CommitteeVideo, optionally filtered by state and with text search support.
         * @param {DefaultApiGetCommitteeVideoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeVideo(requestParameters: DefaultApiGetCommitteeVideoRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCommitteeVideo200Response> {
            return localVarFp.getCommitteeVideo(requestParameters.page, requestParameters.pageSize, requestParameters.stateCode, requestParameters.sessionCode, requestParameters.chamber, requestParameters.committee, requestParameters.year, requestParameters.month, requestParameters.searchTerm, requestParameters.textSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get full detail for one committee video by its ID
         * @param {DefaultApiGetCommitteeVideoByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitteeVideoById(requestParameters: DefaultApiGetCommitteeVideoByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCommitteeVideoByIdResponse> {
            return localVarFp.getCommitteeVideoById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all committee sessions in a given state + session
         * @param {DefaultApiGetCommitteesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommittees(requestParameters: DefaultApiGetCommitteesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCommittees200ResponseInner>> {
            return localVarFp.getCommittees(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.searchTerm, requestParameters.includeNonSession, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of companies with pagination, searching, and sorting.
         * @param {DefaultApiGetCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies(requestParameters: DefaultApiGetCompaniesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCompanies200Response> {
            return localVarFp.getCompanies(requestParameters.state, requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.aiSearch, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Get companies of interest based on user\'s tracked bills and recent bills. Uses bill embeddings from Pinecone to find relevant companies.
         * @param {DefaultApiGetCompaniesOfInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesOfInterest(requestParameters: DefaultApiGetCompaniesOfInterestRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCompaniesOfInterest200Response> {
            return localVarFp.getCompaniesOfInterest(requestParameters.stateCode, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get companies that the user has configured keywords for. Returns only companies that appear as keys in the user\'s BillKeywords config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesWithKeywords(options?: RawAxiosRequestConfig): AxiosPromise<GetCompaniesWithKeywords200Response> {
            return localVarFp.getCompaniesWithKeywords(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single company by its CompanyID.
         * @param {DefaultApiGetCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(requestParameters: DefaultApiGetCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCompany200Response> {
            return localVarFp.getCompany(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetCompanyAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAnalytics(requestParameters: DefaultApiGetCompanyAnalyticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAnalyticsResponse> {
            return localVarFp.getCompanyAnalytics(requestParameters.stateCode, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetCompanyBillsOfInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBillsOfInterest(requestParameters: DefaultApiGetCompanyBillsOfInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCompanyBillsOfInterest200Response> {
            return localVarFp.getCompanyBillsOfInterest(requestParameters.id, requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get contributions for a specific company
         * @param {DefaultApiGetCompanyContributionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyContributions(requestParameters: DefaultApiGetCompanyContributionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCompanyContributions200ResponseInner>> {
            return localVarFp.getCompanyContributions(requestParameters.companyId, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * Get firm engagements for a given company.
         * @param {DefaultApiGetCompanyFirmEngagementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyFirmEngagements(requestParameters: DefaultApiGetCompanyFirmEngagementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCompanyFirmEngagements200ResponseInner>> {
            return localVarFp.getCompanyFirmEngagements(requestParameters.id, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all state variants for a company, grouped by MasterCompanyID. Returns a list of company ids and their state codes so the UI can switch states.
         * @param {DefaultApiGetCompanyStatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyStates(requestParameters: DefaultApiGetCompanyStatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCompanyStates200ResponseInner>> {
            return localVarFp.getCompanyStates(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get testimony for a specific company
         * @param {DefaultApiGetCompanyTestimonyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyTestimony(requestParameters: DefaultApiGetCompanyTestimonyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCompanyTestimony200ResponseInner>> {
            return localVarFp.getCompanyTestimony(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetCompanyTickSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyTickSheet(requestParameters: DefaultApiGetCompanyTickSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyTickSheetEntryDto>> {
            return localVarFp.getCompanyTickSheet(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get concatenated regulations for an entire parent level
         * @param {DefaultApiGetConcatenatedParentLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConcatenatedParentLevel(requestParameters: DefaultApiGetConcatenatedParentLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetConcatenatedRegsResponse> {
            return localVarFp.getConcatenatedParentLevel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetDashboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(requestParameters: DefaultApiGetDashboardRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DashboardData> {
            return localVarFp.getDashboard(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all documents for a remark
         * @param {DefaultApiGetDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(requestParameters: DefaultApiGetDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentMetadata>> {
            return localVarFp.getDocuments(requestParameters.remarkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTypeDto>> {
            return localVarFp.getEventTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetExternalTrackingCountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalTrackingCounts(requestParameters: DefaultApiGetExternalTrackingCountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: RecordStringCountNumberTrackedByAccountBooleanTrackedByLobbyistBooleanValue; }> {
            return localVarFp.getExternalTrackingCounts(requestParameters.billIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetFilesByBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesByBill(requestParameters: DefaultApiGetFilesByBillRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BillFileItem>> {
            return localVarFp.getFilesByBill(requestParameters.masterBillId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single firm by its FirmID with all associated lobbyists.
         * @param {DefaultApiGetFirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirm(requestParameters: DefaultApiGetFirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFirm200Response> {
            return localVarFp.getFirm(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetFirmAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmAnalytics(requestParameters: DefaultApiGetFirmAnalyticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<FirmAnalyticsResponse> {
            return localVarFp.getFirmAnalytics(requestParameters.stateCode, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * Get firm engagements for a given firm.
         * @param {DefaultApiGetFirmEngagementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmEngagements(requestParameters: DefaultApiGetFirmEngagementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetFirmEngagements200ResponseInner>> {
            return localVarFp.getFirmEngagements(requestParameters.id, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of firms with pagination, searching, and sorting.
         * @param {DefaultApiGetFirmsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirms(requestParameters: DefaultApiGetFirmsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFirms200Response> {
            return localVarFp.getFirms(requestParameters.stateCode, requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderTree(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetFolderTree200ResponseInner>> {
            return localVarFp.getFolderTree(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetGmailIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGmailIntegration(requestParameters: DefaultApiGetGmailIntegrationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GmailIntegrationStatusResponse> {
            return localVarFp.getGmailIntegration(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetGmailOAuthUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGmailOAuthUrl(requestParameters: DefaultApiGetGmailOAuthUrlRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetGmailOAuthUrl200Response> {
            return localVarFp.getGmailOAuthUrl(requestParameters.accountId, requestParameters.redirectUri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getIsAccountNew(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getIsAccountNew(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetIssueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssue(requestParameters: DefaultApiGetIssueRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetIssues200ResponseInner> {
            return localVarFp.getIssue(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetIssuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssues(requestParameters: DefaultApiGetIssuesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetIssues200ResponseInner>> {
            return localVarFp.getIssues(requestParameters.status, requestParameters.issueType, requestParameters.priority, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get keyword clips for the current account (all users in the account)
         * @param {DefaultApiGetKeywordClipsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeywordClips(requestParameters: DefaultApiGetKeywordClipsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetKeywordClips200ResponseInner>> {
            return localVarFp.getKeywordClips(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetKeywordGenerationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeywordGenerationStatus(requestParameters: DefaultApiGetKeywordGenerationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<KeywordGenerationStatusResponse> {
            return localVarFp.getKeywordGenerationStatus(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatest(options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsArticle>> {
            return localVarFp.getLatest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLatestBillContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestBillContent(requestParameters: DefaultApiGetLatestBillContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskBillContentDto> {
            return localVarFp.getLatestBillContent(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get latest bill match from AutoTrackReasoning
         * @param {DefaultApiGetLatestMatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestMatch(requestParameters: DefaultApiGetLatestMatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetLatestMatch200Response> {
            return localVarFp.getLatestMatch(requestParameters.accountId, requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLegislatorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegislators(requestParameters: DefaultApiGetLegislatorsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LegislatorWithCount>> {
            return localVarFp.getLegislators(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recent live actions filtered by state
         * @param {DefaultApiGetLiveActionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveActions(requestParameters: DefaultApiGetLiveActionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<LiveActionDto>> {
            return localVarFp.getLiveActions(requestParameters.stateCodes, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch by exactly one of lobbyistId, companyId, masterCompanyId, or companySearch.
         * @param {DefaultApiGetLobbyEngagementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyEngagements(requestParameters: DefaultApiGetLobbyEngagementsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetLobbyEngagements200ResponseInner>> {
            return localVarFp.getLobbyEngagements(requestParameters.lobbyistId, requestParameters.companyId, requestParameters.masterCompanyId, requestParameters.year, requestParameters.companySearch, requestParameters.stateCode, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLobbyistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyist(requestParameters: DefaultApiGetLobbyistRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLobbyist200Response> {
            return localVarFp.getLobbyist(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLobbyistAlertsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistAlerts(requestParameters: DefaultApiGetLobbyistAlertsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<LobbyistAlertDto>> {
            return localVarFp.getLobbyistAlerts(requestParameters.lobbyistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLobbyistAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistAnalytics(requestParameters: DefaultApiGetLobbyistAnalyticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LobbyistAnalyticsResponse> {
            return localVarFp.getLobbyistAnalytics(requestParameters.stateCode, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLobbyistClientsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistClients(requestParameters: DefaultApiGetLobbyistClientsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetLobbyistClients200ResponseInner>> {
            return localVarFp.getLobbyistClients(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Contributions filtered by lobbyist and/or company.
         * @param {DefaultApiGetLobbyistContributionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistContributions(requestParameters: DefaultApiGetLobbyistContributionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContributionDto>> {
            return localVarFp.getLobbyistContributions(requestParameters.lobbyistId, requestParameters.companyId, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLobbyistTestimonyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistTestimony(requestParameters: DefaultApiGetLobbyistTestimonyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetLobbyistTestimony200ResponseInner>> {
            return localVarFp.getLobbyistTestimony(requestParameters.lobbyistId, requestParameters.companyId, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLobbyistsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyists(requestParameters: DefaultApiGetLobbyistsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetLobbyists200Response> {
            return localVarFp.getLobbyists(requestParameters.stateCode, requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetLobbyistsByStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLobbyistsByState(requestParameters: DefaultApiGetLobbyistsByStateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetLobbyistsByState200ResponseInner>> {
            return localVarFp.getLobbyistsByState(requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed information for a single member
         * @param {DefaultApiGetMemberByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberById(requestParameters: DefaultApiGetMemberByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMemberById200Response> {
            return localVarFp.getMemberById(requestParameters.id, requestParameters.sessionCode, requestParameters.includeAuthoredBills, requestParameters.includePassedBills, requestParameters.includeSponsoredBills, requestParameters.includeCoSponsors, options).then((request) => request(axios, basePath));
        },
        /**
         * Get co-sponsors for a member
         * @param {DefaultApiGetMemberCoSponsorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberCoSponsors(requestParameters: DefaultApiGetMemberCoSponsorsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetMemberCoSponsors200ResponseInner>> {
            return localVarFp.getMemberCoSponsors(requestParameters.id, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get contact information for multiple members in batch This is a lightweight endpoint that only fetches contact data without expensive stats calculations
         * @param {DefaultApiGetMemberContactsBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberContactsBatch(requestParameters: DefaultApiGetMemberContactsBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: ContactInfoDto; }> {
            return localVarFp.getMemberContactsBatch(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.chamber, requestParameters.memberIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Get district demographics for a member
         * @param {DefaultApiGetMemberDemographicsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberDemographics(requestParameters: DefaultApiGetMemberDemographicsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMemberDemographics200Response> {
            return localVarFp.getMemberDemographics(requestParameters.id, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get available filter options (chambers and parties) for a state/session
         * @param {DefaultApiGetMemberFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberFilters(requestParameters: DefaultApiGetMemberFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMemberFilters200Response> {
            return localVarFp.getMemberFilters(requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single member image
         * @param {DefaultApiGetMemberImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberImage(requestParameters: DefaultApiGetMemberImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.getMemberImage(requestParameters.memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * Proxy endpoint for member images - provides access without exposing SAS URLs Member images are public, so no authentication required  IMPORTANT: This route MUST be defined before the generic getMemberById (\'{id}\') route. Otherwise, Express will match \'/api/members/123/image\' as getMemberById with id=\'123/image\'.
         * @param {DefaultApiGetMemberImage0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberImage_2(requestParameters: DefaultApiGetMemberImage0Request, options?: RawAxiosRequestConfig): AxiosPromise<NodeJSReadableStream> {
            return localVarFp.getMemberImage_2(requestParameters.id, requestParameters.ext, options).then((request) => request(axios, basePath));
        },
        /**
         * Get multiple member images in bulk
         * @param {DefaultApiGetMemberImagesBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberImagesBulk(requestParameters: DefaultApiGetMemberImagesBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getMemberImagesBulk(requestParameters.memberImagesBulkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get member statistics leaderboards for a state Shows stats from the last completed regular session
         * @param {DefaultApiGetMemberLeaderboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberLeaderboards(requestParameters: DefaultApiGetMemberLeaderboardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMemberLeaderboards200Response> {
            return localVarFp.getMemberLeaderboards(requestParameters.stateCode, requestParameters.currentSessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetMemberListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberList(requestParameters: DefaultApiGetMemberListRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemberListDto> {
            return localVarFp.getMemberList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetMemberListsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberLists(requestParameters: DefaultApiGetMemberListsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberListDto>> {
            return localVarFp.getMemberLists(requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetMemberPublicContributionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberPublicContributions(requestParameters: DefaultApiGetMemberPublicContributionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberRelationship>> {
            return localVarFp.getMemberPublicContributions(requestParameters.memberId, requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetMemberRelationshipsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberRelationships(requestParameters: DefaultApiGetMemberRelationshipsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberRelationship>> {
            return localVarFp.getMemberRelationships(requestParameters.memberId, requestParameters.accountId, requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetMemberTickSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberTickSheet(requestParameters: DefaultApiGetMemberTickSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberTickSheetEntryDto>> {
            return localVarFp.getMemberTickSheet(requestParameters.billId, requestParameters.chamber, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all members for a given state and session
         * @param {DefaultApiGetMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers(requestParameters: DefaultApiGetMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMembers200Response> {
            return localVarFp.getMembers(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.page, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.chamber, requestParameters.party, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAccounts(options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountDto>> {
            return localVarFp.getMyAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetNotifications200ResponseInner>> {
            return localVarFp.getNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * Get payment history (invoices) for the authenticated user\'s account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentHistory(options?: RawAxiosRequestConfig): AxiosPromise<PaymentHistory> {
            return localVarFp.getPaymentHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingFullAccountInvitations(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPendingFullAccountInvitations200ResponseInner>> {
            return localVarFp.getPendingFullAccountInvitations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingInvitations(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPendingInvitations200ResponseInner>> {
            return localVarFp.getPendingInvitations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetPendingRegistrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingRegistration(requestParameters: DefaultApiGetPendingRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PendingRegistrationResponseModel> {
            return localVarFp.getPendingRegistration(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetPersonalBillRemarksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalBillRemarks(requestParameters: DefaultApiGetPersonalBillRemarksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBillRemarks200ResponseInner>> {
            return localVarFp.getPersonalBillRemarks(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlans(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPlans200ResponseInner>> {
            return localVarFp.getPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetPopulateAdvancedFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulateAdvancedFilters(requestParameters: DefaultApiGetPopulateAdvancedFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PopulateAdvancedFiltersResponse> {
            return localVarFp.getPopulateAdvancedFilters(requestParameters.state, requestParameters.session, options).then((request) => request(axios, basePath));
        },
        /**
         * Get priority bills for the current account
         * @param {DefaultApiGetPriorityBillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriorityBills(requestParameters: DefaultApiGetPriorityBillsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PriorityBillResponse>> {
            return localVarFp.getPriorityBills(requestParameters.accountId, requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recent activity for Bill Agent
         * @param {DefaultApiGetRecentActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentActivity(requestParameters: DefaultApiGetRecentActivityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetRecentActivity200ResponseInner>> {
            return localVarFp.getRecentActivity(requestParameters.accountId, requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recent committee analysis
         * @param {DefaultApiGetRecentAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentAnalysis(requestParameters: DefaultApiGetRecentAnalysisRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<RecentAnalysisResponse>> {
            return localVarFp.getRecentAnalysis(requestParameters.viewScope, requestParameters.limit, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recent committee analysis (for dashboard widget)
         * @param {DefaultApiGetRecentCommitteeAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentCommitteeAnalysis(requestParameters: DefaultApiGetRecentCommitteeAnalysisRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommitteeAnalysisResponse>> {
            return localVarFp.getRecentCommitteeAnalysis(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentReports(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetRecentReports200ResponseInner>> {
            return localVarFp.getRecentReports(options).then((request) => request(axios, basePath));
        },
        /**
         * Get regulation details by ID
         * @param {DefaultApiGetRegByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegById(requestParameters: DefaultApiGetRegByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getRegById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get companies related to a specific regulation
         * @param {DefaultApiGetRegCompaniesOfInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegCompaniesOfInterest(requestParameters: DefaultApiGetRegCompaniesOfInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStatuteCompaniesOfInterest200Response> {
            return localVarFp.getRegCompaniesOfInterest(requestParameters.id, requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get items for a specific hierarchy level
         * @param {DefaultApiGetRegHierarchyItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegHierarchyItems(requestParameters: DefaultApiGetRegHierarchyItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegHierarchyItemsResponse> {
            return localVarFp.getRegHierarchyItems(requestParameters.state, requestParameters.level, requestParameters.page, requestParameters.pageSize, requestParameters.level1, requestParameters.level2, requestParameters.level3, requestParameters.level4, requestParameters.level5, requestParameters.level6, requestParameters.level7, options).then((request) => request(axios, basePath));
        },
        /**
         * Get regulations for the selected hierarchy path
         * @param {DefaultApiGetRegHierarchyRegsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegHierarchyRegs(requestParameters: DefaultApiGetRegHierarchyRegsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegHierarchyRegsResponse> {
            return localVarFp.getRegHierarchyRegs(requestParameters.state, requestParameters.page, requestParameters.pageSize, requestParameters.level1, requestParameters.level2, requestParameters.level3, requestParameters.level4, requestParameters.level5, requestParameters.level6, requestParameters.level7, options).then((request) => request(axios, basePath));
        },
        /**
         * Get hierarchy overview for all states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegHierarchyStateCounts(options?: RawAxiosRequestConfig): AxiosPromise<Array<RegHierarchyStateCount>> {
            return localVarFp.getRegHierarchyStateCounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Get hierarchy structure for a specific state
         * @param {DefaultApiGetRegHierarchyStructureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegHierarchyStructure(requestParameters: DefaultApiGetRegHierarchyStructureRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegHierarchyStructure> {
            return localVarFp.getRegHierarchyStructure(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * Get bills related to a specific statute
         * @param {DefaultApiGetRelatedBillsByStatuteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedBillsByStatute(requestParameters: DefaultApiGetRelatedBillsByStatuteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetRelatedBillsByStatute200ResponseInner>> {
            return localVarFp.getRelatedBillsByStatute(requestParameters.statutoryCode, requestParameters.reference, requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetReportContactListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportContactList(requestParameters: DefaultApiGetReportContactListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportContactListWithContactsDto> {
            return localVarFp.getReportContactList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportContactLists(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportContactListDto>> {
            return localVarFp.getReportContactLists(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportSettings(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetReportSettings200ResponseInner>> {
            return localVarFp.getReportSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportStats(options?: RawAxiosRequestConfig): AxiosPromise<ReportsStatsResponse> {
            return localVarFp.getReportStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetSavedTickSheetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedTickSheets(requestParameters: DefaultApiGetSavedTickSheetsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetSavedTickSheets200ResponseInner>> {
            return localVarFp.getSavedTickSheets(requestParameters.billId, requestParameters.chamber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetSavedTickSheets0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedTickSheets_3(requestParameters: DefaultApiGetSavedTickSheets0Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetSavedTickSheets200ResponseInner>> {
            return localVarFp.getSavedTickSheets_3(requestParameters.billId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleTimezones(options?: RawAxiosRequestConfig): AxiosPromise<GetScheduleTimezones200Response> {
            return localVarFp.getScheduleTimezones(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledReports(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetScheduledReports200ResponseInner>> {
            return localVarFp.getScheduledReports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeats(options?: RawAxiosRequestConfig): AxiosPromise<SeatInfo> {
            return localVarFp.getSeats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetSectionTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectionTags(requestParameters: DefaultApiGetSectionTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetSectionTags200ResponseInner>> {
            return localVarFp.getSectionTags(requestParameters.sectionId, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessions(requestParameters: DefaultApiGetSessionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SessionData>> {
            return localVarFp.getSessions(requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetSharedTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedTags(requestParameters: DefaultApiGetSharedTagsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountSharedTags>> {
            return localVarFp.getSharedTags(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetSlackIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackIntegration(requestParameters: DefaultApiGetSlackIntegrationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SlackIntegrationStatusResponse> {
            return localVarFp.getSlackIntegration(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get staff for a given state and session
         * @param {DefaultApiGetStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff(requestParameters: DefaultApiGetStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStaff200Response> {
            return localVarFp.getStaff(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.memberId, requestParameters.position, requestParameters.page, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStakeholderContacts(options?: RawAxiosRequestConfig): AxiosPromise<Array<StakeholderContactResponse>> {
            return localVarFp.getStakeholderContacts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetStakeholderMeetingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStakeholderMeetings(requestParameters: DefaultApiGetStakeholderMeetingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StakeholderMeetingResponse>> {
            return localVarFp.getStakeholderMeetings(requestParameters.stakeholderId, requestParameters.accountId, requestParameters.masterBillId, requestParameters.companyId, requestParameters.meetingType, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of State Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateCodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetStateCodes200ResponseInner>> {
            return localVarFp.getStateCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all members for a given state
         * @param {DefaultApiGetStateMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateMembers(requestParameters: DefaultApiGetStateMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStateMembers200Response> {
            return localVarFp.getStateMembers(requestParameters.stateCode, requestParameters.searchTerm, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats(requestParameters: DefaultApiGetStatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DashboardStatsResponse> {
            return localVarFp.getStats(requestParameters.scope, requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the blob URL for a statute
         * @param {DefaultApiGetStatuteBlobUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteBlobUrl(requestParameters: DefaultApiGetStatuteBlobUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStatuteBlobUrl200Response> {
            return localVarFp.getStatuteBlobUrl(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statute details by ID
         * @param {DefaultApiGetStatuteByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteById(requestParameters: DefaultApiGetStatuteByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<StatuteDetails> {
            return localVarFp.getStatuteById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get companies related to a specific statute
         * @param {DefaultApiGetStatuteCompaniesOfInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteCompaniesOfInterest(requestParameters: DefaultApiGetStatuteCompaniesOfInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStatuteCompaniesOfInterest200Response> {
            return localVarFp.getStatuteCompaniesOfInterest(requestParameters.id, requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get items for a specific hierarchy level
         * @param {DefaultApiGetStatuteHierarchyItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteHierarchyItems(requestParameters: DefaultApiGetStatuteHierarchyItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<StatuteHierarchyItemsResponse> {
            return localVarFp.getStatuteHierarchyItems(requestParameters.state, requestParameters.level, requestParameters.page, requestParameters.pageSize, requestParameters.code, requestParameters.title, requestParameters.subtitle, requestParameters.article, requestParameters.chapter, requestParameters.subchapter, requestParameters.section, requestParameters.subsection, options).then((request) => request(axios, basePath));
        },
        /**
         * Get hierarchy overview for all states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteHierarchyStateCounts(options?: RawAxiosRequestConfig): AxiosPromise<Array<StatuteHierarchyStateCount>> {
            return localVarFp.getStatuteHierarchyStateCounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Get statutes for the selected hierarchy path
         * @param {DefaultApiGetStatuteHierarchyStatutesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteHierarchyStatutes(requestParameters: DefaultApiGetStatuteHierarchyStatutesRequest, options?: RawAxiosRequestConfig): AxiosPromise<StatuteHierarchyStatutesResponse> {
            return localVarFp.getStatuteHierarchyStatutes(requestParameters.state, requestParameters.page, requestParameters.pageSize, requestParameters.code, requestParameters.title, requestParameters.subtitle, requestParameters.article, requestParameters.chapter, requestParameters.subchapter, requestParameters.section, requestParameters.subsection, options).then((request) => request(axios, basePath));
        },
        /**
         * Get hierarchy structure for a specific state
         * @param {DefaultApiGetStatuteHierarchyStructureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuteHierarchyStructure(requestParameters: DefaultApiGetStatuteHierarchyStructureRequest, options?: RawAxiosRequestConfig): AxiosPromise<StatuteHierarchyStructure> {
            return localVarFp.getStatuteHierarchyStructure(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetSubjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjects(requestParameters: DefaultApiGetSubjectsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetSubjects200ResponseInner>> {
            return localVarFp.getSubjects(requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get current subscription details for the authenticated user\'s account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionDetails(options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionDetails> {
            return localVarFp.getSubscriptionDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagCompanyAssignmentStatus(options?: RawAxiosRequestConfig): AxiosPromise<GetTagCompanyAssignmentStatus200Response> {
            return localVarFp.getTagCompanyAssignmentStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(options?: RawAxiosRequestConfig): AxiosPromise<Array<CachedAccountTag>> {
            return localVarFp.getTags(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(requestParameters: DefaultApiGetTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskItemDto> {
            return localVarFp.getTask(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTaskFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFiles(requestParameters: DefaultApiGetTaskFilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskFileDto>> {
            return localVarFp.getTaskFiles(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTaskNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskNotes(requestParameters: DefaultApiGetTaskNotesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskNoteDto>> {
            return localVarFp.getTaskNotes(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTasksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks(requestParameters: DefaultApiGetTasksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskListItemDto>> {
            return localVarFp.getTasks(requestParameters.userId, requestParameters.teamId, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam(requestParameters: DefaultApiGetTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTeam200Response> {
            return localVarFp.getTeam(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTeamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams(requestParameters: DefaultApiGetTeamsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTeams200ResponseInner>> {
            return localVarFp.getTeams(requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTickSheetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTickSheetById(requestParameters: DefaultApiGetTickSheetByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberTickSheetEntryDto>> {
            return localVarFp.getTickSheetById(requestParameters.billId, requestParameters.tickSheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTickSheetById0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTickSheetById_4(requestParameters: DefaultApiGetTickSheetById0Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyTickSheetEntryDto>> {
            return localVarFp.getTickSheetById_4(requestParameters.billId, requestParameters.tickSheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTrackListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackList(requestParameters: DefaultApiGetTrackListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTrackList200Response> {
            return localVarFp.getTrackList(requestParameters.trackListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedActivityEmails(options?: RawAxiosRequestConfig): AxiosPromise<TrackedActivityEmailSettingsResponse> {
            return localVarFp.getTrackedActivityEmails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedActivityReport(options?: RawAxiosRequestConfig): AxiosPromise<GuestTrackedActivityResponse> {
            return localVarFp.getTrackedActivityReport(options).then((request) => request(axios, basePath));
        },
        /**
         * Get recent bill history for all bills tracked by the user or account
         * @param {DefaultApiGetTrackedBillActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedBillActivity(requestParameters: DefaultApiGetTrackedBillActivityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTrackedBillActivity> {
            return localVarFp.getTrackedBillActivity(requestParameters.scope, requestParameters.days, requestParameters.page, requestParameters.pageSize, requestParameters.activityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTrackedBillProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedBillProgress(requestParameters: DefaultApiGetTrackedBillProgressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTrackedBillProgress200ResponseInner>> {
            return localVarFp.getTrackedBillProgress(requestParameters.scope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTrackedBillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedBills(requestParameters: DefaultApiGetTrackedBillsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedBills> {
            return localVarFp.getTrackedBills(requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.states, requestParameters.sessionKeys, requestParameters.activeOnly, requestParameters.tagIds, requestParameters.tagLogic, requestParameters.trackTypes, requestParameters.progressStatuses, requestParameters.alertsOnly, requestParameters.excludeLobbyistUsers, requestParameters.viewScope, options).then((request) => request(axios, basePath));
        },
        /**
         * Get live actions for tracked bills
         * @param {DefaultApiGetTrackedLiveActionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedLiveActions(requestParameters: DefaultApiGetTrackedLiveActionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetTrackedLiveActions200Response> {
            return localVarFp.getTrackedLiveActions(requestParameters.scope, requestParameters.days, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of live actions for tracked bills
         * @param {DefaultApiGetTrackedLiveActionsCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedLiveActionsCount(requestParameters: DefaultApiGetTrackedLiveActionsCountRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetTrackedLiveActionsCount200Response> {
            return localVarFp.getTrackedLiveActionsCount(requestParameters.scope, requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackedWitnesses(options?: RawAxiosRequestConfig): AxiosPromise<Array<TrackedWitnessResponse>> {
            return localVarFp.getTrackedWitnesses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetTrackingActivityReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingActivityReport(requestParameters: DefaultApiGetTrackingActivityReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackingActivityReportResponse> {
            return localVarFp.getTrackingActivityReport(requestParameters.advancedSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get upcoming committee hearings for a given state
         * @param {DefaultApiGetUpcomingHearingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingHearings(requestParameters: DefaultApiGetUpcomingHearingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetUpcomingHearings200ResponseInner>> {
            return localVarFp.getUpcomingHearings(requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get upcoming hearings with tracked bills
         * @param {DefaultApiGetUpcomingHearings0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingHearings_5(requestParameters: DefaultApiGetUpcomingHearings0Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<UpcomingHearingResponse>> {
            return localVarFp.getUpcomingHearings_5(requestParameters.viewScope, requestParameters.limit, requestParameters.sortedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(requestParameters: DefaultApiGetUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUser200Response> {
            return localVarFp.getUser(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetUserAutoTrackStatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAutoTrackStates(requestParameters: DefaultApiGetUserAutoTrackStatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetUser200ResponseUserStatesInner>> {
            return localVarFp.getUserAutoTrackStates(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContacts(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserContactDto>> {
            return localVarFp.getUserContacts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetUserFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFiles(requestParameters: DefaultApiGetUserFilesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDataFileItem> {
            return localVarFp.getUserFiles(requestParameters.folderId, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings(options?: RawAxiosRequestConfig): AxiosPromise<UserSettingsDto> {
            return localVarFp.getUserSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetUserTaskMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTaskMetrics(requestParameters: DefaultApiGetUserTaskMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskMetricsDto> {
            return localVarFp.getUserTaskMetrics(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetUserTrackedActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrackedActivity(requestParameters: DefaultApiGetUserTrackedActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackedActivityConfigResponse> {
            return localVarFp.getUserTrackedActivity(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get calendar events for bills tracked by the current user
         * @param {DefaultApiGetUserTrackedBillCalendarRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrackedBillCalendar(requestParameters: DefaultApiGetUserTrackedBillCalendarRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExtraCalendarEventDto>> {
            return localVarFp.getUserTrackedBillCalendar(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(requestParameters: DefaultApiGetUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetUsers200ResponseInner>> {
            return localVarFp.getUsers(requestParameters.roleName, requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetValidYearsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidYears(requestParameters: DefaultApiGetValidYearsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getValidYears(requestParameters.lobbyistId, requestParameters.companyId, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all saved clip sets for a video
         * @param {DefaultApiGetVideoClipsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoClips(requestParameters: DefaultApiGetVideoClipsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SavedClipSet>> {
            return localVarFp.getVideoClips(requestParameters.videoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all saved summaries for a video
         * @param {DefaultApiGetVideoSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoSummaries(requestParameters: DefaultApiGetVideoSummariesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanySummaryResponse>> {
            return localVarFp.getVideoSummaries(requestParameters.videoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed voting records (including member info) for a specific vote.
         * @param {DefaultApiGetVoteDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoteDetails(requestParameters: DefaultApiGetVoteDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetVoteDetails200ResponseInner>> {
            return localVarFp.getVoteDetails(requestParameters.voteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetVoteReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoteReport(requestParameters: DefaultApiGetVoteReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetVoteReport200Response> {
            return localVarFp.getVoteReport(requestParameters.voteReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiImportReportContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importReportContacts(requestParameters: DefaultApiImportReportContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportContactListDto> {
            return localVarFp.importReportContacts(requestParameters.importReportContactsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiInviteAnalystRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAnalyst(requestParameters: DefaultApiInviteAnalystRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInvitation200Response> {
            return localVarFp.inviteAnalyst(requestParameters.inviteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiInviteFullAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteFullAccount(requestParameters: DefaultApiInviteFullAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInvitation200Response> {
            return localVarFp.inviteFullAccount(requestParameters.inviteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if a session is currently active (SineDie = 0)
         * @param {DefaultApiIsSessionActiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSessionActive(requestParameters: DefaultApiIsSessionActiveRequest, options?: RawAxiosRequestConfig): AxiosPromise<IsSessionActive200Response> {
            return localVarFp.isSessionActive(requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiListBillPositionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillPositions(requestParameters: DefaultApiListBillPositionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<BillPositionDto>> {
            return localVarFp.listBillPositions(requestParameters.billId, requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiLogInteractionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logInteraction(requestParameters: DefaultApiLogInteractionRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogInteraction200Response> {
            return localVarFp.logInteraction(requestParameters.companyId, requestParameters.interactionPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Login a user
         * @param {DefaultApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: DefaultApiLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.login(requestParameters.loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Logout the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiMarkAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead(requestParameters: DefaultApiMarkAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrismaBatchPayload> {
            return localVarFp.markAsRead(requestParameters.markAsReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiMoveFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveFile(requestParameters: DefaultApiMoveFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveFile(requestParameters.fileId, requestParameters.moveFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPeelCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peelCompanies(requestParameters: DefaultApiPeelCompaniesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClusterResponse> {
            return localVarFp.peelCompanies(requestParameters.masterCompanyId, requestParameters.peelClusterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPurchaseSeatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseSeats(requestParameters: DefaultApiPurchaseSeatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseSeatsResponse> {
            return localVarFp.purchaseSeats(requestParameters.purchaseSeatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Query the AI assistant for bill analysis
         * @param {DefaultApiQueryAiChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryAiChat(requestParameters: DefaultApiQueryAiChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIResponse> {
            return localVarFp.queryAiChat(requestParameters.chatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Query the AI assistant for video transcript analysis
         * @param {DefaultApiQueryVideoChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryVideoChat(requestParameters: DefaultApiQueryVideoChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIResponse> {
            return localVarFp.queryVideoChat(requestParameters.videoQuestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Queue background keyword generation for one or more companies
         * @param {DefaultApiQueueKeywordGenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueKeywordGeneration(requestParameters: DefaultApiQueueKeywordGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueueKeywordGenerationResponse> {
            return localVarFp.queueKeywordGeneration(requestParameters.queueKeywordGenerationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reactivate a canceled subscription (before period end)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateSubscription(options?: RawAxiosRequestConfig): AxiosPromise<ConsolidateTags200Response> {
            return localVarFp.reactivateSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCalendarCache(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.refreshCalendarCache(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshDashboardCache(options?: RawAxiosRequestConfig): AxiosPromise<RefreshDashboardCache200Response> {
            return localVarFp.refreshDashboardCache(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshExistingCache(options?: RawAxiosRequestConfig): AxiosPromise<RefreshDashboardCache200Response> {
            return localVarFp.refreshExistingCache(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshMainDashboardCache(options?: RawAxiosRequestConfig): AxiosPromise<RefreshDashboardCache200Response> {
            return localVarFp.refreshMainDashboardCache(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshUserDashboardCache(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.refreshUserDashboardCache(options).then((request) => request(axios, basePath));
        },
        /**
         * Register a new user
         * @param {DefaultApiRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(requestParameters: DefaultApiRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.register(requestParameters.insertUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRejectAutoTrackedBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAutoTrackedBill(requestParameters: DefaultApiRejectAutoTrackedBillRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.rejectAutoTrackedBill(requestParameters.rejectAutoTrackedBillBody, requestParameters.bypassAccessCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRemoveTeamMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTeamMember(requestParameters: DefaultApiRemoveTeamMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.removeTeamMember(requestParameters.id, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRemoveTrackedBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTrackedBill(requestParameters: DefaultApiRemoveTrackedBillRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.removeTrackedBill(requestParameters.removeTrackedBillBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRemoveTrackedWitnessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTrackedWitness(requestParameters: DefaultApiRemoveTrackedWitnessRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.removeTrackedWitness(requestParameters.witnessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRenameFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFile(requestParameters: DefaultApiRenameFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.renameFile(requestParameters.fileId, requestParameters.renameFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRenameFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFolder(requestParameters: DefaultApiRenameFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.renameFolder(requestParameters.folderId, requestParameters.renameFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Report missing live stream
         * @param {DefaultApiReportMissingLiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportMissingLive(requestParameters: DefaultApiReportMissingLiveRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.reportMissingLive(requestParameters.missingLiveReportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate and automatically regenerate a summary when it does not match the company. This endpoint returns immediately and processes the validation/regeneration in the background.
         * @param {DefaultApiReportWrongCompanySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportWrongCompanySummary(requestParameters: DefaultApiReportWrongCompanySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportWrongCompanySummaryResponse> {
            return localVarFp.reportWrongCompanySummary(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRequestMissingParamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMissingParams(requestParameters: DefaultApiRequestMissingParamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.requestMissingParams(requestParameters.missingParamsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRevokeInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation(requestParameters: DefaultApiRevokeInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInvitation200Response> {
            return localVarFp.revokeInvitation(requestParameters.invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiRunScheduledReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runScheduledReport(requestParameters: DefaultApiRunScheduledReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.runScheduledReport(requestParameters.scheduledReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveAccountCompanyClaimsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountCompanyClaims(requestParameters: DefaultApiSaveAccountCompanyClaimsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountCompanyClaimUserDto>> {
            return localVarFp.saveAccountCompanyClaims(requestParameters.saveAccountCompanyClaimsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveAccountCompanySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountCompanySummary(requestParameters: DefaultApiSaveAccountCompanySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountCompanySummaryDto> {
            return localVarFp.saveAccountCompanySummary(requestParameters.saveAccountCompanySummaryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveAutoTrackCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAutoTrackCompanies(requestParameters: DefaultApiSaveAutoTrackCompaniesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AutoTrackCompanyDto>> {
            return localVarFp.saveAutoTrackCompanies(requestParameters.saveAutoTrackCompaniesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveAutoTrackStatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAutoTrackStates(requestParameters: DefaultApiSaveAutoTrackStatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AutoTrackStateDto>> {
            return localVarFp.saveAutoTrackStates(requestParameters.saveAutoTrackStatesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveBillAlertRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillAlert(requestParameters: DefaultApiSaveBillAlertRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillAlertDto> {
            return localVarFp.saveBillAlert(requestParameters.saveBillAlertBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveBillTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillTags(requestParameters: DefaultApiSaveBillTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.saveBillTags(requestParameters.saveBillTagsBody, requestParameters.bypassAccessCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveCommitteeAgentStatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCommitteeAgentStates(requestParameters: DefaultApiSaveCommitteeAgentStatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommitteeAgentStateDto>> {
            return localVarFp.saveCommitteeAgentStates(requestParameters.saveCommitteeAgentStatesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveCommitteeAlertRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCommitteeAlert(requestParameters: DefaultApiSaveCommitteeAlertRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommitteeAlertDto> {
            return localVarFp.saveCommitteeAlert(requestParameters.saveCommitteeAlertBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveCompanyTickSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyTickSheet(requestParameters: DefaultApiSaveCompanyTickSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyTickSheetEntryDto>> {
            return localVarFp.saveCompanyTickSheet(requestParameters.billId, requestParameters.saveCompanyTickSheetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveLobbyistAlertRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLobbyistAlert(requestParameters: DefaultApiSaveLobbyistAlertRequest, options?: RawAxiosRequestConfig): AxiosPromise<LobbyistAlertDto> {
            return localVarFp.saveLobbyistAlert(requestParameters.saveLobbyistAlertBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveMemberTickSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMemberTickSheet(requestParameters: DefaultApiSaveMemberTickSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberTickSheetEntryDto>> {
            return localVarFp.saveMemberTickSheet(requestParameters.billId, requestParameters.saveMemberTickSheetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveReportSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReportSetting(requestParameters: DefaultApiSaveReportSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.saveReportSetting(requestParameters.saveReportSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveSectionTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSectionTags(requestParameters: DefaultApiSaveSectionTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.saveSectionTags(requestParameters.saveSectionTagsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSaveUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserSettings(requestParameters: DefaultApiSaveUserSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingsDto> {
            return localVarFp.saveUserSettings(requestParameters.saveUserSettingsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiScheduleReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleReport(requestParameters: DefaultApiScheduleReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduleReport200Response> {
            return localVarFp.scheduleReport(requestParameters.scheduleReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Search the bills index using ElasticSearch
         * @param {DefaultApiSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(requestParameters: DefaultApiSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDataElasticSearchResult> {
            return localVarFp.search(requestParameters.term, requestParameters.page, requestParameters.limit, requestParameters.stateCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for companies by name, returns one representative company per MasterCompanyID with lobbyist count. Used for the invite page searchbar.
         * @param {DefaultApiSearchCompaniesForInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompaniesForInvite(requestParameters: DefaultApiSearchCompaniesForInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SearchCompaniesForInvite200ResponseInner>> {
            return localVarFp.searchCompaniesForInvite(requestParameters.search, requestParameters.stateCode, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * Search regulations via word or AI search
         * @param {DefaultApiSearchRegsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRegs(requestParameters: DefaultApiSearchRegsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<RegSearchResult>> {
            return localVarFp.searchRegs(requestParameters.query, requestParameters.searchMode, requestParameters.wordQuery, requestParameters.aiQuery, requestParameters.state, requestParameters.code, requestParameters.title, requestParameters.chapter, requestParameters.section, requestParameters.name, requestParameters.fileName, requestParameters.article, requestParameters.subtitle, requestParameters.subchapter, requestParameters.subsection, requestParameters.rule, requestParameters.part, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSearchRemarksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRemarks(requestParameters: DefaultApiSearchRemarksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchRemarks200Response> {
            return localVarFp.searchRemarks(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.q, requestParameters.tags, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Search statutes via word or AI search
         * @param {DefaultApiSearchStatutesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStatutes(requestParameters: DefaultApiSearchStatutesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StatuteSearchResult>> {
            return localVarFp.searchStatutes(requestParameters.query, requestParameters.searchMode, requestParameters.wordQuery, requestParameters.aiQuery, requestParameters.state, requestParameters.code, requestParameters.title, requestParameters.chapter, requestParameters.section, requestParameters.name, requestParameters.fileName, requestParameters.article, requestParameters.subtitle, requestParameters.subchapter, requestParameters.subsection, options).then((request) => request(axios, basePath));
        },
        /**
         * Search committee videos by transcript text
         * @param {DefaultApiSearchVideosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVideos(requestParameters: DefaultApiSearchVideosRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDataElasticSearchResult> {
            return localVarFp.searchVideos(requestParameters.term, requestParameters.page, requestParameters.limit, requestParameters.stateCodes, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSearchWitnessDirectoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWitnessDirectory(requestParameters: DefaultApiSearchWitnessDirectoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<WitnessSearchResult>> {
            return localVarFp.searchWitnessDirectory(requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSendAccountGmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAccountGmail(requestParameters: DefaultApiSendAccountGmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendGmailTestMessage200Response> {
            return localVarFp.sendAccountGmail(requestParameters.gmailSendRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSendEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(requestParameters: DefaultApiSendEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendTaskReminder200Response> {
            return localVarFp.sendEmail(requestParameters.emailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSendGmailTestMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendGmailTestMessage(requestParameters: DefaultApiSendGmailTestMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendGmailTestMessage200Response> {
            return localVarFp.sendGmailTestMessage(requestParameters.sendGmailTestMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSendInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvite(requestParameters: DefaultApiSendInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.sendInvite(requestParameters.referralInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSendNewAnalystRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewAnalyst(requestParameters: DefaultApiSendNewAnalystRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendTaskReminder200Response> {
            return localVarFp.sendNewAnalyst(requestParameters.newAnalystRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSendSlackTestMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSlackTestMessage(requestParameters: DefaultApiSendSlackTestMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SlackTestResponse> {
            return localVarFp.sendSlackTestMessage(requestParameters.slackTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSendTaskReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTaskReminder(requestParameters: DefaultApiSendTaskReminderRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendTaskReminder200Response> {
            return localVarFp.sendTaskReminder(requestParameters.id, requestParameters.sendTaskReminderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiShareTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareTag(requestParameters: DefaultApiShareTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.shareTag(requestParameters.shareTagBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSplitClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitCluster(requestParameters: DefaultApiSplitClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClusterResponse> {
            return localVarFp.splitCluster(requestParameters.masterCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiStartAutoTrackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAutoTrack(requestParameters: DefaultApiStartAutoTrackRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsolidateTags200Response> {
            return localVarFp.startAutoTrack(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiSubscribeNewsletterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeNewsletter(requestParameters: DefaultApiSubscribeNewsletterRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.subscribeNewsletter(requestParameters.subscribeNewsletterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a summary about an entity (company, lobbyist, or associate) based on their name
         * @param {DefaultApiSummarizeTextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeText(requestParameters: DefaultApiSummarizeTextRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntitySummaryResponse> {
            return localVarFp.summarizeText(requestParameters.entitySummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Test Elasticsearch connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testConnection(options?: RawAxiosRequestConfig): AxiosPromise<TestConnection200Response> {
            return localVarFp.testConnection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiTestKeywordMatchingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testKeywordMatching(requestParameters: DefaultApiTestKeywordMatchingRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<KeywordDebugResult> {
            return localVarFp.testKeywordMatching(requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiToggleArchiveTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleArchiveTag(requestParameters: DefaultApiToggleArchiveTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTag200Response> {
            return localVarFp.toggleArchiveTag(requestParameters.tagId, requestParameters.toggleArchiveTagRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Track report download
         * @param {DefaultApiTrackReportDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackReportDownload(requestParameters: DefaultApiTrackReportDownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.trackReportDownload(requestParameters.trackDownloadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateAIStrengthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAIStrength(requestParameters: DefaultApiUpdateAIStrengthRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateAIStrength200Response> {
            return localVarFp.updateAIStrength(requestParameters.updateAIStrengthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update account with selected entity immediately
         * @param {DefaultApiUpdateAccountEntityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountEntity(requestParameters: DefaultApiUpdateAccountEntityRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAccountEntity(requestParameters.updateAccountEntityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Priority and/or Impact for a bill in AutoTrackReasoning
         * @param {DefaultApiUpdateBillPriorityImpactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillPriorityImpact(requestParameters: DefaultApiUpdateBillPriorityImpactRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsolidateTags200Response> {
            return localVarFp.updateBillPriorityImpact(requestParameters.updateBillPriorityImpactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateClientTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientTags(requestParameters: DefaultApiUpdateClientTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.updateClientTags(requestParameters.companyId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the archived status for a saved clip set
         * @param {DefaultApiUpdateClipArchivedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClipArchived(requestParameters: DefaultApiUpdateClipArchivedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForgotPassword200Response> {
            return localVarFp.updateClipArchived(requestParameters.clipSetId, requestParameters.updateClipArchivedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateCommitteeAgentEnabledRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommitteeAgentEnabled(requestParameters: DefaultApiUpdateCommitteeAgentEnabledRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCommitteeAgentEnabledRequest> {
            return localVarFp.updateCommitteeAgentEnabled(requestParameters.updateCommitteeAgentEnabledRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateCompanyStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyStatus(requestParameters: DefaultApiUpdateCompanyStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCompanyStatus200Response> {
            return localVarFp.updateCompanyStatus(requestParameters.companyId, requestParameters.updateCompanyStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateCompanySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanySummary(requestParameters: DefaultApiUpdateCompanySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCompanySummary200Response> {
            return localVarFp.updateCompanySummary(requestParameters.companyId, requestParameters.summaryPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(requestParameters: DefaultApiUpdateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClientDetails200ResponseClientContactsInner> {
            return localVarFp.updateContact(requestParameters.companyId, requestParameters.contactId, requestParameters.contactPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateFolderColorSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolderColorSetting(requestParameters: DefaultApiUpdateFolderColorSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateFolderColorSetting(requestParameters.folderId, requestParameters.updateFolderColorSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateIssueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssue(requestParameters: DefaultApiUpdateIssueRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetIssues200ResponseInner> {
            return localVarFp.updateIssue(requestParameters.id, requestParameters.updateIssueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateKeywordMatchViewedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeywordMatchViewed(requestParameters: DefaultApiUpdateKeywordMatchViewedRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateKeywordMatchViewed200Response> {
            return localVarFp.updateKeywordMatchViewed(requestParameters.updateKeywordMatchViewedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update keywords for an account after initial setup This allows keywords to be generated asynchronously and saved later
         * @param {DefaultApiUpdateKeywordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeywords(requestParameters: DefaultApiUpdateKeywordsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateKeywords(requestParameters.updateKeywordsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateMemberListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberList(requestParameters: DefaultApiUpdateMemberListRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemberListDto> {
            return localVarFp.updateMemberList(requestParameters.id, requestParameters.updateMemberListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata(requestParameters: DefaultApiUpdateMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMetadata(requestParameters.fileId, requestParameters.updateMetadataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the priority and/or impact for a committee analysis record
         * @param {DefaultApiUpdatePriorityImpactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriorityImpact(requestParameters: DefaultApiUpdatePriorityImpactRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommitteeAnalysisResponse> {
            return localVarFp.updatePriorityImpact(requestParameters.id, requestParameters.updatePriorityImpactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateRemarkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRemark(requestParameters: DefaultApiUpdateRemarkRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBillRemark200Response> {
            return localVarFp.updateRemark(requestParameters.remarkId, requestParameters.updateBillRemarkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateReportSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportSetting(requestParameters: DefaultApiUpdateReportSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.updateReportSetting(requestParameters.updateReportSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateSeatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeats(requestParameters: DefaultApiUpdateSeatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSeatsRequest> {
            return localVarFp.updateSeats(requestParameters.updateSeatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateStakeholderContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStakeholderContact(requestParameters: DefaultApiUpdateStakeholderContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<StakeholderContactResponse> {
            return localVarFp.updateStakeholderContact(requestParameters.stakeholderId, requestParameters.stakeholderContactInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateStakeholderMeetingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStakeholderMeeting(requestParameters: DefaultApiUpdateStakeholderMeetingRequest, options?: RawAxiosRequestConfig): AxiosPromise<StakeholderMeetingResponse> {
            return localVarFp.updateStakeholderMeeting(requestParameters.meetingId, requestParameters.stakeholderMeetingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(requestParameters: DefaultApiUpdateTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTag200Response> {
            return localVarFp.updateTag(requestParameters.tagId, requestParameters.updateTagRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask(requestParameters: DefaultApiUpdateTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskItemDto> {
            return localVarFp.updateTask(requestParameters.id, requestParameters.updateTaskDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(requestParameters: DefaultApiUpdateTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTeam200Response> {
            return localVarFp.updateTeam(requestParameters.id, requestParameters.updateTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateTrackedActivityEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackedActivityEmails(requestParameters: DefaultApiUpdateTrackedActivityEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackedActivityEmailSettingsResponse> {
            return localVarFp.updateTrackedActivityEmails(requestParameters.updateTrackedActivityEmailSettingsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateTrackingPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackingPreferences(requestParameters: DefaultApiUpdateTrackingPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClientDetails200ResponseClientTrackingPreferences> {
            return localVarFp.updateTrackingPreferences(requestParameters.companyId, requestParameters.trackingPreferencesPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateUserAutoTrackAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAutoTrackAccess(requestParameters: DefaultApiUpdateUserAutoTrackAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUserAutoTrackAccess200Response> {
            return localVarFp.updateUserAutoTrackAccess(requestParameters.userId, requestParameters.updateUserAutoTrackAccessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the user\'s primary contact email. This is used when setting a lobbyist email.
         * @param {DefaultApiUpdateUserContactEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserContactEmail(requestParameters: DefaultApiUpdateUserContactEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContactDto> {
            return localVarFp.updateUserContactEmail(requestParameters.updateUserContactEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRole(requestParameters: DefaultApiUpdateUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddAnalyst200Response> {
            return localVarFp.updateUserRole(requestParameters.userId, requestParameters.updateUserRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateUserStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus(requestParameters: DefaultApiUpdateUserStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddAnalyst200Response> {
            return localVarFp.updateUserStatus(requestParameters.userId, requestParameters.updateUserStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUpdateUserTrackedActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTrackedActivity(requestParameters: DefaultApiUpdateUserTrackedActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackedActivityConfigResponse> {
            return localVarFp.updateUserTrackedActivity(requestParameters.userId, requestParameters.updateTrackedActivityConfigBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the current user\'s username
         * @param {DefaultApiUpdateUsernameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsername(requestParameters: DefaultApiUpdateUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUsernameRequest> {
            return localVarFp.updateUsername(requestParameters.updateUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadAccountLogoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAccountLogo(requestParameters: DefaultApiUploadAccountLogoRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLogoFromUrl200Response> {
            return localVarFp.uploadAccountLogo(requestParameters.files, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a document attachment to a remark
         * @param {DefaultApiUploadDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument(requestParameters: DefaultApiUploadDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentMetadata> {
            return localVarFp.uploadDocument(requestParameters.remarkId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocuments(requestParameters: DefaultApiUploadDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadDocuments200Response> {
            return localVarFp.uploadDocuments(requestParameters.companyId, requestParameters.files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFiles(requestParameters: DefaultApiUploadFilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadFiles(requestParameters.files, requestParameters.folderId, requestParameters.companyId, requestParameters.masterBillId, requestParameters.purpose, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadLogoFromUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogoFromUrl(requestParameters: DefaultApiUploadLogoFromUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLogoFromUrl200Response> {
            return localVarFp.uploadLogoFromUrl(requestParameters.companyId, requestParameters.uploadLogoFromUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadTaskFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTaskFile(requestParameters: DefaultApiUploadTaskFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskFileDto> {
            return localVarFp.uploadTaskFile(requestParameters.id, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadTrackListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTrackList(requestParameters: DefaultApiUploadTrackListRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackListUploadResponse> {
            return localVarFp.uploadTrackList(requestParameters.file, requestParameters.state, requestParameters.session, requestParameters.lobbyistIds, requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate if a company summary matches the company name using GPT
         * @param {DefaultApiValidateCompanySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCompanySummary(requestParameters: DefaultApiValidateCompanySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateCompanySummaryResponse> {
            return localVarFp.validateCompanySummary(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Warm the cache for recently active bills This endpoint is designed to be called by a cron job (e.g., at 3 AM daily) Protected by API key authentication
         * @param {DefaultApiWarmBillCacheRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmBillCache(requestParameters: DefaultApiWarmBillCacheRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WarmBillCache200Response> {
            return localVarFp.warmBillCache(requestParameters.days, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Warm the cache for bills with recent activity
         * @param {DefaultApiWarmBillCache0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmBillCache_6(requestParameters: DefaultApiWarmBillCache0Request, options?: RawAxiosRequestConfig): AxiosPromise<CacheWarmResult> {
            return localVarFp.warmBillCache_6(requestParameters.xApiKey, requestParameters.days, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptInvitation operation in DefaultApi.
 * @export
 * @interface DefaultApiAcceptInvitationRequest
 */
export interface DefaultApiAcceptInvitationRequest {
    /**
     * 
     * @type {AcceptInviteRequest}
     * @memberof DefaultApiAcceptInvitation
     */
    readonly acceptInviteRequest: AcceptInviteRequest
}

/**
 * Request parameters for acceptInvitationGet operation in DefaultApi.
 * @export
 * @interface DefaultApiAcceptInvitationGetRequest
 */
export interface DefaultApiAcceptInvitationGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAcceptInvitationGet
     */
    readonly token: string
}

/**
 * Request parameters for addAnalyst operation in DefaultApi.
 * @export
 * @interface DefaultApiAddAnalystRequest
 */
export interface DefaultApiAddAnalystRequest {
    /**
     * 
     * @type {AddAnalystRequest}
     * @memberof DefaultApiAddAnalyst
     */
    readonly addAnalystRequest: AddAnalystRequest
}

/**
 * Request parameters for addBillWithSession operation in DefaultApi.
 * @export
 * @interface DefaultApiAddBillWithSessionRequest
 */
export interface DefaultApiAddBillWithSessionRequest {
    /**
     * 
     * @type {AddBillWithSessionBody}
     * @memberof DefaultApiAddBillWithSession
     */
    readonly addBillWithSessionBody: AddBillWithSessionBody
}

/**
 * Request parameters for addTaskNote operation in DefaultApi.
 * @export
 * @interface DefaultApiAddTaskNoteRequest
 */
export interface DefaultApiAddTaskNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAddTaskNote
     */
    readonly id: number

    /**
     * 
     * @type {CreateTaskNoteDto}
     * @memberof DefaultApiAddTaskNote
     */
    readonly createTaskNoteDto: CreateTaskNoteDto
}

/**
 * Request parameters for addTeamMember operation in DefaultApi.
 * @export
 * @interface DefaultApiAddTeamMemberRequest
 */
export interface DefaultApiAddTeamMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAddTeamMember
     */
    readonly id: number

    /**
     * 
     * @type {AddTeamMemberRequest}
     * @memberof DefaultApiAddTeamMember
     */
    readonly addTeamMemberRequest: AddTeamMemberRequest
}

/**
 * Request parameters for addTrackedWitness operation in DefaultApi.
 * @export
 * @interface DefaultApiAddTrackedWitnessRequest
 */
export interface DefaultApiAddTrackedWitnessRequest {
    /**
     * 
     * @type {TrackWitnessRequest}
     * @memberof DefaultApiAddTrackedWitness
     */
    readonly trackWitnessRequest: TrackWitnessRequest
}

/**
 * Request parameters for approveAutoTrackedBill operation in DefaultApi.
 * @export
 * @interface DefaultApiApproveAutoTrackedBillRequest
 */
export interface DefaultApiApproveAutoTrackedBillRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiApproveAutoTrackedBill
     */
    readonly billId: string
}

/**
 * Request parameters for askBillQuestion operation in DefaultApi.
 * @export
 * @interface DefaultApiAskBillQuestionRequest
 */
export interface DefaultApiAskBillQuestionRequest {
    /**
     * 
     * @type {BillQuestionRequest}
     * @memberof DefaultApiAskBillQuestion
     */
    readonly billQuestionRequest: BillQuestionRequest
}

/**
 * Request parameters for askRegQuestion operation in DefaultApi.
 * @export
 * @interface DefaultApiAskRegQuestionRequest
 */
export interface DefaultApiAskRegQuestionRequest {
    /**
     * 
     * @type {RegulationQuestionRequest}
     * @memberof DefaultApiAskRegQuestion
     */
    readonly regulationQuestionRequest: RegulationQuestionRequest
}

/**
 * Request parameters for askStatuteQuestion operation in DefaultApi.
 * @export
 * @interface DefaultApiAskStatuteQuestionRequest
 */
export interface DefaultApiAskStatuteQuestionRequest {
    /**
     * 
     * @type {StatuteQuestionRequest}
     * @memberof DefaultApiAskStatuteQuestion
     */
    readonly statuteQuestionRequest: StatuteQuestionRequest
}

/**
 * Request parameters for assignLobbyist operation in DefaultApi.
 * @export
 * @interface DefaultApiAssignLobbyistRequest
 */
export interface DefaultApiAssignLobbyistRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssignLobbyist
     */
    readonly witnessId: number

    /**
     * 
     * @type {AssignWitnessLobbyistRequest}
     * @memberof DefaultApiAssignLobbyist
     */
    readonly assignWitnessLobbyistRequest: AssignWitnessLobbyistRequest
}

/**
 * Request parameters for bulkCreateTags operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkCreateTagsRequest
 */
export interface DefaultApiBulkCreateTagsRequest {
    /**
     * 
     * @type {BulkCreateTagsRequest}
     * @memberof DefaultApiBulkCreateTags
     */
    readonly bulkCreateTagsRequest: BulkCreateTagsRequest

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiBulkCreateTags
     */
    readonly bypassAccessCheck?: boolean
}

/**
 * Request parameters for bulkDeleteTags operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkDeleteTagsRequest
 */
export interface DefaultApiBulkDeleteTagsRequest {
    /**
     * 
     * @type {BulkDeleteTagsRequest}
     * @memberof DefaultApiBulkDeleteTags
     */
    readonly bulkDeleteTagsRequest: BulkDeleteTagsRequest
}

/**
 * Request parameters for bulkSaveAccountCompanySummaries operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkSaveAccountCompanySummariesRequest
 */
export interface DefaultApiBulkSaveAccountCompanySummariesRequest {
    /**
     * 
     * @type {BulkSaveAccountCompanySummaryBody}
     * @memberof DefaultApiBulkSaveAccountCompanySummaries
     */
    readonly bulkSaveAccountCompanySummaryBody: BulkSaveAccountCompanySummaryBody
}

/**
 * Request parameters for changePassword operation in DefaultApi.
 * @export
 * @interface DefaultApiChangePasswordRequest
 */
export interface DefaultApiChangePasswordRequest {
    /**
     * 
     * @type {ChangePasswordRequest}
     * @memberof DefaultApiChangePassword
     */
    readonly changePasswordRequest: ChangePasswordRequest
}

/**
 * Request parameters for checkAvailableAgendas operation in DefaultApi.
 * @export
 * @interface DefaultApiCheckAvailableAgendasRequest
 */
export interface DefaultApiCheckAvailableAgendasRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCheckAvailableAgendas
     */
    readonly state: string
}

/**
 * Request parameters for checkUsername operation in DefaultApi.
 * @export
 * @interface DefaultApiCheckUsernameRequest
 */
export interface DefaultApiCheckUsernameRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCheckUsername
     */
    readonly username: string
}

/**
 * Request parameters for checkUsernameAvailability operation in DefaultApi.
 * @export
 * @interface DefaultApiCheckUsernameAvailabilityRequest
 */
export interface DefaultApiCheckUsernameAvailabilityRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCheckUsernameAvailability
     */
    readonly username: string
}

/**
 * Request parameters for clearBillCache operation in DefaultApi.
 * @export
 * @interface DefaultApiClearBillCacheRequest
 */
export interface DefaultApiClearBillCacheRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiClearBillCache
     */
    readonly xApiKey: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiClearBillCache
     */
    readonly billId: string
}

/**
 * Request parameters for clearSessionsCache operation in DefaultApi.
 * @export
 * @interface DefaultApiClearSessionsCacheRequest
 */
export interface DefaultApiClearSessionsCacheRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiClearSessionsCache
     */
    readonly xApiKey: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiClearSessionsCache
     */
    readonly userId: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiClearSessionsCache
     */
    readonly stateCode?: string
}

/**
 * Request parameters for clearUserSessionsCache operation in DefaultApi.
 * @export
 * @interface DefaultApiClearUserSessionsCacheRequest
 */
export interface DefaultApiClearUserSessionsCacheRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiClearUserSessionsCache
     */
    readonly xApiKey: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiClearUserSessionsCache
     */
    readonly userId: number
}

/**
 * Request parameters for completeRegistration operation in DefaultApi.
 * @export
 * @interface DefaultApiCompleteRegistrationRequest
 */
export interface DefaultApiCompleteRegistrationRequest {
    /**
     * 
     * @type {CompleteRegistrationRequestModel}
     * @memberof DefaultApiCompleteRegistration
     */
    readonly completeRegistrationRequestModel: CompleteRegistrationRequestModel
}

/**
 * Request parameters for completeSetup operation in DefaultApi.
 * @export
 * @interface DefaultApiCompleteSetupRequest
 */
export interface DefaultApiCompleteSetupRequest {
    /**
     * 
     * @type {CompleteSetupRequest}
     * @memberof DefaultApiCompleteSetup
     */
    readonly completeSetupRequest: CompleteSetupRequest
}

/**
 * Request parameters for connectGmailIntegration operation in DefaultApi.
 * @export
 * @interface DefaultApiConnectGmailIntegrationRequest
 */
export interface DefaultApiConnectGmailIntegrationRequest {
    /**
     * 
     * @type {ConnectGmailRequest}
     * @memberof DefaultApiConnectGmailIntegration
     */
    readonly connectGmailRequest: ConnectGmailRequest
}

/**
 * Request parameters for connectSlackIntegration operation in DefaultApi.
 * @export
 * @interface DefaultApiConnectSlackIntegrationRequest
 */
export interface DefaultApiConnectSlackIntegrationRequest {
    /**
     * 
     * @type {ConnectSlackIntegrationRequest}
     * @memberof DefaultApiConnectSlackIntegration
     */
    readonly connectSlackIntegrationRequest: ConnectSlackIntegrationRequest
}

/**
 * Request parameters for consolidateTags operation in DefaultApi.
 * @export
 * @interface DefaultApiConsolidateTagsRequest
 */
export interface DefaultApiConsolidateTagsRequest {
    /**
     * 
     * @type {ConsolidateTagsRequest}
     * @memberof DefaultApiConsolidateTags
     */
    readonly consolidateTagsRequest: ConsolidateTagsRequest
}

/**
 * Request parameters for createAccountBillRemark operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateAccountBillRemarkRequest
 */
export interface DefaultApiCreateAccountBillRemarkRequest {
    /**
     * 
     * @type {CreateBillRemarkBody}
     * @memberof DefaultApiCreateAccountBillRemark
     */
    readonly createBillRemarkBody: CreateBillRemarkBody
}

/**
 * Request parameters for createBillRemark operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateBillRemarkRequest
 */
export interface DefaultApiCreateBillRemarkRequest {
    /**
     * 
     * @type {CreateBillRemarkBody}
     * @memberof DefaultApiCreateBillRemark
     */
    readonly createBillRemarkBody: CreateBillRemarkBody
}

/**
 * Request parameters for createCluster operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateClusterRequest
 */
export interface DefaultApiCreateClusterRequest {
    /**
     * 
     * @type {CreateClusterBody}
     * @memberof DefaultApiCreateCluster
     */
    readonly createClusterBody: CreateClusterBody
}

/**
 * Request parameters for createCompany operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateCompanyRequest
 */
export interface DefaultApiCreateCompanyRequest {
    /**
     * 
     * @type {CreateCompanyRequest}
     * @memberof DefaultApiCreateCompany
     */
    readonly createCompanyRequest: CreateCompanyRequest
}

/**
 * Request parameters for createContact operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateContactRequest
 */
export interface DefaultApiCreateContactRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiCreateContact
     */
    readonly companyId: number

    /**
     * 
     * @type {ContactPayload}
     * @memberof DefaultApiCreateContact
     */
    readonly contactPayload: ContactPayload
}

/**
 * Request parameters for createFeatureRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateFeatureRequestRequest
 */
export interface DefaultApiCreateFeatureRequestRequest {
    /**
     * 
     * @type {CreateFeatureRequestBody}
     * @memberof DefaultApiCreateFeatureRequest
     */
    readonly createFeatureRequestBody: CreateFeatureRequestBody
}

/**
 * Request parameters for createFirm operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateFirmRequest
 */
export interface DefaultApiCreateFirmRequest {
    /**
     * 
     * @type {CreateFirmRequest}
     * @memberof DefaultApiCreateFirm
     */
    readonly createFirmRequest: CreateFirmRequest
}

/**
 * Request parameters for createGmailCalendarEvent operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateGmailCalendarEventRequest
 */
export interface DefaultApiCreateGmailCalendarEventRequest {
    /**
     * 
     * @type {GmailCalendarRequestBody}
     * @memberof DefaultApiCreateGmailCalendarEvent
     */
    readonly gmailCalendarRequestBody: GmailCalendarRequestBody
}

/**
 * Request parameters for createInvitation operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateInvitationRequest
 */
export interface DefaultApiCreateInvitationRequest {
    /**
     * 
     * @type {InviteUserRequest}
     * @memberof DefaultApiCreateInvitation
     */
    readonly inviteUserRequest: InviteUserRequest
}

/**
 * Request parameters for createIssue operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateIssueRequest
 */
export interface DefaultApiCreateIssueRequest {
    /**
     * 
     * @type {CreateIssueBody}
     * @memberof DefaultApiCreateIssue
     */
    readonly createIssueBody: CreateIssueBody
}

/**
 * Request parameters for createLobbyist operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateLobbyistRequest
 */
export interface DefaultApiCreateLobbyistRequest {
    /**
     * 
     * @type {LobbyistCreateRequest}
     * @memberof DefaultApiCreateLobbyist
     */
    readonly lobbyistCreateRequest: LobbyistCreateRequest
}

/**
 * Request parameters for createMemberList operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateMemberListRequest
 */
export interface DefaultApiCreateMemberListRequest {
    /**
     * 
     * @type {CreateMemberListRequest}
     * @memberof DefaultApiCreateMemberList
     */
    readonly createMemberListRequest: CreateMemberListRequest
}

/**
 * Request parameters for createOrUpdateBillPosition operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateOrUpdateBillPositionRequest
 */
export interface DefaultApiCreateOrUpdateBillPositionRequest {
    /**
     * 
     * @type {CreateBillPositionBody}
     * @memberof DefaultApiCreateOrUpdateBillPosition
     */
    readonly createBillPositionBody: CreateBillPositionBody
}

/**
 * Request parameters for createPersonalBillRemark operation in DefaultApi.
 * @export
 * @interface DefaultApiCreatePersonalBillRemarkRequest
 */
export interface DefaultApiCreatePersonalBillRemarkRequest {
    /**
     * 
     * @type {CreateBillRemarkBody}
     * @memberof DefaultApiCreatePersonalBillRemark
     */
    readonly createBillRemarkBody: CreateBillRemarkBody
}

/**
 * Request parameters for createProspect operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateProspectRequest
 */
export interface DefaultApiCreateProspectRequest {
    /**
     * 
     * @type {ProspectCreateRequest}
     * @memberof DefaultApiCreateProspect
     */
    readonly prospectCreateRequest: ProspectCreateRequest
}

/**
 * Request parameters for createSession operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateSessionRequest
 */
export interface DefaultApiCreateSessionRequest {
    /**
     * 
     * @type {PromotionCheckoutRequestModel}
     * @memberof DefaultApiCreateSession
     */
    readonly body: PromotionCheckoutRequestModel
}

/**
 * Request parameters for createStakeholderContact operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateStakeholderContactRequest
 */
export interface DefaultApiCreateStakeholderContactRequest {
    /**
     * 
     * @type {StakeholderContactInput}
     * @memberof DefaultApiCreateStakeholderContact
     */
    readonly stakeholderContactInput: StakeholderContactInput
}

/**
 * Request parameters for createStakeholderMeeting operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateStakeholderMeetingRequest
 */
export interface DefaultApiCreateStakeholderMeetingRequest {
    /**
     * 
     * @type {StakeholderMeetingInput}
     * @memberof DefaultApiCreateStakeholderMeeting
     */
    readonly stakeholderMeetingInput: StakeholderMeetingInput
}

/**
 * Request parameters for createTag operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateTagRequest
 */
export interface DefaultApiCreateTagRequest {
    /**
     * 
     * @type {CreateTagBody}
     * @memberof DefaultApiCreateTag
     */
    readonly createTagBody: CreateTagBody

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiCreateTag
     */
    readonly bypassAccessCheck?: boolean
}

/**
 * Request parameters for createTask operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateTaskRequest
 */
export interface DefaultApiCreateTaskRequest {
    /**
     * 
     * @type {CreateTaskDto}
     * @memberof DefaultApiCreateTask
     */
    readonly createTaskDto: CreateTaskDto
}

/**
 * Request parameters for createTeam operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateTeamRequest
 */
export interface DefaultApiCreateTeamRequest {
    /**
     * 
     * @type {CreateTeamRequest}
     * @memberof DefaultApiCreateTeam
     */
    readonly createTeamRequest: CreateTeamRequest
}

/**
 * Request parameters for createUserFolder operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateUserFolderRequest
 */
export interface DefaultApiCreateUserFolderRequest {
    /**
     * 
     * @type {CreateFolderBody}
     * @memberof DefaultApiCreateUserFolder
     */
    readonly createFolderBody: CreateFolderBody
}

/**
 * Request parameters for createVideoClip operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateVideoClipRequest
 */
export interface DefaultApiCreateVideoClipRequest {
    /**
     * 
     * @type {VideoSegment}
     * @memberof DefaultApiCreateVideoClip
     */
    readonly videoSegment: VideoSegment
}

/**
 * Request parameters for deleteAccountCompanySummary operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteAccountCompanySummaryRequest
 */
export interface DefaultApiDeleteAccountCompanySummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteAccountCompanySummary
     */
    readonly companyId: number
}

/**
 * Request parameters for deleteAutoTrackedBill operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteAutoTrackedBillRequest
 */
export interface DefaultApiDeleteAutoTrackedBillRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteAutoTrackedBill
     */
    readonly billTagId: number
}

/**
 * Request parameters for deleteBillPosition operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteBillPositionRequest
 */
export interface DefaultApiDeleteBillPositionRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteBillPosition
     */
    readonly id: number
}

/**
 * Request parameters for deleteDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteDocumentRequest
 */
export interface DefaultApiDeleteDocumentRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteDocument
     */
    readonly documentId: number
}

/**
 * Request parameters for deleteFile operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteFileRequest
 */
export interface DefaultApiDeleteFileRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteFile
     */
    readonly fileId: number
}

/**
 * Request parameters for deleteFolder operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteFolderRequest
 */
export interface DefaultApiDeleteFolderRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteFolder
     */
    readonly folderId: number
}

/**
 * Request parameters for deleteMemberList operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteMemberListRequest
 */
export interface DefaultApiDeleteMemberListRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteMemberList
     */
    readonly id: number
}

/**
 * Request parameters for deleteRemark operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteRemarkRequest
 */
export interface DefaultApiDeleteRemarkRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteRemark
     */
    readonly remarkId: number
}

/**
 * Request parameters for deleteScheduledReport operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteScheduledReportRequest
 */
export interface DefaultApiDeleteScheduledReportRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteScheduledReport
     */
    readonly scheduledReportId: number
}

/**
 * Request parameters for deleteTag operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteTagRequest
 */
export interface DefaultApiDeleteTagRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteTag
     */
    readonly tagId: number
}

/**
 * Request parameters for deleteUserKeyword operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteUserKeywordRequest
 */
export interface DefaultApiDeleteUserKeywordRequest {
    /**
     * 
     * @type {DeleteUserKeywordBody}
     * @memberof DefaultApiDeleteUserKeyword
     */
    readonly deleteUserKeywordBody: DeleteUserKeywordBody
}

/**
 * Request parameters for disconnectGmailIntegration operation in DefaultApi.
 * @export
 * @interface DefaultApiDisconnectGmailIntegrationRequest
 */
export interface DefaultApiDisconnectGmailIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDisconnectGmailIntegration
     */
    readonly accountId?: number
}

/**
 * Request parameters for disconnectSlackIntegration operation in DefaultApi.
 * @export
 * @interface DefaultApiDisconnectSlackIntegrationRequest
 */
export interface DefaultApiDisconnectSlackIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDisconnectSlackIntegration
     */
    readonly accountId?: number
}

/**
 * Request parameters for downloadAgenda operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadAgendaRequest
 */
export interface DefaultApiDownloadAgendaRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDownloadAgenda
     */
    readonly id: number
}

/**
 * Request parameters for downloadBillDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadBillDocumentRequest
 */
export interface DefaultApiDownloadBillDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadBillDocument
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadBillDocument
     */
    readonly billVersionId: string

    /**
     * 
     * @type {'pdf' | 'html' | 'txt' | 'doc' | 'rtf'}
     * @memberof DefaultApiDownloadBillDocument
     */
    readonly format?: DownloadBillDocumentFormatEnum
}

/**
 * Request parameters for downloadClip operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadClipRequest
 */
export interface DefaultApiDownloadClipRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadClip
     */
    readonly uuid: string
}

/**
 * Request parameters for downloadDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadDocumentRequest
 */
export interface DefaultApiDownloadDocumentRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDownloadDocument
     */
    readonly documentId: number
}

/**
 * Request parameters for downloadFile operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadFileRequest
 */
export interface DefaultApiDownloadFileRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDownloadFile
     */
    readonly fileId: number
}

/**
 * Request parameters for downloadFileByPath operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadFileByPathRequest
 */
export interface DefaultApiDownloadFileByPathRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadFileByPath
     */
    readonly path: string
}

/**
 * Request parameters for downloadLiveActions operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadLiveActionsRequest
 */
export interface DefaultApiDownloadLiveActionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiDownloadLiveActions
     */
    readonly stateCodes?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof DefaultApiDownloadLiveActions
     */
    readonly limit?: number
}

/**
 * Request parameters for downloadSupportingDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadSupportingDocumentRequest
 */
export interface DefaultApiDownloadSupportingDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadSupportingDocument
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiDownloadSupportingDocument
     */
    readonly documentId: number
}

/**
 * Request parameters for emailAiReport operation in DefaultApi.
 * @export
 * @interface DefaultApiEmailAiReportRequest
 */
export interface DefaultApiEmailAiReportRequest {
    /**
     * 
     * @type {EmailAiReportRequest}
     * @memberof DefaultApiEmailAiReport
     */
    readonly emailAiReportRequest: EmailAiReportRequest
}

/**
 * Request parameters for ensureFolderPath operation in DefaultApi.
 * @export
 * @interface DefaultApiEnsureFolderPathRequest
 */
export interface DefaultApiEnsureFolderPathRequest {
    /**
     * 
     * @type {EnsureFolderPathBody}
     * @memberof DefaultApiEnsureFolderPath
     */
    readonly ensureFolderPathBody: EnsureFolderPathBody
}

/**
 * Request parameters for fetchAIReport operation in DefaultApi.
 * @export
 * @interface DefaultApiFetchAIReportRequest
 */
export interface DefaultApiFetchAIReportRequest {
    /**
     * The full URL to the AI report JSON file
     * @type {string}
     * @memberof DefaultApiFetchAIReport
     */
    readonly url: string
}

/**
 * Request parameters for fetchDailyAgenda operation in DefaultApi.
 * @export
 * @interface DefaultApiFetchDailyAgendaRequest
 */
export interface DefaultApiFetchDailyAgendaRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiFetchDailyAgenda
     */
    readonly state: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiFetchDailyAgenda
     */
    readonly chamber: string
}

/**
 * Request parameters for fixCompanySummary operation in DefaultApi.
 * @export
 * @interface DefaultApiFixCompanySummaryRequest
 */
export interface DefaultApiFixCompanySummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiFixCompanySummary
     */
    readonly companyId: number
}

/**
 * Request parameters for forgotPassword operation in DefaultApi.
 * @export
 * @interface DefaultApiForgotPasswordRequest
 */
export interface DefaultApiForgotPasswordRequest {
    /**
     * 
     * @type {ForgotPasswordRequest}
     * @memberof DefaultApiForgotPassword
     */
    readonly forgotPasswordRequest: ForgotPasswordRequest
}

/**
 * Request parameters for forwardBillToLobbyists operation in DefaultApi.
 * @export
 * @interface DefaultApiForwardBillToLobbyistsRequest
 */
export interface DefaultApiForwardBillToLobbyistsRequest {
    /**
     * 
     * @type {ForwardBillToLobbyistRequest}
     * @memberof DefaultApiForwardBillToLobbyists
     */
    readonly forwardBillToLobbyistRequest: ForwardBillToLobbyistRequest
}

/**
 * Request parameters for gatherContext operation in DefaultApi.
 * @export
 * @interface DefaultApiGatherContextRequest
 */
export interface DefaultApiGatherContextRequest {
    /**
     * 
     * @type {ContextQueryRequest}
     * @memberof DefaultApiGatherContext
     */
    readonly contextQueryRequest: ContextQueryRequest
}

/**
 * Request parameters for generateAIReport operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateAIReportRequest
 */
export interface DefaultApiGenerateAIReportRequest {
    /**
     * 
     * @type {AIReportPayload}
     * @memberof DefaultApiGenerateAIReport
     */
    readonly aIReportPayload: AIReportPayload
}

/**
 * Request parameters for generateClipMetadata operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateClipMetadataRequest
 */
export interface DefaultApiGenerateClipMetadataRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGenerateClipMetadata
     */
    readonly videoId: number

    /**
     * 
     * @type {ClipMetadataRequest}
     * @memberof DefaultApiGenerateClipMetadata
     */
    readonly clipMetadataRequest: ClipMetadataRequest
}

/**
 * Request parameters for generateCompanyClip operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateCompanyClipRequest
 */
export interface DefaultApiGenerateCompanyClipRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGenerateCompanyClip
     */
    readonly videoId: number

    /**
     * 
     * @type {GenerateCompanySummaryRequest}
     * @memberof DefaultApiGenerateCompanyClip
     */
    readonly generateCompanySummaryRequest: GenerateCompanySummaryRequest
}

/**
 * Request parameters for generateCompanySummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateCompanySummaryRequest
 */
export interface DefaultApiGenerateCompanySummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGenerateCompanySummary
     */
    readonly videoId: number

    /**
     * 
     * @type {GenerateCompanySummaryRequest}
     * @memberof DefaultApiGenerateCompanySummary
     */
    readonly generateCompanySummaryRequest: GenerateCompanySummaryRequest
}

/**
 * Request parameters for generateExternalAIReport operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateExternalAIReportRequest
 */
export interface DefaultApiGenerateExternalAIReportRequest {
    /**
     * API key for authentication (pass in x-api-key header)
     * @type {string}
     * @memberof DefaultApiGenerateExternalAIReport
     */
    readonly xApiKey: string

    /**
     * 
     * @type {ExternalAIReportRequest}
     * @memberof DefaultApiGenerateExternalAIReport
     */
    readonly externalAIReportRequest: ExternalAIReportRequest
}

/**
 * Request parameters for generateKeywords operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateKeywordsRequest
 */
export interface DefaultApiGenerateKeywordsRequest {
    /**
     * 
     * @type {GenerateKeywordsRequest}
     * @memberof DefaultApiGenerateKeywords
     */
    readonly generateKeywordsRequest: GenerateKeywordsRequest
}

/**
 * Request parameters for generateSegmentSummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateSegmentSummaryRequest
 */
export interface DefaultApiGenerateSegmentSummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGenerateSegmentSummary
     */
    readonly videoId: number

    /**
     * 
     * @type {GenerateSegmentSummaryRequest}
     * @memberof DefaultApiGenerateSegmentSummary
     */
    readonly generateSegmentSummaryRequest: GenerateSegmentSummaryRequest
}

/**
 * Request parameters for generateSubjects operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateSubjectsRequest
 */
export interface DefaultApiGenerateSubjectsRequest {
    /**
     * 
     * @type {GenerateSubjectsRequest}
     * @memberof DefaultApiGenerateSubjects
     */
    readonly generateSubjectsRequest: GenerateSubjectsRequest
}

/**
 * Request parameters for generateTagContext operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateTagContextRequest
 */
export interface DefaultApiGenerateTagContextRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGenerateTagContext
     */
    readonly tagId: number
}

/**
 * Request parameters for generateTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateTagsRequest
 */
export interface DefaultApiGenerateTagsRequest {
    /**
     * 
     * @type {GenerateTagsRequest}
     * @memberof DefaultApiGenerateTags
     */
    readonly generateTagsRequest: GenerateTagsRequest
}

/**
 * Request parameters for generateTagsForCompany operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateTagsForCompanyRequest
 */
export interface DefaultApiGenerateTagsForCompanyRequest {
    /**
     * 
     * @type {GenerateTagsForCompanyRequest}
     * @memberof DefaultApiGenerateTagsForCompany
     */
    readonly generateTagsForCompanyRequest: GenerateTagsForCompanyRequest
}

/**
 * Request parameters for getAccountBillRemarks operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountBillRemarksRequest
 */
export interface DefaultApiGetAccountBillRemarksRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountBillRemarks
     */
    readonly billId: string
}

/**
 * Request parameters for getAccountCompanyClaims operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountCompanyClaimsRequest
 */
export interface DefaultApiGetAccountCompanyClaimsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAccountCompanyClaims
     */
    readonly companyId: number
}

/**
 * Request parameters for getAccountCompanySummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountCompanySummaryRequest
 */
export interface DefaultApiGetAccountCompanySummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAccountCompanySummary
     */
    readonly companyId: number
}

/**
 * Request parameters for getAccountLobbyist operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountLobbyistRequest
 */
export interface DefaultApiGetAccountLobbyistRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAccountLobbyist
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountLobbyist
     */
    readonly state?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAccountLobbyist
     */
    readonly accountId?: number
}

/**
 * Request parameters for getAccountTrackedBills operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountTrackedBillsRequest
 */
export interface DefaultApiGetAccountTrackedBillsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly states?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly sessionKeys?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly activeOnly?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly tagIds?: string

    /**
     * 
     * @type {'AND' | 'OR'}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly tagLogic?: GetAccountTrackedBillsTagLogicEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly trackTypes?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly progressStatuses?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly alertsOnly?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly excludeLobbyistUsers?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly lobbyistUsersOnly?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly jointTracked?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountTrackedBills
     */
    readonly userIds?: string
}

/**
 * Request parameters for getAccountTrackedBillsBulk operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountTrackedBillsBulkRequest
 */
export interface DefaultApiGetAccountTrackedBillsBulkRequest {
    /**
     * 
     * @type {AccountTrackedBillsBulkBody}
     * @memberof DefaultApiGetAccountTrackedBillsBulk
     */
    readonly accountTrackedBillsBulkBody: AccountTrackedBillsBulkBody
}

/**
 * Request parameters for getAccountUsers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountUsersRequest
 */
export interface DefaultApiGetAccountUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAccountUsers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAccountUsers
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountUsers
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for getActivityCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetActivityCountRequest
 */
export interface DefaultApiGetActivityCountRequest {
    /**
     * Either \&#39;user\&#39; (only user\&#39;s tracked bills) or \&#39;account\&#39; (all users in account)
     * @type {'user' | 'account'}
     * @memberof DefaultApiGetActivityCount
     */
    readonly scope?: GetActivityCountScopeEnum

    /**
     * Number of days to look back (default 30)
     * @type {number}
     * @memberof DefaultApiGetActivityCount
     */
    readonly days?: number

    /**
     * The activity type to get count for
     * @type {ActivityType}
     * @memberof DefaultApiGetActivityCount
     */
    readonly activityType?: ActivityType
}

/**
 * Request parameters for getActivityHistory operation in DefaultApi.
 * @export
 * @interface DefaultApiGetActivityHistoryRequest
 */
export interface DefaultApiGetActivityHistoryRequest {
    /**
     * Start date in YYYY-MM-DD format
     * @type {string}
     * @memberof DefaultApiGetActivityHistory
     */
    readonly startDate: string

    /**
     * End date in YYYY-MM-DD format
     * @type {string}
     * @memberof DefaultApiGetActivityHistory
     */
    readonly endDate: string
}

/**
 * Request parameters for getActivityMetrics operation in DefaultApi.
 * @export
 * @interface DefaultApiGetActivityMetricsRequest
 */
export interface DefaultApiGetActivityMetricsRequest {
    /**
     * Optional date in YYYY-MM-DD format. Defaults to today.
     * @type {string}
     * @memberof DefaultApiGetActivityMetrics
     */
    readonly date?: string
}

/**
 * Request parameters for getAdvancedSearch operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAdvancedSearchRequest
 */
export interface DefaultApiGetAdvancedSearchRequest {
    /**
     * 
     * @type {AdvancedSearchRequest}
     * @memberof DefaultApiGetAdvancedSearch
     */
    readonly advancedSearchRequest: AdvancedSearchRequest
}

/**
 * Request parameters for getAdvocateTestimonyById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAdvocateTestimonyByIdRequest
 */
export interface DefaultApiGetAdvocateTestimonyByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAdvocateTestimonyById
     */
    readonly id: number
}

/**
 * Request parameters for getAnalystMetrics operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAnalystMetricsRequest
 */
export interface DefaultApiGetAnalystMetricsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAnalystMetrics
     */
    readonly id: number
}

/**
 * Request parameters for getAutoTrackMatch operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAutoTrackMatchRequest
 */
export interface DefaultApiGetAutoTrackMatchRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAutoTrackMatch
     */
    readonly masterBillId: string
}

/**
 * Request parameters for getAutoTrackMatches operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAutoTrackMatchesRequest
 */
export interface DefaultApiGetAutoTrackMatchesRequest {
    /**
     * 
     * @type {'Accepted' | 'Rejected'}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly outcome?: GetAutoTrackMatchesOutcomeEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly minScore?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly maxScore?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly rejectedStart?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly rejectedEnd?: string

    /**
     * 
     * @type {'low' | 'medium' | 'high'}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly priority?: GetAutoTrackMatchesPriorityEnum

    /**
     * 
     * @type {'low' | 'medium' | 'high'}
     * @memberof DefaultApiGetAutoTrackMatches
     */
    readonly impact?: GetAutoTrackMatchesImpactEnum
}

/**
 * Request parameters for getAutoTrackedBill operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAutoTrackedBillRequest
 */
export interface DefaultApiGetAutoTrackedBillRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAutoTrackedBill
     */
    readonly billId: string

    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetAutoTrackedBill
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAutoTrackedBill
     */
    readonly targetFolderId?: number
}

/**
 * Request parameters for getAutoTrackedBills operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAutoTrackedBillsRequest
 */
export interface DefaultApiGetAutoTrackedBillsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAutoTrackedBills
     */
    readonly sorted?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAutoTrackedBills
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetAutoTrackedBills
     */
    readonly pageSize?: number

    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetAutoTrackedBills
     */
    readonly viewScope?: ViewScope
}

/**
 * Request parameters for getBatchSessions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBatchSessionsRequest
 */
export interface DefaultApiGetBatchSessionsRequest {
    /**
     * 
     * @type {GetBatchSessionsRequest}
     * @memberof DefaultApiGetBatchSessions
     */
    readonly getBatchSessionsRequest: GetBatchSessionsRequest
}

/**
 * Request parameters for getBill operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillRequest
 */
export interface DefaultApiGetBillRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBill
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetBill
     */
    readonly includeAiSummary?: boolean
}

/**
 * Request parameters for getBillAgentStats operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillAgentStatsRequest
 */
export interface DefaultApiGetBillAgentStatsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBillAgentStats
     */
    readonly accountId?: number

    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetBillAgentStats
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetBillAgentStats
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getBillAiSummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillAiSummaryRequest
 */
export interface DefaultApiGetBillAiSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillAiSummary
     */
    readonly id: string
}

/**
 * Request parameters for getBillAlerts operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillAlertsRequest
 */
export interface DefaultApiGetBillAlertsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillAlerts
     */
    readonly billId?: string
}

/**
 * Request parameters for getBillAlertsBulk operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillAlertsBulkRequest
 */
export interface DefaultApiGetBillAlertsBulkRequest {
    /**
     * 
     * @type {BillAlertsBulkBody}
     * @memberof DefaultApiGetBillAlertsBulk
     */
    readonly billAlertsBulkBody: BillAlertsBulkBody
}

/**
 * Request parameters for getBillCalendar operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillCalendarRequest
 */
export interface DefaultApiGetBillCalendarRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillCalendar
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillCalendar
     */
    readonly endDate?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetBillCalendar
     */
    readonly trackedOnly?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiGetBillCalendar
     */
    readonly stateCodes?: Array<string>

    /**
     * 
     * @type {Array<number>}
     * @memberof DefaultApiGetBillCalendar
     */
    readonly clientCompanyIds?: Array<number>
}

/**
 * Request parameters for getBillChatHistory operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillChatHistoryRequest
 */
export interface DefaultApiGetBillChatHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillChatHistory
     */
    readonly billId: string
}

/**
 * Request parameters for getBillComments operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillCommentsRequest
 */
export interface DefaultApiGetBillCommentsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillComments
     */
    readonly id: string
}

/**
 * Request parameters for getBillCompaniesOfInterest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillCompaniesOfInterestRequest
 */
export interface DefaultApiGetBillCompaniesOfInterestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillCompaniesOfInterest
     */
    readonly id: string
}

/**
 * Request parameters for getBillCompanions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillCompanionsRequest
 */
export interface DefaultApiGetBillCompanionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillCompanions
     */
    readonly id: string
}

/**
 * Request parameters for getBillComparison operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillComparisonRequest
 */
export interface DefaultApiGetBillComparisonRequest {
    /**
     * 
     * @type {GetBillComparisonRequest}
     * @memberof DefaultApiGetBillComparison
     */
    readonly getBillComparisonRequest: GetBillComparisonRequest
}

/**
 * Request parameters for getBillComparisonAi operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillComparisonAiRequest
 */
export interface DefaultApiGetBillComparisonAiRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillComparisonAi
     */
    readonly id: string
}

/**
 * Request parameters for getBillContent operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillContentRequest
 */
export interface DefaultApiGetBillContentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillContent
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillContent
     */
    readonly billVersionId?: string
}

/**
 * Request parameters for getBillDownloadUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillDownloadUrlRequest
 */
export interface DefaultApiGetBillDownloadUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillDownloadUrl
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillDownloadUrl
     */
    readonly billVersionId: string

    /**
     * 
     * @type {'pdf' | 'html' | 'txt' | 'doc' | 'rtf'}
     * @memberof DefaultApiGetBillDownloadUrl
     */
    readonly format?: GetBillDownloadUrlFormatEnum
}

/**
 * Request parameters for getBillHistory operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillHistoryRequest
 */
export interface DefaultApiGetBillHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillHistory
     */
    readonly id: string
}

/**
 * Request parameters for getBillNotes operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillNotesRequest
 */
export interface DefaultApiGetBillNotesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillNotes
     */
    readonly billId: string
}

/**
 * Request parameters for getBillPriorityImpact operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillPriorityImpactRequest
 */
export interface DefaultApiGetBillPriorityImpactRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillPriorityImpact
     */
    readonly masterBillId: string
}

/**
 * Request parameters for getBillRemarks operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillRemarksRequest
 */
export interface DefaultApiGetBillRemarksRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillRemarks
     */
    readonly billId: string
}

/**
 * Request parameters for getBillReport operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillReportRequest
 */
export interface DefaultApiGetBillReportRequest {
    /**
     * 
     * @type {AdvancedSearchRequest}
     * @memberof DefaultApiGetBillReport
     */
    readonly advancedSearchRequest: AdvancedSearchRequest
}

/**
 * Request parameters for getBillSimilarAi operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillSimilarAiRequest
 */
export interface DefaultApiGetBillSimilarAiRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillSimilarAi
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillSimilarAi
     */
    readonly state?: string
}

/**
 * Request parameters for getBillStatutes operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillStatutesRequest
 */
export interface DefaultApiGetBillStatutesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillStatutes
     */
    readonly id: string
}

/**
 * Request parameters for getBillSubjects operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillSubjectsRequest
 */
export interface DefaultApiGetBillSubjectsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillSubjects
     */
    readonly id: string
}

/**
 * Request parameters for getBillSupportingDocuments operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillSupportingDocumentsRequest
 */
export interface DefaultApiGetBillSupportingDocumentsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillSupportingDocuments
     */
    readonly id: string
}

/**
 * Request parameters for getBillTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillTagsRequest
 */
export interface DefaultApiGetBillTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillTags
     */
    readonly billId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillTags
     */
    readonly sessionCode: string
}

/**
 * Request parameters for getBillTestimony operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillTestimonyRequest
 */
export interface DefaultApiGetBillTestimonyRequest {
    /**
     * The ID of the bill
     * @type {string}
     * @memberof DefaultApiGetBillTestimony
     */
    readonly masterBillId: string
}

/**
 * Request parameters for getBillText operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillTextRequest
 */
export interface DefaultApiGetBillTextRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillText
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillText
     */
    readonly billVersionId?: string
}

/**
 * Request parameters for getBillVersions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillVersionsRequest
 */
export interface DefaultApiGetBillVersionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillVersions
     */
    readonly id: string
}

/**
 * Request parameters for getBillVotes operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillVotesRequest
 */
export interface DefaultApiGetBillVotesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillVotes
     */
    readonly id: string
}

/**
 * Request parameters for getBills operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillsRequest
 */
export interface DefaultApiGetBillsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBills
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBills
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly stateCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly sessionCode?: string

    /**
     * Array of session codes for multi-session search
     * @type {Array<string>}
     * @memberof DefaultApiGetBills
     */
    readonly sessionCodes?: Array<string>

    /**
     * 
     * @type {Array<number>}
     * @memberof DefaultApiGetBills
     */
    readonly subjects?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiGetBills
     */
    readonly types?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly authorName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly statuteSection?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly statuteCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly dateTo?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiGetBills
     */
    readonly parties?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBills
     */
    readonly textSearch?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBills
     */
    readonly rerankCompanyId?: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetBills
     */
    readonly rerankProgress?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetBills
     */
    readonly onlyCommitteeChairFiled?: boolean
}

/**
 * Request parameters for getBillsWithHistory operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBillsWithHistoryRequest
 */
export interface DefaultApiGetBillsWithHistoryRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetBillsWithHistory
     */
    readonly onlyWithHistory: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetBillsWithHistory
     */
    readonly onlyTrackedTags: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiGetBillsWithHistory
     */
    readonly types?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBillsWithHistory
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBillsWithHistory
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillsWithHistory
     */
    readonly historyDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBillsWithHistory
     */
    readonly historyDateTo?: string
}

/**
 * Request parameters for getCacheStats operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCacheStatsRequest
 */
export interface DefaultApiGetCacheStatsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCacheStats
     */
    readonly xApiKey: string
}

/**
 * Request parameters for getCalendarEvents operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCalendarEventsRequest
 */
export interface DefaultApiGetCalendarEventsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiGetCalendarEvents
     */
    readonly stateCodes?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCalendarEvents
     */
    readonly sessionCode?: string

    /**
     * 
     * @type {Array<number>}
     * @memberof DefaultApiGetCalendarEvents
     */
    readonly eventTypeIds?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCalendarEvents
     */
    readonly includeUserEvents?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCalendarEvents
     */
    readonly includeAccountEvents?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCalendarEvents
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCalendarEvents
     */
    readonly endDate?: string
}

/**
 * Request parameters for getCampaignFinance operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCampaignFinanceRequest
 */
export interface DefaultApiGetCampaignFinanceRequest {
    /**
     * The state code for the state to filter by.
     * @type {string}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly stateCode: string

    /**
     * Page number for pagination
     * @type {number}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly page: number

    /**
     * Number of records per page
     * @type {number}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly limit: number

    /**
     * General search term across multiple fields
     * @type {string}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly search?: string

    /**
     * Filter by filer name
     * @type {string}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly filerName?: string

    /**
     * Filter by contributor organization
     * @type {string}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly contributorOrganization?: string

    /**
     * Filter by contributor first name
     * @type {string}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly contributorFirstName?: string

    /**
     * Filter by contributor last name
     * @type {string}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly contributorLastName?: string

    /**
     * Filter by contributor state
     * @type {string}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly contributorState?: string

    /**
     * Filter by minimum year
     * @type {number}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly year?: number

    /**
     * Filter by minimum contribution amount
     * @type {number}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly minAmount?: number

    /**
     * Filter by maximum contribution amount
     * @type {number}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly maxAmount?: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly isLobbyist?: boolean

    /**
     * Filter by contributions made to members
     * @type {boolean}
     * @memberof DefaultApiGetCampaignFinance
     */
    readonly isMember?: boolean
}

/**
 * Request parameters for getCampaignFinanceFilers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCampaignFinanceFilersRequest
 */
export interface DefaultApiGetCampaignFinanceFilersRequest {
    /**
     * Search term for filer name
     * @type {string}
     * @memberof DefaultApiGetCampaignFinanceFilers
     */
    readonly search?: string

    /**
     * Filter by state
     * @type {string}
     * @memberof DefaultApiGetCampaignFinanceFilers
     */
    readonly state?: string
}

/**
 * Request parameters for getClientBills operation in DefaultApi.
 * @export
 * @interface DefaultApiGetClientBillsRequest
 */
export interface DefaultApiGetClientBillsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetClientBills
     */
    readonly companyId: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetClientBills
     */
    readonly sessionCode?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetClientBills
     */
    readonly includeInactiveSessions?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetClientBills
     */
    readonly includeAutoUnsorted?: boolean
}

/**
 * Request parameters for getClientCommitteeActivity operation in DefaultApi.
 * @export
 * @interface DefaultApiGetClientCommitteeActivityRequest
 */
export interface DefaultApiGetClientCommitteeActivityRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetClientCommitteeActivity
     */
    readonly companyId: number
}

/**
 * Request parameters for getClientContributions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetClientContributionsRequest
 */
export interface DefaultApiGetClientContributionsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetClientContributions
     */
    readonly companyId: number
}

/**
 * Request parameters for getClientDashboard operation in DefaultApi.
 * @export
 * @interface DefaultApiGetClientDashboardRequest
 */
export interface DefaultApiGetClientDashboardRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetClientDashboard
     */
    readonly includeInactive?: boolean
}

/**
 * Request parameters for getClientDetails operation in DefaultApi.
 * @export
 * @interface DefaultApiGetClientDetailsRequest
 */
export interface DefaultApiGetClientDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetClientDetails
     */
    readonly companyId: number
}

/**
 * Request parameters for getClip operation in DefaultApi.
 * @export
 * @interface DefaultApiGetClipRequest
 */
export interface DefaultApiGetClipRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetClip
     */
    readonly uuid: string
}

/**
 * Request parameters for getCluster operation in DefaultApi.
 * @export
 * @interface DefaultApiGetClusterRequest
 */
export interface DefaultApiGetClusterRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCluster
     */
    readonly masterCompanyId: number
}

/**
 * Request parameters for getCombinedCalendarEvents operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCombinedCalendarEventsRequest
 */
export interface DefaultApiGetCombinedCalendarEventsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiGetCombinedCalendarEvents
     */
    readonly stateCodes?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCombinedCalendarEvents
     */
    readonly sessionCode?: string

    /**
     * 
     * @type {Array<number>}
     * @memberof DefaultApiGetCombinedCalendarEvents
     */
    readonly eventTypeIds?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCombinedCalendarEvents
     */
    readonly includeUserEvents?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCombinedCalendarEvents
     */
    readonly includeAccountEvents?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCombinedCalendarEvents
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCombinedCalendarEvents
     */
    readonly endDate?: string
}

/**
 * Request parameters for getCommittee operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeRequest
 */
export interface DefaultApiGetCommitteeRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommittee
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommittee
     */
    readonly sessionCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommittee
     */
    readonly sections?: string
}

/**
 * Request parameters for getCommitteeAgentRecentActivity operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeAgentRecentActivityRequest
 */
export interface DefaultApiGetCommitteeAgentRecentActivityRequest {
    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetCommitteeAgentRecentActivity
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCommitteeAgentRecentActivity
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getCommitteeAgentStats operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeAgentStatsRequest
 */
export interface DefaultApiGetCommitteeAgentStatsRequest {
    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetCommitteeAgentStats
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCommitteeAgentStats
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getCommitteeAlerts operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeAlertsRequest
 */
export interface DefaultApiGetCommitteeAlertsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeAlerts
     */
    readonly committeeId?: number
}

/**
 * Request parameters for getCommitteeAnalysis operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeAnalysisRequest
 */
export interface DefaultApiGetCommitteeAnalysisRequest {
    /**
     * 
     * @type {'low' | 'medium' | 'high'}
     * @memberof DefaultApiGetCommitteeAnalysis
     */
    readonly minPriority?: GetCommitteeAnalysisMinPriorityEnum

    /**
     * 
     * @type {'low' | 'medium' | 'high'}
     * @memberof DefaultApiGetCommitteeAnalysis
     */
    readonly minImpact?: GetCommitteeAnalysisMinImpactEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeAnalysis
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeAnalysis
     */
    readonly limit?: number
}

/**
 * Request parameters for getCommitteeAnalysisById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeAnalysisByIdRequest
 */
export interface DefaultApiGetCommitteeAnalysisByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeAnalysisById
     */
    readonly id: number
}

/**
 * Request parameters for getCommitteeClips operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeClipsRequest
 */
export interface DefaultApiGetCommitteeClipsRequest {
    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetCommitteeClips
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeClips
     */
    readonly limit?: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCommitteeClips
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getCommitteeSummaries operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeSummariesRequest
 */
export interface DefaultApiGetCommitteeSummariesRequest {
    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetCommitteeSummaries
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeSummaries
     */
    readonly limit?: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCommitteeSummaries
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getCommitteeVideo operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeVideoRequest
 */
export interface DefaultApiGetCommitteeVideoRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly stateCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly sessionCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly chamber?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly committee?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly year?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly month?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommitteeVideo
     */
    readonly textSearch?: string
}

/**
 * Request parameters for getCommitteeVideoById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteeVideoByIdRequest
 */
export interface DefaultApiGetCommitteeVideoByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommitteeVideoById
     */
    readonly id: number
}

/**
 * Request parameters for getCommittees operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommitteesRequest
 */
export interface DefaultApiGetCommitteesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommittees
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommittees
     */
    readonly sessionCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommittees
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCommittees
     */
    readonly includeNonSession?: boolean

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommittees
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCommittees
     */
    readonly pageSize?: number
}

/**
 * Request parameters for getCompanies operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompaniesRequest
 */
export interface DefaultApiGetCompaniesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCompanies
     */
    readonly state?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompanies
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompanies
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCompanies
     */
    readonly search?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCompanies
     */
    readonly aiSearch?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCompanies
     */
    readonly sortBy?: string

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DefaultApiGetCompanies
     */
    readonly sortOrder?: GetCompaniesSortOrderEnum
}

/**
 * Request parameters for getCompaniesOfInterest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompaniesOfInterestRequest
 */
export interface DefaultApiGetCompaniesOfInterestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCompaniesOfInterest
     */
    readonly stateCode?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompaniesOfInterest
     */
    readonly limit?: number
}

/**
 * Request parameters for getCompany operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompanyRequest
 */
export interface DefaultApiGetCompanyRequest {
    /**
     * numeric ID of the company
     * @type {number}
     * @memberof DefaultApiGetCompany
     */
    readonly id: number
}

/**
 * Request parameters for getCompanyAnalytics operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompanyAnalyticsRequest
 */
export interface DefaultApiGetCompanyAnalyticsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCompanyAnalytics
     */
    readonly stateCode: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompanyAnalytics
     */
    readonly year?: number
}

/**
 * Request parameters for getCompanyBillsOfInterest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompanyBillsOfInterestRequest
 */
export interface DefaultApiGetCompanyBillsOfInterestRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompanyBillsOfInterest
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCompanyBillsOfInterest
     */
    readonly stateCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCompanyBillsOfInterest
     */
    readonly sessionCode?: string
}

/**
 * Request parameters for getCompanyContributions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompanyContributionsRequest
 */
export interface DefaultApiGetCompanyContributionsRequest {
    /**
     * The ID of the company
     * @type {number}
     * @memberof DefaultApiGetCompanyContributions
     */
    readonly companyId: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompanyContributions
     */
    readonly year?: number
}

/**
 * Request parameters for getCompanyFirmEngagements operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompanyFirmEngagementsRequest
 */
export interface DefaultApiGetCompanyFirmEngagementsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompanyFirmEngagements
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompanyFirmEngagements
     */
    readonly year?: number
}

/**
 * Request parameters for getCompanyStates operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompanyStatesRequest
 */
export interface DefaultApiGetCompanyStatesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetCompanyStates
     */
    readonly id: number
}

/**
 * Request parameters for getCompanyTestimony operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompanyTestimonyRequest
 */
export interface DefaultApiGetCompanyTestimonyRequest {
    /**
     * The ID of the company
     * @type {number}
     * @memberof DefaultApiGetCompanyTestimony
     */
    readonly companyId: number
}

/**
 * Request parameters for getCompanyTickSheet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCompanyTickSheetRequest
 */
export interface DefaultApiGetCompanyTickSheetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCompanyTickSheet
     */
    readonly billId: string
}

/**
 * Request parameters for getConcatenatedParentLevel operation in DefaultApi.
 * @export
 * @interface DefaultApiGetConcatenatedParentLevelRequest
 */
export interface DefaultApiGetConcatenatedParentLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetConcatenatedParentLevel
     */
    readonly id: string
}

/**
 * Request parameters for getDashboard operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDashboardRequest
 */
export interface DefaultApiGetDashboardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDashboard
     */
    readonly state?: string
}

/**
 * Request parameters for getDocuments operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDocumentsRequest
 */
export interface DefaultApiGetDocumentsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetDocuments
     */
    readonly remarkId: number
}

/**
 * Request parameters for getExternalTrackingCounts operation in DefaultApi.
 * @export
 * @interface DefaultApiGetExternalTrackingCountsRequest
 */
export interface DefaultApiGetExternalTrackingCountsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetExternalTrackingCounts
     */
    readonly billIds: string
}

/**
 * Request parameters for getFilesByBill operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFilesByBillRequest
 */
export interface DefaultApiGetFilesByBillRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFilesByBill
     */
    readonly masterBillId: string
}

/**
 * Request parameters for getFirm operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFirmRequest
 */
export interface DefaultApiGetFirmRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetFirm
     */
    readonly id: number
}

/**
 * Request parameters for getFirmAnalytics operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFirmAnalyticsRequest
 */
export interface DefaultApiGetFirmAnalyticsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFirmAnalytics
     */
    readonly stateCode: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetFirmAnalytics
     */
    readonly year?: number
}

/**
 * Request parameters for getFirmEngagements operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFirmEngagementsRequest
 */
export interface DefaultApiGetFirmEngagementsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetFirmEngagements
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetFirmEngagements
     */
    readonly year?: number
}

/**
 * Request parameters for getFirms operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFirmsRequest
 */
export interface DefaultApiGetFirmsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFirms
     */
    readonly stateCode?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetFirms
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetFirms
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFirms
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFirms
     */
    readonly sortBy?: string

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DefaultApiGetFirms
     */
    readonly sortOrder?: GetFirmsSortOrderEnum
}

/**
 * Request parameters for getGmailIntegration operation in DefaultApi.
 * @export
 * @interface DefaultApiGetGmailIntegrationRequest
 */
export interface DefaultApiGetGmailIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetGmailIntegration
     */
    readonly accountId?: number
}

/**
 * Request parameters for getGmailOAuthUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetGmailOAuthUrlRequest
 */
export interface DefaultApiGetGmailOAuthUrlRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetGmailOAuthUrl
     */
    readonly accountId?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGmailOAuthUrl
     */
    readonly redirectUri?: string
}

/**
 * Request parameters for getIssue operation in DefaultApi.
 * @export
 * @interface DefaultApiGetIssueRequest
 */
export interface DefaultApiGetIssueRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetIssue
     */
    readonly id: number
}

/**
 * Request parameters for getIssues operation in DefaultApi.
 * @export
 * @interface DefaultApiGetIssuesRequest
 */
export interface DefaultApiGetIssuesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIssues
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIssues
     */
    readonly issueType?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIssues
     */
    readonly priority?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetIssues
     */
    readonly limit?: number
}

/**
 * Request parameters for getKeywordClips operation in DefaultApi.
 * @export
 * @interface DefaultApiGetKeywordClipsRequest
 */
export interface DefaultApiGetKeywordClipsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetKeywordClips
     */
    readonly limit?: number
}

/**
 * Request parameters for getKeywordGenerationStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiGetKeywordGenerationStatusRequest
 */
export interface DefaultApiGetKeywordGenerationStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetKeywordGenerationStatus
     */
    readonly companyId: number
}

/**
 * Request parameters for getLatestBillContent operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLatestBillContentRequest
 */
export interface DefaultApiGetLatestBillContentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLatestBillContent
     */
    readonly billId: string
}

/**
 * Request parameters for getLatestMatch operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLatestMatchRequest
 */
export interface DefaultApiGetLatestMatchRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLatestMatch
     */
    readonly accountId?: number

    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetLatestMatch
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetLatestMatch
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getLegislators operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLegislatorsRequest
 */
export interface DefaultApiGetLegislatorsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLegislators
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLegislators
     */
    readonly sessionCode: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLegislators
     */
    readonly accountId?: number
}

/**
 * Request parameters for getLiveActions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLiveActionsRequest
 */
export interface DefaultApiGetLiveActionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiGetLiveActions
     */
    readonly stateCodes?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLiveActions
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLiveActions
     */
    readonly offset?: number
}

/**
 * Request parameters for getLobbyEngagements operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyEngagementsRequest
 */
export interface DefaultApiGetLobbyEngagementsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyEngagements
     */
    readonly lobbyistId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyEngagements
     */
    readonly companyId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyEngagements
     */
    readonly masterCompanyId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyEngagements
     */
    readonly year?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLobbyEngagements
     */
    readonly companySearch?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLobbyEngagements
     */
    readonly stateCode?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyEngagements
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyEngagements
     */
    readonly limit?: number
}

/**
 * Request parameters for getLobbyist operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyistRequest
 */
export interface DefaultApiGetLobbyistRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyist
     */
    readonly id: number
}

/**
 * Request parameters for getLobbyistAlerts operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyistAlertsRequest
 */
export interface DefaultApiGetLobbyistAlertsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLobbyistAlerts
     */
    readonly lobbyistId?: string
}

/**
 * Request parameters for getLobbyistAnalytics operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyistAnalyticsRequest
 */
export interface DefaultApiGetLobbyistAnalyticsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLobbyistAnalytics
     */
    readonly stateCode: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyistAnalytics
     */
    readonly year?: number
}

/**
 * Request parameters for getLobbyistClients operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyistClientsRequest
 */
export interface DefaultApiGetLobbyistClientsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyistClients
     */
    readonly id: number
}

/**
 * Request parameters for getLobbyistContributions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyistContributionsRequest
 */
export interface DefaultApiGetLobbyistContributionsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyistContributions
     */
    readonly lobbyistId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyistContributions
     */
    readonly companyId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyistContributions
     */
    readonly year?: number
}

/**
 * Request parameters for getLobbyistTestimony operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyistTestimonyRequest
 */
export interface DefaultApiGetLobbyistTestimonyRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyistTestimony
     */
    readonly lobbyistId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyistTestimony
     */
    readonly companyId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyistTestimony
     */
    readonly year?: number
}

/**
 * Request parameters for getLobbyists operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyistsRequest
 */
export interface DefaultApiGetLobbyistsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLobbyists
     */
    readonly stateCode?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyists
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetLobbyists
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLobbyists
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLobbyists
     */
    readonly sortBy?: string

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof DefaultApiGetLobbyists
     */
    readonly sortOrder?: GetLobbyistsSortOrderEnum
}

/**
 * Request parameters for getLobbyistsByState operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLobbyistsByStateRequest
 */
export interface DefaultApiGetLobbyistsByStateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLobbyistsByState
     */
    readonly stateCode?: string
}

/**
 * Request parameters for getMemberById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberByIdRequest
 */
export interface DefaultApiGetMemberByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetMemberById
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberById
     */
    readonly sessionCode: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetMemberById
     */
    readonly includeAuthoredBills?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetMemberById
     */
    readonly includePassedBills?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetMemberById
     */
    readonly includeSponsoredBills?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetMemberById
     */
    readonly includeCoSponsors?: boolean
}

/**
 * Request parameters for getMemberCoSponsors operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberCoSponsorsRequest
 */
export interface DefaultApiGetMemberCoSponsorsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetMemberCoSponsors
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberCoSponsors
     */
    readonly sessionCode: string
}

/**
 * Request parameters for getMemberContactsBatch operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberContactsBatchRequest
 */
export interface DefaultApiGetMemberContactsBatchRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberContactsBatch
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberContactsBatch
     */
    readonly sessionCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberContactsBatch
     */
    readonly chamber?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberContactsBatch
     */
    readonly memberIds?: string
}

/**
 * Request parameters for getMemberDemographics operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberDemographicsRequest
 */
export interface DefaultApiGetMemberDemographicsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetMemberDemographics
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberDemographics
     */
    readonly sessionCode: string
}

/**
 * Request parameters for getMemberFilters operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberFiltersRequest
 */
export interface DefaultApiGetMemberFiltersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberFilters
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberFilters
     */
    readonly sessionCode: string
}

/**
 * Request parameters for getMemberImage operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberImageRequest
 */
export interface DefaultApiGetMemberImageRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetMemberImage
     */
    readonly memberId: number
}

/**
 * Request parameters for getMemberImage_2 operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberImage0Request
 */
export interface DefaultApiGetMemberImage0Request {
    /**
     * Member ID
     * @type {number}
     * @memberof DefaultApiGetMemberImage0
     */
    readonly id: number

    /**
     * File extension (default: jpg)
     * @type {string}
     * @memberof DefaultApiGetMemberImage0
     */
    readonly ext?: string
}

/**
 * Request parameters for getMemberImagesBulk operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberImagesBulkRequest
 */
export interface DefaultApiGetMemberImagesBulkRequest {
    /**
     * 
     * @type {MemberImagesBulkBody}
     * @memberof DefaultApiGetMemberImagesBulk
     */
    readonly memberImagesBulkBody: MemberImagesBulkBody
}

/**
 * Request parameters for getMemberLeaderboards operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberLeaderboardsRequest
 */
export interface DefaultApiGetMemberLeaderboardsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberLeaderboards
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberLeaderboards
     */
    readonly currentSessionCode?: string
}

/**
 * Request parameters for getMemberList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberListRequest
 */
export interface DefaultApiGetMemberListRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetMemberList
     */
    readonly id: number
}

/**
 * Request parameters for getMemberLists operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberListsRequest
 */
export interface DefaultApiGetMemberListsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberLists
     */
    readonly stateCode?: string
}

/**
 * Request parameters for getMemberPublicContributions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberPublicContributionsRequest
 */
export interface DefaultApiGetMemberPublicContributionsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetMemberPublicContributions
     */
    readonly memberId: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberPublicContributions
     */
    readonly stateCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberPublicContributions
     */
    readonly sessionCode?: string
}

/**
 * Request parameters for getMemberRelationships operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberRelationshipsRequest
 */
export interface DefaultApiGetMemberRelationshipsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetMemberRelationships
     */
    readonly memberId: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetMemberRelationships
     */
    readonly accountId?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberRelationships
     */
    readonly stateCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberRelationships
     */
    readonly sessionCode?: string
}

/**
 * Request parameters for getMemberTickSheet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMemberTickSheetRequest
 */
export interface DefaultApiGetMemberTickSheetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMemberTickSheet
     */
    readonly billId: string

    /**
     * 
     * @type {Chamber}
     * @memberof DefaultApiGetMemberTickSheet
     */
    readonly chamber?: Chamber
}

/**
 * Request parameters for getMembers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMembersRequest
 */
export interface DefaultApiGetMembersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMembers
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMembers
     */
    readonly sessionCode: string

    /**
     * Page number (starts from 1)
     * @type {number}
     * @memberof DefaultApiGetMembers
     */
    readonly page?: number

    /**
     * Number of items per page
     * @type {number}
     * @memberof DefaultApiGetMembers
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMembers
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMembers
     */
    readonly chamber?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMembers
     */
    readonly party?: string
}

/**
 * Request parameters for getPendingRegistration operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPendingRegistrationRequest
 */
export interface DefaultApiGetPendingRegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPendingRegistration
     */
    readonly sessionId: string
}

/**
 * Request parameters for getPersonalBillRemarks operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPersonalBillRemarksRequest
 */
export interface DefaultApiGetPersonalBillRemarksRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPersonalBillRemarks
     */
    readonly billId: string
}

/**
 * Request parameters for getPopulateAdvancedFilters operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPopulateAdvancedFiltersRequest
 */
export interface DefaultApiGetPopulateAdvancedFiltersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPopulateAdvancedFilters
     */
    readonly state: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPopulateAdvancedFilters
     */
    readonly session: string
}

/**
 * Request parameters for getPriorityBills operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPriorityBillsRequest
 */
export interface DefaultApiGetPriorityBillsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetPriorityBills
     */
    readonly accountId?: number

    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetPriorityBills
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetPriorityBills
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getRecentActivity operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRecentActivityRequest
 */
export interface DefaultApiGetRecentActivityRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRecentActivity
     */
    readonly accountId?: number

    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetRecentActivity
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetRecentActivity
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getRecentAnalysis operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRecentAnalysisRequest
 */
export interface DefaultApiGetRecentAnalysisRequest {
    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetRecentAnalysis
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRecentAnalysis
     */
    readonly limit?: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetRecentAnalysis
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getRecentCommitteeAnalysis operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRecentCommitteeAnalysisRequest
 */
export interface DefaultApiGetRecentCommitteeAnalysisRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRecentCommitteeAnalysis
     */
    readonly limit?: number
}

/**
 * Request parameters for getRegById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRegByIdRequest
 */
export interface DefaultApiGetRegByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegById
     */
    readonly id: string
}

/**
 * Request parameters for getRegCompaniesOfInterest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRegCompaniesOfInterestRequest
 */
export interface DefaultApiGetRegCompaniesOfInterestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegCompaniesOfInterest
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegCompaniesOfInterest
     */
    readonly stateCode: string
}

/**
 * Request parameters for getRegHierarchyItems operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRegHierarchyItemsRequest
 */
export interface DefaultApiGetRegHierarchyItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly state: string

    /**
     * 
     * @type {RegHierarchyField}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly level: RegHierarchyField

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly level1?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly level2?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly level3?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly level4?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly level5?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly level6?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyItems
     */
    readonly level7?: string
}

/**
 * Request parameters for getRegHierarchyRegs operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRegHierarchyRegsRequest
 */
export interface DefaultApiGetRegHierarchyRegsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly state: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly level1?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly level2?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly level3?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly level4?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly level5?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly level6?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyRegs
     */
    readonly level7?: string
}

/**
 * Request parameters for getRegHierarchyStructure operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRegHierarchyStructureRequest
 */
export interface DefaultApiGetRegHierarchyStructureRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRegHierarchyStructure
     */
    readonly state: string
}

/**
 * Request parameters for getRelatedBillsByStatute operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRelatedBillsByStatuteRequest
 */
export interface DefaultApiGetRelatedBillsByStatuteRequest {
    /**
     * The statutory code
     * @type {string}
     * @memberof DefaultApiGetRelatedBillsByStatute
     */
    readonly statutoryCode: string

    /**
     * The statutory reference
     * @type {string}
     * @memberof DefaultApiGetRelatedBillsByStatute
     */
    readonly reference: string

    /**
     * The state code
     * @type {string}
     * @memberof DefaultApiGetRelatedBillsByStatute
     */
    readonly stateCode: string

    /**
     * The session code
     * @type {string}
     * @memberof DefaultApiGetRelatedBillsByStatute
     */
    readonly sessionCode: string
}

/**
 * Request parameters for getReportContactList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetReportContactListRequest
 */
export interface DefaultApiGetReportContactListRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetReportContactList
     */
    readonly id: number
}

/**
 * Request parameters for getSavedTickSheets operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSavedTickSheetsRequest
 */
export interface DefaultApiGetSavedTickSheetsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSavedTickSheets
     */
    readonly billId: string

    /**
     * 
     * @type {Chamber}
     * @memberof DefaultApiGetSavedTickSheets
     */
    readonly chamber?: Chamber
}

/**
 * Request parameters for getSavedTickSheets_3 operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSavedTickSheets0Request
 */
export interface DefaultApiGetSavedTickSheets0Request {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSavedTickSheets0
     */
    readonly billId: string
}

/**
 * Request parameters for getSectionTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSectionTagsRequest
 */
export interface DefaultApiGetSectionTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSectionTags
     */
    readonly sectionId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSectionTags
     */
    readonly sessionCode: string
}

/**
 * Request parameters for getSessions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSessionsRequest
 */
export interface DefaultApiGetSessionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSessions
     */
    readonly stateCode?: string
}

/**
 * Request parameters for getSharedTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSharedTagsRequest
 */
export interface DefaultApiGetSharedTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSharedTags
     */
    readonly state?: string
}

/**
 * Request parameters for getSlackIntegration operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackIntegrationRequest
 */
export interface DefaultApiGetSlackIntegrationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetSlackIntegration
     */
    readonly accountId?: number
}

/**
 * Request parameters for getStaff operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStaffRequest
 */
export interface DefaultApiGetStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStaff
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStaff
     */
    readonly sessionCode: string

    /**
     * Optional filter for a specific member ID
     * @type {number}
     * @memberof DefaultApiGetStaff
     */
    readonly memberId?: number

    /**
     * Optional filter for staff position/title
     * @type {string}
     * @memberof DefaultApiGetStaff
     */
    readonly position?: string

    /**
     * Page number (starts from 1)
     * @type {number}
     * @memberof DefaultApiGetStaff
     */
    readonly page?: number

    /**
     * Number of items per page
     * @type {number}
     * @memberof DefaultApiGetStaff
     */
    readonly pageSize?: number

    /**
     * Optional search across first/last name, title, email, phone
     * @type {string}
     * @memberof DefaultApiGetStaff
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for getStakeholderMeetings operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStakeholderMeetingsRequest
 */
export interface DefaultApiGetStakeholderMeetingsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetStakeholderMeetings
     */
    readonly stakeholderId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetStakeholderMeetings
     */
    readonly accountId?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStakeholderMeetings
     */
    readonly masterBillId?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetStakeholderMeetings
     */
    readonly companyId?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStakeholderMeetings
     */
    readonly meetingType?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStakeholderMeetings
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStakeholderMeetings
     */
    readonly endDate?: string
}

/**
 * Request parameters for getStateMembers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStateMembersRequest
 */
export interface DefaultApiGetStateMembersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStateMembers
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStateMembers
     */
    readonly searchTerm?: string

    /**
     * Page number (starts from 1)
     * @type {number}
     * @memberof DefaultApiGetStateMembers
     */
    readonly page?: number

    /**
     * Number of items per page
     * @type {number}
     * @memberof DefaultApiGetStateMembers
     */
    readonly pageSize?: number
}

/**
 * Request parameters for getStats operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStatsRequest
 */
export interface DefaultApiGetStatsRequest {
    /**
     * 
     * @type {'account' | 'user'}
     * @memberof DefaultApiGetStats
     */
    readonly scope?: GetStatsScopeEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStats
     */
    readonly stateCode?: string
}

/**
 * Request parameters for getStatuteBlobUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStatuteBlobUrlRequest
 */
export interface DefaultApiGetStatuteBlobUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteBlobUrl
     */
    readonly id: string
}

/**
 * Request parameters for getStatuteById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStatuteByIdRequest
 */
export interface DefaultApiGetStatuteByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteById
     */
    readonly id: string
}

/**
 * Request parameters for getStatuteCompaniesOfInterest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStatuteCompaniesOfInterestRequest
 */
export interface DefaultApiGetStatuteCompaniesOfInterestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteCompaniesOfInterest
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteCompaniesOfInterest
     */
    readonly stateCode: string
}

/**
 * Request parameters for getStatuteHierarchyItems operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStatuteHierarchyItemsRequest
 */
export interface DefaultApiGetStatuteHierarchyItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly state: string

    /**
     * 
     * @type {StatuteHierarchyField}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly level: StatuteHierarchyField

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly code?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly title?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly subtitle?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly article?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly chapter?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly subchapter?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly section?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyItems
     */
    readonly subsection?: string
}

/**
 * Request parameters for getStatuteHierarchyStatutes operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStatuteHierarchyStatutesRequest
 */
export interface DefaultApiGetStatuteHierarchyStatutesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly state: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly code?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly title?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly subtitle?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly article?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly chapter?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly subchapter?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly section?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStatutes
     */
    readonly subsection?: string
}

/**
 * Request parameters for getStatuteHierarchyStructure operation in DefaultApi.
 * @export
 * @interface DefaultApiGetStatuteHierarchyStructureRequest
 */
export interface DefaultApiGetStatuteHierarchyStructureRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetStatuteHierarchyStructure
     */
    readonly state: string
}

/**
 * Request parameters for getSubjects operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSubjectsRequest
 */
export interface DefaultApiGetSubjectsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSubjects
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSubjects
     */
    readonly sessionCode: string
}

/**
 * Request parameters for getTask operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTaskRequest
 */
export interface DefaultApiGetTaskRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTask
     */
    readonly id: number
}

/**
 * Request parameters for getTaskFiles operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTaskFilesRequest
 */
export interface DefaultApiGetTaskFilesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTaskFiles
     */
    readonly taskId: number
}

/**
 * Request parameters for getTaskNotes operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTaskNotesRequest
 */
export interface DefaultApiGetTaskNotesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTaskNotes
     */
    readonly taskId: number
}

/**
 * Request parameters for getTasks operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTasksRequest
 */
export interface DefaultApiGetTasksRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTasks
     */
    readonly userId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTasks
     */
    readonly teamId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTasks
     */
    readonly limit?: number
}

/**
 * Request parameters for getTeam operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamRequest
 */
export interface DefaultApiGetTeamRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTeam
     */
    readonly id: number
}

/**
 * Request parameters for getTeams operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsRequest
 */
export interface DefaultApiGetTeamsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTeams
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTeams
     */
    readonly pageSize?: number
}

/**
 * Request parameters for getTickSheetById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTickSheetByIdRequest
 */
export interface DefaultApiGetTickSheetByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTickSheetById
     */
    readonly billId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTickSheetById
     */
    readonly tickSheetId: number
}

/**
 * Request parameters for getTickSheetById_4 operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTickSheetById0Request
 */
export interface DefaultApiGetTickSheetById0Request {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTickSheetById0
     */
    readonly billId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTickSheetById0
     */
    readonly tickSheetId: number
}

/**
 * Request parameters for getTrackList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrackListRequest
 */
export interface DefaultApiGetTrackListRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTrackList
     */
    readonly trackListId: number
}

/**
 * Request parameters for getTrackedBillActivity operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrackedBillActivityRequest
 */
export interface DefaultApiGetTrackedBillActivityRequest {
    /**
     * Either \&#39;user\&#39; (only user\&#39;s tracked bills) or \&#39;account\&#39; (all users in account)
     * @type {'user' | 'account'}
     * @memberof DefaultApiGetTrackedBillActivity
     */
    readonly scope?: GetTrackedBillActivityScopeEnum

    /**
     * Number of days to look back (default 30)
     * @type {number}
     * @memberof DefaultApiGetTrackedBillActivity
     */
    readonly days?: number

    /**
     * Page number
     * @type {number}
     * @memberof DefaultApiGetTrackedBillActivity
     */
    readonly page?: number

    /**
     * Items per page
     * @type {number}
     * @memberof DefaultApiGetTrackedBillActivity
     */
    readonly pageSize?: number

    /**
     * Filter activity by category (all, progress, text, votes)
     * @type {ActivityType}
     * @memberof DefaultApiGetTrackedBillActivity
     */
    readonly activityType?: ActivityType
}

/**
 * Request parameters for getTrackedBillProgress operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrackedBillProgressRequest
 */
export interface DefaultApiGetTrackedBillProgressRequest {
    /**
     * 
     * @type {'account' | 'user'}
     * @memberof DefaultApiGetTrackedBillProgress
     */
    readonly scope?: GetTrackedBillProgressScopeEnum
}

/**
 * Request parameters for getTrackedBills operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrackedBillsRequest
 */
export interface DefaultApiGetTrackedBillsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly states?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly sessionKeys?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly activeOnly?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly tagIds?: string

    /**
     * 
     * @type {'AND' | 'OR'}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly tagLogic?: GetTrackedBillsTagLogicEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly trackTypes?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly progressStatuses?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly alertsOnly?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly excludeLobbyistUsers?: boolean

    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetTrackedBills
     */
    readonly viewScope?: ViewScope
}

/**
 * Request parameters for getTrackedLiveActions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrackedLiveActionsRequest
 */
export interface DefaultApiGetTrackedLiveActionsRequest {
    /**
     * 
     * @type {'user' | 'account'}
     * @memberof DefaultApiGetTrackedLiveActions
     */
    readonly scope?: GetTrackedLiveActionsScopeEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTrackedLiveActions
     */
    readonly days?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTrackedLiveActions
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTrackedLiveActions
     */
    readonly pageSize?: number
}

/**
 * Request parameters for getTrackedLiveActionsCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrackedLiveActionsCountRequest
 */
export interface DefaultApiGetTrackedLiveActionsCountRequest {
    /**
     * 
     * @type {'user' | 'account'}
     * @memberof DefaultApiGetTrackedLiveActionsCount
     */
    readonly scope?: GetTrackedLiveActionsCountScopeEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTrackedLiveActionsCount
     */
    readonly days?: number
}

/**
 * Request parameters for getTrackingActivityReport operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrackingActivityReportRequest
 */
export interface DefaultApiGetTrackingActivityReportRequest {
    /**
     * 
     * @type {AdvancedSearchRequest}
     * @memberof DefaultApiGetTrackingActivityReport
     */
    readonly advancedSearchRequest: AdvancedSearchRequest
}

/**
 * Request parameters for getUpcomingHearings operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUpcomingHearingsRequest
 */
export interface DefaultApiGetUpcomingHearingsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUpcomingHearings
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUpcomingHearings
     */
    readonly sessionCode?: string
}

/**
 * Request parameters for getUpcomingHearings_5 operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUpcomingHearings0Request
 */
export interface DefaultApiGetUpcomingHearings0Request {
    /**
     * 
     * @type {ViewScope}
     * @memberof DefaultApiGetUpcomingHearings0
     */
    readonly viewScope?: ViewScope

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUpcomingHearings0
     */
    readonly limit?: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetUpcomingHearings0
     */
    readonly sortedOnly?: boolean
}

/**
 * Request parameters for getUser operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserRequest
 */
export interface DefaultApiGetUserRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUser
     */
    readonly id: number
}

/**
 * Request parameters for getUserAutoTrackStates operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserAutoTrackStatesRequest
 */
export interface DefaultApiGetUserAutoTrackStatesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserAutoTrackStates
     */
    readonly userId: number
}

/**
 * Request parameters for getUserFiles operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserFilesRequest
 */
export interface DefaultApiGetUserFilesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserFiles
     */
    readonly folderId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserFiles
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserFiles
     */
    readonly limit?: number
}

/**
 * Request parameters for getUserTaskMetrics operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserTaskMetricsRequest
 */
export interface DefaultApiGetUserTaskMetricsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserTaskMetrics
     */
    readonly userId: number
}

/**
 * Request parameters for getUserTrackedActivity operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserTrackedActivityRequest
 */
export interface DefaultApiGetUserTrackedActivityRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserTrackedActivity
     */
    readonly userId: number
}

/**
 * Request parameters for getUserTrackedBillCalendar operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserTrackedBillCalendarRequest
 */
export interface DefaultApiGetUserTrackedBillCalendarRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserTrackedBillCalendar
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserTrackedBillCalendar
     */
    readonly endDate?: string
}

/**
 * Request parameters for getUsers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUsersRequest
 */
export interface DefaultApiGetUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUsers
     */
    readonly roleName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUsers
     */
    readonly stateCode?: string
}

/**
 * Request parameters for getValidYears operation in DefaultApi.
 * @export
 * @interface DefaultApiGetValidYearsRequest
 */
export interface DefaultApiGetValidYearsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetValidYears
     */
    readonly lobbyistId?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetValidYears
     */
    readonly companyId?: number

    /**
     * 
     * @type {'engagements' | 'contributions' | 'testimony'}
     * @memberof DefaultApiGetValidYears
     */
    readonly type?: GetValidYearsTypeEnum
}

/**
 * Request parameters for getVideoClips operation in DefaultApi.
 * @export
 * @interface DefaultApiGetVideoClipsRequest
 */
export interface DefaultApiGetVideoClipsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetVideoClips
     */
    readonly videoId: number
}

/**
 * Request parameters for getVideoSummaries operation in DefaultApi.
 * @export
 * @interface DefaultApiGetVideoSummariesRequest
 */
export interface DefaultApiGetVideoSummariesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetVideoSummaries
     */
    readonly videoId: number
}

/**
 * Request parameters for getVoteDetails operation in DefaultApi.
 * @export
 * @interface DefaultApiGetVoteDetailsRequest
 */
export interface DefaultApiGetVoteDetailsRequest {
    /**
     * The ID of the vote to fetch details for.
     * @type {number}
     * @memberof DefaultApiGetVoteDetails
     */
    readonly voteId: number
}

/**
 * Request parameters for getVoteReport operation in DefaultApi.
 * @export
 * @interface DefaultApiGetVoteReportRequest
 */
export interface DefaultApiGetVoteReportRequest {
    /**
     * 
     * @type {VoteReportRequest}
     * @memberof DefaultApiGetVoteReport
     */
    readonly voteReportRequest: VoteReportRequest
}

/**
 * Request parameters for importReportContacts operation in DefaultApi.
 * @export
 * @interface DefaultApiImportReportContactsRequest
 */
export interface DefaultApiImportReportContactsRequest {
    /**
     * 
     * @type {ImportReportContactsRequest}
     * @memberof DefaultApiImportReportContacts
     */
    readonly importReportContactsRequest: ImportReportContactsRequest
}

/**
 * Request parameters for inviteAnalyst operation in DefaultApi.
 * @export
 * @interface DefaultApiInviteAnalystRequest
 */
export interface DefaultApiInviteAnalystRequest {
    /**
     * 
     * @type {InviteUserRequest}
     * @memberof DefaultApiInviteAnalyst
     */
    readonly inviteUserRequest: InviteUserRequest
}

/**
 * Request parameters for inviteFullAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiInviteFullAccountRequest
 */
export interface DefaultApiInviteFullAccountRequest {
    /**
     * 
     * @type {InviteUserRequest}
     * @memberof DefaultApiInviteFullAccount
     */
    readonly inviteUserRequest: InviteUserRequest
}

/**
 * Request parameters for isSessionActive operation in DefaultApi.
 * @export
 * @interface DefaultApiIsSessionActiveRequest
 */
export interface DefaultApiIsSessionActiveRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiIsSessionActive
     */
    readonly stateCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiIsSessionActive
     */
    readonly sessionCode: string
}

/**
 * Request parameters for listBillPositions operation in DefaultApi.
 * @export
 * @interface DefaultApiListBillPositionsRequest
 */
export interface DefaultApiListBillPositionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiListBillPositions
     */
    readonly billId?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListBillPositions
     */
    readonly tagId?: number
}

/**
 * Request parameters for logInteraction operation in DefaultApi.
 * @export
 * @interface DefaultApiLogInteractionRequest
 */
export interface DefaultApiLogInteractionRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiLogInteraction
     */
    readonly companyId: number

    /**
     * 
     * @type {InteractionPayload}
     * @memberof DefaultApiLogInteraction
     */
    readonly interactionPayload: InteractionPayload
}

/**
 * Request parameters for login operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginRequest
 */
export interface DefaultApiLoginRequest {
    /**
     * 
     * @type {LoginRequest}
     * @memberof DefaultApiLogin
     */
    readonly loginRequest: LoginRequest
}

/**
 * Request parameters for markAsRead operation in DefaultApi.
 * @export
 * @interface DefaultApiMarkAsReadRequest
 */
export interface DefaultApiMarkAsReadRequest {
    /**
     * 
     * @type {MarkAsReadRequest}
     * @memberof DefaultApiMarkAsRead
     */
    readonly markAsReadRequest: MarkAsReadRequest
}

/**
 * Request parameters for moveFile operation in DefaultApi.
 * @export
 * @interface DefaultApiMoveFileRequest
 */
export interface DefaultApiMoveFileRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiMoveFile
     */
    readonly fileId: number

    /**
     * 
     * @type {MoveFileRequest}
     * @memberof DefaultApiMoveFile
     */
    readonly moveFileRequest: MoveFileRequest
}

/**
 * Request parameters for peelCompanies operation in DefaultApi.
 * @export
 * @interface DefaultApiPeelCompaniesRequest
 */
export interface DefaultApiPeelCompaniesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiPeelCompanies
     */
    readonly masterCompanyId: number

    /**
     * 
     * @type {PeelClusterBody}
     * @memberof DefaultApiPeelCompanies
     */
    readonly peelClusterBody: PeelClusterBody
}

/**
 * Request parameters for purchaseSeats operation in DefaultApi.
 * @export
 * @interface DefaultApiPurchaseSeatsRequest
 */
export interface DefaultApiPurchaseSeatsRequest {
    /**
     * 
     * @type {PurchaseSeatsRequest}
     * @memberof DefaultApiPurchaseSeats
     */
    readonly purchaseSeatsRequest: PurchaseSeatsRequest
}

/**
 * Request parameters for queryAiChat operation in DefaultApi.
 * @export
 * @interface DefaultApiQueryAiChatRequest
 */
export interface DefaultApiQueryAiChatRequest {
    /**
     * 
     * @type {ChatRequest}
     * @memberof DefaultApiQueryAiChat
     */
    readonly chatRequest: ChatRequest
}

/**
 * Request parameters for queryVideoChat operation in DefaultApi.
 * @export
 * @interface DefaultApiQueryVideoChatRequest
 */
export interface DefaultApiQueryVideoChatRequest {
    /**
     * 
     * @type {VideoQuestionRequest}
     * @memberof DefaultApiQueryVideoChat
     */
    readonly videoQuestionRequest: VideoQuestionRequest
}

/**
 * Request parameters for queueKeywordGeneration operation in DefaultApi.
 * @export
 * @interface DefaultApiQueueKeywordGenerationRequest
 */
export interface DefaultApiQueueKeywordGenerationRequest {
    /**
     * 
     * @type {QueueKeywordGenerationRequest}
     * @memberof DefaultApiQueueKeywordGeneration
     */
    readonly queueKeywordGenerationRequest: QueueKeywordGenerationRequest
}

/**
 * Request parameters for register operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterRequest
 */
export interface DefaultApiRegisterRequest {
    /**
     * 
     * @type {InsertUser}
     * @memberof DefaultApiRegister
     */
    readonly insertUser: InsertUser
}

/**
 * Request parameters for rejectAutoTrackedBill operation in DefaultApi.
 * @export
 * @interface DefaultApiRejectAutoTrackedBillRequest
 */
export interface DefaultApiRejectAutoTrackedBillRequest {
    /**
     * 
     * @type {RejectAutoTrackedBillBody}
     * @memberof DefaultApiRejectAutoTrackedBill
     */
    readonly rejectAutoTrackedBillBody: RejectAutoTrackedBillBody

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiRejectAutoTrackedBill
     */
    readonly bypassAccessCheck?: boolean
}

/**
 * Request parameters for removeTeamMember operation in DefaultApi.
 * @export
 * @interface DefaultApiRemoveTeamMemberRequest
 */
export interface DefaultApiRemoveTeamMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRemoveTeamMember
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiRemoveTeamMember
     */
    readonly userId: number
}

/**
 * Request parameters for removeTrackedBill operation in DefaultApi.
 * @export
 * @interface DefaultApiRemoveTrackedBillRequest
 */
export interface DefaultApiRemoveTrackedBillRequest {
    /**
     * 
     * @type {RemoveTrackedBillBody}
     * @memberof DefaultApiRemoveTrackedBill
     */
    readonly removeTrackedBillBody: RemoveTrackedBillBody
}

/**
 * Request parameters for removeTrackedWitness operation in DefaultApi.
 * @export
 * @interface DefaultApiRemoveTrackedWitnessRequest
 */
export interface DefaultApiRemoveTrackedWitnessRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRemoveTrackedWitness
     */
    readonly witnessId: number
}

/**
 * Request parameters for renameFile operation in DefaultApi.
 * @export
 * @interface DefaultApiRenameFileRequest
 */
export interface DefaultApiRenameFileRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRenameFile
     */
    readonly fileId: number

    /**
     * 
     * @type {RenameFileRequest}
     * @memberof DefaultApiRenameFile
     */
    readonly renameFileRequest: RenameFileRequest
}

/**
 * Request parameters for renameFolder operation in DefaultApi.
 * @export
 * @interface DefaultApiRenameFolderRequest
 */
export interface DefaultApiRenameFolderRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRenameFolder
     */
    readonly folderId: number

    /**
     * 
     * @type {RenameFileRequest}
     * @memberof DefaultApiRenameFolder
     */
    readonly renameFileRequest: RenameFileRequest
}

/**
 * Request parameters for reportMissingLive operation in DefaultApi.
 * @export
 * @interface DefaultApiReportMissingLiveRequest
 */
export interface DefaultApiReportMissingLiveRequest {
    /**
     * 
     * @type {MissingLiveReportBody}
     * @memberof DefaultApiReportMissingLive
     */
    readonly missingLiveReportBody: MissingLiveReportBody
}

/**
 * Request parameters for reportWrongCompanySummary operation in DefaultApi.
 * @export
 * @interface DefaultApiReportWrongCompanySummaryRequest
 */
export interface DefaultApiReportWrongCompanySummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiReportWrongCompanySummary
     */
    readonly companyId: number
}

/**
 * Request parameters for requestMissingParams operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestMissingParamsRequest
 */
export interface DefaultApiRequestMissingParamsRequest {
    /**
     * 
     * @type {MissingParamsRequest}
     * @memberof DefaultApiRequestMissingParams
     */
    readonly missingParamsRequest: MissingParamsRequest
}

/**
 * Request parameters for revokeInvitation operation in DefaultApi.
 * @export
 * @interface DefaultApiRevokeInvitationRequest
 */
export interface DefaultApiRevokeInvitationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRevokeInvitation
     */
    readonly invitationId: number
}

/**
 * Request parameters for runScheduledReport operation in DefaultApi.
 * @export
 * @interface DefaultApiRunScheduledReportRequest
 */
export interface DefaultApiRunScheduledReportRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRunScheduledReport
     */
    readonly scheduledReportId: number
}

/**
 * Request parameters for saveAccountCompanyClaims operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveAccountCompanyClaimsRequest
 */
export interface DefaultApiSaveAccountCompanyClaimsRequest {
    /**
     * 
     * @type {SaveAccountCompanyClaimsBody}
     * @memberof DefaultApiSaveAccountCompanyClaims
     */
    readonly saveAccountCompanyClaimsBody: SaveAccountCompanyClaimsBody
}

/**
 * Request parameters for saveAccountCompanySummary operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveAccountCompanySummaryRequest
 */
export interface DefaultApiSaveAccountCompanySummaryRequest {
    /**
     * 
     * @type {SaveAccountCompanySummaryBody}
     * @memberof DefaultApiSaveAccountCompanySummary
     */
    readonly saveAccountCompanySummaryBody: SaveAccountCompanySummaryBody
}

/**
 * Request parameters for saveAutoTrackCompanies operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveAutoTrackCompaniesRequest
 */
export interface DefaultApiSaveAutoTrackCompaniesRequest {
    /**
     * 
     * @type {SaveAutoTrackCompaniesBody}
     * @memberof DefaultApiSaveAutoTrackCompanies
     */
    readonly saveAutoTrackCompaniesBody: SaveAutoTrackCompaniesBody
}

/**
 * Request parameters for saveAutoTrackStates operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveAutoTrackStatesRequest
 */
export interface DefaultApiSaveAutoTrackStatesRequest {
    /**
     * 
     * @type {SaveAutoTrackStatesBody}
     * @memberof DefaultApiSaveAutoTrackStates
     */
    readonly saveAutoTrackStatesBody: SaveAutoTrackStatesBody
}

/**
 * Request parameters for saveBillAlert operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveBillAlertRequest
 */
export interface DefaultApiSaveBillAlertRequest {
    /**
     * 
     * @type {SaveBillAlertBody}
     * @memberof DefaultApiSaveBillAlert
     */
    readonly saveBillAlertBody: SaveBillAlertBody
}

/**
 * Request parameters for saveBillTags operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveBillTagsRequest
 */
export interface DefaultApiSaveBillTagsRequest {
    /**
     * 
     * @type {SaveBillTagsBody}
     * @memberof DefaultApiSaveBillTags
     */
    readonly saveBillTagsBody: SaveBillTagsBody

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiSaveBillTags
     */
    readonly bypassAccessCheck?: boolean
}

/**
 * Request parameters for saveCommitteeAgentStates operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveCommitteeAgentStatesRequest
 */
export interface DefaultApiSaveCommitteeAgentStatesRequest {
    /**
     * 
     * @type {SaveCommitteeAgentStatesBody}
     * @memberof DefaultApiSaveCommitteeAgentStates
     */
    readonly saveCommitteeAgentStatesBody: SaveCommitteeAgentStatesBody
}

/**
 * Request parameters for saveCommitteeAlert operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveCommitteeAlertRequest
 */
export interface DefaultApiSaveCommitteeAlertRequest {
    /**
     * 
     * @type {SaveCommitteeAlertBody}
     * @memberof DefaultApiSaveCommitteeAlert
     */
    readonly saveCommitteeAlertBody: SaveCommitteeAlertBody
}

/**
 * Request parameters for saveCompanyTickSheet operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveCompanyTickSheetRequest
 */
export interface DefaultApiSaveCompanyTickSheetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveCompanyTickSheet
     */
    readonly billId: string

    /**
     * 
     * @type {SaveCompanyTickSheetBody}
     * @memberof DefaultApiSaveCompanyTickSheet
     */
    readonly saveCompanyTickSheetBody: SaveCompanyTickSheetBody
}

/**
 * Request parameters for saveLobbyistAlert operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveLobbyistAlertRequest
 */
export interface DefaultApiSaveLobbyistAlertRequest {
    /**
     * 
     * @type {SaveLobbyistAlertBody}
     * @memberof DefaultApiSaveLobbyistAlert
     */
    readonly saveLobbyistAlertBody: SaveLobbyistAlertBody
}

/**
 * Request parameters for saveMemberTickSheet operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveMemberTickSheetRequest
 */
export interface DefaultApiSaveMemberTickSheetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveMemberTickSheet
     */
    readonly billId: string

    /**
     * 
     * @type {SaveMemberTickSheetBody}
     * @memberof DefaultApiSaveMemberTickSheet
     */
    readonly saveMemberTickSheetBody: SaveMemberTickSheetBody
}

/**
 * Request parameters for saveReportSetting operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveReportSettingRequest
 */
export interface DefaultApiSaveReportSettingRequest {
    /**
     * 
     * @type {SaveReportSettingRequest}
     * @memberof DefaultApiSaveReportSetting
     */
    readonly saveReportSettingRequest: SaveReportSettingRequest
}

/**
 * Request parameters for saveSectionTags operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveSectionTagsRequest
 */
export interface DefaultApiSaveSectionTagsRequest {
    /**
     * 
     * @type {SaveSectionTagsBody}
     * @memberof DefaultApiSaveSectionTags
     */
    readonly saveSectionTagsBody: SaveSectionTagsBody
}

/**
 * Request parameters for saveUserSettings operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveUserSettingsRequest
 */
export interface DefaultApiSaveUserSettingsRequest {
    /**
     * 
     * @type {SaveUserSettingsBody}
     * @memberof DefaultApiSaveUserSettings
     */
    readonly saveUserSettingsBody: SaveUserSettingsBody
}

/**
 * Request parameters for scheduleReport operation in DefaultApi.
 * @export
 * @interface DefaultApiScheduleReportRequest
 */
export interface DefaultApiScheduleReportRequest {
    /**
     * 
     * @type {ScheduleReportRequest}
     * @memberof DefaultApiScheduleReport
     */
    readonly scheduleReportRequest: ScheduleReportRequest
}

/**
 * Request parameters for search operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchRequest
 */
export interface DefaultApiSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearch
     */
    readonly term: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearch
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearch
     */
    readonly limit?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiSearch
     */
    readonly stateCodes?: Array<string>
}

/**
 * Request parameters for searchCompaniesForInvite operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchCompaniesForInviteRequest
 */
export interface DefaultApiSearchCompaniesForInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchCompaniesForInvite
     */
    readonly search: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchCompaniesForInvite
     */
    readonly stateCode?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchCompaniesForInvite
     */
    readonly year?: number
}

/**
 * Request parameters for searchRegs operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchRegsRequest
 */
export interface DefaultApiSearchRegsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly query?: string

    /**
     * 
     * @type {'word' | 'ai'}
     * @memberof DefaultApiSearchRegs
     */
    readonly searchMode?: SearchRegsSearchModeEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly wordQuery?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly aiQuery?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly state?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly code?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly title?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly chapter?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly section?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly fileName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly article?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly subtitle?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly subchapter?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly subsection?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly rule?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRegs
     */
    readonly part?: string
}

/**
 * Request parameters for searchRemarks operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchRemarksRequest
 */
export interface DefaultApiSearchRemarksRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRemarks
     */
    readonly stateCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRemarks
     */
    readonly sessionCode?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRemarks
     */
    readonly q?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchRemarks
     */
    readonly tags?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchRemarks
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchRemarks
     */
    readonly pageSize?: number
}

/**
 * Request parameters for searchStatutes operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchStatutesRequest
 */
export interface DefaultApiSearchStatutesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly query?: string

    /**
     * 
     * @type {'word' | 'ai'}
     * @memberof DefaultApiSearchStatutes
     */
    readonly searchMode?: SearchStatutesSearchModeEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly wordQuery?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly aiQuery?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly state?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly code?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly title?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly chapter?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly section?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly fileName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly article?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly subtitle?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly subchapter?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchStatutes
     */
    readonly subsection?: string
}

/**
 * Request parameters for searchVideos operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchVideosRequest
 */
export interface DefaultApiSearchVideosRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchVideos
     */
    readonly term: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchVideos
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchVideos
     */
    readonly limit?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiSearchVideos
     */
    readonly stateCodes?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchVideos
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchVideos
     */
    readonly endDate?: string
}

/**
 * Request parameters for searchWitnessDirectory operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchWitnessDirectoryRequest
 */
export interface DefaultApiSearchWitnessDirectoryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchWitnessDirectory
     */
    readonly query?: string
}

/**
 * Request parameters for sendAccountGmail operation in DefaultApi.
 * @export
 * @interface DefaultApiSendAccountGmailRequest
 */
export interface DefaultApiSendAccountGmailRequest {
    /**
     * 
     * @type {GmailSendRequestBody}
     * @memberof DefaultApiSendAccountGmail
     */
    readonly gmailSendRequestBody: GmailSendRequestBody
}

/**
 * Request parameters for sendEmail operation in DefaultApi.
 * @export
 * @interface DefaultApiSendEmailRequest
 */
export interface DefaultApiSendEmailRequest {
    /**
     * 
     * @type {EmailRequest}
     * @memberof DefaultApiSendEmail
     */
    readonly emailRequest: EmailRequest
}

/**
 * Request parameters for sendGmailTestMessage operation in DefaultApi.
 * @export
 * @interface DefaultApiSendGmailTestMessageRequest
 */
export interface DefaultApiSendGmailTestMessageRequest {
    /**
     * 
     * @type {SendGmailTestMessageRequest}
     * @memberof DefaultApiSendGmailTestMessage
     */
    readonly sendGmailTestMessageRequest: SendGmailTestMessageRequest
}

/**
 * Request parameters for sendInvite operation in DefaultApi.
 * @export
 * @interface DefaultApiSendInviteRequest
 */
export interface DefaultApiSendInviteRequest {
    /**
     * 
     * @type {ReferralInviteRequest}
     * @memberof DefaultApiSendInvite
     */
    readonly referralInviteRequest: ReferralInviteRequest
}

/**
 * Request parameters for sendNewAnalyst operation in DefaultApi.
 * @export
 * @interface DefaultApiSendNewAnalystRequest
 */
export interface DefaultApiSendNewAnalystRequest {
    /**
     * 
     * @type {NewAnalystRequest}
     * @memberof DefaultApiSendNewAnalyst
     */
    readonly newAnalystRequest: NewAnalystRequest
}

/**
 * Request parameters for sendSlackTestMessage operation in DefaultApi.
 * @export
 * @interface DefaultApiSendSlackTestMessageRequest
 */
export interface DefaultApiSendSlackTestMessageRequest {
    /**
     * 
     * @type {SlackTestRequest}
     * @memberof DefaultApiSendSlackTestMessage
     */
    readonly slackTestRequest: SlackTestRequest
}

/**
 * Request parameters for sendTaskReminder operation in DefaultApi.
 * @export
 * @interface DefaultApiSendTaskReminderRequest
 */
export interface DefaultApiSendTaskReminderRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiSendTaskReminder
     */
    readonly id: number

    /**
     * 
     * @type {SendTaskReminderRequest}
     * @memberof DefaultApiSendTaskReminder
     */
    readonly sendTaskReminderRequest: SendTaskReminderRequest
}

/**
 * Request parameters for shareTag operation in DefaultApi.
 * @export
 * @interface DefaultApiShareTagRequest
 */
export interface DefaultApiShareTagRequest {
    /**
     * 
     * @type {ShareTagBody}
     * @memberof DefaultApiShareTag
     */
    readonly shareTagBody: ShareTagBody
}

/**
 * Request parameters for splitCluster operation in DefaultApi.
 * @export
 * @interface DefaultApiSplitClusterRequest
 */
export interface DefaultApiSplitClusterRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiSplitCluster
     */
    readonly masterCompanyId: number
}

/**
 * Request parameters for startAutoTrack operation in DefaultApi.
 * @export
 * @interface DefaultApiStartAutoTrackRequest
 */
export interface DefaultApiStartAutoTrackRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiStartAutoTrack
     */
    readonly type: string
}

/**
 * Request parameters for subscribeNewsletter operation in DefaultApi.
 * @export
 * @interface DefaultApiSubscribeNewsletterRequest
 */
export interface DefaultApiSubscribeNewsletterRequest {
    /**
     * 
     * @type {SubscribeNewsletterRequest}
     * @memberof DefaultApiSubscribeNewsletter
     */
    readonly subscribeNewsletterRequest: SubscribeNewsletterRequest
}

/**
 * Request parameters for summarizeText operation in DefaultApi.
 * @export
 * @interface DefaultApiSummarizeTextRequest
 */
export interface DefaultApiSummarizeTextRequest {
    /**
     * 
     * @type {EntitySummaryRequest}
     * @memberof DefaultApiSummarizeText
     */
    readonly entitySummaryRequest: EntitySummaryRequest
}

/**
 * Request parameters for testKeywordMatching operation in DefaultApi.
 * @export
 * @interface DefaultApiTestKeywordMatchingRequest
 */
export interface DefaultApiTestKeywordMatchingRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiTestKeywordMatching
     */
    readonly days?: number
}

/**
 * Request parameters for toggleArchiveTag operation in DefaultApi.
 * @export
 * @interface DefaultApiToggleArchiveTagRequest
 */
export interface DefaultApiToggleArchiveTagRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiToggleArchiveTag
     */
    readonly tagId: number

    /**
     * 
     * @type {ToggleArchiveTagRequest}
     * @memberof DefaultApiToggleArchiveTag
     */
    readonly toggleArchiveTagRequest: ToggleArchiveTagRequest
}

/**
 * Request parameters for trackReportDownload operation in DefaultApi.
 * @export
 * @interface DefaultApiTrackReportDownloadRequest
 */
export interface DefaultApiTrackReportDownloadRequest {
    /**
     * Download tracking parameters
     * @type {TrackDownloadRequest}
     * @memberof DefaultApiTrackReportDownload
     */
    readonly trackDownloadRequest: TrackDownloadRequest
}

/**
 * Request parameters for updateAIStrength operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateAIStrengthRequest
 */
export interface DefaultApiUpdateAIStrengthRequest {
    /**
     * 
     * @type {UpdateAIStrengthRequest}
     * @memberof DefaultApiUpdateAIStrength
     */
    readonly updateAIStrengthRequest: UpdateAIStrengthRequest
}

/**
 * Request parameters for updateAccountEntity operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateAccountEntityRequest
 */
export interface DefaultApiUpdateAccountEntityRequest {
    /**
     * 
     * @type {UpdateAccountEntityRequest}
     * @memberof DefaultApiUpdateAccountEntity
     */
    readonly updateAccountEntityRequest: UpdateAccountEntityRequest
}

/**
 * Request parameters for updateBillPriorityImpact operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateBillPriorityImpactRequest
 */
export interface DefaultApiUpdateBillPriorityImpactRequest {
    /**
     * 
     * @type {UpdateBillPriorityImpactRequest}
     * @memberof DefaultApiUpdateBillPriorityImpact
     */
    readonly updateBillPriorityImpactRequest: UpdateBillPriorityImpactRequest
}

/**
 * Request parameters for updateClientTags operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateClientTagsRequest
 */
export interface DefaultApiUpdateClientTagsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateClientTags
     */
    readonly companyId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DefaultApiUpdateClientTags
     */
    readonly requestBody: Array<number>
}

/**
 * Request parameters for updateClipArchived operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateClipArchivedRequest
 */
export interface DefaultApiUpdateClipArchivedRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateClipArchived
     */
    readonly clipSetId: number

    /**
     * 
     * @type {UpdateClipArchivedRequest}
     * @memberof DefaultApiUpdateClipArchived
     */
    readonly updateClipArchivedRequest: UpdateClipArchivedRequest
}

/**
 * Request parameters for updateCommitteeAgentEnabled operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCommitteeAgentEnabledRequest
 */
export interface DefaultApiUpdateCommitteeAgentEnabledRequest {
    /**
     * 
     * @type {UpdateCommitteeAgentEnabledRequest}
     * @memberof DefaultApiUpdateCommitteeAgentEnabled
     */
    readonly updateCommitteeAgentEnabledRequest: UpdateCommitteeAgentEnabledRequest
}

/**
 * Request parameters for updateCompanyStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCompanyStatusRequest
 */
export interface DefaultApiUpdateCompanyStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateCompanyStatus
     */
    readonly companyId: number

    /**
     * 
     * @type {UpdateCompanyStatusRequest}
     * @memberof DefaultApiUpdateCompanyStatus
     */
    readonly updateCompanyStatusRequest: UpdateCompanyStatusRequest
}

/**
 * Request parameters for updateCompanySummary operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCompanySummaryRequest
 */
export interface DefaultApiUpdateCompanySummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateCompanySummary
     */
    readonly companyId: number

    /**
     * 
     * @type {SummaryPayload}
     * @memberof DefaultApiUpdateCompanySummary
     */
    readonly summaryPayload: SummaryPayload
}

/**
 * Request parameters for updateContact operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateContactRequest
 */
export interface DefaultApiUpdateContactRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateContact
     */
    readonly companyId: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateContact
     */
    readonly contactId: number

    /**
     * 
     * @type {ContactPayload}
     * @memberof DefaultApiUpdateContact
     */
    readonly contactPayload: ContactPayload
}

/**
 * Request parameters for updateFolderColorSetting operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateFolderColorSettingRequest
 */
export interface DefaultApiUpdateFolderColorSettingRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateFolderColorSetting
     */
    readonly folderId: number

    /**
     * 
     * @type {UpdateFolderColorSettingRequest}
     * @memberof DefaultApiUpdateFolderColorSetting
     */
    readonly updateFolderColorSettingRequest: UpdateFolderColorSettingRequest
}

/**
 * Request parameters for updateIssue operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateIssueRequest
 */
export interface DefaultApiUpdateIssueRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateIssue
     */
    readonly id: number

    /**
     * 
     * @type {UpdateIssueRequest}
     * @memberof DefaultApiUpdateIssue
     */
    readonly updateIssueRequest: UpdateIssueRequest
}

/**
 * Request parameters for updateKeywordMatchViewed operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateKeywordMatchViewedRequest
 */
export interface DefaultApiUpdateKeywordMatchViewedRequest {
    /**
     * 
     * @type {UpdateKeywordMatchViewedRequest}
     * @memberof DefaultApiUpdateKeywordMatchViewed
     */
    readonly updateKeywordMatchViewedRequest: UpdateKeywordMatchViewedRequest
}

/**
 * Request parameters for updateKeywords operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateKeywordsRequest
 */
export interface DefaultApiUpdateKeywordsRequest {
    /**
     * 
     * @type {UpdateKeywordsRequest}
     * @memberof DefaultApiUpdateKeywords
     */
    readonly updateKeywordsRequest: UpdateKeywordsRequest
}

/**
 * Request parameters for updateMemberList operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMemberListRequest
 */
export interface DefaultApiUpdateMemberListRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateMemberList
     */
    readonly id: number

    /**
     * 
     * @type {UpdateMemberListRequest}
     * @memberof DefaultApiUpdateMemberList
     */
    readonly updateMemberListRequest: UpdateMemberListRequest
}

/**
 * Request parameters for updateMetadata operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMetadataRequest
 */
export interface DefaultApiUpdateMetadataRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateMetadata
     */
    readonly fileId: number

    /**
     * 
     * @type {UpdateMetadataRequest}
     * @memberof DefaultApiUpdateMetadata
     */
    readonly updateMetadataRequest: UpdateMetadataRequest
}

/**
 * Request parameters for updatePriorityImpact operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdatePriorityImpactRequest
 */
export interface DefaultApiUpdatePriorityImpactRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdatePriorityImpact
     */
    readonly id: number

    /**
     * 
     * @type {UpdatePriorityImpactRequest}
     * @memberof DefaultApiUpdatePriorityImpact
     */
    readonly updatePriorityImpactRequest: UpdatePriorityImpactRequest
}

/**
 * Request parameters for updateRemark operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateRemarkRequest
 */
export interface DefaultApiUpdateRemarkRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateRemark
     */
    readonly remarkId: number

    /**
     * 
     * @type {UpdateBillRemarkBody}
     * @memberof DefaultApiUpdateRemark
     */
    readonly updateBillRemarkBody: UpdateBillRemarkBody
}

/**
 * Request parameters for updateReportSetting operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateReportSettingRequest
 */
export interface DefaultApiUpdateReportSettingRequest {
    /**
     * 
     * @type {UpdateReportSettingRequest}
     * @memberof DefaultApiUpdateReportSetting
     */
    readonly updateReportSettingRequest: UpdateReportSettingRequest
}

/**
 * Request parameters for updateSeats operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSeatsRequest
 */
export interface DefaultApiUpdateSeatsRequest {
    /**
     * 
     * @type {UpdateSeatsRequest}
     * @memberof DefaultApiUpdateSeats
     */
    readonly updateSeatsRequest: UpdateSeatsRequest
}

/**
 * Request parameters for updateStakeholderContact operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateStakeholderContactRequest
 */
export interface DefaultApiUpdateStakeholderContactRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateStakeholderContact
     */
    readonly stakeholderId: number

    /**
     * 
     * @type {StakeholderContactInput}
     * @memberof DefaultApiUpdateStakeholderContact
     */
    readonly stakeholderContactInput: StakeholderContactInput
}

/**
 * Request parameters for updateStakeholderMeeting operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateStakeholderMeetingRequest
 */
export interface DefaultApiUpdateStakeholderMeetingRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateStakeholderMeeting
     */
    readonly meetingId: number

    /**
     * 
     * @type {StakeholderMeetingInput}
     * @memberof DefaultApiUpdateStakeholderMeeting
     */
    readonly stakeholderMeetingInput: StakeholderMeetingInput
}

/**
 * Request parameters for updateTag operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTagRequest
 */
export interface DefaultApiUpdateTagRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateTag
     */
    readonly tagId: number

    /**
     * 
     * @type {UpdateTagRequest}
     * @memberof DefaultApiUpdateTag
     */
    readonly updateTagRequest: UpdateTagRequest
}

/**
 * Request parameters for updateTask operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTaskRequest
 */
export interface DefaultApiUpdateTaskRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateTask
     */
    readonly id: number

    /**
     * 
     * @type {UpdateTaskDto}
     * @memberof DefaultApiUpdateTask
     */
    readonly updateTaskDto: UpdateTaskDto
}

/**
 * Request parameters for updateTeam operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTeamRequest
 */
export interface DefaultApiUpdateTeamRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateTeam
     */
    readonly id: number

    /**
     * 
     * @type {UpdateTeamRequest}
     * @memberof DefaultApiUpdateTeam
     */
    readonly updateTeamRequest: UpdateTeamRequest
}

/**
 * Request parameters for updateTrackedActivityEmails operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTrackedActivityEmailsRequest
 */
export interface DefaultApiUpdateTrackedActivityEmailsRequest {
    /**
     * 
     * @type {UpdateTrackedActivityEmailSettingsBody}
     * @memberof DefaultApiUpdateTrackedActivityEmails
     */
    readonly updateTrackedActivityEmailSettingsBody: UpdateTrackedActivityEmailSettingsBody
}

/**
 * Request parameters for updateTrackingPreferences operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTrackingPreferencesRequest
 */
export interface DefaultApiUpdateTrackingPreferencesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateTrackingPreferences
     */
    readonly companyId: number

    /**
     * 
     * @type {TrackingPreferencesPayload}
     * @memberof DefaultApiUpdateTrackingPreferences
     */
    readonly trackingPreferencesPayload: TrackingPreferencesPayload
}

/**
 * Request parameters for updateUserAutoTrackAccess operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserAutoTrackAccessRequest
 */
export interface DefaultApiUpdateUserAutoTrackAccessRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateUserAutoTrackAccess
     */
    readonly userId: number

    /**
     * 
     * @type {UpdateUserAutoTrackAccessRequest}
     * @memberof DefaultApiUpdateUserAutoTrackAccess
     */
    readonly updateUserAutoTrackAccessRequest: UpdateUserAutoTrackAccessRequest
}

/**
 * Request parameters for updateUserContactEmail operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserContactEmailRequest
 */
export interface DefaultApiUpdateUserContactEmailRequest {
    /**
     * 
     * @type {UpdateUserContactEmailRequest}
     * @memberof DefaultApiUpdateUserContactEmail
     */
    readonly updateUserContactEmailRequest: UpdateUserContactEmailRequest
}

/**
 * Request parameters for updateUserRole operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserRoleRequest
 */
export interface DefaultApiUpdateUserRoleRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateUserRole
     */
    readonly userId: number

    /**
     * 
     * @type {UpdateUserRoleRequest}
     * @memberof DefaultApiUpdateUserRole
     */
    readonly updateUserRoleRequest: UpdateUserRoleRequest
}

/**
 * Request parameters for updateUserStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserStatusRequest
 */
export interface DefaultApiUpdateUserStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateUserStatus
     */
    readonly userId: number

    /**
     * 
     * @type {UpdateUserStatusRequest}
     * @memberof DefaultApiUpdateUserStatus
     */
    readonly updateUserStatusRequest: UpdateUserStatusRequest
}

/**
 * Request parameters for updateUserTrackedActivity operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserTrackedActivityRequest
 */
export interface DefaultApiUpdateUserTrackedActivityRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateUserTrackedActivity
     */
    readonly userId: number

    /**
     * 
     * @type {UpdateTrackedActivityConfigBody}
     * @memberof DefaultApiUpdateUserTrackedActivity
     */
    readonly updateTrackedActivityConfigBody: UpdateTrackedActivityConfigBody
}

/**
 * Request parameters for updateUsername operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUsernameRequest
 */
export interface DefaultApiUpdateUsernameRequest {
    /**
     * 
     * @type {UpdateUsernameRequest}
     * @memberof DefaultApiUpdateUsername
     */
    readonly updateUsernameRequest: UpdateUsernameRequest
}

/**
 * Request parameters for uploadAccountLogo operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadAccountLogoRequest
 */
export interface DefaultApiUploadAccountLogoRequest {
    /**
     * 
     * @type {Array<File>}
     * @memberof DefaultApiUploadAccountLogo
     */
    readonly files: Array<File>
}

/**
 * Request parameters for uploadDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadDocumentRequest
 */
export interface DefaultApiUploadDocumentRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadDocument
     */
    readonly remarkId: number

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUploadDocument
     */
    readonly file: File
}

/**
 * Request parameters for uploadDocuments operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadDocumentsRequest
 */
export interface DefaultApiUploadDocumentsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadDocuments
     */
    readonly companyId: number

    /**
     * 
     * @type {Array<File>}
     * @memberof DefaultApiUploadDocuments
     */
    readonly files: Array<File>
}

/**
 * Request parameters for uploadFiles operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadFilesRequest
 */
export interface DefaultApiUploadFilesRequest {
    /**
     * 
     * @type {Array<File>}
     * @memberof DefaultApiUploadFiles
     */
    readonly files: Array<File>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadFiles
     */
    readonly folderId?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadFiles
     */
    readonly companyId?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadFiles
     */
    readonly masterBillId?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadFiles
     */
    readonly purpose?: string
}

/**
 * Request parameters for uploadLogoFromUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadLogoFromUrlRequest
 */
export interface DefaultApiUploadLogoFromUrlRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadLogoFromUrl
     */
    readonly companyId: number

    /**
     * 
     * @type {UploadLogoFromUrlRequest}
     * @memberof DefaultApiUploadLogoFromUrl
     */
    readonly uploadLogoFromUrlRequest: UploadLogoFromUrlRequest
}

/**
 * Request parameters for uploadTaskFile operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadTaskFileRequest
 */
export interface DefaultApiUploadTaskFileRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadTaskFile
     */
    readonly id: number

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUploadTaskFile
     */
    readonly file: File
}

/**
 * Request parameters for uploadTrackList operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadTrackListRequest
 */
export interface DefaultApiUploadTrackListRequest {
    /**
     * 
     * @type {File}
     * @memberof DefaultApiUploadTrackList
     */
    readonly file: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadTrackList
     */
    readonly state: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadTrackList
     */
    readonly session: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadTrackList
     */
    readonly lobbyistIds: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadTrackList
     */
    readonly accountId?: string
}

/**
 * Request parameters for validateCompanySummary operation in DefaultApi.
 * @export
 * @interface DefaultApiValidateCompanySummaryRequest
 */
export interface DefaultApiValidateCompanySummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiValidateCompanySummary
     */
    readonly companyId: number
}

/**
 * Request parameters for warmBillCache operation in DefaultApi.
 * @export
 * @interface DefaultApiWarmBillCacheRequest
 */
export interface DefaultApiWarmBillCacheRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiWarmBillCache
     */
    readonly days?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiWarmBillCache
     */
    readonly limit?: number
}

/**
 * Request parameters for warmBillCache_6 operation in DefaultApi.
 * @export
 * @interface DefaultApiWarmBillCache0Request
 */
export interface DefaultApiWarmBillCache0Request {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiWarmBillCache0
     */
    readonly xApiKey: string

    /**
     * Number of days to look back for recent activity (default: 7)
     * @type {number}
     * @memberof DefaultApiWarmBillCache0
     */
    readonly days?: number

    /**
     * Maximum number of bills to cache (optional, for safety)
     * @type {number}
     * @memberof DefaultApiWarmBillCache0
     */
    readonly limit?: number
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {DefaultApiAcceptInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public acceptInvitation(requestParameters: DefaultApiAcceptInvitationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).acceptInvitation(requestParameters.acceptInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAcceptInvitationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public acceptInvitationGet(requestParameters: DefaultApiAcceptInvitationGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).acceptInvitationGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAddAnalystRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addAnalyst(requestParameters: DefaultApiAddAnalystRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addAnalyst(requestParameters.addAnalystRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAddBillWithSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addBillWithSession(requestParameters: DefaultApiAddBillWithSessionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addBillWithSession(requestParameters.addBillWithSessionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAddTaskNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addTaskNote(requestParameters: DefaultApiAddTaskNoteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addTaskNote(requestParameters.id, requestParameters.createTaskNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAddTeamMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addTeamMember(requestParameters: DefaultApiAddTeamMemberRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addTeamMember(requestParameters.id, requestParameters.addTeamMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAddTrackedWitnessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addTrackedWitness(requestParameters: DefaultApiAddTrackedWitnessRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addTrackedWitness(requestParameters.trackWitnessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiApproveAutoTrackedBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public approveAutoTrackedBill(requestParameters: DefaultApiApproveAutoTrackedBillRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).approveAutoTrackedBill(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Answer questions about a bill using its text content with conversation history
     * @param {DefaultApiAskBillQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public askBillQuestion(requestParameters: DefaultApiAskBillQuestionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).askBillQuestion(requestParameters.billQuestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAskRegQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public askRegQuestion(requestParameters: DefaultApiAskRegQuestionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).askRegQuestion(requestParameters.regulationQuestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAskStatuteQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public askStatuteQuestion(requestParameters: DefaultApiAskStatuteQuestionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).askStatuteQuestion(requestParameters.statuteQuestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssignLobbyistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignLobbyist(requestParameters: DefaultApiAssignLobbyistRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignLobbyist(requestParameters.witnessId, requestParameters.assignWitnessLobbyistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiBulkCreateTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkCreateTags(requestParameters: DefaultApiBulkCreateTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkCreateTags(requestParameters.bulkCreateTagsRequest, requestParameters.bypassAccessCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiBulkDeleteTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkDeleteTags(requestParameters: DefaultApiBulkDeleteTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkDeleteTags(requestParameters.bulkDeleteTagsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkImportClients(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkImportClients(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiBulkSaveAccountCompanySummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkSaveAccountCompanySummaries(requestParameters: DefaultApiBulkSaveAccountCompanySummariesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkSaveAccountCompanySummaries(requestParameters.bulkSaveAccountCompanySummaryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel the setup process for an account
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cancelSetup(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelSetup(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel subscription at the end of the current billing period
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cancelSubscription(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the current user\'s password
     * @param {DefaultApiChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public changePassword(requestParameters: DefaultApiChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changePassword(requestParameters.changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check which chambers have agendas available for a given state
     * @param {DefaultApiCheckAvailableAgendasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkAvailableAgendas(requestParameters: DefaultApiCheckAvailableAgendasRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkAvailableAgendas(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCheckUsernameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkUsername(requestParameters: DefaultApiCheckUsernameRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkUsername(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if a username is available
     * @param {DefaultApiCheckUsernameAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkUsernameAvailability(requestParameters: DefaultApiCheckUsernameAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkUsernameAvailability(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clear a specific bill from cache
     * @param {DefaultApiClearBillCacheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public clearBillCache(requestParameters: DefaultApiClearBillCacheRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).clearBillCache(requestParameters.xApiKey, requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clear sessions cache for a specific user and state
     * @param {DefaultApiClearSessionsCacheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public clearSessionsCache(requestParameters: DefaultApiClearSessionsCacheRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).clearSessionsCache(requestParameters.xApiKey, requestParameters.userId, requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clear sessions cache for a specific user
     * @param {DefaultApiClearUserSessionsCacheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public clearUserSessionsCache(requestParameters: DefaultApiClearUserSessionsCacheRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).clearUserSessionsCache(requestParameters.xApiKey, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCompleteRegistrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public completeRegistration(requestParameters: DefaultApiCompleteRegistrationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).completeRegistration(requestParameters.completeRegistrationRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete the setup process for an account with the provided information
     * @param {DefaultApiCompleteSetupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public completeSetup(requestParameters: DefaultApiCompleteSetupRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).completeSetup(requestParameters.completeSetupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiConnectGmailIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public connectGmailIntegration(requestParameters: DefaultApiConnectGmailIntegrationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).connectGmailIntegration(requestParameters.connectGmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiConnectSlackIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public connectSlackIntegration(requestParameters: DefaultApiConnectSlackIntegrationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).connectSlackIntegration(requestParameters.connectSlackIntegrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiConsolidateTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public consolidateTags(requestParameters: DefaultApiConsolidateTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).consolidateTags(requestParameters.consolidateTagsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateAccountBillRemarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAccountBillRemark(requestParameters: DefaultApiCreateAccountBillRemarkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAccountBillRemark(requestParameters.createBillRemarkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateBillRemarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createBillRemark(requestParameters: DefaultApiCreateBillRemarkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createBillRemark(requestParameters.createBillRemarkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createCluster(requestParameters: DefaultApiCreateClusterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createCluster(requestParameters.createClusterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new company and generate a Full summary via Perplexity. Ensures MasterCompanyID is set to CompanyID.
     * @param {DefaultApiCreateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createCompany(requestParameters: DefaultApiCreateCompanyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createCompany(requestParameters.createCompanyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createContact(requestParameters: DefaultApiCreateContactRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createContact(requestParameters.companyId, requestParameters.contactPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateFeatureRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFeatureRequest(requestParameters: DefaultApiCreateFeatureRequestRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFeatureRequest(requestParameters.createFeatureRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateFirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFirm(requestParameters: DefaultApiCreateFirmRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFirm(requestParameters.createFirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateGmailCalendarEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createGmailCalendarEvent(requestParameters: DefaultApiCreateGmailCalendarEventRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createGmailCalendarEvent(requestParameters.gmailCalendarRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createInvitation(requestParameters: DefaultApiCreateInvitationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createInvitation(requestParameters.inviteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateIssueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createIssue(requestParameters: DefaultApiCreateIssueRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createIssue(requestParameters.createIssueBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateLobbyistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createLobbyist(requestParameters: DefaultApiCreateLobbyistRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createLobbyist(requestParameters.lobbyistCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateMemberListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createMemberList(requestParameters: DefaultApiCreateMemberListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createMemberList(requestParameters.createMemberListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateOrUpdateBillPositionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createOrUpdateBillPosition(requestParameters: DefaultApiCreateOrUpdateBillPositionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createOrUpdateBillPosition(requestParameters.createBillPositionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreatePersonalBillRemarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPersonalBillRemark(requestParameters: DefaultApiCreatePersonalBillRemarkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPersonalBillRemark(requestParameters.createBillRemarkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe Customer Portal session for managing billing This allows customers to update payment methods, view invoices, etc.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPortalSession(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPortalSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe Customer Portal session for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPortalSession_1(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPortalSession_1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateProspectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createProspect(requestParameters: DefaultApiCreateProspectRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createProspect(requestParameters.prospectCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSession(requestParameters: DefaultApiCreateSessionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSession(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateStakeholderContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createStakeholderContact(requestParameters: DefaultApiCreateStakeholderContactRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createStakeholderContact(requestParameters.stakeholderContactInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateStakeholderMeetingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createStakeholderMeeting(requestParameters: DefaultApiCreateStakeholderMeetingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createStakeholderMeeting(requestParameters.stakeholderMeetingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTag(requestParameters: DefaultApiCreateTagRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTag(requestParameters.createTagBody, requestParameters.bypassAccessCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTask(requestParameters: DefaultApiCreateTaskRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTask(requestParameters.createTaskDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTeam(requestParameters: DefaultApiCreateTeamRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTeam(requestParameters.createTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCreateUserFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createUserFolder(requestParameters: DefaultApiCreateUserFolderRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUserFolder(requestParameters.createFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create video clip  Creates a clip record with timestamps only. The video segment is generated on-demand when viewed or downloaded, just like the share endpoint and committee agent.
     * @param {DefaultApiCreateVideoClipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createVideoClip(requestParameters: DefaultApiCreateVideoClipRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createVideoClip(requestParameters.videoSegment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteAccountCompanySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAccountCompanySummary(requestParameters: DefaultApiDeleteAccountCompanySummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAccountCompanySummary(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAllAutoTrackedBills(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAllAutoTrackedBills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteAutoTrackedBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAutoTrackedBill(requestParameters: DefaultApiDeleteAutoTrackedBillRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAutoTrackedBill(requestParameters.billTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteBillPositionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteBillPosition(requestParameters: DefaultApiDeleteBillPositionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteBillPosition(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a document
     * @param {DefaultApiDeleteDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteDocument(requestParameters: DefaultApiDeleteDocumentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteDocument(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteFile(requestParameters: DefaultApiDeleteFileRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteFile(requestParameters.fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteFolder(requestParameters: DefaultApiDeleteFolderRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteFolder(requestParameters.folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteMemberListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMemberList(requestParameters: DefaultApiDeleteMemberListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMemberList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteRemarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteRemark(requestParameters: DefaultApiDeleteRemarkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteRemark(requestParameters.remarkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteScheduledReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteScheduledReport(requestParameters: DefaultApiDeleteScheduledReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteScheduledReport(requestParameters.scheduledReportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTag(requestParameters: DefaultApiDeleteTagRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteTag(requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDeleteUserKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteUserKeyword(requestParameters: DefaultApiDeleteUserKeywordRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteUserKeyword(requestParameters.deleteUserKeywordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDisconnectGmailIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disconnectGmailIntegration(requestParameters: DefaultApiDisconnectGmailIntegrationRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disconnectGmailIntegration(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDisconnectSlackIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disconnectSlackIntegration(requestParameters: DefaultApiDisconnectSlackIntegrationRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disconnectSlackIntegration(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dismiss the new user welcome modal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public dismissNewUserModal(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).dismissNewUserModal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Proxy endpoint for downloading agenda content Streams the file directly from Azure to the client without exposing SAS tokens
     * @param {DefaultApiDownloadAgendaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadAgenda(requestParameters: DefaultApiDownloadAgendaRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadAgenda(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Proxy endpoint for downloading bill documents Streams the file directly from Azure to the client without exposing SAS tokens  IMPORTANT: This route MUST be defined before generic routes that might capture it.
     * @param {DefaultApiDownloadBillDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadBillDocument(requestParameters: DefaultApiDownloadBillDocumentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadBillDocument(requestParameters.id, requestParameters.billVersionId, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a Video Clip as MP4.
     * @param {DefaultApiDownloadClipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadClip(requestParameters: DefaultApiDownloadClipRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadClip(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a document
     * @param {DefaultApiDownloadDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadDocument(requestParameters: DefaultApiDownloadDocumentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadDocument(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiDownloadFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadFile(requestParameters: DefaultApiDownloadFileRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadFile(requestParameters.fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Proxy endpoint for downloading files by path Replaces direct SAS URL access for security compliance
     * @param {DefaultApiDownloadFileByPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadFileByPath(requestParameters: DefaultApiDownloadFileByPathRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadFileByPath(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download recent live actions as CSV
     * @param {DefaultApiDownloadLiveActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadLiveActions(requestParameters: DefaultApiDownloadLiveActionsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadLiveActions(requestParameters.stateCodes, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Proxy endpoint for downloading supporting documents Streams the file directly from Azure to the client without exposing SAS tokens  IMPORTANT: This route MUST be defined before generic routes that might capture it.
     * @param {DefaultApiDownloadSupportingDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadSupportingDocument(requestParameters: DefaultApiDownloadSupportingDocumentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadSupportingDocument(requestParameters.id, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiEmailAiReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public emailAiReport(requestParameters: DefaultApiEmailAiReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).emailAiReport(requestParameters.emailAiReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiEnsureFolderPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public ensureFolderPath(requestParameters: DefaultApiEnsureFolderPathRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ensureFolderPath(requestParameters.ensureFolderPathBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Proxy endpoint to fetch AI report from Azure storage (bypasses CORS)
     * @param {DefaultApiFetchAIReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public fetchAIReport(requestParameters: DefaultApiFetchAIReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).fetchAIReport(requestParameters.url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the most recent daily agenda for a specific state and chamber
     * @param {DefaultApiFetchDailyAgendaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public fetchDailyAgenda(requestParameters: DefaultApiFetchDailyAgendaRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).fetchDailyAgenda(requestParameters.state, requestParameters.chamber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fix an incorrect company summary by regenerating it
     * @param {DefaultApiFixCompanySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public fixCompanySummary(requestParameters: DefaultApiFixCompanySummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).fixCompanySummary(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request a password reset
     * @param {DefaultApiForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public forgotPassword(requestParameters: DefaultApiForgotPasswordRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).forgotPassword(requestParameters.forgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Forward a bill to one or more lobbyists in the account
     * @param {DefaultApiForwardBillToLobbyistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public forwardBillToLobbyists(requestParameters: DefaultApiForwardBillToLobbyistsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).forwardBillToLobbyists(requestParameters.forwardBillToLobbyistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGatherContextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public gatherContext(requestParameters: DefaultApiGatherContextRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).gatherContext(requestParameters.contextQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGenerateAIReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateAIReport(requestParameters: DefaultApiGenerateAIReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateAIReport(requestParameters.aIReportPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a suggested title and description for a clip.
     * @param {DefaultApiGenerateClipMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateClipMetadata(requestParameters: DefaultApiGenerateClipMetadataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateClipMetadata(requestParameters.videoId, requestParameters.clipMetadataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a video clip of segments relevant to a company
     * @param {DefaultApiGenerateCompanyClipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateCompanyClip(requestParameters: DefaultApiGenerateCompanyClipRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateCompanyClip(requestParameters.videoId, requestParameters.generateCompanySummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a company-specific summary of a committee video
     * @param {DefaultApiGenerateCompanySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateCompanySummary(requestParameters: DefaultApiGenerateCompanySummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateCompanySummary(requestParameters.videoId, requestParameters.generateCompanySummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate AI report using API key authentication (for external clients)
     * @param {DefaultApiGenerateExternalAIReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateExternalAIReport(requestParameters: DefaultApiGenerateExternalAIReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateExternalAIReport(requestParameters.xApiKey, requestParameters.externalAIReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate relevant keywords based on the entity description Can process single entity or multiple companies in parallel
     * @param {DefaultApiGenerateKeywordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateKeywords(requestParameters: DefaultApiGenerateKeywordsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateKeywords(requestParameters.generateKeywordsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGenerateSegmentSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateSegmentSummary(requestParameters: DefaultApiGenerateSegmentSummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateSegmentSummary(requestParameters.videoId, requestParameters.generateSegmentSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate relevant subjects based on the entity description
     * @param {DefaultApiGenerateSubjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateSubjects(requestParameters: DefaultApiGenerateSubjectsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateSubjects(requestParameters.generateSubjectsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGenerateTagContextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateTagContext(requestParameters: DefaultApiGenerateTagContextRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateTagContext(requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate relevant tags based on provided keywords
     * @param {DefaultApiGenerateTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateTags(requestParameters: DefaultApiGenerateTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateTags(requestParameters.generateTagsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGenerateTagsForCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateTagsForCompany(requestParameters: DefaultApiGenerateTagsForCompanyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateTagsForCompany(requestParameters.generateTagsForCompanyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateTrackedActivityReportsBatch(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateTrackedActivityReportsBatch(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccount(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAccountBillRemarksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountBillRemarks(requestParameters: DefaultApiGetAccountBillRemarksRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountBillRemarks(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAccountCompanyClaimsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountCompanyClaims(requestParameters: DefaultApiGetAccountCompanyClaimsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountCompanyClaims(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountCompanySummaries(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountCompanySummaries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAccountCompanySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountCompanySummary(requestParameters: DefaultApiGetAccountCompanySummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountCompanySummary(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAccountLobbyistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountLobbyist(requestParameters: DefaultApiGetAccountLobbyistRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountLobbyist(requestParameters.id, requestParameters.state, requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all lobbyist users in the current account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountLobbyistUsers(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountLobbyistUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAccountTrackedBillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountTrackedBills(requestParameters: DefaultApiGetAccountTrackedBillsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountTrackedBills(requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.states, requestParameters.sessionKeys, requestParameters.activeOnly, requestParameters.tagIds, requestParameters.tagLogic, requestParameters.trackTypes, requestParameters.progressStatuses, requestParameters.alertsOnly, requestParameters.excludeLobbyistUsers, requestParameters.lobbyistUsersOnly, requestParameters.jointTracked, requestParameters.userIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAccountTrackedBillsBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountTrackedBillsBulk(requestParameters: DefaultApiGetAccountTrackedBillsBulkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountTrackedBillsBulk(requestParameters.accountTrackedBillsBulkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAccountUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountUsers(requestParameters: DefaultApiGetAccountUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountUsers(requestParameters.page, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get counts for a specific activity type
     * @param {DefaultApiGetActivityCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getActivityCount(requestParameters: DefaultApiGetActivityCountRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getActivityCount(requestParameters.scope, requestParameters.days, requestParameters.activityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get historical DAU/MAU data for a date range
     * @param {DefaultApiGetActivityHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getActivityHistory(requestParameters: DefaultApiGetActivityHistoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getActivityHistory(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Daily Active Users (DAU) and Monthly Active Users (MAU) metrics
     * @param {DefaultApiGetActivityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getActivityMetrics(requestParameters: DefaultApiGetActivityMetricsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getActivityMetrics(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAdvancedSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAdvancedSearch(requestParameters: DefaultApiGetAdvancedSearchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAdvancedSearch(requestParameters.advancedSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAdvocateTestimony(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAdvocateTestimony(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAdvocateTestimonyByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAdvocateTestimonyById(requestParameters: DefaultApiGetAdvocateTestimonyByIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAdvocateTestimonyById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllAnalystMetrics(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllAnalystMetrics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAnalystCandidates(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAnalystCandidates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAnalystMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAnalystMetrics(requestParameters: DefaultApiGetAnalystMetricsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAnalystMetrics(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAnalysts(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAnalysts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoTrackAvailability(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoTrackAvailability(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoTrackCompanies(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoTrackCompanies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAutoTrackMatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoTrackMatch(requestParameters: DefaultApiGetAutoTrackMatchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoTrackMatch(requestParameters.masterBillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAutoTrackMatchesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoTrackMatches(requestParameters: DefaultApiGetAutoTrackMatchesRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoTrackMatches(requestParameters.outcome, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.minScore, requestParameters.maxScore, requestParameters.rejectedStart, requestParameters.rejectedEnd, requestParameters.priority, requestParameters.impact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoTrackStates(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoTrackStates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoTrackStatus(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoTrackStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAutoTrackedBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoTrackedBill(requestParameters: DefaultApiGetAutoTrackedBillRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoTrackedBill(requestParameters.billId, requestParameters.viewScope, requestParameters.targetFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetAutoTrackedBillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoTrackedBills(requestParameters: DefaultApiGetAutoTrackedBillsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoTrackedBills(requestParameters.sorted, requestParameters.page, requestParameters.pageSize, requestParameters.viewScope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sessions for multiple states in a single request
     * @param {DefaultApiGetBatchSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBatchSessions(requestParameters: DefaultApiGetBatchSessionsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBatchSessions(requestParameters.getBatchSessionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBill(requestParameters: DefaultApiGetBillRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBill(requestParameters.id, requestParameters.includeAiSummary, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Bill Agent statistics for the current account
     * @param {DefaultApiGetBillAgentStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillAgentStats(requestParameters: DefaultApiGetBillAgentStatsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillAgentStats(requestParameters.accountId, requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillAiSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillAiSummary(requestParameters: DefaultApiGetBillAiSummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillAiSummary(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillAlertsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillAlerts(requestParameters: DefaultApiGetBillAlertsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillAlerts(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillAlertsBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillAlertsBulk(requestParameters: DefaultApiGetBillAlertsBulkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillAlertsBulk(requestParameters.billAlertsBulkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get committee calendar entries for the selected date range. When trackedOnly is true, results are limited to bills tracked by the account.
     * @param {DefaultApiGetBillCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillCalendar(requestParameters: DefaultApiGetBillCalendarRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillCalendar(requestParameters.startDate, requestParameters.endDate, requestParameters.trackedOnly, requestParameters.stateCodes, requestParameters.clientCompanyIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get bill chat history for the current session and specific bill
     * @param {DefaultApiGetBillChatHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillChatHistory(requestParameters: DefaultApiGetBillChatHistoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillChatHistory(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillComments(requestParameters: DefaultApiGetBillCommentsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillComments(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillCompaniesOfInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillCompaniesOfInterest(requestParameters: DefaultApiGetBillCompaniesOfInterestRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillCompaniesOfInterest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillCompanionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillCompanions(requestParameters: DefaultApiGetBillCompanionsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillCompanions(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillComparisonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillComparison(requestParameters: DefaultApiGetBillComparisonRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillComparison(requestParameters.getBillComparisonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillComparisonAiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillComparisonAi(requestParameters: DefaultApiGetBillComparisonAiRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillComparisonAi(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillContent(requestParameters: DefaultApiGetBillContentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillContent(requestParameters.id, requestParameters.billVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get download URL for bill content - UPDATED TO BE A PROXY ENDPOINT Now returns the actual file stream instead of a SAS URL
     * @param {DefaultApiGetBillDownloadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillDownloadUrl(requestParameters: DefaultApiGetBillDownloadUrlRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillDownloadUrl(requestParameters.id, requestParameters.billVersionId, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillHistory(requestParameters: DefaultApiGetBillHistoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillHistory(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillNotes(requestParameters: DefaultApiGetBillNotesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillNotes(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillPriorityImpactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillPriorityImpact(requestParameters: DefaultApiGetBillPriorityImpactRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillPriorityImpact(requestParameters.masterBillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillRemarksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillRemarks(requestParameters: DefaultApiGetBillRemarksRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillRemarks(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillReport(requestParameters: DefaultApiGetBillReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillReport(requestParameters.advancedSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillSimilarAiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillSimilarAi(requestParameters: DefaultApiGetBillSimilarAiRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillSimilarAi(requestParameters.id, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillStatutesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillStatutes(requestParameters: DefaultApiGetBillStatutesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillStatutes(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillSubjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillSubjects(requestParameters: DefaultApiGetBillSubjectsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillSubjects(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillSupportingDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillSupportingDocuments(requestParameters: DefaultApiGetBillSupportingDocumentsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillSupportingDocuments(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillTags(requestParameters: DefaultApiGetBillTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillTags(requestParameters.billId, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get testimony for a specific bill
     * @param {DefaultApiGetBillTestimonyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillTestimony(requestParameters: DefaultApiGetBillTestimonyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillTestimony(requestParameters.masterBillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillTextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillText(requestParameters: DefaultApiGetBillTextRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillText(requestParameters.id, requestParameters.billVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillVersionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillVersions(requestParameters: DefaultApiGetBillVersionsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillVersions(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillVotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillVotes(requestParameters: DefaultApiGetBillVotesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillVotes(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBills(requestParameters: DefaultApiGetBillsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBills(requestParameters.page, requestParameters.pageSize, requestParameters.stateCode, requestParameters.sessionCode, requestParameters.sessionCodes, requestParameters.subjects, requestParameters.searchTerm, requestParameters.types, requestParameters.authorName, requestParameters.statuteSection, requestParameters.statuteCode, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.parties, requestParameters.textSearch, requestParameters.rerankCompanyId, requestParameters.rerankProgress, requestParameters.onlyCommitteeChairFiled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetBillsWithHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBillsWithHistory(requestParameters: DefaultApiGetBillsWithHistoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBillsWithHistory(requestParameters.onlyWithHistory, requestParameters.onlyTrackedTags, requestParameters.types, requestParameters.limit, requestParameters.page, requestParameters.historyDateFrom, requestParameters.historyDateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cache statistics
     * @param {DefaultApiGetCacheStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCacheStats(requestParameters: DefaultApiGetCacheStatsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCacheStats(requestParameters.xApiKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetCalendarEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCalendarEvents(requestParameters: DefaultApiGetCalendarEventsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCalendarEvents(requestParameters.stateCodes, requestParameters.sessionCode, requestParameters.eventTypeIds, requestParameters.includeUserEvents, requestParameters.includeAccountEvents, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get campaign finance data with various filters
     * @param {DefaultApiGetCampaignFinanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCampaignFinance(requestParameters: DefaultApiGetCampaignFinanceRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCampaignFinance(requestParameters.stateCode, requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.filerName, requestParameters.contributorOrganization, requestParameters.contributorFirstName, requestParameters.contributorLastName, requestParameters.contributorState, requestParameters.year, requestParameters.minAmount, requestParameters.maxAmount, requestParameters.isLobbyist, requestParameters.isMember, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get campaign finance filers
     * @param {DefaultApiGetCampaignFinanceFilersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCampaignFinanceFilers(requestParameters: DefaultApiGetCampaignFinanceFilersRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCampaignFinanceFilers(requestParameters.search, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get chat history for the current session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getChatHistory(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getChatHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetClientBillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getClientBills(requestParameters: DefaultApiGetClientBillsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getClientBills(requestParameters.companyId, requestParameters.sessionCode, requestParameters.includeInactiveSessions, requestParameters.includeAutoUnsorted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetClientCommitteeActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getClientCommitteeActivity(requestParameters: DefaultApiGetClientCommitteeActivityRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getClientCommitteeActivity(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetClientContributionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getClientContributions(requestParameters: DefaultApiGetClientContributionsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getClientContributions(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetClientDashboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getClientDashboard(requestParameters: DefaultApiGetClientDashboardRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getClientDashboard(requestParameters.includeInactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetClientDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getClientDetails(requestParameters: DefaultApiGetClientDetailsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getClientDetails(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Video Clip.
     * @param {DefaultApiGetClipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getClip(requestParameters: DefaultApiGetClipRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getClip(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCluster(requestParameters: DefaultApiGetClusterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCluster(requestParameters.masterCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetCombinedCalendarEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCombinedCalendarEvents(requestParameters: DefaultApiGetCombinedCalendarEventsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCombinedCalendarEvents(requestParameters.stateCodes, requestParameters.sessionCode, requestParameters.eventTypeIds, requestParameters.includeUserEvents, requestParameters.includeAccountEvents, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full detail for one committee session by its ID
     * @param {DefaultApiGetCommitteeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommittee(requestParameters: DefaultApiGetCommitteeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommittee(requestParameters.id, requestParameters.sessionCode, requestParameters.sections, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recent activity for Committee Agent
     * @param {DefaultApiGetCommitteeAgentRecentActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeAgentRecentActivity(requestParameters: DefaultApiGetCommitteeAgentRecentActivityRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeAgentRecentActivity(requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeAgentStates(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeAgentStates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Committee Agent statistics for the current account
     * @param {DefaultApiGetCommitteeAgentStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeAgentStats(requestParameters: DefaultApiGetCommitteeAgentStatsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeAgentStats(requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetCommitteeAlertsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeAlerts(requestParameters: DefaultApiGetCommitteeAlertsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeAlerts(requestParameters.committeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get committee analysis for the current account
     * @param {DefaultApiGetCommitteeAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeAnalysis(requestParameters: DefaultApiGetCommitteeAnalysisRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeAnalysis(requestParameters.minPriority, requestParameters.minImpact, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single committee analysis by ID
     * @param {DefaultApiGetCommitteeAnalysisByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeAnalysisById(requestParameters: DefaultApiGetCommitteeAnalysisByIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeAnalysisById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all clips from CommitteeVideoClips table
     * @param {DefaultApiGetCommitteeClipsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeClips(requestParameters: DefaultApiGetCommitteeClipsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeClips(requestParameters.viewScope, requestParameters.limit, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all summaries from CommitteeVideoSummaries table
     * @param {DefaultApiGetCommitteeSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeSummaries(requestParameters: DefaultApiGetCommitteeSummariesRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeSummaries(requestParameters.viewScope, requestParameters.limit, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of CommitteeVideo, optionally filtered by state and with text search support.
     * @param {DefaultApiGetCommitteeVideoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeVideo(requestParameters: DefaultApiGetCommitteeVideoRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeVideo(requestParameters.page, requestParameters.pageSize, requestParameters.stateCode, requestParameters.sessionCode, requestParameters.chamber, requestParameters.committee, requestParameters.year, requestParameters.month, requestParameters.searchTerm, requestParameters.textSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get full detail for one committee video by its ID
     * @param {DefaultApiGetCommitteeVideoByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommitteeVideoById(requestParameters: DefaultApiGetCommitteeVideoByIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommitteeVideoById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of all committee sessions in a given state + session
     * @param {DefaultApiGetCommitteesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommittees(requestParameters: DefaultApiGetCommitteesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommittees(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.searchTerm, requestParameters.includeNonSession, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of companies with pagination, searching, and sorting.
     * @param {DefaultApiGetCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompanies(requestParameters: DefaultApiGetCompaniesRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanies(requestParameters.state, requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.aiSearch, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get companies of interest based on user\'s tracked bills and recent bills. Uses bill embeddings from Pinecone to find relevant companies.
     * @param {DefaultApiGetCompaniesOfInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompaniesOfInterest(requestParameters: DefaultApiGetCompaniesOfInterestRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompaniesOfInterest(requestParameters.stateCode, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get companies that the user has configured keywords for. Returns only companies that appear as keys in the user\'s BillKeywords config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompaniesWithKeywords(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompaniesWithKeywords(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single company by its CompanyID.
     * @param {DefaultApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompany(requestParameters: DefaultApiGetCompanyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompany(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetCompanyAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompanyAnalytics(requestParameters: DefaultApiGetCompanyAnalyticsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanyAnalytics(requestParameters.stateCode, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetCompanyBillsOfInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompanyBillsOfInterest(requestParameters: DefaultApiGetCompanyBillsOfInterestRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanyBillsOfInterest(requestParameters.id, requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get contributions for a specific company
     * @param {DefaultApiGetCompanyContributionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompanyContributions(requestParameters: DefaultApiGetCompanyContributionsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanyContributions(requestParameters.companyId, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get firm engagements for a given company.
     * @param {DefaultApiGetCompanyFirmEngagementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompanyFirmEngagements(requestParameters: DefaultApiGetCompanyFirmEngagementsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanyFirmEngagements(requestParameters.id, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all state variants for a company, grouped by MasterCompanyID. Returns a list of company ids and their state codes so the UI can switch states.
     * @param {DefaultApiGetCompanyStatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompanyStates(requestParameters: DefaultApiGetCompanyStatesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanyStates(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get testimony for a specific company
     * @param {DefaultApiGetCompanyTestimonyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompanyTestimony(requestParameters: DefaultApiGetCompanyTestimonyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanyTestimony(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetCompanyTickSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCompanyTickSheet(requestParameters: DefaultApiGetCompanyTickSheetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCompanyTickSheet(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get concatenated regulations for an entire parent level
     * @param {DefaultApiGetConcatenatedParentLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getConcatenatedParentLevel(requestParameters: DefaultApiGetConcatenatedParentLevelRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConcatenatedParentLevel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetDashboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDashboard(requestParameters: DefaultApiGetDashboardRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDashboard(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all documents for a remark
     * @param {DefaultApiGetDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDocuments(requestParameters: DefaultApiGetDocumentsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDocuments(requestParameters.remarkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEventTypes(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEventTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetExternalTrackingCountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getExternalTrackingCounts(requestParameters: DefaultApiGetExternalTrackingCountsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getExternalTrackingCounts(requestParameters.billIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetFilesByBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFilesByBill(requestParameters: DefaultApiGetFilesByBillRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFilesByBill(requestParameters.masterBillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single firm by its FirmID with all associated lobbyists.
     * @param {DefaultApiGetFirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFirm(requestParameters: DefaultApiGetFirmRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFirm(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetFirmAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFirmAnalytics(requestParameters: DefaultApiGetFirmAnalyticsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFirmAnalytics(requestParameters.stateCode, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get firm engagements for a given firm.
     * @param {DefaultApiGetFirmEngagementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFirmEngagements(requestParameters: DefaultApiGetFirmEngagementsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFirmEngagements(requestParameters.id, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of firms with pagination, searching, and sorting.
     * @param {DefaultApiGetFirmsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFirms(requestParameters: DefaultApiGetFirmsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFirms(requestParameters.stateCode, requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFolderTree(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFolderTree(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetGmailIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGmailIntegration(requestParameters: DefaultApiGetGmailIntegrationRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGmailIntegration(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetGmailOAuthUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGmailOAuthUrl(requestParameters: DefaultApiGetGmailOAuthUrlRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGmailOAuthUrl(requestParameters.accountId, requestParameters.redirectUri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIsAccountNew(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIsAccountNew(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetIssueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIssue(requestParameters: DefaultApiGetIssueRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIssue(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetIssuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIssues(requestParameters: DefaultApiGetIssuesRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIssues(requestParameters.status, requestParameters.issueType, requestParameters.priority, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get keyword clips for the current account (all users in the account)
     * @param {DefaultApiGetKeywordClipsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getKeywordClips(requestParameters: DefaultApiGetKeywordClipsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getKeywordClips(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetKeywordGenerationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getKeywordGenerationStatus(requestParameters: DefaultApiGetKeywordGenerationStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getKeywordGenerationStatus(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLatest(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLatest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLatestBillContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLatestBillContent(requestParameters: DefaultApiGetLatestBillContentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLatestBillContent(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get latest bill match from AutoTrackReasoning
     * @param {DefaultApiGetLatestMatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLatestMatch(requestParameters: DefaultApiGetLatestMatchRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLatestMatch(requestParameters.accountId, requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLegislatorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLegislators(requestParameters: DefaultApiGetLegislatorsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLegislators(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recent live actions filtered by state
     * @param {DefaultApiGetLiveActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLiveActions(requestParameters: DefaultApiGetLiveActionsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLiveActions(requestParameters.stateCodes, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch by exactly one of lobbyistId, companyId, masterCompanyId, or companySearch.
     * @param {DefaultApiGetLobbyEngagementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyEngagements(requestParameters: DefaultApiGetLobbyEngagementsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyEngagements(requestParameters.lobbyistId, requestParameters.companyId, requestParameters.masterCompanyId, requestParameters.year, requestParameters.companySearch, requestParameters.stateCode, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLobbyistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyist(requestParameters: DefaultApiGetLobbyistRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyist(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLobbyistAlertsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyistAlerts(requestParameters: DefaultApiGetLobbyistAlertsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyistAlerts(requestParameters.lobbyistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLobbyistAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyistAnalytics(requestParameters: DefaultApiGetLobbyistAnalyticsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyistAnalytics(requestParameters.stateCode, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLobbyistClientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyistClients(requestParameters: DefaultApiGetLobbyistClientsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyistClients(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Contributions filtered by lobbyist and/or company.
     * @param {DefaultApiGetLobbyistContributionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyistContributions(requestParameters: DefaultApiGetLobbyistContributionsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyistContributions(requestParameters.lobbyistId, requestParameters.companyId, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLobbyistTestimonyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyistTestimony(requestParameters: DefaultApiGetLobbyistTestimonyRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyistTestimony(requestParameters.lobbyistId, requestParameters.companyId, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLobbyistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyists(requestParameters: DefaultApiGetLobbyistsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyists(requestParameters.stateCode, requestParameters.page, requestParameters.limit, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetLobbyistsByStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLobbyistsByState(requestParameters: DefaultApiGetLobbyistsByStateRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLobbyistsByState(requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed information for a single member
     * @param {DefaultApiGetMemberByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberById(requestParameters: DefaultApiGetMemberByIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberById(requestParameters.id, requestParameters.sessionCode, requestParameters.includeAuthoredBills, requestParameters.includePassedBills, requestParameters.includeSponsoredBills, requestParameters.includeCoSponsors, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get co-sponsors for a member
     * @param {DefaultApiGetMemberCoSponsorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberCoSponsors(requestParameters: DefaultApiGetMemberCoSponsorsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberCoSponsors(requestParameters.id, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get contact information for multiple members in batch This is a lightweight endpoint that only fetches contact data without expensive stats calculations
     * @param {DefaultApiGetMemberContactsBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberContactsBatch(requestParameters: DefaultApiGetMemberContactsBatchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberContactsBatch(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.chamber, requestParameters.memberIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get district demographics for a member
     * @param {DefaultApiGetMemberDemographicsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberDemographics(requestParameters: DefaultApiGetMemberDemographicsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberDemographics(requestParameters.id, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get available filter options (chambers and parties) for a state/session
     * @param {DefaultApiGetMemberFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberFilters(requestParameters: DefaultApiGetMemberFiltersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberFilters(requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single member image
     * @param {DefaultApiGetMemberImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberImage(requestParameters: DefaultApiGetMemberImageRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberImage(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Proxy endpoint for member images - provides access without exposing SAS URLs Member images are public, so no authentication required  IMPORTANT: This route MUST be defined before the generic getMemberById (\'{id}\') route. Otherwise, Express will match \'/api/members/123/image\' as getMemberById with id=\'123/image\'.
     * @param {DefaultApiGetMemberImage0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberImage_2(requestParameters: DefaultApiGetMemberImage0Request, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberImage_2(requestParameters.id, requestParameters.ext, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get multiple member images in bulk
     * @param {DefaultApiGetMemberImagesBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberImagesBulk(requestParameters: DefaultApiGetMemberImagesBulkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberImagesBulk(requestParameters.memberImagesBulkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get member statistics leaderboards for a state Shows stats from the last completed regular session
     * @param {DefaultApiGetMemberLeaderboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberLeaderboards(requestParameters: DefaultApiGetMemberLeaderboardsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberLeaderboards(requestParameters.stateCode, requestParameters.currentSessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetMemberListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberList(requestParameters: DefaultApiGetMemberListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetMemberListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberLists(requestParameters: DefaultApiGetMemberListsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberLists(requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetMemberPublicContributionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberPublicContributions(requestParameters: DefaultApiGetMemberPublicContributionsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberPublicContributions(requestParameters.memberId, requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetMemberRelationshipsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberRelationships(requestParameters: DefaultApiGetMemberRelationshipsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberRelationships(requestParameters.memberId, requestParameters.accountId, requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetMemberTickSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMemberTickSheet(requestParameters: DefaultApiGetMemberTickSheetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMemberTickSheet(requestParameters.billId, requestParameters.chamber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all members for a given state and session
     * @param {DefaultApiGetMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMembers(requestParameters: DefaultApiGetMembersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMembers(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.page, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.chamber, requestParameters.party, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMyAccounts(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMyAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getNotifications(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payment history (invoices) for the authenticated user\'s account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentHistory(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPendingFullAccountInvitations(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPendingFullAccountInvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPendingInvitations(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPendingInvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetPendingRegistrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPendingRegistration(requestParameters: DefaultApiGetPendingRegistrationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPendingRegistration(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetPersonalBillRemarksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPersonalBillRemarks(requestParameters: DefaultApiGetPersonalBillRemarksRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPersonalBillRemarks(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPlans(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetPopulateAdvancedFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPopulateAdvancedFilters(requestParameters: DefaultApiGetPopulateAdvancedFiltersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPopulateAdvancedFilters(requestParameters.state, requestParameters.session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get priority bills for the current account
     * @param {DefaultApiGetPriorityBillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPriorityBills(requestParameters: DefaultApiGetPriorityBillsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPriorityBills(requestParameters.accountId, requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recent activity for Bill Agent
     * @param {DefaultApiGetRecentActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRecentActivity(requestParameters: DefaultApiGetRecentActivityRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRecentActivity(requestParameters.accountId, requestParameters.viewScope, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recent committee analysis
     * @param {DefaultApiGetRecentAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRecentAnalysis(requestParameters: DefaultApiGetRecentAnalysisRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRecentAnalysis(requestParameters.viewScope, requestParameters.limit, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recent committee analysis (for dashboard widget)
     * @param {DefaultApiGetRecentCommitteeAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRecentCommitteeAnalysis(requestParameters: DefaultApiGetRecentCommitteeAnalysisRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRecentCommitteeAnalysis(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRecentReports(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRecentReports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get regulation details by ID
     * @param {DefaultApiGetRegByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRegById(requestParameters: DefaultApiGetRegByIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRegById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get companies related to a specific regulation
     * @param {DefaultApiGetRegCompaniesOfInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRegCompaniesOfInterest(requestParameters: DefaultApiGetRegCompaniesOfInterestRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRegCompaniesOfInterest(requestParameters.id, requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get items for a specific hierarchy level
     * @param {DefaultApiGetRegHierarchyItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRegHierarchyItems(requestParameters: DefaultApiGetRegHierarchyItemsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRegHierarchyItems(requestParameters.state, requestParameters.level, requestParameters.page, requestParameters.pageSize, requestParameters.level1, requestParameters.level2, requestParameters.level3, requestParameters.level4, requestParameters.level5, requestParameters.level6, requestParameters.level7, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get regulations for the selected hierarchy path
     * @param {DefaultApiGetRegHierarchyRegsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRegHierarchyRegs(requestParameters: DefaultApiGetRegHierarchyRegsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRegHierarchyRegs(requestParameters.state, requestParameters.page, requestParameters.pageSize, requestParameters.level1, requestParameters.level2, requestParameters.level3, requestParameters.level4, requestParameters.level5, requestParameters.level6, requestParameters.level7, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get hierarchy overview for all states
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRegHierarchyStateCounts(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRegHierarchyStateCounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get hierarchy structure for a specific state
     * @param {DefaultApiGetRegHierarchyStructureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRegHierarchyStructure(requestParameters: DefaultApiGetRegHierarchyStructureRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRegHierarchyStructure(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get bills related to a specific statute
     * @param {DefaultApiGetRelatedBillsByStatuteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRelatedBillsByStatute(requestParameters: DefaultApiGetRelatedBillsByStatuteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRelatedBillsByStatute(requestParameters.statutoryCode, requestParameters.reference, requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetReportContactListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getReportContactList(requestParameters: DefaultApiGetReportContactListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getReportContactList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getReportContactLists(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getReportContactLists(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getReportSettings(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getReportSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getReportStats(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getReportStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetSavedTickSheetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSavedTickSheets(requestParameters: DefaultApiGetSavedTickSheetsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSavedTickSheets(requestParameters.billId, requestParameters.chamber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetSavedTickSheets0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSavedTickSheets_3(requestParameters: DefaultApiGetSavedTickSheets0Request, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSavedTickSheets_3(requestParameters.billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getScheduleTimezones(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getScheduleTimezones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getScheduledReports(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getScheduledReports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSeats(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSeats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetSectionTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSectionTags(requestParameters: DefaultApiGetSectionTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSectionTags(requestParameters.sectionId, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSessions(requestParameters: DefaultApiGetSessionsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSessions(requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetSharedTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSharedTags(requestParameters: DefaultApiGetSharedTagsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSharedTags(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetSlackIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackIntegration(requestParameters: DefaultApiGetSlackIntegrationRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackIntegration(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get staff for a given state and session
     * @param {DefaultApiGetStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStaff(requestParameters: DefaultApiGetStaffRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStaff(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.memberId, requestParameters.position, requestParameters.page, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStakeholderContacts(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStakeholderContacts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetStakeholderMeetingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStakeholderMeetings(requestParameters: DefaultApiGetStakeholderMeetingsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStakeholderMeetings(requestParameters.stakeholderId, requestParameters.accountId, requestParameters.masterBillId, requestParameters.companyId, requestParameters.meetingType, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of State Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStateCodes(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStateCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all members for a given state
     * @param {DefaultApiGetStateMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStateMembers(requestParameters: DefaultApiGetStateMembersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStateMembers(requestParameters.stateCode, requestParameters.searchTerm, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStats(requestParameters: DefaultApiGetStatsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStats(requestParameters.scope, requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStatus(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the blob URL for a statute
     * @param {DefaultApiGetStatuteBlobUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStatuteBlobUrl(requestParameters: DefaultApiGetStatuteBlobUrlRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStatuteBlobUrl(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statute details by ID
     * @param {DefaultApiGetStatuteByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStatuteById(requestParameters: DefaultApiGetStatuteByIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStatuteById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get companies related to a specific statute
     * @param {DefaultApiGetStatuteCompaniesOfInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStatuteCompaniesOfInterest(requestParameters: DefaultApiGetStatuteCompaniesOfInterestRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStatuteCompaniesOfInterest(requestParameters.id, requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get items for a specific hierarchy level
     * @param {DefaultApiGetStatuteHierarchyItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStatuteHierarchyItems(requestParameters: DefaultApiGetStatuteHierarchyItemsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStatuteHierarchyItems(requestParameters.state, requestParameters.level, requestParameters.page, requestParameters.pageSize, requestParameters.code, requestParameters.title, requestParameters.subtitle, requestParameters.article, requestParameters.chapter, requestParameters.subchapter, requestParameters.section, requestParameters.subsection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get hierarchy overview for all states
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStatuteHierarchyStateCounts(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStatuteHierarchyStateCounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statutes for the selected hierarchy path
     * @param {DefaultApiGetStatuteHierarchyStatutesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStatuteHierarchyStatutes(requestParameters: DefaultApiGetStatuteHierarchyStatutesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStatuteHierarchyStatutes(requestParameters.state, requestParameters.page, requestParameters.pageSize, requestParameters.code, requestParameters.title, requestParameters.subtitle, requestParameters.article, requestParameters.chapter, requestParameters.subchapter, requestParameters.section, requestParameters.subsection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get hierarchy structure for a specific state
     * @param {DefaultApiGetStatuteHierarchyStructureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStatuteHierarchyStructure(requestParameters: DefaultApiGetStatuteHierarchyStructureRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStatuteHierarchyStructure(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetSubjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSubjects(requestParameters: DefaultApiGetSubjectsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSubjects(requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get current subscription details for the authenticated user\'s account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSubscriptionDetails(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSubscriptionDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTagCompanyAssignmentStatus(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTagCompanyAssignmentStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTags(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTask(requestParameters: DefaultApiGetTaskRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTask(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTaskFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTaskFiles(requestParameters: DefaultApiGetTaskFilesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTaskFiles(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTaskNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTaskNotes(requestParameters: DefaultApiGetTaskNotesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTaskNotes(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTasks(requestParameters: DefaultApiGetTasksRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTasks(requestParameters.userId, requestParameters.teamId, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeam(requestParameters: DefaultApiGetTeamRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeam(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTeamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeams(requestParameters: DefaultApiGetTeamsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeams(requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTickSheetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTickSheetById(requestParameters: DefaultApiGetTickSheetByIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTickSheetById(requestParameters.billId, requestParameters.tickSheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTickSheetById0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTickSheetById_4(requestParameters: DefaultApiGetTickSheetById0Request, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTickSheetById_4(requestParameters.billId, requestParameters.tickSheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTrackListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackList(requestParameters: DefaultApiGetTrackListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackList(requestParameters.trackListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackedActivityEmails(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackedActivityEmails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackedActivityReport(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackedActivityReport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recent bill history for all bills tracked by the user or account
     * @param {DefaultApiGetTrackedBillActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackedBillActivity(requestParameters: DefaultApiGetTrackedBillActivityRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackedBillActivity(requestParameters.scope, requestParameters.days, requestParameters.page, requestParameters.pageSize, requestParameters.activityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTrackedBillProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackedBillProgress(requestParameters: DefaultApiGetTrackedBillProgressRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackedBillProgress(requestParameters.scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTrackedBillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackedBills(requestParameters: DefaultApiGetTrackedBillsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackedBills(requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.states, requestParameters.sessionKeys, requestParameters.activeOnly, requestParameters.tagIds, requestParameters.tagLogic, requestParameters.trackTypes, requestParameters.progressStatuses, requestParameters.alertsOnly, requestParameters.excludeLobbyistUsers, requestParameters.viewScope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get live actions for tracked bills
     * @param {DefaultApiGetTrackedLiveActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackedLiveActions(requestParameters: DefaultApiGetTrackedLiveActionsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackedLiveActions(requestParameters.scope, requestParameters.days, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of live actions for tracked bills
     * @param {DefaultApiGetTrackedLiveActionsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackedLiveActionsCount(requestParameters: DefaultApiGetTrackedLiveActionsCountRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackedLiveActionsCount(requestParameters.scope, requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackedWitnesses(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackedWitnesses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetTrackingActivityReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrackingActivityReport(requestParameters: DefaultApiGetTrackingActivityReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrackingActivityReport(requestParameters.advancedSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get upcoming committee hearings for a given state
     * @param {DefaultApiGetUpcomingHearingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUpcomingHearings(requestParameters: DefaultApiGetUpcomingHearingsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUpcomingHearings(requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get upcoming hearings with tracked bills
     * @param {DefaultApiGetUpcomingHearings0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUpcomingHearings_5(requestParameters: DefaultApiGetUpcomingHearings0Request = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUpcomingHearings_5(requestParameters.viewScope, requestParameters.limit, requestParameters.sortedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUser(requestParameters: DefaultApiGetUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetUserAutoTrackStatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserAutoTrackStates(requestParameters: DefaultApiGetUserAutoTrackStatesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserAutoTrackStates(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserContacts(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserContacts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetUserFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserFiles(requestParameters: DefaultApiGetUserFilesRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserFiles(requestParameters.folderId, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserSettings(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetUserTaskMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserTaskMetrics(requestParameters: DefaultApiGetUserTaskMetricsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserTaskMetrics(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetUserTrackedActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserTrackedActivity(requestParameters: DefaultApiGetUserTrackedActivityRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserTrackedActivity(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get calendar events for bills tracked by the current user
     * @param {DefaultApiGetUserTrackedBillCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserTrackedBillCalendar(requestParameters: DefaultApiGetUserTrackedBillCalendarRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserTrackedBillCalendar(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUsers(requestParameters: DefaultApiGetUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUsers(requestParameters.roleName, requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetValidYearsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getValidYears(requestParameters: DefaultApiGetValidYearsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getValidYears(requestParameters.lobbyistId, requestParameters.companyId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all saved clip sets for a video
     * @param {DefaultApiGetVideoClipsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVideoClips(requestParameters: DefaultApiGetVideoClipsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVideoClips(requestParameters.videoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all saved summaries for a video
     * @param {DefaultApiGetVideoSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVideoSummaries(requestParameters: DefaultApiGetVideoSummariesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVideoSummaries(requestParameters.videoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed voting records (including member info) for a specific vote.
     * @param {DefaultApiGetVoteDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVoteDetails(requestParameters: DefaultApiGetVoteDetailsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVoteDetails(requestParameters.voteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetVoteReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVoteReport(requestParameters: DefaultApiGetVoteReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVoteReport(requestParameters.voteReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiImportReportContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importReportContacts(requestParameters: DefaultApiImportReportContactsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importReportContacts(requestParameters.importReportContactsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiInviteAnalystRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inviteAnalyst(requestParameters: DefaultApiInviteAnalystRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inviteAnalyst(requestParameters.inviteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiInviteFullAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inviteFullAccount(requestParameters: DefaultApiInviteFullAccountRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inviteFullAccount(requestParameters.inviteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if a session is currently active (SineDie = 0)
     * @param {DefaultApiIsSessionActiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public isSessionActive(requestParameters: DefaultApiIsSessionActiveRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).isSessionActive(requestParameters.stateCode, requestParameters.sessionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiListBillPositionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listBillPositions(requestParameters: DefaultApiListBillPositionsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listBillPositions(requestParameters.billId, requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiLogInteractionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public logInteraction(requestParameters: DefaultApiLogInteractionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).logInteraction(requestParameters.companyId, requestParameters.interactionPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Login a user
     * @param {DefaultApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public login(requestParameters: DefaultApiLoginRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).login(requestParameters.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logout the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiMarkAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public markAsRead(requestParameters: DefaultApiMarkAsReadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).markAsRead(requestParameters.markAsReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiMoveFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public moveFile(requestParameters: DefaultApiMoveFileRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).moveFile(requestParameters.fileId, requestParameters.moveFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPeelCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public peelCompanies(requestParameters: DefaultApiPeelCompaniesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).peelCompanies(requestParameters.masterCompanyId, requestParameters.peelClusterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPurchaseSeatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public purchaseSeats(requestParameters: DefaultApiPurchaseSeatsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).purchaseSeats(requestParameters.purchaseSeatsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query the AI assistant for bill analysis
     * @param {DefaultApiQueryAiChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public queryAiChat(requestParameters: DefaultApiQueryAiChatRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).queryAiChat(requestParameters.chatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query the AI assistant for video transcript analysis
     * @param {DefaultApiQueryVideoChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public queryVideoChat(requestParameters: DefaultApiQueryVideoChatRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).queryVideoChat(requestParameters.videoQuestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Queue background keyword generation for one or more companies
     * @param {DefaultApiQueueKeywordGenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public queueKeywordGeneration(requestParameters: DefaultApiQueueKeywordGenerationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).queueKeywordGeneration(requestParameters.queueKeywordGenerationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reactivate a canceled subscription (before period end)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public reactivateSubscription(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reactivateSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public refreshCalendarCache(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).refreshCalendarCache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public refreshDashboardCache(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).refreshDashboardCache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public refreshExistingCache(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).refreshExistingCache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public refreshMainDashboardCache(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).refreshMainDashboardCache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public refreshUserDashboardCache(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).refreshUserDashboardCache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a new user
     * @param {DefaultApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public register(requestParameters: DefaultApiRegisterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).register(requestParameters.insertUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRejectAutoTrackedBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rejectAutoTrackedBill(requestParameters: DefaultApiRejectAutoTrackedBillRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rejectAutoTrackedBill(requestParameters.rejectAutoTrackedBillBody, requestParameters.bypassAccessCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRemoveTeamMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeTeamMember(requestParameters: DefaultApiRemoveTeamMemberRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).removeTeamMember(requestParameters.id, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRemoveTrackedBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeTrackedBill(requestParameters: DefaultApiRemoveTrackedBillRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).removeTrackedBill(requestParameters.removeTrackedBillBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRemoveTrackedWitnessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeTrackedWitness(requestParameters: DefaultApiRemoveTrackedWitnessRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).removeTrackedWitness(requestParameters.witnessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRenameFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public renameFile(requestParameters: DefaultApiRenameFileRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).renameFile(requestParameters.fileId, requestParameters.renameFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRenameFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public renameFolder(requestParameters: DefaultApiRenameFolderRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).renameFolder(requestParameters.folderId, requestParameters.renameFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report missing live stream
     * @param {DefaultApiReportMissingLiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public reportMissingLive(requestParameters: DefaultApiReportMissingLiveRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reportMissingLive(requestParameters.missingLiveReportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate and automatically regenerate a summary when it does not match the company. This endpoint returns immediately and processes the validation/regeneration in the background.
     * @param {DefaultApiReportWrongCompanySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public reportWrongCompanySummary(requestParameters: DefaultApiReportWrongCompanySummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reportWrongCompanySummary(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRequestMissingParamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestMissingParams(requestParameters: DefaultApiRequestMissingParamsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestMissingParams(requestParameters.missingParamsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRevokeInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public revokeInvitation(requestParameters: DefaultApiRevokeInvitationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).revokeInvitation(requestParameters.invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiRunScheduledReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public runScheduledReport(requestParameters: DefaultApiRunScheduledReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).runScheduledReport(requestParameters.scheduledReportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveAccountCompanyClaimsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveAccountCompanyClaims(requestParameters: DefaultApiSaveAccountCompanyClaimsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveAccountCompanyClaims(requestParameters.saveAccountCompanyClaimsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveAccountCompanySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveAccountCompanySummary(requestParameters: DefaultApiSaveAccountCompanySummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveAccountCompanySummary(requestParameters.saveAccountCompanySummaryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveAutoTrackCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveAutoTrackCompanies(requestParameters: DefaultApiSaveAutoTrackCompaniesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveAutoTrackCompanies(requestParameters.saveAutoTrackCompaniesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveAutoTrackStatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveAutoTrackStates(requestParameters: DefaultApiSaveAutoTrackStatesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveAutoTrackStates(requestParameters.saveAutoTrackStatesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveBillAlertRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveBillAlert(requestParameters: DefaultApiSaveBillAlertRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveBillAlert(requestParameters.saveBillAlertBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveBillTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveBillTags(requestParameters: DefaultApiSaveBillTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveBillTags(requestParameters.saveBillTagsBody, requestParameters.bypassAccessCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveCommitteeAgentStatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveCommitteeAgentStates(requestParameters: DefaultApiSaveCommitteeAgentStatesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveCommitteeAgentStates(requestParameters.saveCommitteeAgentStatesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveCommitteeAlertRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveCommitteeAlert(requestParameters: DefaultApiSaveCommitteeAlertRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveCommitteeAlert(requestParameters.saveCommitteeAlertBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveCompanyTickSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveCompanyTickSheet(requestParameters: DefaultApiSaveCompanyTickSheetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveCompanyTickSheet(requestParameters.billId, requestParameters.saveCompanyTickSheetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveLobbyistAlertRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveLobbyistAlert(requestParameters: DefaultApiSaveLobbyistAlertRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveLobbyistAlert(requestParameters.saveLobbyistAlertBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveMemberTickSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveMemberTickSheet(requestParameters: DefaultApiSaveMemberTickSheetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveMemberTickSheet(requestParameters.billId, requestParameters.saveMemberTickSheetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveReportSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveReportSetting(requestParameters: DefaultApiSaveReportSettingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveReportSetting(requestParameters.saveReportSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveSectionTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveSectionTags(requestParameters: DefaultApiSaveSectionTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveSectionTags(requestParameters.saveSectionTagsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSaveUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveUserSettings(requestParameters: DefaultApiSaveUserSettingsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveUserSettings(requestParameters.saveUserSettingsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiScheduleReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public scheduleReport(requestParameters: DefaultApiScheduleReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).scheduleReport(requestParameters.scheduleReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search the bills index using ElasticSearch
     * @param {DefaultApiSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public search(requestParameters: DefaultApiSearchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).search(requestParameters.term, requestParameters.page, requestParameters.limit, requestParameters.stateCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for companies by name, returns one representative company per MasterCompanyID with lobbyist count. Used for the invite page searchbar.
     * @param {DefaultApiSearchCompaniesForInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchCompaniesForInvite(requestParameters: DefaultApiSearchCompaniesForInviteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchCompaniesForInvite(requestParameters.search, requestParameters.stateCode, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search regulations via word or AI search
     * @param {DefaultApiSearchRegsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchRegs(requestParameters: DefaultApiSearchRegsRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchRegs(requestParameters.query, requestParameters.searchMode, requestParameters.wordQuery, requestParameters.aiQuery, requestParameters.state, requestParameters.code, requestParameters.title, requestParameters.chapter, requestParameters.section, requestParameters.name, requestParameters.fileName, requestParameters.article, requestParameters.subtitle, requestParameters.subchapter, requestParameters.subsection, requestParameters.rule, requestParameters.part, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSearchRemarksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchRemarks(requestParameters: DefaultApiSearchRemarksRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchRemarks(requestParameters.stateCode, requestParameters.sessionCode, requestParameters.q, requestParameters.tags, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search statutes via word or AI search
     * @param {DefaultApiSearchStatutesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchStatutes(requestParameters: DefaultApiSearchStatutesRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchStatutes(requestParameters.query, requestParameters.searchMode, requestParameters.wordQuery, requestParameters.aiQuery, requestParameters.state, requestParameters.code, requestParameters.title, requestParameters.chapter, requestParameters.section, requestParameters.name, requestParameters.fileName, requestParameters.article, requestParameters.subtitle, requestParameters.subchapter, requestParameters.subsection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search committee videos by transcript text
     * @param {DefaultApiSearchVideosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchVideos(requestParameters: DefaultApiSearchVideosRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchVideos(requestParameters.term, requestParameters.page, requestParameters.limit, requestParameters.stateCodes, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSearchWitnessDirectoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchWitnessDirectory(requestParameters: DefaultApiSearchWitnessDirectoryRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchWitnessDirectory(requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSendAccountGmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendAccountGmail(requestParameters: DefaultApiSendAccountGmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendAccountGmail(requestParameters.gmailSendRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSendEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendEmail(requestParameters: DefaultApiSendEmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendEmail(requestParameters.emailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSendGmailTestMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendGmailTestMessage(requestParameters: DefaultApiSendGmailTestMessageRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendGmailTestMessage(requestParameters.sendGmailTestMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSendInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendInvite(requestParameters: DefaultApiSendInviteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendInvite(requestParameters.referralInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSendNewAnalystRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendNewAnalyst(requestParameters: DefaultApiSendNewAnalystRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendNewAnalyst(requestParameters.newAnalystRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSendSlackTestMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendSlackTestMessage(requestParameters: DefaultApiSendSlackTestMessageRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendSlackTestMessage(requestParameters.slackTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSendTaskReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendTaskReminder(requestParameters: DefaultApiSendTaskReminderRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendTaskReminder(requestParameters.id, requestParameters.sendTaskReminderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiShareTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public shareTag(requestParameters: DefaultApiShareTagRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).shareTag(requestParameters.shareTagBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSplitClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public splitCluster(requestParameters: DefaultApiSplitClusterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).splitCluster(requestParameters.masterCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiStartAutoTrackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public startAutoTrack(requestParameters: DefaultApiStartAutoTrackRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).startAutoTrack(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiSubscribeNewsletterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public subscribeNewsletter(requestParameters: DefaultApiSubscribeNewsletterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).subscribeNewsletter(requestParameters.subscribeNewsletterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a summary about an entity (company, lobbyist, or associate) based on their name
     * @param {DefaultApiSummarizeTextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public summarizeText(requestParameters: DefaultApiSummarizeTextRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).summarizeText(requestParameters.entitySummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test Elasticsearch connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public testConnection(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).testConnection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiTestKeywordMatchingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public testKeywordMatching(requestParameters: DefaultApiTestKeywordMatchingRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).testKeywordMatching(requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiToggleArchiveTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleArchiveTag(requestParameters: DefaultApiToggleArchiveTagRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleArchiveTag(requestParameters.tagId, requestParameters.toggleArchiveTagRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Track report download
     * @param {DefaultApiTrackReportDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public trackReportDownload(requestParameters: DefaultApiTrackReportDownloadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).trackReportDownload(requestParameters.trackDownloadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateAIStrengthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAIStrength(requestParameters: DefaultApiUpdateAIStrengthRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAIStrength(requestParameters.updateAIStrengthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update account with selected entity immediately
     * @param {DefaultApiUpdateAccountEntityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAccountEntity(requestParameters: DefaultApiUpdateAccountEntityRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAccountEntity(requestParameters.updateAccountEntityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Priority and/or Impact for a bill in AutoTrackReasoning
     * @param {DefaultApiUpdateBillPriorityImpactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateBillPriorityImpact(requestParameters: DefaultApiUpdateBillPriorityImpactRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateBillPriorityImpact(requestParameters.updateBillPriorityImpactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateClientTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateClientTags(requestParameters: DefaultApiUpdateClientTagsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateClientTags(requestParameters.companyId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the archived status for a saved clip set
     * @param {DefaultApiUpdateClipArchivedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateClipArchived(requestParameters: DefaultApiUpdateClipArchivedRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateClipArchived(requestParameters.clipSetId, requestParameters.updateClipArchivedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateCommitteeAgentEnabledRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCommitteeAgentEnabled(requestParameters: DefaultApiUpdateCommitteeAgentEnabledRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCommitteeAgentEnabled(requestParameters.updateCommitteeAgentEnabledRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateCompanyStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCompanyStatus(requestParameters: DefaultApiUpdateCompanyStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCompanyStatus(requestParameters.companyId, requestParameters.updateCompanyStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateCompanySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCompanySummary(requestParameters: DefaultApiUpdateCompanySummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCompanySummary(requestParameters.companyId, requestParameters.summaryPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateContact(requestParameters: DefaultApiUpdateContactRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateContact(requestParameters.companyId, requestParameters.contactId, requestParameters.contactPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateFolderColorSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFolderColorSetting(requestParameters: DefaultApiUpdateFolderColorSettingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFolderColorSetting(requestParameters.folderId, requestParameters.updateFolderColorSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateIssueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateIssue(requestParameters: DefaultApiUpdateIssueRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateIssue(requestParameters.id, requestParameters.updateIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateKeywordMatchViewedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateKeywordMatchViewed(requestParameters: DefaultApiUpdateKeywordMatchViewedRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateKeywordMatchViewed(requestParameters.updateKeywordMatchViewedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update keywords for an account after initial setup This allows keywords to be generated asynchronously and saved later
     * @param {DefaultApiUpdateKeywordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateKeywords(requestParameters: DefaultApiUpdateKeywordsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateKeywords(requestParameters.updateKeywordsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateMemberListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMemberList(requestParameters: DefaultApiUpdateMemberListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMemberList(requestParameters.id, requestParameters.updateMemberListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMetadata(requestParameters: DefaultApiUpdateMetadataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMetadata(requestParameters.fileId, requestParameters.updateMetadataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the priority and/or impact for a committee analysis record
     * @param {DefaultApiUpdatePriorityImpactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePriorityImpact(requestParameters: DefaultApiUpdatePriorityImpactRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePriorityImpact(requestParameters.id, requestParameters.updatePriorityImpactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateRemarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRemark(requestParameters: DefaultApiUpdateRemarkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateRemark(requestParameters.remarkId, requestParameters.updateBillRemarkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateReportSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateReportSetting(requestParameters: DefaultApiUpdateReportSettingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateReportSetting(requestParameters.updateReportSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateSeatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSeats(requestParameters: DefaultApiUpdateSeatsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSeats(requestParameters.updateSeatsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateStakeholderContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateStakeholderContact(requestParameters: DefaultApiUpdateStakeholderContactRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateStakeholderContact(requestParameters.stakeholderId, requestParameters.stakeholderContactInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateStakeholderMeetingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateStakeholderMeeting(requestParameters: DefaultApiUpdateStakeholderMeetingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateStakeholderMeeting(requestParameters.meetingId, requestParameters.stakeholderMeetingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTag(requestParameters: DefaultApiUpdateTagRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTag(requestParameters.tagId, requestParameters.updateTagRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTask(requestParameters: DefaultApiUpdateTaskRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTask(requestParameters.id, requestParameters.updateTaskDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTeam(requestParameters: DefaultApiUpdateTeamRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTeam(requestParameters.id, requestParameters.updateTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateTrackedActivityEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTrackedActivityEmails(requestParameters: DefaultApiUpdateTrackedActivityEmailsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTrackedActivityEmails(requestParameters.updateTrackedActivityEmailSettingsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateTrackingPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTrackingPreferences(requestParameters: DefaultApiUpdateTrackingPreferencesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTrackingPreferences(requestParameters.companyId, requestParameters.trackingPreferencesPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateUserAutoTrackAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserAutoTrackAccess(requestParameters: DefaultApiUpdateUserAutoTrackAccessRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserAutoTrackAccess(requestParameters.userId, requestParameters.updateUserAutoTrackAccessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the user\'s primary contact email. This is used when setting a lobbyist email.
     * @param {DefaultApiUpdateUserContactEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserContactEmail(requestParameters: DefaultApiUpdateUserContactEmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserContactEmail(requestParameters.updateUserContactEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserRole(requestParameters: DefaultApiUpdateUserRoleRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserRole(requestParameters.userId, requestParameters.updateUserRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateUserStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserStatus(requestParameters: DefaultApiUpdateUserStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserStatus(requestParameters.userId, requestParameters.updateUserStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUpdateUserTrackedActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserTrackedActivity(requestParameters: DefaultApiUpdateUserTrackedActivityRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserTrackedActivity(requestParameters.userId, requestParameters.updateTrackedActivityConfigBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the current user\'s username
     * @param {DefaultApiUpdateUsernameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUsername(requestParameters: DefaultApiUpdateUsernameRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUsername(requestParameters.updateUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadAccountLogoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadAccountLogo(requestParameters: DefaultApiUploadAccountLogoRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadAccountLogo(requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a document attachment to a remark
     * @param {DefaultApiUploadDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadDocument(requestParameters: DefaultApiUploadDocumentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadDocument(requestParameters.remarkId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadDocuments(requestParameters: DefaultApiUploadDocumentsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadDocuments(requestParameters.companyId, requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadFiles(requestParameters: DefaultApiUploadFilesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadFiles(requestParameters.files, requestParameters.folderId, requestParameters.companyId, requestParameters.masterBillId, requestParameters.purpose, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadLogoFromUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadLogoFromUrl(requestParameters: DefaultApiUploadLogoFromUrlRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadLogoFromUrl(requestParameters.companyId, requestParameters.uploadLogoFromUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadTaskFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadTaskFile(requestParameters: DefaultApiUploadTaskFileRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadTaskFile(requestParameters.id, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadTrackListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadTrackList(requestParameters: DefaultApiUploadTrackListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadTrackList(requestParameters.file, requestParameters.state, requestParameters.session, requestParameters.lobbyistIds, requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate if a company summary matches the company name using GPT
     * @param {DefaultApiValidateCompanySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public validateCompanySummary(requestParameters: DefaultApiValidateCompanySummaryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).validateCompanySummary(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Warm the cache for recently active bills This endpoint is designed to be called by a cron job (e.g., at 3 AM daily) Protected by API key authentication
     * @param {DefaultApiWarmBillCacheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public warmBillCache(requestParameters: DefaultApiWarmBillCacheRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).warmBillCache(requestParameters.days, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Warm the cache for bills with recent activity
     * @param {DefaultApiWarmBillCache0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public warmBillCache_6(requestParameters: DefaultApiWarmBillCache0Request, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).warmBillCache_6(requestParameters.xApiKey, requestParameters.days, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DownloadBillDocumentFormatEnum = {
    Pdf: 'pdf',
    Html: 'html',
    Txt: 'txt',
    Doc: 'doc',
    Rtf: 'rtf'
} as const;
export type DownloadBillDocumentFormatEnum = typeof DownloadBillDocumentFormatEnum[keyof typeof DownloadBillDocumentFormatEnum];
/**
 * @export
 */
export const GetAccountTrackedBillsTagLogicEnum = {
    And: 'AND',
    Or: 'OR'
} as const;
export type GetAccountTrackedBillsTagLogicEnum = typeof GetAccountTrackedBillsTagLogicEnum[keyof typeof GetAccountTrackedBillsTagLogicEnum];
/**
 * @export
 */
export const GetActivityCountScopeEnum = {
    User: 'user',
    Account: 'account'
} as const;
export type GetActivityCountScopeEnum = typeof GetActivityCountScopeEnum[keyof typeof GetActivityCountScopeEnum];
/**
 * @export
 */
export const GetAutoTrackMatchesOutcomeEnum = {
    Accepted: 'Accepted',
    Rejected: 'Rejected'
} as const;
export type GetAutoTrackMatchesOutcomeEnum = typeof GetAutoTrackMatchesOutcomeEnum[keyof typeof GetAutoTrackMatchesOutcomeEnum];
/**
 * @export
 */
export const GetAutoTrackMatchesPriorityEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;
export type GetAutoTrackMatchesPriorityEnum = typeof GetAutoTrackMatchesPriorityEnum[keyof typeof GetAutoTrackMatchesPriorityEnum];
/**
 * @export
 */
export const GetAutoTrackMatchesImpactEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;
export type GetAutoTrackMatchesImpactEnum = typeof GetAutoTrackMatchesImpactEnum[keyof typeof GetAutoTrackMatchesImpactEnum];
/**
 * @export
 */
export const GetBillDownloadUrlFormatEnum = {
    Pdf: 'pdf',
    Html: 'html',
    Txt: 'txt',
    Doc: 'doc',
    Rtf: 'rtf'
} as const;
export type GetBillDownloadUrlFormatEnum = typeof GetBillDownloadUrlFormatEnum[keyof typeof GetBillDownloadUrlFormatEnum];
/**
 * @export
 */
export const GetCommitteeAnalysisMinPriorityEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;
export type GetCommitteeAnalysisMinPriorityEnum = typeof GetCommitteeAnalysisMinPriorityEnum[keyof typeof GetCommitteeAnalysisMinPriorityEnum];
/**
 * @export
 */
export const GetCommitteeAnalysisMinImpactEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;
export type GetCommitteeAnalysisMinImpactEnum = typeof GetCommitteeAnalysisMinImpactEnum[keyof typeof GetCommitteeAnalysisMinImpactEnum];
/**
 * @export
 */
export const GetCompaniesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCompaniesSortOrderEnum = typeof GetCompaniesSortOrderEnum[keyof typeof GetCompaniesSortOrderEnum];
/**
 * @export
 */
export const GetFirmsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetFirmsSortOrderEnum = typeof GetFirmsSortOrderEnum[keyof typeof GetFirmsSortOrderEnum];
/**
 * @export
 */
export const GetLobbyistsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetLobbyistsSortOrderEnum = typeof GetLobbyistsSortOrderEnum[keyof typeof GetLobbyistsSortOrderEnum];
/**
 * @export
 */
export const GetStatsScopeEnum = {
    Account: 'account',
    User: 'user'
} as const;
export type GetStatsScopeEnum = typeof GetStatsScopeEnum[keyof typeof GetStatsScopeEnum];
/**
 * @export
 */
export const GetTrackedBillActivityScopeEnum = {
    User: 'user',
    Account: 'account'
} as const;
export type GetTrackedBillActivityScopeEnum = typeof GetTrackedBillActivityScopeEnum[keyof typeof GetTrackedBillActivityScopeEnum];
/**
 * @export
 */
export const GetTrackedBillProgressScopeEnum = {
    Account: 'account',
    User: 'user'
} as const;
export type GetTrackedBillProgressScopeEnum = typeof GetTrackedBillProgressScopeEnum[keyof typeof GetTrackedBillProgressScopeEnum];
/**
 * @export
 */
export const GetTrackedBillsTagLogicEnum = {
    And: 'AND',
    Or: 'OR'
} as const;
export type GetTrackedBillsTagLogicEnum = typeof GetTrackedBillsTagLogicEnum[keyof typeof GetTrackedBillsTagLogicEnum];
/**
 * @export
 */
export const GetTrackedLiveActionsScopeEnum = {
    User: 'user',
    Account: 'account'
} as const;
export type GetTrackedLiveActionsScopeEnum = typeof GetTrackedLiveActionsScopeEnum[keyof typeof GetTrackedLiveActionsScopeEnum];
/**
 * @export
 */
export const GetTrackedLiveActionsCountScopeEnum = {
    User: 'user',
    Account: 'account'
} as const;
export type GetTrackedLiveActionsCountScopeEnum = typeof GetTrackedLiveActionsCountScopeEnum[keyof typeof GetTrackedLiveActionsCountScopeEnum];
/**
 * @export
 */
export const GetValidYearsTypeEnum = {
    Engagements: 'engagements',
    Contributions: 'contributions',
    Testimony: 'testimony'
} as const;
export type GetValidYearsTypeEnum = typeof GetValidYearsTypeEnum[keyof typeof GetValidYearsTypeEnum];
/**
 * @export
 */
export const SearchRegsSearchModeEnum = {
    Word: 'word',
    Ai: 'ai'
} as const;
export type SearchRegsSearchModeEnum = typeof SearchRegsSearchModeEnum[keyof typeof SearchRegsSearchModeEnum];
/**
 * @export
 */
export const SearchStatutesSearchModeEnum = {
    Word: 'word',
    Ai: 'ai'
} as const;
export type SearchStatutesSearchModeEnum = typeof SearchStatutesSearchModeEnum[keyof typeof SearchStatutesSearchModeEnum];


/**
 * PortalApi - axios parameter creator
 * @export
 */
export const PortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PortalCommentRequest} portalCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPortalComment: async (portalCommentRequest: PortalCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalCommentRequest' is not null or undefined
            assertParamExists('addPortalComment', 'portalCommentRequest', portalCommentRequest)
            const localVarPath = `/api/portal/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portalCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PortalRelationshipRequest} portalRelationshipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPortalRelationship: async (portalRelationshipRequest: PortalRelationshipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalRelationshipRequest' is not null or undefined
            assertParamExists('addPortalRelationship', 'portalRelationshipRequest', portalRelationshipRequest)
            const localVarPath = `/api/portal/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portalRelationshipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PortalAuthRequest} portalAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticatePortal: async (portalAuthRequest: PortalAuthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalAuthRequest' is not null or undefined
            assertParamExists('authenticatePortal', 'portalAuthRequest', portalAuthRequest)
            const localVarPath = `/api/portal/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portalAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePortalRequest} createPortalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountPortal: async (createPortalRequest: CreatePortalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPortalRequest' is not null or undefined
            assertParamExists('createAccountPortal', 'createPortalRequest', createPortalRequest)
            const localVarPath = `/api/portal/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPortalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountPortal: async (portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('deleteAccountPortal', 'portalId', portalId)
            const localVarPath = `/api/portal/settings/{portalId}`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForwardClipToPortalRequest} forwardClipToPortalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardClipToPortal: async (forwardClipToPortalRequest: ForwardClipToPortalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forwardClipToPortalRequest' is not null or undefined
            assertParamExists('forwardClipToPortal', 'forwardClipToPortalRequest', forwardClipToPortalRequest)
            const localVarPath = `/api/portal/share/clip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forwardClipToPortalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [includeHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalBillDetails: async (id: string, includeHistory?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPortalBillDetails', 'id', id)
            const localVarPath = `/api/portal/bills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeHistory !== undefined) {
                localVarQueryParameter['includeHistory'] = includeHistory;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalBillHistory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPortalBillHistory', 'id', id)
            const localVarPath = `/api/portal/bills/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalTrackedActivity: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/tracked-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalTrackingTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/settings/tracking-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} tickSheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedTickSheet: async (tickSheetId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tickSheetId' is not null or undefined
            assertParamExists('getSharedTickSheet', 'tickSheetId', tickSheetId)
            const localVarPath = `/api/portal/tick-sheets/{tickSheetId}`
                .replace(`{${"tickSheetId"}}`, encodeURIComponent(String(tickSheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountPortals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutPortal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stream a committee video clip This endpoint handles committee clips that are stored in the database and need proper video streaming with authentication
         * @param {string} clipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamCommitteeClip: async (clipId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clipId' is not null or undefined
            assertParamExists('streamCommitteeClip', 'clipId', clipId)
            const localVarPath = `/api/portal/committee-clip/{clipId}/stream`
                .replace(`{${"clipId"}}`, encodeURIComponent(String(clipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} portalId 
         * @param {UpdatePortalRequest} updatePortalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountPortal: async (portalId: number, updatePortalRequest: UpdatePortalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('updateAccountPortal', 'portalId', portalId)
            // verify required parameter 'updatePortalRequest' is not null or undefined
            assertParamExists('updateAccountPortal', 'updatePortalRequest', updatePortalRequest)
            const localVarPath = `/api/portal/settings/{portalId}`
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication session required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePortalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} tickSheetId 
         * @param {PortalTickSheetUpdateRequest} portalTickSheetUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSharedTickSheet: async (tickSheetId: number, portalTickSheetUpdateRequest: PortalTickSheetUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tickSheetId' is not null or undefined
            assertParamExists('updateSharedTickSheet', 'tickSheetId', tickSheetId)
            // verify required parameter 'portalTickSheetUpdateRequest' is not null or undefined
            assertParamExists('updateSharedTickSheet', 'portalTickSheetUpdateRequest', portalTickSheetUpdateRequest)
            const localVarPath = `/api/portal/tick-sheets/{tickSheetId}`
                .replace(`{${"tickSheetId"}}`, encodeURIComponent(String(tickSheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portalTickSheetUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortalApi - functional programming interface
 * @export
 */
export const PortalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PortalCommentRequest} portalCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPortalComment(portalCommentRequest: PortalCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddPortalComment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPortalComment(portalCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.addPortalComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PortalRelationshipRequest} portalRelationshipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPortalRelationship(portalRelationshipRequest: PortalRelationshipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddPortalRelationship200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPortalRelationship(portalRelationshipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.addPortalRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PortalAuthRequest} portalAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticatePortal(portalAuthRequest: PortalAuthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticatePortal(portalAuthRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.authenticatePortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePortalRequest} createPortalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccountPortal(createPortalRequest: CreatePortalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountPortalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccountPortal(createPortalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.createAccountPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccountPortal(portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccountPortal(portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.deleteAccountPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ForwardClipToPortalRequest} forwardClipToPortalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forwardClipToPortal(forwardClipToPortalRequest: ForwardClipToPortalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forwardClipToPortal(forwardClipToPortalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.forwardClipToPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [includeHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortalBillDetails(id: string, includeHistory?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalBillDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortalBillDetails(id, includeHistory, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.getPortalBillDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortalBillHistory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalBillHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortalBillHistory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.getPortalBillHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortalInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortalInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.getPortalInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortalTrackedActivity(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalTrackedActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortalTrackedActivity(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.getPortalTrackedActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortalTrackingTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortalTrackingTags200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortalTrackingTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.getPortalTrackingTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} tickSheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharedTickSheet(tickSheetId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalTickSheetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharedTickSheet(tickSheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.getSharedTickSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountPortals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountPortalResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountPortals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.listAccountPortals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutPortal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissNewUserModal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutPortal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.logoutPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stream a committee video clip This endpoint handles committee clips that are stored in the database and need proper video streaming with authentication
         * @param {string} clipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async streamCommitteeClip(clipId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreamCommitteeClip200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.streamCommitteeClip(clipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.streamCommitteeClip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} portalId 
         * @param {UpdatePortalRequest} updatePortalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountPortal(portalId: number, updatePortalRequest: UpdatePortalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountPortalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountPortal(portalId, updatePortalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.updateAccountPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} tickSheetId 
         * @param {PortalTickSheetUpdateRequest} portalTickSheetUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSharedTickSheet(tickSheetId: number, portalTickSheetUpdateRequest: PortalTickSheetUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalTickSheetDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSharedTickSheet(tickSheetId, portalTickSheetUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.updateSharedTickSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PortalApi - factory interface
 * @export
 */
export const PortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortalApiFp(configuration)
    return {
        /**
         * 
         * @param {PortalApiAddPortalCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPortalComment(requestParameters: PortalApiAddPortalCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddPortalComment200Response> {
            return localVarFp.addPortalComment(requestParameters.portalCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiAddPortalRelationshipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPortalRelationship(requestParameters: PortalApiAddPortalRelationshipRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddPortalRelationship200Response> {
            return localVarFp.addPortalRelationship(requestParameters.portalRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiAuthenticatePortalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticatePortal(requestParameters: PortalApiAuthenticatePortalRequest, options?: RawAxiosRequestConfig): AxiosPromise<PortalAuthResponse> {
            return localVarFp.authenticatePortal(requestParameters.portalAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiCreateAccountPortalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountPortal(requestParameters: PortalApiCreateAccountPortalRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountPortalResponse> {
            return localVarFp.createAccountPortal(requestParameters.createPortalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiDeleteAccountPortalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountPortal(requestParameters: PortalApiDeleteAccountPortalRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.deleteAccountPortal(requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiForwardClipToPortalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardClipToPortal(requestParameters: PortalApiForwardClipToPortalRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.forwardClipToPortal(requestParameters.forwardClipToPortalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiGetPortalBillDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalBillDetails(requestParameters: PortalApiGetPortalBillDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PortalBillDetailsResponse> {
            return localVarFp.getPortalBillDetails(requestParameters.id, requestParameters.includeHistory, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiGetPortalBillHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalBillHistory(requestParameters: PortalApiGetPortalBillHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PortalBillHistoryResponse> {
            return localVarFp.getPortalBillHistory(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalInfo(options?: RawAxiosRequestConfig): AxiosPromise<PortalInfoResponse> {
            return localVarFp.getPortalInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalTrackedActivity(options?: RawAxiosRequestConfig): AxiosPromise<PortalTrackedActivityResponse> {
            return localVarFp.getPortalTrackedActivity(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalTrackingTags(options?: RawAxiosRequestConfig): AxiosPromise<GetPortalTrackingTags200Response> {
            return localVarFp.getPortalTrackingTags(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiGetSharedTickSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedTickSheet(requestParameters: PortalApiGetSharedTickSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PortalTickSheetDetailResponse> {
            return localVarFp.getSharedTickSheet(requestParameters.tickSheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountPortals(options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountPortalResponse>> {
            return localVarFp.listAccountPortals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutPortal(options?: RawAxiosRequestConfig): AxiosPromise<DismissNewUserModal200Response> {
            return localVarFp.logoutPortal(options).then((request) => request(axios, basePath));
        },
        /**
         * Stream a committee video clip This endpoint handles committee clips that are stored in the database and need proper video streaming with authentication
         * @param {PortalApiStreamCommitteeClipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamCommitteeClip(requestParameters: PortalApiStreamCommitteeClipRequest, options?: RawAxiosRequestConfig): AxiosPromise<StreamCommitteeClip200Response> {
            return localVarFp.streamCommitteeClip(requestParameters.clipId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiUpdateAccountPortalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountPortal(requestParameters: PortalApiUpdateAccountPortalRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountPortalResponse> {
            return localVarFp.updateAccountPortal(requestParameters.portalId, requestParameters.updatePortalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PortalApiUpdateSharedTickSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSharedTickSheet(requestParameters: PortalApiUpdateSharedTickSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PortalTickSheetDetailResponse> {
            return localVarFp.updateSharedTickSheet(requestParameters.tickSheetId, requestParameters.portalTickSheetUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addPortalComment operation in PortalApi.
 * @export
 * @interface PortalApiAddPortalCommentRequest
 */
export interface PortalApiAddPortalCommentRequest {
    /**
     * 
     * @type {PortalCommentRequest}
     * @memberof PortalApiAddPortalComment
     */
    readonly portalCommentRequest: PortalCommentRequest
}

/**
 * Request parameters for addPortalRelationship operation in PortalApi.
 * @export
 * @interface PortalApiAddPortalRelationshipRequest
 */
export interface PortalApiAddPortalRelationshipRequest {
    /**
     * 
     * @type {PortalRelationshipRequest}
     * @memberof PortalApiAddPortalRelationship
     */
    readonly portalRelationshipRequest: PortalRelationshipRequest
}

/**
 * Request parameters for authenticatePortal operation in PortalApi.
 * @export
 * @interface PortalApiAuthenticatePortalRequest
 */
export interface PortalApiAuthenticatePortalRequest {
    /**
     * 
     * @type {PortalAuthRequest}
     * @memberof PortalApiAuthenticatePortal
     */
    readonly portalAuthRequest: PortalAuthRequest
}

/**
 * Request parameters for createAccountPortal operation in PortalApi.
 * @export
 * @interface PortalApiCreateAccountPortalRequest
 */
export interface PortalApiCreateAccountPortalRequest {
    /**
     * 
     * @type {CreatePortalRequest}
     * @memberof PortalApiCreateAccountPortal
     */
    readonly createPortalRequest: CreatePortalRequest
}

/**
 * Request parameters for deleteAccountPortal operation in PortalApi.
 * @export
 * @interface PortalApiDeleteAccountPortalRequest
 */
export interface PortalApiDeleteAccountPortalRequest {
    /**
     * 
     * @type {number}
     * @memberof PortalApiDeleteAccountPortal
     */
    readonly portalId: number
}

/**
 * Request parameters for forwardClipToPortal operation in PortalApi.
 * @export
 * @interface PortalApiForwardClipToPortalRequest
 */
export interface PortalApiForwardClipToPortalRequest {
    /**
     * 
     * @type {ForwardClipToPortalRequest}
     * @memberof PortalApiForwardClipToPortal
     */
    readonly forwardClipToPortalRequest: ForwardClipToPortalRequest
}

/**
 * Request parameters for getPortalBillDetails operation in PortalApi.
 * @export
 * @interface PortalApiGetPortalBillDetailsRequest
 */
export interface PortalApiGetPortalBillDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof PortalApiGetPortalBillDetails
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof PortalApiGetPortalBillDetails
     */
    readonly includeHistory?: boolean
}

/**
 * Request parameters for getPortalBillHistory operation in PortalApi.
 * @export
 * @interface PortalApiGetPortalBillHistoryRequest
 */
export interface PortalApiGetPortalBillHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof PortalApiGetPortalBillHistory
     */
    readonly id: string
}

/**
 * Request parameters for getSharedTickSheet operation in PortalApi.
 * @export
 * @interface PortalApiGetSharedTickSheetRequest
 */
export interface PortalApiGetSharedTickSheetRequest {
    /**
     * 
     * @type {number}
     * @memberof PortalApiGetSharedTickSheet
     */
    readonly tickSheetId: number
}

/**
 * Request parameters for streamCommitteeClip operation in PortalApi.
 * @export
 * @interface PortalApiStreamCommitteeClipRequest
 */
export interface PortalApiStreamCommitteeClipRequest {
    /**
     * 
     * @type {string}
     * @memberof PortalApiStreamCommitteeClip
     */
    readonly clipId: string
}

/**
 * Request parameters for updateAccountPortal operation in PortalApi.
 * @export
 * @interface PortalApiUpdateAccountPortalRequest
 */
export interface PortalApiUpdateAccountPortalRequest {
    /**
     * 
     * @type {number}
     * @memberof PortalApiUpdateAccountPortal
     */
    readonly portalId: number

    /**
     * 
     * @type {UpdatePortalRequest}
     * @memberof PortalApiUpdateAccountPortal
     */
    readonly updatePortalRequest: UpdatePortalRequest
}

/**
 * Request parameters for updateSharedTickSheet operation in PortalApi.
 * @export
 * @interface PortalApiUpdateSharedTickSheetRequest
 */
export interface PortalApiUpdateSharedTickSheetRequest {
    /**
     * 
     * @type {number}
     * @memberof PortalApiUpdateSharedTickSheet
     */
    readonly tickSheetId: number

    /**
     * 
     * @type {PortalTickSheetUpdateRequest}
     * @memberof PortalApiUpdateSharedTickSheet
     */
    readonly portalTickSheetUpdateRequest: PortalTickSheetUpdateRequest
}

/**
 * PortalApi - object-oriented interface
 * @export
 * @class PortalApi
 * @extends {BaseAPI}
 */
export class PortalApi extends BaseAPI {
    /**
     * 
     * @param {PortalApiAddPortalCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public addPortalComment(requestParameters: PortalApiAddPortalCommentRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).addPortalComment(requestParameters.portalCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiAddPortalRelationshipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public addPortalRelationship(requestParameters: PortalApiAddPortalRelationshipRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).addPortalRelationship(requestParameters.portalRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiAuthenticatePortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public authenticatePortal(requestParameters: PortalApiAuthenticatePortalRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).authenticatePortal(requestParameters.portalAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiCreateAccountPortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public createAccountPortal(requestParameters: PortalApiCreateAccountPortalRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).createAccountPortal(requestParameters.createPortalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiDeleteAccountPortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public deleteAccountPortal(requestParameters: PortalApiDeleteAccountPortalRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).deleteAccountPortal(requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiForwardClipToPortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public forwardClipToPortal(requestParameters: PortalApiForwardClipToPortalRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).forwardClipToPortal(requestParameters.forwardClipToPortalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiGetPortalBillDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public getPortalBillDetails(requestParameters: PortalApiGetPortalBillDetailsRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).getPortalBillDetails(requestParameters.id, requestParameters.includeHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiGetPortalBillHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public getPortalBillHistory(requestParameters: PortalApiGetPortalBillHistoryRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).getPortalBillHistory(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public getPortalInfo(options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).getPortalInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public getPortalTrackedActivity(options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).getPortalTrackedActivity(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public getPortalTrackingTags(options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).getPortalTrackingTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiGetSharedTickSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public getSharedTickSheet(requestParameters: PortalApiGetSharedTickSheetRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).getSharedTickSheet(requestParameters.tickSheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public listAccountPortals(options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).listAccountPortals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public logoutPortal(options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).logoutPortal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stream a committee video clip This endpoint handles committee clips that are stored in the database and need proper video streaming with authentication
     * @param {PortalApiStreamCommitteeClipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public streamCommitteeClip(requestParameters: PortalApiStreamCommitteeClipRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).streamCommitteeClip(requestParameters.clipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiUpdateAccountPortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public updateAccountPortal(requestParameters: PortalApiUpdateAccountPortalRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).updateAccountPortal(requestParameters.portalId, requestParameters.updatePortalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PortalApiUpdateSharedTickSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalApi
     */
    public updateSharedTickSheet(requestParameters: PortalApiUpdateSharedTickSheetRequest, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).updateSharedTickSheet(requestParameters.tickSheetId, requestParameters.portalTickSheetUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhooksApi - axios parameter creator
 * @export
 */
export const WebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle Stripe webhook events  This endpoint processes Stripe webhook events, particularly checkout.session.completed to automatically create user accounts and set up subscription schedules.
         * @summary Process Stripe webhook event
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleWebhook', 'body', body)
            const localVarPath = `/api/webhooks/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhooksApi - functional programming interface
 * @export
 */
export const WebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle Stripe webhook events  This endpoint processes Stripe webhook events, particularly checkout.session.completed to automatically create user accounts and set up subscription schedules.
         * @summary Process Stripe webhook event
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhook(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.handleWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhooksApi - factory interface
 * @export
 */
export const WebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhooksApiFp(configuration)
    return {
        /**
         * Handle Stripe webhook events  This endpoint processes Stripe webhook events, particularly checkout.session.completed to automatically create user accounts and set up subscription schedules.
         * @summary Process Stripe webhook event
         * @param {WebhooksApiHandleWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook(requestParameters: WebhooksApiHandleWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookResponse> {
            return localVarFp.handleWebhook(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for handleWebhook operation in WebhooksApi.
 * @export
 * @interface WebhooksApiHandleWebhookRequest
 */
export interface WebhooksApiHandleWebhookRequest {
    /**
     * 
     * @type {any}
     * @memberof WebhooksApiHandleWebhook
     */
    readonly body: any
}

/**
 * WebhooksApi - object-oriented interface
 * @export
 * @class WebhooksApi
 * @extends {BaseAPI}
 */
export class WebhooksApi extends BaseAPI {
    /**
     * Handle Stripe webhook events  This endpoint processes Stripe webhook events, particularly checkout.session.completed to automatically create user accounts and set up subscription schedules.
     * @summary Process Stripe webhook event
     * @param {WebhooksApiHandleWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public handleWebhook(requestParameters: WebhooksApiHandleWebhookRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).handleWebhook(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



